window.__npEmb2Build = 'b0821-etch-flip';
/* ═══════════════════════════════════════════════════════════════════
   Embroidery 2.0 builder (product.embroidery-2-0 template only).
   Pre-upload: untouched legacy flow. When body.image-uploaded appears,
   this hides the legacy post-upload UI and runs the 3-step builder.

   Integration contract (nothing here re-implements pricing):
   - width/height/qty proxy into the legacy inputs (width__value /
     height__value / .customQtyFile__qty + keyup) so variant selection,
     discount properties (_discount_input/_discount_name) and validation
     all run exactly as production today.
   - Variant is ALSO set directly on the form (no BCPO dependency).
   - Committed options write properties[_Select Shape] / [Patch
     Background Color] / [Border Thread Color] / [_Select Your Backing].
   - AI proof = client-canvas composite of the actual uploaded render,
     hosted via the theme's own getPresignedUploadUrl, stored in
     properties[_AI Proof] and set as _cartImg (cart thumbnail).
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var root = document.getElementById('np-e2');
  if (!root) return; // not the embroidery-2-0 template

  var cfgEl = document.getElementById('np-e2-config');
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { console.error('np-emb2 config parse', e); return; }
  /* C43 (2026-08-31, Justin: "I love the tight rectangle and oval we did but
     can we also ALWAYS keep the regular rectangle and oval too ... nothing
     should be default they should just show"). C26 made the EXISTING Rectangle
     and Oval tiles follow the artwork's aspect. They are split back apart:
     plain Rectangle/Oval return to their fixed pre-C26 proportions, and the
     artwork-following behaviour moves to NEW "Cropped" tiles. Injected at
     runtime rather than as template blocks so every builder template gets them
     without editing each product's JSON; each inherits its base tile's assets. */
  try {
    var npC43 = [];
    (CFG.shapes || []).forEach(function (sC) {
      if (sC.geom === 'rectangle-v' || sC.geom === 'oval-h') return; /* C223 (Justin 2026-09-15): Tall Rectangle / Wide Oval are retired everywhere — Rectangle and Oval orient themselves from the design */
      npC43.push(sC);
      var lbl = String(sC.label || '');
      if (sC.geom === 'rectangle' && !sC.crop && !/cropped/i.test(lbl)) {
        var rC = {}; for (var kR in sC) rC[kR] = sC[kR];
        rC.label = 'Cropped Rectangle'; rC.crop = 1; npC43.push(rC);
      }
      if (sC.geom === 'oval' && !sC.crop && !/cropped/i.test(lbl)) {
        var oC = {}; for (var kO in sC) oC[kO] = sC[kO];
        oC.label = 'Cropped Oval'; oC.crop = 1; npC43.push(oC);
      }
    });
    var seenC43 = {};
    CFG.shapes = npC43.filter(function (sF) {
      if (seenC43[sF.label]) return false; seenC43[sF.label] = 1; return true;
    });
  } catch (eC43) {}
  var S = CFG.settings || {};
  var QTY_MIN = parseInt(S.qtyMin, 10) || 10, QTY_STEP = S.qtyStep || 5, QTY_MAX = Infinity; /* C442 (Justin 2026-09-29): "every product page should have 0 limit on the quantity amount they can enter for classic mode or AI mode / right now its stopping at 999" */
  var SIZE_STEP = S.sizeStep || 0.25;
  var SIZE_MIN = Math.max(S.sizeMin || 0.5, parseFloat(S.sizeMinMeta) || 0.5);
  function npMinIn() { return SIZE_MIN > 0.5 ? SIZE_MIN : 0; } /* C155: the product minimum (custom.min_width, applied to both dims) feeds the gate's judging frame; 0.5 = no floor */
  var SIZE_MAX = parseFloat(S.sizeMaxMeta) || 15;
  function sizeError(msg) {
    var el = document.getElementById('np-e2-size-err');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el.__t);
    el.__t = setTimeout(function () { el.hidden = true; }, 2000);
  }
  function clampSize(v, silent) {
    if (v < SIZE_MIN) { if (!silent) sizeError('Minimum size for this patch is ' + SIZE_MIN + '"'); return SIZE_MIN; }
    if (v > SIZE_MAX) { if (!silent) sizeError('Maximum size for this patch is ' + SIZE_MAX + '"'); return SIZE_MAX; }
    return v;
  }
  var REGEN_LIMIT = S.regenLimit || 4;

  /* ---- state ---- */
  var st = {
    shape: null, border: null, bg: null, thread: null, backing: null,
    step: null, draft: null,
    removeBg: false, crop: true, /* remove-background defaults OFF on upload */ /* crop+trim is ALWAYS on — the fill slider owns spacing */
    expanded: false, isAI: true, artZoom: 1, artDx: 0, artDy: 0, corners: null, /* C151 artDx/artDy = pan offset as a fraction of the patch box */
    w: 2.00, h: 2.19, ratio: 2.19 / 2.00, sizeSeeded: false, qty: QTY_MIN,
    versions: [], selected: 0, proofPhase: null, proofApproved: false,
    cart: 0
  };
  /* order mandate: the surface TEXTURE follows the background COLOR it sits on,
     and border STYLE comes after the border COLOR (thread).
     WZ_TITLES/WZ_LABELS are positional — they must be permuted in lockstep with
     WZ_STEPS, and the accordion rows in np-emb2-builder.liquid carry the same
     index in data-e2-acc/acchead/accbody. */
  /* 'font' is APPENDED, never inserted: WZ_TITLES/WZ_LABELS and the liquid
     accordion rows are keyed to these indices, so renumbering would silently
     repoint every other patch type's rows. The customer-facing ORDER comes
     from the accordion's DOM order instead — see stepSeq(). */
  /* 'opt1'/'opt2'/'opt3' are APPENDED for the same reason 'font' was: they are
     the NATIVE SHOPIFY VARIANT OPTIONS of a product whose customer choices are
     not theme-editor blocks at all (Custom Tackle Twill Letters: Size / Layers
     / Lines of Text). Their title and label are written at render time from
     product.options, so the placeholders below are never shown. */
  var WZ_STEPS = ['shape', 'bg', 'texture', 'border', 'thread', 'backing', 'font', 'opt1', 'opt2', 'opt3', 'text', 'ttext'];
  var WZ_TITLES = ['Select Shape', 'Patch Background Color', 'Background Texture', 'Select Border Style', 'Border Thread Color', 'Select Your Backing', 'Select Font Style', 'Select Option', 'Select Option', 'Select Option'];
  var WZ_LABELS = ['Shape', 'Background', 'Texture', 'Border', 'Thread', 'Backing', 'Font', 'Option', 'Option', 'Option'];
  /* C164 (Justin 2026-09-10): FOLD STYLE for Woven Labels (Straight Cut / Design’s Shape (die cut) / End Fold / Mitre Fold /
     Center Fold (was Loop Fold until C173, 2026-09-11) / Horizontal Fold (Manhattan Fold removed 2026-09-10, C169), from the template's fold_style blocks). Appended as index 12 so no static accordion row is renumbered —
     stepSeq() reads the accordion's DOM order and the liquid places the fold row right after Shape. */
  WZ_STEPS.push('fold'); WZ_TITLES[12] = 'Select Fold Style'; WZ_LABELS[12] = 'Fold';
  WZ_STEPS.push('size'); WZ_TITLES[13] = 'Select Size'; WZ_LABELS[13] = 'Size'; /* C229 (Justin 2026-09-17): the size is chosen BEFORE the AI proof and feeds the feasibility check */
  var NP_JUDGE_OVERRIDE = 0; /* C229: when > 0, analyzeArtwork judges the artwork as a patch THIS many inches wide (the Size step's check) */

  /* ═══ PATCH TYPE PROFILES — each 2-0 template carries the option set the
     type ACTUALLY offers (mirrors the mockup lab / legacy product pages) ═══ */
  var PATCH_TYPES = {
    'embroidery-2-0':       { name: 'Embroidered', shape: 1, bg: 1, thread: 1, border: 1, fdGate: 1, stitchout: 1, txtRunMin: 8 }, /* C153 (Justin 2026-09-05): small-text run threshold 8 for the embroidery family (was the global 6) */
    'print-and-stitch-2-0': { name: 'Print & Stitch', shape: 1, bg: 1, thread: 1, border: 1 },
    'fullcolor-2-0':        { name: 'Printed', photoBtn: 1, shape: 1, bg: 1, thread: 1, border: 1, borders: /merrow/i, noMerrowGeom: /^(heart|custom)$/, /* C502: Hot Cut gone (HC1 had offered it on every shape); Heart + Design's Shape = No Border only */ noBorderCustom: 1, threadLabel: 'Border Color', threadProp: '_Border Color', noBorderOpt: 1, stitchout: 1 },
    'rubber-pvc-2-0':       { name: 'PVC / Rubber', shape: 1, bg: 1, thread: 1, border: 0, fdGate: 1, borderThick: 1, lbDefault: 5, lbZeroMax2: 1, threadLabel: 'Border Color', threadProp: '_Border Color', backings: ['heat', 'hook'], sewChannel: 1 /* C538 */, noneCushion: 1 /* C538b */, noneHidesThick: 1 /* C538c */ },
    'woven-2-0':            { name: 'Woven', shape: 1, bg: 1, thread: 1, border: 1, noBorderOpt: 1, noBorderCustom: 1 }, /* C160 (2026-09-10, Justin: 'when its custom shape on woven please allow no border option to exist like it does for other woven shapes'): the custom-shape pool was Hot Cut alone, so autoPickSingles silently pre-selected it and No Border never appeared */
    /* Woven Labels (Justin 2026-09-10): the Woven Patches product cloned for LABELS ONLY (product 10624898269503, template
       woven-labels = a copy of product.woven-patches.json, so its blocks still carry border styles and backings). Border =
       NONE with no border step at all (C162, Justin 2026-09-10: "there never will be a border for woven labels" — the
       border-style and border-colour steps are gone; `borderless: 1` keeps every no-border prompt + compose rule firing
       and nothing is written for border style or colour); NO backing step and nothing written for it. `family`
       keeps the remote services (Patch Gate, Patch Sensei) and the C158 full-bleed prompt on the woven-2-0 rules while the
       proof filenames / My Proofs stay typed woven-labels so a re-order lands back on this product. */
    'woven-labels':         { name: 'Woven Label', family: 'woven-2-0', shape: 1, foldCustom: 1, fixedCorners: 'square', defaultBg: 'White', bgLabel: 'Label color', bgProp: '_Background Color', /* C178 (Justin 2026-09-11): Design’s Shape is a FOLD STYLE option again; picking it cuts to the artwork outline and hides the Shape step (the shape tiles never list it) */ /* C176: the step/summary say Label color; the order property is unchanged */ /* C174 (Justin 2026-09-11): Shape is a customer step again (Square / Rectangle / Cropped Rectangle / Design's Shape), SECOND after Fold Style; foldShapes dropped so the fold no longer sets the geometry; corners stay square */ aiOnly: 1, bg: 1, fold: 1, thread: 0, border: 0, borderless: 1, backing: 0, labelsOnly: 1, previewTitle: 'Your Woven Label Preview' }, /* C165 (Justin 2026-09-10): 'instead of shape … show fold type in its place and the mockup will work off of that fold type' + 'they are only square' — no shape step, no corner question; the fold decides the geometry (applyFoldShape) */ /* C164: fold: 1 = the Fold Style step */ /* C162: was thread/border steps with No Border as the only option. C163: labelsOnly = every upload-gate stop becomes the single woven-label message + 'Upload another image' (no conversion offers, never recommended elsewhere) */
    /* molded PVC keychain: rubber-pvc options (shape / background / border
       color), but the physical size IS the Shopify variant option and the
       keyring means there is no backing to choose */
    /* C08 (2026-08-25, Justin): "keychains should be setup just like rubber pvc
       without the backing option but everything else should be the same". So it
       now carries PVC's fdGate / borderThick / lbDefault / lbZeroMax2 — the
       molded-PVC option set, keeping only `backing: 0` — a keyring has no
       backing to choose.
       C09 (same day): the Shopify-variant sizing keys (optVariant /
       sizeFromOpt / fixedSize) were REMOVED too — Justin: "size needs to get
       away from shopify variants and be sized exactly like you do with rubber
       pvc". Keychains now measures freely like PVC; nearestVariant() still maps
       the measurement onto the closest size variant for price, which is exactly
       how PVC resolves its own per-size variants. */
    'keychains-2-0':        { name: 'Keychain', shape: 1, bg: 1, thread: 1, border: 0, fdGate: 1, borderThick: 1, lbDefault: 5, lbZeroMax2: 1, threadLabel: 'Border Color', threadProp: '_Border Color', backing: 0 },
    'leather-2-0':          { name: 'Leather', shape: 1, bg: 1, thread: 0, border: 1, stitchout: 1, bgLabel: 'Leather Color', bgProp: '_Background Color', backings: ['heat', 'peel'], mats: [{ label: 'Sand', hex: '#DCA05F', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODgyNTAxNzUtTmF0dXJhbF9IaWdoX0NvbnRyYXN0Mi5wbmciLCAiZWRpdHMiOiB7InJlc2l6ZSI6IHsid2lkdGgiOiAyMjAsICJmaXQiOiAiY29udGFpbiJ9fX0=' }, { label: 'Brown', hex: '#834822', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODgyNTAxNzUtQ2FyYW1lbF9IaWdoX0NvbnRyYXN0Mi5wbmciLCAiZWRpdHMiOiB7InJlc2l6ZSI6IHsid2lkdGgiOiAyMjAsICJmaXQiOiAiY29udGFpbiJ9fX0=' }, { label: 'Dark Brown', hex: '#716151', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODgyNTAxNzUtVGF1cGVfTG93X0NvbnRyYXN0Mi5wbmciLCAiZWRpdHMiOiB7InJlc2l6ZSI6IHsid2lkdGgiOiAyMjAsICJmaXQiOiAiY29udGFpbiJ9fX0=' }] },
    /* C530 (Justin 2026-10-29, PATCH-2121370): faux Tan w/ Black Imprint #987868 -> #8C7C57, the colour of World Emblem's
       stitchout (their proof photo, balanced on its white paper). #987868 was a reddish tan; the material is a muted khaki tan. */
    'fauxleather-2-0':      { name: 'Faux Leather', shape: 1, bg: 1, thread: 0, border: 1, stitchout: 1, bgLabel: 'Faux Leather Color', bgProp: '_Background Color', backings: ['heat', 'peel'], mats: [{ label: 'Black & Silver', hex: '#131313', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODc5MjI0OTUtc2xvd19uaW5qYS5wbmciLCAiZWRpdHMiOiB7InJlc2l6ZSI6IHsid2lkdGgiOiAyMjAsICJmaXQiOiAiY29udGFpbiJ9fX0=' }, { label: 'Light Brown w/ Black Imprint', hex: '#8A3D18', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODc5MjI0OTUtTGlnaHQtQnJvd24ucG5nIiwgImVkaXRzIjogeyJyZXNpemUiOiB7IndpZHRoIjogMjIwLCAiZml0IjogImNvbnRhaW4ifX19' }, { label: 'Dark Brown w/ Black Imprint', hex: '#482818', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODc5MjI0OTUtY2hvYy1hbmQtYmxhY2sucG5nIiwgImVkaXRzIjogeyJyZXNpemUiOiB7IndpZHRoIjogMjIwLCAiZml0IjogImNvbnRhaW4ifX19' }, { label: 'Tan w/ Black Imprint', hex: '#8C7C57', img: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiAiYmNwbyIsICJrZXkiOiAibmluamFwb2RkZC5teXNob3BpZnkuY29tLzg3MzM4ODc5MjI0OTUtU2FuZHN0b25lX2FuZF9ibGFjazIucG5nIiwgImVkaXRzIjogeyJyZXNpemUiOiB7IndpZHRoIjogMjIwLCAiZml0IjogImNvbnRhaW4ifX19' }] },
    'silicone-2-0':         { name: 'Silicone', shape: 1, bg: 1, thread: 1, border: 0, /* C62: same thickness kit as PVC (Justin 8-31) */ borderThick: 1, lbDefault: 5, lbZeroMax2: 1, threadLabel: 'Border Color', threadProp: '_Border Color', backings: ['heat', 'hook'] },
    '3demb-2-0':            { name: '3D Embroidered', shape: 1, bg: 1, thread: 1, border: 1, borders: /hot/i, fdGate: 1, txtRunMin: 8 }, /* C133 (2026-09-02, Justin: 'Embroidery and 3d embroidery should be working on the EXACT same blocks') - same upload gates as embroidery-2-0 */
    /* C471 (Justin 2026-10-05, "update Chenille to match the 14 with no custom color"): chenille felt only comes in World
       Emblem's 14 stock colours (the template's bg_color blocks), so the background step has no colour wheel and the
       artwork colours offer the nearest stock felt instead of a PMS (see stockNearest471). */
    'chenille-2-0':         { name: 'Chenille', shape: 1, bg: 1, thread: 1, border: 1, borders: /hot/i, fdGate: 1, noCustomBg: 1 },
    'metallic-flex-2-0': { name: 'Metallic Flex', shape: 1, bg: 1, thread: 1, border: 0, backings: ['heat', 'peel'], threadLabel: 'Border Color', threadProp: '_Border Color', threadHelp: 'The molded border around the edge of your patch.', borderThick: 1, bgHelp: 'The base color of the molded patch behind your design.', fixedBg: { label: 'Metallic Silver', hex: '#C3C7CD' }, texPre: 1, texture: (window.NP_PATCH_TEXTURES || {})['metallic-flex-2-0'] },
    'fullcolor-flex-2-0': { name: 'Full Color Flex', shape: 1, bg: 1, thread: 1, border: 0, backings: ['heat', 'peel'], threadLabel: 'Border Color', threadProp: '_Border Color', threadHelp: 'The molded border around the edge of your patch.', borderThick: 1, bgHelp: 'The base color of the molded patch behind your design.', fixedBg: { label: 'White', hex: '#FFFFFF' }, texPre: 1, texture: (window.NP_PATCH_TEXTURES || {})['fullcolor-flex-2-0'] },
    'matte-black-flex-2-0': { name: 'Matte Black Flex', monoTone: { dark: '#0E0E10', light: '#46464B' }, shape: 1, bg: 0, thread: 0, border: 0, backings: ['heat', 'peel'], fixedBg: { label: 'Matte Black', hex: '#1A1A1C' }, texPre: 0, texture: (window.NP_PATCH_TEXTURES || {})['matte-black-flex-2-0'] },
    'matte-white-flex-2-0': { name: 'Matte White Flex', monoTone: { dark: '#CFCEC7', light: '#FFFFFF' }, shape: 1, bg: 0, thread: 0, border: 0, backings: ['heat', 'peel'], fixedBg: { label: 'Matte White', hex: '#F5F5F3' }, texPre: 0, texture: (window.NP_PATCH_TEXTURES || {})['matte-white-flex-2-0'] },
    'chrome-flex-2-0': { name: 'Chrome Flex', monoTone: { dark: '#8C929B', light: '#FFFFFF' }, shape: 1, bg: 0, thread: 0, border: 0, backings: ['heat', 'peel'], fixedBg: { label: 'Chrome', hex: '#D9DDE3' }, texPre: 0, texture: (window.NP_PATCH_TEXTURES || {})['chrome-flex-2-0'] }
    ,
    /* Custom Tackle Twill Letters. The ONLY type whose customer choices are
       NATIVE SHOPIFY VARIANT OPTIONS rather than theme-editor blocks: Size,
       Layers and Lines of Text are real product options and the PRICE rides on
       the variant, so the three steps together must resolve ONE variant (see
       optVariant / nearestVariant). The live PDP carries no BCPO option set and
       asks for no shape, colour, border or backing, so every block-driven step
       sits out. Artwork upload + AI proof run exactly as on every other type. */
    'tackle-twill-2-0': {
      name: 'Tackle Twill',
      /* one backing, Heat Applied — the row still renders, pre-selected, so
         the customer sees what they're getting */
      shape: 0, border: 0, backings: ['heat'],
      /* The lettering IS the product: the customer TYPES it, so there is no
         upload at all and the preview composes the text the way custom names
         does. How many lines they fill in picks the Lines of Text variant. */
      noArt: 1, textLines: 3, autoOpt: 3, layersOpt: 2, swoosh: 1, noLnc: 1,
      classicOk: 1, /* C231 (Justin 2026-09-17): the old upload flow (size, layers, lines) is offered as Classic Order Mode beside the typed builder */
      cta: 'Start Designing Tackle Twill',
      ctaTitle: 'Design your tackle twill letters',
      ctaSub: 'Type your lettering, pick your size, layers and twill colors. No artwork needed.',
      font: 1, fontProp: '_Font Style', textFill: 0.9, previewDims: 1,
      formats: ['Straight', 'Arch'], stitches: ['Zig Zag', 'Satin'],
      /* layer 1 = the letters themselves; layer 2 (2-layer orders only) is the
         twill underneath, which reads as a contrasting outline around them */
      bg: 1, bgLabel: 'Letter Color', bgProp: '_Letter Color',
      bgHelp: 'The twill your letters are cut from.',
      thread: 1, threadLabel: 'Outline Color', threadProp: '_Outline Color',
      threadHelp: 'The second layer of twill showing behind the letters.',
      /* the option NAMES, their order and their values all come from Shopify
         (CFG.optionNames + CFG.variants) — nothing about them is listed here,
         so an option renamed in admin renames the step by itself */
      optVariant: 1,
      /* option 1 states the physical size ('11" x 4" (Most Popular)'), so
         picking it drives st.w/st.h -> the rulers, the proof prompt and
         _Width (in) / _Height (in), the way the steppers do elsewhere */
      sizeFromOpt: 1,
      fixedSize: 1,
      /* twill letters are cut pieces satin-stitched down: there is no patch
         base to fill and no merrow ring to draw, so the compose is bare art */
      fixedShape: { label: 'Custom', geom: 'custom' },
      bareArt: 1,
      matNote: function () {
        var layTT = st.opt2 ? String(st.opt2.label) : '';
        var linTT = st.opt3 ? String(st.opt3.label) : '';
        var inkTT = (st.bg && st.bg.hex) ? st.bg.label : '';
        var edgeTT = (twoLayers() && st.thread && st.thread.hex) ? st.thread.label : '';
        var zigTT = /zig/i.test(String(st.ttStitch || 'Zig Zag'));
        var fontTT = st.font ? st.font.label : '';
        var laysTT = ttLines().map(function (lT, iT) {
          return 'line ' + (iT + 1) + ' "' + lT + '" ' + String(st['ttLay' + (iT + 1)] || 'Straight').toLowerCase() +
            (iT > 0 && st['ttHalf' + (iT + 1)] ? ' at half height' : '');
        }).join('; ');
        var tailTT = ttSwooshOn() ? ttSwooshDef(st.swooshStyle).name : '';
        var tailTxtTT = ttSwooshOn() ? String(st.swooshText || '').trim() : '';
        return 'TACKLE TWILL LETTERING - this is NOT an embroidered patch: the design is CUT from flat matte twill fabric'
          + (inkTT ? ' in ' + inkTT : '')
          + (layTT ? ' (' + layTT.toLowerCase() + ')' : '')
          + (/2\s*layer/i.test(layTT) ? (' - a second' + (edgeTT ? ' ' + edgeTT : '') + ' twill layer sits beneath the top layer, cut slightly larger so it shows as a narrow even outline around each letter') : '')
          + '. EDGE FINISH - THIS MUST BE CLEARLY VISIBLE IN THE IMAGE: ' + (zigTT
              ? 'every cut edge is finished with an OPEN ZIG-ZAG STITCH - a row of separate slanted thread stitches marching along the edge with visible gaps of twill between them, each stitch individually countable at this size. It is NOT a smooth or solid edge'
              : 'every cut edge is finished with a DENSE SATIN STITCH - a solid, tightly packed column of parallel threads forming a raised glossy band that covers the cut edge completely, with visible thread direction across the band')
          + ', and every stitch thread MATCHES the colour of the twill it secures - there is NO white thread, NO white outline, NO white gap or halo between the twill layers anywhere'
          + (/2\s*layer/i.test(layTT) ? ((edgeTT ? '. The ' + edgeTT : '. The second-layer') + ' outline is a solid, even band of twill fabric about 1/8 inch wide, fully visible and touching the top-layer letter directly along its whole edge') : '')
          + '. CRITICAL: each letter is its OWN separate cut piece with a small gap of empty space between letters, exactly as spaced in the reference image. There is NO patch base, NO background field, NO merrow border and NO material of any kind between, around or behind the letters - the letters sit directly on the garment-free backdrop as individual pieces. Reproduce only the lettering itself.'
          + (linTT ? ' The lettering is laid out as ' + linTT.toLowerCase() + ' of text.' : '')
          + (fontTT ? ' Letterform style: ' + fontTT + '.' : '')
          + (laysTT ? ' Layout, exactly as in the reference image: ' + laysTT + '.' : '')
          + (tailTT ? (' A ' + tailTT + ' tail is cut from the same twill and stitched below the lettering, joined to the last letter as ONE continuous piece'
              + (tailTxtTT ? ', with "' + tailTxtTT.toUpperCase() + '" stitched along it' : '') + '.') : '');
      }
    },
    /* Custom Embroidered Name Patches. The ONLY type with no artwork at all:
       the patch IS the name, so the preview composes TEXT instead of an
       upload, and the whole upload/AI-proof half of the builder sits out.
       Size, border style and backing are fixed by the product and the price
       is flat, so those steps never render and the tier table stays hidden. */
    'custom-names': {
      name: 'Embroidered Name',
      shape: 0, bg: 1, thread: 1, border: 0, font: 1,
      noArt: 1, textPreview: 'Name', textFill: 0.64, textFillW: 0.88, previewDims: 1, noLnc: 1,
      /* C515 (Justin 2026-10-26, a real "DV8" tag beside its mockup: "keep them centered and proportionate"): the
         letters are sized by CAP HEIGHT, not by the ink box. On the stitched tags the capitals stand ~37% of the patch
         height, centred; the ink-box fit blew a short name up to 64% of the patch. Long names stay width-bound
         (textFillW). */
      textCapFill: 0.38,
      cta: 'Start Designing Custom Names',
      bgLabel: 'Patch Background Color',
      bgProp: '_Background Color',
      threadLabel: 'Border Color',
      threadProp: '_Border Color',
      threadHelp: 'The merrow border around the edge.',
      textColor: 1,
      textLabel: 'Text Thread Color',
      textProp: '_Text Color',
      textHelp: 'Stitches the lettering.',
      bgHelp: 'The felt color behind the lettering.',
      /* C328 (Justin 2026-09-23): name patches are cut from STOCK twill, so the background can only be one
         of the stock colours — no colour wheel. Border and text keep theirs; those are thread. */
      noCustomBg: 1,
      /* C329 (Justin 2026-09-23): offer the chosen background as a one-click match on the Border Color step.
         There is no artwork on a name patch, so the COLORS FROM YOUR ARTWORK rail is always empty here —
         this puts the same affordance to the same use. Border only, never the text (C331). */
      borderMatchBg: 1,
      fixedShape: { label: 'Rectangle', geom: 'rectangle' },
      fixedDims: [104, 40],  /* preview aspect = 3.25 : 1.25 */
      fixedWH: [3.25, 1.25],
      fixedSize: 1, flatPrice: 1,
      fixedBorder: 'Merrow', borderProp: 'Border Style',
      fixedBacking: 'Heat Applied (Most Popular)', backingProp: 'Backing',
      fontProp: 'Font Style',
      names: 1, namesMin: QTY_MIN, namesProp: 'List of Names (Separate by Comma)'
    }
  };
  /* ═══ LIVE-TEMPLATE ALIASES ═══════════════════════════════════════════
     The 2.0 builders were authored on their own `*-2-0` templates and reached
     with ?view=. For a theme-level A/B rollout the builder has to run on the
     template each product ACTUALLY uses (its real template_suffix, shared by
     every theme), so the type can no longer be read from the file name alone.
     This maps each live suffix onto its 2.0 type key; the 2.0 names still work
     unchanged, so ?view= previews and existing proof filenames keep working. */
  var SUFFIX_ALIAS = {
    'embroidered-patches': 'embroidery-2-0',
    'chenile-patches': 'chenille-2-0',
    'woven-patches': 'woven-2-0',
    'rubber-patches': 'rubber-pvc-2-0',
    'leather-patches': 'leather-2-0',
    'sublimated-patches': 'fullcolor-2-0',
    '3d-embroidered-patches': '3demb-2-0',
    'silicone-patches': 'silicone-2-0',
    'faux-leather-2': 'fauxleather-2-0',
    'print-and-stitch-patches': 'print-and-stitch-2-0',
    'ninja-flex': 'metallic-flex-2-0',
    'full-color-flex': 'fullcolor-flex-2-0',
    'matte-black-flex': 'matte-black-flex-2-0',
    'matte-white-flex': 'matte-white-flex-2-0',
    'chrome-flex': 'chrome-flex-2-0',
    'tackle-twill': 'tackle-twill-2-0',
    'keychains': 'keychains-2-0'
  };
  /* ONE canonical type key for the whole file — never read the raw suffix for
     identity again, or a live-template render silently falls back to embroidery */
  var TYPE_KEY = SUFFIX_ALIAS[String(CFG.templateSuffix || '')] || String(CFG.templateSuffix || '');
  var PTYPE = PATCH_TYPES[TYPE_KEY] || PATCH_TYPES['embroidery-2-0'];
  var NP_NOUN = PTYPE.labelsOnly ? 'label' : 'patch'; /* C176 (Justin 2026-09-11): woven labels are labels for clothing, not patches — every customer-facing sentence below says so */
  /* C199 (2026-09-11): the woven-labels 0.5" minimum now comes from the product metafield custom.min_width (set to 0.5 by Justin) via S.sizeMinMeta — the C165 profile override is retired, no parallel source. */
  /* the 2-0 rule set a DERIVED type inherits (woven-labels -> woven-2-0): what the remote services and the
     type-keyed prompt rules see. TYPE_KEY stays the page's own identity (proof filenames, My Proofs routing). */
  var TYPE_FAMILY = PTYPE.family || TYPE_KEY;
  /* ---- C134: CENTRAL GATE SERVICE (Patch Gate) -----------------------------
     Justin 2026-09-02: every upload-gate learning lives in ONE place that the
     PDP, the mockup lab and Shinobi read every time. When NP_GATE_URL is set
     (window.NP_GATE_URL or CFG.gateUrl), the upload gates stop evaluating the
     local classifier and ask the service; it returns the verdict AND the card
     (offers + copy). Empty = the local rules, byte-for-byte pre-C134 behaviour.
     Fail-open: any error / timeout = no stop, logged. */
  /* rollout switch per theme (house pattern: runtime theme-id gates). STAGING first;
     live 187988967743 + 3-column 188164800831 join once Justin approves. */
  var NP_GATE_THEME_MAP = { '188236005695': 'https://6rkg1olal7.execute-api.us-east-1.amazonaws.com/', '187988967743': 'https://6rkg1olal7.execute-api.us-east-1.amazonaws.com/', '188164800831': 'https://6rkg1olal7.execute-api.us-east-1.amazonaws.com/' }; /* API Gateway in front of Lambda PatchGate (public Function URLs are blocked at the org level) */
  var npThemeIdG = String((typeof window !== 'undefined' && window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || '');
  var NP_GATE_URL = String((typeof window !== 'undefined' && window.NP_GATE_URL) || CFG.gateUrl || NP_GATE_THEME_MAP[npThemeIdG] || '').trim();
  var NP_GATE_ENV = String((typeof window !== 'undefined' && window.NP_GATE_ENV) || CFG.gateEnv || 'live');
  function npGateOn() { return !!NP_GATE_URL; }
  var npGateCache = {};
  function npGateRemote(imageUrl) {
    if (!imageUrl) return Promise.resolve({ ok: false, error: 'no image url' });
    if (npGateCache[imageUrl]) return npGateCache[imageUrl];
    var ctlG = (typeof AbortController === 'function') ? new AbortController() : null;
    var timerG = ctlG ? setTimeout(function () { try { ctlG.abort(); } catch (eAb) {} }, 8000) : null;
    var t0G = Date.now();
    npGateCache[imageUrl] = fetch(NP_GATE_URL, {
      method: 'POST', mode: 'cors', credentials: 'omit',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ imageUrl: imageUrl, typeKey: TYPE_FAMILY, env: NP_GATE_ENV, minIn: npMinIn() }), /* C155; family key: woven-labels gates as woven-2-0 */
      signal: ctlG ? ctlG.signal : undefined
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (timerG) clearTimeout(timerG);
      res = res || {}; res.__ms = Date.now() - t0G;
      try { console.log('[np-e2] gate remote', res.verdict || 'pass', res.arm || '', 'rules v' + res.version, res.__ms + 'ms', res.metrics || ''); } catch (eLg) {}
      try { /* keep the np_art_metrics ring alive for the intake / harness tooling */
        if (res.metrics) {
          var ringG = JSON.parse(localStorage.getItem('np_art_metrics') || '[]'); if (!(ringG instanceof Array)) ringG = [];
          ringG.push({ t: Date.now(), u: (imageUrl.split('?')[0].split('/').pop() || '').slice(-48), remote: true, verdict: res.verdict || null, arm: res.arm || null, m: res.metrics, ph: res.metrics });
          if (ringG.length > 40) ringG = ringG.slice(-40);
          localStorage.setItem('np_art_metrics', JSON.stringify(ringG));
        }
      } catch (eRg) {}
      return res;
    }).catch(function (e) {
      if (timerG) clearTimeout(timerG);
      try { console.warn('[np-e2] gate remote failed (fail-open)', e && e.message); } catch (eW) {}
      return { ok: false, error: String(e && e.message || e) };
    });
    return npGateCache[imageUrl];
  }
  function npGateArtUrl() { return applyToggleParams(cleanUrl(artworkUrl())); }
  function npGateVerdictIs(kind) {
    /* sync read of the RESOLVED remote verdict (Generate-time backstops) */
    var rG = st.__gateRes; return !!(rG && rG.ok && rG.verdict === kind);
  }
  function npGateRenderUpload(res, modeR, deferDetail) {
    /* the upload-time card straight from the service; true = a stop was shown */
    if (PTYPE.labelsOnly && res && res.ok && res.verdict) { openLabelsStop(modeR); return true; } /* C163: any stop verdict, offers or not */
    /* C432 (Justin 2026-09-28): "in AI mode a photograph should only work on full color and reccomend / force full color as it is now.
       Any other image due to fine detail etc, shouldnt give the customer the issue until they put their size in, where we will now give
       reccomendations and the opportunity to continue with current patch type" — a non-photo verdict is remembered for the Size step
       (sizeFirstJudge) instead of stopping the upload; types without a Size step keep the upload stop */
    if (deferDetail && res && res.ok && res.verdict && res.verdict !== 'photo' && szfDefersDetail()) { st.__szfDetail = res.verdict; return false; }
    if (!(res && res.ok && res.verdict && res.card && res.card.copy)) return false;
    var cG = res.card, offersG = cG.offers || [], primG = offersG[0], altG = offersG[1];
    if (!primG) return false;
    st.__photoNudged = true;
    openUploadReco(cG.copy.eyebrow, cG.copy.title, cG.copy.bodyHtml, primG.label, primG.handle, modeR, altG ? { label: altG.label, handle: altG.handle } : null, { keep: res.verdict !== 'photo', short: !!cG.copy.short }); /* C422 */
    return true;
  }
  function npGateAsk() {
    /* one request per artwork URL; st.__artAnalyzed doubles as "gate answered"
       so every Generate-time wait keeps working unchanged */
    var uG = npGateArtUrl();
    if (st.__gateFor === uG && st.__gateReq) return st.__gateReq;
    st.__gateFor = uG; st.__gateRes = null; st.__gateDone = false;
    st.__gateReq = npGateRemote(uG).then(function (res) {
      /* C134b: our OWN completion flag — the theme's palette analysis also sets
         st.__artAnalyzed (art image load handler), which could outrun the service */
      st.__gateRes = res; st.__gateDone = true;
      return res;
    });
    return st.__gateReq;
  }
  /* thickness scale differs per material: PVC (lbZeroMax2) runs 1=barely-there
     to 10=double with 5 as standard, so its slider must START at 5 (Justin
     2026-08-24). Arrivals overwrite this via np_lbt / the ml handoff. */
  if (PTYPE.lbDefault && !st.lbThick) st.lbThick = PTYPE.lbDefault;
  /* STAGING EXPERIMENT (Justin 2026-08-24, post-A/B): Size & Pricing lives ON
     THE PAGE as Step 3 of 3, always beside the digital preview, with the
     proof options (free AI proof / skip to checkout) BELOW it. Inert on the
     published theme. ⚠ remove the id here before publishing staging. */
  var NP_PDP_PRICING = false;
  /* C90 (2026-09-01, Justin): A/B test — the duplicated Embroidered product
     (handle embroidered-patches-v2, template embroidery-2-0) gets the
     3-column Size & Pricing ON THE LIVE THEME, tested against the original.
     Add handles to widen the test; drop the theme-id term to go global. */
  /* C91 (2026-09-01, Justin): generation waits are capped at 60s - 'if nothing
     generates in 1 minute it must kick back to digital review'. The 95s waits
     above were replaced wholesale; the fallback banner + uploaded-design proof
     flow is unchanged. */
  var NP_3COL_AB_HANDLES = ['embroidered-patches-v2'];
  try {
    var np3colTheme90 = !!(window.Shopify && Shopify.theme && String(Shopify.theme.id) === '188164800831');
    var np3colHandle90 = NP_3COL_AB_HANDLES.indexOf(((location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '').toLowerCase()) > -1;
    NP_PDP_PRICING = (np3colTheme90 || np3colHandle90) && !PTYPE.names && !PTYPE.optVariant && !PTYPE.fixedSize;
  } catch (ePP) {}
  /* KILL-SWITCH — currently OFF (Justin greenlit the AI-mode restore
     2026-08-24 evening after the add-first/pre-add checkout rework). To
     re-engage in an emergency: set the compared id back to the LIVE theme id
     ('187988967743') and push np-emb2.js to live — forces classic mode and
     hides the AI tabs for customers. Justin's call ONLY, both directions. */
  /* ⛔ KILL-SWITCH ENGAGED 2026-08-25 ~01:45 ET on Justin's explicit
     instruction ("set up the kill switch and get everything in classic mode
     only ASAP") after AI mode failed repeatedly on iOS Safari and hung on
     "Finalizing Order & Adding to Cart".
     Set unconditionally — NOT via the Shopify.theme.id comparison — because
     that comparison silently evaluates FALSE (re-enabling AI mode) on any page
     where window.Shopify.theme is unavailable. Classic mode is now the ONLY
     mode for customers: orderMode() returns 'classic' and the AI tab is hidden.
     TO RESTORE AI MODE: set this back to false. Justin's call ONLY. */
  /* STAGING ONLY: AI mode ON here so the flow can be fixed and tested.
     LIVE (#187988967743) keeps this true until Justin says otherwise. */
  var NP_FORCE_CLASSIC = false;
  /* BUILD SPEC SHEETS — OFF (B70, 2026-08-25, Justin: "if you need to get rid
     of spec sheet get rid of it completely").
     The sheet was a canvas composite (patch + a drawn spec panel) uploaded and
     stamped onto the cart line. Measured cost on live: 14.5s and 16.1s clicks,
     plus the "Finalizing Order & Adding to Cart" hang, because compose/upload
     sat behind four unbounded awaits and the click waited on a freshness token
     that could drift. Orders still carry _AI Proof, _Upload, _Original Image
     and every option property — only the drawn panel is gone.
     Set back to true to re-enable sheet generation. */
  /* B95 (2026-08-25) — spec sheets back ON to MEASURE. They were switched off
     when adds ran 14-16s and looked responsible. That whole measurement window
     was on a page starved by ~2,500 runaway timers (see custom-uploader.js
     selectNearestVariant2), so every number from it was inflated and the sheets
     may have taken the blame unfairly. Justin's budget, verbatim: "If it's
     under 7 seconds of additional time it's worth keeping it." Measure against
     the 663ms clean-add baseline before deciding. */
  var NP_SPEC_SHEETS = true;
  (function () {
    var pvT = document.getElementById('np-e2-prevtitle');
    if (pvT) pvT.textContent = PTYPE.previewTitle || ('Your ' + (PTYPE.name === 'Printed' ? 'Full Color' : PTYPE.name) + ' Patch Preview');
    /* C171 (Justin 2026-09-10): a size tip under the label preview — reads the live window (metafields custom.min_width /
       custom.max_width_height) so it follows the product settings */
    if (PTYPE.fold) { /* C174: keyed on the fold STEP, not the retired fold-drives-shape flag */
      try {
        var tipHost171 = document.getElementById('np-e2-canvas');
        if (tipHost171 && !document.getElementById('np-e2-size-tip')) {
          /* C171b (Justin): the tip sits INSIDE the preview window as a light cream box along the bottom; pointer-events off so
             artwork panning on the canvas is untouched */
          var tip171 = document.createElement('p'); tip171.id = 'np-e2-size-tip'; tip171.className = 'np-e2-size-tip';
          tip171.setAttribute('style', 'position:absolute;left:12px;right:12px;bottom:12px;margin:0;padding:8px 12px;background:#FFF6DC;color:#5B4A1A;border:1px solid #F0E1B2;border-radius:10px;font-size:12px;line-height:1.4;text-align:center;pointer-events:none;z-index:3;box-shadow:0 1px 3px rgba(0,0,0,0.08)');
          var fmt171 = function (v) { return (Math.round(v * 100) / 100) + '\u2033'; };
          tip171.textContent = 'Note: woven labels can be ' + fmt171(SIZE_MIN) + ' to ' + fmt171(SIZE_MAX) + ' wide and ' + fmt171(SIZE_MIN) + ' to ' + fmt171(SIZE_MAX) + ' tall.';
          tipHost171.appendChild(tip171);
          if (!document.getElementById('np-e2-size-tip-css')) { var css171 = document.createElement('style'); css171.id = 'np-e2-size-tip-css'; css171.textContent = '@media (max-width: 749px) { #np-e2-size-tip { font-size: 9.6px !important; padding: 6px 10px !important; left: 8px !important; right: 8px !important; bottom: 8px !important; } }'; document.head.appendChild(css171); } /* C171d: 20% smaller on mobile */
        }
      } catch (eTip171) {}
    }
    /* molded flex finishes: the material IS the base color — fix it so the
       compose + specs carry it even though the bg step never shows */
    if (PTYPE.fixedBg) {
      /* the finish's own color is ALWAYS swatch #1 for both background and
         border, and it stays there no matter what the customer picks. The
         CFG arrays themselves are reordered because the swatch tiles carry
         their index INTO those arrays — reordering only the display list
         would make every tile select the wrong color. */
      ['bgs', 'threads'].forEach(function (kPin) {
        var arrPin = CFG[kPin];
        if (!arrPin || !arrPin.length) return;
        var labPin = String(PTYPE.fixedBg.label || '').toLowerCase();
        CFG[kPin] = [{ label: PTYPE.fixedBg.label, hex: PTYPE.fixedBg.hex }].concat(
          arrPin.filter(function (cPin) { return String(cPin.label || '').toLowerCase() !== labPin; })
        );
      });
    }
    if (PTYPE.fixedBg && !st.bg && !stepEnabled('bg')) st.bg = PTYPE.fixedBg;
    /* C166 (Justin 2026-09-10, woven labels): 'the tag should always start as a white tag until the user picks another color' —
       pre-select the profile's default background from the template's own swatches; the step stays open to change */
    if (PTYPE.defaultBg && !st.bg && stepEnabled('bg')) { var dBg166 = (CFG.bgs || []).filter(function (b) { return String(b.label || '').toLowerCase() === String(PTYPE.defaultBg).toLowerCase(); })[0]; if (dBg166) { st.bg = dBg166; st.__bgSeeded166 = true; } }
    /* C170 (Justin 2026-09-10): 'always default it to straight fold selected at load' — the profile's default fold is pre-selected; the step stays open to change */
    if (PTYPE.defaultFold && !st.fold && (CFG.folds || []).length) { var dF170 = CFG.folds.filter(function (f) { return String(f.label || '').toLowerCase() === String(PTYPE.defaultFold).toLowerCase(); })[0]; if (dF170) { st.fold = dF170; try { applyFoldShape(); } catch (eDF) {} } }
    /* a type whose shape / border / backing / size are PRODUCT facts rather
       than customer choices: seed them up front so the compose, the specs
       and the cart properties all carry them without a step ever showing */
    if (PTYPE.fixedShape && !st.shape) st.shape = PTYPE.fixedShape.label;
    /* C182 (Justin 2026-09-11, 'default to straight cut at load but dont actually select it'): a label type opens with the
       flat straight-cut LOOK — the default Rectangle is seeded (C175 pattern, st.__shapeSeeded175) so the preview shows
       the white label with the artwork on it — while NO fold is selected: the Fold Style row stays the first unset step. */
    if (PTYPE.foldCustom && PTYPE.fold && !st.shape && stepEnabled('shape') && (CFG.shapes || []).length) {
      var sR182 = (CFG.shapes || []).filter(function (sh) { return sh.geom === 'rectangle'; })[0];
      if (sR182) {
        st.shape = sR182.label; st.__shapeSeeded175 = true;
        try { var dR182 = shapeDims('rectangle', 1, npSelCropped()); st.ratio = dR182[1] / dR182[0]; st.h = clampSize(Math.round(st.w * st.ratio * 100) / 100, true); } catch (eR182) {}
      }
    }
    if (PTYPE.fixedCorners && !st.corners) st.corners = PTYPE.fixedCorners; /* C165: woven labels are square-cornered, no question asked */
    /* leather/faux: NO shape pre-select (Justin 2026-08-21) — the first
       preview still opens AS leather via a compose-time circle fallback
       in composePatchImage; the shape tiles stay unpicked. The FIRST mat
       (Sand etc.) seeds the hide color so that first paint is leather-toned,
       not a white face — the customer changes it like any pick. */
    if (PTYPE.mats && !st.bg && !PTYPE.noArt && PTYPE.mats[0] && PTYPE.mats[0].hex) {
      st.bg = { label: PTYPE.mats[0].label, hex: PTYPE.mats[0].hex, img: PTYPE.mats[0].img };
    }
    if (PTYPE.fixedBorder && !st.border) st.border = { label: PTYPE.fixedBorder };
    if (PTYPE.fixedBacking && !st.backing) st.backing = { label: PTYPE.fixedBacking };
    if (PTYPE.fixedWH) {
      st.w = PTYPE.fixedWH[0];
      st.h = PTYPE.fixedWH[1];
      st.ratio = st.h / st.w;
      st.sizeSeeded = true; /* stop the legacy size poller from moving them */
    }
    /* a one-colour finish is invisible against a same-tone stage: present the
       white finishes on dark material and the dark finishes on light */
    if (PTYPE.monoTone) {
      var lightFinish = (function () {
        var hx = String((PTYPE.fixedBg && PTYPE.fixedBg.hex) || '').replace('#', '');
        if (hx.length !== 6) return false;
        return (0.299 * parseInt(hx.substr(0, 2), 16) + 0.587 * parseInt(hx.substr(2, 2), 16) + 0.114 * parseInt(hx.substr(4, 2), 16)) > 140;
      })();
      document.body.classList.add(lightFinish ? 'np-e2-stage-dark' : 'np-e2-stage-light');
    }
  })();
  /* "Match My Artwork" (previously shown as "Follow Image") is a FLAG, not a
     color. The label string is persisted to line-item properties, sidecars and
     np_bgl/np_thl reorder params, and it comes back WITHOUT the follow flag —
     so both the old and new wording must keep matching forever. */
  var FOLLOW_LABEL = 'Match My Artwork';
  var FOLLOW_RE = /^(follow image|match my artwork)$/i;
  function isFollowVal(c) { return !!(c && (c.follow || FOLLOW_RE.test(c.label || ''))); }
  var PHOTO_LABEL = 'Photo (full bleed)';
  function isPhotoVal(c) { return !!(c && c.label === PHOTO_LABEL); }
  /* "Let AI Choose" picks a REAL color, not a placeholder: the preview, the
     AI proof and the order all carry the same concrete pick, and the customer
     can override it like any other swatch. */
  function npLum(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length !== 6) return 0;
    return parseInt(h.slice(0, 2), 16) * 0.299 + parseInt(h.slice(2, 4), 16) * 0.587 + parseInt(h.slice(4, 6), 16) * 0.114;
  }
  function npLum709(hex) { /* the studio's lum(): Rec.709 weights, 0-255 */
    var h = String(hex || '').replace('#', ''); if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]; if (h.length !== 6) return 0;
    return parseInt(h.slice(0, 2), 16) * 0.2126 + parseInt(h.slice(2, 4), 16) * 0.7152 + parseInt(h.slice(4, 6), 16) * 0.0722;
  }
  function npDefaultBgHex() {
    /* white artwork on the default white base is invisible — when EVERY
       colour in the artwork reads near-white, the un-picked base defaults to
       black so the design shows the moment a shape is chosen */
    var pal = st.artColors || [];
    if (pal.length && pal.every(function (h) { return npLum(h) > 215; })) return '#0C0C0E';
    return '#FFFFFF';
  }
  function aiChooseColor(kind) {
    /* C154 (Justin 2026-09-08): "the let ai choose should work on the product pages the same way it works on the mockup
       generator page ... best match based on user image colors". Parity with Patch Express `ai-choose`: the BASE contrasts
       with the design's dominant colour (dark design -> White base, light design -> Black base) and the border / lettering
       contrasts with the base (light base -> Black, dark base -> White). st.artColors[0] is the biggest colour bucket, the
       same "dominant" the studio uses. Leather keeps the palette pick (fixed hides, no white/black stock). */
    var pal = (st.artColors || []).filter(Boolean);
    if (isLeather()) {
      var hexL = null;
      if (pal.length) {
        var byLumL = pal.slice().sort(function (a, b) { return npLum(a) - npLum(b); });
        if (kind === 'bg') hexL = byLumL[0];
        else {
          var bgHexL = (st.draft && st.draft.bg && st.draft.bg.hex) || (st.bg && st.bg.hex) || byLumL[0], bestL = null, bestDL = -1;
          pal.forEach(function (c) { if (c.toLowerCase() === String(bgHexL || '').toLowerCase()) return; var dL = Math.abs(npLum(c) - npLum(bgHexL)); if (dL > bestDL) { bestDL = dL; bestL = c; } });
          hexL = bestL || byLumL[byLumL.length - 1];
        }
      }
      if (!hexL) hexL = kind === 'bg' ? '#0C0C0E' : '#FFFFFF';
      return { label: pmsName(hexL), hex: hexL };
    }
    var list = kind === 'bg' ? (CFG.bgs || []) : (CFG.threads || []);
    var byLabel = function (lab) { var f = null; list.forEach(function (c) { if (!f && c && c.hex && String(c.label).toLowerCase() === lab) f = c; }); return f; };
    var nearest = function (hex) {
      var t = [parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16)], best = null, bd = Infinity;
      list.forEach(function (c) { if (!c || !c.hex) return; var h = String(c.hex).replace('#', ''); if (h.length < 6) return; var p = [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)]; var dd = (t[0] - p[0]) * (t[0] - p[0]) * 2 + (t[1] - p[1]) * (t[1] - p[1]) * 4 + (t[2] - p[2]) * (t[2] - p[2]) * 3; if (dd < bd) { bd = dd; best = c; } });
      return best;
    };
    var pickWB = function (wantWhite) { return byLabel(wantWhite ? 'white' : 'black') || nearest(wantWhite ? '#FFFFFF' : '#0C0C0E') || { label: wantWhite ? 'White' : 'Black', hex: wantWhite ? '#FFFFFF' : '#0C0C0E' }; };
    var domHex = pal[0] || null, dark = domHex ? npLum709(domHex) < 0.55 * 255 : true; /* same weights + threshold as the studio's lum() < 0.55 */
    if (kind === 'bg') return pickWB(dark);
    var bgHex = (st.draft && st.draft.bg && st.draft.bg.hex) || (st.bg && st.bg.hex) || npDefaultBgHex(); /* the base actually on screen when none is chosen */
    return pickWB(!(npLum709(bgHex) > 0.55 * 255));
  }
  /* ═══ NATIVE VARIANT-OPTION STEPS (opt1 / opt2 / opt3) ═══
     Every other 2-0 type picks its variant by patch SIZE alone and carries the
     customer's choices as line-item properties. A type with `optVariant` does
     the opposite: its steps ARE the product's own Shopify options, and all of
     them together resolve the single variant that carries the price. Nothing
     here is product-specific — the names come from CFG.optionNames and the
     values from CFG.variants, so the option strings stay byte-identical to the
     ones Shopify matches variants on. */
  var OPT_RE = /^opt([123])$/;
  function optIdx(k) { var m = OPT_RE.exec(k || ''); return m ? parseInt(m[1], 10) : 0; }
  function optDef(k) {
    if (!PTYPE.optVariant) return null;
    var n = optIdx(k);
    if (!n) return null;
    var nm = (CFG.optionNames || [])[n - 1];
    if (!nm) return null;
    return { n: n, name: String(nm), values: optValues(n) };
  }
  function optValues(n) {
    /* first-seen order = Shopify's own option order */
    var seen = {}, out = [];
    (CFG.variants || []).forEach(function (v) {
      var lab = v['opt' + n];
      if (!lab || seen[lab]) return;
      seen[lab] = 1;
      out.push({ label: lab });
    });
    return out;
  }
  function optSizeWH(label) {
    /* '11" x 4" (Most Popular)' -> [11, 4] */
    var m = /([\d.]+)\s*"?\s*[x\u00d7]\s*([\d.]+)/i.exec(String(label || ''));
    if (m) {
      var w = parseFloat(m[1]), h = parseFloat(m[2]);
      return (isNaN(w) || isNaN(h)) ? null : [w, h];
    }
    /* single-dimension options ('2"' keychains) size the LONGEST side —
       reported as the square envelope the piece fits inside */
    var m1 = /([\d.]+)\s*"/.exec(String(label || ''));
    if (m1) { var n1 = parseFloat(m1[1]); if (!isNaN(n1)) return [n1, n1]; }
    return null;
  }
  function optVariantMatch() {
    /* EVERY enabled dimension has to agree — a partial match would charge the
       wrong price. An unfinished selection falls back to the product's first
       variant purely so the panel has a number to show; committed() still
       blocks checkout until all three rows are answered. */
    var vs = CFG.variants || [];
    var pick = null;
    vs.forEach(function (v) {
      if (pick) return;
      var ok = true;
      for (var n = 1; n <= 3; n++) {
        var d = optDef('opt' + n);
        if (!d) continue;
        var sel = st['opt' + n];
        if (!sel || String(v['opt' + n]) !== String(sel.label)) { ok = false; break; }
      }
      if (ok) pick = v;
    });
    var v2 = pick || vs[0];
    if (!v2) return null;
    var szN = PTYPE.sizeFromOpt ? optSizeWH(v2['opt' + PTYPE.sizeFromOpt]) : null;
    return {
      id: v2.id,
      price: v2.price,
      num: szN ? (szN[0] + szN[1]) / 2 : 0,
      sizeLabel: PTYPE.sizeFromOpt ? String(v2['opt' + PTYPE.sizeFromOpt] || '') : ''
    };
  }
  function commitOptStep() {
    /* commit the variant-option draft AND the physical size the size option
       states, so st.w/st.h feed the rulers, the prompt and the width/height
       properties exactly as the steppers do on every other type */
    if (!PTYPE.optVariant || !st.draft) return;
    ['opt1', 'opt2', 'opt3'].forEach(function (kC) { if (optDef(kC)) st[kC] = st.draft[kC]; });
    if (PTYPE.sizeFromOpt) {
      var selS = st['opt' + PTYPE.sizeFromOpt];
      var whS = selS ? optSizeWH(selS.label) : null;
      if (whS) { st.w = whS[0]; st.h = whS[1]; st.ratio = st.h / st.w; st.sizeSeeded = true; }
    }
  }
  function stepEnabled(k) {
    /* a variant-option step exists only while the product actually has that
       option (a 2-option product simply renders two rows) */
    /* INLINE regex, not OPT_RE: the boot IIFE calls stepEnabled('bg') for the
       fixed-colour flex types BEFORE the var initializers below have run, and
       `var` hoists as undefined — OPT_RE.test here killed the whole builder on
       every fixedBg type (metallic/matte/chrome flex went blank, 2026-08-18) */
    /* charAt, not optIdx(): same hoisting trap as OPT_RE above */
    if (/^opt[123]$/.test(k)) return !!optDef(k) && !(PTYPE.autoOpt && parseInt(k.charAt(3), 10) === PTYPE.autoOpt);
    if (k === 'ttext') return !!PTYPE.textLines;
    if (k === 'thread' && PTYPE.layersOpt) return twoLayers();
    if (k === 'font') return !!PTYPE.font;
    if (k === 'text') return !!PTYPE.textColor;
    /* one backing, decided by the product = nothing to ask; `backing: 0` is a
       product that carries no backing choice at all (nothing to write either) */
    if (k === 'backing') return PTYPE.backing !== 0 && !PTYPE.fixedBacking;
    if (k === 'size') return sizeFirstOn(); /* C229 */
    if (k === 'proof') return false; /* proof choice lives on the footer CTA + skip link now */
    if (k === 'texture') {
      /* a hot-cut silhouette has no molded field to texture — custom and free
         form skip the step entirely */
      var gT = shapeGeom();
      return !!PTYPE.texture && gT !== 'custom';
    }
    /* free form has no patch edge, so there is no border to colour */
    if (k === 'thread' && isFreeFormShape()) return false;
    /* free form has no patch BASE either — no background to colour. The one
       exception is metallic flex, where that colour IS the material the
       pieces are cut from. */
    if (k === 'bg' && isFreeFormShape() && !/^metallic-flex/.test(TYPE_KEY) && !PTYPE.fixedBg && !PTYPE.mats) return false;
    /* "No Border" chosen on the border-style step: there is no border, so
       there is no border colour either */
    if (k === 'thread' && st.border && /no border/i.test(st.border.label || '')) return false;
    if (k === 'fold') return !!PTYPE.fold && !!(CFG.folds && CFG.folds.length); /* C164 */
    if (!k) return false;
    if (k === 'shape') return !!PTYPE.shape && !foldIsDesign178(); /* C178: the Design’s Shape fold IS the shape — no Shape step while it is picked */
    if (k === 'bg') return !!PTYPE.bg;
    if (k === 'thread') return !!PTYPE.thread;
    if (k === 'border') return !!PTYPE.border;
    return true;
  }
  function isLeather() { return !!PTYPE.mats; }
  var STITCH_ADDON_TYPES = ['embroidery-2-0', 'fullcolor-2-0', 'fauxleather-2-0', 'leather-2-0', 'print-and-stitch-2-0', '3demb-2-0'];
  function stitchAddonEligible() {
    return STITCH_ADDON_TYPES.indexOf(TYPE_KEY) !== -1 && !!CFG.stitchVid;
  }
  function adjustStitchLine(delta) {
    /* the $19.99 stitchout is billed via the proof-approval product as its
       own cart line; qty = number of patches that requested it */
    try { console.log('[np-e2] stitch addon', { vid: CFG.stitchVid, delta: delta }); } catch (eSL) {}
    if (!CFG.stitchVid || !delta) return Promise.resolve();
    if (delta > 0) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', keepalive: true, body: JSON.stringify({ id: CFG.stitchVid, quantity: delta }) })
        .then(function (r) {
          if (!r.ok) { console.warn('[np-e2] stitch addon add FAILED', r.status); npToast('Could not add the $19.99 proof line - please retry'); return null; }
          return r.json();
        }).catch(function (eAF) { console.warn('[np-e2] stitch addon add error', eAF); return null; });
    }
    return cartJson().then(function (cart) {
      var ln = (cart.items || []).filter(function (it) { return String(it.variant_id) === String(CFG.stitchVid); })[0];
      if (!ln) return null;
      var q2 = Math.max(0, ln.quantity + delta);
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: ln.key, quantity: q2 }) }).then(function (r) { return r.ok ? r.json() : null; });
    }).catch(function () { return null; });
  }
  var LEATHER_ETCH = {
    'Sand':       { hex: '#4A3830' },
    'Brown':      { hex: '#3E2D1C' },
    'Dark Brown': { hex: '#55453A' },
    'F:Black & Silver': { hex: '#9A9A9A' },
    'F:Light Brown':    { hex: '#33180A' },
    'F:Dark Brown':     { hex: '#1A0D06' },
    'F:Tan':            { hex: '#2E2622' }
  };
  /* C472: Full Color (sublimated) custom shapes keep the border at least this far (inches) from the design */
  var NP_SUBLI_SAFE_IN = 0.125;
  /* C472b (Justin 2026-10-05: "match my artwork would be adding the color of the images background with the 1/8 margin"):
     the colour of the artwork's OWN background = the dominant colour along its outer edge — but only when the artwork has
     one: its outline (holes filled) is one connected shape that is at least 90% opaque inside (a badge, a framed or
     full-rectangle design). Line art or loose elements on a transparent background have no background to extend: null,
     and the safety margin stays white fabric (filling it with the stroke colour would swallow the design). */
  var npArtEdgeCache = {};
  function npArtEdgeHex(img) {
    try {
      var nw = img.naturalWidth || img.width, nh = img.naturalHeight || img.height;
      if (!(nw > 0 && nh > 0)) return null;
      var key = (img.src || '') ? img.src + '|' + nw + 'x' + nh : '';
      if (key && npArtEdgeCache.hasOwnProperty(key)) return npArtEdgeCache[key];
      var sc = Math.min(1, 360 / Math.max(nw, nh)), w = Math.max(1, Math.round(nw * sc)), h = Math.max(1, Math.round(nh * sc));
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d'); x.drawImage(img, 0, 0, w, h);
      var d = x.getImageData(0, 0, w, h).data, N = w * h, ext = new Uint8Array(N), stk = [];
      var push = function (p) { if (!ext[p] && d[p * 4 + 3] < 128) { ext[p] = 1; stk.push(p); } };
      for (var i = 0; i < w; i++) { push(i); push((h - 1) * w + i); }
      for (var j = 0; j < h; j++) { push(j * w); push(j * w + w - 1); }
      while (stk.length) { var p = stk.pop(), px = p % w; if (px > 0) push(p - 1); if (px < w - 1) push(p + 1); if (p >= w) push(p - w); if (p + w < N) push(p + w); }
      var seed = -1, shape = 0, opaque = 0;
      for (var k = 0; k < N; k++) if (!ext[k]) { shape++; if (d[k * 4 + 3] >= 128) opaque++; if (seed < 0) seed = k; }
      var out = null;
      if (seed >= 0 && opaque >= shape * 0.9) {
        var seen = new Uint8Array(N), st2 = [seed], cnt = 0; seen[seed] = 1;
        while (st2.length) {
          var q = st2.pop(), qx = q % w; cnt++;
          var nb = [qx > 0 ? q - 1 : -1, qx < w - 1 ? q + 1 : -1, q - w, q + w];
          for (var m = 0; m < 4; m++) { var n = nb[m]; if (n >= 0 && n < N && !ext[n] && !seen[n]) { seen[n] = 1; st2.push(n); } }
        }
        if (cnt >= shape * 0.97) {
          var bk = {}, tot = 0, best = null;
          for (var e = 0; e < N; e++) {
            if (ext[e] || d[e * 4 + 3] < 128) continue;
            var ex = e % w, ey = (e / w) | 0;
            if (!(ex === 0 || ey === 0 || ex === w - 1 || ey === h - 1 || ext[e - 1] || ext[e + 1] || ext[e - w] || ext[e + w])) continue;
            var o = e * 4, kb = (d[o] >> 4) + '_' + (d[o + 1] >> 4) + '_' + (d[o + 2] >> 4);
            var b = bk[kb] || (bk[kb] = { n: 0, r: 0, g: 0, b: 0 });
            b.n++; b.r += d[o]; b.g += d[o + 1]; b.b += d[o + 2]; tot++;
            if (!best || b.n > best.n) best = b;
          }
          if (best && best.n >= tot * 0.4) {
            out = '#' + [best.r, best.g, best.b].map(function (v) { return ('0' + Math.round(v / best.n).toString(16)).slice(-2); }).join('');
          }
        }
      }
      if (key) npArtEdgeCache[key] = out;
      return out;
    } catch (eE) { return null; }
  }
  /* C463 (Justin 10-02, faux leather "BM" brush art — "those thin lines should not look like that in digital mockup"): a TRUE
     disk dilation of a canvas's alpha, from an exact Euclidean distance field (Felzenszwalb–Huttenlocher, two 1-D passes). It
     replaces the stamped copies (4 radii x 24 angles for the custom-shape bubble, 28 for the border ring): stamping only
     approximates a disk for SOLID shapes — hair-thin features (brush bristles) stayed separate thin copies and fanned out
     into a hairy fringe on the cut line and the ring. The edge keeps a 1px anti-aliased ramp. */
  /* C549 (Justin 2026-11-03, a faux leather Design's Shape came out as two pieces: "it can never be 2 pieces"): the Design's
     Shape bubble dilates the art 5%, so art groups further apart than that were cut as separate pieces. A patch is ONE piece:
     close the mask (grow r, shrink r) with the smallest r that leaves a single piece, so the extra hide / backing only fills
     the gaps between the groups. r is searched on a <=200px copy, then applied once at full size. Returns r (0 = already one). */
  function npOnePiece549(ctx, W, H, C) {
    if (!(W > 0) || !(H > 0)) return 0;
    var pieces = function (m, w, h) {
      var seen = new Uint8Array(w * h), st = [], n = 0;
      for (var s = 0; s < w * h; s++) {
        if (m[s] < 128 || seen[s]) continue;
        n++; if (n > 1) return n; seen[s] = 1; st.push(s);
        while (st.length) { var p = st.pop(), x = p % w;
          if (x > 0 && m[p - 1] > 127 && !seen[p - 1]) { seen[p - 1] = 1; st.push(p - 1); }
          if (x < w - 1 && m[p + 1] > 127 && !seen[p + 1]) { seen[p + 1] = 1; st.push(p + 1); }
          if (p >= w && m[p - w] > 127 && !seen[p - w]) { seen[p - w] = 1; st.push(p - w); }
          if (p + w < w * h && m[p + w] > 127 && !seen[p + w]) { seen[p + w] = 1; st.push(p + w); } }
      }
      return n;
    };
    var maskOf = function (cv) { var dd = cv.getContext('2d').getImageData(0, 0, cv.width, cv.height).data, m = new Uint8Array(cv.width * cv.height); for (var q = 0; q < m.length; q++) m[q] = dd[q * 4 + 3]; return m; };
    var closeOn = function (srcCv, w, h, r) {
      /* closing on a canvas padded by r, so growing never clips at the edge: grow r, then grow the outside by r */
      var p = r + 2, A = document.createElement('canvas'); A.width = w + p * 2; A.height = h + p * 2;
      var ax = A.getContext('2d'); ax.drawImage(srcCv, p, p, w, h);
      npDiskDilate(ax, A.width, A.height, r);
      var id = ax.getImageData(0, 0, A.width, A.height), dd = id.data;
      for (var q = 3; q < dd.length; q += 4) dd[q] = dd[q] > 127 ? 0 : 255;
      ax.putImageData(id, 0, 0);
      npDiskDilate(ax, A.width, A.height, r);
      var id2 = ax.getImageData(p, p, w, h), d2 = id2.data, m = new Uint8Array(w * h);
      for (var q2 = 0; q2 < m.length; q2++) m[q2] = 255 - d2[q2 * 4 + 3]; /* closed alpha, anti-aliased edge kept */
      return m;
    };
    var full = ctx.canvas, m0 = maskOf(full);
    if (pieces(m0, W, H) <= 1) return 0;
    var k = Math.min(1, 200 / Math.max(W, H)), w = Math.max(1, Math.round(W * k)), h = Math.max(1, Math.round(H * k));
    var small = document.createElement('canvas'); small.width = w; small.height = h;
    small.getContext('2d').drawImage(full, 0, 0, w, h);
    var rS = 0;
    for (var r = Math.max(1, Math.round(C * k * 0.015)); r <= Math.round(C * k * 0.35); r = Math.max(r + 1, Math.round(r * 1.3))) {
      if (pieces(closeOn(small, w, h, r), w, h) <= 1) { rS = r; break; }
    }
    if (!rS) return -1;
    var rF = Math.ceil(rS / k) + 1, mF = closeOn(full, W, H, rF);
    if (pieces(mF, W, H) > 1) { rF = Math.ceil(rF * 1.25); mF = closeOn(full, W, H, rF); }
    var id3 = ctx.getImageData(0, 0, W, H), d3 = id3.data;
    for (var q3 = 0; q3 < mF.length; q3++) if (mF[q3] > d3[q3 * 4 + 3]) { d3[q3 * 4] = 0; d3[q3 * 4 + 1] = 0; d3[q3 * 4 + 2] = 0; d3[q3 * 4 + 3] = mF[q3]; }
    ctx.putImageData(id3, 0, 0);
    return rF;
  }
  function npDiskDilate(ctx, W, H, R) {
    if (!(R > 0) || !(W > 0) || !(H > 0)) return;
    var id = ctx.getImageData(0, 0, W, H), d = id.data, N = W * H, BIG = 1e20;
    var f = new Float64Array(N);
    for (var i = 0; i < N; i++) f[i] = d[i * 4 + 3] > 127 ? 0 : BIG;
    npEdtSq(f, W, H);
    for (var j = 0; j < N; j++) {
      var a = R + 0.5 - Math.sqrt(f[j]);
      if (a <= 0) continue;
      var p = j * 4, av = a >= 1 ? 255 : Math.round(a * 255);
      if (av > d[p + 3]) { d[p] = 0; d[p + 1] = 0; d[p + 2] = 0; d[p + 3] = av; }
    }
    ctx.putImageData(id, 0, 0);
  }
  /* the squared Euclidean distance of every pixel to the nearest 0 in f (C463's two 1-D passes, in place; npDiskDilate and
     the C538 sewing channel share it) */
  function npEdtSq(f, W, H) {
    var BIG = 1e20;
    var n = Math.max(W, H), z = new Float64Array(n + 1), v = new Int32Array(n), g = new Float64Array(n), o = new Float64Array(n);
    var dt1 = function (len) {
      var k = 0; v[0] = 0; z[0] = -BIG; z[1] = BIG;
      for (var q = 1; q < len; q++) {
        var s = ((g[q] + q * q) - (g[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
        while (s <= z[k]) { k--; s = ((g[q] + q * q) - (g[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]); }
        k++; v[k] = q; z[k] = s; z[k + 1] = BIG;
      }
      k = 0;
      for (var q2 = 0; q2 < len; q2++) { while (z[k + 1] < q2) k++; var dq = q2 - v[k]; o[q2] = dq * dq + g[v[k]]; }
    };
    for (var x = 0; x < W; x++) { for (var y = 0; y < H; y++) g[y] = f[y * W + x]; dt1(H); for (var y2 = 0; y2 < H; y2++) f[y2 * W + x] = o[y2]; }
    for (var y3 = 0; y3 < H; y3++) { var r0 = y3 * W; for (var x2 = 0; x2 < W; x2++) g[x2] = f[r0 + x2]; dt1(W); for (var x3 = 0; x3 < W; x3++) f[r0 + x3] = o[x3]; }
  }
  /* C538 (Justin 2026-11-03): the PVC sewing channel. One FIXED width whatever the border thickness ("thickness slider will
     not affect the sewing line thickness"); it runs in the middle of the moulded rim when the rim is 4/10 or wider, else just
     inside the patch edge (border None too: "it will just be along the border"). Drawn as a groove with a soft drop shadow so it
     still reads white on white or colour on the same colour. */
  function npSewOn() { return !!(PTYPE.sewChannel && st.sewChannel && !isFreeFormShape()); }
  function npSewInRim(ring) { return ring > 0 && Math.max(1, Math.min(10, st.lbThick || PTYPE.lbDefault || 5)) >= 4; }
  function npSewWidth(C) { return Math.max(2, Math.round(C * 0.0055)); }
  function npSewInk(underHex) {
    var h = String(underHex || '#e6e6e6').replace('#', '');
    if (!/^[0-9a-f]{6}$/i.test(h)) h = 'e6e6e6';
    var r = parseInt(h.substr(0, 2), 16), g = parseInt(h.substr(2, 2), 16), b = parseInt(h.substr(4, 2), 16);
    var dark = (0.299 * r + 0.587 * g + 0.114 * b) < 90;
    var mix = function (c, t, k) { return Math.round(c + (t - c) * k); };
    var q = function (v) { return ('0' + Math.max(0, Math.min(255, v)).toString(16)).slice(-2); };
    return dark ? '#' + q(mix(r, 255, 0.32)) + q(mix(g, 255, 0.32)) + q(mix(b, 255, 0.32))
                : '#' + q(mix(r, 0, 0.1)) + q(mix(g, 0, 0.1)) + q(mix(b, 0, 0.1));
  }
  /* the groove's shadow, set on a context before it strokes / draws the channel */
  function npSewShadow(x, gw, on) {
    x.shadowColor = on ? 'rgba(0, 0, 0, 0.32)' : 'transparent';
    x.shadowBlur = on ? gw * 1.2 : 0;
    x.shadowOffsetX = 0;
    x.shadowOffsetY = on ? Math.max(1, gw * 0.3) : 0;
  }
  /* a channel band on a custom-shape canvas: the pixels whose signed distance to the mask edge (outside > 0, inside < 0)
     lies within w/2 of s, with a 1px anti-aliased edge */
  function npSewBand(mask, W, H, s, w) {
    var mx = mask.getContext('2d'), md = mx.getImageData(0, 0, W, H).data, N = W * H, BIG = 1e20;
    var fo = new Float64Array(N), fi = new Float64Array(N);
    for (var i = 0; i < N; i++) { var on = md[i * 4 + 3] > 127; fo[i] = on ? 0 : BIG; fi[i] = on ? BIG : 0; }
    npEdtSq(fo, W, H); npEdtSq(fi, W, H);
    var out = document.createElement('canvas'); out.width = W; out.height = H;
    var ox = out.getContext('2d'), oi = ox.createImageData(W, H), od = oi.data, half = w / 2;
    for (var j = 0; j < N; j++) {
      var sd = fo[j] > 0 ? Math.sqrt(fo[j]) : -Math.sqrt(fi[j]);
      var a = Math.min(1, half + 0.5 - Math.abs(sd - s));
      if (a <= 0) continue;
      od[j * 4 + 3] = Math.round(a * 255);
    }
    ox.putImageData(oi, 0, 0);
    return out;
  }
  function leatherBurnHex(baseHex) {
    /* the etch is TWO-TONE with the hide: the burn is the leather's OWN hue,
       deeper and warmer — never a foreign gray-brown (Justin 2026-08-21,
       Sand leather previews) */
    var h = String(baseHex || '').replace('#', '');
    if (h.length !== 6) return '#2E1B0E';
    var r = Math.round(parseInt(h.substr(0, 2), 16) * 0.46);
    var g = Math.round(parseInt(h.substr(2, 2), 16) * 0.38);
    var b = Math.round(parseInt(h.substr(4, 2), 16) * 0.30);
    function q(v) { return ('0' + Math.max(0, Math.min(255, v)).toString(16)).slice(-2); }
    return '#' + q(r) + q(g) + q(b);
  }
  function leatherEtch() {
    var key = (PTYPE.name === 'Faux Leather' ? 'F:' : '') + (st.bg ? String(st.bg.label).split(' w/ ')[0] : '');
    /* faux mats have a MANUFACTURED imprint color — keep the curated tones;
       real leather burns in its own hue, derived from the picked hide */
    if (key.indexOf('F:') === 0 && LEATHER_ETCH[key]) return LEATHER_ETCH[key];
    if (st.bg && st.bg.hex) return { hex: leatherBurnHex(st.bg.hex) };
    return LEATHER_ETCH[key] || { hex: '#2E1B0E' };
  }
  function npTightArt122(img) {
    /* C122: content bounding-box crop for the shape-tile stamps. "Content" =
       a pixel that is visible AND not near-white (near-white is the JPEG's
       blank canvas the way it is paper/knockout in the etch). The bbox always
       CONTAINS every content pixel — nothing can be amputated, unlike
       trim=color's row-stripping. Returns a canvas with naturalWidth/Height
       expandos (the composer's fit math reads those), or null when the crop
       is pointless (already tight), fails (CORS taint), or would collapse. */
    try {
      var NW = img.naturalWidth, NH = img.naturalHeight;
      if (!NW || !NH) return null;
      var K = Math.min(1, 700 / Math.max(NW, NH));
      var sw = Math.max(1, Math.round(NW * K)), sh = Math.max(1, Math.round(NH * K));
      var sc = document.createElement('canvas'); sc.width = sw; sc.height = sh;
      var sx = sc.getContext('2d', { willReadFrequently: true });
      sx.drawImage(img, 0, 0, sw, sh);
      var dd = sx.getImageData(0, 0, sw, sh).data;
      var x0 = sw, y0 = sh, x1 = -1, y1 = -1;
      for (var y = 0; y < sh; y++) {
        for (var x = 0; x < sw; x++) {
          var o = (y * sw + x) * 4;
          if (dd[o + 3] > 8 && !(dd[o] > 242 && dd[o + 1] > 242 && dd[o + 2] > 242)) {
            if (x < x0) x0 = x; if (x > x1) x1 = x;
            if (y < y0) y0 = y; if (y > y1) y1 = y;
          }
        }
      }
      if (x1 < 0 || (x1 - x0) < 8 || (y1 - y0) < 8) return null;
      var padT = Math.round(Math.max(x1 - x0, y1 - y0) * 0.03);
      x0 = Math.max(0, x0 - padT); y0 = Math.max(0, y0 - padT);
      x1 = Math.min(sw - 1, x1 + padT); y1 = Math.min(sh - 1, y1 + padT);
      /* already tight (>=92% both axes): the original frame is fine */
      if ((x1 - x0 + 1) / sw >= 0.92 && (y1 - y0 + 1) / sh >= 0.92) return null;
      var cx0 = Math.round(x0 / K), cy0 = Math.round(y0 / K);
      var cw = Math.min(NW - cx0, Math.round((x1 - x0 + 1) / K)), ch = Math.min(NH - cy0, Math.round((y1 - y0 + 1) / K));
      if (cw < 4 || ch < 4) return null;
      var oc = document.createElement('canvas'); oc.width = cw; oc.height = ch;
      oc.getContext('2d').drawImage(img, cx0, cy0, cw, ch, 0, 0, cw, ch);
      oc.naturalWidth = cw; oc.naturalHeight = ch;
      return oc;
    } catch (e122) { return null; }
  }
  /* C473 (Justin 2026-10-07, PATCH-2118780 "Son's Rays Juices", faux leather Tan: "I can not see the actual logo on the proof"):
     the burn / bare split is ONE luminance threshold over the whole artwork, so a multi-colour logo collapsed to two classes — the
     yellow sun and lettering fell on the bare side (bare tan hide on a tan patch: invisible, nothing outlines them) and the purple
     disc and green fleur-de-lis fell together on the burn side (one solid disc). Inverting only swapped which half vanished.
     This maps the artwork's flat COLOUR AREAS, nested from the outside in, and overrides the plain rule (dark burns, light stays
     bare) in exactly two cases:
       1. a coloured light shape sitting on bare hide (the patch, or a white knockout) burns — it has nothing else to show it —
          unless it outlines / highlights a dark shape, holds dark shapes (a panel), or the image has its own light background;
       2. a distinctly-coloured dark detail inside a broad, solidly burned fill stays bare so it reads.
     Every other pixel keeps the per-pixel etch exactly as before; photographs / gradients (no small set of flat areas) return null.
     C473b (10-07, Justin's no-background version of the same logo still broke): a cut-out's soft edge (fragments within 3px of
     transparency) now counts as OUTSIDE and fragments between two areas bridge them, so shapes fenced by their own anti-aliasing
     are placed; area borders counted once; photo-texture art (>10% tiny fragments) keeps the plain rule.
     Checked on the 695 leather / faux uploads ordered 9-10..10-06 at preview size: 604 identical, 48 under 2% (edge noise), the
     rest the vanishing-shape / merged-detail cases this fixes. */
  function etchRegionBurn(d, W, H, T) {
    var N = W * H, i, j;
    if (!N || N > 4000000) return null;
    var buck = new Int16Array(N), opN = 0;
    for (i = 0; i < N; i++) {
      var o = i * 4;
      if (d[o + 3] < 40) { buck[i] = -1; continue; }
      buck[i] = ((d[o] >> 5) << 6) | ((d[o + 1] >> 5) << 3) | (d[o + 2] >> 5); opN++;
    }
    if (opN < 200) return null;
    /* flat-colour components (4-connected, same bucket) */
    var cc = new Int32Array(N).fill(-1), ccSize = [], stk = new Int32Array(N), nC = 0;
    for (i = 0; i < N; i++) {
      if (buck[i] < 0 || cc[i] >= 0) continue;
      var b0 = buck[i], sp = 0, sz = 0; stk[sp++] = i; cc[i] = nC;
      while (sp) {
        var p = stk[--sp]; sz++;
        var x = p % W;
        if (x > 0 && cc[p - 1] < 0 && buck[p - 1] === b0) { cc[p - 1] = nC; stk[sp++] = p - 1; }
        if (x < W - 1 && cc[p + 1] < 0 && buck[p + 1] === b0) { cc[p + 1] = nC; stk[sp++] = p + 1; }
        if (p >= W && cc[p - W] < 0 && buck[p - W] === b0) { cc[p - W] = nC; stk[sp++] = p - W; }
        if (p + W < N && cc[p + W] < 0 && buck[p + W] === b0) { cc[p + W] = nC; stk[sp++] = p + W; }
      }
      ccSize.push(sz); nC++;
    }
    var ccR = new Float64Array(nC), ccG = new Float64Array(nC), ccB = new Float64Array(nC);
    for (i = 0; i < N; i++) if (cc[i] >= 0) { var o1 = i * 4, c1 = cc[i]; ccR[c1] += d[o1]; ccG[c1] += d[o1 + 1]; ccB[c1] += d[o1 + 2]; }
    var minA = Math.max(24, Math.round(opN * 0.002));
    var regOf = new Int32Array(nC).fill(-1), nR = 0, cover = 0;
    var regR = [], regG = [], regB = [];
    for (j = 0; j < nC; j++) if (ccSize[j] >= minA) { regOf[j] = nR++; cover += ccSize[j]; regR.push(ccR[j] / ccSize[j]); regG.push(ccG[j] / ccSize[j]); regB.push(ccB[j] / ccSize[j]); }
    /* a photo / gradient is not a handful of flat areas: keep the luminance rule */
    if (!nR || nR > 60 || cover < opN * 0.8) return null;
    /* the anti-aliased fringe (a few px) joins the nearest large area (multi-source BFS, distance-capped so a small letter
       next to a big area keeps its own shape instead of being swallowed by it) */
    var lab = new Int32Array(N).fill(-1), dist = new Uint8Array(N), q = new Int32Array(N), qh = 0, qt = 0, FR = 3;
    for (i = 0; i < N; i++) if (buck[i] >= 0 && regOf[cc[i]] >= 0) { lab[i] = regOf[cc[i]]; q[qt++] = i; }
    var near = function (pp, L, dn) {
      if (dn <= 1) return true; /* the 1px anti-aliased edge always joins */
      var oo = pp * 4, dr = d[oo] - regR[L], dg = d[oo + 1] - regG[L], db = d[oo + 2] - regB[L];
      return dr * dr + dg * dg + db * db < 48 * 48; /* further in, only the same colour joins (thin dark text next to a fill stays its own shape) */
    };
    while (qh < qt) {
      var p2 = q[qh++], x2 = p2 % W, L = lab[p2], dn = dist[p2] + 1;
      if (dn > FR) continue;
      if (x2 > 0 && buck[p2 - 1] >= 0 && lab[p2 - 1] < 0 && near(p2 - 1, L, dn)) { lab[p2 - 1] = L; dist[p2 - 1] = dn; q[qt++] = p2 - 1; }
      if (x2 < W - 1 && buck[p2 + 1] >= 0 && lab[p2 + 1] < 0 && near(p2 + 1, L, dn)) { lab[p2 + 1] = L; dist[p2 + 1] = dn; q[qt++] = p2 + 1; }
      if (p2 >= W && buck[p2 - W] >= 0 && lab[p2 - W] < 0 && near(p2 - W, L, dn)) { lab[p2 - W] = L; dist[p2 - W] = dn; q[qt++] = p2 - W; }
      if (p2 + W < N && buck[p2 + W] >= 0 && lab[p2 + W] < 0 && near(p2 + W, L, dn)) { lab[p2 + W] = L; dist[p2 + W] = dn; q[qt++] = p2 + W; }
    }
    /* leftover flat-colour pieces (a lone letter, a small leaf, a counter) are areas of their own — per colour, never merged
       across colours; tiny fragments (anti-aliasing bits) stay unlabelled (-3): they keep the per-pixel rule and are left out
       of the shape map */
    var minS = Math.max(10, Math.round(minA / 10)), regOf2 = new Int32Array(nC).fill(-1);
    for (i = 0; i < N; i++) {
      if (buck[i] < 0 || lab[i] !== -1) continue;
      var cj = cc[i];
      if (ccSize[cj] >= minS) {
        if (regOf2[cj] < 0) { regOf2[cj] = nR++; if (nR > 600) return null; } /* confetti / noise: keep the luminance rule */
        lab[i] = regOf2[cj];
      } else lab[i] = -3;
    }
    /* fragments joined to the transparency / frame (the soft edge left by a removed background) lead OUTSIDE: -4. Fragments
       between two areas (-3) bridge those areas instead, so a shape fenced by its own anti-aliased edge is still placed */
    /* (only the band within 3px of real transparency: a soft edge is thin, and a chain of fringe pixels deeper in the art
       belongs to the shapes it separates) */
    qh = 0; qt = 0; dist.fill(0);
    for (i = 0; i < N; i++) {
      var xe = i % W, ye = (i / W) | 0, onFrame = xe === 0 || ye === 0 || xe === W - 1 || ye === H - 1;
      if (buck[i] < 0 || (onFrame && lab[i] === -3)) { if (lab[i] === -3) { lab[i] = -4; dist[i] = 1; } q[qt++] = i; }
    }
    while (qh < qt) {
      var pe = q[qh++], xq = pe % W, de = dist[pe] + 1;
      if (de > 3) continue;
      if (xq > 0 && lab[pe - 1] === -3) { lab[pe - 1] = -4; dist[pe - 1] = de; q[qt++] = pe - 1; }
      if (xq < W - 1 && lab[pe + 1] === -3) { lab[pe + 1] = -4; dist[pe + 1] = de; q[qt++] = pe + 1; }
      if (pe >= W && lab[pe - W] === -3) { lab[pe - W] = -4; dist[pe - W] = de; q[qt++] = pe - W; }
      if (pe + W < N && lab[pe + W] === -3) { lab[pe + W] = -4; dist[pe + W] = de; q[qt++] = pe + W; }
    }
    /* a photo texture (leather grain, distress, noise) breaks into a mass of tiny pieces: over 10% of the art = not flat colour
       areas, keep the plain rule (measured: the textured tag PATCH-2118444 12%; real logos <8%, a transparent cut-out ~6%) */
    var fragN = 0; for (i = 0; i < N; i++) if (lab[i] === -3 || lab[i] === -4) fragN++;
    if (fragN > opN * 0.1) return null;
    /* area stats + adjacency (EXT = transparency and the frame edge) */
    var EXT = nR, size = new Float64Array(nR), lumS = new Float64Array(nR), edgeTouch = new Float64Array(nR);
    var sR = new Float64Array(nR), sG = new Float64Array(nR), sB = new Float64Array(nR), darkThin = new Float64Array(nR + 1), thinE = new Float64Array(nR + 1);
    var darkN = new Float64Array(nR + 1), trE = new Float64Array(nR + 1), w550 = new Uint8Array(nR + 1); /* C550: border with transparency; white burned */
    var adj = {}, addE = function (a, b) { if (a === b) return; var k = a < b ? a + ',' + b : b + ',' + a; adj[k] = (adj[k] || 0) + 1; };
    var thinDark = function (pp) { var o6 = pp * 4; return 0.299 * d[o6] + 0.587 * d[o6 + 1] + 0.114 * d[o6 + 2] < T; };
    var fragOf = new Int32Array(N).fill(-1), fragTouch = [];
    var touchF = function (fi, r) { var m = fragTouch[fi]; m[r] = (m[r] || 0) + 1; };
    var link = function (r, q2) { /* region r meets pixel q2 */
      var Lq = q2 < 0 ? -1 : lab[q2];
      if (q2 < 0 || buck[q2] < 0) { addE(r, EXT); if (q2 >= 0) trE[r]++; return; }
      if (Lq >= 0) { addE(r, Lq); return; }
      if (Lq === -4) { addE(r, EXT); trE[r]++; if (thinDark(q2)) darkThin[r]++; return; }
      thinE[r]++; if (thinDark(q2)) darkThin[r]++;
      if (fragOf[q2] < 0) { /* label this internal fragment once */
        var fi = fragTouch.length; fragTouch.push({}); var fs = [q2]; fragOf[q2] = fi;
        while (fs.length) { var fp = fs.pop(), fx = fp % W;
          var cand = [fx > 0 ? fp - 1 : -1, fx < W - 1 ? fp + 1 : -1, fp >= W ? fp - W : -1, fp + W < N ? fp + W : -1];
          for (var ci = 0; ci < 4; ci++) { var cq = cand[ci]; if (cq >= 0 && lab[cq] === -3 && fragOf[cq] < 0) { fragOf[cq] = fi; fs.push(cq); } } }
      }
      touchF(fragOf[q2], r);
    };
    for (i = 0; i < N; i++) {
      var Li = lab[i], xi = i % W, yi = (i / W) | 0;
      if (Li < 0) continue;
      var o2 = i * 4, l2 = 0.299 * d[o2] + 0.587 * d[o2 + 1] + 0.114 * d[o2 + 2]; size[Li]++; lumS[Li] += l2; sR[Li] += d[o2]; sG[Li] += d[o2 + 1]; sB[Li] += d[o2 + 2]; if (l2 < T) darkN[Li]++;
      if (xi === 0 || yi === 0 || xi === W - 1 || yi === H - 1) { edgeTouch[Li]++; addE(Li, EXT); }
      /* each area-to-area border is counted once (right / down); borders with non-areas (outside, fragments) from all four
         sides, since those pixels are not walked */
      if (xi > 0) { var nl = lab[i - 1]; if (nl < 0) link(Li, i - 1); }
      if (xi < W - 1) { var nr2 = lab[i + 1]; if (nr2 !== Li) link(Li, i + 1); }
      if (i >= W) { var nu = lab[i - W]; if (nu < 0) link(Li, i - W); }
      if (i + W < N) { var nd = lab[i + W]; if (nd !== Li) link(Li, i + W); }
    }
    /* an internal fragment touching several areas bridges them (weight = the smaller contact) */
    for (var fz = 0; fz < fragTouch.length; fz++) {
      var ks = Object.keys(fragTouch[fz]); if (ks.length < 2) continue;
      for (var ka = 0; ka < ks.length; ka++) for (var kb = ka + 1; kb < ks.length; kb++) {
        var ra = +ks[ka], rb = +ks[kb], wgt = Math.min(fragTouch[fz][ra], fragTouch[fz][rb]);
        var kk = ra < rb ? ra + ',' + rb : rb + ',' + ra; adj[kk] = (adj[kk] || 0) + wgt;
      }
    }
    var nb = []; for (j = 0; j <= nR; j++) nb.push({});
    Object.keys(adj).forEach(function (k) { var ab = k.split(','), a = +ab[0], b = +ab[1]; nb[a][b] = adj[k]; nb[b][a] = adj[k]; });
    var depth = new Int32Array(nR + 1).fill(-1), order = [EXT]; depth[EXT] = 0;
    for (var h = 0; h < order.length; h++) { var u = order[h]; Object.keys(nb[u]).forEach(function (v) { v = +v; if (depth[v] < 0) { depth[v] = depth[u] + 1; order.push(v); } }); }
    var parent = new Int32Array(nR).fill(EXT), hasKids = new Uint8Array(nR + 1);
    for (j = 0; j < nR; j++) {
      if (depth[j] <= 1) { parent[j] = EXT; continue; }
      var bestP = -1, bestE = -1;
      Object.keys(nb[j]).forEach(function (v) { v = +v; if (depth[v] === depth[j] - 1 && nb[j][v] > bestE) { bestE = nb[j][v]; bestP = v; } });
      parent[j] = bestP < 0 ? EXT : bestP;
    }
    var meanL = new Float64Array(nR + 1), per = new Float64Array(nR + 1);
    for (j = 0; j < nR; j++) meanL[j] = lumS[j] / Math.max(1, size[j]);
    for (j = 0; j < nR; j++) Object.keys(nb[j]).forEach(function (v) { per[j] += nb[j][v]; });
    var hasDarkKids = new Uint8Array(nR + 1);
    for (j = 0; j < nR; j++) { hasKids[parent[j]] = 1; if (meanL[j] < T) hasDarkKids[parent[j]] = 1; }
    var perim = 2 * (W + H), burnR = new Uint8Array(nR + 1), thickMin = Math.max(4, Math.max(W, H) * 0.012);
    /* an image with its OWN light, coloured background reaching the frame edge (parchment, cream, kraft, a vignette): its light
       areas are background, not shapes that would vanish — the light-shape rule stays off for that image */
    var edgeN = 0, edgeLight = 0;
    var edgeChk = function (pp) { edgeN++; var o7 = pp * 4; if (d[o7 + 3] < 40) return; var l7 = 0.299 * d[o7] + 0.587 * d[o7 + 1] + 0.114 * d[o7 + 2]; if (l7 >= T && l7 < 246) edgeLight++; };
    for (i = 0; i < W; i++) { edgeChk(i); edgeChk((H - 1) * W + i); }
    for (j = 1; j < H - 1; j++) { edgeChk(j * W); edgeChk(j * W + W - 1); }
    var lightBg = edgeLight >= edgeN * 0.5;
    var clear550 = (N - opN) >= N * 0.08; /* C550: the art has real transparency (a removed or transparent background) */
    for (h = 1; h < order.length; h++) {
      var r = order[h]; if (r === EXT) continue;
      var lum = meanL[r], pr = parent[r], dark = lum < T;
      /* knockout: near-white, or the image's own light background panel (holds a large share of the frame edge and other shapes) */
      /* C550 (Justin 2026-11-03, the Addams lettering vanished on leather: "the 3rd one has no white at all"): once the background is
         gone, white IS the design — a laser cannot add white, so a pale shape standing on the cleared area (at least half its border
         is transparency) that holds no dark detail and is not the outline / highlight of a dark shape burns instead of vanishing.
         White inside the art (a face holding line-work, a fill inside an outline) is unchanged: bare hide. */
      if (clear550 && !dark && pr === EXT && !hasDarkKids[r] && edgeTouch[r] < perim * 0.3) {
        var dE550 = darkThin[r], tE550 = thinE[r];
        Object.keys(nb[r]).forEach(function (v) { v = +v; tE550 += nb[r][v]; if (v !== EXT && meanL[v] < T) dE550 += nb[r][v]; });
        if (trE[r] >= tE550 * 0.5 && dE550 < tE550 * 0.35) { burnR[r] = 1; w550[r] = 1; continue; }
      }
      var knock = lum >= 246 || (edgeTouch[r] >= perim * 0.3 && hasKids[r] && lum >= 150);
      if (knock) { burnR[r] = 0; continue; }
      if (dark) {
        /* a detail inside a BROAD burned fill (not inside a thin outline) would merge into it: keep it bare so it reads */
        var cdR = sR[r] / size[r] - (pr !== EXT ? sR[pr] / size[pr] : 0), cdG = sG[r] / size[r] - (pr !== EXT ? sG[pr] / size[pr] : 0), cdB = sB[r] / size[r] - (pr !== EXT ? sB[pr] / size[pr] : 0);
        var distinct = cdR * cdR + cdG * cdG + cdB * cdB >= 70 * 70; /* a different colour (green on purple), not two shades of one dark */
        var broad = pr !== EXT && burnR[pr] && distinct && darkN[pr] >= size[pr] * 0.8 && (size[pr] / Math.max(1, per[pr])) >= thickMin; /* the fill really renders solid burned */
        burnR[r] = broad ? 0 : 1;
      } else {
        /* a light shape on bare hide (the patch itself or a knockout) has nothing to outline it and would vanish: burn it —
           unless it is the outline / highlight of a dark shape (that shape carries the silhouette) or a panel holding dark shapes */
        var onBare = pr === EXT || !burnR[pr];
        if (!onBare || lightBg) { burnR[r] = 0; continue; }
        var darkEdge = darkThin[r], totE = thinE[r];
        Object.keys(nb[r]).forEach(function (v) { v = +v; totE += nb[r][v]; if (v !== EXT && meanL[v] < T) darkEdge += nb[r][v]; });
        /* only a real COLOUR vanishes this way (yellow, pink, gold, light blue); near-white and pale grey are paper/highlight: bare */
        var mr = sR[r] / size[r], mg = sG[r] / size[r], mb = sB[r] / size[r], chroma = Math.max(mr, mg, mb) - Math.min(mr, mg, mb);
        var colour = chroma >= 40 || lum < 200;
        burnR[r] = (!colour || hasDarkKids[r] || darkEdge >= totE * 0.35) ? 0 : 1;
      }
    }
    /* areas the shape map could not reach (fenced off by unlabelled fragments) keep the plain rule */
    for (j = 0; j < nR; j++) if (depth[j] < 0) burnR[j] = meanL[j] < T ? 1 : 0;
    /* override ONLY the areas whose decision differs from the plain luminance rule (dark burns, light stays bare), and only on
       their pixels of that same tone; every other pixel keeps the existing per-pixel etch exactly as before (-1) */
    var out = new Int8Array(N).fill(-1), flips = 0;
    for (i = 0; i < N; i++) {
      var Lr = lab[i]; if (Lr < 0) continue;
      var baseDark = meanL[Lr] < T, want = burnR[Lr];
      if ((baseDark ? 1 : 0) === want || (meanL[Lr] >= 246 && !w550[Lr])) continue;
      var o5 = i * 4, pl = 0.299 * d[o5] + 0.587 * d[o5 + 1] + 0.114 * d[o5 + 2];
      if ((pl < T) !== baseDark) continue;
      out[i] = want; flips++;
    }
    return flips ? out : null;
  }
  /* C535 (Justin 2026-10-30, PATCH-2125023, faux leather Dark Brown, revision "I can't see my logo at this patch !"): the
     upload was a mockup of the logo on a dark wall, opaque edge to edge. Otsu split it at 47, under the floor of 50, so the
     cut-off fell back to 196, brighter than every pixel in it. The whole frame burned: the digital preview was one flat colour,
     the AI drew a blank patch from it, and World Emblem proofed a blank patch.
     This is the cut-off etchArtCanvasRaw has always used, moved here unchanged, plus `blank`: the 196 fallback burns 98% or
     more of the WHOLE frame (not of the opaque pixels, so a dark logo on a transparent or white background never counts) while
     the art still has a lighter part Otsu can split off. Then the etch keeps Otsu's split (keepT), so the logo shows as bare
     hide in a burned frame. 6 of the 1,477 leather / faux uploads ordered 5-18..10-30 were blank this way; every other upload
     etches exactly as before. Switching Remove background on automatically was tried and dropped: imgix's cut-out erased
     most of the lettering on 2 of those 6 (HOWDY IDAHO, CNR). */
  function etchSplit535(d) {
    var __h = []; for (var hi = 0; hi < 256; hi++) __h[hi] = 0;
    var __tot = 0;
    for (var pi = 0; pi < d.length; pi += 4) {
      if (d[pi + 3] < 40) continue;
      var lP = Math.round(0.299 * d[pi] + 0.587 * d[pi + 1] + 0.114 * d[pi + 2]);
      if (lP >= 246) continue; /* knockout white is bare, never ink data */
      __h[Math.max(0, Math.min(255, lP))]++; __tot++;
    }
    var __etchT = 196, bestT = -1, minorFrac = 0;
    if (__tot > 100) {
      var sumAll = 0; for (var si = 0; si < 256; si++) sumAll += si * __h[si];
      var wB = 0, sumB = 0, best = -1;
      bestT = 128;
      for (var ti = 0; ti < 256; ti++) {
        wB += __h[ti]; if (!wB) continue;
        var wF = __tot - wB; if (!wF) break;
        sumB += ti * __h[ti];
        var mB = sumB / wB, mF = (sumAll - sumB) / wF;
        var v = wB * wF * (mB - mF) * (mB - mF);
        if (v > best) { best = v; bestT = ti; }
      }
      var minor = 0; for (var mi = bestT + 1; mi < 256; mi++) minor += __h[mi];
      minorFrac = Math.min(minor, __tot - minor) / __tot;
      if (minorFrac >= 0.06 && bestT >= 50 && bestT <= 210) __etchT = bestT + 2;
    }
    var blank = false;
    if (__etchT === 196 && bestT >= 12 && bestT <= 210 && minorFrac >= 0.01) {
      var burnN = 0;
      for (var bi = 0; bi < d.length; bi += 4) {
        if (d[bi + 3] < 40) continue;
        if (0.299 * d[bi] + 0.587 * d[bi + 1] + 0.114 * d[bi + 2] < 196) burnN++;
      }
      blank = burnN >= (d.length / 4) * 0.98;
    }
    return { T: __etchT, blank: blank, keepT: blank ? bestT + 2 : __etchT };
  }
  /* C535b (Justin 2026-10-30: "we need to have a message to let the customer know while their Design may not be giving a good
     preview. We will be sure to print it like their original design and the choices they chose"): the note under the preview
     and on the AI proof shows while the etch flags the artwork as a frame-filling burn (etchSplit535 `blank`). Every etch
     decides it again, so switching Remove background on or uploading other art clears it. */
  function npPrevNote535(on) {
    st.__etchBlank535 = !!on; /* C535c: npPreviewFlag535 reads it at add time */
    var els = document.querySelectorAll('[data-e2-prevnote]');
    for (var i = 0; i < els.length; i++) els[i].hidden = !on;
  }
  /* C535c (Justin 2026-10-30, "Yes please" to tagging these lines so the World Emblem app sends the original image): a line
     whose design the etch could not preview carries `_Preview Flag`, and vendors make it from `_Original Image` instead of a
     proof built on that preview. Written at add time next to C519's `_Patch Rec`; '' (no property) otherwise. */
  function npPreviewFlag535() {
    setProp('_Preview Flag', (isLeather() && st.__etchBlank535) ? 'Preview could not show this design - make it from the original upload' : '');
  }
  function etchArtCanvas(img, w, h, toneHex, invertK) {
    /* C220: the two-tone burn is decided at 2x and downsampled, so edges come out anti-aliased instead of stair-stepped and the
       3x3 median / fleck cleanup nibble half as much of a thin stroke. Budget-capped (output <= 250k px, i.e. the 640-composite
       and panning cases); larger art boxes already sit at device resolution and take the raw path unchanged. */
    var W220 = Math.max(1, Math.round(w)), H220 = Math.max(1, Math.round(h));
    if (W220 * H220 <= 250000) {
      try {
        var hi220 = etchArtCanvasRaw(img, W220 * 2, H220 * 2, toneHex, invertK);
        var out220 = document.createElement('canvas'); out220.width = W220; out220.height = H220;
        var ox220 = out220.getContext('2d'); ox220.imageSmoothingEnabled = true; try { ox220.imageSmoothingQuality = 'high'; } catch (eQ) {}
        ox220.drawImage(hi220, 0, 0, W220, H220);
        return out220;
      } catch (e220) {}
    }
    return etchArtCanvasRaw(img, W220, H220, toneHex, invertK);
  }
  function etchArtCanvasRaw(img, w, h, toneHex, invertK) {
    /* two-tone laser etch, ENGRAVER'S RULES (Justin 2026-08-21): thin dark
       line-work burns; a BROAD dark fill flips — the fill reads as bare hide
       with a burned rim, and the light detail enclosed in it (letters, gill
       lines) burns instead — how a real vendor etches dark-fill art so the
       patch still reads as leather. Near-white is paper/knockout: always
       bare AND excluded from the ink split, so an un-removed white
       background can no longer collapse the art into one solid silhouette.
       Output stays STRICT TWO-TONE: hide + ONE burn tone. */
    var t = document.createElement('canvas');
    t.width = Math.max(1, Math.round(w)); t.height = Math.max(1, Math.round(h));
    var tx = t.getContext('2d');
    /* inverted designs get a small inset so the burned outline ringing the
       silhouette has room inside the canvas (Justin 2026-08-21) */
    var padK = invertK ? Math.max(4, Math.round(Math.min(t.width, t.height) * 0.025)) : 0;
    tx.drawImage(img, padK, padK, t.width - padK * 2, t.height - padK * 2);
    var id, d;
    try { id = tx.getImageData(0, 0, t.width, t.height); d = id.data; }
    catch (eTaint) {
      /* CORS-tainted source: pixels unreadable — burn the whole silhouette
         in the etch tone rather than break the compose */
      tx.globalCompositeOperation = 'source-in';
      tx.fillStyle = toneHex || leatherEtch().hex;
      tx.fillRect(0, 0, t.width, t.height);
      return t;
    }
    var W2 = t.width, H2 = t.height;
    var sp535 = etchSplit535(d);
    var __etchT = sp535.blank ? sp535.keepT : sp535.T; /* C535: a frame-filling burn keeps Otsu's own split */
    try { npPrevNote535(sp535.blank); } catch (e535b) {}
    var rb473 = null; try { rb473 = etchRegionBurn(d, W2, H2, __etchT); } catch (eRB) { rb473 = null; } /* C473: colour-area overrides (null = none) */
    /* broad-fill analysis on a downsampled mask: morphological opening finds
       fills wider than ~7%% of the art; thin strokes survive as line-work */
    var sw = W2, sh = H2;
    if (Math.max(W2, H2) > 300) {
      if (W2 >= H2) { sw = 300; sh = Math.max(1, Math.round(H2 * 300 / W2)); }
      else { sh = 300; sw = Math.max(1, Math.round(W2 * 300 / H2)); }
    }
    var scv = document.createElement('canvas'); scv.width = sw; scv.height = sh;
    var scx = scv.getContext('2d'); scx.drawImage(t, 0, 0, sw, sh);
    var sdd = null;
    try { sdd = scx.getImageData(0, 0, sw, sh).data; } catch (eT2) { sdd = null; }
    var NN = sw * sh, ink = new Uint8Array(NN), opq = new Uint8Array(NN), inkN = 0;
    if (sdd) for (var qi = 0; qi < NN; qi++) {
      var q4 = qi * 4;
      if (sdd[q4 + 3] < 40) continue;
      opq[qi] = 1;
      var lQ = 0.299 * sdd[q4] + 0.587 * sdd[q4 + 1] + 0.114 * sdd[q4 + 2];
      if (lQ < __etchT && lQ < 246) { ink[qi] = 1; inkN++; }
    }
    function mErode(src) {
      var out = new Uint8Array(NN);
      for (var y = 0; y < sh; y++) for (var x = 0; x < sw; x++) {
        var i2 = y * sw + x; if (!src[i2]) continue;
        if (x > 0 && !src[i2 - 1]) continue; if (x < sw - 1 && !src[i2 + 1]) continue;
        if (y > 0 && !src[i2 - sw]) continue; if (y < sh - 1 && !src[i2 + sw]) continue;
        out[i2] = 1;
      }
      return out;
    }
    function mDilate(src) {
      var out = new Uint8Array(src);
      for (var y = 0; y < sh; y++) for (var x = 0; x < sw; x++) {
        var i2 = y * sw + x; if (src[i2]) continue;
        if ((x > 0 && src[i2 - 1]) || (x < sw - 1 && src[i2 + 1]) || (y > 0 && src[i2 - sw]) || (y < sh - 1 && src[i2 + sw])) out[i2] = 1;
      }
      return out;
    }
    var RR = Math.max(3, Math.round(Math.min(sw, sh) * 0.035)), mz;
    var opn = ink;
    for (mz = 0; mz < RR; mz++) opn = mErode(opn);
    for (mz = 0; mz < RR + 1; mz++) opn = mDilate(opn);
    var opnN = 0;
    for (qi = 0; qi < NN; qi++) { if (opn[qi] && !ink[qi]) opn[qi] = 0; opnN += opn[qi]; }
    /* one plain solid mark (a silhouette logo) still burns solid — flip only
       when real line-work exists alongside the fills */
    /* C101 (2026-09-01): FLOOR on the flip - morphological remnants of bold
       glyph cores used to satisfy `opnN > 0` and flip the fill bare, punching
       light dots INSIDE dark lettering (the TRANSFERS speckles). A real broad
       fill keeps at least ~20% of the ink after opening. */
    /* C111 (2026-09-01, Justin sign-off on the etch-compare strip): the AUTO
       broad-fill invert is DISABLED - it flipped solid text logos into
       bare-with-outline ("tops of NINJA missing"). Dark always burns dark;
       the explicit invert mode (invertK) is untouched. */
    var invertOn = false;
    /* inverted designs ALWAYS keep a burned outline around the artwork so
       the silhouette never fades into the hide: a ring just OUTSIDE the
       opaque footprint, in the etch tone */
    var outlM = null;
    if (invertK && sdd) {
      var oR = Math.max(3, Math.round(Math.min(sw, sh) * 0.015)), oz;
      var dil = opq;
      for (oz = 0; oz < oR; oz++) dil = mDilate(dil);
      outlM = new Uint8Array(NN);
      for (qi = 0; qi < NN; qi++) outlM[qi] = (dil[qi] && !opq[qi]) ? 1 : 0;
    }
    var bareM = new Uint8Array(NN), holeM = new Uint8Array(NN);
    if (invertOn) {
      var cor = opn, rimW = Math.max(2, Math.round(RR / 2));
      for (mz = 0; mz < rimW; mz++) cor = mErode(cor);
      for (qi = 0; qi < NN; qi++) bareM[qi] = cor[qi];
      /* enclosed light detail (letters, gill lines INSIDE a fill): bare
         regions that never reach the outside and border mostly-broad ink */
      var lbl = new Int32Array(NN), stk = [], comp = 0, opqN = 0;
      for (qi = 0; qi < NN; qi++) opqN += opq[qi];
      for (var s0 = 0; s0 < NN; s0++) {
        if (lbl[s0] || ink[s0] || !opq[s0]) continue;
        comp++;
        var touchesOut = false, bInk = 0, bOpen = 0, members = [];
        lbl[s0] = comp; stk.push(s0);
        while (stk.length) {
          var c0 = stk.pop(); members.push(c0);
          var cy = (c0 / sw) | 0, cx = c0 - cy * sw;
          for (var dn = 0; dn < 4; dn++) {
            var nx = cx + (dn === 0 ? -1 : dn === 1 ? 1 : 0), ny = cy + (dn === 2 ? -1 : dn === 3 ? 1 : 0);
            if (nx < 0 || ny < 0 || nx >= sw || ny >= sh) { touchesOut = true; continue; }
            var n0 = ny * sw + nx;
            if (!opq[n0]) { touchesOut = true; continue; }
            if (ink[n0]) { bInk++; if (opn[n0]) bOpen++; continue; }
            if (!lbl[n0]) { lbl[n0] = comp; stk.push(n0); }
          }
        }
        if (!touchesOut && bInk && (bOpen / bInk) >= 0.55 && members.length <= opqN * 0.25) {
          for (var m0 = 0; m0 < members.length; m0++) holeM[members[m0]] = 1;
        }
      }
    }
    function mSample(m, fx, fy) {
      var x0 = fx | 0, y0 = fy | 0;
      var x1 = Math.min(sw - 1, x0 + 1), y1 = Math.min(sh - 1, y0 + 1);
      var ax = fx - x0, ay = fy - y0;
      return m[y0 * sw + x0] * (1 - ax) * (1 - ay) + m[y0 * sw + x1] * ax * (1 - ay) + m[y1 * sw + x0] * (1 - ax) * ay + m[y1 * sw + x1] * ax * ay;
    }
    var hx = (toneHex || leatherEtch().hex).replace('#', '');
    var er = parseInt(hx.substr(0, 2), 16), eg = parseInt(hx.substr(2, 2), 16), eb = parseInt(hx.substr(4, 2), 16);
    var kxS = (sw - 1) / Math.max(1, W2 - 1), kyS = (sh - 1) / Math.max(1, H2 - 1);
    /* C104 (2026-09-01): 3x3 MEDIAN on luminance BEFORE thresholding - kills
       compression/AA salt at the source instead of patching dots afterwards.
       Text edges survive a 3x3 median at this resolution; isolated specks
       inside glyphs do not. */
    var lum104 = new Float32Array(W2 * H2);
    for (var q4 = 0, i4 = 0; i4 < d.length; i4 += 4, q4++) lum104[q4] = 0.299 * d[i4] + 0.587 * d[i4 + 1] + 0.114 * d[i4 + 2];
    var med104 = lum104;
    try {
      med104 = new Float32Array(W2 * H2);
      med104.set(lum104);
      var win104 = new Float32Array(9);
      for (var yM = 1; yM < H2 - 1; yM++) {
        var rM = yM * W2;
        for (var xM = 1; xM < W2 - 1; xM++) {
          var pM = rM + xM, wN = 0;
          for (var dy = -1; dy <= 1; dy++) { var rr = pM + dy * W2; win104[wN++] = lum104[rr - 1]; win104[wN++] = lum104[rr]; win104[wN++] = lum104[rr + 1]; }
          /* median of 9 via partial selection */
          for (var aM = 0; aM < 5; aM++) { var mn = aM; for (var bM = aM + 1; bM < 9; bM++) if (win104[bM] < win104[mn]) mn = bM; var tv = win104[aM]; win104[aM] = win104[mn]; win104[mn] = tv; }
          med104[pM] = win104[4];
        }
      }
    } catch (e104) { med104 = lum104; }
    for (var i = 0; i < d.length; i += 4) {
      var l = med104[i >> 2];
      /* BINARY burn with an 8-unit AA ramp only — laser burns or it doesn't */
      var k = l < __etchT - 4 ? 1 : (l < __etchT + 4 ? (__etchT + 4 - l) / 8 : 0);
      if (l >= 246) k = 0;
      if (rb473 && rb473[i >> 2] >= 0) k = rb473[i >> 2]; /* C473 */
      if (invertOn) {
        var p0 = i >> 2, pyF = (p0 / W2) | 0, pxF = p0 - pyF * W2;
        var fB = mSample(bareM, pxF * kxS, pyF * kyS), hB = mSample(holeM, pxF * kxS, pyF * kyS);
        k = Math.max(0, Math.min(1, k * (1 - fB) + hB));
      }
      /* INVERT-THE-DESIGN mode (standard shapes): flip burn/bare WITHIN the
         artwork's own opaque footprint — the patch face is untouched */
      if (invertK && d[i + 3] >= 40) k = 1 - k;
      var aOut = Math.round(d[i + 3] * k);
      if (outlM) {
        var p1 = i >> 2, pyO = (p1 / W2) | 0, pxO = p1 - pyO * W2;
        var oV = mSample(outlM, pxO * kxS, pyO * kyS);
        if (oV > 0.02) aOut = Math.max(aOut, Math.round(oV * 255));
      }
      d[i + 3] = aOut;
      d[i] = er; d[i + 1] = eg; d[i + 2] = eb;
    }
    /* C109 (2026-09-01, Justin: "solid outlines solid, solid imprint solid -
       not distressed - whether inverted or not"). Two safe operations only:
       CLOSE (r=2) fills pinholes/distress INSIDE burned strokes and fills -
       it never removes ink, so thin outlines are safe. Fleck removal is by
       CONNECTED-COMPONENT AREA, not erosion (C108's open erased 2px outline
       strokes): an isolated burn island smaller than ~30px is distress; a
       thin outline is one large connected component and survives untouched.
       The etched-border ring (outlM) is protected from all of it. */
    try {
      var N9 = W2 * H2;
      var B9 = new Uint8Array(N9);
      for (var s9 = 0; s9 < N9; s9++) B9[s9] = d[s9 * 4 + 3] >= 128 ? 1 : 0;
      var prot9 = null;
      if (outlM) {
        prot9 = new Uint8Array(N9);
        for (var q9 = 0; q9 < N9; q9++) {
          var py9 = (q9 / W2) | 0, px9 = q9 - py9 * W2;
          if (mSample(outlM, px9 * kxS, py9 * kyS) > 0.02) prot9[q9] = 1;
        }
      }
      function dil9(src9) {
        var o9 = new Uint8Array(N9);
        for (var y9 = 0; y9 < H2; y9++) { var r9 = y9 * W2;
          for (var x9 = 0; x9 < W2; x9++) { var p9 = r9 + x9, v9 = src9[p9];
            if (!v9) { for (var dy9 = -1; dy9 <= 1 && !v9; dy9++) { var yy9 = y9 + dy9; if (yy9 < 0 || yy9 >= H2) continue;
              for (var dx9 = -1; dx9 <= 1; dx9++) { var xx9 = x9 + dx9; if (xx9 >= 0 && xx9 < W2 && src9[yy9 * W2 + xx9]) { v9 = 1; break; } } } }
            o9[p9] = v9; } }
        return o9;
      }
      function ero9(src9) {
        var o9 = new Uint8Array(N9);
        for (var y9 = 0; y9 < H2; y9++) { var r9 = y9 * W2;
          for (var x9 = 0; x9 < W2; x9++) { var p9 = r9 + x9, v9 = src9[p9];
            if (v9) { for (var dy9 = -1; dy9 <= 1 && v9; dy9++) { var yy9 = y9 + dy9; if (yy9 < 0 || yy9 >= H2) { v9 = 0; break; }
              for (var dx9 = -1; dx9 <= 1; dx9++) { var xx9 = x9 + dx9; if (xx9 < 0 || xx9 >= W2 || !src9[yy9 * W2 + xx9]) { v9 = 0; break; } } } }
            o9[p9] = v9; } }
        return o9;
      }
      var C9 = ero9(ero9(dil9(dil9(B9)))); /* CLOSE r=2: fills interior distress */
      /* fleck removal: kill small isolated BURN components */
      var lbl9 = new Int32Array(N9), stack9 = [], comp9 = 0;
      var minA9 = Math.max(30, Math.round(N9 * 0.00003));
      for (var seed9 = 0; seed9 < N9; seed9++) {
        if (C9[seed9] && !lbl9[seed9]) {
          comp9++; var mem9 = [seed9]; lbl9[seed9] = comp9; stack9.length = 0; stack9.push(seed9);
          while (stack9.length) {
            var c9 = stack9.pop(), cy9 = (c9 / W2) | 0, cx9 = c9 - cy9 * W2;
            for (var dy9b = -1; dy9b <= 1; dy9b++) { var ny9 = cy9 + dy9b; if (ny9 < 0 || ny9 >= H2) continue;
              for (var dx9b = -1; dx9b <= 1; dx9b++) { var nx9 = cx9 + dx9b; if (nx9 < 0 || nx9 >= W2) continue;
                var n9 = ny9 * W2 + nx9;
                if (C9[n9] && !lbl9[n9]) { lbl9[n9] = comp9; stack9.push(n9); mem9.push(n9); } } }
          }
          if (mem9.length < minA9) { for (var k9 = 0; k9 < mem9.length; k9++) C9[mem9[k9]] = 0; }
        }
      }
      for (var f9 = 0; f9 < N9; f9++) {
        if (prot9 && prot9[f9]) continue;
        if (C9[f9] && !B9[f9]) d[f9 * 4 + 3] = 255;      /* interior distress: fill solid */
        else if (!C9[f9] && B9[f9]) d[f9 * 4 + 3] = 0;   /* isolated fleck: remove */
      }
    } catch (e109) {}
    tx.putImageData(id, 0, 0);
    return t;
  }
  function monoArtCanvas(img, w, h, tone) {
    /* single-material finishes (matte black / matte white) are ONE colour of
       flex: the design is not printed, it is molded in the same material, so
       the artwork reads as two tones of that colour rather than full colour.
       Artwork luminance maps between the finish's dark and light tone. */
    var t = document.createElement('canvas');
    t.width = Math.max(1, Math.round(w)); t.height = Math.max(1, Math.round(h));
    var tx = t.getContext('2d');
    tx.drawImage(img, 0, 0, t.width, t.height);
    var id = tx.getImageData(0, 0, t.width, t.height), d = id.data;
    function rgb(hx) {
      hx = String(hx || '').replace('#', '');
      return [parseInt(hx.substr(0, 2), 16), parseInt(hx.substr(2, 2), 16), parseInt(hx.substr(4, 2), 16)];
    }
    var lo = rgb(tone && tone.dark), hi = rgb(tone && tone.light);
    for (var i = 0; i < d.length; i += 4) {
      if (!d[i + 3]) continue;
      var l = (0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]) / 255;
      d[i] = Math.round(lo[0] + (hi[0] - lo[0]) * l);
      d[i + 1] = Math.round(lo[1] + (hi[1] - lo[1]) * l);
      d[i + 2] = Math.round(lo[2] + (hi[2] - lo[2]) * l);
    }
    tx.putImageData(id, 0, 0);
    return t;
  }
  function effectiveBorders() {
    if (PTYPE.mats) {
      /* leather-family: the border is a laser-etched LINE, not thread.
         CUSTOM SHAPE is cut clean on the artwork's own edge — No Border is
         the ONLY option there (Justin 2026-08-21). */
      var lbCustom = (function () {
        var lab = (st.draft && st.draft.shape) || st.shape;
        var hit = false;
        (CFG.shapes || []).forEach(function (sB) { if (sB.label === lab && sB.geom === 'custom') hit = true; });
        return hit;
      })();
      var lbAll = [
        { label: 'No Border', img: 'https://ninjauploads-production.imgix.net/np-lb-noborder-1786993611.png', note: 'Smooth clean cut edge' },
        { label: 'Etched Border', img: 'https://ninjauploads-production.imgix.net/np-lb-border-1786993636.png', note: 'A border line etched just inside the edge' }
      ];
      return lbCustom ? [lbAll[0]] : lbAll;
    }
    var isCustomB = shapeGeom() === 'custom';
    var listB = (CFG.borders || []).filter(function (b) { return !isCustomB || b.customOnly; });
    if (PTYPE.borders) listB = listB.filter(function (b) { return PTYPE.borders.test(b.label || ''); });
    if (PTYPE.noMerrowGeom && PTYPE.noMerrowGeom.test(shapeGeom() || '')) listB = listB.filter(function (b) { return !/merrow/i.test(b.label || ''); }); /* C502 (Justin 2026-10-20, Full Color: "we need to remove hot cut as an embroidered option" / "heart shape and designs shape if selected we need to hide the merrow option") */
    if (PTYPE.noBorderOpt && (!isCustomB || !listB.length || PTYPE.noBorderCustom)) listB = listB.concat( /* HC1: Full Color keeps No Border on custom shapes too — Hot Cut sits right before it; C160: Woven too */[{ label: 'No Border', note: 'Background runs edge to edge' }]);
    return listB;
  }
  /* C475 (Justin 2026-10-07): "on full color patches if a customer selects hot cut border hide the velcro backing as an
     option". C476 (same day): "if a customer picks custom shape drop velcro as an option for full color". Judged against
     the border + shape being picked (the wizard draft) or the committed ones. C492 (Justin 2026-10-13: "can we also turn off
     velcro for No border"): No Border drops it too — Full Color keeps Velcro only with a Merrow border. */
  function npShapeGeomOf(lbl) { var g = null; (CFG.shapes || []).forEach(function (s) { if (s.label === lbl) g = s.geom; }); return g; }
  /* C490 (Justin 2026-10-12): "remove that option on print and stitch if they choose merrow border" — World Emblem's Print
     Stitch Emblems offer no Velcro with a Merrow border (PATCH-2119529, PATCH-2120359 bounced to another vendor).
     C534 (Justin 2026-10-29): 3D Embroidered + a custom shape = no Velcro — World Emblem's 3D Emblems offer none (PATCH-2125185). */
  function npNoVelcroFor(brd, shp) {
    if (TYPE_FAMILY === 'print-and-stitch-2-0') return !!brd && /merrow/i.test(brd.label || ''); /* C490 */
    if (TYPE_FAMILY === '3demb-2-0') return !!shp && npShapeGeomOf(shp) === 'custom'; /* C534 */
    return TYPE_FAMILY === 'fullcolor-2-0' && ((!!brd && /hot ?cut|no border/i.test(brd.label || '')) || (!!shp && npShapeGeomOf(shp) === 'custom')); /* C492: + No Border */
  }
  function effectiveBackings(brdIn, shpIn) {
    var bk = CFG.backings || [];
    if (PTYPE.backings) bk = bk.filter(function (b) {
      var L = (b.label || '').toLowerCase();
      return PTYPE.backings.some(function (t2) { return L.indexOf(t2) !== -1; });
    });
    var brd475 = arguments.length ? brdIn : ((st.draft && st.draft.border) || st.border);
    var shp476 = arguments.length > 1 ? shpIn : ((st.draft && st.draft.shape) || st.shape);
    if (npNoVelcroFor(brd475, shp476)) bk = bk.filter(function (b) { return !/hook|velcro/i.test(b.label || ''); });
    return bk;
  }
  function npBackingOk(bk, brd, shp) { return !bk || !npNoVelcroFor(brd, shp) || !/hook|velcro/i.test(bk.label || ''); } /* C475/C476 */


  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }

  /* ---- legacy bridges ---- */
  function legacyInput(name) { return document.querySelector('input[name="' + name + '"]'); }
  function setLegacySize(w, h) {
    var wi = legacyInput('width__value'), hi = legacyInput('height__value');
    if (wi) { wi.value = w.toFixed(2); wi.dispatchEvent(new Event('keyup', { bubbles: true })); }
    if (hi) { hi.value = h.toFixed(2); hi.dispatchEvent(new Event('keyup', { bubbles: true })); }
  }
  function setLegacyQty(q) {
    var qi = document.querySelector('.customQtyFile__qty');
    if (qi) { qi.value = q; qi.dispatchEvent(new Event('keyup', { bubbles: true })); qi.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  function setFormVariant(id) {
    var f = document.querySelector('product-form.product-form form [name="id"]');
    if (f) { f.value = id; f.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  /* Properties the ORDER ADMIN does not want. Blocked at the single write
     point so no call site can reintroduce them. Image-wise the order keeps
     only _Upload, _AI Proof and _Original Image. */
  function propBlocked(name) {
    var n = String(name || '');
    /* C145: _Proof Version is no longer blocked — it reaches the order when the approved
       render is v2 or later (a v1 write is turned into a removal in setProp / orderPropsObj) */
    return n === '_Preview Image' || n === '_AI Proof Revisions';
  }
  function proofVersionShown(v) {
    /* "v1" is the default and adds nothing to the order line — only a later version is worth a property */
    return /^v([2-9]|[1-9]\d+)$/i.test(String(v || '').trim());
  }
  function setProp(name, value) {
    /* C98 (2026-09-01) CONTRACT GUARD (order 7834443645247): _Original Image
       is the customer's RAW upload, ALWAYS — never a generated render. A
       SPEC SHEET reached it through the My Proofs reorder path: spec files
       (ai-proof-…--spec-dk…) matched the panel's proof pattern but have no
       sidecar JSON, so the handoff fell back to file=<the proof itself> and
       the builder adopted it as the artwork. No legitimate flow stores an
       ai-proof render as the original (see the image contract comments), so
       refuse the write at the one choke point every np-emb2 writer uses.
       Panel-side fix ships alongside (spec sheets excluded from My Proofs). */
    /* C125: a spec sheet may only enter the form if THIS session made it */
    if ((name === '_AI Proof' || name === '_Upload' || name === '_Preview Image') && typeof dkOfUrl === 'function') {
      try {
        var tSp = dkOfUrl(value);
        if (tSp && sensei && sensei.__sessionDks && !sensei.__sessionDks[tSp]) {
          try { console.warn('[np-emb2] C125: blocked foreign spec sheet (dk' + tSp + ') from ' + name); } catch (eSpW) {}
          return;
        }
      } catch (eSpG) {}
    }
    if (name === '_Proof Version' && !proofVersionShown(value)) value = ''; /* C145: v1 (or blank) = no property on the line */
    if (name === '_Original Image' && /(^|\/)ai-proof-/i.test(String(value || ''))) {
      try { console.warn('[np-emb2] C98: blocked ai-proof render from _Original Image:', String(value).slice(-64)); } catch (eC98) {}
      return;
    }
    if (propBlocked(name)) {
      /* switch off any existing field of that name rather than leaving a stale
         value from an earlier build on the line */
      var fB = document.querySelector('product-form.product-form form');
      if (fB) $$('[name="properties[' + name + ']"]', fB).forEach(function (eB) { eB.disabled = true; });
      return;
    }
    var form = document.querySelector('product-form.product-form form');
    if (!form) return;
    /* The options app injects its OWN properties[...] fields asynchronously,
       so a name can end up with two live inputs: the app's field plus a
       hidden one we created before it arrived. Two live fields = two values
       in the FormData. Retire OURS, never theirs — a radio group
       legitimately shares one name, and disabling its siblings would break
       the customer's selection. */
    var allP = $$('[name="properties[' + name + ']"]', form);
    var oursP = allP.filter(function (n2) { return n2.getAttribute('data-np-e2-prop') === '1'; });
    var theirsP = allP.filter(function (n2) { return n2.getAttribute('data-np-e2-prop') !== '1'; });
    if (theirsP.length && oursP.length) oursP.forEach(function (n2) { n2.disabled = true; });
    var el = theirsP.length ? theirsP[0] : oursP[0];
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'properties[' + name + ']';
      el.setAttribute('data-np-e2-prop', '1');
      form.appendChild(el);
    }
    var val = value == null ? '' : String(value);
    /* An EMPTY property still rides to the order and shows up as a bare label
       with no value (the legacy underscore fields were filling the order page
       with "_Patch Background Color", "_Border Thickness" and friends). A
       property with nothing in it is not a property — switch it off instead. */
    el.value = val;
    el.disabled = !val;
  }
  /* legacy option fields the old flow left in the DOM. They duplicate what the
     2-0 builder writes (or carry nothing at all), so they are switched off
     before the line is added rather than shipped to the order. */
  var LEGACY_PROPS = [
    '_Patch Background Color', '_Border Color (For Merrow Only)', '_Border Color (Merrow only)',
    '_Border Thread Color', '_Border Thickness', '_Select Shape', '_Select Your Backing'
  ];
  function pruneLegacyProps() {
    var form = document.querySelector('product-form.product-form form');
    if (!form) return;
    var dropped = [];
    $$('[name^="properties["]', form).forEach(function (el2) {
      var mN = /^properties\[(.*)\]$/.exec(el2.getAttribute('name') || '');
      if (!mN) return;
      var nm = mN[1];
      if (propKept(nm) && String(el2.value || '').trim()) { el2.disabled = false; return; }
      if (!el2.disabled) dropped.push(nm);
      el2.disabled = true;
    });
    if (dropped.length) console.log('[np-e2] props stripped from the order:', dropped.join(', '));
  }
  /* ORDER-ADMIN PROPERTY ORDER. Shopify lists line-item properties in the
     order they were SUBMITTED: DOM order for a form post, key-insertion order
     for a /cart/change.js properties object. The two helpers below put the
     contract properties first, in the exact sequence ops asked for; anything
     not listed keeps its relative position behind them. */
  var PROP_ORDER = [
    '_Order Mode',
    /* _AI Model retired 2026-09-16 (Justin: no longer needed as a line item property) — not written any more, and off the
       whitelist so a re-ordered line's old value is pruned too; the spec sheet still hides it on old orders */
    '_Upload',
    '_AI Proof',
    '_Proof Version',        /* C145 (Justin 2026-09-04): right under _AI Proof, and ONLY when it is not v1 */
    '_Mockup Catalog',
    '_Original Image',
    '_Lettering Text',
    '_Font Style',           /* tackle twill lettering face — was being PRUNED at add time (2026-08-24) */
    '_Width (in)',
    '_Height (in)',
    '_Shape',
    '_Corners',
    '_Background Color',
    '_Border Color',
    '_Text Color',
    '_Letter Color',
    '_Outline Color',
    '_Design Format',
    '_Line Sizes',
    '_Border Stitch',
    '_Swoosh',
    '_Swoosh Style',
    '_Swoosh Text',
    '_Swoosh Text Color',
    '_Border Style',
    '_Fold Style',           /* C164: woven labels fold style */
    '_Etch Style',
    '_Select Your Backing',
    'Design Notes',
    '_Proof Preference',
    '_Proof Approval',
    '_AI Proof Status',
    '_Revision Notes'
  ];
  /* NEW ORDERS carry ONLY what rebuilds the patch (PROP_ORDER, in that order)
     plus the functional set below. Anything else is stripped at add time.
     READERS are untouched — they keep their legacy-name fallbacks, so
     reordering an OLD order still works; the new line it creates simply comes
     out clean. */
  var PROP_KEEP = PROP_ORDER.concat([
    '_Remove Background',   /* C27: without this the prune drops it on the way to the order */
    '_Crop & Trim',
    '_Background Texture',     /* flex surface — part of the rebuild */
    '_Border Thickness',       /* leather/flex border width — part of the rebuild */
    '_Etch Style',             /* leather inverted-etch flag */
    '_Production Method',      /* PRINT & STITCH split — production reads it */
    '_Printed PVC',            /* C440: high-detail PVC is made as printed rubber PVC — production reads it */
    '_Sewing Channel',         /* C538: rubber PVC moulded sewing groove — production reads it */
    '_Patch Rec',              /* C519: the recommendation a "Keep as <type>" turned down — 'Declined Full Color Patch' */
    '_Preview Flag',           /* C535c: the etch could not preview this design — vendors make it from _Original Image */
    '_Shinobi',                /* C135: chat-placed line marker (Shinobi stamps '_Shinobi: Yes'; absent otherwise) — survive the prune */
    '_reorder',                /* C555: a reorder — "Exact reorder of PATCH #…" / "Similar reorder of PATCH #… (new sizes, keep same vendor)" (custom-uploader.js) */
    '_cartImg',                /* cart/checkout thumbnail */
    '_discount_input',         /* volume pricing — checkout breaks without them */
    '_discount_name',
    /* Design Notes rides along (ordered above); 'AI Edit' deliberately NOT
       kept (2026-08-19): the AI-edited artwork IS the outcome — the prompt
       text is session noise at order level */
    /* custom names (name-patches): the roster IS the order, the font and the
       combined border+text thread colour are its production spec. The thread
       property name carries a TRAILING SPACE to match the live product option
       byte for byte. */
    'List of Names (Separate by Comma)',
    'Font Style',
    'Border & Text Thread Color '
    /* _Art Fill deliberately NOT kept (2026-08-18): nothing reads it back on
       reorder and the proof images already show the final layout — the order
       does not need it. The zoom slider still works in-session. */
  ]);
  function propKept(name) { return PROP_KEEP.indexOf(String(name || '')) !== -1; }
  /* C555 (Justin 2026-11-03): a My Designs purchase ordered as this same patch type carries `_reorder` "Exact reorder of
     PATCH #…" at the purchased size, "Similar reorder of PATCH #… (new sizes, keep same vendor)" at a new one
     (custom-uploader.js npReorderFor). The line is added at the seeded size and sized after, so every write of the line's
     size re-reads it. null = not such a purchase (the props are left alone), '' = this patch type is not a reorder. */
  function reorderFor555(w, h, vid) {
    if (!window.npReorderFor) return null;
    if (vid == null) { try { var fI = document.querySelector('product-form.product-form form [name="id"]'); vid = fI ? fI.value : ''; } catch (eV5) { vid = ''; } }
    return window.npReorderFor(w, h, vid);
  }
  function applyReorder555(props) {
    var rn = reorderFor555(st.w, st.h);
    if (rn) props['_reorder'] = rn;
    else if (rn === '') delete props['_reorder'];
  }
  /* C124 (Justin 2026-09-02): props that must never ride a NO-ARTWORK patch
     (PTYPE.noArt — Custom Names): they were landing there as code defaults,
     not customer choices, and read downstream as an AI-proof flow that never
     happened ("custom names, submitted with revision? how did this come up?"). */
  var NOART_STRIP_C124 = ['_Proof Approval', '_Remove Background', '_Crop & Trim'];
  /* form path: move OUR hidden inputs to the front of the form. A VISIBLE
     field (a radio group / select the options app owns) is left exactly where
     it is - moving it would move the customer-facing UI with it. */
  function orderProps() {
    var form = document.querySelector('product-form.product-form form');
    if (!form) return;
    var mark = document.createComment('np-e2-prop-order');
    form.insertBefore(mark, form.firstChild);
    PROP_ORDER.forEach(function (nmO) {
      $$('[name="properties[' + nmO + ']"]', form).forEach(function (elO) {
        if (elO.tagName !== 'INPUT' || elO.type !== 'hidden') return;
        form.insertBefore(elO, mark);
      });
    });
    if (mark.parentNode) mark.parentNode.removeChild(mark);
  }
  /* /cart/change.js path: rebuild the object with the listed keys inserted
     first, in order, then the remainder in its original order */
  function orderPropsObj(o) {
    if (!o) return o;
    var out = {};
    PROP_ORDER.forEach(function (kO) {
      if (Object.prototype.hasOwnProperty.call(o, kO)) out[kO] = o[kO];
    });
    Object.keys(o).forEach(function (kO) {
      if (!Object.prototype.hasOwnProperty.call(out, kO)) out[kO] = o[kO];
    });
    if (Object.prototype.hasOwnProperty.call(out, '_Proof Version') && !proofVersionShown(out['_Proof Version'])) delete out['_Proof Version']; /* C145 */
    /* C125: every line write flows through here - drop foreign spec sheets */
    return (typeof scrubForeignSheets === 'function') ? scrubForeignSheets(out, 'orderProps') : out;
  }
  function cleanUrl(u) {
    /* legacy reloads could bake "...png&nocache=..." (params without a "?")
       into properties — truncate the junk so the URL actually resolves */
    if (u) {
      /* flatten-era _cartImg URLs baked a grey background — shed it */
      u = String(u).replace(/[?&]fm=jpg&q=88&bg=f2f2f2/g, function (m) { return m.charAt(0) === '?' ? '?' : ''; });
      u = u.replace(/\?&/, '?').replace(/\?$/, '');
    }
    if (u && u.indexOf('?') === -1 && u.indexOf('&') > -1) return u.split('&')[0];
    return u;
  }
  function isUploadLineage(u) {
    /* every REAL customer file carries the upload pipeline's name token
       (image_<ts>_<rand>) or is a generated proof (ai-proof-*). Catalog /
       style / marketing assets (FULL_COLOR_PRINTED_PATCHES.png poisoning
       real orders, 2026-08-21) carry neither and must never be artwork. */
    return /(image|img)_\d{9,}_\d+|ai-proof-/i.test(String(u || ''));
  }
  function artLineageSfx(u) {
    /* proofs embed the ORIGINAL upload's name after "____" — that suffix is
       the session's artwork lineage (the portal matches on it already) */
    var m = /____((?:image|img)?_?\d{9,}_\d+)/.exec(String(u || ''));
    return m ? m[1] : '';
  }
  function sameLineage(candidate, proofUrl) {
    var sfx = artLineageSfx(proofUrl);
    if (!sfx) return true; /* no lineage on the proof — nothing to enforce */
    return String(candidate || '').indexOf(sfx) > -1;
  }
  function artworkCandidates() {
    var out = [];
    var hero = document.getElementById('fileupload_hero');
    var heroSrc = hero ? (hero.getAttribute('src') || '') : '';
    if (heroSrc && heroSrc.indexOf('loader') === -1) out.push(heroSrc);
    ['properties[_Upload]', 'properties[_cartImg]', 'properties[_Original Image]'].forEach(function (n) {
      var el = legacyInput(n);
      if (el && el.value && el.value.indexOf('http') === 0) out.push(el.value);
    });
    /* the ?file= reuse param is a KNOWN-hosted url — reliable fallback when
       the legacy flow re-uploads under a name that isn't live yet */
    var m = window.location.search.split('file=')[1];
    if (m) { try { var dec = decodeURIComponent(m); if (dec.indexOf('http') === 0) out.push(dec.split('&')[0]); } catch (e) {} }
    /* S3-hosted originals load via the imgix front */
    var imgixHost = '';
    out.forEach(function (u) { if (!imgixHost && u.indexOf('imgix') > -1) { try { imgixHost = new URL(u).hostname; } catch (e) {} } });
    if (imgixHost) out.slice().forEach(function (u) {
      if (u.indexOf('imgix') === -1 && (u.indexOf('s3') > -1 || u.indexOf('amazonaws') > -1)) {
        try { var s = new URL(u); out.push('https://' + imgixHost + s.pathname); } catch (e) {}
      }
    });
    out = out.map(cleanUrl);
    /* customer uploads live on the uploads imgix/S3 ONLY — the legacy hero
       can silently fall back to PRODUCT images (cdn.shopify.com), which must
       never become the artwork */
    out = out.filter(function (u) { return u.indexOf('/cdn/shop/') === -1 && u.indexOf('cdn.shopify.com') === -1; });
    out = out.filter(isUploadLineage);
    return out.filter(function (u, i) { return out.indexOf(u) === i; });
  }
  function legacyArtworkUrl() {
    /* classic mode: the artwork lives in the legacy form's own fields */
    var f = document.querySelector('input[name="properties[_Upload]"], input[name="properties[_cartImg]"]');
    if (f && f.value) return cleanUrl(f.value);
    var im = document.querySelector('#uploadArea img, .np-upload-tabs img, file-preview img');
    return (im && im.src) ? cleanUrl(im.src) : '';
  }
  function artworkUrl() {
    /* prefer a source we KNOW loaded (the builder canvas img), else first candidate */
    var img = document.getElementById('np-e2-artimg');
    var canvasSrc = (img && img.naturalWidth > 0 && img.src) ? img.src : '';
    /* C28 (2026-08-26, Justin: "silicone orders are including our images in the
       proof"). This returned the canvas img UNCONDITIONALLY, short-circuiting
       every guard artworkCandidates() applies below it — the cdn.shopify.com
       exclusion AND isUploadLineage. So any marketing / sample / style asset
       that reached #np-e2-artimg became the artwork, got rendered into the AI
       proof, and shipped on the order. This is the same class as the 2026-08-21
       catalog-asset incident; the guards existed, this path simply bypassed
       them. Trust the canvas only when it carries real upload lineage — or is a
       data:/blob: URL, which is a fresh local upload not yet hosted. */
    if (canvasSrc && (/^data:|^blob:/.test(canvasSrc) || isUploadLineage(canvasSrc))) return canvasSrc;
    return artworkCandidates()[0] || '';
  }
  /* ═══ VECTOR DISPLAY PROXY (Justin 2026-08-24) ═══
     imgix re-rasterizes an .ai/.eps/.pdf server-side for EVERY unique param
     combination — and the builder requests many (trim/bg-remove toggles,
     several widths) — so every option change took seconds on vector uploads.
     Rasterize ONCE to a hosted PNG and route all DISPLAY paths through it
     (this hook inside applyToggleParams covers loadArt, the compose canvas
     and the analyzer). Order properties keep the TRUE vector: they read
     artworkUrl()/cleanUrl directly and never pass through here. */
  function isVectorArt(u) { return /\.(ai|eps|pdf)$/i.test(String(u || '').split('?')[0]); }
  var vecProxy = { src: null, url: null, busy: false };
  function ensureVectorProxy() {
    var a = cleanUrl(artworkUrl());
    if (!a || !isVectorArt(a)) return;
    if (vecProxy.src === a && (vecProxy.url || vecProxy.busy)) return;
    vecProxy.src = a; vecProxy.url = null; vecProxy.busy = true;
    var vU = toImgixHost(a);
    fetch(vU + (vU.indexOf('?') > -1 ? '&' : '?') + 'fm=png&w=2000')
      .then(function (r) { if (!r.ok) throw new Error('raster ' + r.status); return r.blob(); })
      .then(function (blob) {
        var name = 'vec-raster____image_' + Date.now() + '_' + Math.floor(Math.random() * 1000) + '.png';
        if (typeof window.getPresignedUploadUrl !== 'function') throw new Error('no presign');
        return window.getPresignedUploadUrl(name, 'image/png').then(function (p) {
          if (!p || !p.url) throw new Error('presign');
          return npPut(p.url, blob).then(function (r2) {
            if (!r2.ok) throw new Error('put');
            vecProxy.url = toImgixHost(p.sourceUrl || '');
            vecProxy.busy = false;
            try { loadArt(); } catch (eVL) {}
            try { st.__artAnalyzed = false; analyzeArtwork(); } catch (eVA) {}
          });
        });
      })
      .catch(function (eVP) { vecProxy.busy = false; console.warn('[np-e2] vector proxy failed — staying on live rasterization', eVP); });
  }
  function applyToggleParams(url) {
    /* the canvas render mirrors the toggles directly on the imgix URL:
       Crop+Trim -> trim=colorUnlessAlpha, Remove background -> bg-remove=true */
    try {
      if (vecProxy.url && isVectorArt(url)) url = vecProxy.url;
      if ((url || '').indexOf('imgix') === -1) return url;
      var u = new URL(url);
      if (st.crop) u.searchParams.set('trim', 'colorUnlessAlpha'); else u.searchParams.delete('trim');
      /* C107 (2026-09-01): on leather/faux, a verified-OPAQUE file drops trim
         EVERYWHERE (visible preview included) - imgix color-trim amputates
         solid designs whose fill/background reaches the canvas edge. */
      try {
        if ((PTYPE.name === 'Leather' || PTYPE.name === 'Faux Leather')) {
          var aK107 = (url || '').split('?')[0];
          if (alphaTruth[aK107] === false || alphaTruth[cleanUrl(url) || ''] === false) u.searchParams.delete('trim');
          else if (alphaTruth[aK107] === undefined) { try { npPixelHasAlpha(aK107, function () {}); } catch (e107b) {} }
        }
      } catch (e107) {}
      if (st.removeBg) u.searchParams.set('bg-remove', 'true'); else u.searchParams.delete('bg-remove');
      if (/gram-edit/i.test(url)) u.searchParams.set('cs', 'strip'); /* AI-edit outputs: strip the ICC color profile */
      /* VECTORS: imgix rasterizes an SVG at its tiny intrinsic size unless a
         width is forced — small viewBoxes were arriving as thumbnail-sized
         rasters and every preview of them looked soft. Rasterize big. */
      if (/\.svg(\?|$)/i.test(u.pathname)) { u.searchParams.set('w', '1600'); u.searchParams.set('fm', 'png'); }
      return u.toString();
    } catch (e) { return url; }
  }
  var artRetryTimer = null;
  function artLoader(on) {
    var l = document.getElementById('np-e2-artload');
    if (l) l.classList.toggle('is-on', !!on);
    /* never show the broken-image glyph while the artwork loads */
    var im = document.getElementById('np-e2-artimg');
    if (im) im.style.visibility = on ? 'hidden' : '';
  }
  function loadArt() {
    /* NO-ART types (custom names) compose their preview from text — there is
       no artwork to fetch, so every entry here used to hit the retry loop and
       leave the loading spinner pinned over the preview forever */
    if (PTYPE.noArt) {
      if (artRetryTimer) { clearTimeout(artRetryTimer); artRetryTimer = null; }
      artLoader(false);
      return;
    }
    /* walk candidates until one actually loads — the legacy reuse path can
       set a 404ing hero src on some lineages */
    var img = document.getElementById('np-e2-artimg');
    if (!img.__npLoadWired) {
      img.__npLoadWired = true;
      img.addEventListener('load', function () { artLoader(false); });
    }
    artLoader(true);
    try { ensureVectorProxy(); } catch (eEVP) {}
    var cands = artworkCandidates().map(applyToggleParams);
    var i = 0;
    function retrySoon() {
      /* the legacy flow writes properties[_Upload] a few seconds after the
         upload signal — keep retrying until something renders */
      if (artRetryTimer) return;
      artRetryTimer = setTimeout(function () { artRetryTimer = null; loadArt(); }, 1500);
    }
    if (!cands.length) { retrySoon(); return; }
    function tryNext() {
      if (i >= cands.length) { retrySoon(); return; }
      var probe = new Image();
      var url = cands[i++];
      var rbTries = 0;
      probe.onload = function () { if (img.src === url) artLoader(false); img.src = url; };
      probe.onerror = function () {
        /* the bg-remove rendition 5xxes while imgix GENERATES it on the first
           request — falling through to the next candidate silently showed the
           UN-removed image with the toggle ON until a later re-toggle found
           the finished rendition (911, 2026-08-24). It IS coming: retry the
           same URL under the loader instead of abandoning it. */
        if (/[?&]bg-remove=true/.test(url) && rbTries++ < 10) { setTimeout(function () { probe.src = url; }, 2000); return; }
        tryNext();
      };
      probe.src = url;
    }
    tryNext();
  }

  /* ---- pricing (mirrors legacy: variant by mean size, tier % off) ---- */
  function displayShapeLabel(l) {
    /* DISPLAY-ONLY rename (Justin 2026-08-24): the stored value, the _Shape
       property, sidecars, reorder params and the renderer specs all keep
       "Custom Shape" — only what the customer READS changes. */
    /* C66 (2026-08-31, Justin): reads "Design's Shape" now - still display-only. */
    return /^(custom shape|shape of my design)$/i.test(String(l || '').trim()) ? "Design's Shape" : l;
  }
  function isFreeFormShape(lbl) {
    /* Free Form shares the 'custom' geometry but has NO patch base at all:
       each element is cut on its own, so there is no contour to fill or ring */
    return /free\s*form/i.test(lbl || st.shape || '');
  }
  function npSelCropped() {
    /* C43: is the SELECTED shape one of the Cropped (artwork-aspect) tiles? */
    var hit = false;
    (CFG.shapes || []).forEach(function (s) { if (s.label === st.shape && s.crop) hit = true; });
    return hit;
  }
  function shapeGeom() {
    var g = null;
    (CFG.shapes || []).forEach(function (s) { if (s.label === st.shape) g = s.geom; });
    /* fixed-shape types ship NO shape blocks, so the lookup above finds
       nothing — the profile itself is the answer */
    if (!g && PTYPE.fixedShape) g = PTYPE.fixedShape.geom;
    return g;
  }
  function heightLocked() {
    /* symmetric shapes lock height to width */
    var g = shapeGeom();
    return ['circle', 'square', 'star', 'rhombus', 'hexagon', 'heart', 'shield'].indexOf(g) > -1;
  }
  function sizeMean() { return (st.w + st.h) / 2; }
  function nearestVariant() {
    /* the variant-option steps together ARE the variant: the price rides on it,
       so patch size can never be what chooses it here */
    if (PTYPE.optVariant) return optVariantMatch();
    /* fixed-size types have exactly ONE variant and its title is not a plain
       number ('3.25" x 1.25"'), so the size-matching walk below cannot read
       it — the product's own variant IS the answer */
    if (PTYPE.fixedSize) {
      var fv = (CFG.variants || [])[0];
      return fv ? { id: fv.id, num: parseFloat(String(fv.opt1).replace(/[^0-9.]/g, '')) || 0, price: fv.price } : null;
    }
    var size = sizeMean();
    var vs = (CFG.variants || []).map(function (v) {
      return { id: v.id, num: parseFloat(String(v.opt1).replace(/[^0-9.]/g, '')), price: v.price };
    }).filter(function (v) { return !isNaN(v.num); }).sort(function (a, b) { return a.num - b.num; });
    if (!vs.length) return null;
    for (var i = 0; i < vs.length; i++) { if (size <= vs[i].num) return vs[i]; }
    return vs[vs.length - 1];
  }
  function tiers() {
    /* C67/C67b (2026-08-31, Justin: "on ninja flex and silicone the discounts
       on the pricing table for classic and ai mode do not match ... AI mode
       needs to read from the same place"). CFG.tiers comes from the builder
       SECTION's blocks - ONE theme-level list shared by every patch type.
       The truth is the legacy section's PER-PRODUCT tier rows, rendered on
       this same PDP for every patch type (measured: silicone 25->51%,
       flex 25->15% vs the global copy's 25->25%). Parse those rows - from the
       DOM when the popup is mounted, else from the inline script template -
       and only fall back to the section blocks when the legacy rows are
       genuinely absent. */
    try {
      var rows67 = [];
      var seen67 = {};
      var push67 = function (mn, off) {
        mn = parseInt(mn, 10); off = parseInt(off || '0', 10) || 0;
        if (!isFinite(mn) || mn < 1 || seen67[mn]) return;
        seen67[mn] = 1; rows67.push({ min: mn, off: off });
      };
      var els67 = document.querySelectorAll('.customTabelPlace__item[min]');
      if (els67.length) {
        for (var i67 = 0; i67 < els67.length; i67++) push67(els67[i67].getAttribute('min'), els67[i67].getAttribute('off'));
      } else {
        var scs67 = document.querySelectorAll('script:not([src])');
        for (var j67 = 0; j67 < scs67.length; j67++) {
          var tx67 = scs67[j67].textContent || '';
          if (tx67.indexOf('customTabelPlace__item') === -1) continue;
          var re67 = /customTabelPlace__item"[^>]*?min="(\d+)"[^>]*?off="(\d*)"/g, m67;
          while ((m67 = re67.exec(tx67)) !== null) push67(m67[1], m67[2]);
          if (rows67.length) break;
        }
      }
      if (rows67.length >= 2) return rows67.sort(function (a, b) { return a.min - b.min; });
    } catch (eT67) {}
    return (CFG.tiers || []).slice().sort(function (a, b) { return a.min - b.min; });
  }
  function tierIndexFor(q) {
    var t = tiers(), idx = 0;
    for (var i = 0; i < t.length; i++) { if (q >= t[i].min) idx = i; }
    return idx;
  }
  function pricing() {
    var v = nearestVariant();
    var base = v ? v.price : 0;
    var t = tiers();
    var idx = tierIndexFor(st.qty);
    var off = t.length ? (t[idx].off || 0) : 0;
    var unit = base * (1 - off / 100);
    return { base: base, unit: unit, off: off, idx: idx, variant: v, tiers: t };
  }

  /* ---- render: step 2 + volume panel ---- */
  function renderPricing() {
    if (heightLocked()) st.h = st.w; /* circle/square: height mirrors width */
    try { sizeFirstPricingCheck(); } catch (eSP) {} /* C229: the size window applies here too */
    var p = pricing();
    var wIn = document.getElementById('np-e2-winput'), hIn = document.getElementById('np-e2-hinput');
    if (wIn && document.activeElement !== wIn) wIn.value = st.w.toFixed(2);
    if (hIn && document.activeElement !== hIn) hIn.value = st.h.toFixed(2);
    var hs = document.querySelector('[data-e2-step="h"]');
    if (hs) hs.classList.toggle('is-locked', heightLocked());
    if (hIn) hIn.disabled = heightLocked();
    var qin = document.getElementById('np-e2-qtyinput');
    if (qin && document.activeElement !== qin) qin.value = st.qty;
    /* Patch Size = the variant actually charged (mean rounded UP to the
       nearest size variant), not the raw average */
    var pv = nearestVariant();
    /* a variant-option type states its size in the option label itself
       ('11" x 4" (Most Popular)') — a mean-of-W-and-H number means nothing */
    $('#np-e2-sizeval').textContent = (pv && pv.sizeLabel)
      ? pv.sizeLabel
      : ((pv ? String(parseFloat(pv.num.toFixed(2))) : (Math.round(sizeMean() * 10) / 10).toFixed(1)) + '"');
    /* C119: phones read "N piece min" — CSS picks the span, so a resize
       never needs a rewrite (QTY_MIN is a number, innerHTML-safe) */
    $('#np-e2-qtycap').innerHTML = QTY_MIN + ' piece <span class="np-e2-min-full">minimum</span><span class="np-e2-min-abbr">min</span>';

    var each = $('#np-e2-each'), baseEach = $('#np-e2-base-each');
    var total = $('#np-e2-total'), baseTotal = $('#np-e2-base-total');
    var badge = $('#np-e2-offbadge');
    each.textContent = money(p.unit);
    total.textContent = money(p.unit * st.qty);
    if (p.off > 0) {
      baseEach.textContent = money(p.base); baseEach.style.display = '';
      baseTotal.textContent = money(p.base * st.qty); baseTotal.style.display = '';
      badge.textContent = p.off + '% off'; badge.hidden = false;
    } else {
      baseEach.style.display = 'none'; baseTotal.style.display = 'none';
      badge.textContent = ''; badge.hidden = true;
    }
    $('#np-e2-co-total').textContent = money(p.unit * st.qty) + ' for ' + st.qty + ' pieces';
    /* sizing-phase extras: dimension-arrow chips + modal checkout row */
    var wchip = $('#np-e2-sz-wchip'); if (wchip) wchip.textContent = st.w.toFixed(2) + '"';
    var hchip = $('#np-e2-sz-hchip'); if (hchip) hchip.textContent = st.h.toFixed(2) + '"';
    var szTotal = $('#np-e2-sz-cototal'); if (szTotal) szTotal.textContent = money(p.unit * st.qty);
    var szSub = $('#np-e2-sz-cosub');
    if (szSub) szSub.textContent = st.qty + ' pcs · ' + money(p.unit) + ' ea' + (p.off > 0 ? ' · ' + p.off + '% off' : '');
    /* C44 (2026-08-31, Justin: "on live theme and staging 8-25 theme I want to
       add this to the bottom of sizing and pricing and include the Free Proof &
       Shipping Included") — green trust line under the footer total. */
    if (szSub && !document.getElementById('np-e2-sz-cofree')) {
      var szFree = document.createElement('i');
      szFree.id = 'np-e2-sz-cofree';
      szFree.textContent = 'Free Proof & Shipping Included';
      szSub.parentElement.appendChild(szFree);
    }
    var szCo = $('#np-e2-sz-checkout');
    if (szCo) szCo.textContent = 'Continue'; /* Add to Cart lives on the page's approved summary */
    positionDims();
    renderVolume(p);
  }

  function isAlphaSrc(url) {
    /* imgix-hosted files (customer uploads, edit outputs, FC proofs) carry
       real transparency AND CORS headers; local data-URL composes (digital
       proofs) are alpha PNGs too. Sensei mockups (S3) have neither — but a
       flattened display copy (fm=jpg) is opaque even on imgix. */
    if (/fm=jpg/.test(url || '')) return false;
    if (/ai-proof-[a-z0-9-]+--(v\d+|ml)-/i.test(url || '')) return false; /* frozen AI mockup copies: opaque studio shots on imgix */
    return /imgix/.test(url || '') || /^data:image\/png/i.test(url || '');
  }
  /* ---- PMS (Pantone Solid Coated) nearest-match — colors display as PMS
     codes, the embroidery production standard, never raw hex ---- */
  var PMS = [ /* C180: offline fallback only — hexes corrected from the Solid Coated palette (98 of 100 were wrong) */
    ['#FFFFFF','White'],['#0E1920','Black 6 C'],['#2D2925','Black C'],['#757779','Cool Gray 9 C'],['#A8A9A9','Cool Gray 6 C'],['#D2D2CE','Cool Gray 2 C'],
    ['#DBDAD6','Cool Gray 1 C'],['#D3162C','PMS 186 C'],['#F8353D','PMS Red 032 C'],['#AF1C2C','PMS 187 C'],['#7C262F','PMS 188 C'],['#E93F2E','PMS 179 C'],
    ['#FF4737','PMS Warm Red C'],['#FF8400','PMS 151 C'],['#FF5300','PMS Orange 021 C'],['#F57724','PMS 158 C'],['#DF5F12','PMS 1595 C'],['#90481F','PMS 1615 C'],
    ['#FFDC00','PMS Yellow C'],['#FFC62C','PMS 123 C'],['#FDA700','PMS 130 C'],['#FFB81F','PMS 1235 C'],['#F5AA00','PMS 124 C'],['#FFD500','PMS Yellow 012 C'],
    ['#81BC27','PMS 368 C'],['#A0D506','PMS 375 C'],['#00943C','PMS 355 C'],['#009947','PMS 347 C'],['#008340','PMS 348 C'],['#0B6737','PMS 349 C'],
    ['#134633','PMS 3435 C'],['#4CAD2E','PMS 361 C'],['#76C04E','PMS 360 C'],['#BFDD7B','PMS 366 C'],['#00AD43','PMS 354 C'],['#00945F','PMS 340 C'],
    ['#007268','PMS 328 C'],['#00837B','PMS 3282 C'],['#00AFA9','PMS 326 C'],['#00C0D6','PMS 3115 C'],['#5DC5E8','PMS 297 C'],['#00B7E5','PMS 298 C'],
    ['#00A3DF','PMS 299 C'],['#0077C7','PMS 3005 C'],['#0041A5','PMS 293 C'],['#00379F','PMS 286 C'],['#00215E','PMS 2757 C'],['#004CBA','PMS 2728 C'],
    ['#001B9E','PMS Blue 072 C'],['#001F41','PMS 282 C'],['#003157','PMS 540 C'],['#49758A','PMS 5405 C'],['#91CCEA','PMS 291 C'],['#B6DAEB','PMS 290 C'],
    ['#523081','PMS 268 C'],['#54198B','PMS 2597 C'],['#7059C2','PMS 2665 C'],['#9E62B4','PMS 2583 C'],['#B886C9','PMS 2573 C'],['#C8A3DB','PMS 529 C'],
    ['#D80056','PMS Rubine Red C'],['#EA2674','PMS 213 C'],['#E96EAE','PMS 218 C'],['#EE73BA','PMS 224 C'],['#F9B7CC','PMS 1895 C'],['#FCB7C3','PMS 707 C'],
    ['#682F24','PMS 483 C'],['#7D4412','PMS 731 C'],['#A4662D','PMS 730 C'],['#BB8250','PMS 729 C'],['#D3A176','PMS 728 C'],['#E1C9A2','PMS 468 C'],
    ['#F6E4B2','PMS 7499 C'],['#D7D1C3','PMS 7527 C'],['#B8A998','PMS 7529 C'],['#7C6654','PMS 7531 C'],['#8C2531','PMS 202 C'],['#712F3D','PMS 505 C'],
    ['#4D306C','PMS 269 C'],['#1B252B','PMS 433 C'],['#3F5564','PMS 7545 C'],['#5A6870','PMS 431 C'],['#9EA1A1','PMS 422 C'],['#CFD2D2','PMS 427 C'],
    ['#C3C7C8','PMS 428 C'],['#C14900','PMS 1525 C'],['#D47B23','PMS 7565 C'],['#DDC79D','PMS 7501 C'],['#00574F','PMS 3292 C'],
    ['#48B4E2','PMS 2915 C'],['#002F73','PMS 288 C'],['#FFE94B','PMS 101 C'],['#A3E3B9','PMS 351 C'],['#CBE56C','PMS 374 C'],['#FF5B58','PMS 178 C'],
    ['#C1B5E0','PMS 2635 C'],['#494E53','PMS 7540 C'],['#C9C9C8','PMS Cool Gray 3 C'],['#FF8E2B','PMS 715 C']
  ];
  /* ---- C180 (2026-09-11): colour naming = nearest PANTONE+ Solid Coated swatch in CIELAB.
     The table is the shared snippet np-pms-coated.liquid rendered into #np-e2-config.pms (1,341 colours); the short list
     below is only the offline fallback (its hexes corrected from the same palette — the old hand-typed values put
     'PMS 7565 C' at a dull brown while the real 7565 C is orange, which is how a tan proof became an orange patch). */
  function hexToLab(hex) {
    var h = String(hex || '').replace('#', ''); if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var c = [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)];
    if (c.some(function (v) { return isNaN(v); })) return null;
    var lin = c.map(function (v) { v /= 255; return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
    var X = (lin[0] * 0.4124 + lin[1] * 0.3576 + lin[2] * 0.1805) / 0.95047, Y = lin[0] * 0.2126 + lin[1] * 0.7152 + lin[2] * 0.0722, Z = (lin[0] * 0.0193 + lin[1] * 0.1192 + lin[2] * 0.9505) / 1.08883;
    var f = function (t) { return t > 0.008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116; };
    return [116 * f(Y) - 16, 500 * (f(X) - f(Y)), 200 * (f(Y) - f(Z))];
  }
  var pmsLabCache = null;
  function pmsTable() { return (CFG.pms && CFG.pms.length >= 500) ? CFG.pms : PMS; }
  function pmsName(hex) {
    var lab = hexToLab(hex); if (!lab) return hex;
    var tbl = pmsTable();
    if (!pmsLabCache || pmsLabCache.src !== tbl) { pmsLabCache = { src: tbl, lab: tbl.map(function (p) { return hexToLab(p[0]); }) }; }
    var chroma = Math.sqrt(lab[1] * lab[1] + lab[2] * lab[2]);
    var inNeutral = chroma < 8; /* a colour with real chroma is never named after a grey, and a grey never after a tint */
    var isWhite = inNeutral && lab[0] > 93; /* White competes for every light NEUTRAL (off-whites, creams under chroma 8) — the chroma bucket alone keeps tints away from it */
    var best = null, bd = Infinity;
    for (var i = 0; i < tbl.length; i++) {
      var pl = pmsLabCache.lab[i]; if (!pl) continue;
      var pc = Math.sqrt(pl[1] * pl[1] + pl[2] * pl[2]);
      if ((pc < 8) !== inNeutral) continue;
      if (tbl[i][1] === 'White' && !isWhite) continue;
      var d = (lab[0] - pl[0]) * (lab[0] - pl[0]) + (lab[1] - pl[1]) * (lab[1] - pl[1]) + (lab[2] - pl[2]) * (lab[2] - pl[2]);
      if (d < bd) { bd = d; best = tbl[i][1]; }
    }
    return best || hex;
  }
  /* C471: the nearest STOCK colour in a swatch list (CIELAB ΔE76, the pmsName distance) — for a type whose background
     can only be a stock colour (PTYPE.noCustomBg), an artwork colour is offered as the felt that will really be used */
  function stockNearest471(hex, list) {
    var lab = hexToLab(hex), best = null, bd = Infinity;
    if (!lab) return null;
    (list || []).forEach(function (c) {
      var cl = c && c.hex ? hexToLab(c.hex) : null; if (!cl) return;
      var d = (lab[0] - cl[0]) * (lab[0] - cl[0]) + (lab[1] - cl[1]) * (lab[1] - cl[1]) + (lab[2] - cl[2]) * (lab[2] - cl[2]);
      if (d < bd) { bd = d; best = c; }
    });
    return best;
  }
  /* the order line carries the PMS name AND the exact hex for any colour we named ourselves (custom pick / artwork
     match), so production can verify the number against the approved proof; stock swatches keep their plain names */
  function propColor(c) {
    if (!c || !c.label) return '';
    var isPms = (/^PMS\s/.test(c.label) || ['Black 6 C', 'Black C', 'Cool Gray 9 C', 'Cool Gray 6 C', 'Cool Gray 2 C', 'Cool Gray 1 C'].indexOf(c.label) !== -1) && !!c.hex && /^#[0-9a-fA-F]{6}$/.test(c.hex);
    return isPms ? (c.label + ' (' + c.hex.toUpperCase() + ')') : c.label;
  }
  var mockupHosted = {};
  function freezeProofCopy(url, tag, cb) {
    /* every approved AI proof becomes a UNIQUE immutable file — the render
       bucket reuses ONE key per style, so a later regen would overwrite the
       file an order already points at */
    try {
      fetch(url, { mode: 'cors' }).then(function (r) { return r.blob(); }).then(function (blob) {
        /* dk token = hash(artwork|size): same art + same size + same patch
           type ⇒ same key, so listings can collapse duplicates */
        var dkSrc = (cleanUrl(artworkUrl()) || '') + '|' + (st.w || 0) + 'x' + (st.h || 0);
        var dkH = 5381;
        for (var iH = 0; iH < dkSrc.length; iH++) dkH = ((dkH << 5) + dkH + dkSrc.charCodeAt(iH)) >>> 0;
        var name = 'ai-proof-' + tag + '-dk' + dkH.toString(36) + '-' + Date.now() + '-' + Math.floor(Math.random() * 10000) + '.png';
        if (typeof window.getPresignedUploadUrl !== 'function') { cb(null); return; }
        window.getPresignedUploadUrl(name, 'image/png').then(function (p) {
          if (!p || !p.url) { cb(null); return; }
          npPut(p.url, blob).then(function (r2) {
            var okF = r2 && r2.ok;
            cb(okF ? toImgixHost(p.sourceUrl || '') : null);
            if (!okF) return;
            /* sidecar JSON: the proof's full line-item data, so My Proofs
               can reorder it with every option intact */
            try {
              var sc = {
                v: 1, type: TYPE_KEY || '',
                shape: st.shape || '', corners: st.corners || '', fold: st.fold ? st.fold.label : '', /* C164b */
                bgl: st.bg ? st.bg.label : '', thl: st.thread ? st.thread.label : '',
                txl: st.text ? st.text.label : '',
                bgh: (st.bg && st.bg.hex) || '', thh: (st.thread && st.thread.hex) || '', txh: (st.text && st.text.hex) || '', /* C180: hexes ride along so a re-order rebuilds PMS colours exactly */
                bsl: st.border ? st.border.label : '', bkl: st.backing ? st.backing.label : '',
                lbThick: st.lbThick || null,
                sewChannel: npSewOn() ? 1 : 0, /* C538 */
                etchInvert: st.etchInvert ? 1 : 0,
                w: st.w, h: st.h, qty: st.qty,
                art: cleanUrl(artworkUrl()) || '',
                notes: (function () { try { return formProp('Design Notes') || ''; } catch (eN) { return ''; } })(),
                pp: (st.proofMode === 'digital' || st.proofMode === 'stitch') ? 'digital' : '',
                tex: st.texture ? st.texture.label : ''
              };
              window.getPresignedUploadUrl(name + '.json', 'application/json').then(function (p2) {
                if (!p2 || !p2.url) return;
                npPut(p2.url, new Blob([JSON.stringify(sc)], { type: 'application/json' }), { 'Content-Type': 'application/json' });
              }).catch(function () {});
            } catch (eSc) {}
            /* register in the customer's uploads DB — fetchDataNew (the My
               Proofs listing) is DB-backed, not a bucket scan */
            try {
              if (CFG.customerId) {
                fetch('https://hpz51rjda5.execute-api.us-east-1.amazonaws.com/production/uploads/saveData', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify([{
                    variant_title: 'custom',
                    file: p.sourceUrl || '',
                    customer_id: String(CFG.customerId),
                    file_name: name,
                    file_crc: name,
                    product_id: 'my-proofs',
                    gangsheet: false
                  }])
                }).then(function (rRg) { console.log('[np-e2] proof registered', name, rRg && rRg.status); }).catch(function (eRg2) { console.warn('[np-e2] proof register failed', eRg2); });
              }
            } catch (eRg) {}
          }).catch(function () { cb(null); });
        }).catch(function () { cb(null); });
      }).catch(function () { cb(null); });
    } catch (e) { cb(null); }
  }
  function toImgixHost(u) {
    return (u || '').replace(/https:\/\/[^/]*ninjauploads[^/]*\.s3\.amazonaws\.com/i, 'https://ninjauploads-production.imgix.net');
  }
  function lightRing() {
    /* light (white/cream) borders are color-identical to the white studio
       backdrop — the color flood eats them (verified: white merrow, 8-16) */
    if (!st.thread || st.thread.none) return false;
    if (st.border && /no border/i.test(st.border.label || '')) return false;
    var hx = st.thread.hex;
    if (!hx || !/^#[0-9a-fA-F]{6}$/.test(hx)) return false;
    var r = parseInt(hx.substr(1, 2), 16), g2 = parseInt(hx.substr(3, 2), 16), b = parseInt(hx.substr(5, 2), 16);
    return 0.299 * r + 0.587 * g2 + 0.114 * b > 210;
  }
  var renderAlphaProbe = {};
  function probeRenderAlpha(url, cb) {
    /* true when the render already carries meaningful transparency */
    if (renderAlphaProbe[url] !== undefined) { cb(renderAlphaProbe[url]); return; }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var W = 160, H = Math.max(1, Math.round(im.naturalHeight * (W / im.naturalWidth)));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(im, 0, 0, W, H);
        var d = x.getImageData(0, 0, W, H).data, clear = 0;
        for (var i = 3; i < d.length; i += 4) if (d[i] < 8) clear++;
        var frac = clear / (W * H);
        renderAlphaProbe[url] = frac > 0.10;
        cb(renderAlphaProbe[url]);
      } catch (e) { renderAlphaProbe[url] = false; cb(false); }
    };
    im.onerror = function () { renderAlphaProbe[url] = false; cb(false); };
    im.src = url;
  }
  function hostRenderAsIs(url, cb) {
    /* already transparent: re-host it unchanged so the cart/proof pipeline
       still gets its own immutable imgix copy */
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var c = document.createElement('canvas'); c.width = im.naturalWidth; c.height = im.naturalHeight;
        c.getContext('2d').drawImage(im, 0, 0);
        cb(c);
      } catch (e) { cb(null); }
    };
    im.onerror = function () { cb(null); };
    im.src = url;
  }
  function lightBorderPicked() {
    /* white/cream borders sit within the flood tolerance of the studio
       backdrop and get eaten out of the alpha copy (2026-08-24) */
    var tl = (st.thread && st.thread.label) || '';
    var th = (st.thread && st.thread.hex) || '';
    if (/white|cream|ivory|natural|silver|light gr[ae]y/i.test(tl)) return true;
    if (/^#?[0-9a-f]{6}$/i.test(th)) {
      var hh = th.replace('#', '');
      return (0.299 * parseInt(hh.slice(0, 2), 16) + 0.587 * parseInt(hh.slice(2, 4), 16) + 0.114 * parseInt(hh.slice(4, 6), 16)) > 218;
    }
    return false;
  }
  function shapeMaskCutCanvas(url, geom, cb) {
    /* white-on-white cut: the studio backdrop is FLAT; a real patch surface
       (even white merrow) is TEXTURED. Flood from the borders eating only
       flat backdrop-colored pixels — texture blocks the flood at the true
       patch edge, whatever the border color. */
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var MAX = 1200;
        var sc = Math.min(1, MAX / Math.max(img.naturalWidth, img.naturalHeight));
        var W = Math.max(1, Math.round(img.naturalWidth * sc)), H = Math.max(1, Math.round(img.naturalHeight * sc));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, W, H);
        var id = x.getImageData(0, 0, W, H), d = id.data;
        var N = W * H;
        var rs = 0, gs = 0, bs = 0, n = 0;
        function acc(px) { var o = px * 4; rs += d[o]; gs += d[o + 1]; bs += d[o + 2]; n++; }
        for (var i = 0; i < W; i++) { acc(i); acc((H - 1) * W + i); }
        for (var j = 1; j < H - 1; j++) { acc(j * W); acc(j * W + W - 1); }
        var br = rs / n, bgc = gs / n, bb = bs / n;
        var bLumS = 0.299 * br + 0.587 * bgc + 0.114 * bb;
        var guardLight = lightBorderPicked();
        var lum = new Float32Array(N);
        for (i = 0; i < N; i++) lum[i] = 0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2];
        var grad = new Float32Array(N);
        for (var y2 = 1; y2 < H - 1; y2++) for (var x2 = 1; x2 < W - 1; x2++) {
          var p2 = y2 * W + x2, l0 = lum[p2];
          var g1 = Math.abs(l0 - lum[p2 - 1]), g2 = Math.abs(l0 - lum[p2 + 1]);
          var g3 = Math.abs(l0 - lum[p2 - W]), g4 = Math.abs(l0 - lum[p2 + W]);
          grad[p2] = Math.max(g1, g2, g3, g4);
        }
        var TOL2 = 52 * 52, G = 5.5;
        function isBg(px) {
          var o = px * 4;
          if (d[o + 3] < 12) return true;
          if (grad[px] >= G) return false; /* texture = patch */
          if (guardLight) {
            /* the light border is BRIGHTER than the backdrop; shadows are
               darker — never eat brighter-than-backdrop pixels */
            var lmG = 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2];
            if (lmG > bLumS + 5) return false;
          }
          var dr = d[o] - br, dg = d[o + 1] - bgc, db = d[o + 2] - bb;
          return dr * dr + dg * dg + db * db < TOL2;
        }
        var mark = new Uint8Array(N);
        var q = new Int32Array(N), qh = 0, qt = 0;
        function push(px) { if (!mark[px] && isBg(px)) { mark[px] = 1; q[qt++] = px; } }
        for (i = 0; i < W; i++) { push(i); push((H - 1) * W + i); }
        for (j = 1; j < H - 1; j++) { push(j * W); push(j * W + W - 1); }
        while (qh < qt) {
          var p = q[qh++], px2 = p % W, py = (p / W) | 0;
          if (px2 > 0) push(p - 1);
          if (px2 < W - 1) push(p + 1);
          if (py > 0) push(p - W);
          if (py < H - 1) push(p + W);
        }
        if (qt < N * 0.05 || qt > N * 0.98) { cb(null); return; }
        for (p = 0; p < N; p++) if (mark[p]) d[p * 4 + 3] = 0;
        x.putImageData(id, 0, 0);
        var minX = W, minY = H, maxX = -1, maxY = -1;
        for (var yy = 0; yy < H; yy++) for (var xx = 0; xx < W; xx++) {
          if (d[(yy * W + xx) * 4 + 3] > 12) {
            if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
            if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
          }
        }
        if (maxX < 0) { cb(null); return; }
        var bw = maxX - minX + 1, bh = maxY - minY + 1;
        var pad = Math.round(Math.max(bw, bh) * 0.05);
        var out = document.createElement('canvas'); out.width = bw + pad * 2; out.height = bh + pad * 2;
        out.getContext('2d').drawImage(c, minX, minY, bw, bh, pad, pad, bw, bh);
        cb(out);
      } catch (e) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    img.src = url;
  }
  function outerCutCanvas(url, cb) {
    /* cut the studio backdrop off the mockup LOCALLY: flood fill from the
       image border, so only pixels CONNECTED to the outside are removed —
       the patch base (even pure white) can never be eaten. The AI remover
       this replaces silhouette-cut white patches. */
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var MAX = 1200;
        var sc = Math.min(1, MAX / Math.max(img.naturalWidth, img.naturalHeight));
        var W = Math.max(1, Math.round(img.naturalWidth * sc)), H = Math.max(1, Math.round(img.naturalHeight * sc));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, W, H);
        var id = x.getImageData(0, 0, W, H), d = id.data;
        var rs = 0, gs = 0, bs = 0, n = 0;
        function acc(px) { var o = px * 4; rs += d[o]; gs += d[o + 1]; bs += d[o + 2]; n++; }
        for (var i = 0; i < W; i++) { acc(i); acc((H - 1) * W + i); }
        for (var j = 1; j < H - 1; j++) { acc(j * W); acc(j * W + W - 1); }
        var br = rs / n, bgc = gs / n, bb = bs / n;
        var bLum = 0.299 * br + 0.587 * bgc + 0.114 * bb;
        var TOL2 = 52 * 52;
        var guardLightO = lightBorderPicked();
        function isBg(px) {
          var o = px * 4;
          if (d[o + 3] < 12) return true;
          if (guardLightO) {
            var lmG2 = 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2];
            var chG2 = Math.max(d[o], d[o + 1], d[o + 2]) - Math.min(d[o], d[o + 1], d[o + 2]);
            if (lmG2 > bLum + 5 && chG2 < 24) return false; /* brighter than backdrop = the light border */
          }
          var dr = d[o] - br, dg = d[o + 1] - bgc, db = d[o + 2] - bb;
          if (dr * dr + dg * dg + db * db < TOL2) return true;
          var mx = Math.max(d[o], d[o + 1], d[o + 2]), mn = Math.min(d[o], d[o + 1], d[o + 2]);
          var lum = 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2];
          return (mx - mn) < 30 && lum >= 110 && lum <= bLum - 12;
        }
        var mark = new Uint8Array(W * H);
        var q = new Int32Array(W * H), qh = 0, qt = 0;
        function push(px) { if (!mark[px] && isBg(px)) { mark[px] = 1; q[qt++] = px; } }
        for (i = 0; i < W; i++) { push(i); push((H - 1) * W + i); }
        for (j = 1; j < H - 1; j++) { push(j * W); push(j * W + W - 1); }
        while (qh < qt) {
          var p = q[qh++], px2 = p % W, py = (p / W) | 0;
          if (px2 > 0) push(p - 1);
          if (px2 < W - 1) push(p + 1);
          if (py > 0) push(p - W);
          if (py < H - 1) push(p + W);
        }
        if (qt < W * H * 0.05 || qt > W * H * 0.98) { cb(null); return; }
        for (p = 0; p < W * H; p++) if (mark[p]) d[p * 4 + 3] = 0;
        x.putImageData(id, 0, 0);
        var minX = W, minY = H, maxX = -1, maxY = -1;
        for (var yy = 0; yy < H; yy++) for (var xx = 0; xx < W; xx++) {
          if (d[(yy * W + xx) * 4 + 3] > 12) {
            if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
            if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
          }
        }
        if (maxX < 0) { cb(null); return; }
        var bw = maxX - minX + 1, bh = maxY - minY + 1;
        var pad = Math.round(Math.max(bw, bh) * 0.05);
        var out = document.createElement('canvas'); out.width = bw + pad * 2; out.height = bh + pad * 2;
        out.getContext('2d').drawImage(c, minX, minY, bw, bh, pad, pad, bw, bh);
        cb(out);
      } catch (e) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    img.src = url;
  }
  function freeFormHoleCut(url, cb, optsH) {
    /* C137d (Justin 2026-09-03, "Fascomp" free-form silicone): the image model
       keeps filling an ENCLOSED transparent region (the inside of a ring) with
       material — three prompt rounds and a staging change did not stop it, and
       feeding it transparent art made it inpaint other patches. So the fix is
       deterministic: the customer's artwork alpha says which enclosed regions
       are EMPTY; each one is located in the render (design bbox → patch bbox), a
       colour flood from its centre removes whatever the model painted there and
       the studio backdrop colour goes back in. The flood is bounded to the hole's
       own footprint and aborted on any breach, so a misregistered hole is left
       alone rather than clipped. cb(canvas|null, why). */
    var art = applyToggleParams(cleanUrl(artworkUrl()) || '');
    if (!url || !art) { cb(null, 'no-src'); return; }
    /* C141: the source may be a CANVAS (the plate cut's output) instead of a URL */
    var srcCv = (url && url.getContext) ? url : null;
    var rImg = new Image(), aImg = new Image();
    rImg.crossOrigin = 'anonymous'; aImg.crossOrigin = 'anonymous';
    var pend = srcCv ? 1 : 2, failed = false;
    var go = function () {
      try {
        var W = srcCv ? srcCv.width : rImg.naturalWidth, H = srcCv ? srcCv.height : rImg.naturalHeight;
        if (!W || !H) { cb(null, 'render-size'); return; }
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var x = cv.getContext('2d'); x.drawImage(srcCv || rImg, 0, 0);
        var id = x.getImageData(0, 0, W, H), d = id.data;
        var cs = [[4, 4], [W - 5, 4], [4, H - 5], [W - 5, H - 5]], br = 0, bg = 0, bb = 0;
        cs.forEach(function (c) { var o = (c[1] * W + c[0]) * 4; br += d[o]; bg += d[o + 1]; bb += d[o + 2]; });
        br = Math.round(br / 4); bg = Math.round(bg / 4); bb = Math.round(bb / 4);
        var dist2 = function (o, r, g, b) { var dr = d[o] - r, dg = d[o + 1] - g, db = d[o + 2] - b; return dr * dr + dg * dg + db * db; };
        var pminX = W, pminY = H, pmaxX = -1, pmaxY = -1, i, yy, xx;
        for (yy = 0; yy < H; yy += 2) for (xx = 0; xx < W; xx += 2) {
          if (dist2((yy * W + xx) * 4, br, bg, bb) > 900) { if (xx < pminX) pminX = xx; if (xx > pmaxX) pmaxX = xx; if (yy < pminY) pminY = yy; if (yy > pmaxY) pmaxY = yy; }
        }
        if (pmaxX - pminX < W * 0.2 || pmaxY - pminY < H * 0.1) { cb(null, 'patch-bbox'); return; }
        var sA = Math.min(1, 400 / Math.max(aImg.naturalWidth, aImg.naturalHeight));
        var aw = Math.max(2, Math.round(aImg.naturalWidth * sA)), ah = Math.max(2, Math.round(aImg.naturalHeight * sA));
        var ac = document.createElement('canvas'); ac.width = aw; ac.height = ah;
        var ax = ac.getContext('2d'); ax.drawImage(aImg, 0, 0, aw, ah);
        var ad = ax.getImageData(0, 0, aw, ah).data;
        var op = new Uint8Array(aw * ah), aminX = aw, aminY = ah, amaxX = -1, amaxY = -1;
        for (i = 0; i < aw * ah; i++) {
          if (ad[i * 4 + 3] >= 128) { op[i] = 1; var px = i % aw, py = (i / aw) | 0; if (px < aminX) aminX = px; if (px > amaxX) amaxX = px; if (py < aminY) aminY = py; if (py > amaxY) amaxY = py; }
        }
        if (amaxX < 0) { cb(null, 'art-empty'); return; }
        var ext = new Uint8Array(aw * ah), q = new Int32Array(aw * ah), qh = 0, qt = 0;
        var pushE = function (p) { if (!ext[p] && !op[p]) { ext[p] = 1; q[qt++] = p; } };
        for (i = 0; i < aw; i++) { pushE(i); pushE((ah - 1) * aw + i); }
        for (i = 0; i < ah; i++) { pushE(i * aw); pushE(i * aw + aw - 1); }
        while (qh < qt) { var p = q[qh++], px2 = p % aw, py2 = (p / aw) | 0; if (px2 > 0) pushE(p - 1); if (px2 < aw - 1) pushE(p + 1); if (py2 > 0) pushE(p - aw); if (py2 < ah - 1) pushE(p + aw); }
        var lab = new Int32Array(aw * ah), holes = [], abw = amaxX - aminX + 1, abh = amaxY - aminY + 1, minArea = abw * abh * 0.015;
        /* C426: simpleOnly (Custom Shape counters) — label the pieces so a hole touching two of them (a frame around a
           wordmark) is left alone */
        var simpleH = !!(optsH && optsH.simpleOnly), plab = null;
        if (simpleH) {
          plab = new Int32Array(aw * ah); var nP = 0, sP = [];
          for (i = 0; i < aw * ah; i++) {
            if (!op[i] || plab[i]) continue;
            nP++; plab[i] = nP; sP.push(i);
            while (sP.length) {
              var qP = sP.pop(), qPx = qP % aw;
              if (qPx + 1 < aw && op[qP + 1] && !plab[qP + 1]) { plab[qP + 1] = nP; sP.push(qP + 1); }
              if (qPx > 0 && op[qP - 1] && !plab[qP - 1]) { plab[qP - 1] = nP; sP.push(qP - 1); }
              if (qP + aw < aw * ah && op[qP + aw] && !plab[qP + aw]) { plab[qP + aw] = nP; sP.push(qP + aw); }
              if (qP - aw >= 0 && op[qP - aw] && !plab[qP - aw]) { plab[qP - aw] = nP; sP.push(qP - aw); }
            }
          }
        }
        for (i = 0; i < aw * ah; i++) {
          if (op[i] || ext[i] || lab[i]) continue;
          var hid = holes.length + 1, hq = [i], pix = [], hminX = aw, hminY = ah, hmaxX = -1, hmaxY = -1, tP = 0, mP = false;
          lab[i] = hid;
          while (hq.length) {
            var hp = hq.pop(); pix.push(hp); var hx = hp % aw, hy = (hp / aw) | 0;
            if (simpleH) {
              var nbP = [hx > 0 ? hp - 1 : -1, hx < aw - 1 ? hp + 1 : -1, hy > 0 ? hp - aw : -1, hy < ah - 1 ? hp + aw : -1];
              for (var kP = 0; kP < 4; kP++) { var nPp = nbP[kP]; if (nPp < 0 || !op[nPp]) continue; if (!tP) tP = plab[nPp]; else if (plab[nPp] !== tP) mP = true; }
            }
            if (hx < hminX) hminX = hx; if (hx > hmaxX) hmaxX = hx; if (hy < hminY) hminY = hy; if (hy > hmaxY) hmaxY = hy;
            if (hx > 0 && !op[hp - 1] && !ext[hp - 1] && !lab[hp - 1]) { lab[hp - 1] = hid; hq.push(hp - 1); }
            if (hx < aw - 1 && !op[hp + 1] && !ext[hp + 1] && !lab[hp + 1]) { lab[hp + 1] = hid; hq.push(hp + 1); }
            if (hy > 0 && !op[hp - aw] && !ext[hp - aw] && !lab[hp - aw]) { lab[hp - aw] = hid; hq.push(hp - aw); }
            if (hy < ah - 1 && !op[hp + aw] && !ext[hp + aw] && !lab[hp + aw]) { lab[hp + aw] = hid; hq.push(hp + aw); }
          }
          if (pix.length >= minArea && !(simpleH && mP)) holes.push({ id: hid, area: pix.length, pix: pix, x0: hminX, y0: hminY, x1: hmaxX, y1: hmaxY });
        }
        if (!holes.length) { cb(null, 'no-holes'); return; }
        /* seed = the DEEPEST point of each hole (farthest from any piece), never
           its centroid — a ring's interior is an annulus whose centroid sits ON
           the artwork (that seed read the white wordmark as "already open") */
        var dist = new Int32Array(aw * ah), dq = new Int32Array(aw * ah), dh = 0, dt = 0;
        for (i = 0; i < aw * ah; i++) { if (op[i] || ext[i]) { dist[i] = 0; dq[dt++] = i; } else dist[i] = -1; }
        while (dh < dt) {
          var dp = dq[dh++], dx0 = dp % aw, dy0 = (dp / aw) | 0, dv = dist[dp] + 1;
          if (dx0 > 0 && dist[dp - 1] < 0) { dist[dp - 1] = dv; dq[dt++] = dp - 1; }
          if (dx0 < aw - 1 && dist[dp + 1] < 0) { dist[dp + 1] = dv; dq[dt++] = dp + 1; }
          if (dy0 > 0 && dist[dp - aw] < 0) { dist[dp - aw] = dv; dq[dt++] = dp - aw; }
          if (dy0 < ah - 1 && dist[dp + aw] < 0) { dist[dp + aw] = dv; dq[dt++] = dp + aw; }
        }
        holes.forEach(function (hRec) {
          var best = -1, bp = hRec.pix[0];
          for (var u = 0; u < hRec.pix.length; u++) { if (dist[hRec.pix[u]] > best) { best = dist[hRec.pix[u]]; bp = hRec.pix[u]; } }
          hRec.cx = bp % aw; hRec.cy = (bp / aw) | 0; hRec.depth = best; hRec.pix = null;
        });
        var kx = (pmaxX - pminX + 1) / abw, ky = (pmaxY - pminY + 1) / abh;
        var mapX = function (v) { return Math.round(pminX + (v - aminX) * kx); }, mapY = function (v) { return Math.round(pminY + (v - aminY) * ky); };
        var mark = new Uint8Array(W * H), painted = 0, skipped = 0, rq = new Int32Array(W * H), notesFF = [];
        var lumAt = function (o) { return 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2]; };
        holes.forEach(function (hRec) {
          var sxR = Math.max(0, Math.min(W - 1, mapX(hRec.cx))), syR = Math.max(0, Math.min(H - 1, mapY(hRec.cy)));
          var so = (syR * W + sxR) * 4;
          /* no "already open" shortcut: the model's fill can sit within a few
             shades of the backdrop (233 vs 243 on the Fascomp ring) and still
             read as a plate; painting backdrop over backdrop is harmless */
          var sr = d[so], sg = d[so + 1], sb = d[so + 2];
          var padX = Math.round((pmaxX - pminX) * 0.06), padY = Math.round((pmaxY - pminY) * 0.06);
          var lx0 = Math.max(0, mapX(hRec.x0) - padX), lx1 = Math.min(W - 1, mapX(hRec.x1) + padX);
          var ly0 = Math.max(0, mapY(hRec.y0) - padY), ly1 = Math.min(H - 1, mapY(hRec.y1) + padY);
          var seen = new Uint8Array(W * H), rh = 0, rt = 0, breach = 0, region = [];
          var pushR = function (px3, py3) {
            if (px3 < lx0 || px3 > lx1 || py3 < ly0 || py3 > ly1) { breach++; return; }
            var o3 = py3 * W + px3; if (seen[o3]) return; seen[o3] = 1;
            if (dist2(o3 * 4, sr, sg, sb) > 48 * 48) return;
            rq[rt++] = o3;
          };
          pushR(sxR, syR);
          while (rh < rt) { var rp = rq[rh++]; region.push(rp); var rx = rp % W, ry = (rp / W) | 0; pushR(rx + 1, ry); pushR(rx - 1, ry); pushR(rx, ry + 1); pushR(rx, ry - 1); }
          var mappedArea = hRec.area * kx * ky;
          if (!region.length || region.length > mappedArea * 1.6 || breach > region.length * 0.02) { skipped++; notesFF.push('skip r' + region.length + '/a' + Math.round(mappedArea) + ' b' + breach); return; }
          /* the flood must sit on THIS hole's footprint (inverse-map each pixel to
             the artwork) — a misregistered seed that landed on a piece and ate it
             fails this and is left alone */
          var onHole = 0;
          for (var f = 0; f < region.length; f++) {
            var fx = region[f] % W, fy = (region[f] / W) | 0;
            var axI = Math.round(aminX + (fx - pminX) / kx), ayI = Math.round(aminY + (fy - pminY) / ky);
            if (axI >= 0 && ayI >= 0 && axI < aw && ayI < ah && lab[ayI * aw + axI] === hRec.id) onHole++;
          }
          if (onHole < region.length * 0.7) { skipped++; return; }
          notesFF.push('r' + region.length + '/a' + Math.round(mappedArea) + ' b' + breach + ' h' + Math.round(onHole / region.length * 100) + '%');
          /* soften: four rings of light fringe pixels (the plate's bevel/shadow) join
             the cut — never the dark piece edges */
          for (var pass = 0; pass < 4; pass++) {
            var add = [];
            for (var r1 = 0; r1 < region.length; r1++) {
              var rp1 = region[r1], rx1 = rp1 % W, ry1 = (rp1 / W) | 0;
              var nbs = [rp1 - 1, rp1 + 1, rp1 - W, rp1 + W];
              for (var k = 0; k < 4; k++) {
                var n1 = nbs[k]; if (n1 < 0 || n1 >= W * H || (k === 0 && rx1 === 0) || (k === 1 && rx1 === W - 1)) continue;
                if (seen[n1] === 2 || mark[n1]) continue;
                var nx = n1 % W, ny = (n1 / W) | 0;
                if (nx < lx0 || nx > lx1 || ny < ly0 || ny > ly1) continue;
                if (lumAt(n1 * 4) > 165) { seen[n1] = 2; add.push(n1); }
              }
            }
            region = region.concat(add);
          }
          for (var r2 = 0; r2 < region.length; r2++) mark[region[r2]] = 1;
          painted++;
        });
        if (!painted) { cb(null, 'skipped:' + skipped + ' ' + notesFF.join(' ')); return; }
        for (i = 0; i < W * H; i++) if (mark[i]) { d[i * 4] = br; d[i * 4 + 1] = bg; d[i * 4 + 2] = bb; d[i * 4 + 3] = 255; }
        x.putImageData(id, 0, 0);
        cb(cv, 'holes:' + painted + (skipped ? ' skipped:' + skipped : '') + ' ' + notesFF.join(' '));
      } catch (e) { cb(null, 'threw'); }
    };
    var loaded = function () { if (failed) return; if (--pend === 0) go(); };
    rImg.onload = loaded; aImg.onload = loaded;
    rImg.onerror = aImg.onerror = function () { if (!failed) { failed = true; cb(null, 'load'); } };
    if (!srcCv) rImg.src = url;
    aImg.src = art;
  }
  function freeFormPlateCut(cv, aImg) {
    /* C141 (Justin 2026-09-04, NINJA TRANSFERS free-form silicone: "this is not
       free form! … each letter is individual and applied with a transfer sheet"):
       the model keeps mounting free-form pieces on a die-cut BACKING PLATE no
       matter how the prompt forbids it (C137, C137b, C140 all tried). Same remedy
       as the C137d hole cut, applied OUTWARD: the plate is colour-flooded away
       from the studio frame and the studio surface is painted back, so the pieces
       sit directly on the surface. The pieces are never touched: (a) the flood
       cannot enter anything darker than plate/backdrop (tolerance 90), (b) light
       pieces get a 4% protection band from the artwork alpha, (c) for dark designs
       a second sweep paints light pixels OUTSIDE the artwork footprint (plate
       strips that a darker bevel line fenced off from the flood). Output stays an
       OPAQUE studio render — this is not the C139 transparency cut Justin rejected.
       Returns { cv: canvas|null, why }. */
    var W = cv.width, H = cv.height, x = cv.getContext('2d'), id = x.getImageData(0, 0, W, H), d = id.data, i, xx, yy;
    var br = 0, bg = 0, bb = 0, nC = 0;
    [[4, 4], [W - 10, 4], [4, H - 10], [W - 10, H - 10]].forEach(function (c) { for (var cy = 0; cy < 6; cy++) for (var cx = 0; cx < 6; cx++) { var o = ((c[1] + cy) * W + c[0] + cx) * 4; br += d[o]; bg += d[o + 1]; bb += d[o + 2]; nC++; } });
    br = Math.round(br / nC); bg = Math.round(bg / nC); bb = Math.round(bb / nC);
    var dist2 = function (o) { var dr = d[o] - br, dg = d[o + 1] - bg, db = d[o + 2] - bb; return dr * dr + dg * dg + db * db; };
    var lum = function (o) { return 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2]; };
    /* artwork alpha + colour at <=400px */
    var aW0 = aImg.naturalWidth || aImg.width, aH0 = aImg.naturalHeight || aImg.height;
    var sA = Math.min(1, 400 / Math.max(aW0, aH0));
    var aw = Math.max(2, Math.round(aW0 * sA)), ah = Math.max(2, Math.round(aH0 * sA));
    var ac = document.createElement('canvas'); ac.width = aw; ac.height = ah;
    var ax = ac.getContext('2d'); ax.drawImage(aImg, 0, 0, aw, ah);
    var ad = ax.getImageData(0, 0, aw, ah).data, op = new Uint8Array(aw * ah), lightOp = new Uint8Array(aw * ah);
    var aminX = aw, aminY = ah, amaxX = -1, amaxY = -1, nLight = 0, nOp = 0, lums = [];
    for (i = 0; i < aw * ah; i++) {
      if (ad[i * 4 + 3] < 128) continue;
      op[i] = 1; nOp++;
      var apx = i % aw, apy = (i / aw) | 0;
      if (apx < aminX) aminX = apx; if (apx > amaxX) amaxX = apx; if (apy < aminY) aminY = apy; if (apy > amaxY) amaxY = apy;
      var adr = ad[i * 4] - br, adg = ad[i * 4 + 1] - bg, adb = ad[i * 4 + 2] - bb;
      if (adr * adr + adg * adg + adb * adb < 14400) { lightOp[i] = 1; nLight++; }
      lums.push(0.299 * ad[i * 4] + 0.587 * ad[i * 4 + 1] + 0.114 * ad[i * 4 + 2]);
    }
    if (amaxX < 0) return { cv: null, why: 'art-empty' };
    lums.sort(function (a, b) { return a - b; });
    var p95 = lums[Math.floor(lums.length * 0.95)] || 0;
    var lightDesign = nLight / nOp > 0.35;              /* white/light art: flood only, never sweep */
    var thr = Math.max(100, Math.min(190, p95 + 30));    /* "lighter than anything in the art" */
    /* C141c: sweep bands — 1-3% from a piece: lighter than the art's ink; beyond 3%: anything that is not ink */
    var thrNear = Math.min(thr, Math.max(60, p95 + 15)), thrFar = Math.min(thr, 60);
    var abw = amaxX - aminX + 1, abh = amaxY - aminY + 1;
    /* render boxes on a 2px grid: loose = anything that is not backdrop; tight = INK pixels
       (as dark as the art itself, C142c — the plate's grey drop shadow stretched the box by
       30px and pulled the protected footprint over the plate rim) after 3 erosions (the
       plate's thin dark edge line must not stretch it either) */
    var inkMax = Math.min(200, p95 + 40);
    var gw = Math.ceil(W / 2), gh = Math.ceil(H / 2), dark = new Uint8Array(gw * gh), gx, gy;
    var lx0 = W, ly0 = H, lx1 = -1, ly1 = -1;
    for (gy = 0; gy < gh; gy++) for (gx = 0; gx < gw; gx++) {
      xx = gx * 2; yy = gy * 2; var o0 = (yy * W + xx) * 4, q = dist2(o0);
      if (q > 900) { if (xx < lx0) lx0 = xx; if (xx > lx1) lx1 = xx; if (yy < ly0) ly0 = yy; if (yy > ly1) ly1 = yy; }
      if (q > 14400 && lum(o0) < inkMax) dark[gy * gw + gx] = 1;
    }
    if (lx1 < 0) return { cv: null, why: 'no-patch' };
    for (var er = 0; er < 3; er++) {
      var nd = new Uint8Array(gw * gh);
      for (gy = 1; gy < gh - 1; gy++) for (gx = 1; gx < gw - 1; gx++) { var gi = gy * gw + gx; if (dark[gi] && dark[gi - 1] && dark[gi + 1] && dark[gi - gw] && dark[gi + gw]) nd[gi] = 1; }
      dark = nd;
    }
    var tx0 = W, ty0 = H, tx1 = -1, ty1 = -1, nDark = 0;
    for (gy = 0; gy < gh; gy++) for (gx = 0; gx < gw; gx++) { if (!dark[gy * gw + gx]) continue; nDark++; xx = gx * 2; yy = gy * 2; if (xx < tx0) tx0 = xx; if (xx > tx1) tx1 = xx; if (yy < ty0) ty0 = yy; if (yy > ty1) ty1 = yy; }
    tx1 += 6; ty1 += 6; /* the erosion shaved 3 cells off the far edges */
    var useTight = !lightDesign && nDark > 50 && (tx1 - tx0) >= (lx1 - lx0) * 0.6 && (ty1 - ty0) >= (ly1 - ly0) * 0.6;
    var pminX = useTight ? tx0 : lx0, pmaxX = useTight ? tx1 : lx1, pminY = useTight ? ty0 : ly0, pmaxY = useTight ? ty1 : ly1;
    var kx = (pmaxX - pminX + 1) / abw, ky = (pmaxY - pminY + 1) / abh;
    var dil = function (src, r) {
      var out = new Uint8Array(aw * ah), dq = new Int32Array(aw * ah), dd = new Int32Array(aw * ah), qh = 0, qt = 0, k;
      for (k = 0; k < aw * ah; k++) { if (src[k]) { out[k] = 1; dd[k] = 0; dq[qt++] = k; } else dd[k] = -1; }
      while (qh < qt) {
        var p = dq[qh++], dv = dd[p] + 1; if (dv > r) continue;
        var ppx = p % aw, ppy = (p / aw) | 0, nbs = [[ppx - 1, ppy], [ppx + 1, ppy], [ppx, ppy - 1], [ppx, ppy + 1]];
        for (k = 0; k < 4; k++) { var nx = nbs[k][0], ny = nbs[k][1]; if (nx < 0 || ny < 0 || nx >= aw || ny >= ah) continue; var np2 = ny * aw + nx; if (dd[np2] < 0) { dd[np2] = dv; out[np2] = 1; dq[qt++] = np2; } }
      }
      return out;
    };
    var rP = Math.max(2, Math.round(Math.max(abw, abh) * 0.04)), rB = Math.max(2, Math.round(Math.max(abw, abh) * 0.02)), rF3 = Math.max(3, Math.round(Math.max(abw, abh) * 0.03));
    var pd = nLight ? dil(lightOp, rP) : null, fb = dil(op, rB), fd3 = dil(op, rF3);
    var artAt = function (M, fx, fy) { var axI = Math.round(aminX + (fx - pminX) / kx), ayI = Math.round(aminY + (fy - pminY) / ky); return axI >= 0 && ayI >= 0 && axI < aw && ayI < ah && M[ayI * aw + axI] === 1; };
    /* C141d: protected from every pass = the light-piece band AND the 2% band around EVERY
       piece — the model's bevel, highlight and contact shadow stay with the piece (Justin:
       the flat cut-out look "does not look like what it looked like before") */
    var prot = function (fx, fy) { return (!!pd && artAt(pd, fx, fy)) || artAt(fb, fx, fy); };
    /* pass 1 — flood from the studio frame through backdrop / plate coloured pixels */
    var TOL2 = 8100, seen = new Uint8Array(W * H), fq = new Int32Array(W * H), fh = 0, ft = 0;
    var push = function (px2, py2) { if (px2 < 0 || py2 < 0 || px2 >= W || py2 >= H) return; var o = py2 * W + px2; if (seen[o]) return; seen[o] = 1; if (dist2(o * 4) > TOL2) return; if (prot(px2, py2)) return; fq[ft++] = o; };
    for (i = 0; i < W; i++) { push(i, 0); push(i, H - 1); }
    for (i = 0; i < H; i++) { push(0, i); push(W - 1, i); }
    while (fh < ft) { var fp = fq[fh++], fpx = fp % W, fpy = (fp / W) | 0; push(fpx + 1, fpy); push(fpx - 1, fpy); push(fpx, fpy + 1); push(fpx, fpy - 1); }
    var mark = new Uint8Array(W * H);
    for (i = 0; i < ft; i++) mark[fq[i]] = 1;
    /* fringe — the plate's bevel and its shadow (all lighter than the art) join the cut */
    for (var pass = 0; pass < 6; pass++) {
      var add = [];
      for (i = 0; i < ft; i++) {
        var p1 = fq[i], p1x = p1 % W, nb = [p1 - 1, p1 + 1, p1 - W, p1 + W];
        for (var k2 = 0; k2 < 4; k2++) {
          var q2 = nb[k2]; if (q2 < 0 || q2 >= W * H || (k2 === 0 && p1x === 0) || (k2 === 1 && p1x === W - 1)) continue;
          if (mark[q2] || prot(q2 % W, (q2 / W) | 0)) continue;
          if (lum(q2 * 4) > thr) { mark[q2] = 1; add.push(q2); }
        }
      }
      for (i = 0; i < add.length; i++) fq[ft++] = add[i];
      if (!add.length) break;
    }
    /* pass 2 — dark designs only: light pixels outside the artwork footprint are plate */
    var swept = 0, padX = Math.round((lx1 - lx0) * 0.08), padY = Math.round((ly1 - ly0) * 0.08);
    var sx0 = Math.max(0, lx0 - padX), sx1 = Math.min(W - 1, lx1 + padX), sy0 = Math.max(0, ly0 - padY), sy1 = Math.min(H - 1, ly1 + padY);
    if (!lightDesign) {
      for (yy = sy0; yy <= sy1; yy++) for (xx = sx0; xx <= sx1; xx++) {
        var o2 = yy * W + xx;
        if (mark[o2] || prot(xx, yy)) continue;
        if (lum(o2 * 4) <= (artAt(fd3, xx, yy) ? thrNear : thrFar)) continue;
        mark[o2] = 1; swept++;
      }
    }
    /* C141d: plate colour = median of the marked, visibly off-backdrop pixels in the design
       box; inside the 2% band only FLAT PLATE pixels (within 30 of that colour) go — the
       bevels, highlights and contact shadows around each piece stay */
    var rs = [], gs = [], bs = [];
    for (yy = ly0; yy <= ly1; yy += 3) for (xx = lx0; xx <= lx1; xx += 3) { var om = yy * W + xx; if (!mark[om]) continue; var o4m = om * 4; if (dist2(o4m) <= 36) continue; rs.push(d[o4m]); gs.push(d[o4m + 1]); bs.push(d[o4m + 2]); }
    var med = function (a) { if (!a.length) return -1; a.sort(function (u, v) { return u - v; }); return a[a.length >> 1]; };
    var pr = med(rs), pg = med(gs), pb = med(bs), banded = 0, plateLum = pr >= 0 ? (0.299 * pr + 0.587 * pg + 0.114 * pb) : 999;
    if (pr >= 0 && !lightDesign) {
      for (yy = sy0; yy <= sy1; yy++) for (xx = sx0; xx <= sx1; xx++) {
        var ob = yy * W + xx; if (mark[ob] || (pd && artAt(pd, xx, yy)) || !artAt(fb, xx, yy)) continue;
        var o4b = ob * 4; if (dist2(o4b) <= 36) continue;
        /* flat plate, or anything LIGHTER than the plate face (its bevel highlight) — a dark piece's own highlights that get caught here are repainted in a near-identical surface colour */
        if (Math.abs(d[o4b] - pr) + Math.abs(d[o4b + 1] - pg) + Math.abs(d[o4b + 2] - pb) <= 30 || lum(o4b) >= plateLum - 10) { mark[ob] = 1; banded++; }
      }
    }
    /* paint — every marked pixel inside the padded design box takes the studio surface's
       OWN texture (the pixel mirrored across the nearer top/bottom edge of the box), so
       neither a flat rectangle nor a pale plate silhouette is left behind (C141c); the
       flat backdrop colour is the fallback when the mirror lands on something else */
    var plate = 0, srcCopy = new Uint8ClampedArray(d);
    for (yy = sy0; yy <= sy1; yy++) for (xx = sx0; xx <= sx1; xx++) {
      var o3 = yy * W + xx; if (!mark[o3]) continue;
      var o4 = o3 * 4; if (dist2(o4) > 36) plate++;
      var dTop = yy - sy0, dBot = sy1 - yy, ys = (dTop <= dBot) ? (sy0 - 1 - dTop) : (sy1 + 1 + dBot);
      var so = (ys >= 0 && ys < H) ? (ys * W + xx) * 4 : -1;
      if (so >= 0 && Math.abs(srcCopy[so] - br) + Math.abs(srcCopy[so + 1] - bg) + Math.abs(srcCopy[so + 2] - bb) <= 30) { d[o4] = srcCopy[so]; d[o4 + 1] = srcCopy[so + 1]; d[o4 + 2] = srcCopy[so + 2]; }
      else { d[o4] = br; d[o4 + 1] = bg; d[o4 + 2] = bb; }
    }
    var boxArea = (lx1 - lx0 + 1) * (ly1 - ly0 + 1);
    var why = 'plate ' + Math.round(plate / boxArea * 100) + '% of box ' + (useTight ? 'tight' : 'loose') + ' thr' + thr + '/' + thrNear + '/' + thrFar + (lightDesign ? ' light-art' : '') + ' ink<' + inkMax + ' swept' + swept + ' band' + banded + (pr >= 0 ? ' plate' + pr + ',' + pg + ',' + pb : '');
    if (plate < boxArea * 0.002) return { cv: null, why: 'no-plate (' + why + ')' };
    x.putImageData(id, 0, 0);
    return { cv: cv, why: why };
  }
  function freeFormPlateCutUrl(url, cb) {
    /* C141 loader: render + artwork → freeFormPlateCut. cb(canvas|null, why). */
    var art = applyToggleParams(cleanUrl(artworkUrl()) || '');
    if (!url || !art) { cb(null, 'no-src'); return; }
    var rImg = new Image(), aImg = new Image();
    rImg.crossOrigin = 'anonymous'; aImg.crossOrigin = 'anonymous';
    var pend = 2, failed = false;
    var go = function () {
      try {
        var W = rImg.naturalWidth, H = rImg.naturalHeight;
        if (!W || !H) { cb(null, 'render-size'); return; }
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var x = cv.getContext('2d'); x.drawImage(rImg, 0, 0);
        if (x.getImageData(0, 0, 1, 1).data[3] < 20) { cb(null, 'alpha-render'); return; }
        var r = freeFormPlateCut(cv, aImg);
        cb(r.cv, r.why);
      } catch (e) { cb(null, 'threw'); }
    };
    var loaded = function () { if (failed) return; if (--pend === 0) go(); };
    rImg.onload = loaded; aImg.onload = loaded;
    rImg.onerror = aImg.onerror = function () { if (!failed) { failed = true; cb(null, 'load'); } };
    rImg.src = url; aImg.src = art;
  }
  function npAdoptLateFix(v, rawUrl, lateU) {
    /* C141 (was C139h): a Free Form cut that landed after the reveal cap replaces
       the raw render on ITS version — only while that version still shows the raw
       render and nothing has been approved from it. */
    if (!v || !lateU || v.hosted !== rawUrl || st.proofApproved) return;
    v.dataUrl = lateU; v.hosted = lateU; v.alpha = null;
    console.log('[np-e2] free-form late cut adopted');
    try { prepareVersionDisplay(v, function () { try { rerenderProofPhase(); } catch (e1) {} }); } catch (e2) {}
  }
  function npFreeFormFix(url, maxMs, onLate) {
    /* C137d: Promise<hosted URL of the corrected render | null = keep the raw
       render>. Free Form only; bounded; fail-open. The hosted copy is named
       like a frozen proof (…--v0-ffcut…) so isAlphaSrc() classifies it as an
       opaque studio render, exactly like the raw one it replaces. */
    return new Promise(function (res) {
      var done = false, timedOut = false;
      var fin = function (u) {
        /* C141: a cut that finishes after the reveal cap is handed to onLate instead of dropped */
        if (done) { if (timedOut && u && typeof onLate === 'function') { try { onLate(u); } catch (eL) {} } return; }
        done = true; res(u || null);
      };
      /* C426: a Custom Shape whose compose cut letter counters gets the same deterministic hole cut on the render
         (the model fills enclosed openings), limited to single-piece holes and without Free Form's plate step */
      var counterOnly = !isFreeFormShape() && !isLeather() && (st.__contourHoles || 0) > 0 && shapeGeom() === 'custom'; /* C545: never on leather */
      if (!url || !(isFreeFormShape() || counterOnly) || PTYPE.bareArt) { fin(null); return; }
      setTimeout(function () { timedOut = true; fin(null); }, maxMs || 6000);
      try {
        var hostIt = function (cv, why) {
          hostProof(cv, (TYPE_KEY || 'patch') + '--v0-ffcut', function (e, u) {
            var out = u ? toImgixHost(u) : '';
            console.log('[np-e2] free-form cut ' + (out ? 'hosted' : 'host FAILED'), why || '');
            fin(out || null);
          });
        };
        if (counterOnly) {
          freeFormHoleCut(url, function (cvC, whyC) {
            if (!cvC) { console.log('[np-e2] counter cut: no change', whyC || ''); fin(null); return; }
            hostIt(cvC, 'counters[' + whyC + ']');
          }, { simpleOnly: true });
          return;
        }
        /* C141: plate cut first (the backing plate around the pieces), then the C137d
           hole cut (enclosed openings) on its result; one hosted copy */
        freeFormPlateCutUrl(url, function (cvP, whyP) {
          freeFormHoleCut(cvP || url, function (cvH, whyH) {
            var cvOut = cvH || cvP;
            if (!cvOut) { console.log('[np-e2] free-form cut: no change', whyP || '', whyH || ''); fin(null); return; }
            hostIt(cvOut, (cvP ? 'plate[' + whyP + ']' : 'plate[none: ' + (whyP || '') + ']') + (cvH ? ' holes[' + whyH + ']' : ''));
          });
        });
      } catch (eF) { fin(null); }
    });
  }
  function geoShapeCut(url, geom, cb) {
    /* photo mockups: NO pixel flood at all — photos contain flat light
       regions every flood misreads (a light merrow ring lets the flood
       breach into sky/sand). Measure the patch bounds (pixels clearly not
       studio white) and clip to the exact chosen geometry. */
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var W = img.naturalWidth, H = img.naturalHeight;
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var x = cv.getContext('2d');
        x.drawImage(img, 0, 0);
        var d = x.getImageData(0, 0, W, H).data;
        var minX = W, minY = H, maxX = -1, maxY = -1;
        for (var yy = 0; yy < H; yy += 2) for (var xx = 0; xx < W; xx += 2) {
          var o = (yy * W + xx) * 4;
          if (d[o + 3] < 40) continue;
          if ((255 - d[o]) + (255 - d[o + 1]) + (255 - d[o + 2]) > 90) {
            if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
            if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
          }
        }
        if (maxX < 0) { cb(null); return; }
        var bw = maxX - minX + 1, bh = maxY - minY + 1;
        if (lightBorderPicked()) {
          /* a light merrow ring reads as "studio white" and vanishes from the
             measured bounds — grow them by the ring width so the geometry
             mask keeps the border (2026-08-24) */
          var gxL = Math.round(bw * 0.045), gyL = Math.round(bh * 0.045);
          minX = Math.max(0, minX - gxL); maxX = Math.min(W - 1, maxX + gxL);
          minY = Math.max(0, minY - gyL); maxY = Math.min(H - 1, maxY + gyL);
          bw = maxX - minX + 1; bh = maxY - minY + 1;
        }
        var m = document.createElement('canvas'); m.width = W; m.height = H;
        var mx = m.getContext('2d');
        mx.beginPath();
        if (geom === 'circle' || geom === 'oval' || geom === 'oval-h') {
          var rx = (geom === 'circle' ? Math.min(bw, bh) : bw) / 2 * 0.99;
          var ry = (geom === 'circle' ? Math.min(bw, bh) : bh) / 2 * 0.99;
          mx.ellipse(minX + bw / 2, minY + bh / 2, rx, ry, 0, 0, Math.PI * 2);
        } else {
          var rr = (st.corners === 'square') ? 0 : Math.min(bw, bh) * 0.1;
          var inx = bw * 0.012, iny = bh * 0.012; /* shadow-inflated bounds: shave the rim */
          if (rr > 0 && mx.roundRect) mx.roundRect(minX + inx, minY + iny, bw - inx * 2, bh - iny * 2, rr);
          else mx.rect(minX + inx, minY + iny, bw - inx * 2, bh - iny * 2);
        }
        mx.closePath(); mx.fillStyle = '#000'; mx.fill();
        x.globalCompositeOperation = 'destination-in';
        x.drawImage(m, 0, 0);
        x.globalCompositeOperation = 'source-over';
        cb(cv);
      } catch (e) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    img.src = url;
  }
  function npCutInteriorSolid(cv) {
    /* a real patch is a solid object: the central region of the cut's own
       bounding box must be nearly fully opaque. Hollow center = the flood
       ate patch content (e.g. white felt with no separating border). */
    try {
      var w = cv.width, h = cv.height;
      var x = cv.getContext('2d');
      var d = x.getImageData(0, 0, w, h).data;
      var minX = w, minY = h, maxX = -1, maxY = -1;
      for (var yy = 0; yy < h; yy += 2) for (var xx = 0; xx < w; xx += 2) {
        if (d[(yy * w + xx) * 4 + 3] > 12) {
          if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
          if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
        }
      }
      if (maxX < 0) return false;
      var bw = maxX - minX, bh = maxY - minY;
      var x0 = Math.round(minX + bw * 0.25), x1 = Math.round(minX + bw * 0.75);
      var y0 = Math.round(minY + bh * 0.25), y1 = Math.round(minY + bh * 0.75);
      var tot = 0, op = 0;
      for (var y2 = y0; y2 <= y1; y2 += 2) for (var x2 = x0; x2 <= x1; x2 += 2) {
        tot++;
        if (d[(y2 * w + x2) * 4 + 3] > 12) op++;
      }
      return tot > 0 && (op / tot) >= 0.82;
    } catch (eIS) { return true; } /* unverifiable: don't block */
  }
  /* ═══ DIAGNOSTICS MASTER SWITCH ═══
     Everything below this flag was built on 2026-08-25 to find the runaway
     timer in custom-uploader.js (selectNearestVariant2 spawning ~2,500 live
     intervals). It WRAPS GLOBAL PROTOTYPES — setInterval, clearInterval,
     setTimeout, EventTarget.addEventListener, MutationObserver,
     HTMLCanvasElement.toDataURL and XMLHttpRequest.send — which is acceptable
     on a test theme and NOT acceptable for customers. Flip to true only on an
     unpublished theme while chasing a performance bug; the tooling (leak /
     leakSRC / ticktrace / mtblock) is worth keeping for the next one.
     Method notes live in the np-self-replicating-timer memory. */
  var NP_DIAG = false;
  /* B85 (2026-08-25) — GLOBAL CANVAS CENSUS. The add still jams the thread for
     14s with timerTicks:0 and zero network. Rather than guess at another
     suspect, time EVERY canvas readback and encode in the page, whoever calls
     them, and report the delta across the add window. Sync canvas work is the
     only thing that can freeze both clocks like this; if these counters come
     back near zero the jam is NOT canvas and not ours. */
  if (NP_DIAG) try {
    window.__npCv = { tdu: 0, gid: 0, nT: 0, nG: 0, xSync: 0, xSyncMs: 0, xAsync: 0, ltMax: 0, ltN: 0, ltSrc: '' };
    /* B89 (2026-08-25) — CONTINUOUS TICK TRACE, running from page load.
       On Justin's last add the tab was awake the WHOLE time
       (tabsleep hidden:0ms switches:0) yet BOTH clocks ticked 0 times in 13.5s,
       with no long task (153ms max), no canvas, no sync XHR and no network.
       Timers measured native and healthy on /cart, so whatever stops them is
       specific to the PDP or to the moment of the add. This records the gap
       between every tick from page load, so the dump shows exactly WHEN the
       clock stopped and restarted rather than only that it did. */
    /* B91 (2026-08-25) — LEAK CENSUS. The tick trace showed a 250ms interval
       degrading as 743,1311,2051,3112,5587,8458,13690,27496ms — DOUBLING, i.e.
       the page progressively dying rather than blocking at one instant. That
       reconciles longestTask:148ms (no single long task) with a starved clock:
       thousands of SHORT tasks saturate the loop and longtask never sees them.
       Count what accumulates so the leak names itself instead of being guessed
       at: live intervals, listeners, observers, DOM nodes and heap. */
    window.__npT = { si: 0, siLive: 0, st: 0, ael: 0, mo: 0 };
    try {
      /* B93 (2026-08-25) — WHO IS MAKING THEM? The census came back
         intervalsMade:2505 intervalsLive:2489 timeouts:24914 heapMB:614 on a
         two-minute-old page. ~20 new repeating timers PER SECOND. Record the
         caller of every setInterval so the flood names its own source instead
         of being guessed at. Strip query strings from the frame: this string
         is read back through a tool that rejects URLs. */
      var _oSI = window.setInterval, _oCI = window.clearInterval;
      window.__npT.src = {};
      window.setInterval = function () {
        window.__npT.si++; window.__npT.siLive++;
        try {
          var stk = ((new Error()).stack || '').split('\n');
          var frame = stk[2] || stk[1] || 'unknown';
          var mm = frame.match(/([A-Za-z0-9_.-]+\.js)[^:]*:(\d+):(\d+)/);
          var key = mm ? (mm[1] + ':' + mm[2]) : frame.replace(/https?:[^\s)]+/g, '').trim().slice(0, 40);
          window.__npT.src[key] = (window.__npT.src[key] || 0) + 1;
        } catch (eSt) {}
        return _oSI.apply(window, arguments);
      };
      window.clearInterval = function () { if (window.__npT.siLive > 0) window.__npT.siLive--; return _oCI.apply(window, arguments); };
      var _oST = window.setTimeout;
      window.setTimeout = function () { window.__npT.st++; return _oST.apply(window, arguments); };
      var _oAEL = window.EventTarget && window.EventTarget.prototype && window.EventTarget.prototype.addEventListener;
      if (_oAEL) {
        window.EventTarget.prototype.addEventListener = function () { window.__npT.ael++; return _oAEL.apply(this, arguments); };
      }
      var _oMO = window.MutationObserver;
      if (_oMO) {
        window.MutationObserver = function (cb) { window.__npT.mo++; return new _oMO(cb); };
        window.MutationObserver.prototype = _oMO.prototype;
      }
    } catch (eLk) {}
    window.__npTk = { last: performance.now(), gaps: [], n: 0 };
    setInterval(function () {
      var nT2 = performance.now();
      var gT2 = nT2 - window.__npTk.last;
      window.__npTk.last = nT2; window.__npTk.n++;
      window.__npTk.gaps.push(Math.round(gT2));
      if (window.__npTk.gaps.length > 60) window.__npTk.gaps.shift();
    }, 250);
    /* B86 (2026-08-25) — SYNC-XHR + LONGTASK CENSUS. The add jams 16s with
       BOTH clocks frozen, zero canvas work (0ms/0 calls) and no network. A
       synchronous XMLHttpRequest is the classic way to freeze a main thread
       like that, and XMLHttpRequest.prototype.open is already WRAPPED on this
       page (measured: xhrNative=false), so another script owns it. */
    try {
      var _xo = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
      if (_xo && _xo.open && !_xo.__npWrapped) {
        var _oOpen = _xo.open, _oSend = _xo.send;
        _xo.open = function (m, u, async) {
          try { this.__npSync = (async === false); } catch (e1) {}
          return _oOpen.apply(this, arguments);
        };
        _xo.send = function () {
          if (this.__npSync) {
            var tS = performance.now();
            var rS = _oSend.apply(this, arguments);
            window.__npCv.xSyncMs += performance.now() - tS;
            window.__npCv.xSync++;
            return rS;
          }
          window.__npCv.xAsync++;
          return _oSend.apply(this, arguments);
        };
        _xo.__npWrapped = true;
      }
    } catch (eX) {}
    try {
      if (window.PerformanceObserver) {
        new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (en) {
            window.__npCv.ltN++;
            if (en.duration > window.__npCv.ltMax) {
              window.__npCv.ltMax = en.duration;
              try {
                var at = (en.attribution && en.attribution[0]) || null;
                window.__npCv.ltSrc = at ? (at.containerType || 'window') + ':' + (at.containerName || at.containerId || '-') : 'none';
              } catch (e2) {}
            }
          });
        }).observe({ entryTypes: ['longtask'] });
      }
    } catch (eL) {}
    var _cProto = window.HTMLCanvasElement && window.HTMLCanvasElement.prototype;
    var _xProto = window.CanvasRenderingContext2D && window.CanvasRenderingContext2D.prototype;
    if (_cProto && _cProto.toDataURL && !_cProto.__npWrapped) {
      var _oTdu = _cProto.toDataURL;
      _cProto.toDataURL = function () {
        var tA = performance.now();
        var rA = _oTdu.apply(this, arguments);
        window.__npCv.tdu += performance.now() - tA; window.__npCv.nT++;
        return rA;
      };
      _cProto.__npWrapped = true;
    }
    if (_xProto && _xProto.getImageData && !_xProto.__npWrapped) {
      var _oGid = _xProto.getImageData;
      _xProto.getImageData = function () {
        var tB = performance.now();
        var rB = _oGid.apply(this, arguments);
        window.__npCv.gid += performance.now() - tB; window.__npCv.nG++;
        return rB;
      };
      _xProto.__npWrapped = true;
    }
  } catch (eCv) {}
  var NP_ALPHA_CUT = false; /* B84 — see hostMockup note below */
  function hostMockup(url, cb) {
    /* transparent copy of a sensei mockup: LOCAL edge-connected cut (never
       eats the patch base) hosted via the presign pipeline to imgix. */
    /* Renders come back OPAQUE on a white studio backdrop again (the transparent
       experiment was reverted 2026-08-18 — it made the model render flat product
       cutouts and destroyed embroidery texture). So the cut is back on. The
       probeRenderAlpha path below still short-circuits any render that DOES
       arrive with alpha, so this is safe either way. */
    if (!url || isAlphaSrc(url)) { cb(null); return; }
    /* B84 (2026-08-25) — gated HERE, not at each caller, so every existing
       "cut failed" fallback still runs (upgradeVersionAlpha's freezeProofCopy
       still catalogs the raw render, so proofs keep saving). prepareVersionDisplay
       calls this AT REVEAL — that is why Justin's Safari froze on the second
       checkmark and never advanced: the thread was jammed mid-reveal by the
       same synchronous pixel cut that cost the add 17.9s. */
    if (!NP_ALPHA_CUT) { cb(null); return; }
    if (mockupHosted[url] !== undefined) { cb(mockupHosted[url] || null); return; }
    var gCut = shapeGeom();
    var photoArt = st.artColorCount > 600 || (st.artColorCount > 250 && (st.artGradFrac || 0) > 0.22);
    /* GEOMETRY-FIRST: for every standard shape the intended geometry is
       KNOWN, and a geometric mask can never eat patch content (its only
       failure mode is including a sliver of backdrop). The color flood is
       reserved for CUSTOM silhouettes where geometry is unknown — and its
       result is sanity-checked before it ships. */
    var cutFn;
    if (gCut && gCut !== 'custom') {
      cutFn = photoArt
        ? function (u2, cb2) { geoShapeCut(u2, gCut, cb2); }
        : function (u2, cb2) { shapeMaskCutCanvas(u2, gCut, cb2); };
    } else {
      cutFn = outerCutCanvas;
    }
    var usedFlood = cutFn === outerCutCanvas;
    /* The renderer returns REAL alpha since 2026-08-18 (background=transparent
       on the image API). Those renders must NOT be cut: there is no backdrop
       to remove, and a geometric mask would clip the model's own soft, feathered
       edges back into a hard cut-out. Probe the actual pixels rather than the
       URL, because old opaque renders live at the same URL shape. */
    probeRenderAlpha(url, function (already) {
      if (already) {
        /* same contract as the cut path: cb receives a HOSTED URL, not a canvas */
        console.log('[np-e2] render already transparent — cut skipped', url.slice(-52));
        hostRenderAsIs(url, function (cvA) {
          if (!cvA) { delete mockupHosted[url]; cb(null); return; }
          hostProof(cvA, 'alpha' + (Date.now() % 100000), function (eA, uA) {
            var outA = uA ? toImgixHost(uA) : '';
            if (!outA) { delete mockupHosted[url]; cb(null); return; }
            mockupHosted[url] = outA;
            cb(outA);
          });
        });
        return;
      }
      cutFn(url, function (cv) {
      if (!cv) {
        console.warn('[np-e2] alpha cut FAILED (cutter returned null)', url.slice(-60));
        delete mockupHosted[url]; /* never negative-cache — retries may succeed */
        cb(null); return;
      }
      if (usedFlood && !npCutInteriorSolid(cv)) {
        /* the flood hollowed out the patch — never ship a mutilated cut */
        console.warn('[np-e2] flood cut REJECTED (interior loss)', url.slice(-60));
        delete mockupHosted[url];
        cb(null); return;
      }
      hostProof(cv, 'alpha' + (Date.now() % 100000), function (e, u) {
        var out = u ? toImgixHost(u) : '';
        if (!out) { console.warn('[np-e2] alpha cut hosted FAILED', url.slice(-60)); delete mockupHosted[url]; cb(null); return; }
        mockupHosted[url] = out;
        cb(out);
      });
      });
    });
  }
  var cmpSweep = false; /* one-shot proof reveal animation */
  function wireCompare() {
    wireCompareEls(
      document.getElementById('np-e2-pf-stage'),
      document.getElementById('np-e2-cmp-before'),
      document.getElementById('np-e2-cmp-handle')
    );
  }
  function wireCompareEls(stage, before, handle) {
    /* before/after slider: upload (checkerboard) left, AI proof (green)
       right, draggable divider */
    if (!stage || !before || !handle) return;
    function setPos(p) {
      p = Math.max(0, Math.min(100, p));
      before.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
      handle.style.left = p + '%';
    }
    setPos(9); /* just enough for the handle circle + arrows to fully show */
    if (cmpSweep) {
      /* one-shot reveal: show the digital preview fully, sweep across to the
         AI proof, then rest at the normal handle position */
      cmpSweep = false;
      var tS = null, durS = 1300, cancelS = false;
      handle.addEventListener('pointerdown', function () { cancelS = true; }, { once: true });
      setPos(100);
      requestAnimationFrame(function stepS(ts) {
        if (cancelS) return;
        if (tS === null) { tS = ts; requestAnimationFrame(stepS); return; }
        var pS = Math.min(1, (ts - tS) / durS);
        var eS = pS < 0.5 ? 2 * pS * pS : 1 - Math.pow(-2 * pS + 2, 2) / 2;
        setPos(100 - eS * 100); /* ends fully on the AI proof */
        if (pS < 1) requestAnimationFrame(stepS);
      });
    }

    function move(e) {
      var r = stage.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      setPos(x / r.width * 100);
    }
    function up() {
      document.removeEventListener('pointermove', move);
      document.removeEventListener('pointerup', up);
    }
    handle.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      document.addEventListener('pointermove', move);
      document.addEventListener('pointerup', up);
    });
    /* drag starts ONLY from the handle — stage taps must not move the reveal */
  }
  function swapStageAlpha(v) {
    /* the transparent copy replaces the mockup IN PLACE — same layout, same
       slider position, no rebuild, no bounce */
    var sel = (st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected;
    if (st.versions[sel] !== v || pf.hidden) return;
    if (st.proofPhase === 'ready') {
      var pfStage = document.getElementById('np-e2-pf-stage');
      var im = pfStage ? pfStage.querySelector('img') : null;
      if (im) { im.src = v.alpha; pfStage.classList.add('is-alpha'); }
    } else if (st.proofPhase === 'sizing') {
      var szImg = document.getElementById('np-e2-sz-img');
      var szStage = document.getElementById('np-e2-sz-stage');
      if (szImg) szImg.src = v.alpha;
      if (szStage) szStage.classList.add('is-alpha');
    }
  }
  /* max fraction of each shape's bounding box that content can occupy while
     staying FULLY INSIDE the silhouette — 100% fill = largest no-clip size */
  var SHAPE_SAFE = { circle: 0.68, oval: 0.66, 'oval-h': 0.66, square: 0.84, rectangle: 0.84, 'rectangle-v': 0.84, star: 0.46, heart: 0.56, rhombus: 0.5, hexagon: 0.66, shield: 0.58 };
  /* merrow = wrapped thread edge — give the digital ring visible thread texture */
  var MERROW_CSS = 'repeating-linear-gradient(45deg, rgba(0,0,0,.25) 0 2px, rgba(255,255,255,.15) 2px 3px, rgba(0,0,0,0) 3px 6px)';
  function merrowPattern(x, hex, ring) {
    /* stripe pitch scales WITH the ring so the wrap texture reads chunky at
       every render size (fixed 8px tiles went mushy at preview scale) */
    var t = Math.max(6, Math.round((ring || 24) * 0.55));
    var p = document.createElement('canvas'); p.width = t; p.height = t;
    var px = p.getContext('2d');
    px.fillStyle = hex || '#0C0C0E'; px.fillRect(0, 0, t, t);
    px.strokeStyle = 'rgba(0,0,0,0.32)'; px.lineWidth = Math.max(2, t * 0.32);
    px.beginPath(); px.moveTo(-t * 0.25, t * 0.75); px.lineTo(t * 0.75, -t * 0.25);
    px.moveTo(t * 0.25, t * 1.25); px.lineTo(t * 1.25, t * 0.25); px.stroke();
    px.strokeStyle = 'rgba(255,255,255,0.24)'; px.lineWidth = Math.max(1, t * 0.16);
    px.beginPath(); px.moveTo(-t * 0.125, t); px.lineTo(t, -t * 0.125);
    px.moveTo(t * 0.5, t * 1.4); px.lineTo(t * 1.4, t * 0.5); px.stroke();
    return x.createPattern(p, 'repeat');
  }
  /* molded surface ribbing for the flex finishes. Builds ONE seamless tile
     (period = tile width, rows meet at the tile edges) and returns a canvas
     pattern, so the ribs stay crisp at every render size the way the merrow
     wrap does. 'Flat' has no tile — it returns null and nothing is painted. */
  function texturePattern(x, hex, kind, C) {
    var kd = String(kind || '').toLowerCase();
    if (!kd || kd === 'flat') return null;
    var t = Math.max(12, Math.round((C || 1200) * 0.05));
    /* straight ribs run TIGHT — half the period of the sculpted patterns, so
       vertical/horizontal read as fine molded pinstripes like the real flex */
    if (kd === 'vertical' || kd === 'horizontal') t = Math.max(8, Math.round(t * 0.5));
    /* wave + chevron run on a LONG horizontal period — one gentle rise and
       fall per ~3 rib-widths — so the ribs read as sweeping curves instead of
       tight zigzag. Straight ribs keep the square tile. */
    /* the wave sweeps LONG and gentle; the chevron is a steep nested V, so it
       runs on a short period with a tall rise (matches the molded reference) */
    var pw = kd === 'wave' ? Math.round(t * 3.2) : (kd === 'chevron' ? Math.round(t * 1.15) : t);
    var p = document.createElement('canvas'); p.width = pw; p.height = t;
    var px = p.getContext('2d');
    px.fillStyle = hex || '#FFFFFF'; px.fillRect(0, 0, pw, t);
    var dark = 'rgba(0,0,0,0.30)', lite = 'rgba(255,255,255,0.26)';
    if (kd === 'vertical' || kd === 'horizontal') {
      /* straight ribs: a shaded groove + the highlight on its rising edge */
      var horiz = kd === 'horizontal';
      px.fillStyle = dark;
      if (horiz) px.fillRect(0, 0, t, t * 0.42); else px.fillRect(0, 0, t * 0.42, t);
      px.fillStyle = lite;
      if (horiz) px.fillRect(0, t * 0.42, t, t * 0.12); else px.fillRect(t * 0.42, 0, t * 0.12, t);
    } else {
      /* two rows per tile so the ribs tile vertically as well as horizontally */
      var amp = (kd === 'chevron' ? t * 0.62 : t * 0.20), step = t / 2;
      px.lineJoin = 'round'; px.lineCap = 'butt';
      [[dark, Math.max(2, t * 0.20), 0], [lite, Math.max(1, t * 0.10), t * 0.17]].forEach(function (pass) {
        px.strokeStyle = pass[0]; px.lineWidth = pass[1];
        for (var yy = -step; yy <= t + step; yy += step) {
          px.beginPath();
          if (kd === 'chevron') {
            /* apex at the tile centre — both ends sit at the same height, so
               the long V repeats seamlessly across the horizontal join */
            px.moveTo(0, yy + pass[2]);
            px.lineTo(pw / 2, yy + amp + pass[2]);
            px.lineTo(pw, yy + pass[2]);
          } else {
            for (var xx = 0; xx <= pw; xx += Math.max(1, Math.round(pw / 40))) {
              var yv = yy + Math.sin(xx / pw * Math.PI * 2) * amp + pass[2];
              if (xx === 0) px.moveTo(xx, yv); else px.lineTo(xx, yv);
            }
          }
          px.stroke();
        }
      });
    }
    return x.createPattern(p, 'repeat');
  }
  function normalizeCustomBg() {
    if (isLeather() && shapeGeom() === 'custom' && st.border && /etched/i.test(st.border.label || '')) {
      st.border = { label: 'No Border', img: 'https://ninjauploads-production.imgix.net/np-lb-noborder-1786993611.png', note: 'Smooth clean cut edge' };
    }
    /* custom shape defaults the background to None (cut art IS the patch);
       leaving custom clears it so standard shapes ask for a real color */
    try {
      var isCust = st.shape && shapeGeom() === 'custom';
      if (isCust && !isLeather() && !PTYPE.noArt) {
        /* C143 (2026-09-04, Justin: Design's Shape must look different from Free
           Form — show the border as it would look): NO silent 'None' default any
           more. Un-picked, the composer previews the bridged plate in #f2f2f2 with
           the hot-cut edge; 'None' stays an explicit choice in the background step
           (cut on the art's own contour). */
      } else if (!isCust && st.bg && /^none$/i.test(String(st.bg.label || ''))) {
        st.bg = null;
        if (st.draft && st.draft.bg && /^none$/i.test(String(st.draft.bg.label || ''))) st.draft.bg = null;
      }
    } catch (eNB) {}
  }
  /* C220 (Justin 2026-09-15, "why is this high res image showing up poorly on genuine leather?"): the on-screen composite was a
     FIXED 640 px and got stretched ~1.5x on retina screens; the leather etch decides hide/burn pixel by pixel at that size, so
     letters came out stair-stepped and nibbled. Compose at DEVICE resolution (the composite fills ~0.94 of C), floor 640, capped
     at the 1200 px the renderer's reference already uses; while the finger pans keep 640 so the drag stays 1:1. */
  function previewComposeSize220(el, w, h) {
    try {
      if (el && el.classList && el.classList.contains('is-panning')) return 640;
      var dpr = Math.max(1, Math.min(3, window.devicePixelRatio || 1));
      var need = Math.ceil(Math.max(w || 0, h || 0) * dpr / 0.94);
      return Math.max(640, Math.min(1200, need || 640));
    } catch (e220) { return 640; }
  }
  function renderMaskPreview() {
    normalizeCustomBg();
    /* the Step-1 preview shows the artwork INSIDE the chosen shape mask, so
       the customer sees how their image sits before generating */
    var canvas = document.getElementById('np-e2-canvas');
    if (!canvas || st.proofApproved) return;
    var art = canvas.querySelector('.np-e2-art');
    var old = canvas.querySelector('.np-e2-maskprev');
    var zrow = document.getElementById('np-e2-zoomrow');
    var g = shapeGeom();
    if (zrow) zrow.hidden = !!PTYPE.noArt || !(st.shape && g !== 'custom');
    if (!st.shape) {
      var aImgR = document.getElementById('np-e2-artimg');
      var hasArtR = !!(aImgR && aImgR.getAttribute('src'));
      if (PTYPE.mats && !PTYPE.noArt && hasArtR) {
        /* leather/faux with no shape picked yet: the first paint must
           already look like leather — compose on a preview circle (the
           composePatchImage fallback supplies ov = {g:'circle'}) */
        g = 'circle';
      } else {
        if (old) old.remove();
        if (art) art.hidden = !!PTYPE.noArt;
        return;
      }
    }
    if (art) art.hidden = true;
    var cw = canvas.offsetWidth || 600, ch = canvas.offsetHeight || cw;
    var d = (PTYPE.previewDims && st.w && st.h) ? [st.w * 100, st.h * 100] : shapeDims(g, 1, npSelCropped());
    var fit = PTYPE.textPreview ? 0.86 : 0.68;
    var k = Math.min((cw * fit) / d[0], (ch * fit) / d[1]);
    var w = Math.round(d[0] * k), h = Math.round(d[1] * k);
    var el = old;
    if (!el) {
      el = document.createElement('div');
      el.className = 'np-e2-maskprev';
      canvas.appendChild(el);
    }
    el.style.width = w + 'px'; el.style.height = h + 'px';
    el.style.marginLeft = (-w / 2) + 'px'; el.style.marginTop = (-h / 2) + 'px';
    if (window.__npE2PanSync) window.__npE2PanSync(); /* C151 touch-action classes before the first touch */
    el.classList.toggle('np-e2-maskprev--guide', !!PTYPE.previewDims); /* C436 (Justin 2026-09-28, "lets remove this dotted line around the patch"): an entered size no longer draws the dashed tile — the rulers hug the design (C431); tackle twill keeps its option envelope */
    previewDims(canvas, el);
    el.style.background = 'transparent';
    el.style.boxShadow = 'none';
    el.style.borderRadius = '';
    el.style.clipPath = '';
    el.style.backgroundImage = 'none';
    var inn = el.querySelector('.np-e2-maskprev__in');
    if (!inn) { el.innerHTML = '<span class="np-e2-maskprev__in"><img alt=""></span>'; inn = el.querySelector('.np-e2-maskprev__in'); }
    inn.style.inset = '0px';
    inn.style.background = 'transparent';
    inn.style.borderRadius = '';
    inn.style.clipPath = '';
    inn.style.filter = '';
    var im = inn.querySelector('img');
    im.setAttribute('draggable', 'false'); /* pan, never a native image drag */
    im.style.maxWidth = '100%'; im.style.maxHeight = '100%';
    im.style.width = '100%'; im.style.height = '100%';
    im.style.objectFit = 'contain';
    im.style.transform = ''; im.style.filter = ''; im.style.mixBlendMode = '';
    /* ONE renderer for everything the customer sees: the live preview IS the
       composer's output — perfectly smooth stroked rings on every shape,
       merrow texture, colors — identical to the AI's reference */
    var tok = ++maskPrevSeq;
    /* B60 (Justin, night's end): back to the SIMPLE path this morning had —
       latest-wins by token, nothing else. The single-flight lock, watchdog
       and restart counter I added today were managing load that today's own
       additions created; with the sheet composer off the session (see
       doCheckout) they are pure overhead and the source of dead previews. */
    composePatchImage(function (cv) {
      if (tok !== maskPrevSeq || !cv) return;
      try {
        /* C168: the digital preview shows the chosen fold; the FLAT composite rides along in data-np-flat for every reader
           that turns this <img> into a proof / size image (digitalProofFlow quick proof, the size mirror, the pricing modal) */
        var flatUrl = cv.toDataURL('image/png');
        var shown = el.classList.contains('is-panning') ? cv : foldDepiction(cv); /* C170: flat while panning so the finger tracks the box 1:1 */
        if (shown !== cv) im.setAttribute('data-np-flat', flatUrl); else im.removeAttribute('data-np-flat');
        im.src = (shown === cv) ? flatUrl : shown.toDataURL('image/png');
        /* C431: the rulers hug what was actually drawn (see previewDims) */
        el.__npB = canvasDrawnBounds(shown); el.__npBW = shown.width; el.__npBH = shown.height; el.__npBg = shapeGeom();
        previewDims(canvas, el);
      } catch (eP) { try { im.removeAttribute('data-np-flat'); im.src = cv.toDataURL('image/png'); } catch (eP2) {} }
      artLoader(false); /* first composed frame = loading is over (all types) */
    }, previewComposeSize220(el, w, h));
  }
  function previewDims(canvas, patchEl) {
    /* the twill sizes are variant choices, so the step-1 preview carries the
       same measuring arrows the size step does — the customer sees 11" x 4"
       around their lettering the moment they pick it */
    var wd = document.getElementById('np-e2-pv-dimw');
    var hd = document.getElementById('np-e2-pv-dimh');
    if (!wd || !hd) return;
    /* a size-driven type has nothing true to measure until the customer picks
       the size — custom names ships one size, so its rulers are permanent */
    var sizeKnown = !PTYPE.sizeFromOpt || !!st['opt' + PTYPE.sizeFromOpt];
    /* the approved/final view draws its OWN measuring arrows, so the step-1
       pair has to stand down or the customer sees two sets */
    var on = !!(((PTYPE.previewDims && sizeKnown) || (sizeFirstOn() && st.__sizeEntered)) && st.w && st.h && patchEl && !st.proofApproved); /* C229: rulers the moment a size is entered */
    wd.hidden = !on; hd.hidden = !on;
    if (!on) return;
    /* measure the PATCH ITSELF rather than recomputing where it ought to be —
       the recomputed box drifted from the rendered one and the two arrows ended
       up hugging by different amounts */
    var cR = canvas.getBoundingClientRect(), pR = patchEl.getBoundingClientRect();
    var cw = cR.width, ch = cR.height;
    var w = pR.width, h = pR.height;
    var x0 = pR.left - cR.left, y0 = pR.top - cR.top;
    /* C431 (Justin 2026-09-28, "when size is entered the arrows should ONLY measure the design itself … they are too big"): the box is the
       shape TILE (Design's Shape is a fixed 76×76 square while its size follows the artwork's own aspect), so rulers on the box framed empty
       stage around the design. When the composed frame has been measured, the rulers take the drawn patch's own bounds inside the box
       (object-fit: contain), so they measure the design and nothing else. */
    var bP = PTYPE.previewDims ? null : patchEl.__npB; /* tackle twill / names: the size IS the option's envelope, letters float inside it */
    if (bP && patchEl.__npBW && patchEl.__npBH && patchEl.__npBg === shapeGeom()) {
      var sP = Math.min(w / patchEl.__npBW, h / patchEl.__npBH), dwP = patchEl.__npBW * sP, dhP = patchEl.__npBH * sP;
      var oxP = x0 + (w - dwP) / 2, oyP = y0 + (h - dhP) / 2;
      x0 = oxP + bP.x0 * dwP; y0 = oyP + bP.y0 * dhP; w = (bP.x1 - bP.x0) * dwP; h = (bP.y1 - bP.y0) * dhP;
    }
    wd.style.left = Math.round(x0) + 'px';
    wd.style.right = Math.round(cw - (x0 + w)) + 'px';
    var OFF = 16; /* one gap for both arrows so they read as a pair */
    wd.style.top = Math.max(4, Math.round(y0) - OFF) + 'px';
    hd.style.top = Math.round(y0) + 'px';
    hd.style.bottom = Math.round(ch - (y0 + h)) + 'px';
    hd.style.left = Math.max(4, Math.round(x0) - OFF) + 'px';
    var wc = wd.querySelector('.np-e2-dim__chip'), hc = hd.querySelector('.np-e2-dim__chip');
    if (wc) wc.textContent = st.w.toFixed(2) + '"';
    if (hc) hc.textContent = st.h.toFixed(2) + '"';
  }
  /* C148 (Justin 2026-09-05, "when someone is using the color slider … update the preview in real time"):
     while the native colour picker is dragged, commit just the colour and recompose the live preview on a
     trailing ~110ms throttle. The step body is never re-rendered here (that would destroy the input and
     snap the picker shut); the full commit still happens on 'change'. */
  var livePrevT = 0, livePrevPending = false;
  function livePreviewTick() {
    if (livePrevPending) return;
    livePrevPending = true;
    var waitLP = Math.max(0, 110 - (Date.now() - livePrevT));
    setTimeout(function () { livePrevPending = false; livePrevT = Date.now(); try { renderMaskPreview(); } catch (eLP) {} }, waitLP);
  }
  var maskPrevSeq = 0;
  function renderApprovedCanvas() {
    /* post-approval summary page: the Step-1 preview becomes the PROOF with
       the compare slider; prep tools no longer apply */
    var idx = (st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected;
    var v = st.versions[idx];
    if (!v || !st.proofApproved) return;
    var tbS = document.querySelector('.np-e2-cartrow__thumb');
    if (tbS) {
      tbS.classList.toggle('is-digital', !!v.digital);
      tbS.classList.toggle('is-alpha', !!(v.alpha || v.digital || isAlphaSrc(v.dataUrl || v.hosted || '')));
    }
    var srowS = document.getElementById('np-e2-stitchrow');
    if (srowS) {
      srowS.hidden = !(v.digital && stitchAddonEligible());
      var swS2 = srowS.querySelector('.np-e2-switch');
      if (swS2) swS2.classList.toggle('is-on', !!st.stitchAddon);
      var siS = srowS.querySelector('.np-e2-stitchrow__txt i');
      if (siS) {
        var sfx = TYPE_KEY;
        var verbS = (sfx === 'leather-2-0' || sfx === 'fauxleather-2-0') ? 'laser etches'
          : (sfx === 'fullcolor-2-0' ? 'prints' : 'stitches');
        siS.textContent = 'A specialist ' + verbS + ' a real sample for your approval. Adds 2-4 business days to your order. Billed as its own $19.99 line in your cart.';
      }
    }
    document.body.classList.add('np-e2-approved-view');
    /* C19 (2026-08-25, Justin: "when they get to final step page it always
       needs to auto focus to top"). Arriving from the proof modal keeps
       whatever scroll position the design page had, so the customer could land
       mid-page and miss the proof entirely. Jump to the card's own top rather
       than 0, so the sticky site header never covers the heading. rAF so it
       runs after the approved view has actually laid out. */
    try {
      requestAnimationFrame(function () {
        /* Pick the first element that is genuinely ON SCREEN. The first
           attempt took #np-e2-step-pricing unconditionally, but that card is
           hidden on live (NP_PDP_PRICING off) — a hidden element's rect is all
           zeros, so `rect.top + pageYOffset` resolved to wherever the customer
           already was, which is why it landed at the bottom instead of the top. */
        npFocusFinalTop();
      });
    } catch (eTop) {}
    try { paintModeSwitch(); } catch (ePA) {} /* review page: mode tabs leave */
    var canvas = document.getElementById('np-e2-canvas');
    if (!canvas) return;
    var proofSrc = v.alpha || v.dataUrl || v.hosted || '';
    var uploadSrc = sensei.composedLocalFolded || sensei.composedLocal || sensei.composedCleanUrl || applyToggleParams(cleanUrl(artworkUrl()) || '') || ''; /* C181: digital preview first */
    var old = canvas.querySelector('.np-e2-cmp-page');
    if (old) old.remove();
    var art = canvas.querySelector('.np-e2-art');
    if (art) art.hidden = true;
    var mp = canvas.querySelector('.np-e2-maskprev');
    if (mp) mp.remove();
    var cmp = document.createElement('div');
    cmp.className = 'np-e2-cmp-page' + (isAlphaSrc(proofSrc) ? ' is-alpha' : '') + (v.digital ? ' is-digital' : '');
    /* the review view: AI proof on green with size rulers AND the
       original-vs-proof compare slider */
    cmp.innerHTML =
      '<i class="np-e2-sz-under" aria-hidden="true"></i>' +
      '<div class="np-e2-cmp-page__proof"><img src="' + proofSrc + '" alt="Approved proof"></div>' +
      '<span class="np-e2-cmp__tag np-e2-cmp__tag--r">' + (v.digital ? 'DIGITAL PROOF' : 'AI PROOF') + '</span>' +
      '<div class="np-e2-dim np-e2-dim--w"><i class="np-e2-dim__line"></i><b class="np-e2-dim__chip"></b></div>' +
      '<div class="np-e2-dim np-e2-dim--h"><i class="np-e2-dim__line"></i><b class="np-e2-dim__chip"></b></div>' +
      '';
    canvas.appendChild(cmp);
    /* C33 (2026-08-28, Justin: "you have to do it here too"). The FINAL STEP
       stage is .np-e2-cmp-page — a THIRD element, separate from the sizing and
       proof stages C30/C31 covered — and its is-alpha comes from the URL guess
       (isAlphaSrc) alone, never corrected from the bitmap. So white artwork
       vanished here even after the other two were fixed. Ask the pixels, same
       as the sizing stage, and light-classify for the neutral backdrop. */
    npPixelHasAlpha(proofSrc, function (hasA) { if (hasA !== null) cmp.classList.toggle('is-alpha', hasA); });
    npArtIsLight(proofSrc, function (lite) { cmp.classList.toggle('is-lightart', lite); });
    var pimg = cmp.querySelector('.np-e2-cmp-page__proof img');
    if (pimg) pimg.addEventListener('load', function () {
      positionDims();
      centerPatchInBox(pimg, proofSrc);
      try { matchCompareScale(cmp); } catch (eMS2) {}
    });
    if (pimg && pimg.complete) centerPatchInBox(pimg, proofSrc);
    /* one header above BOTH cards: this is the final review step */
    var main = document.querySelector('.np-e2__main');
    if (main && !document.getElementById('np-e2-review-head')) {
      var rh = document.createElement('header');
      rh.id = 'np-e2-review-head';
      rh.className = 'np-e2-stephead np-e2-reviewhead';
      rh.innerHTML = '<span class="np-e2-eyebrow">FINAL STEP</span><h2 class="np-e2-title">Review and Submit Your Patch Order</h2>';
      main.insertBefore(rh, main.firstChild);
    }
    /* the approved note sits under the preview (the options card is hidden) */
    var note = document.getElementById('np-e2-approved-note');
    if (!note) {
      note = document.createElement('p');
      note.id = 'np-e2-approved-note';
      note.className = 'np-e2-apnote';
      canvas.parentElement.insertBefore(note, canvas.nextSibling);
    }
    note.textContent = 'Approved ✓ Your final proof. Size, pricing, and checkout are inside.';
    positionDims();
  }
  function clearApprovedCanvas() {
    document.body.classList.remove('np-e2-approved-view');
    try { paintModeSwitch(); } catch (ePC) {} /* back on the design page: tabs return */
    var strip = document.getElementById('np-e2-orig-strip');
    if (strip) strip.remove();
    var note = document.getElementById('np-e2-approved-note');
    if (note) note.remove();
    var rh = document.getElementById('np-e2-review-head');
    if (rh) rh.remove();
    var canvas = document.getElementById('np-e2-canvas');
    if (!canvas) return;
    var cmp = canvas.querySelector('.np-e2-cmp-page');
    if (cmp) cmp.remove();
    var art = canvas.querySelector('.np-e2-art');
    /* typed products have NO artwork element to show — un-hiding it painted a
       broken-image icon over the preview when they hit Edit selections */
    if (art) art.hidden = !!PTYPE.noArt;
    renderMaskPreview();
  }
  function rerenderProofPhase() {
    if (pf.hidden) return;
    if (st.proofPhase === 'sizing') renderSizing();
    else if (st.proofPhase === 'ready') renderProofReady();
  }
  function preloadImg(src, capMs) {
    return new Promise(function (resolve) {
      if (!src) { resolve(); return; }
      var done = false;
      var fin = function () { if (done) return; done = true; resolve(); };
      var im = new Image();
      im.onload = im.onerror = fin;
      /* B65: a STALLED request fires NEITHER load nor error — iOS holds the
         socket open indefinitely on a flaky connection. prepareVersionDisplay
         gates the whole proof reveal on Promise.all over these, so one stalled
         image pinned the modal on "Rendering your patch" even though the
         render had completed. Resolve after a cap; the image keeps loading and
         paints whenever it arrives. */
      npTick(fin, capMs || 6000);
      im.src = src;
    });
  }
  function prepareVersionDisplay(v, cb) {
    /* WHITE STAGE: the RAW render is what we display — no transparency gate
       before reveal. The transparent copy still cooks in the background for
       the cart-thumbnail contract, and the bounds cache warms for rulers. */
    if (v.dataUrl && !isAlphaSrc(v.dataUrl) && !v.fallbackUpload) {
      measureAlphaBounds(v.dataUrl, function () {});
      hostMockup(v.dataUrl, function (u) { if (u) v.alpha = u; });
    }
    var shown = v.dataUrl || v.alpha || '';
    var cmp = (!v.fallbackUpload && shown)
      ? (sensei.composedLocalFolded || sensei.composedLocal || sensei.composedCleanUrl || applyToggleParams(cleanUrl(artworkUrl()) || '') || '') /* C181 */
      : '';
    Promise.all([preloadImg(shown), preloadImg(cmp)]).then(function () { cb(); });
  }
  function upgradeVersionAlpha(v) {
    /* swap the display copy to the transparent imgix re-host when it lands */
    if (!v || v.alpha || !v.dataUrl || isAlphaSrc(v.dataUrl)) return;
    hostMockup(v.dataUrl, function (u) {
      if (!u) {
        /* cut failed — catalog the raw render so the proof still saves */
        if (!v.digital && !v.fallbackUpload && !v.frozenProof && !v.__frozeStart && (v.hosted || v.dataUrl)) {
          v.__frozeStart = true;
          var idxR = st.versions.indexOf(v) + 1 || 1;
          freezeProofCopy(v.hosted || v.dataUrl, (TYPE_KEY || 'patch') + '--v' + idxR, function (uFR) { if (uFR && !v.frozenProof) v.frozenProof = uFR; });
        }
        return;
      }
      v.alpha = u;
      /* My Proofs catalog: the TRANSPARENT copy is the saved proof — no
         white studio box anywhere it's shown (--va tag = alpha-era freeze,
         the old --v tag stays classified opaque in isAlphaSrc) */
      if (!v.digital && !v.fallbackUpload && !v.frozenProof && !v.__frozeStart) {
        v.__frozeStart = true; /* concurrent alpha callbacks must not double-catalog */
        var idxF = st.versions.indexOf(v) + 1 || 1;
        freezeProofCopy(u, (TYPE_KEY || 'patch') + '--va' + idxF, function (uFA) { if (uFA && !v.frozenProof) v.frozenProof = uFA; });
      }
      try { rerenderProofPhase(); } catch (eRr) {}
      if (st.proofApproved) { try { renderApprovedCanvas(); } catch (eRr2) {} }
      /* if this version is already the approved one, upgrade the cart image
         to the transparent copy (patch on checkerboard, no studio white) */
      if (st.proofApproved && st.versions[st.selected] === v) {
        setProp('_cartImg', digitalCartUrl(u));
        if (sensei.added) lineSync({ '_cartImg': digitalCartUrl(u) });
        var th = document.getElementById('np-e2-cart-thumb');
        if (th) th.src = u;
        var tb = document.querySelector('.np-e2-cartrow__thumb');
        if (tb) tb.classList.add('is-alpha');
      }
    });
  }
  var boundsCache = {};
  /* C29 (2026-08-26, Justin: "you can see it disappears here ... I didnt hit
     remove background"). Nothing removed it. `.np-e2-sz-stage:not(.is-alpha)
     img { mix-blend-mode: multiply }` knocks out a white BACKGROUND — but
     multiply leaves white pixels exactly equal to the backdrop, so a logo drawn
     for a dark background (ANKATLOGODARKBG: 62% of its opaque pixels are white,
     measured) becomes invisible except its coloured parts.
     The blend is gated on is-alpha, which came from isAlphaSrc(URL). That PNG
     genuinely carries ~25k transparent pixels, so it IS alpha and should never
     have been multiplied. Decide from the bitmap, exactly as C25c does for the
     bounds scan: ask the pixels, not the filename. */
  var alphaTruth = {};
  var lightTruth = {};
  function npPixelHasAlpha(url, cb) {
    if (!url) { cb(false); return; }
    if (alphaTruth[url] !== undefined) { cb(alphaTruth[url]); return; }
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var W = 60, H = Math.max(1, Math.round(im.naturalHeight * (W / im.naturalWidth)));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(im, 0, 0, W, H);
        var d = x.getImageData(0, 0, W, H).data, clear = 0, opq = 0, lite = 0;
        /* C30 (2026-08-28, Justin: "you can see it disappears here ... I didnt
           hit remove background"). C29 stopped MULTIPLYING this artwork, which
           was right but not enough: ANKATLOGODARKBG is 62.1% near-white across
           its opaque pixels (measured), and white on the #f2f2f2 checker field
           reads as nothing with or without the blend. Count the light pixels in
           the pass C29 already runs — no second decode, no extra request — so
           the stage can drop to a neutral grey for dark-background artwork. */
        /* C68 (2026-08-31, Justin: "why would this grey background show here for
           full color" — a cream-faced shield with a GREEN border tripped the
           white-artwork stage). Light-dominance of the FACE is the wrong
           discriminator: a patch vanishes on a light stage only when its EDGE
           is light (white letters meeting the page). Classify by the alpha
           BOUNDARY: opaque pixels bordering transparency (or the canvas edge).
           ANKAT's white letters -> boundary ~100% light -> grey stage. The
           pickle shield -> green boundary -> stays on the normal stage. */
        var bLite = 0, bTot = 0;
        var oq = function (px, py) { return px >= 0 && py >= 0 && px < W && py < H && d[(py * W + px) * 4 + 3] >= 13; };
        for (var yy = 0; yy < H; yy++) for (var xx = 0; xx < W; xx++) {
          var i = (yy * W + xx) * 4;
          if (d[i + 3] < 13) { clear++; continue; }
          opq++;
          var isLite = (0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) > 225;
          if (isLite) lite++;
          if (!oq(xx - 1, yy) || !oq(xx + 1, yy) || !oq(xx, yy - 1) || !oq(xx, yy + 1)) {
            bTot++;
            if (isLite) bLite++;
          }
        }
        var has = clear > (W * H) * 0.02;
        lightTruth[url] = bTot > 8 && (bLite / bTot) > 0.45;
        alphaTruth[url] = has; cb(has);
      } catch (e) { alphaTruth[url] = null; cb(null); } /* tainted: caller keeps today's guess */
    };
    im.onerror = function () { alphaTruth[url] = null; cb(null); };
    im.src = /^data:|^blob:/.test(url) ? url : toImgixHost(url);
  }
  function npArtIsLight(url, cb) {
    /* C30: rides on npPixelHasAlpha's cache — one decode serves both answers */
    npPixelHasAlpha(url, function () { cb(!!lightTruth[url]); });
  }
  function canvasDrawnBounds(cv) {
    /* C431: measureAlphaBounds' rule on a canvas already in hand (the preview composer's frame) — the drawn patch is the alpha > 128 region
       when the frame carries real transparency (soft shadows are not patch); an opaque frame answers null and the rulers keep the box */
    try {
      if (!cv || !cv.width || !cv.height) return null;
      var W = 300, H = Math.max(1, Math.round(cv.height * (W / cv.width)));
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d'); x.drawImage(cv, 0, 0, W, H);
      var d = x.getImageData(0, 0, W, H).data, clearPx = 0, minX = W, minY = H, maxX = -1, maxY = -1;
      for (var aa = 3; aa < d.length; aa += 4) { if (d[aa] < 13) clearPx++; }
      if (clearPx <= (W * H) * 0.005) return null;
      for (var yy = 0; yy < H; yy++) {
        for (var xx = 0; xx < W; xx++) {
          if (d[(yy * W + xx) * 4 + 3] > 128) { if (xx < minX) minX = xx; if (xx > maxX) maxX = xx; if (yy < minY) minY = yy; if (yy > maxY) maxY = yy; }
        }
      }
      if (maxX < 0) return null;
      return { x0: minX / W, y0: minY / H, x1: (maxX + 1) / W, y1: (maxY + 1) / H };
    } catch (eCB) { return null; }
  }
  function measureAlphaBounds(url, cb) {
    /* exact drawn-pixel bounding box as fractions of the image. imgix serves
       CORS natively; the sensei mockup bucket got a CORS policy 2026-08-14 —
       for those OPAQUE mockups the box is the non-near-white region (the
       patch + its soft shadow) instead of the alpha region. */
    if (!url) { cb(null); return; }
    if (boundsCache[url] !== undefined) { cb(boundsCache[url] || null); return; }
    var opaque = !isAlphaSrc(url);
    var img = new Image();
    img.crossOrigin = 'anonymous';
    /* the raw S3 host has no CORS headers, so reading its pixels taints the
       canvas and the scan throws — every frozen proof arriving from a reorder
       hit that and the rulers stayed stretched across the padded PNG. imgix
       fronts the same object WITH CORS, so measure there. */
    var measureUrl = /^data:|^blob:/.test(url) ? url : toImgixHost(url); /* a data URL is canvas-safe as-is — the imgix rewrite mangled it and the scan died to the 75% guess */
    img.onload = function () {
      try {
        var W = 300, H = Math.max(1, Math.round(img.naturalHeight * (W / img.naturalWidth)));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, W, H);
        var d = x.getImageData(0, 0, W, H).data;
        var minX = W, minY = H, maxX = -1, maxY = -1;
        /* TRANSPARENCY FROM PIXELS, not URL (Justin 2026-08-24: rulers/compare
           following the backdrop): new renders are transparent on URLs the
           isAlphaSrc heuristic calls opaque — the wrong test then measured
           the backdrop, and rulers + the compare scale fell to the 75% guess.
           If the bitmap carries real alpha, the alpha IS the patch. */
        var clearPx = 0;
        for (var aa = 3; aa < d.length; aa += 4) { if (d[aa] < 13) clearPx++; }
        /* C25c (2026-08-26) — DECIDE FROM THE PIXELS IN BOTH DIRECTIONS.
           This was `!opaque || clearPx > 5%`: it upgraded to alpha when the
           pixels showed transparency, but never DOWNGRADED when the URL claimed
           alpha and the bitmap had none. A fully opaque PNG judged "alpha" by
           isAlphaSrc then matched every pixel (alpha 255 > 128), so the bounds
           came back as the ENTIRE CANVAS. Measured on the real file: alpha mode
           gave 1024x1024 (ratio 1.000 — the square Justin saw at 1024/300 =
           3.41"), colour mode gave 932x413 (2.256, the actual artwork).
           The 2026-08-24 note above fixed the opaque->alpha direction; this is
           the same principle applied symmetrically. Alpha is used only when the
           bitmap genuinely carries transparent pixels. */
        var useAlpha = clearPx > (W * H) * 0.005;
        /* opaque renders: the backdrop is whatever the four corners average —
           white studio, grey stage, off-white — excluded by color distance,
           not a fixed near-white cut that greyish stages slipped through
           (rulers then hugged the whole image instead of the patch) */
        var cIdx = [0, (W - 1) * 4, ((H - 1) * W) * 4, ((H - 1) * W + (W - 1)) * 4];
        var bR = 0, bG = 0, bB = 0;
        cIdx.forEach(function (ci) { bR += d[ci]; bG += d[ci + 1]; bB += d[ci + 2]; });
        bR /= 4; bG /= 4; bB /= 4;
        for (var yy = 0; yy < H; yy++) {
          for (var xx = 0; xx < W; xx++) {
            var i4 = (yy * W + xx) * 4;
            var hit = useAlpha
              ? d[i4 + 3] > 128 /* soft drop shadows (15-40% alpha) are NOT patch — counting them inflated the proof bounds and broke the compare scale (measured k 0.91 vs true 0.65) */
              : (d[i4 + 3] > 12 && (Math.abs(d[i4] - bR) + Math.abs(d[i4 + 1] - bG) + Math.abs(d[i4 + 2] - bB)) > 90);
            if (hit) {
              if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
              if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
            }
          }
        }
        if (maxX < 0) { boundsCache[url] = false; cb(null); return; }
        var b = { x0: minX / W, y0: minY / H, x1: (maxX + 1) / W, y1: (maxY + 1) / H };
        boundsCache[url] = b; cb(b);
      } catch (e) { boundsCache[url] = false; cb(null); }
    };
    img.onerror = function () { boundsCache[url] = false; cb(null); };
    img.src = measureUrl;
  }
  function centerPatchInBox(imgX, srcX) {
    /* transparent compositions can be lopsided — translate the img so the
       DRAWN patch (not the bitmap box) centers, then re-place the rulers */
    if (!imgX || !srcX) return;
    measureAlphaBounds(srcX, function (bC) {
      if (!bC) return;
      var bx = (bC.x0 + bC.x1) / 2 - 0.5, by = (bC.y0 + bC.y1) / 2 - 0.5;
      imgX.style.transform = 'translate(' + (-bx * 100) + '%, ' + (-by * 100) + '%)';
      try { positionDims(); } catch (eC) {}
    });
  }
  function matchCompareScale(stage) {
    /* the compare is only honest when the two patches MATCH on screen — same
       drawn size AND same position (Justin 2026-08-24). Bounds come from the
       pixel scan; the preview half is scaled about its center and then
       translated so its patch sits exactly over the proof's. All math in
       real screen pixels so different CSS sizing of the halves can't skew it. */
    if (!stage) return;
    var proofImg = stage.querySelector(':scope > img, .np-e2-cmp-page__proof img');
    var prevImg = stage.querySelector('.np-e2-cmp__before img');
    if (!proofImg || !prevImg) return;
    var got = { p: null, u: null };
    function ctr(b) { return b ? { x: (b.x0 + b.x1) / 2, y: (b.y0 + b.y1) / 2 } : { x: 0.5, y: 0.5 }; }
    function frac(b) { return b ? Math.max(0.02, Math.max(b.x1 - b.x0, b.y1 - b.y0)) : null; }
    function go() {
      if (!got.p || !got.u) return;
      prevImg.style.transform = ''; /* measure the UNTRANSFORMED rect */
      var pR = proofImg.getBoundingClientRect(), uR = prevImg.getBoundingClientRect();
      if (!pR.width || !uR.width) return;
      var k = (frac(got.p) * pR.width) / (frac(got.u) * uR.width);
      if (!isFinite(k) || k <= 0) return;
      k = Math.max(0.4, Math.min(2.5, k));
      var pc = ctr(got.p), uc = ctr(got.u);
      var px = pR.left + pc.x * pR.width, py = pR.top + pc.y * pR.height;
      var ucx = uR.left + uR.width / 2, ucy = uR.top + uR.height / 2;
      var ux = ucx + (uc.x - 0.5) * uR.width * k, uy = ucy + (uc.y - 0.5) * uR.height * k;
      prevImg.style.transformOrigin = '50% 50%';
      prevImg.style.transform = 'translate(' + (px - ux).toFixed(1) + 'px, ' + (py - uy).toFixed(1) + 'px) scale(' + k.toFixed(4) + ')';
      try { stage.classList.remove('is-settling'); } catch (eSv) {} /* matched — reveal */
    }
    /* opaque sensei mockups without a readable box fall back to the
       renderer's known ~75% framing */
    measureAlphaBounds(proofImg.getAttribute('src'), function (b) { got.p = b || { x0: 0.125, y0: 0.125, x1: 0.875, y1: 0.875 }; go(); });
    measureAlphaBounds(prevImg.getAttribute('src'), function (b) { got.u = b || { x0: 0, y0: 0, x1: 1, y1: 1 }; go(); });
    /* the DOM imgs may still be LOADING when the modal renders — zero rects
       made go() bail silently and the halves never matched. Re-run when each
       finishes (go() recomputes from scratch, so extra calls are harmless). */
    if (!proofImg.complete) proofImg.addEventListener('load', go);
    if (!prevImg.complete) prevImg.addEventListener('load', go);
  }
  function positionDims() {
    var sz = document.getElementById('np-e2-sz-stage');
    if (sz) positionDimsIn(sz, document.getElementById('np-e2-sz-img'), 48);
    var pf2 = document.getElementById('np-e2-pf-stage');
    if (pf2) positionDimsIn(pf2, pf2.querySelector('img'), Math.max(12, (pf2.offsetWidth - 430) / 2));
    var ac = document.querySelector('.np-e2-cmp-page');
    if (ac) positionDimsIn(ac, ac.querySelector('.np-e2-cmp-page__proof img'), Math.round((ac.offsetWidth || 0) * 0.12));
  }
  function positionDimsIn(stage, imgEl, inset) {
    /* places BOTH the dimension arrows (when the stage has them) and the
       white under-panel (opaque mockups) at the patch bounds: for
       transparent imgix sources the true alpha bounds are measured from the
       pixels; opaque sensei mockups fall back to the true w:h aspect at the
       renderer's ~75% framing */
    var wd = stage.querySelector('.np-e2-dim--w'), hd = stage.querySelector('.np-e2-dim--h');
    var und = stage.querySelector('.np-e2-sz-under, .np-e2-pf-under');
    if (!(wd && hd) && !und) return;
    var S = stage.offsetWidth;
    if (!S) return; /* modal hidden */
    if (wd && hd) {
      var wc = wd.querySelector('.np-e2-dim__chip'), hc = hd.querySelector('.np-e2-dim__chip');
      if (wc) wc.textContent = st.w.toFixed(2) + '"';
      if (hc) hc.textContent = st.h.toFixed(2) + '"';
    }
    var box = S - inset * 2;
    function apply(x0, y0, x1, y1) {
      if (wd && hd) {
        wd.style.left = Math.round(x0) + 'px'; wd.style.right = Math.round(S - x1) + 'px';
        hd.style.top = Math.round(y0) + 'px'; hd.style.bottom = Math.round(S - y1) + 'px';
        /* hug the patch: the perpendicular offsets track the measured bounds
           instead of the stage edges (the white stage leaves big margins) */
        wd.style.top = Math.max(10, Math.round(y0) - 30) + 'px';
        hd.style.left = Math.max(10, Math.round(x0) - 30) + 'px';
      }
      /* the white under-panel hugs the same patch bounds (opaque mockups) */
      if (und) {
        var ox = Math.max(2, (x1 - x0) * 0.02), oy = Math.max(2, (y1 - y0) * 0.02);
        und.style.left = Math.round(x0 - ox) + 'px';
        und.style.top = Math.round(y0 - oy) + 'px';
        und.style.width = Math.round((x1 - x0) + ox * 2) + 'px';
        und.style.height = Math.round((y1 - y0) + oy * 2) + 'px';
        var g = shapeGeom();
        und.style.borderRadius = g === 'circle' ? '999px' : ((g === 'oval' || g === 'oval-h') ? '50%' : '8%');
        und.style.clipPath = SHAPE_CLIPS[g] || 'none';
        /* custom shapes get the panel too — true colors for the few seconds
           before the transparent copy lands beat a green-tinted render */
        und.style.display = '';
      }
    }
    var src = imgEl ? (imgEl.currentSrc || imgEl.src) : '';
    var nw = imgEl ? imgEl.naturalWidth : 0, nh = imgEl ? imgEl.naturalHeight : 0;
    if (src && nw && nh) {
      /* the image's ACTUAL rendered rect (CSS caps the img smaller than the
         stage box, so the assumed-box math overshot the patch) */
      var sR = stage.getBoundingClientRect();
      var iR = imgEl.getBoundingClientRect();
      var zf = sR.width ? (S / sR.width) : 1; /* modal zoom: rects are visual px */
      var iw = (iR.width || box) * zf, ih = (iR.height || box) * zf;
      var ixL = (iR.left - sR.left) * zf, iyT = (iR.top - sR.top) * zf;
      var scale = Math.min(iw / nw, ih / nh);
      var cw = nw * scale, ch = nh * scale;
      var cx = ixL + (iw - cw) / 2, cy = iyT + (ih - ch) / 2;
      /* DIGITAL proofs: the compose canvas IS the patch, border ring at the
         very edge — the rulers must span the full image so the stroke is
         always measured (pixel-bounds scans can under-shoot pale borders).
         Custom shapes keep the alpha scan (their canvas carries padding). */
      /* C69 (2026-08-31, Justin's mobile final step: height arrow spanning a
         fraction of the patch, width overshooting onto the stage). This
         full-image shortcut assumed the digital compose canvas IS the patch -
         C56's border margin made that false, and the compose has carried inset
         padding since. A transparent compose measures perfectly with the alpha
         scan (border pixels are opaque, so pale rings are safe); keep the
         shortcut only for OPAQUE digital sources. */
      if (stage.classList && stage.classList.contains('is-digital') && shapeGeom() !== 'custom' && !isAlphaSrc(src)) { apply(cx, cy, cx + cw, cy + ch); return; }
      var b = boundsCache[src];
      if (b) { apply(cx + b.x0 * cw, cy + b.y0 * ch, cx + b.x1 * cw, cy + b.y1 * ch); return; }
      if (b === undefined) measureAlphaBounds(src, function (bb) { if (bb) positionDims(); });
      /* image edges only while the scan is still pending — once it has failed
         (cache === false) fall through to the geometric box, because a padded
         proof PNG is always wider than the patch it contains */
      if (isAlphaSrc(src) && b !== false) { apply(cx, cy, cx + cw, cy + ch); return; }
      /* pixel scan failed (CORS-tainted host / unreadable): frame the patch
         inside the IMAGE rect at the renderer's ~75% canvas framing with the
         true w:h aspect. The stage-box fallback below ignores the img rect
         and overshoots whenever CSS caps the img smaller than the stage —
         a ruler wider than the patch reads as paying for more than you get. */
      var arF = (st.w > 0 && st.h > 0) ? (st.w / st.h) : (nw / nh);
      var fw2 = cw * 0.75, fh2 = fw2 / arF;
      if (fh2 > ch * 0.75) { fh2 = ch * 0.75; fw2 = fh2 * arF; }
      apply(cx + (cw - fw2) / 2, cy + (ch - fh2) / 2, cx + (cw + fw2) / 2, cy + (ch + fh2) / 2);
      return;
    }
    var FILL = 0.75, pw, ph;
    if (st.w >= st.h) { pw = box * FILL; ph = pw * (st.h / st.w); }
    else { ph = box * FILL; pw = ph * (st.w / st.h); }
    var wpad = Math.max(inset - 6, Math.round((S - pw) / 2));
    var hpad = Math.max(inset - 6, Math.round((S - ph) / 2));
    apply(wpad, hpad, S - wpad, S - hpad);
  }

  function renderVolume(p) {
    var t = p.tiers;
    if (!t.length) return;
    /* a tier that ends below the product's minimum quantity can never be
       bought — showing it just dangles a price the customer cannot have */
    var dropT = 0;
    while (dropT < t.length - 1 && t[dropT + 1].min <= QTY_MIN) dropT++;
    if (dropT > 0) t = t.slice(dropT);
    /* derive the active tier from the SLICED list. (This line previously
       referenced pIdx while defining it — NaN — which left no row highlighted
       and the bar stuck on "max discount reached".) */
    var pIdx = 0;
    for (var iP = 0; iP < t.length; iP++) if (st.qty >= t[iP].min) pIdx = iP;
    $('#np-e2-vol-count').textContent = st.qty + ' pieces';
    var nextEl = $('#np-e2-vol-next');
    if (pIdx < t.length - 1) nextEl.textContent = 'next tier at ' + t[pIdx + 1].min;
    else nextEl.textContent = 'max discount reached';

    /* fill: equal segments between tier minimums */
    var fill = 0, segs = t.length - 1;
    if (segs > 0) {
      if (st.qty <= t[0].min) fill = 0;
      else if (st.qty >= t[segs].min) fill = 100;
      else {
        for (var i = 0; i < segs; i++) {
          if (st.qty >= t[i].min && st.qty < t[i + 1].min) {
            fill = (i + (st.qty - t[i].min) / (t[i + 1].min - t[i].min)) * (100 / segs);
            break;
          }
        }
      }
    }
    $('#np-e2-vol-fill').style.width = fill + '%';
    $('#np-e2-vol-scale').innerHTML = t.map(function (x) { return '<span>' + x.min + '</span>'; }).join('');

    var rows = $('#np-e2-vol-rows');
    rows.innerHTML = t.map(function (x, i) {
      var hi = (i < t.length - 1) ? (t[i + 1].min - 1) : null;
      var range = hi ? (x.min + '–' + hi + (i === 0 ? ' pcs' : '')) : (x.min + '+');
      var unit = p.base * (1 - (x.off || 0) / 100);
      var cls = 'np-e2-tier' + (i === pIdx ? ' is-active' : (i === pIdx + 1 ? ' is-next' : ''));
      var offCell = x.off > 0 ? '<em>' + x.off + '% off</em>' : '<i>—</i>';
      var nudge = '';
      /* the nudge belongs to the tier the customer is actually IN, not the
         first row of the table */
      if (i === pIdx && pIdx < t.length - 1) {
        var need = t[pIdx + 1].min - st.qty;
        if (need > 0) nudge = '<span class="np-e2-tier__nudge">Add ' + need + ' of this design to reach ' + t[pIdx + 1].off + '% off in savings.</span>';
      }
      return '<div class="' + cls + '" data-e2-tier="' + x.min + '">' +
        '<span class="np-e2-tier__qty">' + range + '</span>' +
        '<span class="np-e2-tier__price">' + money(unit) + ' ea</span>' +
        '<span class="np-e2-tier__off">' + offCell + '</span>' + nudge + '</div>';
    }).join('');
    $$('#np-e2-vol-rows [data-e2-tier]').forEach(function (row) {
      row.addEventListener('click', function () {
        /* C18 (2026-08-25, Justin: "clicking this on mobile should not change
           quantity"). On a phone the tier table is a price REFERENCE the
           customer scrolls past, not a control — a thumb landing on a row
           silently rewrote the order quantity. Desktop keeps click-to-set,
           where it is a deliberate pointer action. Tested at CLICK time rather
           than render time so a rotate or resize can never leave the wrong
           behaviour wired in. */
        try {
          if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) return;
        } catch (eMQ) {}
        setQty(parseInt(row.getAttribute('data-e2-tier'), 10));
      });
    });
  }

  function commitSizeQty() {
    /* BACKGROUND SHEET STAMPER (2026-08-24): Add to Cart no longer waits on
       build sheets — they compose HERE, debounced, whenever the approved
       size/qty settles (the AI-lane line is already in the cart at approval).
       applySpecToLine skips itself when the stamped sheet is already fresh. */
    if (st.proofApproved && !coBusy && !commitSizeQty.__stamping) {
      /* BACKGROUND PRE-ADD / PRE-SYNC (Justin 2026-08-24, "less than 2
         seconds"): Shopify cart calls cost 3-12s each on this store, so they
         run HERE — debounced, while the customer is still on sizing. The add
         happens at approval/skip with seeded values, every size/qty settle
         re-syncs the line, and Add to Cart just verifies state + navigates.
         Trade-off (approved direction): leaving the page after approval
         keeps the patch in the cart — same as the AI lane's generate-time
         add always did. */
      /* B61: sheets compose AFTER approval/skip (this whole block is gated on
         st.proofApproved) — never while the customer is picking options, and
         never on the click. Deferred so the cart call goes first. */
      npTick(function () { try { preComposeSheets(); } catch (ePC) {} }, 1200);
      /* STARVATION GUARD (Justin 2026-08-24 late): commitSizeQty has 16
         callers and several fire faster than the debounce — resetting the
         timer on every call meant it NEVER fired (no pre-add, no sheets,
         slow clicks). Reset ONLY when the size/qty/variant state actually
         changed; same-state calls let the pending timer run out. */
      var armTok = curLineState();
      if (commitSizeQty.__armTok !== armTok || !commitSizeQty.__sheetPend) {
      commitSizeQty.__armTok = armTok;
      try { coMark('bg-arm'); } catch (eBa) {}
      /* WORKER CLOCK + generation token (B34): the plain setTimeout version
         ARMED but never FIRED on live (beacon-proven) — page optimizers sweep
         and clear pending timer ids (clearTimeout/clearInterval share one
         pool), and a swept timer dies silently. Worker messages route through
         OUR closure map; nothing on the page can cancel them. */
      var myGen = (commitSizeQty.__sheetGen = (commitSizeQty.__sheetGen || 0) + 1);
      commitSizeQty.__sheetPend = true;
      npTick(function () {
        commitSizeQty.__sheetPend = false;
        if (commitSizeQty.__sheetGen !== myGen) return; /* superseded or cancelled */
        try { coMark(coBusy ? 'bg-fire-cobusy' : (commitSizeQty.__stamping ? 'bg-fire-stamping' : 'bg-fire')); } catch (eBf) {}
        if (coBusy || commitSizeQty.__stamping) return;
        commitSizeQty.__stamping = true;
        /* B66: the `: ensureInCart()` half is GONE — a size settle must never
           CREATE a cart line. It only re-syncs a line that the customer has
           already added themselves via Add to Cart. */
        try { coMark(sensei.added ? 'bg-sync' : 'bg-nosync'); } catch (eBm) {}
        var pre = null;
        try { pre = sensei.added ? syncCartLine() : null; } catch (ePre) {}
        sensei.__syncBusy = Promise.resolve(pre).catch(function () {}).then(function () {
          sensei.__syncBusy = null;
          commitSizeQty.__stamping = false;
          try { coMark('bg-ready'); } catch (eBm2) {}
        });
      }, 700);
      }
    }
    /* orientation follows the chosen shape variant: wide shapes keep the
       width as the long side, tall shapes the height */
    var _g = shapeGeom();
    /* C26: for a flex family the ratio already carries the orientation, taken
       from the artwork — forcing landscape/portrait here would re-introduce the
       very stretch this change removes. The fixed families keep the old swap. */
    if (!(FLEX_GEOM[_g] && npSelCropped())) { /* C43: flex only for Cropped tiles */
      var _og = orientGeom(_g); /* C223: Rectangle / Oval take the DESIGN's orientation (tall art = tall patch) — this replaces "rectangle = always landscape" */
      if ((_og === 'rectangle' || _og === 'oval-h') && st.h > st.w) {
        var _t = st.w; st.w = st.h; st.h = _t;
        st.ratio = st.h / st.w;
      } else if ((_og === 'rectangle-v' || _og === 'oval') && st.w > st.h) {
        var _t2 = st.w; st.w = st.h; st.h = _t2;
        st.ratio = st.h / st.w;
      }
    }
    /* the legacy width/height boxes drive THEIR OWN size->variant matcher;
       feeding them on a variant-option product would fight the variant the
       three option steps just chose (and its price) */
    if (!PTYPE.optVariant) setLegacySize(st.w, st.h);
    setLegacyQty(st.qty);
    var v = nearestVariant();
    if (v) setFormVariant(v.id);
    setProp('_Width (in)', st.w.toFixed(2));
    setProp('_Height (in)', st.h.toFixed(2));
    renderPricing();
  }
  function setQty(q) {
    st.qty = Math.max(QTY_MIN, Math.min(QTY_MAX, q));
    commitSizeQty();
  }

  /* ---- render: option rows + step-3 summary + proof gate ---- */
  function optionLabel(key) {
    if (key === 'shape') return st.shape;
    if (key === 'size') { if (st.size && st.w > 0 && st.h > 0) st.size.label = szfFmt(st.w) + '\u2033 \u00d7 ' + szfFmt(st.h) + '\u2033'; return st.size ? st.size.label : null; } /* C229: the label follows st.w/st.h (a later shape pick re-derives the height) */
    if (key === 'border') return st.border ? st.border.label : null;
    if (key === 'fold') return st.fold ? st.fold.label : null; /* C164 */
    if (key === 'bg') return st.bg ? st.bg.label : null;
    if (key === 'thread') return st.thread ? st.thread.label : null;
    if (key === 'backing') return st.backing ? st.backing.label : null;
    if (key === 'texture') return st.texture ? st.texture.label : null;
    if (key === 'text') return st.text ? st.text.label : null;
    if (key === 'font') return st.font ? st.font.label : null;
    if (OPT_RE.test(key)) return st[key] ? st[key].label : null;
    return null;
  }
  function shapeChipHTML() {
    /* tiny green chip cut to the CHOSEN shape for the closed accordion row */
    var g = shapeGeom();
    if (!g) return '';
    if (g === 'custom') {
      var aC = artworkUrl();
      return aC ? '<img class="np-e2-valimg np-e2-valimg--art" src="' + cleanUrl(aC) + '" alt="">' : '';
    }
    var s5 = 'background:#1AA86C;';
    var w5 = 22, h5 = 22;
    if (g === 'circle') s5 += 'border-radius:50%;';
    else if (g === 'oval' || g === 'oval-h' || g === 'oval-v') { s5 += 'border-radius:50%;'; var oT5 = orientGeom(g) === 'oval'; w5 = oT5 ? 18 : 27; h5 = oT5 ? 27 : 18; } /* C223: chip follows the oriented oval */
    else if (g === 'square' || g === 'rectangle' || g === 'rectangle-v') {
      s5 += 'border-radius:' + (st.corners === 'square' ? '2px' : '5px') + ';';
      if (g === 'rectangle' || g === 'rectangle-v') { var rT5 = orientGeom(g) === 'rectangle-v'; w5 = rT5 ? 19 : 28; h5 = rT5 ? 28 : 19; } /* C223 */
    }
    else if (SHAPE_CLIPS[g]) s5 += '-webkit-clip-path:' + SHAPE_CLIPS[g] + ';clip-path:' + SHAPE_CLIPS[g] + ';';
    else s5 += 'border-radius:5px;';
    return '<span class="np-e2-valshape" style="' + s5 + 'width:' + w5 + 'px;height:' + h5 + 'px;"></span>';
  }
  function renderOptions() {
    normalizeCustomBg();
    var map = { shape: 'Select shape', size: 'Select size' /* C229 */, border: 'Select style', fold: 'Select fold style' /* C164 */, bg: 'Select color', thread: 'Select color', backing: 'Select backing', texture: 'Select texture', font: 'Select font', text: 'Select color' };
    /* variant-option rows are named by the product's own option, so their
       placeholder is BUILT from that name rather than listed above */
    ['opt1', 'opt2', 'opt3'].forEach(function (kM) { var dM = optDef(kM); if (dM) map[kM] = 'Select ' + dM.name.toLowerCase(); });
    Object.keys(map).forEach(function (k) {
      var el = $('[data-e2-val="' + k + '"]');
      if (!el) return; /* a row this type does not render */
      var v = optionLabel(k);
      var objV = k === 'bg' ? st.bg : k === 'thread' ? st.thread : k === 'text' ? st.text : k === 'border' ? st.border : k === 'fold' ? st.fold : k === 'backing' ? st.backing : k === 'texture' ? st.texture : null; /* C164 */
      var vis = '';
      if (k === 'shape' && v) vis = shapeChipHTML();
      else if (k === 'fold' && v) vis = '<img class="np-e2-valimg" src="' + ((objV && objV.img) ? objV.img : foldSchematic(v)) + '" alt="" loading="lazy" onerror="this.onerror=null;this.src=\'' + foldSchematic(v) + '\'">'; /* C164: photo, else the schematic */
      else if (v && objV && objV.img) vis = '<img class="np-e2-valimg" src="' + objV.img + '" alt="" loading="lazy">';
      else if (k === 'bg' || k === 'thread' || k === 'text') vis = '<i class="np-e2-swatchdot"' + (v && objV && objV.hex ? ' style="background:' + objV.hex + '"' : '') + '></i>';
      el.innerHTML = vis + (v || map[k]);
      el.classList.toggle('is-set', !!v);
      var sum = $('[data-e2-sum="' + k + '"]');
      if (sum) { sum.textContent = v || '—'; sum.classList.toggle('is-set', !!v); }
    });
    var ready = committed();
    var statusEl = $('#np-e2-opt-status');
    if (statusEl) statusEl.textContent = ready ? 'All options set' : ((PTYPE.names || PTYPE.optVariant || PTYPE.labelsOnly) ? stepSeq().length + ' quick choices' : 'Five quick choices'); /* C174: labels count their own rows (fold, shape, background) */
    var btn = $('#np-e2-proofbtn'), hint = $('#np-e2-proofhint');
    btn.disabled = false;
    /* idle = no button at all (selections auto-generate the proof); the
       button exists only once it has a real action */
    /* the CTA lives and dies by the green checks alone: every section chosen
       -> Generate AI Proof shows, whether or not the last "Continue" was hit */
    if (ready) st.ctaRevealed = true;
    btn.hidden = !(ready || st.versions.length || st.proofApproved);
    var of = btn.closest('.np-e2-optfoot');
    if (of) of.classList.toggle('is-cta-live', !btn.hidden); /* mobile: floats at the bottom */
    var pillF = btn.querySelector('.np-e2-proofbtn__pill');
    if (pillF) pillF.hidden = !!st.versions.length || !!st.proofApproved;
    var skipF = document.getElementById('np-e2-skipproof');
    if (skipF) skipF.hidden = !(ready && !st.versions.length && !st.proofApproved);
    /* this builder IS the proofing process — nothing gets emailed later
       (except the specialist path when the AI render failed) */
    var av = (st.selected === null || st.selected === undefined) ? null : st.versions[st.selected];
    if (st.proofApproved && av && av.fallbackUpload) {
      btn.querySelector('span').textContent = 'Proof requested';
      hint.textContent = 'Our team will prepare your proof and email it shortly.';
      hint.classList.add('is-ready');
    } else if (st.proofApproved) {
      btn.querySelector('span').textContent = 'View approved proof';
      hint.textContent = 'Approved ✓ Your final proof. Size, pricing, and checkout are inside.';
      hint.classList.add('is-ready');
    } else if (st.versions.length) {
      var specsDirty = !st.proofApproved && regensLeft() > 0 && specsChangedSince(st.versions[st.versions.length - 1]);
      btn.querySelector('span').textContent = specsDirty ? 'Generate new proof' : 'View your proof';
      hint.textContent = specsDirty
        ? 'Selections changed \u2014 we\u2019ll render a fresh proof with your updates.'
        : 'Your proof is ready \u2014 approve it to set size and pricing.';
      hint.classList.add('is-ready');
    } else if (ready) {
      btn.querySelector('span').textContent = 'Generate AI Proof';
      hint.textContent = 'Ready — see your patch before it prints.';
      hint.classList.add('is-ready');
    } else {
      hint.textContent = 'Make your choices above to continue.';
      hint.classList.remove('is-ready');
    }
    if (PTYPE.names) {
      /* no AI proof on a names patch — the roster below IS the next step */
      btn.hidden = true;
      if (skipF) skipF.hidden = true;
      hint.textContent = ready ? 'All set \u2014 enter your names below.' : 'Make your choices above to continue.';
      hint.classList.toggle('is-ready', ready);
    }
    renderMaskPreview();
  }
  function lbRingFactor() {
    var tL = Math.max(1, Math.min(10, st.lbThick || PTYPE.lbDefault || 3));
    return PTYPE.lbZeroMax2 ? tL / 5 : (0.55 + tL * 0.15);
  }
  function commitOptions() {
    /* C27 (2026-08-26, Justin: "make sure if customer removes background that
       that line item property _Remove Background: Yes or No comes over with
       every design"). Nothing wrote this property at all — its only mention in
       the file was SPEC_EXCLUDE, the list of props to keep OFF the printed
       sheet, which implies it was expected to exist. Written unconditionally
       (not behind a stepEnabled gate) so it rides on every design, and as an
       explicit 'No' rather than '' because setProp prunes empty values — a
       blank would simply vanish and read as "never asked". */
    if (!PTYPE.noArt) { /* C124: no artwork = nothing to remove or crop */
      setProp('_Remove Background', st.removeBg ? 'Yes' : 'No');
      setProp('_Crop & Trim', st.crop ? 'Yes' : 'No'); /* C27: same reasoning — classic carries both switches */
    }
    if (stepEnabled('shape') || PTYPE.foldShapes) setProp('_Shape', st.shape || ''); /* C165: labels write the fold-derived shape */
    /* ONE border property, no shape suffix - clear any per-shape leftovers
       (the old app wrote "_Border Style {Shape}") before rewriting it */
    $$('input[name^="properties[_Border Style"]').forEach(function (el) { el.remove(); });
    if (stepEnabled('border') && st.shape && st.border) setProp('_Border Style', normalizeBorder(st.border.label));
    if (stepEnabled('fold')) setProp('_Fold Style', st.fold ? st.fold.label : ''); /* C164 */
    if (stepEnabled('bg')) setProp(PTYPE.bgProp || PTYPE.bgLabel || '_Background Color', propColor(st.bg)); /* C180 */
    if (stepEnabled('thread')) setProp(PTYPE.threadProp || PTYPE.threadLabel || '_Border Color', propColor(st.thread)); /* C180 */
    else if (PTYPE.threadProp) setProp(PTYPE.threadProp, ''); /* step switched off — drop what it wrote */
    /* the preview falls back to the FIRST font when none was clicked — the
       order must carry that same font, never a blank (fontless order
       PATCH-2106693, 2026-08-24) */
    /* C24 (2026-08-25, Justin: "custom names is still not coming over with the
       font the customer chose to the Shopify order admin"). stepEnabled('font')
       is `return !!PTYPE.font`, and the custom-names type declares
       fontProp: 'Font Style' but never sets font:1 — it sets names:1 instead.
       So this guard was false on custom names and the property was never
       written AT ALL. It was not the PROP_KEEP prune this time ('Font Style' is
       whitelisted); the value simply never existed. The names flow does render
       a font picker (nameFonts()), so the customer picked a face that went
       nowhere. Write it whenever a font is genuinely in play. */
    if (stepEnabled('font') || (PTYPE.names && PTYPE.fontProp && nameFonts().length)) {
      setProp(PTYPE.fontProp || '_Font Style', activeNameFont().label || '');
    }
    /* fixed-by-product values still have to reach the order — they are just
       never asked. These write to the CUSTOMER-VISIBLE option names the live
       product already uses, so ops reads one vocabulary either way. */
    if (PTYPE.fixedBorder && PTYPE.borderProp) setProp(PTYPE.borderProp, PTYPE.fixedBorder);
    if (PTYPE.fixedBacking && PTYPE.backingProp) setProp(PTYPE.backingProp, PTYPE.fixedBacking);
    if (!npBackingOk(st.backing, st.border, st.shape)) {
      /* C475/C476/C490: never order Velcro on a Full Color custom shape or Hot Cut edge, or a Print & Stitch Merrow edge. The version forgets the dropped backing
         too, so the customer's re-pick is not read as a spec change that un-approves their proof. */
      st.backing = null;
      if (st.draft && !npBackingOk(st.draft.backing, st.draft.border, st.draft.shape)) st.draft.backing = null;
      (st.versions || []).forEach(function (v476) { if (v476 && v476.backing && /hook|velcro/i.test(v476.backing.label || '')) v476.backing = null; });
    }
    if (!PTYPE.backingProp) setProp('_Select Your Backing', st.backing ? st.backing.label : '');
    if (stepEnabled('texture')) setProp('_Background Texture', st.texture ? st.texture.label : '');
    if (stepEnabled('text')) setProp(PTYPE.textProp || '_Text Color', propColor(st.text)); /* C180 */
    if (PTYPE.borderThick) setProp('_Border Thickness', Math.max(1, Math.min(10, st.lbThick || 3)) + '/10');
    if (PTYPE.sewChannel) setProp('_Sewing Channel', npSewOn() ? 'Yes' : ''); /* C538: only when chosen */
    var g2 = shapeGeom();
    if (stepEnabled('shape') || PTYPE.foldShapes) setProp('_Corners', (g2 === 'square' || g2 === 'rectangle' || g2 === 'rectangle-v') ? (st.corners || 'rounded') : ''); /* C165b: labels write their fixed square corners */
    /* borderThick types wrote their value above — this leather-etch line
       must not CLEAR it (it was wiping flex thickness at add time, 2026-08-24) */
    if (!PTYPE.borderThick) setProp('_Border Thickness', (isLeather() && st.border && /etched/i.test(st.border.label || '')) ? (st.lbThick || 3) + '/10' : '');
    setProp('_Etch Style', (isLeather() && st.etchInvert) ? 'Inverted - background etched, artwork bare' : '');
  }

  /* ---- shape mask helpers (customer image contained in each shape) ---- */
  /* polygon masks for the non-radius shapes (tiles + the white under-panel) */
  var SHAPE_CLIPS = {
    rhombus: 'polygon(50% 2%, 98% 50%, 50% 98%, 2% 50%)',
    star: 'polygon(50% 2%, 61% 36%, 98% 36%, 68% 58%, 79% 92%, 50% 71%, 21% 92%, 32% 58%, 2% 36%, 39% 36%)',
    hexagon: 'polygon(25% 4%, 75% 4%, 99% 50%, 75% 96%, 25% 96%, 1% 50%)',
    shield: 'polygon(15.4% 6.2%, 21.2% 4.9%, 27.0% 3.9%, 32.7% 3.1%, 38.5% 2.5%, 44.2% 2.1%, 50.0% 2.0%, 55.8% 2.1%, 61.5% 2.5%, 67.3% 3.1%, 73.0% 3.9%, 78.8% 4.9%, 84.6% 6.2%, 88.1% 7.6%, 91.1% 9.4%, 93.6% 11.9%, 95.5% 14.9%, 96.9% 18.5%, 97.7% 22.6%, 98.0% 27.3%, 97.8% 32.6%, 96.9% 38.5%, 95.6% 44.2%, 94.0% 49.8%, 92.0% 55.1%, 89.6% 60.2%, 86.9% 65.1%, 83.8% 69.9%, 80.3% 74.4%, 76.5% 78.7%, 72.4% 82.9%, 67.8% 86.8%, 62.9% 90.5%, 57.7% 94.1%, 52.0% 97.4%, 51.0% 97.9%, 50.0% 98.0%, 49.0% 97.9%, 48.0% 97.4%, 42.3% 94.1%, 37.1% 90.5%, 32.2% 86.8%, 27.6% 82.9%, 23.5% 78.7%, 19.7% 74.4%, 16.2% 69.9%, 13.1% 65.1%, 10.4% 60.2%, 8.0% 55.1%, 6.0% 49.8%, 4.4% 44.2%, 3.1% 38.5%, 2.2% 32.6%, 2.0% 27.3%, 2.3% 22.6%, 3.1% 18.5%, 4.5% 14.9%, 6.4% 11.9%, 8.9% 9.4%, 11.9% 7.6%, 15.4% 6.2%)',
    heart: 'polygon(50.0% 10.9%, 47.0% 8.1%, 43.7% 5.8%, 40.1% 4.0%, 36.3% 2.7%, 32.4% 2.1%, 28.4% 2.0%, 24.5% 2.5%, 20.6% 3.7%, 17.0% 5.4%, 13.6% 7.6%, 10.6% 10.3%, 7.9% 13.4%, 5.7% 17.0%, 4.0% 20.8%, 2.8% 24.8%, 2.1% 29.0%, 2.0% 33.2%, 2.5% 37.4%, 3.5% 41.5%, 5.0% 45.4%, 7.1% 49.1%, 9.6% 52.3%, 50.0% 98.0%, 90.4% 52.3%, 92.9% 49.1%, 95.0% 45.4%, 96.5% 41.5%, 97.5% 37.4%, 98.0% 33.2%, 97.9% 29.0%, 97.2% 24.8%, 96.0% 20.8%, 94.3% 17.0%, 92.1% 13.4%, 89.4% 10.3%, 86.4% 7.6%, 83.0% 5.4%, 79.4% 3.7%, 75.5% 2.5%, 71.6% 2.0%, 67.6% 2.1%, 63.7% 2.7%, 59.9% 4.0%, 56.3% 5.8%, 53.0% 8.1%)'
  };
  function shapeStyle(geom, w, h) {
    /* returns CSS for the render element */
    var s = 'width:' + w + 'px;height:' + h + 'px;';
    if (geom === 'circle') s += 'border-radius:999px;';
    else if (geom === 'square' || geom === 'rectangle' || geom === 'rectangle-v') s += 'border-radius:6px;';
    else if (geom === 'oval' || geom === 'oval-h') s += 'border-radius:50%;';
    else if (SHAPE_CLIPS[geom]) s += 'clip-path:' + SHAPE_CLIPS[geom] + ';';
    return s;
  }
  /* ═══ C26 (2026-08-26) — FLEX-ASPECT SHAPES ═══════════════════════════
     A shape preset used to mean two things at once: the OUTLINE FAMILY and a
     hardcoded aspect ratio (rectangle was always 84x60 = 1.4:1). So a customer
     with a 2.25:1 rectangular design could not pick "Rectangle" without being
     stretched to 1.4:1 — which raises the mean of W and H and therefore the
     price. The only escape was Custom Shape, and that is precisely the one
     option that forbids Merrow.
     Merrow does not care about the aspect; it cares that the outline is a
     simple continuous edge it can sew. A 3:1 rectangle is as sewable as a
     1.4:1 one. So for these families the aspect now FOLLOWS THE ARTWORK, and
     Merrow stays available because the gate keys on geom === 'custom'.
     Nothing else needs to change to draw them: shapePath() already takes
     arbitrary w/h, and its corner radius is Math.min(w,h) * 0.1 — already
     proportional to the short side, so corners follow the design. */
  var FLEX_GEOM = { rectangle: 1, 'rectangle-v': 1, oval: 1, 'oval-h': 1 };
  /* C26b — once the aspect follows the artwork, the orientation-qualified twin
     of each pair renders IDENTICALLY to its partner ("Tall Rectangle" is just
     "Rectangle" again). Hide the qualified one and keep the generic label,
     which is the one that still reads correctly when it adapts. Only while a
     real artwork aspect exists — with no upload the fixed tiles still differ
     and both are worth showing. */
  var TWIN_OF = { 'rectangle-v': 'rectangle', 'oval-h': 'oval' };
  function shapeTwinHidden(geom) { return false; } /* C43: every tile always shows — C26b's hiding retired with the Cropped split */
  function flexAspect() {
    /* C45 (2026-08-31, Justin: "when you click any of them it overrides the
       other 2 and the shapes are all the same and you cant choose the cropped
       anymore"). This read st.ratio — but picking ANY fixed shape overwrites
       st.ratio with THAT SHAPE's ratio (Rectangle = 60/84), so from that click
       on the Cropped tiles "flexed" to 0.714 and rendered identical to plain
       Rectangle, permanently. C26 never saw it because flex lived on the plain
       tile, whose own pick re-seeded the ratio from the artwork. Flex now reads
       st.artRatio, written ONLY by the artwork-measurement paths and never by a
       shape pick, so Cropped always follows the design. */
    var r = st.artRatio;
    if (!isFinite(r) || r <= 0) return null;
    return r;
  }
  /* ═══ C223 (2026-09-15, Justin: "remove tall rectangle and tall oval from every product page — instead it should have
     rectangle or cropped rectangle and oval and cropped oval, and be smart about showing the rectangle and oval as tall or
     wide based on the design"). The two labels now cover both orientations: artwork clearly taller than wide (h/w > 1.05)
     draws the tall tile, everything else the wide one — tiles, size seeding, the preview, the renderer spec and the
     prompt all read orientGeom(). The internal 'rectangle-v' / 'oval-h' geoms survive only as the oriented variants. With
     no artwork measured yet the historical tiles stand (Rectangle wide, Oval tall). ═══ */
  var LEGACY_SHAPE_LABEL = { 'Tall Rectangle': 'Rectangle', 'Wide Oval': 'Oval' };
  function legacyShapeLabel(v) { if (typeof v !== 'string') return v; var inList = (CFG.shapes || []).some(function (s) { return s.label === v; }); return (!inList && LEGACY_SHAPE_LABEL[v]) ? LEGACY_SHAPE_LABEL[v] : v; } /* old orders / handoffs saved with the retired labels */
  function artTall() { var r = flexAspect(); if (r === null) return null; return r > 1.05; }
  function orientGeom(g) {
    if (g !== 'rectangle' && g !== 'oval') return g;
    var t = artTall(); if (t === null) t = (g === 'oval');
    return g === 'rectangle' ? (t ? 'rectangle-v' : 'rectangle') : (t ? 'oval' : 'oval-h');
  }
  function shapeDims(geom, scale, crop) { /* C43: crop = artwork-aspect tile */
    /* the fixed-size patch has its OWN proportions (3.25 x 1.25), not the
       generic rectangle tile's */
    if (PTYPE.fixedDims && PTYPE.fixedShape && geom === PTYPE.fixedShape.geom) {
      return [Math.round(PTYPE.fixedDims[0] * (scale || 1)), Math.round(PTYPE.fixedDims[1] * (scale || 1))];
    }
    /* C26: flex families are drawn at the ARTWORK's aspect, longest side
       pinned to 84 so every tile still occupies the same visual box */
    if (FLEX_GEOM[geom] && crop) { /* C43 */
      var rF = flexAspect();
      if (rF) {
        var wF, hF;
        if (rF >= 1) { hF = 84; wF = Math.max(24, Math.round(84 / rF)); }
        else { wF = 84; hF = Math.max(24, Math.round(84 * rF)); }
        return [Math.round(wF * (scale || 1)), Math.round(hF * (scale || 1))];
      }
    }
    var d = {
      circle: [76, 76], square: [76, 76],
      rectangle: [84, 60], 'rectangle-v': [60, 84],
      oval: [62, 80], 'oval-h': [80, 62],
      heart: [80, 74], star: [82, 82], rhombus: [76, 76], hexagon: [80, 72], shield: [72, 80],
      custom: [76, 76]
    }[orientGeom(geom)] || [76, 76]; /* C223: Rectangle / Oval at the design's orientation */
    return [Math.round(d[0] * (scale || 1)), Math.round(d[1] * (scale || 1))];
  }
  function shapeRenderHTML(geom, opts) {
    /* opts: {img, bg, thread, scale} — customer art contained inside the shape */
    var o = opts || {};
    var dims = shapeDims(geom, o.scale, o.crop); /* C43 */
    var art = o.img ? '<img src="' + o.img + '" alt="">' : '';
    var fill = o.bg || '#e5e7eb'; /* neutral: light grey shading */
    /* C143 (2026-09-04, Justin): Design's Shape tiles now go through the
       composer like every other shape — the bridged #f2f2f2 plate with the
       hot-cut edge — so the tile stops reading as Free Form (which the caller
       flags data-e2-tilefree → the composer draws the pieces only). */
    /* composer-rendered tile: even outline on every shape */
    return '<span class="np-e2-shapetile__render np-e2-shapetile__render--cv" data-e2-tilegeom="' + geom + '" data-e2-tilecrop="' + (o.crop ? 1 : 0) + '" style="width:' + dims[0] + 'px;height:' + dims[1] + 'px;"><i class="np-e2-tilespin"></i></span>';
  }

  /* ---- artwork color analysis (feeds "Colors detected from artwork"
     and the full-color recommendation) ---- */
  st.artColors = [];
  st.artColorCount = 0;
  /* C147 (Justin 2026-09-04): "update the patch size to 3 inches wide and proportional
     height from 2 inches wide as the default size when making these decisions". Every
     physical judgement below (thin-stroke raster, mm-per-pixel, text height, openings)
     is made as if the patch were NP_JUDGE_IN inches wide. Colour / gradient / edge
     metrics (the 96px pass) are size-free and unchanged. The Patch Gate service is a
     verbatim transplant of this block — regenerate it (scripts/patchgate-regen-core.py)
     and redeploy whenever this changes. */
  function analyzeArtwork() {
    var NP_JUDGE_IN = 3; /* C147: judged patch width in inches — lives inside the block the gate service transplants */
    var NP_MIN_IN = (typeof npMinIn === 'function') ? (parseFloat(npMinIn()) || 0) : 0; /* C155 (Justin 2026-09-08): the product's minimum size — Chenille is 3 x 3 now */
    var NP_JUDGE_EFF = NP_JUDGE_IN; /* C155: the judged width = the SMALLEST patch this product allows for THIS artwork (set once the image dimensions are known) */
    /* Analyse the render the customer is LOOKING AT — cleanUrl() strips the
       imgix params, so this used to quantize the RAW upload every time: the
       detected palette ignored Remove background entirely, and it picked up
       the white field plus a spread of anti-aliased edge tones (one green logo
       reading as White + 5 near-identical greens). With the toggles applied a
       bg-removed logo correctly resolves to its real colours. */
    var url = applyToggleParams(cleanUrl(artworkUrl()));
    if (!url) return;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      NP_JUDGE_EFF = (typeof NP_JUDGE_OVERRIDE === 'number' && NP_JUDGE_OVERRIDE > 0) ? NP_JUDGE_OVERRIDE : Math.max(NP_JUDGE_IN, NP_MIN_IN, NP_MIN_IN * ((img.naturalWidth || img.width || 1) / (img.naturalHeight || img.height || 1))); /* C229: the Size step judges at the customer's width */ /* C155: a 3 x 3 minimum makes a landscape logo 3 * aspect inches wide; portrait art stays at max(3, min) */
      try {
        var artEl0 = document.getElementById('np-e2-artimg');
        st.__analyzedSrc = artEl0 ? artEl0.src : url;
        var S = 96;
        var cv = document.createElement('canvas'); cv.width = S; cv.height = S;
        var cx = cv.getContext('2d');
        var r = Math.min(S / img.width, S / img.height);
        var w = Math.max(1, Math.round(img.width * r)), h = Math.max(1, Math.round(img.height * r));
        cx.drawImage(img, 0, 0, w, h);
        var data = cx.getImageData(0, 0, w, h).data;
        /* BACKGROUND EXCLUSION (Justin 2026-08-22): a solid field behind the
           design (black square, white card) dominated every metric — the
           Elemental logo's black field diluted its non-flat fraction below
           the photo gates. The border-dominant colour bucket (>50% of the
           border ring) is the background; its pixels are excluded from the
           palette and texture measurements. */
        var bKey = function (o) { return (data[o] >> 4) + ',' + (data[o + 1] >> 4) + ',' + (data[o + 2] >> 4); };
        var borderB = {}, bTot = 0;
        var bAdd = function (o) { if (data[o + 3] >= 128) { var kB = bKey(o); borderB[kB] = (borderB[kB] || 0) + 1; bTot++; } };
        for (var xB = 0; xB < w; xB++) { bAdd(xB * 4); bAdd(((h - 1) * w + xB) * 4); }
        for (var yB = 0; yB < h; yB++) { bAdd((yB * w) * 4); bAdd((yB * w + w - 1) * 4); }
        var bgKey = null, bgMax = 0;
        for (var kB2 in borderB) { if (borderB[kB2] > bgMax) { bgMax = borderB[kB2]; bgKey = kB2; } }
        if (!(bTot && bgMax / bTot > 0.5)) bgKey = null;
        var bgParts = bgKey ? bgKey.split(',') : null;
        var isBgPx = function (o) {
          if (!bgParts) return false;
          return Math.abs((data[o] >> 4) - bgParts[0]) <= 1 &&
                 Math.abs((data[o + 1] >> 4) - bgParts[1]) <= 1 &&
                 Math.abs((data[o + 2] >> 4) - bgParts[2]) <= 1;
        };
        /* EXCLUSION FLOOR (2026-08-25): on a background-REMOVED upload the
           border ring is almost all transparent, so the only opaque pixels
           sampled there are the artwork's own edge — the logo's colour then
           wins the "background" vote and the exclusion deletes the entire
           design (measured live: 927 opaque px -> 0 art px -> no swatches at
           all under COLORS FROM YOUR ARTWORK). The exclusion is only ever
           meant to drop a solid FIELD behind the art, so if it would take
           the artwork with it, drop the exclusion instead. */
        if (bgParts) {
          var keepPx = 0, totPx = 0;
          for (var iF = 0; iF < data.length; iF += 4) {
            if (data[iF + 3] < 128) continue;
            totPx++;
            if (!isBgPx(iF)) keepPx++;
          }
          if (!keepPx || keepPx / Math.max(1, totPx) < 0.15) bgParts = null;
        }
        var buckets = {};
        /* C517 (Justin 2026-10-27, a blurry WSU cougar in one maroon listed PMS 201 C + 194 C + 7419 C + 695 C): a soft or
           anti-aliased EDGE is a blend of the colours either side of it, not a colour of the design. A blend pixel sits on the
           straight line between two clearly different pixels 1-2 px away across it, or is a half-transparent cut-out edge next
           to solid art of another colour. A swatch that is mostly blend pixels is dropped when its colour is explained: it lies
           between two kept colours, between a kept colour and the background field, or is a kept colour faded toward grey /
           white / black. A thin real colour (a gold chain, 90% edge pixels at this size) is not a shade of anything kept, so it
           stays. Art touching a mostly transparent image edge is not a field, so it stays in the swatches; a solid dark or
           coloured field is offered after the art colours (white / light grey cards stay out). Only the swatches use these;
           every metric and verdict counts exactly as before. */
        var pBk517 = {}, fld517 = { n: 0, r: 0, g: 0, b: 0 }, ring517 = 2 * (w + h) - 4, clear517 = bTot < 0.5 * ring517;
        var blend517 = function (o) {
          var p = o >> 2, x = p % w, y = (p - x) / w, ax, ay, bx, by, oa, ob, er, eg, eb, t, k, d, dx, dy, edge = false, other = false;
          if (data[o + 3] < 230) {
            for (ay = y - 2; ay <= y + 2; ay++) for (ax = x - 2; ax <= x + 2; ax++) {
              if (ax < 0 || ay < 0 || ax >= w || ay >= h) { edge = true; continue; }
              oa = (ay * w + ax) * 4;
              if (data[oa + 3] < 128) { if (Math.abs(ax - x) <= 1 && Math.abs(ay - y) <= 1) edge = true; }
              else if (data[oa + 3] >= 230 && Math.abs(data[o] - data[oa]) + Math.abs(data[o + 1] - data[oa + 1]) + Math.abs(data[o + 2] - data[oa + 2]) >= 40) other = true;
            }
            if (edge && other) return true;
          }
          for (k = 1; k <= 2; k++) for (d = 0; d < 4; d++) {
            dx = d === 1 ? 0 : k; dy = d === 0 ? 0 : (d === 3 ? -k : k);
            ax = x - dx; ay = y - dy; bx = x + dx; by = y + dy;
            if (ax < 0 || bx >= w || ay < 0 || ay >= h || by < 0 || by >= h) continue;
            oa = (ay * w + ax) * 4; ob = (by * w + bx) * 4;
            if (data[oa + 3] < 128 || data[ob + 3] < 128) continue;
            er = data[ob] - data[oa]; eg = data[ob + 1] - data[oa + 1]; eb = data[ob + 2] - data[oa + 2];
            if (Math.abs(er) + Math.abs(eg) + Math.abs(eb) < 90) continue;
            t = ((data[o] - data[oa]) * er + (data[o + 1] - data[oa + 1]) * eg + (data[o + 2] - data[oa + 2]) * eb) / (er * er + eg * eg + eb * eb);
            if (t < 0.12 || t > 0.88) continue;
            if (Math.abs(data[o] - data[oa] - t * er) + Math.abs(data[o + 1] - data[oa + 1] - t * eg) + Math.abs(data[o + 2] - data[oa + 2] - t * eb) <= 30) return true;
          }
          return false;
        };
        var opaque = 0, artPx = 0;
        /* VIVID SPOT-COLOR signal (Justin 2026-08-24): saturated-pixel share
           + distinct-hue count over the ART pixels. AI art already rendered
           AS an embroidered patch is a THREAD PALETTE — mostly saturated
           pixels in a handful of hues — while painterly/photo art is muted
           or hue-diverse. */
        var hueBins = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0], satPx = 0;
        for (var i = 0; i < data.length; i += 4) {
          if (data[i + 3] < 128) continue;
          opaque++;
          if (clear517 || !isBgPx(i)) { var k517 = (data[i] >> 4) + ',' + (data[i + 1] >> 4) + ',' + (data[i + 2] >> 4), pb517 = pBk517[k517] = pBk517[k517] || { n: 0, r: 0, g: 0, b: 0, nb: 0 }; pb517.n++; pb517.r += data[i]; pb517.g += data[i + 1]; pb517.b += data[i + 2]; if (blend517(i)) pb517.nb++; } else { fld517.n++; fld517.r += data[i]; fld517.g += data[i + 1]; fld517.b += data[i + 2]; }
          if (isBgPx(i)) continue;
          artPx++;
          var key = (data[i] >> 4) + ',' + (data[i + 1] >> 4) + ',' + (data[i + 2] >> 4);
          var b = buckets[key] = buckets[key] || { n: 0, r: 0, g: 0, b: 0 };
          b.n++; b.r += data[i]; b.g += data[i + 1]; b.b += data[i + 2];
          var rH = data[i] / 255, gH = data[i + 1] / 255, bH = data[i + 2] / 255;
          var mxH = Math.max(rH, gH, bH), mnH = Math.min(rH, gH, bH), dH = mxH - mnH;
          if (mxH > 0.15 && (mxH ? dH / mxH : 0) > 0.25) {
            satPx++;
            var hueD = 0;
            if (dH) {
              if (mxH === rH) hueD = ((gH - bH) / dH) % 6;
              else if (mxH === gH) hueD = (bH - rH) / dH + 2;
              else hueD = (rH - gH) / dH + 4;
              hueD *= 60; if (hueD < 0) hueD += 360;
            }
            hueBins[Math.min(23, Math.floor(hueD / 15))]++;
          }
        }
        st.artSatFrac = artPx ? satPx / artPx : 0;
        var hueUsed = 0;
        for (var hB = 0; hB < 24; hB++) if (satPx && hueBins[hB] / satPx > 0.03) hueUsed++;
        st.artHueBins = hueUsed;
        var keys = Object.keys(buckets);
        st.artColorCount = keys.length;
        /* photo signal: smooth-gradient fraction (neighbor luminance diff
           6-40) — photos are gradient-heavy, flat logos are not */
        var grads = 0, edges = 0, np2 = 0;
        for (var yy2 = 0; yy2 < h - 1; yy2++) for (var xx2 = 0; xx2 < w - 1; xx2++) {
          var o2 = (yy2 * w + xx2) * 4;
          if (data[o2 + 3] < 128) continue;
          if (isBgPx(o2)) continue; /* texture measured over the ART only */
          np2++;
          var l0 = 0.299 * data[o2] + 0.587 * data[o2 + 1] + 0.114 * data[o2 + 2];
          var oR = o2 + 4, oD = o2 + w * 4;
          var dm = Math.max(
            Math.abs(l0 - (0.299 * data[oR] + 0.587 * data[oR + 1] + 0.114 * data[oR + 2])),
            Math.abs(l0 - (0.299 * data[oD] + 0.587 * data[oD + 1] + 0.114 * data[oD + 2])));
          if (dm > 40) edges++;
          else if (dm > 6) grads++;
        }
        st.artGradFrac = np2 ? grads / np2 : 0;
        st.artEdgeFrac = np2 ? edges / np2 : 0;
        /* C516 (Justin 2026-10-26, PATCH-2120783's lacrosse logo on a metallic sheen: "if a design has a gradient like that and it has
           embroidered elements, it should always recommend print and stitch"): a smooth sweep changes too little per pixel for the
           6-40 test above, so it read as flat (grad .216). A RAMP pixel starts a 4-pixel run, right or down, where every step is small
           (<= 6, no edge crossed), the change keeps one direction and adds up to >= 8. Real uploads: median .002, p98 .06; the
           lacrosse sheen .223. The gate's gradient arm reads st.artRampFrac. */
        var n516 = 0, p516 = 0, K516 = 4;
        var L516 = function (o) { return 0.299 * data[o] + 0.587 * data[o + 1] + 0.114 * data[o + 2]; };
        var ok516 = function (o) { return data[o + 3] >= 128 && !isBgPx(o); };
        for (var y516 = 0; y516 < h - K516; y516++) for (var x516 = 0; x516 < w - K516; x516++) {
          var o516 = (y516 * w + x516) * 4;
          if (!ok516(o516) || !ok516(o516 + 4) || !ok516(o516 + w * 4) || !ok516(o516 + K516 * 4) || !ok516(o516 + K516 * w * 4)) continue;
          n516++;
          var l516 = L516(o516);
          for (var d516 = 0; d516 < 2; d516++) {
            var s516 = (d516 ? w : 1) * 4, v516 = l516, run516 = true, g516 = 0;
            for (var k516 = 1; k516 <= K516; k516++) {
              var q516 = o516 + s516 * k516; if (!ok516(q516)) { run516 = false; break; }
              var m516 = L516(q516), dd516 = m516 - v516;
              if (Math.abs(dd516) > 6) { run516 = false; break; }
              if (dd516 > 0.5) { if (g516 < 0) { run516 = false; break; } g516 = 1; } else if (dd516 < -0.5) { if (g516 > 0) { run516 = false; break; } g516 = -1; }
              v516 = m516;
            }
            if (run516 && Math.abs(v516 - l516) >= 8) { p516++; break; }
          }
        }
        st.artRampFrac = n516 ? p516 / n516 : 0;
        try { console.log('[np-e2] art metrics', { colors: st.artColorCount, gradFrac: +st.artGradFrac.toFixed(3), edgeFrac: +st.artEdgeFrac.toFixed(3), nonFlat: +(st.artGradFrac + st.artEdgeFrac).toFixed(3), artFrac: opaque ? +(artPx / opaque).toFixed(2) : 1, bgExcluded: !!bgKey, satFrac: +st.artSatFrac.toFixed(2), hueBins: st.artHueBins }); } catch (eAM) {}
        /* fine-detail signal: fraction of ink pixels ON a boundary — thin
           strokes and small text approach 1, chunky shapes stay low */
        var domKey = null, domN = 0;
        for (var kD in buckets) if (buckets[kD].n > domN) { domN = buckets[kD].n; domKey = kD; }
        var dpD = domKey ? domKey.split(',') : [15, 15, 15];
        var drD = (dpD[0] << 4) + 8, dgD = (dpD[1] << 4) + 8, dbD = (dpD[2] << 4) + 8;
        var ink = new Uint8Array(w * h), inkN = 0;
        for (var yI = 0; yI < h; yI++) for (var xI = 0; xI < w; xI++) {
          var oI = (yI * w + xI) * 4;
          if (data[oI + 3] < 128) continue;
          if (Math.abs(data[oI] - drD) + Math.abs(data[oI + 1] - dgD) + Math.abs(data[oI + 2] - dbD) > 90) { ink[yI * w + xI] = 1; inkN++; }
        }
        var bnd = 0;
        for (var yB = 0; yB < h; yB++) for (var xB = 0; xB < w; xB++) {
          if (!ink[yB * w + xB]) continue;
          if (yB === 0 || xB === 0 || yB === h - 1 || xB === w - 1 ||
              !ink[yB * w + xB - 1] || !ink[yB * w + xB + 1] || !ink[(yB - 1) * w + xB] || !ink[(yB + 1) * w + xB]) bnd++;
        }
        st.artThinFrac = inkN ? bnd / inkN : 0;
        st.artInkFrac = np2 ? inkN / np2 : 0;
        st.artBoundShare = np2 ? bnd / np2 : 0; /* boundary ink per canvas — dense linework signal */
        /* stroke-THICKNESS pass at higher resolution: an opening (erode x2,
           dilate x2) removes features thinner than ~5px at a 240px raster —
           roughly embroidery's physical minimum stitch width. Bold block
           lettering keeps its cores no matter how many letters; genuinely
           small text and hairlines vanish. (At the 96px raster above, EVERY
           letter stroke reads as thin — the Ninja Transfers false positive.) */
        try {
          var S2 = Math.round(120 * NP_JUDGE_EFF); /* C147: 120px per judged inch (was a fixed 240 = 2 in) */
          var r2 = Math.min(S2 / img.width, S2 / img.height, 4);
          var w2 = Math.max(1, Math.round(img.width * r2)), h2 = Math.max(1, Math.round(img.height * r2));
          var cvH = document.createElement('canvas'); cvH.width = w2; cvH.height = h2;
          var cxH = cvH.getContext('2d');
          cxH.drawImage(img, 0, 0, w2, h2);
          var d2 = cxH.getImageData(0, 0, w2, h2).data;
          var bk2 = {}, dom2 = null, domN2 = 0, op2 = 0;
          for (var i2b = 0; i2b < d2.length; i2b += 4) {
            if (d2[i2b + 3] < 128) continue;
            op2++;
            var k2b = (d2[i2b] >> 4) + ',' + (d2[i2b + 1] >> 4) + ',' + (d2[i2b + 2] >> 4);
            bk2[k2b] = (bk2[k2b] || 0) + 1;
            if (bk2[k2b] > domN2) { domN2 = bk2[k2b]; dom2 = k2b; }
          }
          var dp2 = dom2 ? dom2.split(',') : [15, 15, 15];
          var dr2 = (dp2[0] << 4) + 8, dg2 = (dp2[1] << 4) + 8, db2 = (dp2[2] << 4) + 8;
          var ink2 = new Uint8Array(w2 * h2), inkN2 = 0;
          for (var y2b = 0; y2b < h2; y2b++) for (var x2b = 0; x2b < w2; x2b++) {
            var o2b = (y2b * w2 + x2b) * 4;
            if (d2[o2b + 3] < 128) continue;
            if (Math.abs(d2[o2b] - dr2) + Math.abs(d2[o2b + 1] - dg2) + Math.abs(d2[o2b + 2] - db2) > 90) { ink2[y2b * w2 + x2b] = 1; inkN2++; }
          }
          /* C112 (2026-09-01, corpus 006: the "NINJA TRANSFERS" bold text
             logo false-stopped by the fine-detail gate on embroidered): on
             MONOCHROME art over TRANSPARENCY the dominant bucket IS the art,
             so this colour-vs-dominant mask degenerates to the anti-aliasing
             halo (measured live: ink = 7% of opaque, thinFrac 1.0) and bold
             block lettering reads as hairlines — the exact false positive
             this 240px pass was built to prevent; it was tuned on white-bg
             files where the mask stays sane. When the render has real
             transparency and the ink mask is a sliver of the art, measure
             stroke thickness on the ALPHA MASK (the art body) instead —
             which is what this pass was always meant to measure. Validated:
             bold transparent text tf 1.0 -> 0.01 (passes); transparent
             hairline art still reads tf 1.0 (still stops); opaque images
             take this branch never (unchanged); corpus 001-005 verdicts
             unchanged. */
          if ((w2 * h2 - op2) > (w2 * h2) * 0.05 && inkN2 < op2 * 0.1) {
            inkN2 = 0;
            for (var pA12 = 0, oA12 = 3; oA12 < d2.length; oA12 += 4, pA12++) {
              ink2[pA12] = d2[oA12] >= 128 ? 1 : 0;
              if (ink2[pA12]) inkN2++;
            }
          }
          var mA = new Uint8Array(w2 * h2), mB = new Uint8Array(w2 * h2);
          var erodeH = function (sA, dA) {
            for (var yE = 0; yE < h2; yE++) for (var xE = 0; xE < w2; xE++) {
              dA[yE * w2 + xE] = (sA[yE * w2 + xE] &&
                xE > 0 && sA[yE * w2 + xE - 1] && xE < w2 - 1 && sA[yE * w2 + xE + 1] &&
                yE > 0 && sA[(yE - 1) * w2 + xE] && yE < h2 - 1 && sA[(yE + 1) * w2 + xE]) ? 1 : 0;
            }
          };
          var dilateH = function (sA, dA) {
            for (var yD = 0; yD < h2; yD++) for (var xD = 0; xD < w2; xD++) {
              dA[yD * w2 + xD] = (sA[yD * w2 + xD] ||
                (xD > 0 && sA[yD * w2 + xD - 1]) || (xD < w2 - 1 && sA[yD * w2 + xD + 1]) ||
                (yD > 0 && sA[(yD - 1) * w2 + xD]) || (yD < h2 - 1 && sA[(yD + 1) * w2 + xD])) ? 1 : 0;
            }
          };
          erodeH(ink2, mA); erodeH(mA, mB); dilateH(mB, mA); dilateH(mA, mB);
          var thinN2 = 0;
          for (var iT2 = 0; iT2 < w2 * h2; iT2++) if (ink2[iT2] && !mB[iT2]) thinN2++;
          st.artThinInkFrac = inkN2 ? thinN2 / inkN2 : 0;
          st.artThinInkShare = op2 ? thinN2 / op2 : 0;
          try { console.log('[np-e2] detail metrics', { thinFrac: +(st.artThinInkFrac).toFixed(3), thinShare: +(st.artThinInkShare).toFixed(3), inkFrac: +(st.artInkFrac || 0).toFixed(3) }); } catch (eM) {}
        } catch (eHR) { st.artThinInkFrac = st.artThinFrac; st.artThinInkShare = st.artBoundShare; }
        /* C78 (2026-08-31) PHYSICAL DETAIL AT PATCH SIZE (Justin): judge the
           art in millimetres on a 2-inch-wide patch (height proportional),
           not in palette stats — corpus case 001 (Schultz Farm) was dense
           pictorial art whose soft rendered texture read as neither thin ink
           nor photo, so every existing gate waved it through. 480px-wide
           raster => 1px ~ 0.106mm at 2". An opening (erode xN, dilate xN)
           removes features thinner than (2N+1)px; u025/u1/u2/u4 = share of
           ink thinner than ~0.25 / 1 / 2 / 4mm (thread limits: ~1mm minimum
           satin width, ~4mm minimum legible text height). isl/tiny = distinct
           ink elements (>=4px), and those smaller than ~4mm across.
           Telemetry only reads st.artPhys; kill: window.NP_PHYS_METRICS=false. */
        try {
          if (window.NP_PHYS_METRICS !== false && st.__physSrc !== url) {
            /* C150 (Justin 2026-09-04, "whatever will keep it more honest and accurate"): the physical
               raster scales WITH the judged width — 240px per judged inch (720px at 3in) keeps the
               9.4 px/mm every millimetre rule below was tuned at; a fixed 480px had dropped to 6.3 px/mm
               at 3in and let 1.4mm taglines merge into blobs. Height cap scales the same way. */
            /* C229i: a judged width ABOVE the calibrated frame keeps the calibrated raster resolution and only rescales the millimetres —
               upsampling a small file to 240px per inch at 8-12in chained anti-alias specks into a "small text run" (a file that passes
               at 3in flagged smallText at 8in). Below the frame the raster shrinks with the width as before (conservative). */
            var NP_PHYS_IN = (typeof NP_JUDGE_OVERRIDE === 'number' && NP_JUDGE_OVERRIDE > NP_JUDGE_IN) ? NP_JUDGE_IN : NP_JUDGE_EFF;
            var rPm = Math.min(Math.round(240 * NP_PHYS_IN) / img.width, 4);
            var wPm = Math.max(1, Math.round(img.width * rPm)), hPm = Math.max(1, Math.min(Math.round(img.height * rPm), Math.round(600 * NP_PHYS_IN)));
            var mmPx = (NP_PHYS_IN * 25.4) / wPm; /* C147: millimetres per raster pixel on a NP_JUDGE_IN-wide patch (was 50.8 = 2 in). C229i: above the calibrated frame every mm window stays calibrated — only the reported text height is rescaled to the judged width below */
            var cvPm = document.createElement('canvas'); cvPm.width = wPm; cvPm.height = hPm;
            var cxPm = cvPm.getContext('2d');
            cxPm.drawImage(img, 0, 0, wPm, hPm);
            var dPm = cxPm.getImageData(0, 0, wPm, hPm).data;
            var bkPm = {}, domPm = null, domNPm = 0;
            for (var iPm = 0; iPm < dPm.length; iPm += 4) {
              if (dPm[iPm + 3] < 128) continue;
              var kPm = (dPm[iPm] >> 4) + ',' + (dPm[iPm + 1] >> 4) + ',' + (dPm[iPm + 2] >> 4);
              bkPm[kPm] = (bkPm[kPm] || 0) + 1;
              if (bkPm[kPm] > domNPm) { domNPm = bkPm[kPm]; domPm = kPm; }
            }
            if (domPm) {
              var dpPm = domPm.split(','), drPm = (dpPm[0] << 4) + 8, dgPm = (dpPm[1] << 4) + 8, dbPm = (dpPm[2] << 4) + 8;
              var inkPm = new Uint8Array(wPm * hPm), inkNPm = 0;
              for (var pPm = 0, oPm = 0; oPm < dPm.length; oPm += 4, pPm++) {
                if (dPm[oPm + 3] < 128) continue;
                if (Math.abs(dPm[oPm] - drPm) + Math.abs(dPm[oPm + 1] - dgPm) + Math.abs(dPm[oPm + 2] - dbPm) > 90) { inkPm[pPm] = 1; inkNPm++; }
              }
              if (inkNPm) {
                var erPm = function (sA, dA) {
                  for (var yE = 0; yE < hPm; yE++) for (var xE = 0; xE < wPm; xE++) {
                    dA[yE * wPm + xE] = (sA[yE * wPm + xE] &&
                      xE > 0 && sA[yE * wPm + xE - 1] && xE < wPm - 1 && sA[yE * wPm + xE + 1] &&
                      yE > 0 && sA[(yE - 1) * wPm + xE] && yE < hPm - 1 && sA[(yE + 1) * wPm + xE]) ? 1 : 0;
                  }
                };
                var diPm = function (sA, dA) {
                  for (var yD = 0; yD < hPm; yD++) for (var xD = 0; xD < wPm; xD++) {
                    dA[yD * wPm + xD] = (sA[yD * wPm + xD] ||
                      (xD > 0 && sA[yD * wPm + xD - 1]) || (xD < wPm - 1 && sA[yD * wPm + xD + 1]) ||
                      (yD > 0 && sA[(yD - 1) * wPm + xD]) || (yD < hPm - 1 && sA[(yD + 1) * wPm + xD])) ? 1 : 0;
                  }
                };
                var openSharePm = function (nOp) {
                  var aOp = new Uint8Array(inkPm), bOp = new Uint8Array(wPm * hPm), tOp, iOp;
                  for (iOp = 0; iOp < nOp; iOp++) { erPm(aOp, bOp); tOp = aOp; aOp = bOp; bOp = tOp; }
                  for (iOp = 0; iOp < nOp; iOp++) { diPm(aOp, bOp); tOp = aOp; aOp = bOp; bOp = tOp; }
                  var remOp = 0;
                  for (iOp = 0; iOp < wPm * hPm; iOp++) if (inkPm[iOp] && !aOp[iOp]) remOp++;
                  return +(remOp / inkNPm).toFixed(3);
                };
                var rForPm = function (mm) { return Math.max(1, Math.round((mm / mmPx - 1) / 2)); };
                var physPm = {
                  u025: openSharePm(rForPm(0.25)),
                  u1: openSharePm(rForPm(1)),
                  u2: openSharePm(rForPm(2)),
                  u4: openSharePm(rForPm(4)),
                  mmPx: +mmPx.toFixed(4)
                };
                /* distinct ink elements: components >=4px; tiny = bbox under ~4mm */
                var tinyPxPm = 4 / mmPx;
                var floodPm = function (maskPm, maskNPm) {
                  var lblPm = new Int32Array(wPm * hPm), islPm = 0, tinyPm = 0, tinyInkPm = 0, stkPm = [];
                  for (var cPm = 0; cPm < wPm * hPm; cPm++) {
                    if (!maskPm[cPm] || lblPm[cPm]) continue;
                    var szPm = 0, mnX = wPm, mxX = 0, mnY = hPm, mxY = 0;
                    stkPm.push(cPm); lblPm[cPm] = 1;
                    while (stkPm.length) {
                      var qPm = stkPm.pop(); szPm++;
                      var qx = qPm % wPm, qy = (qPm / wPm) | 0;
                      if (qx < mnX) mnX = qx; if (qx > mxX) mxX = qx;
                      if (qy < mnY) mnY = qy; if (qy > mxY) mxY = qy;
                      if (qx > 0 && maskPm[qPm - 1] && !lblPm[qPm - 1]) { lblPm[qPm - 1] = 1; stkPm.push(qPm - 1); }
                      if (qx < wPm - 1 && maskPm[qPm + 1] && !lblPm[qPm + 1]) { lblPm[qPm + 1] = 1; stkPm.push(qPm + 1); }
                      if (qy > 0 && maskPm[qPm - wPm] && !lblPm[qPm - wPm]) { lblPm[qPm - wPm] = 1; stkPm.push(qPm - wPm); }
                      if (qy < hPm - 1 && maskPm[qPm + wPm] && !lblPm[qPm + wPm]) { lblPm[qPm + wPm] = 1; stkPm.push(qPm + wPm); }
                    }
                    if (szPm >= 4) {
                      islPm++;
                      if (Math.max(mxX - mnX, mxY - mnY) + 1 < tinyPxPm) { tinyPm++; tinyInkPm += szPm; }
                    }
                  }
                  return { isl: islPm, tiny: tinyPm, tinyInk: tinyInkPm, share: maskNPm ? +(tinyInkPm / maskNPm).toFixed(3) : 0 };
                };
                var rawFlPm = floodPm(inkPm, inkNPm);
                physPm.isl = rawFlPm.isl; physPm.tiny = rawFlPm.tiny;
                /* C84 (2026-08-31) SCATTER MASK (corpus 002, the Regal badge):
                   when the art sits on a solid field (white around an oval
                   badge) that field wins the dominant vote above, and inkPm
                   degenerates to the design SILHOUETTE — internal line detail
                   becomes invisible (002 measured 2 islands, u1 .007 on the
                   raw mask). Rebuild the mask with the border-ring-dominant
                   background EXCLUDED (same >50% ring rule + 15% floor as
                   analyzeArtwork), pick the dominant bucket from the ART, and
                   measure fts = share of ink in TINY scattered elements
                   (< ~4mm across at 2in): circuit dots, waveform ticks,
                   sub-legible lettering. Text-safe: bold letters are rarely
                   under 4mm across (bold-logo control measured .012; 002
                   measured .188; gate fires at .08). */
                var ringPm = {}, ringTotPm = 0;
                var ringAddPm = function (oR) { if (dPm[oR + 3] >= 128) { var kR = (dPm[oR] >> 4) + ',' + (dPm[oR + 1] >> 4) + ',' + (dPm[oR + 2] >> 4); ringPm[kR] = (ringPm[kR] || 0) + 1; ringTotPm++; } };
                for (var xR2 = 0; xR2 < wPm; xR2++) { ringAddPm(xR2 * 4); ringAddPm(((hPm - 1) * wPm + xR2) * 4); }
                for (var yR2 = 0; yR2 < hPm; yR2++) { ringAddPm((yR2 * wPm) * 4); ringAddPm((yR2 * wPm + wPm - 1) * 4); }
                var bgKPm = null, bgMxPm = 0;
                for (var kR3 in ringPm) { if (ringPm[kR3] > bgMxPm) { bgMxPm = ringPm[kR3]; bgKPm = kR3; } }
                if (!(ringTotPm && bgMxPm / ringTotPm > 0.5)) bgKPm = null;
                var bgPPm = bgKPm ? bgKPm.split(',') : null;
                var isBgPm = function (oB) {
                  if (!bgPPm) return false;
                  return Math.abs((dPm[oB] >> 4) - bgPPm[0]) <= 1 &&
                         Math.abs((dPm[oB + 1] >> 4) - bgPPm[1]) <= 1 &&
                         Math.abs((dPm[oB + 2] >> 4) - bgPPm[2]) <= 1;
                };
                if (bgPPm) { /* exclusion floor: never let the exclusion eat the art */
                  var keepPm = 0, totKPm = 0;
                  for (var iK = 0; iK < dPm.length; iK += 4) {
                    if (dPm[iK + 3] < 128) continue; totKPm++;
                    if (!isBgPm(iK)) keepPm++;
                  }
                  if (!keepPm || keepPm / Math.max(1, totKPm) < 0.15) bgPPm = null;
                }
                if (bgPPm) {
                  var bkF = {}, domF = null, domNF = 0;
                  for (var iD2 = 0; iD2 < dPm.length; iD2 += 4) {
                    if (dPm[iD2 + 3] < 128 || isBgPm(iD2)) continue;
                    var kF = (dPm[iD2] >> 4) + ',' + (dPm[iD2 + 1] >> 4) + ',' + (dPm[iD2 + 2] >> 4);
                    bkF[kF] = (bkF[kF] || 0) + 1;
                    if (bkF[kF] > domNF) { domNF = bkF[kF]; domF = kF; }
                  }
                  physPm.fts = 0; physPm.fTiny = 0;
                  if (domF) {
                    var dpF = domF.split(','), drF = (dpF[0] << 4) + 8, dgF = (dpF[1] << 4) + 8, dbF = (dpF[2] << 4) + 8;
                    var inkF = new Uint8Array(wPm * hPm), inkNF = 0;
                    for (var pF = 0, oF = 0; oF < dPm.length; oF += 4, pF++) {
                      if (dPm[oF + 3] < 128 || isBgPm(oF)) continue;
                      if (Math.abs(dPm[oF] - drF) + Math.abs(dPm[oF + 1] - dgF) + Math.abs(dPm[oF + 2] - dbF) > 90) { inkF[pF] = 1; inkNF++; }
                    }
                    physPm.inkShare = keepPm ? +(inkNF / keepPm).toFixed(3) : 0;
                    /* C96 (2026-09-01) INK-MASS FLOOR — see the else branch */
                    if (inkNF && inkNF >= keepPm * 0.1) {
                      var fFlPm = floodPm(inkF, inkNF);
                      physPm.fts = fFlPm.share;
                      physPm.fTiny = fFlPm.tiny;
                    }
                  }
                } else {
                  /* no solid field behind the art: the raw mask already IS the
                     internal-detail mask */
                  /* C96 (2026-09-01) INK-MASS FLOOR (corpus 005: Nunzi's
                     Advertising, a black vector PDF, false-stopped on the
                     silicone PDP): on near-monochrome art the non-dominant
                     "ink" is only the anti-aliasing halo — measured on the
                     live render: 443 ink px vs 17,919 opaque (2.5%), sat 0,
                     colors 33, fts .516 — a meaningless denominator that
                     reads as scattered tiny elements. The scatter ratio only
                     means anything when the ink is a real mass of the art:
                     require ink >= 10% of the mask's pixel base, else the
                     gate-facing fts is 0. Corpus margins: Regal (the case
                     that NEEDS the scatter arm) inkShare .493; all must-stop
                     cases .49-.86; halo cases ~.025. Applied to BOTH mask
                     branches. */
                  var opRawPm = 0;
                  for (var iOr = 3; iOr < dPm.length; iOr += 4) if (dPm[iOr] >= 128) opRawPm++;
                  physPm.inkShare = opRawPm ? +(inkNPm / opRawPm).toFixed(3) : 0;
                  if (inkNPm >= opRawPm * 0.1) {
                    physPm.fts = rawFlPm.share;
                    physPm.fTiny = rawFlPm.tiny;
                  } else {
                    physPm.fts = 0;
                    physPm.fTiny = rawFlPm.tiny;
                  }
                }
                /* C129 (2026-09-02, corpus 009: Stormy Shores, order 2108767,
                   sheet row 7 — expected Print & Stitch): SMALL-TEXT RUN.
                   "PHOTOGRAPHY" at ~1.7mm cap height on a filled band was
                   invisible to fineDetailLikely: the thin-ink share is diluted
                   by the big fills (ts .041 < .05) and the 2-hue vivid class
                   exempts it anyway. Physical read instead: local-contrast
                   components (|lum - 1.6mm box mean| > 45) of glyph size
                   (0.7-3.5mm tall, width <= 2.2x height, not a solid dot) that
                   CONTRAST with their wider surround (ring test at 2x height:
                   letter counters and inter-letter gaps match the ground and
                   drop out), chained into same-polarity runs (centre distance
                   < 2.5x height, heights within 0.55-1.8x). txtRun = longest
                   run, txtH = its median glyph height in mm. Validated on 18
                   synthetic controls (5mm caps with counters, serif, outlined
                   text, dotted ring, star row, icon grid...) -> max run 2;
                   1mm tagline 14, 2.9mm caps 9, light-on-dark 16, Stormy 11 @
                   1.69mm; both pass-corpus files <= 1. */
                try {
                  var NTx = wPm * hPm, LTx = new Float32Array(NTx), ATx = new Uint8Array(NTx);
                  for (var iTx = 0; iTx < NTx; iTx++) { var oTx = iTx * 4; if (dPm[oTx + 3] >= 128) { ATx[iTx] = 1; LTx[iTx] = 0.299 * dPm[oTx] + 0.587 * dPm[oTx + 1] + 0.114 * dPm[oTx + 2]; } }
                  var RTx = Math.max(2, Math.round(1.6 / mmPx)), W1Tx = wPm + 1;
                  var SLTx = new Float64Array(W1Tx * (hPm + 1)), SATx = new Float64Array(W1Tx * (hPm + 1));
                  for (var yTx = 0; yTx < hPm; yTx++) { var rlTx = 0, raTx = 0; for (var xTx = 0; xTx < wPm; xTx++) { var i2Tx = yTx * wPm + xTx; rlTx += LTx[i2Tx]; raTx += ATx[i2Tx]; SLTx[(yTx + 1) * W1Tx + xTx + 1] = SLTx[yTx * W1Tx + xTx + 1] + rlTx; SATx[(yTx + 1) * W1Tx + xTx + 1] = SATx[yTx * W1Tx + xTx + 1] + raTx; } }
                  var polTx = new Uint8Array(NTx);
                  for (var y2Tx = 0; y2Tx < hPm; y2Tx++) for (var x2Tx = 0; x2Tx < wPm; x2Tx++) {
                    var i3Tx = y2Tx * wPm + x2Tx; if (!ATx[i3Tx]) continue;
                    var x0Tx = Math.max(0, x2Tx - RTx), x1Tx = Math.min(wPm - 1, x2Tx + RTx), y0Tx = Math.max(0, y2Tx - RTx), y1Tx = Math.min(hPm - 1, y2Tx + RTx);
                    var saTx = SATx[(y1Tx + 1) * W1Tx + x1Tx + 1] - SATx[y0Tx * W1Tx + x1Tx + 1] - SATx[(y1Tx + 1) * W1Tx + x0Tx] + SATx[y0Tx * W1Tx + x0Tx];
                    if (saTx < 1) continue;
                    var slTx = SLTx[(y1Tx + 1) * W1Tx + x1Tx + 1] - SLTx[y0Tx * W1Tx + x1Tx + 1] - SLTx[(y1Tx + 1) * W1Tx + x0Tx] + SLTx[y0Tx * W1Tx + x0Tx];
                    var dfTx = LTx[i3Tx] - slTx / saTx;
                    if (dfTx < -45) polTx[i3Tx] = 1; else if (dfTx > 45) polTx[i3Tx] = 2;
                  }
                  var lblTx = new Int32Array(NTx), nTx = 0, stkTx = [], boxTx = [];
                  var rMnTx = new Int32Array(hPm).fill(1e9), rMxTx = new Int32Array(hPm).fill(-1), rTchTx = []; /* C429: per-row extents -> convex hull */
                  for (var sTx = 0; sTx < NTx; sTx++) {
                    if (!polTx[sTx] || lblTx[sTx]) continue; nTx++;
                    var PTx = polTx[sTx], mnXTx = wPm, mxXTx = 0, mnYTx = hPm, mxYTx = 0, szTx = 0, smLTx = 0, smCTx = 0; stkTx.push(sTx); lblTx[sTx] = nTx;
                    while (stkTx.length) { var pTx = stkTx.pop(); szTx++; smLTx += LTx[pTx]; var pxTx = pTx % wPm, pyTx = (pTx / wPm) | 0;
                      var ocTx = pTx * 4; smCTx += Math.max(dPm[ocTx], dPm[ocTx + 1], dPm[ocTx + 2]) - Math.min(dPm[ocTx], dPm[ocTx + 1], dPm[ocTx + 2]);
                      if (rMxTx[pyTx] < 0) rTchTx.push(pyTx); if (pxTx < rMnTx[pyTx]) rMnTx[pyTx] = pxTx; if (pxTx > rMxTx[pyTx]) rMxTx[pyTx] = pxTx;
                      if (pxTx < mnXTx) mnXTx = pxTx; if (pxTx > mxXTx) mxXTx = pxTx; if (pyTx < mnYTx) mnYTx = pyTx; if (pyTx > mxYTx) mxYTx = pyTx;
                      if (pxTx > 0 && polTx[pTx - 1] === PTx && !lblTx[pTx - 1]) { lblTx[pTx - 1] = nTx; stkTx.push(pTx - 1); }
                      if (pxTx < wPm - 1 && polTx[pTx + 1] === PTx && !lblTx[pTx + 1]) { lblTx[pTx + 1] = nTx; stkTx.push(pTx + 1); }
                      if (pyTx > 0 && polTx[pTx - wPm] === PTx && !lblTx[pTx - wPm]) { lblTx[pTx - wPm] = nTx; stkTx.push(pTx - wPm); }
                      if (pyTx < hPm - 1 && polTx[pTx + wPm] === PTx && !lblTx[pTx + wPm]) { lblTx[pTx + wPm] = nTx; stkTx.push(pTx + wPm); } }
                    /* C429 (PATCH-2116084, 2026-09-28): SOLIDITY = filled pixels / convex-hull area. Letters bend, branch or
                       ring a counter (T H P R O ~0.4-0.75); teeth, checker squares and dots are convex blobs (>= 0.8). */
                    var hpTx = [];
                    rTchTx.sort(function (a8, b8) { return a8 - b8; });
                    for (var rq = 0; rq < rTchTx.length; rq++) { var yq = rTchTx[rq]; hpTx.push([rMnTx[yq], yq], [rMxTx[yq] + 1, yq], [rMnTx[yq], yq + 1], [rMxTx[yq] + 1, yq + 1]); rMnTx[yq] = 1e9; rMxTx[yq] = -1; }
                    rTchTx.length = 0;
                    hpTx.sort(function (a8, b8) { return a8[0] - b8[0] || a8[1] - b8[1]; });
                    var crTx = function (o8, a8, b8) { return (a8[0] - o8[0]) * (b8[1] - o8[1]) - (a8[1] - o8[1]) * (b8[0] - o8[0]); }, loTx = [], upTx = [];
                    for (var hq = 0; hq < hpTx.length; hq++) { while (loTx.length >= 2 && crTx(loTx[loTx.length - 2], loTx[loTx.length - 1], hpTx[hq]) <= 0) loTx.pop(); loTx.push(hpTx[hq]); }
                    for (var hq2 = hpTx.length - 1; hq2 >= 0; hq2--) { while (upTx.length >= 2 && crTx(upTx[upTx.length - 2], upTx[upTx.length - 1], hpTx[hq2]) <= 0) upTx.pop(); upTx.push(hpTx[hq2]); }
                    var hlTx = loTx.slice(0, -1).concat(upTx.slice(0, -1)), haTx = 0;
                    for (var hk = 0; hk < hlTx.length; hk++) { var pa8 = hlTx[hk], pb8 = hlTx[(hk + 1) % hlTx.length]; haTx += pa8[0] * pb8[1] - pb8[0] * pa8[1]; }
                    haTx = Math.abs(haTx) / 2;
                    boxTx.push({ P: PTx, x0: mnXTx, x1: mxXTx, y0: mnYTx, y1: mxYTx, w: mxXTx - mnXTx + 1, h: mxYTx - mnYTx + 1, size: szTx, meanL: smLTx / szTx, chroma: smCTx / szTx, sol: haTx > 0 ? szTx / haTx : 1 });
                  }
                  /* C429 (PATCH-2116084 line 2, 2026-09-28): FAKE TRANSPARENCY. A JPEG saved from a transparent PNG's preview
                     carries the grey/white checkerboard as pixels; along the edge the local-contrast pass cuts its cells
                     into narrow slivers that dodge the solid-dot test and chain into a fake 19-glyph run. Find the lattice
                     on the raster's outer frame (two neutral light tones alternating at a steady cell size, >= 80%
                     parity agreement) and drop candidates that ARE a cell of it. */
                  var ckTx = null;
                  try {
                    var FRTx = 3, fbTx = [], fnTx = 0;
                    var ckCls = function (x8, y8, mid8) {
                      var i8 = y8 * wPm + x8, o8 = i8 * 4; if (dPm[o8 + 3] < 128) return -1;
                      var mx8 = Math.max(dPm[o8], dPm[o8 + 1], dPm[o8 + 2]), mn8 = Math.min(dPm[o8], dPm[o8 + 1], dPm[o8 + 2]);
                      if (mx8 - mn8 > 16 || LTx[i8] < 140) return -1;
                      return mid8 === undefined ? LTx[i8] : (LTx[i8] > mid8 ? 1 : 0);
                    };
                    for (var fyTx = 0; fyTx < hPm; fyTx++) for (var fxTx = 0; fxTx < wPm; fxTx++) {
                      if (fxTx >= FRTx && fxTx < wPm - FRTx && fyTx >= FRTx && fyTx < hPm - FRTx) { fxTx = wPm - FRTx - 1; continue; }
                      if (dPm[(fyTx * wPm + fxTx) * 4 + 3] < 128) continue; fnTx++;
                      var fLTx = ckCls(fxTx, fyTx); if (fLTx >= 150) fbTx.push(fLTx);
                    }
                    if (fbTx.length >= 60 && fbTx.length >= 0.6 * fnTx) {
                      var k1Tx = 0, k2Tx = 255, n1Tx = 0;
                      for (var kzTx = 0; kzTx < fbTx.length; kzTx++) { if (fbTx[kzTx] > k1Tx) k1Tx = fbTx[kzTx]; if (fbTx[kzTx] < k2Tx) k2Tx = fbTx[kzTx]; }
                      for (var kiTx = 0; kiTx < 8; kiTx++) {
                        var s1Tx = 0, s2Tx = 0, c1Tx = 0, c2Tx = 0;
                        for (var kjTx = 0; kjTx < fbTx.length; kjTx++) { if (Math.abs(fbTx[kjTx] - k1Tx) <= Math.abs(fbTx[kjTx] - k2Tx)) { s1Tx += fbTx[kjTx]; c1Tx++; } else { s2Tx += fbTx[kjTx]; c2Tx++; } }
                        if (c1Tx) k1Tx = s1Tx / c1Tx; if (c2Tx) k2Tx = s2Tx / c2Tx; n1Tx = c1Tx;
                      }
                      var mfTx = n1Tx / fbTx.length;
                      if (k1Tx - k2Tx >= 10 && k1Tx - k2Tx <= 110 && mfTx >= 0.25 && mfTx <= 0.75) {
                        var midTx = (k1Tx + k2Tx) / 2, spTx = [], phXTx = [], phYTx = [];
                        var ckLines = [[1, 0], [hPm - 2, 0], [1, 1], [wPm - 2, 1]];
                        for (var lnI = 0; lnI < ckLines.length; lnI++) {
                          var fixTx = ckLines[lnI][0], vrtTx = ckLines[lnI][1], lenTx = vrtTx ? hPm : wPm, prvTx = -2, lstTx = -1;
                          for (var qTx = 0; qTx < lenTx; qTx++) {
                            var cqTx = vrtTx ? ckCls(fixTx, qTx, midTx) : ckCls(qTx, fixTx, midTx);
                            if (cqTx < 0) { prvTx = -2; lstTx = -1; continue; }
                            if (prvTx >= 0 && cqTx !== prvTx) { if (lstTx >= 0) spTx.push(qTx - lstTx); (vrtTx ? phYTx : phXTx).push(qTx); lstTx = qTx; }
                            prvTx = cqTx;
                          }
                        }
                        if (spTx.length >= 8) {
                          var sSTx = spTx.slice().sort(function (a8, b8) { return a8 - b8; }), sMdTx = sSTx[sSTx.length >> 1];
                          var nrTx = spTx.filter(function (v8) { return Math.abs(v8 - sMdTx) <= Math.max(1, 0.3 * sMdTx); });
                          if (sMdTx >= 3 && sMdTx <= Math.min(wPm, hPm) / 4 && nrTx.length >= 0.7 * spTx.length) {
                            var cellTx = nrTx.reduce(function (a8, b8) { return a8 + b8; }, 0) / nrTx.length;
                            var phTx = function (arr8) { var cs8 = 0, sn8 = 0; for (var z8 = 0; z8 < arr8.length; z8++) { var an8 = 2 * Math.PI * arr8[z8] / cellTx; cs8 += Math.cos(an8); sn8 += Math.sin(an8); } var p8 = Math.atan2(sn8, cs8) / (2 * Math.PI) * cellTx; return p8 < 0 ? p8 + cellTx : p8; };
                            var oxTx = phXTx.length ? phTx(phXTx) : 0, oyTx = phYTx.length ? phTx(phYTx) : 0;
                            var prTx = function (x8, y8) { return (Math.floor((x8 - oxTx) / cellTx) + Math.floor((y8 - oyTx) / cellTx)) & 1; };
                            var agSame = 0, agFlip = 0, stY = Math.max(1, (hPm / 60) | 0), stX = Math.max(1, (wPm / 60) | 0);
                            for (var ay8 = 1; ay8 < hPm - 1; ay8 += stY) for (var ex8 = 0; ex8 < 2; ex8++) { var ax8 = ex8 ? wPm - 2 : 1, ca8 = ckCls(ax8, ay8, midTx); if (ca8 < 0) continue; if (ca8 === prTx(ax8, ay8)) agSame++; else agFlip++; }
                            for (var bx8 = 1; bx8 < wPm - 1; bx8 += stX) for (var ey8 = 0; ey8 < 2; ey8++) { var by8 = ey8 ? hPm - 2 : 1, cb8 = ckCls(bx8, by8, midTx); if (cb8 < 0) continue; if (cb8 === prTx(bx8, by8)) agSame++; else agFlip++; }
                            var nAg8 = agSame + agFlip;
                            if (nAg8 >= 40 && Math.max(agSame, agFlip) / nAg8 >= 0.8) ckTx = { s: cellTx, p0: agFlip > agSame ? 1 : 0, t1: k1Tx, t2: k2Tx, pred: prTx };
                          }
                        }
                      }
                    }
                  } catch (eCk) { ckTx = null; }
                  physPm.ckCell = ckTx ? +(ckTx.s * mmPx).toFixed(2) : 0; /* C429: fake-transparency cell size in mm, 0 = none */
                  var minHTx = 0.7 / mmPx, maxHTx = 3.5 / mmPx, glTx = [];
                  for (var cTx = 0; cTx < boxTx.length; cTx++) {
                    var BTx = boxTx[cTx], fillTx = BTx.size / (BTx.w * BTx.h);
                    if (!(BTx.h >= minHTx && BTx.h <= maxHTx && BTx.w <= BTx.h * 2.2 && BTx.w >= 2 && BTx.size >= 4 && fillTx >= 0.12)) continue;
                    if (fillTx >= 0.7 && BTx.w / BTx.h > 0.75 && BTx.w / BTx.h < 1.33) continue; /* solid dot, not a glyph */
                    if (ckTx && BTx.chroma <= 18 && BTx.w <= ckTx.s * 1.3 + 1 && BTx.h <= ckTx.s * 1.3 + 1 &&
                        Math.abs(BTx.meanL - ((ckTx.pred((BTx.x0 + BTx.x1) / 2, (BTx.y0 + BTx.y1) / 2) ^ ckTx.p0) ? ckTx.t1 : ckTx.t2)) <= 28) continue; /* C429: a fake-transparency cell */
                    var bcxTx = (BTx.x0 + BTx.x1) / 2, bcyTx = (BTx.y0 + BTx.y1) / 2, rrTx = 2 * BTx.h, matchTx = 0, validTx = 0, drkTx = 0, lgtTx = 0, nulTx = 0;
                    for (var tTx = 0; tTx < 16; tTx++) { var angTx = tTx * Math.PI / 8, sxTx = Math.round(bcxTx + rrTx * Math.cos(angTx)), syTx = Math.round(bcyTx + rrTx * Math.sin(angTx)); if (sxTx < 0 || syTx < 0 || sxTx >= wPm || syTx >= hPm) continue; if (!ATx[syTx * wPm + sxTx]) { nulTx++; continue; } validTx++; var dLTx = LTx[syTx * wPm + sxTx] - BTx.meanL; if (Math.abs(dLTx) < 45) matchTx++; else if (dLTx < 0) drkTx++; else lgtTx++; }
                    if (validTx >= 6 && matchTx / validTx >= 0.6) continue; /* counter or gap: it IS the ground */
                    /* C150 (2026-09-04): an ANTI-ALIASING FRINGE is not a letter. The honest 240px-per-inch
                       raster resolves the soft grey edges of big letters into thin (<= 0.45x height), ragged
                       (fill < 0.8) mid-tone components whose ring is the letter on one side and the ground -
                       or nothing at all, on a transparent upload - on the other (151 of them on the Ninja
                       Transfers logo, chaining into a fake 11-glyph run). A real glyph has ONE ground all the
                       way round; a solid thin letter (I, l, 1) is protected by its fill. */
                    var totTx = validTx + nulTx, sidesTx = [drkTx, lgtTx, nulTx].sort(function (p4Tx, q4Tx) { return q4Tx - p4Tx; });
                    if (totTx >= 8 && sidesTx[1] / totTx >= 0.25 && BTx.w <= BTx.h * 0.45 && fillTx < 0.8) continue;
                    glTx.push({ cx: bcxTx, cy: bcyTx, h: BTx.h, pol: BTx.P, sol: BTx.sol });
                  }
                  var GTx = glTx.length, clTx = new Int32Array(GTx), bestTx = 0, bestHTx = [];
                  for (var aTx = 0; aTx < GTx; aTx++) {
                    if (clTx[aTx]) continue; var memTx = [aTx]; clTx[aTx] = 1; var st2Tx = [aTx];
                    while (st2Tx.length) { var uTx = st2Tx.pop(); for (var bTx = 0; bTx < GTx; bTx++) { if (clTx[bTx]) continue; var gaTx = glTx[uTx], gbTx = glTx[bTx]; if (gaTx.pol !== gbTx.pol) continue; var mhTx = Math.max(gaTx.h, gbTx.h), dxTx = gaTx.cx - gbTx.cx, dyTx = gaTx.cy - gbTx.cy, rtTx = gaTx.h / gbTx.h; if (dxTx * dxTx + dyTx * dyTx < 6.25 * mhTx * mhTx && rtTx > 0.55 && rtTx < 1.8) { clTx[bTx] = 1; memTx.push(bTx); st2Tx.push(bTx); } } }
                    /* C429 (PATCH-2116084 line 1): a wolverine's row of white teeth chained into a 12-glyph "text" run — every member a convex
                       triangle. A run that is mostly convex blobs keeps only its letter-like members (solidity < 0.8); real lettering is
                       mostly letter-like and keeps its full count (1mm tagline 14 of 15, light-on-dark 13 of 16, Schultz 12 of 12). */
                    var letTx = memTx.filter(function (ixTx) { return glTx[ixTx].sol < 0.8; }), effTx = (letTx.length * 2 >= memTx.length) ? memTx : letTx;
                    if (effTx.length > bestTx) { bestTx = effTx.length; bestHTx = effTx.map(function (ixTx) { return glTx[ixTx].h; }).sort(function (p3Tx, q3Tx) { return p3Tx - q3Tx; }); }
                  }
                  physPm.txtRun = bestTx;
                  physPm.txtH = bestHTx.length ? +(bestHTx[bestHTx.length >> 1] * mmPx).toFixed(2) : 0;
                } catch (eTx) { physPm.txtRun = 0; physPm.txtH = 0; }
                if (NP_PHYS_IN !== NP_JUDGE_EFF && physPm.txtH > 0) physPm.txtH = +(physPm.txtH * NP_JUDGE_EFF / NP_PHYS_IN).toFixed(2); /* C229i: lettering measured at the calibrated frame, reported at the judged width — bigger patch, taller letters */
                physPm.judgeIn = +NP_JUDGE_EFF.toFixed(2); /* C155: tells the verdict which frame was judged */
                st.artPhys = physPm; st.__physSrc = url;
                try { console.log('[np-e2] phys metrics (' + NP_JUDGE_EFF.toFixed(2) + 'in)', physPm); } catch (ePLg) {}
                try {
                  var recPm = { t: Date.now(), u: (url.split('?')[0].split('/').pop() || '').slice(-48),
                    m: { colors: st.artColorCount, grad: +(st.artGradFrac || 0).toFixed(3), edge: +(st.artEdgeFrac || 0).toFixed(3),
                         sat: +(st.artSatFrac || 0).toFixed(2), hues: st.artHueBins,
                         tf: +(st.artThinInkFrac || 0).toFixed(3), ts: +(st.artThinInkShare || 0).toFixed(3) },
                    ph: physPm };
                  var ringPm = JSON.parse(localStorage.getItem('np_art_metrics') || '[]');
                  if (!(ringPm instanceof Array)) ringPm = [];
                  ringPm.push(recPm);
                  if (ringPm.length > 40) ringPm = ringPm.slice(-40);
                  localStorage.setItem('np_art_metrics', JSON.stringify(ringPm));
                } catch (eRng) {}
              }
            }
          }
        } catch (ePhy) {}
        st.__artAnalyzed = true;
        var mean517 = function (q) { return [q.r / q.n, q.g / q.n, q.b / q.n]; };
        var cand517 = Object.keys(pBk517).filter(function (k) { return pBk517[k].n / Math.max(1, opaque) >= 0.005; });
        var solid517 = cand517.filter(function (k) { return pBk517[k].nb < 0.6 * pBk517[k].n; }).map(function (k) { return mean517(pBk517[k]); });
        var fldC517 = (!clear517 && fld517.n) ? mean517(fld517) : null;
        var seg517 = function (c, a, b) { /* c on the segment a -> b (not at either end), within 30 */
          var e0 = b[0] - a[0], e1 = b[1] - a[1], e2 = b[2] - a[2], ee = e0 * e0 + e1 * e1 + e2 * e2; if (ee < 1) return false;
          var t = ((c[0] - a[0]) * e0 + (c[1] - a[1]) * e1 + (c[2] - a[2]) * e2) / ee; if (t < 0.08 || t > 0.92) return false;
          return Math.abs(c[0] - a[0] - t * e0) + Math.abs(c[1] - a[1] - t * e1) + Math.abs(c[2] - a[2] - t * e2) <= 30;
        };
        var expl517 = function (c) {
          for (var s = 0; s < solid517.length; s++) {
            var K = solid517[s];
            for (var s2 = s + 1; s2 < solid517.length; s2++) if (seg517(c, K, solid517[s2])) return true;
            if (fldC517 && seg517(c, K, fldC517)) return true;
            for (var tq = 0.08; tq <= 0.921; tq += 0.02) { /* K faded toward some grey level */
              var gq = Math.max(0, Math.min(255, ((c[0] - (1 - tq) * K[0]) + (c[1] - (1 - tq) * K[1]) + (c[2] - (1 - tq) * K[2])) / (3 * tq)));
              if (Math.abs(c[0] - (1 - tq) * K[0] - tq * gq) + Math.abs(c[1] - (1 - tq) * K[1] - tq * gq) + Math.abs(c[2] - (1 - tq) * K[2] - tq * gq) <= 30) return true;
            }
          }
          return false;
        };
        var pal517 = solid517.length ? cand517.filter(function (k) { var q = pBk517[k]; return q.nb < 0.6 * q.n || !expl517(mean517(q)); }) : []; /* nothing solid (an all-edge sketch) = the old palette */
        var fldHex517 = '';
        if (pal517.length && fldC517 && fld517.n / Math.max(1, opaque) >= 0.005) {
          var fq517 = fldC517.map(Math.round);
          if (Math.max(fq517[0], fq517[1], fq517[2]) - Math.min(fq517[0], fq517[1], fq517[2]) >= 24 || 0.299 * fq517[0] + 0.587 * fq517[1] + 0.114 * fq517[2] <= 80) fldHex517 = ('#' + fq517.map(function (v) { return ('0' + v.toString(16)).slice(-2); }).join('')).toUpperCase();
        }
        var palB517 = pal517.length ? pBk517 : buckets;
        var top = (pal517.length ? pal517 : Object.keys(buckets)).map(function (k) { return palB517[k]; })
          .sort(function (a, b) { return b.n - a.n; })
          .filter(function (b) { return b.n / Math.max(1, opaque) >= 0.005; })
          .slice(0, 24)
          .map(function (b) {
            function hx(v) { return ('0' + Math.round(v / b.n).toString(16)).slice(-2); }
            return ('#' + hx(b.r) + hx(b.g) + hx(b.b)).toUpperCase();
          });
        if (fldHex517 && top.indexOf(fldHex517) < 0) top.push(fldHex517); /* C517: a solid dark or coloured field, after the art colours */
        /* drop near-duplicates */
        var out = [];
        top.forEach(function (hex) {
          var rr = parseInt(hex.slice(1, 3), 16), gg = parseInt(hex.slice(3, 5), 16), bb = parseInt(hex.slice(5, 7), 16);
          var chN = Math.max(rr, gg, bb) - Math.min(rr, gg, bb);
          var dupe = out.some(function (o) {
            var orr = parseInt(o.slice(1, 3), 16), ogg = parseInt(o.slice(3, 5), 16), obb = parseInt(o.slice(5, 7), 16);
            var oCh = Math.max(orr, ogg, obb) - Math.min(orr, ogg, obb);
            if (chN < 28 && oCh < 28) {
              /* both near-neutral: greys collapse HARD — a mono design is
                 white / grey / black, not eight barely-different PMS greys */
              var lN = 0.299 * rr + 0.587 * gg + 0.114 * bb;
              var lO = 0.299 * orr + 0.587 * ogg + 0.114 * obb;
              return Math.abs(lN - lO) < 72;
            }
            return Math.abs(rr - orr) + Math.abs(gg - ogg) + Math.abs(bb - obb) < 36;
          });
          if (!dupe) out.push(hex);
        });
        var seenNm = {};
        st.artColors = out.filter(function (hx2) {
          var nm2 = pmsName(hx2);
          if (seenNm[nm2]) return false;
          seenNm[nm2] = 1;
          return true;
        }).slice(0, 8);
      } catch (e) { console.warn('[np-emb2] artwork analysis failed', e); }
    };
    /* a CORS/404 failure used to be SILENT: onload never fired, __artAnalyzed
       (set inside onload) stayed false, and the palette stayed empty forever
       with no signal anywhere. Mark it analysed so the proof gate cannot hang
       waiting, and say so in the console. */
    img.onerror = function () {
      st.__artAnalyzed = true;
      console.warn('[np-emb2] artwork analysis: image failed to load (CORS or 404) — no detected colours');
    };
    img.src = url;
  }

  function photoGateOn() {
    /* photographs are producible ONLY by full-color printing — every other
       material (embroidery, chenille, leather, PVC, silicone, flex, woven…)
       stops the generate and converts. Typed products have no upload. */
    if (PTYPE.noArt) return false;
    return !/^(fullcolor-2-0|fullcolor-flex-2-0|print-and-stitch-2-0)$/.test(TYPE_KEY);
  }
  function fullColorLikely(line) {
    /* prefer the backend's confidence/feedback when Ninja Force exposes it */
    if (line && typeof line.confidence === 'number') return line.confidence < 0.5;
    if (line && line.feedback && /full.?color|photo/i.test(String(line.feedback))) return true;
    /* client heuristic: ONLY photo-real art (thousands of distinct colors)
       — flat logos with a few gradients must NOT trigger the banner */
    /* PHOTO vs ILLUSTRATION (Justin 2026-08-21): the separator is gradient
       DOMINANCE. Photos are smooth-gradient heavy with few hard edges (beach
       portraits quantize to only a few hundred colors, so color count alone
       under-detects); illustrations (shaded mascots, cel art) carry strong
       outlines, so their edge fraction rivals or beats their gradients. */
    var gfP = st.artGradFrac || 0, efP = st.artEdgeFrac || 0;
    /* PAINTERLY/RENDERED LOGOS (Justin 2026-08-22, Elemental Clean Slate) —
       thresholds MEASURED with the background excluded, 96px analysis:
         painterly (white bg): 377 colors, nonFlat .99
         painterly (BLACK bg): 438 colors, nonFlat .67   <- the Elemental case
         painterly badge:      445 colors, nonFlat .96
         true photo:           613 colors, nonFlat .64
         cel mascot:           169 colors, nonFlat .67   <- colors separates it
         flat 2-tone logo:      29 colors, nonFlat .21
       nonFlat alone cannot separate cel art from painterly once the bg is
       excluded — ART-ONLY COLOR RICHNESS is the separator, nonFlat is the
       floor that spares flat-but-multicolour designs. */
    /* floor at .35, not .55: real painterly logos contain CALM interior
       fields (whitewashed planks, paper textures) that pull art-only nonFlat
       toward ~.4-.5, while the measured cel mascot sits at .67 — nonFlat
       cannot rank these classes. ART-COLOR RICHNESS separates (169 cel vs
       377-613 painterly/photo); the floor only excludes flat 2-tone art (.21). */
    /* FINAL gates measured on Justin's REAL Elemental file (2026-08-22):
         his file:    254 colors, nonFlat .745  <- must trigger
         cel mascot:  169 colors, nonFlat .667  <- must NOT
       (muted painterly palettes quantize ~30% tighter than vivid ones;
        dominant-fill share does NOT separate these classes.) The gate sits
        between them with ~20% margin each way. */
    /* VIVID SPOT-COLOR EXEMPTION (Justin 2026-08-24, the "Revelators" AI
       patch render): thread-texture renders inflate colors (measured 649)
       and nonFlat (.99), tripping this gate — but the art is a thread
       palette and embroiders perfectly. Measured with bg excluded:
         Revelators render: satFrac .72, hueBins 6  <- must NOT stop
         Elemental logo:    satFrac .14, hueBins 7  <- must stop
         A-NIGHT render:    satFrac .03, hueBins 2  <- stops via fine detail
       Muted painterly and photographic art stays well under .5 saturated. */
    var vividSpot = (st.artSatFrac || 0) > 0.5 && (st.artHueBins || 99) <= 8;
    if (st.artColorCount > 210 && (gfP + efP) > 0.35 && !vividSpot) return true;
    if (st.artColorCount > 1400 && gfP > 0.25 && gfP > efP) return true;
    return st.artColorCount > 250 && gfP > 0.22 && gfP > efP * 1.6;
  }
  function fineDetailLikely() {
    /* small text / hairline strokes that embroidery thread physically can't
       stitch. Photos are owned by the Full Color path first. */
    if (fullColorLikely()) return false;
    /* C129 (2026-09-02, corpus 009 Stormy Shores): a RUN of small glyphs —
       6+ same-polarity contrast components 0.7-3.5mm tall chained in a line
       with a median height <= 3mm — is small text no thread can stitch
       (legible embroidered caps start around 4mm). Measured physically at
       2in by analyzeArtwork (st.artPhys.txtRun / txtH). Fires regardless
       of the vivid exemption below: that exemption is about satin outlines
       between bold fills, not lettering. */
    var phTx = st.artPhys;
    /* C153 (Justin 2026-09-05, Ninja Blanks logo stopped at run 6 @ 2.75mm: "I need embroidery to be flexible"):
       the embroidery family needs a run of 8+ glyphs (PTYPE.txtRunMin) before a short decorative label counts as
       unstitchable small text; PVC / keychain / chenille keep the global 6. Corpus stops sit at 10-16. */
    if (phTx && phTx.txtRun >= (PTYPE.txtRunMin || 6) && phTx.txtH > 0 && phTx.txtH <= 3.0) return true;
    /* mostly-thin art: the design itself is small text / hairline linework
       (thin = vanishes under the erosion opening; bold lettering never does) */
    var tf = st.artThinInkFrac || 0, ts = st.artThinInkShare || 0;
    if (tf > 0.55 && ts > 0.012) return true;
    /* MIXED art: chunky fills plus a REAL block of genuinely thin detail
       (that's the Print & Stitch case) */
    /* vivid spot-color art whose "thin ink" is really the satin outlines
       between bold regions (Revelators: tf .21, ts .15) is embroiderable —
       exempt it unless the design is genuinely thin-dominant. A-NIGHT
       (satFrac .03, tf .29, ts .11) stays caught. */
    var vividFd = (st.artSatFrac || 0) > 0.5 && (st.artHueBins || 99) <= 8;
    return ts > 0.05 && (st.artInkFrac || 0) > 0.2 && !(vividFd && tf < 0.4);
  }
  function densePictorialLikely() {
    /* C78 (2026-08-31): dense pictorial art inside the vivid spot-color class
       — exactly what the vividSpot exemption waves through. Corpus 001
       (Schultz Farm, must stop): satFrac 1.0, hueBins 4, u2 .196, u4 .264 —
       painterly fired on its numbers but was vetoed by vividSpot, Photo B
       missed by 3-7 colors, and the thin-ink gates cannot see soft rendered
       density. This gate asks the PHYSICAL question instead: at 2" wide, a
       fifth or more of the ink lives in features under 2mm.
       PROVISIONAL SEED (u2>=0.15 && u4>=0.22) from corpus 001 ONLY — staged
       for calibration against must-pass vivid renders (Revelators class)
       BEFORE this ships to live. Scoped to the vivid class because non-vivid
       dense art is already owned by the painterly/photo gates. */
    if (!photoGateOn()) return false;
    /* C130 (2026-09-02, Justin: "leather doesn't need the fine detail but it
       needs the photography stop"): leather / faux leather are laser-etched,
       not stitched — dense texture and tiny detail burn fine, so the
       dense-detail interrupt (with its embroidery-worded copy) never belongs
       on those PDPs; fdGate is already off for them. Photographs still stop
       via fullColorLikely (photoGateOn includes leather) — the ONLY gate a
       leather upload gets. Corpus 008 (HUMAN distressed lettering) had been
       stopped here by the C127 tonal arm. */
    if (isLeather()) return false;
    var phD = st.artPhys;
    if (!phD) return false;
    /* C84 arm (corpus 002, Regal badge): SCATTERED TINY ELEMENTS on the
       bg-excluded mask — palette-independent. Circuit dots / waveform ticks /
       sub-legible lettering measured fts .188; bold-logo controls <= .012.
       Validated: 001 STOP(C78) / 002 STOP(C84) / bold logo, vivid emblem,
       outline logo all PASS. */
    /* C97 (2026-09-01, corpus 005 second variant): the imgix/vecProxy render
       of a monochrome PDF is flattened onto WHITE, and anti-aliasing against
       white makes a fat mid-grey fringe — measured live: inkShare .309,
       fts .516 on a black logo with 33 colours — which clears the C96 mass
       floor. Real scatter art is colour-rich (Regal, the case this arm
       exists for, measures 253 colours; the mono false-stop 33 — 8x margin
       on the same axis the C78 arm already guards with). */
    /* C127 (2026-09-01, corpus 007, order 2108675): the C97 colour guard is
       a proxy for "flat monochrome vector art whose ink mask degenerated to
       an anti-aliasing fringe" — but it also blocks DARK tonal renders with
       a small palette. Measured: an engraved-style Florida patch render
       (dense hatching, palms, gator, sub-legible script) at 2" wide has
       fts .266 / inkShare .396 — real scattered sub-4mm ink — yet quantises
       to only 108 colours (near-black art, hueBins 2), 12 short of the
       guard, so it shipped as embroidery-only. Palette size is the wrong
       axis for that art; TONAL DOMINANCE is the right one: soft shading
       covering 40%+ of the raster and outweighing hard edges cannot come
       from the AA-fringe degeneracy the guard exists for (flat vector /
       text controls measure gradFrac .003-.028, the mono false-stops
       .057-.276 with edgeFrac 0, this case .581 with edge .335). So the
       colour guard gains a tonal escape hatch; the ink-mass floor (C96) and
       the fts threshold still have to be cleared either way. */
    var tonalDense = (st.artGradFrac || 0) >= 0.40 && (st.artGradFrac || 0) > (st.artEdgeFrac || 0);
    if ((st.artColorCount > 120 || tonalDense) && (phD.fts || 0) >= 0.08) return true;
    var vividDp = (st.artSatFrac || 0) > 0.5 && (st.artHueBins || 99) <= 8;
    if (!vividDp) return false;
    /* C84 guard on the C78 arm: bold flat VIVID logos (control measured 27
       colours) can reach u2/u4 through TEXT STROKES alone — require colour
       richness. 120, not the painterly gate's 210: Schultz measures 243-247
       on the GPU decode path but 209 on software canvas (same file!), while
       bold logos sit at ~27 — 120 clears both bands with 4x margin. */
    if (!(st.artColorCount > 120)) return false;
    return phD.u2 >= 0.15 && phD.u4 >= 0.22;
  }

  /* ---- wizard ---- */
  var wz = $('#np-e2-wizard');
  var wzReturnToProof = false;
  function openWizard(step) {
    st.step = step;
    st.draft = { shape: st.shape, border: st.border, fold: st.fold, bg: st.bg, thread: st.thread, backing: st.backing, texture: st.texture, font: st.font, opt1: st.opt1, opt2: st.opt2, opt3: st.opt3, text: st.text };
    wz.hidden = false;
    renderWizard();
  }
  function closeWizard() { wz.hidden = true; st.step = null; st.draft = null; }
  function draftValue(i) {
    var k = WZ_STEPS[i];
    if (k === 'size') return st.size ? st.size.label : null; /* C229 */
    var v = st.draft[k];
    if (!v) return null;
    return (k === 'shape') ? displayShapeLabel(v) : v.label;
  }
  function cornersNeeded() {
    var g2 = shapeGeom();
    return (g2 === 'square' || g2 === 'rectangle' || g2 === 'rectangle-v') && !st.corners;
  }
  function committed() { return WZ_STEPS.every(function (k) { return !stepEnabled(k) || !!st[k]; }) && !(stepEnabled('shape') && cornersNeeded()); }

  function renderWizard() {
    var i = st.step;
    var sqW = stepSeq(), posW = sqW.indexOf(i);
    $('#np-e2-wz-eyebrow').textContent = 'STEP ' + ((posW === -1 ? i : posW) + 1) + ' OF ' + WZ_STEPS.filter(stepEnabled).length;
    var dW = optDef(WZ_STEPS[i]);
    $('#np-e2-wz-title').textContent = dW ? ('Select ' + dW.name) : WZ_TITLES[i];
    /* progress strip */
    $('#np-e2-wz-progress').innerHTML = WZ_STEPS.map(function (k, n) {
      var cls = 'np-e2-progress__seg' + (n === i ? ' is-current' : (draftValue(n) ? ' is-done' : ''));
      var dN = optDef(k);
      var lab = (dN ? dN.name : WZ_LABELS[n]) + (draftValue(n) ? ' <em>' + draftValue(n) + '</em>' : '');
      return '<span class="' + cls + '" data-e2-seg="' + n + '"><span class="np-e2-progress__bar"></span><span class="np-e2-progress__lab">' + lab + '</span></span>';
    }).join('');
    $$('#np-e2-wz-progress [data-e2-seg]').forEach(function (seg) {
      seg.addEventListener('click', function () { st.step = parseInt(seg.getAttribute('data-e2-seg'), 10); renderWizard(); });
    });

    /* body */
    renderStepBody(i, $('#np-e2-wz-body'), renderWizard);
    renderWizardFoot(i);
  }

  /* shared step-body renderer: fills `body` with the option UI for step i and
     calls onChange() after any selection mutates st.draft. Used by the ON-PAGE
     accordion (primary, v2) and the dormant wizard modal. */
  function renderStepBody(i, body, onChange) {
    var art = artworkUrl();
    /* dispatch on the step KEY: WZ_STEPS is reorderable, indices are not */
    var k = WZ_STEPS[i];
    if (k === 'size') { renderSizeFirstBody(body, onChange); return; } /* C229 */
    if (k === 'shape') {
      /* C26b — a shape already chosen on a now-hidden twin (a reorder, or a
         pick made before the artwork was measured) would leave the picker with
         nothing lit. Move it to the partner, which renders identically. */
      (function normalizeTwinPick() {
        try {
          var curLbl = st.draft.shape || st.shape, curGeom = null, partner = null;
          (CFG.shapes || []).forEach(function (sT) { if (sT.label === curLbl) curGeom = sT.geom; });
          if (!shapeTwinHidden(curGeom)) return;
          var wantGeom = TWIN_OF[curGeom];
          (CFG.shapes || []).forEach(function (sT) { if (sT.geom === wantGeom) partner = sT.label; });
          if (!partner) return;
          st.draft.shape = partner;
          if (st.shape === curLbl) st.shape = partner;
        } catch (eTw) {}
      })();
      body.innerHTML = '<div class="np-e2-shapes">' + (CFG.shapes || []).map(function (s, n) {
        var on = st.draft.shape === s.label;
        /* customer's uploaded image masked into each shape (contained);
           custom shape = the image silhouette itself. NO placeholder art —
           a spinner holds each shape until the upload resolves (the artimg
           load listener re-renders this row the moment it lands). */
        /* molded finishes preview in their own material color — a matte black
           patch must never preview on the grey placeholder field */
        var tileBg = (PTYPE.fixedBg && ((st.bg && st.bg.hex) || PTYPE.fixedBg.hex)) || '#e5e7eb';
        /* C26b: blank rather than filter — data-e2-i below is this map's index
           into CFG.shapes, so dropping entries would mis-target every pick. */
        if (shapeTwinHidden(s.geom)) return '';
        if (PTYPE.foldCustom && s.geom === 'custom') return ''; /* C178: Design’s Shape lives on the Fold Style step */
        var render = shapeRenderHTML(s.geom, { img: art || null, bg: tileBg, crop: !!s.crop });
        if (isFreeFormShape(s.label)) render = render.replace('data-e2-tilegeom="', 'data-e2-tilefree="1" data-e2-tilegeom="');
        if (!art && render.indexOf('np-e2-tilespin') === -1) render = render.replace('</span>', '<i class="np-e2-tilespin"></i></span>');
        /* Free Form needs explaining: the elements come apart into separate
           pieces rather than sitting on one connected patch */
        var tipFF = /free\s*form/i.test(s.label || '')
          ? '<span class="np-e2-ftip np-e2-ftip--tile" data-e2-ftip tabindex="0" aria-label="What is Free Form?"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span class="np-e2-ftip__pop"><img src="' + (CFG.freeformImg || '') + '" alt="Free form patches cut as separate pieces" loading="lazy"><b class="np-e2-ftip__head">Every piece cut on its own</b><i>Free form cuts each element of your design as its own separate patch, instead of one connected shape.</i></span></span>'
          : '';
        /* the custom tile explains itself: we cut to the design's own shape */
        var tipCS = (s.geom === 'custom' && !isFreeFormShape(s.label))
          ? '<span class="np-e2-ftip np-e2-ftip--tile" data-e2-ftip tabindex="0" aria-label="What is Design&#39;s Shape?"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span class="np-e2-ftip__pop"><img src="https://ninjauploads-production.imgix.net/np-custom-shape-example-1787593373.png?w=520" alt="A patch cut to the exact shape of the uploaded design" loading="lazy"><b class="np-e2-ftip__head">Your design IS the patch shape</b><i>We cut the patch to the outer shape of your uploaded design \u2014 the edge follows your artwork\u2019s own outline.</i></span></span>'
          : '';
        return '<div class="np-e2-shapetile' + (on ? ' is-on' : '') + '" data-e2-pick="shape" data-e2-i="' + n + '">' + render + '<b>' + displayShapeLabel(s.label) + tipCS + tipFF + '</b>' + '</div>';
      }).join('') + '</div>';
      var dGeom = null;
      (CFG.shapes || []).forEach(function (s3) { if (s3.label === st.draft.shape) dGeom = s3.geom; });
      if ((dGeom === 'square' || dGeom === 'rectangle' || dGeom === 'rectangle-v') && !PTYPE.fixedCorners) { /* C175 (Justin 2026-09-11, 'get rid of corner options'): a fixed-corner type (woven labels = square) never asks */
        body.innerHTML += '<p class="np-e2-wz-subhead" style="margin-top:14px">CORNERS <em class="np-e2-req">Required</em></p><div class="np-e2-cornrow">' +
          '<button type="button" class="np-e2-corner' + (st.corners === 'rounded' ? ' is-on' : '') + '" data-e2-corner="rounded"><i class="np-e2-corner__glyph np-e2-corner__glyph--r"></i>Rounded corners</button>' +
          '<button type="button" class="np-e2-corner' + (st.corners === 'square' ? ' is-on' : '') + '" data-e2-corner="square"><i class="np-e2-corner__glyph"></i>Square corners</button></div>';
        $$('[data-e2-corner]', body).forEach(function (cbn) {
          cbn.addEventListener('click', function () {
            st.corners = cbn.getAttribute('data-e2-corner');
            /* in-place: a corner pick only changes the mask radius — a full
               re-render would reload every shape tile's composite */
            $$('[data-e2-corner]', body).forEach(function (b2) {
              var k2 = b2.getAttribute('data-e2-corner');
              var on2 = k2 === st.corners;
              b2.classList.toggle('is-on', on2);
              b2.innerHTML = '<i class="np-e2-corner__glyph' + (k2 === 'rounded' ? ' np-e2-corner__glyph--r' : '') + '"></i>' + (k2 === 'rounded' ? 'Rounded corners' : 'Square corners');
            });
            var contBtn = body.querySelector('[data-e2-acccont]');
            if (contBtn) contBtn.disabled = !st.shape || cornersNeeded();
            renderOptions();
            renderMaskPreview();
            commitOptions();
          });
        });
      }
      if (art) $$('[data-e2-tilegeom]', body).forEach(function (tEl) {
        var tileBg2 = (tEl.getAttribute('data-e2-tilegeom') === 'custom') ? '#f2f2f2' /* C143: Design's Shape tile = the plate */ : ((PTYPE.fixedBg && ((st.bg && st.bg.hex) || PTYPE.fixedBg.hex)) || '#e5e7eb');
        composePatchImage(function (cvT) {
          if (cvT) { try { tEl.innerHTML = '<img src="' + cvT.toDataURL('image/png') + '" alt="">'; } catch (eT) {} }
        }, 200, { g: tEl.getAttribute('data-e2-tilegeom'), bg: tileBg2, ring: '#0C0C0E', thin: true, zoom: 1, freeform: tEl.hasAttribute('data-e2-tilefree'), tile: 1, crop: tEl.getAttribute('data-e2-tilecrop') === '1' });
      });
    } else if (k === 'border') {
      /* border style — Custom Shape only allows the hot-cut edge */
      var isCustom = false;
      (CFG.shapes || []).forEach(function (s) { if (s.label === st.draft.shape && s.geom === 'custom') isCustom = true; });
      if (PTYPE.mats) {
        var lbList = effectiveBorders();
        /* custom shape: No Border is the single option — pre-select it so the
           step self-completes, and clear a stale Etched pick */
        if (isCustom && lbList.length === 1 && (!st.draft.border || st.draft.border.label !== lbList[0].label)) st.draft.border = lbList[0];
        var lbSel = st.draft.border ? st.draft.border.label : '';
        body.innerHTML = '<p class="np-e2-wz-help">' + (isCustom ? 'A custom shape is cut clean along your artwork\u2019s outline \u2014 separate letters or pieces are bridged into one shape with a small leather margin. No border options.' :'Add a laser-etched border line inside the edge \u2014 or keep a smooth clean cut.') + '</p><div class="np-e2-backings np-e2-borders">' + lbList.map(function (bL, nL) {
          var onL = lbSel === bL.label;
          return '<div class="np-e2-backtile' + (onL ? ' is-on' : '') + '" data-e2-lb="' + nL + '"><img src="' + bL.img + '?w=520" alt="' + bL.label + '"><b>' + bL.label + '</b><i>' + (bL.note || '') + '</i></div>';
        }).join('') + '</div>' +
        (/etched/i.test(lbSel) ? '<div class="np-e2-zoomrow np-e2-zoomrow--step"><span>Border thickness</span><input type="range" data-e2-lbthick min="1" max="10" step="1" value="' + (st.lbThick || 3) + '"><b>' + (st.lbThick || 3) + '/10</b></div>' : '');
        $$('[data-e2-lb]', body).forEach(function (tileL) {
          tileL.addEventListener('click', function () {
            st.draft.border = lbList[parseInt(tileL.getAttribute('data-e2-lb'), 10)];
            onChange();
          });
        });
        var lt = body.querySelector('[data-e2-lbthick]');
        if (lt) {
          try { paintSlider(lt); } catch (eL1) {}
          lt.addEventListener('input', function () {
            try { paintSlider(lt); } catch (eL2) {}
            st.lbThick = parseInt(lt.value, 10) || 3;
            var bTh = lt.parentNode.querySelector('b');
            if (bTh) bTh.textContent = lt.value + '/10';
            setProp('_Border Thickness', lt.value + '/10');
            if (!lt.__npRaf) { lt.__npRaf = true; requestAnimationFrame(function () { lt.__npRaf = false; renderMaskPreview(); }); }
          });
        }
        return;
      }
      var blist = effectiveBorders();
      var noMer502 = !!(PTYPE.noMerrowGeom && PTYPE.noMerrowGeom.test(shapeGeom() || '')); /* C502 */
      if ((isCustom || noMer502) && blist.length === 1 && (!st.draft.border || st.draft.border.label !== blist[0].label)) st.draft.border = blist[0];
      var bhelp = noMer502 ? 'Heart and Design\u2019s Shape patches have no border \u2014 Merrow needs a standard shape.' : (isCustom ? 'Custom shapes are hot cut to your artwork — Merrow requires a standard shape.' : '');
      body.innerHTML = '<p class="np-e2-wz-help">' + bhelp + '</p><div class="np-e2-backings np-e2-borders">' + blist.map(function (b) {
        var on = st.draft.border && st.draft.border.label === b.label;
        var n = (CFG.borders || []).indexOf(b);
        return '<div class="np-e2-backtile' + (on ? ' is-on' : '') + '" data-e2-pick="border" data-e2-i="' + n + '">' + (b.img ? '<img src="' + b.img + '" alt="' + b.label + '">' : '<span class="np-e2-backtile__noimg"><i></i></span>') + '<b>' + b.label + '</b><i>' + (b.note || '') + '</i></div>';
      }).join('') + '</div>' +
      (st.shape && shapeGeom() !== 'custom' ? '<div class="np-e2-zoomrow np-e2-zoomrow--step"><span>Artwork fill</span><input type="range" data-e2-artzoom2 min="60" max="250" step="5" value="' + Math.round((st.artZoom || 1) * 100) + '"><b>' + Math.round((st.artZoom || 1) * 100) + '%</b></div>' : '');
      var z2 = body.querySelector('[data-e2-artzoom2]');
      if (z2) {
        try { paintSlider(z2); } catch (eZ2) {}
        z2.addEventListener('input', function () {
          try { paintSlider(z2); } catch (eZ3) {}
          st.artZoom = parseInt(z2.value, 10) / 100; if (Math.abs((st.artZoom || 1) - 1) < 0.001) { st.artDx = 0; st.artDy = 0; } /* 100% = centred again (review 2026-09-05) */
          var bV2 = z2.parentNode.querySelector('b');
          if (bV2) bV2.textContent = z2.value + '%';
          var mainS = document.getElementById('np-e2-artzoom');
          var mainV = document.getElementById('np-e2-artzoom-val');
          if (mainS) { mainS.value = z2.value; try { paintSlider(mainS); } catch (eZ4) {} }
          if (mainV) mainV.textContent = z2.value + '%';
          if (!z2.__npRaf) { z2.__npRaf = true; requestAnimationFrame(function () { z2.__npRaf = false; renderMaskPreview(); }); }
          setProp('_Art Fill', z2.value + '%');
        });
      }
    } else if (k === 'bg' || k === 'thread' || k === 'text') {
      var list = k === 'bg' ? CFG.bgs : CFG.threads; /* text shares the thread palette */
      var cur = k === 'bg' ? st.draft.bg : (k === 'text' ? st.draft.text : st.draft.thread);
      var help = ''; /* now shown beside the row label — see stepHelpText() */
      var kindKey = k;
      if (kindKey === 'bg' && PTYPE.mats) {
        var curM = st.draft.bg;
        body.innerHTML = '<div class="np-e2-colorhead"><p class="np-e2-wz-help">The artwork is laser etched into the hide.</p></div>' +
          '<div class="np-e2-swatches np-e2-swatches--mats">' + PTYPE.mats.map(function (c, nM) {
            var onM = curM && curM.label === c.label;
            return '<div class="np-e2-swatch np-e2-swatch--mat' + (onM ? ' is-on' : '') + '" data-e2-mat="' + nM + '"><span class="np-e2-matimg"><img src="' + c.img + '" alt="" loading="lazy"></span><b>' + c.label + '</b></div>';
          }).join('') +
          '<button type="button" class="np-e2-etchinv' + (st.etchInvert ? ' is-on' : '') + '" data-e2-etchinv style="grid-column:' + ((PTYPE.mats.map(function (cc) { return cc.label; }).indexOf(curM && curM.label) + 1) || 1) + '"><b>' + (st.etchInvert ? 'Inverted Etch \u2713' : 'Invert the etch') + '</b></button>' + '</div>';
        $$('[data-e2-mat]', body).forEach(function (tileM) {
          tileM.addEventListener('click', function () {
            st.draft.bg = PTYPE.mats[parseInt(tileM.getAttribute('data-e2-mat'), 10)];
            onChange();
          });
        });
        var invT = body.querySelector('[data-e2-etchinv]');
        if (invT) invT.addEventListener('click', function () {
          st.etchInvert = !st.etchInvert;
          this.classList.toggle('is-on', st.etchInvert);
          var bT = this.querySelector('b');
          if (bT) bT.textContent = st.etchInvert ? 'Inverted Etch \u2713' : 'Invert the etch';
          setProp('_Etch Style', st.etchInvert ? 'Inverted - background etched, artwork bare' : '');
          renderMaskPreview();
        });
        return;
      }
      var isCustomCur = cur && !isFollowVal(cur) && cur.label !== 'Not Sure' && cur.label !== 'Let Ninja Choose' && cur.label !== 'None' && st.artColors.indexOf(cur.hex) === -1 && (list || []).every(function (c) { return c.label !== cur.label; });
      /* "Match My Artwork" is the same idea as the artwork colours, so it sits
         with them. It only stays in the header row when there are none. */
      var artSection = '';
      var artNames = {}; /* one swatch per color NAME — dupes within the artwork
        palette collapse, and standard colors already offered there hide */
      /* custom shape: the patch is cut to the artwork, so "None" (no felt
         background) rides as the LAST artwork swatch — red no-slash icon,
         picked/unpicked exactly like any other swatch */
      /* NOT on lettering types: on tackle twill / name patches the "bg" step
         IS the LETTER colour, and letters must have a colour — "None" there
         meant invisible letters (Justin 2026-08-21) */
      /* C63 (2026-08-31, Justin: "lets add NONE as a border color option for
         Rubber PVC and silicone ... to the right of the colors from your
         artwork as a square with the red line through it"). The molded-rim
         family (lbZeroMax2: PVC, keychain, silicone) gets the existing None
         tile on the Border Color step — the click handler, thNone composer
         path (ring 0) and _Border Color: None property all already handle it. */
      var noneTile = ((kindKey === 'bg' && shapeGeom() === 'custom' && !PTYPE.textLines && !PTYPE.textPreview && !PTYPE.bareArt && !PTYPE.lbZeroMax2 /* C63b: molded PVC/silicone always need a base colour (Justin 8-31) */)
        || (kindKey === 'thread' && PTYPE.lbZeroMax2))
        ? '<div class="np-e2-swatch np-e2-swatch--none' + ((cur && cur.label === 'None') ? ' is-on' : '') + '" data-e2-none="' + kindKey + '"><i style="background:linear-gradient(135deg,transparent 44%,#E5484D 44%,#E5484D 56%,transparent 56%),#fff;box-shadow:inset 0 0 0 1px #d5dbe0"></i><b>None</b></div>'
        : '';
      if (st.artColors.length) {
        artSection = '<p class="np-e2-wz-subhead">COLORS FROM YOUR ARTWORK</p><div class="np-e2-swatches np-e2-swatches--art">' + st.artColors.map(function (hex) {
          /* C471: no custom background on this type — the artwork colour is offered as its nearest stock colour,
             named and coloured as that stock swatch (data-label keeps pmsName off it) */
          var stockA = (PTYPE.noCustomBg && kindKey === 'bg') ? stockNearest471(hex, list) : null;
          var hexA = stockA ? stockA.hex : hex;
          var nmA = stockA ? stockA.label : pmsName(hex);
          if (artNames[nmA]) return '';
          artNames[nmA] = 1;
          var on = cur && (cur.hex === hexA || cur.label === nmA);
          return '<div class="np-e2-swatch' + (on ? ' is-on' : '') + '" data-e2-artcolor="' + kindKey + '" data-hex="' + hexA + '"' + (stockA ? ' data-label="' + String(nmA).replace(/"/g, '&quot;') + '"' : '') + '><i style="background:' + hexA + '"></i><b>' + nmA + '</b></div>';
        }).join('') + noneTile + '</div><p class="np-e2-wz-subhead">STANDARD COLORS</p>';
        noneTile = ''; /* consumed */
      }
      /* C329: same rail, fed by the background they just picked rather than by artwork colours. Only when
         the artwork rail did not claim the slot, so the two can never both appear.
         C330 put this on the text thread step too and C331 took it straight back off (Justin: "that makes no
         sense because then you would never see the text"). BORDER ONLY — the border sits beside the felt, so
         matching reads as deliberate; the lettering sits ON it, so matching makes it disappear. */
      if (!artSection && kindKey === 'thread' && PTYPE.borderMatchBg && st.bg && st.bg.hex) {
        var onBgMatch = cur && cur.label === st.bg.label;
        artSection = '<p class="np-e2-wz-subhead">MATCH YOUR BACKGROUND</p><div class="np-e2-swatches np-e2-swatches--art">' +
          '<div class="np-e2-swatch' + (onBgMatch ? ' is-on' : '') + '" data-e2-artcolor="' + kindKey + '"' +
            ' data-hex="' + st.bg.hex + '" data-label="' + String(st.bg.label).replace(/"/g, '&quot;') + '">' +
            '<i style="background:' + st.bg.hex + '"></i><b>' + st.bg.label + '</b></div>' +
          noneTile + '</div><p class="np-e2-wz-subhead">STANDARD COLORS</p>';
        noneTile = ''; /* consumed */
      }
      var isUnsure = cur && (cur.label === 'Not Sure' || cur.label === 'Let Ninja Choose');
      /* Justin 2026-08-25: "when I select photo it also checks match artwork,
         not necessary". Photo stores { label: PHOTO_LABEL, follow: true } —
         the follow flag is REAL (it makes compose go full bleed and drops
         background_color from the renderer specs) so it must stay, but it also
         satisfied isFollowVal(), lighting up both buttons. Exclude the photo
         value from the Match Artwork on-state rather than touching the flag. */
      var isFollow = isFollowVal(cur) && !isPhotoVal(cur);
      var moreKey = 'more_' + kindKey;
      var LIMITC = 15; /* + the color wheel = 16 tiles */
      var showAllC = !!st[moreKey] || !!(cur && (list || []).some(function (c2, n2) { return n2 >= LIMITC && c2.label === cur.label; }));
      var moreBtn = ((list || []).length > LIMITC)
        ? '<button type="button" class="np-e2-showmore" data-e2-more="' + kindKey + '">' + (showAllC ? 'Show fewer colors' : 'Show ' + (list.length - LIMITC) + ' more colors') + '</button>'
        : '';
      /* no upload on this type = nothing to follow */
      var followBtnHTML = PTYPE.noArt ? '' : ('<button type="button" class="np-e2-lnc np-e2-lnc--follow' + (isFollow ? ' is-on' : '') + '" data-e2-follow="' + kindKey + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>' + '<span class="np-e2-lnc-full">' + FOLLOW_LABEL + '</span><span class="np-e2-lnc-short">Match Artwork</span>' + ''  /* tick is a corner badge now, not label text */ + '<span class="np-e2-ftip" data-e2-ftip tabindex="0" aria-label="What does Match My Artwork do?"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span class="np-e2-ftip__pop"><img src="https://ninjauploads-production.imgix.net/np-follow-example-1786985124.png?w=520" alt="Example artwork with its own border and background" loading="lazy"><b class="np-e2-ftip__head">Image already designed correctly?</b><i>We will follow the background and border in your image to make sure your patch matches your design</i></span></span>' + '</button>');
      /* full colour: the artwork IS the whole patch face, so there is no felt
         behind it to colour. Leads the row; Let Ninja Choose sits right of it. */
      var photoBtnHTML = ((kindKey === 'bg' && PTYPE.photoBtn)
          ? '<button type="button" class="np-e2-lnc np-e2-lnc--photo' + (isPhotoVal(cur) ? ' is-on' : '') + '" data-e2-photo="bg"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>' + '<span class="np-e2-lnc-full">It\u2019s a photo</span><span class="np-e2-lnc-short">Photo</span>' + ''  /* tick is a corner badge now */ + '</button>'
          : '');
      /* the artwork-colours heading carries the Match My Artwork button; the
         token is only resolvable here, after followBtnHTML is built */
      body.innerHTML = '<div class="np-e2-colorhead">' + (help ? '<p class="np-e2-wz-help">' + help + '</p>' : '') + '<span class="np-e2-colorhead__acts">' +
        followBtnHTML + photoBtnHTML +
        /* Let Ninja Choose — a REAL button, upper right (the specialist picks).
           Typed products (names, tackle twill) are ordered on the exact colours
           the customer sees in the preview, so it is suppressed there. */
        (PTYPE.noLnc ? '' :
        '<button type="button" class="np-e2-lnc' + (isUnsure ? ' is-on' : '') + '" data-e2-unsure="' + kindKey + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.7 4.3L18 9l-4.3 1.7L12 15l-1.7-4.3L6 9l4.3-1.7z"/><path d="M19 15l.9 2.1L22 18l-2.1.9L19 21l-.9-2.1L16 18l2.1-.9z"/></svg>' +
        'Let AI Choose'  /* tick is a corner badge now */ +
        '<span class="np-e2-ftip" data-e2-ftip tabindex="0" aria-label="What does Let AI Choose do?"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span class="np-e2-ftip__pop"><b class="np-e2-ftip__head">Let AI choose</b><i>AI will choose for you based on your design \u2014 the pick shows in your preview and you can change it anytime.</i></span></span>' +
        '</button>') +
        '</span></div>' +
        artSection + '<div class="np-e2-swatches">' + noneTile + (list || []).map(function (c, n) {
        if (!showAllC && n >= LIMITC) return '';
        if (artNames[c.label]) return ''; /* already offered under COLORS FROM YOUR ARTWORK */
        var on = cur && cur.label === c.label;
        return '<div class="np-e2-swatch' + (on ? ' is-on' : '') + '" data-e2-pick="' + kindKey + '" data-e2-i="' + n + '"><i style="background:' + c.hex + '"></i><b>' + c.label + '</b></div>';
      }).join('') +
      /* color wheel — pick ANY color; it's named by its hex code and that
         hex is what lands on the line-item property.
         C328: suppressed where the material makes it a lie — a stock-twill background can only be a stock
         colour, so offering a wheel would take an order we cannot make. Scoped to that kind on that patch
         type; every other swatch list keeps its wheel. */
      ((PTYPE.noCustomBg && kindKey === 'bg') ? '' :
      '<div class="np-e2-swatch np-e2-swatch--wheel' + (isCustomCur ? ' is-on' : '') + '" data-e2-wheel="' + kindKey + '">' +
        '<i' + (isCustomCur ? ' style="background:' + cur.hex + '"' : '') + '></i>' +
        '<b>' + (isCustomCur ? cur.label : 'Custom') + '</b>' +
        '<input type="color" value="' + (isCustomCur ? cur.hex : '#1AA86C') + '">' +
      '</div>') + moreBtn + '</div>';
      $$('[data-e2-none]', body).forEach(function (tile) {
        tile.addEventListener('click', function () {
          var kN = tile.getAttribute('data-e2-none');
          var val = { label: 'None', hex: '' };
          if (kN === 'bg') st.draft.bg = val; else if (kN === 'text') st.draft.text = val; else st.draft.thread = val;
          onChange();
        });
      });
      $$('[data-e2-artcolor]', body).forEach(function (tile) {
        tile.addEventListener('click', function () {
          var hex = tile.getAttribute('data-hex');
          /* C329: a tile may carry its own name (the background match does) — pmsName would rename a stock
             twill colour to its nearest PMS, which is not what goes on the order. */
          var val = { label: tile.getAttribute('data-label') || pmsName(hex), hex: hex };
          var kA = tile.getAttribute('data-e2-artcolor');
          if (kA === 'bg') st.draft.bg = val; else if (kA === 'text') st.draft.text = val; else st.draft.thread = val;
          onChange();
        });
      });
      $$('[data-e2-photo]', body).forEach(function (tile) {
        tile.addEventListener('click', function () {
          /* photo = no patch background at all; follow:true makes the compose go
             full bleed and drops background_color from the renderer specs */
          st.draft.bg = { label: PHOTO_LABEL, hex: '', follow: true };
          onChange();
        });
      });
      $$('[data-e2-unsure]', body).forEach(function (tile) {
        tile.addEventListener('click', function (evU) {
          /* a tooltip tap must never trigger the pick */
          if (evU.target && evU.target.closest && evU.target.closest('[data-e2-ftip]')) return;
          var kU = tile.getAttribute('data-e2-unsure');
          var val = aiChooseColor(kU);
          if (kU === 'bg') st.draft.bg = val; else if (kU === 'text') st.draft.text = val; else st.draft.thread = val;
          npToast('\u2713 AI picked ' + val.label + ' for your design \u2014 tap any swatch to change it');
          onChange();
        });
      });
      $$('[data-e2-follow]', body).forEach(function (tile) {
        tile.addEventListener('click', function () {
          /* the artwork already carries this element — follow the image */
          var val = { label: FOLLOW_LABEL, hex: '', follow: true };
          var kF = tile.getAttribute('data-e2-follow');
          if (kF === 'bg') st.draft.bg = val; else if (kF === 'text') st.draft.text = val; else st.draft.thread = val;
          onChange();
        });
      });
      $$('[data-e2-more]', body).forEach(function (bM) {
        bM.addEventListener('click', function () {
          st[moreKey] = !st[moreKey];
          renderAccordion();
        });
      });
      /* C538c (Justin 2026-11-03, PVC: "when NONE Is selected hide the border thickness please"): no border, nothing to size */
      var thNoneStep = !!(st.thread && !isFollowVal(st.thread) && (st.thread.none || /^none$/i.test(st.thread.label || '')));
      if (kindKey === 'thread' && PTYPE.borderThick && !(PTYPE.noneHidesThick && thNoneStep)) {
        /* molded flex: the border is part of the mold, so its WIDTH is a
           choice — same 1-10 control (and _Border Thickness property) the
           laser-etched leather border already uses */
        var thWrap = document.createElement('div');
        thWrap.className = 'np-e2-zoomrow np-e2-zoomrow--step';
        thWrap.innerHTML = '<span>Border thickness</span><input type="range" data-e2-lbthick min="1" max="10" step="1" value="' + (st.lbThick || 3) + '"><b>' + (st.lbThick || 3) + '/10</b>';
        body.appendChild(thWrap);
        var ltF = thWrap.querySelector('[data-e2-lbthick]');
        try { paintSlider(ltF); } catch (eF1) {}
        ltF.addEventListener('input', function () {
          try { paintSlider(ltF); } catch (eF2) {}
          st.lbThick = parseInt(ltF.value, 10) || 3;
          var bF = thWrap.querySelector('b');
          if (bF) bF.textContent = ltF.value + '/10';
          setProp('_Border Thickness', ltF.value + '/10');
          if (!ltF.__npRaf) { ltF.__npRaf = true; requestAnimationFrame(function () { ltF.__npRaf = false; renderMaskPreview(); }); }
        });
      }
      if (kindKey === 'thread' && PTYPE.sewChannel && !isFreeFormShape()) {
        /* C538 (Justin 2026-11-03): optional sewing channel on rubber PVC — offered with any border colour, None included */
        var scWrap = document.createElement('label');
        scWrap.className = 'np-e2-sewchan' + (st.sewChannel ? ' is-on' : '');
        scWrap.innerHTML = '<input type="checkbox" data-e2-sewchan' + (st.sewChannel ? ' checked' : '') + '>' +
          '<span class="np-e2-sewchan__txt"><b>Add sewing channel</b><span>Molds a groove into the rubber border as a sewing channel, so you can stitch the patch on cleanly. No thread is included.</span></span>';
        body.appendChild(scWrap);
        scWrap.querySelector('[data-e2-sewchan]').addEventListener('change', function () {
          st.sewChannel = !!this.checked;
          scWrap.classList.toggle('is-on', st.sewChannel);
          setProp('_Sewing Channel', st.sewChannel ? 'Yes' : '');
          renderMaskPreview();
        });
      }
      $$('[data-e2-wheel]', body).forEach(function (tile) {
        var picker = tile.querySelector('input[type="color"]');
        /* two open paths: the input covers the tile (native), plus an
           explicit showPicker() for contexts where the covered-input click
           doesn't open (zoomed/stacked modals) */
        picker.addEventListener('click', function (e) { e.stopPropagation(); });
        tile.addEventListener('click', function (e) {
          if (e.target === picker) return;
          try {
            if (typeof picker.showPicker === 'function') picker.showPicker();
            else picker.click();
          } catch (err) { try { picker.click(); } catch (e2) {} }
        });
        picker.addEventListener('input', function () {
          /* fires continuously while sliding — update the draft + this tile
             IN PLACE only. Re-rendering here would destroy the input and
             snap the native picker shut mid-drag. */
          var hex = picker.value.toUpperCase();
          var val = { label: pmsName(hex), hex: hex };
          var kW = tile.getAttribute('data-e2-wheel');
          if (kW === 'bg') st.draft.bg = val; else if (kW === 'text') st.draft.text = val; else st.draft.thread = val;
          tile.classList.add('is-on');
          tile.querySelector('i').style.background = hex;
          tile.querySelector('b').textContent = val.label;
          /* C148: the preview follows the drag — same colour commit accApply() makes on 'change' */
          if (kW === 'bg') st.bg = val; else if (kW === 'text') st.text = val; else st.thread = val;
          livePreviewTick();
        });
        picker.addEventListener('change', function () { onChange(); });
      });
    } else if (k === 'font') {
      /* the tile IS the sample: each option shows the very word the patch
         will carry, set in that face */
      var fontsF = nameFonts();
      body.innerHTML = '<p class="np-e2-wz-help">The lettering style your names are stitched in.</p>' +
        '<div class="np-e2-fonts">' + fontsF.map(function (f2, nF) {
          var onF = st.draft.font && st.draft.font.label === f2.label;
          return '<div class="np-e2-fonttile' + (onF ? ' is-on' : '') + '" data-e2-font="' + nF + '">' +
            '<span class="np-e2-fonttile__samp" style="font-family:' + nameFontStack(f2) + ';font-weight:' + ((f2 && f2.weight) || 700) + '">' + nameTileSample(f2) + '</span>' +
            '<b>' + f2.label + '</b></div>';
        }).join('') + '</div>';
      $$('[data-e2-font]', body).forEach(function (tileF) {
        tileF.addEventListener('click', function () {
          st.draft.font = fontsF[parseInt(tileF.getAttribute('data-e2-font'), 10)];
          onChange();
        });
      });
    } else if (k === 'backing') {
      var noVel476 = npNoVelcroFor((st.draft && st.draft.border) || st.border, (st.draft && st.draft.shape) || st.shape) && (CFG.backings || []).some(function (bV) { return /hook|velcro/i.test(bV.label || ''); });
      body.innerHTML = (noVel476 ? '<p class="np-e2-wz-help">' + (TYPE_FAMILY === 'print-and-stitch-2-0' ? 'Hook &amp; Loop isn\u2019t available on Print &amp; Stitch patches with a Merrow border.' /* C490 */ : TYPE_FAMILY === '3demb-2-0' ? 'Hook &amp; Loop isn\u2019t available on 3D Embroidered patches with a custom shape.' /* C534 */ : 'Hook &amp; Loop is only available on Full Color patches with a Merrow border.' /* C492 */) + '</p>' : '') + /* C476 */
        '<div class="np-e2-backings">' + effectiveBackings().map(function (b) {
        var n = (CFG.backings || []).indexOf(b);
        var on = st.draft.backing && st.draft.backing.label === b.label;
        return '<div class="np-e2-backtile' + (on ? ' is-on' : '') + '" data-e2-pick="backing" data-e2-i="' + n + '"><img src="' + b.img + '" alt="' + b.label + '"><b>' + b.label + '</b><i>' + (b.note || '') + '</i></div>';
      }).join('') + '</div>';
    } else if (OPT_RE.test(k)) {
      /* one tile per value of THIS Shopify option. The tile label is the option
         value byte-for-byte, because that exact string is what matches a
         variant — never a prettified copy of it. */
      var dO = optDef(k) || { name: '', values: [] };
      var helpO = (PTYPE.optHelp || {})[dO.name];
      body.innerHTML = (helpO ? '<p class="np-e2-wz-help">' + helpO + '</p>' : '') +
        '<div class="np-e2-backings np-e2-backings--txt">' + dO.values.map(function (o2, nO) {
          var onO = st.draft[k] && st.draft[k].label === o2.label;
          /* a value with a configured example image renders as a PICTURE tile
             (the Layers choice shows real 1-layer vs 2-layer stitched work) */
          var imgO = (CFG.optImgs || {})[o2.label];
          return '<div class="np-e2-backtile' + (imgO ? ' np-e2-backtile--full' : ' np-e2-backtile--txt') + (onO ? ' is-on' : '') + '" data-e2-opt="' + nO + '">' + (imgO ? '<img src="' + imgO + '" alt="" loading="lazy">' : '') + '<b>' + o2.label + '</b></div>';
        }).join('') + '</div>';
      $$('[data-e2-opt]', body).forEach(function (tileO) {
        tileO.addEventListener('click', function () {
          st.draft[k] = dO.values[parseInt(tileO.getAttribute('data-e2-opt'), 10)];
          onChange();
        });
      });
    } else if (k === 'fold') {
      /* C164: fold style tiles (woven labels) — block photo, else the theme-asset fallback, else the inline schematic */
      var foldsF = CFG.folds || [];
      body.innerHTML = '<div class="np-e2-backings np-e2-borders np-e2-folds">' + foldsF.map(function (f2, nF) {
        var onF = st.draft.fold && st.draft.fold.label === f2.label;
        var svgF = foldSchematic(f2.label);
        return '<div class="np-e2-backtile' + (onF ? ' is-on' : '') + '" data-e2-pick="fold" data-e2-i="' + nF + '">' + (f2.img ? '<img src="' + f2.img + '" alt="' + f2.label + '" loading="lazy" onerror="this.onerror=null;this.src=\'' + svgF + '\'">' : '<img src="' + svgF + '" alt="' + f2.label + '">') + '<b>' + f2.label + '</b><i>' + (f2.note || '') + '</i></div>';
      }).join('') + '</div>';
    } else if (k === 'texture') {
      /* ═══ Background texture — molded flex surface ═══ */
      var texes = PTYPE.texture || [];
      body.innerHTML = '<p class="np-e2-wz-help">The molded surface texture behind your design.</p><div class="np-e2-backings np-e2-textures">' + texes.map(function (t2, nT) {
        var onT = st.draft.texture && st.draft.texture.label === t2.label;
        return '<div class="np-e2-backtile' + (onT ? ' is-on' : '') + '" data-e2-tex="' + nT + '"><img src="' + t2.img + '" alt="' + t2.label + '"><b>' + t2.label + '</b></div>';
      }).join('') + '</div>';
      $$('[data-e2-tex]', body).forEach(function (tileT) {
        tileT.addEventListener('click', function () {
          st.draft.texture = texes[parseInt(tileT.getAttribute('data-e2-tex'), 10)];
          onChange();
        });
      });
    }
    /* info tips are bound for EVERY step body — a tip click never counts as
       choosing the tile it sits on */
    $$('[data-e2-ftip]', body).forEach(function (tip) {
      tip.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        tip.classList.toggle('is-open');
      });
    });
    $$('[data-e2-pick]', body).forEach(function (tile) {
      tile.addEventListener('click', function () {
        var kind = tile.getAttribute('data-e2-pick');
        var n = parseInt(tile.getAttribute('data-e2-i'), 10);
        if (kind === 'shape') { st.draft.shape = CFG.shapes[n].label; st.__shapeSeeded175 = false; st.__shapeByFold178 = false; if (!npBackingOk(st.draft.backing, st.draft.border, st.draft.shape)) st.draft.backing = null; } /* C175: a real pick replaces the seeded Rectangle; C178: and any fold-forced shape; C476: a custom shape drops a Velcro pick */
        else if (kind === 'border') { st.draft.border = (n === -1 ? { label: 'No Border' } : CFG.borders[n]); if (!npBackingOk(st.draft.backing, st.draft.border, st.draft.shape)) st.draft.backing = null; } /* C475: Hot Cut drops a Velcro pick */
        else if (kind === 'bg') { st.draft.bg = CFG.bgs[n]; st.__bgSeeded166 = false; } /* C164c: a real pick is progress */
        else if (kind === 'thread') st.draft.thread = CFG.threads[n];
        else if (kind === 'text') st.draft.text = CFG.threads[n];
        else if (kind === 'fold') st.draft.fold = CFG.folds[n]; /* C164 */
        else st.draft.backing = CFG.backings[n];
        /* capture BEFORE onChange(): the re-render detaches this tile, and
           closest() on a detached node finds no ancestors — reading it after
           onChange() made the whole scroll block silently skip */
        var rowC = (kind === 'shape' && tile.closest) ? tile.closest('.np-e2-accrow') : null;
        var accI = rowC ? rowC.getAttribute('data-e2-acc') : null;
        onChange();
        /* SHAPE picked: bring this step's own row to the top of the screen so
           the Continue button is in view on every screen size — the shape grid
           is the tallest step, so on short viewports the button sat below the
           fold (Justin 2026-08-21). Clears the mobile sticky preview via
           npScrollPad(). */
        if (kind === 'shape') {
          /* onChange() re-renders the accordion, so the clicked tile's row is
             DETACHED by the time we measure (a detached node reports 0s and
             the scroll silently went nowhere). Capture the step index first,
             then re-query the live row after the re-render. */
          /* the accordion REBUILDS on pick, so the row is briefly absent from
             the DOM — a single rAF lands mid-rebuild, finds nothing and the
             scroll silently never happens. Poll briefly for the rebuilt row,
             and wait for its shape tiles (the tallest content) so the measured
             offset is the settled one. */
          if (accI !== null) (function () {
            var tries = 0;
            (function attempt() {
              var live = document.querySelector('.np-e2-accrow[data-e2-acc="' + accI + '"]');
              var ready = live && (live.querySelector('[data-e2-pick="shape"]') || tries > 6);
              if (!ready) {
                if (tries++ < 12) return setTimeout(attempt, 60);
                return;
              }
              /* target: row top below the sticky preview — but on SHORT
                 viewports the shape grid is taller than the visible band, so
                 the Continue button would still sit below the fold. The
                 button is the point (Justin): scroll however far it takes to
                 get it on screen, keeping as much of the grid visible as the
                 viewport allows. */
              var targetY = function () {
                var lv = document.querySelector('.np-e2-accrow[data-e2-acc="' + accI + '"]');
                if (!lv) return null;
                var y = lv.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
                var ct = lv.querySelector('.np-e2-acc-cont');
                if (ct) {
                  var yB = ct.getBoundingClientRect().bottom + window.pageYOffset - window.innerHeight + 16;
                  if (yB > y) y = yB;
                }
                return Math.max(0, y);
              };
              var yS = targetY();
              if (yS === null) return;
              window.scrollTo({ top: yS, behavior: 'smooth' });
              /* settle pass: the sticky preview re-measures mid-scroll and
                 some engines ignore smooth scrolling — recompute once the
                 layout settles and correct with an instant jump if off */
              setTimeout(function () {
                var y2 = targetY();
                if (y2 !== null && Math.abs(window.pageYOffset - y2) > 6) window.scrollTo(0, y2);
              }, 550);
            })();
          })();
        }
      });
    });
  }

  /* The accordion's DOM order is the CUSTOMER's order. WZ_STEPS indices are
     a stable key (liquid rows + WZ_TITLES ride them), so a type that wants a
     different sequence — custom names lead with Font, which is index 6 —
     reorders its ROWS, not the array. For every existing type the two orders
     are identical, so this returns exactly what the old index walk did. */
  function stepSeq() {
    var out = [];
    $$('.np-e2-accrow').forEach(function (r) {
      var n = parseInt(r.getAttribute('data-e2-acc'), 10);
      if (!isNaN(n) && WZ_STEPS[n] && stepEnabled(WZ_STEPS[n])) out.push(n);
    });
    if (!out.length) for (var i = 0; i < WZ_STEPS.length; i++) if (stepEnabled(WZ_STEPS[i])) out.push(i);
    return out;
  }
  function stepAfter(i) {
    var sq = stepSeq(), p = sq.indexOf(i);
    return (p === -1 || p === sq.length - 1) ? -1 : sq[p + 1];
  }
  function wzFirstIdx() { for (var a = 0; a < WZ_STEPS.length; a++) { if (stepEnabled(WZ_STEPS[a])) return a; } return 0; }
  function wzLastIdx() { for (var b = WZ_STEPS.length - 1; b >= 0; b--) { if (stepEnabled(WZ_STEPS[b])) return b; } return WZ_STEPS.length - 1; }
  function renderWizardFoot(i) {
    var lastI = wzLastIdx();
    var prev = $('#np-e2-wz-prev');
    prev.style.visibility = i === wzFirstIdx() ? 'hidden' : 'visible';
    var hasVal = !!draftValue(i);
    var next = $('#np-e2-wz-next');
    next.disabled = !hasVal;
    /* proof-first flow: the first wizard completion IS the generate action */
    next.textContent = i === lastI
      ? (st.versions.length ? (committed() ? 'Save selections' : 'Apply selections') : 'Apply and generate proof')
      : 'Next';
    $('#np-e2-wz-hint').style.display = hasVal ? 'none' : '';
    $('#np-e2-wz-save').hidden = !(committed() && i < lastI);
  }

  /* ═══ ON-PAGE OPTIONS ACCORDION (v2.1 — no modal; options are chosen
     right on the page, right column). Selections commit INSTANTLY, the
     next unset row auto-opens, and the 5th selection auto-fires the proof. */
  var accOpen = null;
  function accEnsureDraft() {
    if (!st.draft) st.draft = { shape: st.shape, border: st.border, fold: st.fold, bg: st.bg, thread: st.thread, backing: st.backing, proof: st.proof, texture: st.texture, font: st.font, opt1: st.opt1, opt2: st.opt2, opt3: st.opt3, text: st.text };
  }
  function openAcc(i) { accEnsureDraft(); accOpen = i; renderAccordion(); }
  function autoPickSingles() {
    /* a step with exactly ONE valid option needs no question — pre-select it
       (e.g. Custom Shape narrows border style to Hot Cut alone) */
    var changed = false;
    if (stepEnabled('border') && st.shape) {
      var blistA = effectiveBorders();
      var okA = st.border && blistA.some(function (b) { return b.label === st.border.label; });
      if (blistA.length === 1 && !okA) {
        st.border = blistA[0];
        if (st.draft) st.draft.border = blistA[0];
        changed = true;
      } else if (PTYPE.noMerrowGeom && st.border && !okA && blistA.length > 1) {
        /* C502: a border Full Color no longer offers (Hot Cut from a reorder or an Embroidered-builder hand-off, Merrow left over
           from a Heart / Design's Shape switch) is cleared — the customer re-picks and Add to Cart asks (C493) */
        st.border = null;
        if (st.draft) st.draft.border = null;
        changed = true;
      }
    }
    var bkE = effectiveBackings();
    if (bkE.length === 1 && !st.backing) {
      st.backing = bkE[0];
      if (st.draft) st.draft.backing = bkE[0];
      changed = true;
    }
    if (changed) { try { commitOptions(); } catch (eAp) {} }
  }
  /* C164: fold style — renderer instruction per option (woven labels). The fold is rendered as a real physical
     feature of the finished label; copy is generic (no image-specific numbers). */
  function foldPrompt(label) {
    var l = String(label || '').toLowerCase();
    if (/straight/.test(l)) return 'FOLD STYLE \u2014 STRAIGHT CUT: a flat woven label cut straight on all four sides with clean heat-sealed edges and NO folds \u2014 the edges finished exactly like a die-cut label: cut flat and clean right to the end. NO BORDER OF ANY KIND: no merrow, no stitched frame, no raised rim, no hem, no white margin or keyline; the edges are razor-flat heat-cut edges flush with the face, and the woven design and its background run right to the cut edge. Render it lying flat, face up, edges crisp.'; /* C189/C193 (Justin 2026-09-11): straight cut kept rendering a slight rim */
    if (/die|design/.test(l)) return 'FOLD STYLE \u2014 DIE CUT (DESIGN\u2019S SHAPE): the woven label is die-cut cleanly around the outline of the design instead of a plain rectangle, with sealed edges and NO folds. NO BORDER OF ANY KIND: no merrow, stitched frame, rim or margin \u2014 the weave runs to the cut edge. Render it lying flat, face up.'; /* C189 */
    if (/end/.test(l)) return 'FOLD STYLE \u2014 END FOLD: a rectangular woven label lying flat, photographed straight-on. Its LEFT and RIGHT ends are folded BACK behind the label, and from the front that shows only SUBTLY: a soft rounded fold at each side edge, and the folded end just peeking behind the label at the top-left and top-right corners (a small tucked flap), exactly like the classic end-fold diagram. Nothing sticks out sideways, no wings or tabs, no camera angle; top and bottom edges straight cut.'; /* C188: subtle, straight-on (Justin's reference photos) */
    if (/mit(re|er)/.test(l)) return 'FOLD STYLE \u2014 MITRE FOLD: each end of the label is folded back and up along a diagonal crease so it stands as a short upright tab at the top corner (for sewing into a seam), and the label body hangs below the two tabs as a WIDE, landscape shield with a shallow point at the bottom centre. Render it as a real folded label.';
    if (/horizontal/.test(l)) return 'FOLD STYLE \u2014 HORIZONTAL FOLD: the label is folded once in half so its two halves lie flat on top of each other, and the whole folded label LIES FLAT on the surface, photographed straight-on from above \u2014 exactly like the reference photo. It is NOT standing up, NOT a tent, NOT an open greeting card, no camera angle. The FOLD is the closed RIGHT edge; the OPENING (the two free edges) is the LEFT edge. The front panel faces the camera and carries the design. The back panel lies directly behind it, shifted a hair up and to the left, so a thin dark wedge of its top edge shows above the front panel\u2019s top edge \u2014 widest at the top-left corner and tapering to nothing at the right, where the two halves meet at the fold \u2014 and a sliver of it shows past the front panel\u2019s left edge. Nothing shows beyond the right edge. Never the other way round.'; /* C196 (Justin 2026-09-11, "not a standing folded label — it opens on the left side and folds on the right side like this [tile]"): flat, face-on, wedge top-left */
    if (/loop|cent(re|er)/.test(l)) return 'FOLD STYLE \u2014 CENTER FOLD (loop fold): the label is folded in half at its centre so its two open ends meet at the TOP, where they are sewn into the seam, and the FOLD is the BOTTOM edge \u2014 a soft rounded fold along the bottom; the label hangs from the seam as a closed loop. Only the FRONT half carries the design; the back half is plain label material. Render it as a real folded label, front half facing the camera, open ends at the top, the rounded fold at the bottom.' /* C184: fold at the bottom, opening at the top */
    return 'FOLD STYLE: ' + label + '. Render the label with that fold as a real physical feature of the finished label.';
  }
  /* C165: on woven labels the FOLD is the geometry — Die Cut follows the design's own outline (the template's custom
     shape block), every other fold is a rectangle (fixedShape). The shape step never shows; this keeps st.shape, the
     draft, the aspect seed and every downstream reader (compose, prompt, specs, _Shape) in step with the fold. */
  function applyFoldShape() {
    if (!PTYPE.foldShapes) {
      /* C178 (Justin 2026-09-11, 'move Design’s Shape back to Fold Type and when selected do not show shape options'):
         the Design’s Shape FOLD forces the template's custom-geometry shape (cut to the artwork outline, aspect from the
         artwork) and stepEnabled('shape') goes false so the Shape row disappears; switching to any other fold hands the
         shape back to the customer — a shape this fold forced is replaced by the seeded Rectangle below. */
      if (PTYPE.foldCustom) {
        var labC178 = null;
        (CFG.shapes || []).forEach(function (sC) { if (!labC178 && sC.geom === 'custom') labC178 = sC.label; });
        if (foldIsDesign178() && labC178) {
          if (st.shape !== labC178) {
            st.shape = labC178;
            if (st.draft) st.draft.shape = labC178;
            if (isFinite(st.artRatio) && st.artRatio > 0) { st.ratio = st.artRatio; st.h = clampSize(Math.round(st.w * st.ratio * 100) / 100, true); }
          }
          st.__shapeByFold178 = true; st.__shapeSeeded175 = false;
        } else if (st.__shapeByFold178 && st.shape === labC178) {
          st.shape = null; if (st.draft) st.draft.shape = null; st.__shapeByFold178 = false; /* falls through to the C175 seed */
        }
      }
      /* C175 (Justin 2026-09-11, 'bring the fold type back in the display and have it alternate with the shape the
         user chooses'): Shape is a real step on labels (C174), but the digital preview can only depict a fold on a
         geometry — so the moment a fold is picked with no shape chosen yet, the label's default shape (Rectangle) is
         seeded the way C166 seeds the white background: the Shape row opens next with Rectangle highlighted and any
         other pick re-draws the fold on that shape. A shape the customer already chose is never touched. */
      if (PTYPE.fold && st.fold && stepEnabled('shape') && !st.shape && !(st.draft && st.draft.shape)) {
        var labR175 = null;
        (CFG.shapes || []).forEach(function (sR) { if (!labR175 && sR.geom === 'rectangle') labR175 = sR.label; });
        if (labR175) {
          st.shape = labR175;
          if (st.draft) st.draft.shape = labR175;
          st.__shapeSeeded175 = true;
          var gR175 = shapeGeom();
          if (gR175 && gR175 !== 'custom' && !heightLocked()) { var dR175 = shapeDims(gR175, 1, npSelCropped()); st.ratio = dR175[1] / dR175[0]; st.h = clampSize(Math.round(st.w * st.ratio * 100) / 100, true); }
        }
      }
      return;
    }
    var wantF = (st.fold && /die|design/i.test(st.fold.label || '')) ? 'custom' : 'rectangle'; /* C167: the die-cut option is labelled "Design’s Shape" (Justin 2026-09-10) */
    var labF = null;
    (CFG.shapes || []).forEach(function (sF) { if (!labF && sF.geom === wantF) labF = sF.label; });
    if (!labF) labF = PTYPE.fixedShape ? PTYPE.fixedShape.label : st.shape;
    if (labF === st.shape) return;
    st.shape = labF;
    if (st.draft) st.draft.shape = labF;
    var gF = shapeGeom();
    if (gF === 'custom') { if (isFinite(st.artRatio) && st.artRatio > 0) { st.ratio = st.artRatio; st.h = clampSize(Math.round(st.w * st.ratio * 100) / 100, true); } } /* C165b: Design’s Shape follows the artwork's own aspect (rulers, height, size-mean price) */
    else if (gF && !heightLocked()) { var dF = shapeDims(gF, 1, npSelCropped()); st.ratio = dF[1] / dF[0]; st.h = clampSize(Math.round(st.w * st.ratio * 100) / 100, true); }
  }
  /* C168 (Justin 2026-09-10, "when a customer chooses fold type, the digital preview needs to update with that fold
     type"): the on-screen digital preview folds the composed FLAT label into the chosen fold — a schematic, front-on
     depiction (folded ends / tabs / back panel drawn in the label's own colours). ONLY renderMaskPreview uses it: the
     hosted composite (production _Upload, the renderer's flat reference) and every other caller stay flat. Straight
     Cut and Design’s Shape return the canvas untouched. */
  /* C178: on a foldCustom type the “Design’s Shape” fold option means die-cut to the artwork outline */
  function foldIsDesign178() { return !!(PTYPE.foldCustom && st.fold && /die|design/i.test(st.fold.label || '')); }
  function foldKind(label) {
    var l = String(label || '').toLowerCase();
    if (/end/.test(l)) return 'end';
    if (/mit(re|er)/.test(l)) return 'mitre';
    if (/loop|cent(re|er)/.test(l)) return 'loop'; /* C173 (Justin 2026-09-11): 'Center Fold' replaces Loop Fold — same fold, new name */
    if (/horizontal/.test(l)) return 'horizontal';
    return '';
  }
  /* C168: readers that reuse the on-screen preview as a PROOF or SIZE image must take the flat composite */
  function previewFlatSrc(pv) { return pv ? (pv.getAttribute('data-np-flat') || pv.src || '') : ''; }
  function foldDepiction(cv) {
    if (!cv || !PTYPE.fold || !st.fold || shapeGeom() === 'custom') return cv; /* C174: fold depiction follows the fold step */
    var kind = foldKind(st.fold.label);
    if (!kind) return cv;
    var W = cv.width, H = cv.height;
    /* the label's own colours: face colour from a pixel just inside the edge, a darker tone for the back side */
    var faceHex = (st.bg && st.bg.hex) || null;
    var rgb = [235, 235, 235];
    try {
      if (faceHex && /^#[0-9a-f]{6}$/i.test(faceHex)) rgb = [parseInt(faceHex.slice(1, 3), 16), parseInt(faceHex.slice(3, 5), 16), parseInt(faceHex.slice(5, 7), 16)];
      else { var px = cv.getContext('2d').getImageData(Math.max(0, Math.round(W * 0.03)), Math.round(H / 2), 1, 1).data; if (px[3] > 0) rgb = [px[0], px[1], px[2]]; }
    } catch (ePx) {}
    var tone = function (f, a) { return 'rgba(' + Math.round(rgb[0] * f) + ',' + Math.round(rgb[1] * f) + ',' + Math.round(rgb[2] * f) + ',' + (a == null ? 1 : a) + ')'; };
    var back = tone(0.72), backDeep = tone(0.58), crease = 'rgba(0,0,0,0.28)', sheen = 'rgba(255,255,255,0.22)';
    /* margins sized per fold so the label stays as large as possible in its box: only what each depiction draws outside the face */
    var mx = Math.round(W * (kind === 'mitre' ? 0.10 : kind === 'horizontal' ? 0.08 : kind === 'end' ? 0.06 : 0.03)); /* C171c: horizontal back panel protrudes left; C188: the end fold's corner peeks need a little room */
    var my = Math.round(H * (kind === 'mitre' ? 0.25 : kind === 'end' ? 0.16 : kind === 'horizontal' ? 0.17 : 0.05)); /* C188: end-fold corner peeks above the face; C192: the horizontal fold's back panel stands above the front */
    var out = document.createElement('canvas'); out.width = W + mx * 2; out.height = H + my * 2;
    var x = out.getContext('2d'); var ox = mx, oy = my; /* NB: the helpers below read `x` at call time (the loop branch swaps the canvas height and context) */
    var shadow = function (on) { if (on) { x.shadowColor = 'rgba(0,0,0,0.28)'; x.shadowBlur = Math.round(W * 0.03); x.shadowOffsetY = Math.round(W * 0.012); } else { x.shadowColor = 'transparent'; x.shadowBlur = 0; x.shadowOffsetY = 0; } };
    var face = function (sx, sw, dx, dw) { shadow(true); x.drawImage(cv, sx, 0, sw, H, dx, oy, dw, H); shadow(false); };
    var quad = function (pts, fill) { x.beginPath(); x.moveTo(pts[0][0], pts[0][1]); for (var i = 1; i < pts.length; i++) x.lineTo(pts[i][0], pts[i][1]); x.closePath(); x.fillStyle = fill; x.fill(); };
    var line = function (x1, y1, x2, y2, col, wdt) { x.beginPath(); x.moveTo(x1, y1); x.lineTo(x2, y2); x.strokeStyle = col; x.lineWidth = wdt || Math.max(1, W * 0.004); x.stroke(); };
    if (kind === 'end') {
      /* C188 (Justin 2026-09-11, four reference photos: 'it just needs to slightly express that the labels bend in on
         the left and right subtly' — the C187 three-quarter view had 'too much going on'): straight-on front view. The
         ends fold BACK behind the label and show only as (1) a soft rounded fold at each side edge with a shade band,
         (2) a thin sliver of the folded end just outside each edge and (3) the folded end's corner peeking above the
         top corners, like the classic end-fold diagram. Nothing sticks out sideways; top and bottom are straight cut. */
      var fw = Math.round(W * 0.13), vw = W - fw * 2, r = Math.round(H * 0.045), bw = Math.round(fw * 0.42), face0 = ox + fw, face1 = ox + fw + vw;
      var sl188 = Math.round(W * 0.016), triW = Math.round(fw * 0.5), triH = Math.round(H * 0.13);
      /* folded ends behind the face: corner peeks + side slivers, drawn first so the face covers their inner parts */
      shadow(true);
      quad([[face0 - sl188, oy + Math.round(H * 0.04)], [face0 + triW, oy - triH], [face0 + triW, oy], [face0 - sl188, oy]], tone(0.86));
      quad([[face1 + sl188, oy + Math.round(H * 0.04)], [face1 - triW, oy - triH], [face1 - triW, oy], [face1 + sl188, oy]], tone(0.86));
      quad([[face0 - sl188, oy + Math.round(H * 0.04)], [face0, oy], [face0, oy + H], [face0 - sl188, oy + H - Math.round(H * 0.04)]], tone(0.86));
      quad([[face1 + sl188, oy + Math.round(H * 0.04)], [face1, oy], [face1, oy + H], [face1 + sl188, oy + H - Math.round(H * 0.04)]], tone(0.86));
      shadow(false);
      var facePath188 = function () {
        x.beginPath();
        x.moveTo(face0 + r, oy); x.lineTo(face1 - r, oy); x.quadraticCurveTo(face1, oy, face1, oy + r);
        x.lineTo(face1, oy + H - r); x.quadraticCurveTo(face1, oy + H, face1 - r, oy + H);
        x.lineTo(face0 + r, oy + H); x.quadraticCurveTo(face0, oy + H, face0, oy + H - r);
        x.lineTo(face0, oy + r); x.quadraticCurveTo(face0, oy, face0 + r, oy); x.closePath();
      };
      shadow(true); facePath188(); x.fillStyle = tone(1); x.fill(); shadow(false);
      x.save(); facePath188(); x.clip();
      x.drawImage(cv, fw, 0, vw, H, face0, oy, vw, H);
      var gL188 = x.createLinearGradient(face0, 0, face0 + bw, 0); gL188.addColorStop(0, 'rgba(0,0,0,0.14)'); gL188.addColorStop(1, 'rgba(0,0,0,0)'); x.fillStyle = gL188; x.fillRect(face0, oy, bw, H);
      var gR188 = x.createLinearGradient(face1, 0, face1 - bw, 0); gR188.addColorStop(0, 'rgba(0,0,0,0.14)'); gR188.addColorStop(1, 'rgba(0,0,0,0)'); x.fillStyle = gR188; x.fillRect(face1 - bw, oy, bw, H);
      x.restore();
      line(face0 + 1, oy + r, face0 + 1, oy + H - r, sheen, Math.max(1, W * 0.004));
      line(face1 - 1, oy + r, face1 - 1, oy + H - r, sheen, Math.max(1, W * 0.004));
    } else if (kind === 'mitre') {
      /* C170 (Justin: 'mitre could be a little wider'): the body is a WIDE pentagon 10% wider than the flat label; the face is
         scaled uniformly to fill it (tiny crop, no stretch); the shadow is painted on the outline BEFORE clipping (review) */
      var bwM = Math.round(W * 1.1), bxM = ox - Math.round((bwM - W) / 2), tipM = Math.round(H * 0.09), pointM = Math.round(H * 0.85), lipM = Math.round(H * 0.05);
      var twM = Math.round(bwM * 0.22), thM = Math.round(H * 0.19); /* C171c (Justin: 'slightly less tall, keep width, shorten the wings') */
      var pentM = function () { x.beginPath(); x.moveTo(bxM, oy); x.lineTo(bxM + bwM, oy); x.lineTo(bxM + bwM, oy + pointM); x.lineTo(bxM + bwM / 2, oy + H + tipM); x.lineTo(bxM, oy + pointM); x.closePath(); };
      shadow(true);
      quad([[bxM, oy - thM], [bxM + twM, oy - thM], [bxM + twM, oy + lipM], [bxM, oy + lipM]], tone(1)); /* C179: own material */
      quad([[bxM + bwM - twM, oy - thM], [bxM + bwM, oy - thM], [bxM + bwM, oy + lipM], [bxM + bwM - twM, oy + lipM]], tone(1));
      pentM(); x.fillStyle = tone(1); x.fill();
      shadow(false);
      var gT179 = x.createLinearGradient(0, oy + lipM, 0, oy - thM); gT179.addColorStop(0, 'rgba(0,0,0,0.20)'); gT179.addColorStop(1, 'rgba(0,0,0,0.02)'); /* C179: the tabs sit in the body's shade at their base */
      quad([[bxM, oy - thM], [bxM + twM, oy - thM], [bxM + twM, oy + lipM], [bxM, oy + lipM]], gT179);
      quad([[bxM + bwM - twM, oy - thM], [bxM + bwM, oy - thM], [bxM + bwM, oy + lipM], [bxM + bwM - twM, oy + lipM]], gT179);
      x.save(); pentM(); x.clip();
      var scM = Math.max(bwM / W, (H + tipM) / H), dwM = Math.round(W * scM), dhM = Math.round(H * scM);
      x.drawImage(cv, bxM + Math.round((bwM - dwM) / 2), oy, dwM, dhM); x.restore();
      line(bxM, oy, bxM + twM, oy + lipM, crease); line(bxM + bwM, oy, bxM + bwM - twM, oy + lipM, crease);
    } else if (kind === 'loop') {
      /* C184 (Justin 2026-09-11, 'center fold: the fold has to be at the bottom and the opening up top'): a CENTER FOLD
         hangs from the seam — the two open ends are sewn in at the TOP and the FOLD is the BOTTOM edge. Front panel
         faces us: a straight cut top edge with the back panel's edge just visible above it (two layers), a soft rounded
         fold along the bottom with a shade band where the material turns under. C168/C169 drew the fold along the top. */
      var r = Math.round(H * 0.08), lip = Math.round(H * 0.025);
      var loopPath184 = function () {
        x.beginPath(); x.moveTo(ox, oy); x.lineTo(ox + W, oy); x.lineTo(ox + W, oy + H - r); x.quadraticCurveTo(ox + W, oy + H, ox + W - r, oy + H);
        x.lineTo(ox + r, oy + H); x.quadraticCurveTo(ox, oy + H, ox, oy + H - r); x.closePath();
      };
      shadow(true); quad([[ox, oy - lip], [ox + W, oy - lip], [ox + W, oy + lip], [ox, oy + lip]], tone(0.9)); shadow(false); /* the back panel's open end, just above */
      shadow(true); loopPath184(); x.fillStyle = tone(1); x.fill(); shadow(false);
      x.save(); loopPath184(); x.clip(); x.drawImage(cv, ox, oy);
      var grB184 = x.createLinearGradient(0, oy + H, 0, oy + H - Math.round(H * 0.16)); grB184.addColorStop(0, 'rgba(0,0,0,0.16)'); grB184.addColorStop(1, 'rgba(0,0,0,0)'); x.fillStyle = grB184; x.fillRect(ox, oy + H - Math.round(H * 0.16), W, Math.round(H * 0.16));
      x.restore();
      line(ox, oy, ox + W, oy, crease);
    } else if (kind === 'horizontal') {
      /* C192 (Justin 2026-09-11, 'horizontal fold is supposed to look like image 2 [its own tile] — fold on the RIGHT,
         opening on the LEFT, at that angle'): folded once like a BOOK. The front panel faces us; the FOLD is the spine
         along the RIGHT edge; the back panel opens slightly behind toward the LEFT and stands a little taller, so its
         slanted top edge shows above and behind the front panel and a shaded sliver of it shows past the left edge. */
      var dx = Math.round(W * 0.07), up = Math.round(H * 0.14);
      var hinge = ox + W - Math.round(W * 0.012);
      shadow(true); quad([[ox - dx, oy - up], [hinge, oy], [hinge, oy + H], [ox - dx, oy + H]], tone(0.88)); shadow(false); /* C196: the wedge tapers to nothing where the halves meet at the fold */
      var shL192 = x.createLinearGradient(ox, 0, ox - dx, 0); shL192.addColorStop(0, 'rgba(0,0,0,0.30)'); shL192.addColorStop(1, 'rgba(0,0,0,0)'); x.fillStyle = shL192; x.fillRect(ox - dx, oy - up, dx, H + up);
      face(0, W, ox, W);
      line(ox + W, oy, ox + W, oy + H, crease); /* the spine */
    }
    return out;
  }
  /* C164: inline schematic per fold (data URI SVG) — the tile image until a block photo / theme asset exists */
  function foldSchematic(label) {
    var l = String(label || '').toLowerCase(), b = '';
    var face = '#1f2a5c', dark = '#141c3f', art = '#e8dcc0';
    if (/straight/.test(l)) b = '<rect x="12" y="24" width="96" height="34" fill="' + face + '"/><rect x="34" y="35" width="52" height="4" fill="' + art + '"/><rect x="44" y="43" width="32" height="3" fill="' + art + '"/>';
    else if (/die|design/.test(l)) b = '<path d="M20 18 H100 L110 28 V54 L100 64 H20 L10 54 V28 Z" fill="' + face + '"/><rect x="36" y="36" width="48" height="4" fill="' + art + '"/><rect x="46" y="44" width="28" height="3" fill="' + art + '"/>';
    else if (/end/.test(l)) b = '<path d="M22 24 L12 15 V51 L22 60 Z" fill="' + dark + '"/><path d="M98 24 L108 15 V51 L98 60 Z" fill="' + dark + '"/><rect x="22" y="24" width="76" height="36" fill="' + face + '"/><rect x="38" y="37" width="44" height="4" fill="' + art + '"/><rect x="46" y="45" width="28" height="3" fill="' + art + '"/>';
    else if (/mit(re|er)/.test(l)) b = '<rect x="14" y="12" width="24" height="14" fill="' + dark + '"/><rect x="82" y="12" width="24" height="14" fill="' + dark + '"/><path d="M14 26 H106 V46 L60 70 L14 46 Z" fill="' + face + '"/><rect x="38" y="33" width="44" height="4" fill="' + art + '"/><rect x="46" y="41" width="28" height="3" fill="' + art + '"/>';
    else if (/horizontal/.test(l)) b = '<rect x="20" y="12" width="88" height="36" fill="' + dark + '"/><rect x="12" y="26" width="88" height="42" fill="' + face + '"/><rect x="32" y="41" width="48" height="4" fill="' + art + '"/><rect x="42" y="49" width="28" height="3" fill="' + art + '"/>';
    else if (/loop|cent(re|er)/.test(l)) b = '<rect x="38" y="14" width="58" height="44" rx="2" fill="' + dark + '"/><rect x="26" y="22" width="58" height="44" rx="2" fill="' + face + '"/><rect x="38" y="38" width="34" height="4" fill="' + art + '"/><rect x="44" y="46" width="22" height="3" fill="' + art + '"/>';
    else b = '<rect x="12" y="24" width="96" height="34" fill="' + face + '"/>';
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 80">' + b + '</svg>');
  }
  function stepHelpText(k) {
    if (k === 'bg') return isFreeFormShape() ? 'Free form is molded in ONE solid color — this is the color of every piece.' : (PTYPE.bgHelp || 'The felt color behind your artwork.');
    if (k === 'thread') return PTYPE.threadHelp || 'The stitched border around the edge of your patch.';
    if (k === 'text') return PTYPE.textHelp || 'The thread color of the lettering.';
    if (k === 'border') return 'How the edge of your patch is finished.';
    if (k === 'fold') return 'How the finished label is folded or cut for sewing in.'; /* C164 */
    return '';
  }
  function renderAccordion() {
    autoPickSingles();
    accEnsureDraft();
    $$('.np-e2-accrow').forEach(function (row) {
      var i = parseInt(row.getAttribute('data-e2-acc'), 10);
      /* rows that are not wizard steps (the tackle-twill lettering and border
         stitch panels) own their own visibility — walking them here made
         stepEnabled(undefined) fall through to true and showed an empty
         Border stitch row on leather and faux leather */
      if (isNaN(i)) return;
      var enR = stepEnabled(WZ_STEPS[i]);
      row.hidden = !enR;
      var doneR = !!st[WZ_STEPS[i]] && !(WZ_STEPS[i] === 'shape' && cornersNeeded());
      row.classList.toggle('is-done', doneR && !open);
      if (!enR) { var bR = row.querySelector('[data-e2-accbody]'); if (bR) { bR.hidden = true; bR.innerHTML = ''; } return; }
      var labR = row.querySelector('.np-e2-accrow__lab');
      if (labR) {
        /* ONE decision, resolved into a variable before anything else touches
           this block. This used to be an if/else-if chain and an unrelated
           insertion in the middle of it re-parented the later arms onto the
           hint's own `if`, silently dropping the thread row's label. */
        var labTxt = null;
        if (WZ_STEPS[i] === 'bg') labTxt = isFreeFormShape() ? 'Patch color' : (PTYPE.bgLabel || null);
        else if (WZ_STEPS[i] === 'thread') labTxt = PTYPE.threadLabel || null;
        else if (WZ_STEPS[i] === 'text') labTxt = PTYPE.textLabel || 'Text Color';
        else if (WZ_STEPS[i] === 'font') labTxt = 'Font style';
        else if (WZ_STEPS[i] === 'fold') labTxt = 'Fold style'; /* C164 */
        else if (optDef(WZ_STEPS[i])) labTxt = optDef(WZ_STEPS[i]).name;
        if (labTxt) labR.textContent = labTxt;
        /* the explainer sits BESIDE the row label, freeing the body row for the
           choice buttons (which no longer fit alongside it) */
        var hintR = labR.parentNode.querySelector('.np-e2-accrow__hint');
        var hintTxt = stepHelpText(WZ_STEPS[i]);
        if (hintTxt) {
          if (!hintR) {
            hintR = document.createElement('span');
            hintR.className = 'np-e2-accrow__hint';
            labR.parentNode.insertBefore(hintR, labR.nextSibling);
          }
          hintR.textContent = hintTxt;
        } else if (hintR) { hintR.remove(); }
      }
      var open = accOpen === i;
      row.classList.toggle('is-open', open);
      /* the lifted choice buttons belong to the OPEN panel — left in the header
         of a collapsed row they sat on top of the done check */
      if (!open) {
        var closedActs = row.querySelector('.np-e2-accrow__head .np-e2-colorhead__acts');
        if (closedActs) closedActs.parentNode.removeChild(closedActs);
      }
      var body = row.querySelector('[data-e2-accbody]');
      if (!body) return;
      body.hidden = !open;
      if (open) {
        renderStepBody(i, body, function () { accApply(i); });
        /* lift the colour-step choice buttons onto the ROW HEADER line — they
           are the widest thing in the panel and sitting them beside the label
           reclaims a whole row of vertical space. The header is itself the
           open/close click target, so the moved buttons must stop the click
           from bubbling or every press would collapse the row. */
        var actsA = body.querySelector('.np-e2-colorhead__acts');
        var headA = row.querySelector('.np-e2-accrow__head');
        var staleA = headA && headA.querySelector('.np-e2-colorhead__acts');
        if (staleA && staleA !== actsA) staleA.parentNode.removeChild(staleA);
        if (actsA && headA) {
          actsA.classList.add('np-e2-acts--inhead');
          actsA.addEventListener('click', function (eA) { eA.stopPropagation(); });
          headA.appendChild(actsA);
        }
        /* explicit stepping: each section ends with its own Continue — except
           the LAST one, where the big footer "Generate AI Proof" is the CTA */
        var nxC = stepAfter(i);
        /* shape needs a label too: it is usually the FIRST step, but on
           variant-sized products (keychains) the size option precedes it —
           without this the button read "Continue to undefined" */
        var STEP_LABELS = { size: 'Sizing' /* C229 */, shape: 'Shape', fold: 'Fold Style' /* C164 */, text: PTYPE.textLabel || 'Text Color', bg: (isFreeFormShape() ? 'Patch Color' : (PTYPE.bgLabel || 'Background Color')), border: 'Border Style', thread: PTYPE.threadLabel || 'Border Thread', backing: 'Backing', texture: 'Background Texture', proof: 'Your Proof Type', font: 'Font Style' };
        ['opt1', 'opt2', 'opt3'].forEach(function (kL) { var dL = optDef(kL); if (dL) STEP_LABELS[kL] = dL.name; });
        var has = !!st[WZ_STEPS[i]];
        if (WZ_STEPS[i] === 'shape' && cornersNeeded()) has = false;
        var cont = document.createElement('div');
        cont.className = 'np-e2-acc-cont';
        var inSlotC = row.parentElement && row.parentElement.id === 'np-e2-tt-fontslot';
        if (PTYPE.textLines && inSlotC && row === row.parentElement.lastElementChild) {
          cont.innerHTML = '<button type="button" class="np-e2-btn np-e2-btn--green np-e2-acc-cont__btn" data-e2-acctext="1"' + (has ? '' : ' disabled') + '>Continue to your lettering</button>';
        } else if (nxC !== -1) {
          var nxLbl = STEP_LABELS[WZ_STEPS[nxC]];
          /* the stitch picker sits between the colours and Backing — it is not
             an accordion row, so the hand-off names IT, not Backing */
          if (PTYPE.stitches && WZ_STEPS[nxC] === 'backing') nxLbl = 'Border stitch';
          cont.innerHTML = '<button type="button" class="np-e2-btn np-e2-btn--green np-e2-acc-cont__btn" data-e2-acccont="' + i + '"' + (has ? '' : ' disabled') + '>Continue to ' + nxLbl + '</button>';
        } else {
          /* last step: close up and hand off to the proof CTA — or, on a
             no-artwork type, straight to the names roster */
          /* Once the LAST step is answered the Generate AI Proof button (and
             its bypass line) is already showing right below — a second
             "Continue to Your Proof" is noise, so it only appears while the
             step is still unanswered (Justin 2026-08-21). Names types keep
             theirs: the roster is a separate destination, not the CTA. */
          if (WZ_STEPS[i] === 'size' || (has && !PTYPE.names)) cont.innerHTML = ''; /* C229 (Justin 2026-09-17): the Size row has no Continue — the Generate AI Proof button and its bypass line appear below the moment the size is in the window, like Backing used to */
          else cont.innerHTML = '<button type="button" class="np-e2-btn np-e2-btn--green np-e2-acc-cont__btn" data-e2-accdone="1"' + (has ? '' : ' disabled') + '>Continue to ' + (PTYPE.names ? 'Your Names' : 'Your Proof') + '</button>';
        }
        body.appendChild(cont);
      }
      else body.innerHTML = '';
    });
    renderOptions();
  }
  function accApply(i) {
    /* instant commit — but STAY on this row; the Continue button advances */
    var wasLocked = heightLocked();
    var prevShape = st.shape;
    st.shape = st.draft.shape;
    var nowLocked = heightLocked();
    if (wasLocked && !nowLocked) {
      st.h = Math.max(SIZE_MIN, Math.round(st.w * st.ratio * 100) / 100);
    }
    if (st.shape !== prevShape && !nowLocked) {
      /* the PATCH defines the proportions, not the artwork — a Rectangle
         patch seeds rectangle numbers even when the logo is ultra-wide */
      var gA = shapeGeom();
      if (gA && gA !== 'custom') {
        var dA = shapeDims(gA, 1, npSelCropped()); /* C43 */
        st.ratio = dA[1] / dA[0];
        st.h = clampSize(Math.round(st.w * st.ratio * 100) / 100, true);
      }
    }
    st.border = st.draft.border;
    st.fold = st.draft.fold; /* C164 */
    applyFoldShape(); /* C165 */
    st.bg = st.draft.bg;
    st.thread = st.draft.thread;
    st.backing = st.draft.backing;
    st.texture = st.draft.texture;
    st.text = st.draft.text;
    st.proof = st.draft.proof;
    st.font = st.draft.font;
    commitOptStep();
    /* 2 Layers -> 1 Layer: there is no underlay any more, so the outline colour
       is dropped from state AND from the order (a stale one would ship) */
    if (PTYPE.layersOpt && !twoLayers()) {
      st.thread = null;
      if (st.draft) st.draft.thread = null;
    }
    commitOptions();
    if (heightLocked()) st.h = st.w;
    commitSizeQty();
    /* font / layers / colour / SIZE changes all change how the lettering draws,
       and the size option drives the rulers — repaint, do not just re-read */
    if (PTYPE.textLines) ttSync();
    unapproveIfChanged();
    renderAccordion();
  }

  function applyDraft() {
    var wasLocked = heightLocked();
    st.shape = st.draft.shape;
    var nowLocked = heightLocked();
    if (wasLocked && !nowLocked) {
      /* back to a free shape: repopulate the proportional height from the
         image's own aspect ratio */
      st.h = Math.max(SIZE_MIN, Math.round(st.w * st.ratio * 100) / 100);
    }
    st.border = st.draft.border;
    st.fold = st.draft.fold; /* C164 */
    applyFoldShape(); /* C165 */
    st.bg = st.draft.bg;
    st.thread = st.draft.thread;
    st.backing = st.draft.backing;
    st.texture = st.draft.texture;
    st.text = st.draft.text;
    st.proof = st.draft.proof;
    commitOptStep();
    /* 2 Layers -> 1 Layer: there is no underlay any more, so the outline colour
       is dropped from state AND from the order (a stale one would ship) */
    if (PTYPE.layersOpt && !twoLayers()) {
      st.thread = null;
      if (st.draft) st.draft.thread = null;
    }
    commitOptions();
    if (heightLocked()) st.h = st.w;
    commitSizeQty();
    renderOptions();
    closeWizard();
    if (wzReturnToProof) {
      wzReturnToProof = false;
      pf.hidden = false;
      if (st.versions.length) { st.proofPhase = 'ready'; renderProofReady(); }
    } else if (!st.versions.length && st.shape && st.border && st.bg && st.thread && st.backing) {
      /* all set: the customer explicitly picks Generate AI Proof or Skip */
      var fB2 = document.getElementById('np-e2-proofbtn');
      if (fB2) { var yB2 = fB2.getBoundingClientRect().top + window.pageYOffset - npScrollPad() - 80; window.scrollTo({ top: Math.max(0, yB2), behavior: 'smooth' }); }
    }
  }

  /* ═══ PATCH-SENSEI PROOFING (the same backend Shinobi / the proof-
     preview page uses — see sections/proof-preview-v3.liquid).
     Contract: POST {EP}/api/proof/session {cart_token, line_items:[{
       line_item_id, title, quantity, artwork_url, specs:{shape,
       background_color, border_color, width_inches, height_inches, ...}}]}
     → {session_id, line_items:[{line_item_id, mockup_url, status
       pending|ready, decision, revision_count, revision_limit, error}]}
     GET {EP}/api/proof/session/{cartToken} to poll; POST
     {EP}/api/proof/decision {session_id, line_item_id, status, note}.
     The item must be IN the cart first (sessions are cart-token keyed).
     The canvas composite below stays as the offline fallback. ═══ */
  var SENSEI_EP = 'https://d14rzh04nceswa.cloudfront.net';
  var sensei = { sessionId: null, lineItemId: null, renderLineId: null, cartToken: null, added: false, busy: false };

  var npPutQ = Promise.resolve();
  function npPut(url, body, hdrs) {
    /* UPLOAD GATE (Justin 2026-08-24, B30): approval fires several multi-MB
       PNG uploads at once — they saturated the customer's upstream and the
       tiny /cart/add POST drowned behind them (server measured 0.4s while
       the browser waited 20s). All background PUTs now run ONE at a time,
       and hold completely while a checkout is in flight. */
    var run = function () { return fetch(url, hdrs ? { method: 'PUT', body: body, headers: hdrs } : { method: 'PUT', body: body }); };
    /* B52: the serial queue is GONE — it was built on the disproven
       saturation theory and became the bottleneck itself (sheet PNGs stuck
       for 30s behind multi-MB proof copies, beacon-proven). Browsers manage
       upload parallelism fine. */
    return run();
  }
  function coMark(n) {
    /* checkout sub-beacon: appends to the same localStorage timeline the
       doCheckout stages write — survives the /cart navigation */
    try { var t = Math.round(performance.now()); localStorage.setItem('np_co_log', (localStorage.getItem('np_co_log') || '') + n + '@' + t + 'ms | '); console.log('[np-e2] co', n, t + 'ms'); } catch (eM) {}
  }
  /* B76: wall-clock every cleanFetch cart call so np_co_log always has a
     number even when resource timing is unavailable. */
  function cfTimed(url, opts, tag) {
    var t0 = Date.now();
    return cleanFetch()(url, opts).then(function (r) {
      try { coMark('cf:' + tag + ':' + (Date.now() - t0) + 'ms:' + r.status); } catch (e) {}
      return r;
    }, function (e) {
      try { coMark('cf:' + tag + ':FAIL:' + (Date.now() - t0) + 'ms'); } catch (e2) {}
      throw e;
    });
  }
  function cleanFetch() {
    /* window.fetch AND XMLHttpRequest are WRAPPED by theme/app scripts on
       this store (measured 2026-08-24) — a wrapper can queue a /cart/add
       behind its own drawer re-renders for tens of seconds. Cart calls on
       the checkout path use a PRISTINE fetch from a hidden same-origin
       iframe that no wrapper has touched. Falls back to window.fetch. */
    try {
      if (cleanFetch.__f) return cleanFetch.__f;
      var ifr = document.createElement('iframe');
      ifr.setAttribute('aria-hidden', 'true');
      ifr.style.display = 'none';
      document.documentElement.appendChild(ifr); /* stays attached — removing it kills its realm */
      cleanFetch.__ifr = ifr;
      cleanFetch.__f = ifr.contentWindow.fetch.bind(window);
      return cleanFetch.__f;
    } catch (eCF) { return window.fetch.bind(window); }
  }
  function cartJson() { return cleanFetch()('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

  function ourCartLine(cart) {
    /* Shopify RE-KEYS a cart line whenever its properties change, so a stored
       key goes stale after every /cart/change.js that touches properties.
       Match by key first, then by this session's artwork/proof fingerprint —
       and NEVER fall back to an arbitrary line (that clobbers other patches). */
    /* C427 (PATCH-2115499, 2026-09-25): NOTHING in the cart belongs to this page until its OWN add has landed.
       sensei.added is set only by add-ok and no arrival resumes an existing line, so before that every match is
       another patch's line. The "design another" page adopted patch 1's line (findOurLine's cart.items[0]
       fallback feeding the key match below), rewrote it with patch 2's options, and C125 then stripped patch 1's
       sheets, which is how line 2 shipped with patch 1's render and no _Upload. */
    if (!sensei.added) return null;
    var items = (cart && cart.items) || [];
    var keyOf = function (it) { return it.key || String(it.id); };
    var byKey = items.filter(function (it) { return keyOf(it) === sensei.lineItemId; })[0] ||
      (sensei.__addKey ? items.filter(function (it) { return keyOf(it) === sensei.__addKey; })[0] : null); /* C427: the line our add made */
    if (byKey) { sensei.lineItemId = keyOf(byKey); return byKey; }
    var marks = [], own = [];
    var art = cleanUrl(artworkUrl());
    if (art) marks.push(art.split('/').pop().split('?')[0]);
    st.versions.forEach(function (x) {
      [x.hosted, x.frozenProof, x.alpha].forEach(function (uM) {
        if (!uM || !/^https?:/i.test(String(uM))) return;
        var bM = String(uM).split('/').pop().split('?')[0];
        if (bM) { marks.push(bM); own.push(bM); }
      });
    });
    marks = marks.filter(Boolean);
    if (!marks.length) return null;
    var hits = items.filter(function (it) {
      var blob = JSON.stringify(it.properties || {});
      return marks.some(function (m) { return blob.indexOf(m) > -1; });
    });
    /* C427: two patches can share one design file. Rank the hits instead of taking the first (Shopify lists the
       NEWEST line first): a line holding this page's own render wins, then the one whose size and options match */
    var hit = null, best = -1;
    hits.forEach(function (it) {
      var pH = it.properties || {}, blobH = JSON.stringify(pH), sc = 0;
      try {
        if (own.some(function (m) { return blobH.indexOf(m) > -1; })) sc += 100;
        if (pH['_Width (in)'] === st.w.toFixed(2)) sc += 2;
        if (pH['_Height (in)'] === st.h.toFixed(2)) sc += 2;
        if (st.shape && pH['_Shape'] === st.shape) sc += 1;
        if (st.border && pH['_Border Style'] === normalizeBorder(st.border.label)) sc += 1;
      } catch (eSc427) {}
      if (sc > best) { best = sc; hit = it; }
    });
    if (hit) sensei.lineItemId = keyOf(hit); /* re-key for later calls */
    return hit || null;
  }
  function origBase(uO) { return String(uO || '').split('?')[0].split('&')[0].split('/').pop(); } /* C427 */

  function curLineState() {
    /* fingerprint of what the CART LINE should hold — when the line already
       matches, the click has nothing left to write and can navigate at once.
       Includes an OPTIONS fingerprint (B43): an option flipped after approval
       must force the full sync, never ride the fast path with stale props. */
    var v = null; try { v = nearestVariant(); } catch (eV) {}
    var opts = '';
    try {
      opts = [st.shape, st.corners, st.fold && st.fold.label /* C164b */, st.border && st.border.label, st.bg && st.bg.label,
        st.thread && st.thread.label, st.text && st.text.label, st.backing && st.backing.label,
        st.texture && st.texture.label, st.font && st.font.label,
        (st.selected !== null && st.selected !== undefined && st.versions[st.selected]) ? (st.versions[st.selected].frozenProof || st.versions[st.selected].hosted || '') : ''
      ].map(function (xO) { return xO || ''; }).join('~');
    } catch (eO) {}
    return st.w.toFixed(2) + '|' + st.h.toFixed(2) + '|' + st.qty + '|' + ((v && v.id) || '') + '|' + opts;
  }
  function formPropsObject() {
    /* the SAME property set an add would carry — scraped from the prepared
       form, the single source of truth for order props */
    var form = document.querySelector('product-form.product-form form');
    if (!form) return null;
    var o = {};
    try {
      new FormData(form).forEach(function (vF, kF) {
        var mF = /^properties\[(.+)\]$/.exec(kF);
        if (mF && typeof vF === 'string' && vF.trim() !== '') o[mF[1]] = vF;
      });
    } catch (eFP) { return null; }
    return o;
  }
  function mergedOrderProps() {
    /* B51: outgoing REPLACE-writes merge the line snapshot with the form —
       late-arriving props (the _Mockup Catalog copy lands only after its
       upload) can never be raced off the order again */
    var base = {};
    try { var sp = (sensei.__lineSnap && sensei.__lineSnap.props) || {}; Object.keys(sp).forEach(function (k) { base[k] = sp[k]; }); } catch (eM1) {}
    var f = formPropsObject() || {};
    Object.keys(f).forEach(function (k) { base[k] = f[k]; });
    return base;
  }
  function lineSnapMatchesSession() {
    /* C124 (2026-09-01, order 7843192308031 line 2): finalSyncFire and
       fireSheetStamp write READ-FREE to a remembered line index, merging the
       remembered snapshot's props as the base (B51). In a multi-line cart
       that snapshot can belong to a DIFFERENT patch — the order above
       shipped a week-old FULLCOLOR spec pair ("Sun City Contracting",
       dk111vy5g, composed Aug 24) as _AI Proof/_Upload on an EMBROIDERY line
       whose _Original Image and _cartImg were the fresh design (Pinewood,
       Aug 31): the form had no sheet inputs at merge time, so the foreign
       line's pair survived into the outgoing write. IDENTITY RULE: a
       snapshot is only OUR line if its _Original Image anchor matches the
       session's. On mismatch the read-free fast path STANDS DOWN entirely
       (the read-based sync re-finds the line by artwork fingerprint) —
       skipping a fast write is always better than corrupting a line. */
    try {
      var snapP = (sensei.__lineSnap && sensei.__lineSnap.props) || null;
      if (!snapP) return true;
      var soI = String(snapP['_Original Image'] || '').split('?')[0].split('/').pop();
      var foI = String(formProp('_Original Image') || '').split('?')[0].split('/').pop();
      if (soI && foI && soI !== foI) {
        try { coMark('snap-identity-mismatch'); } catch (eIm) {}
        try { console.warn('[np-emb2] C124: line snapshot holds a different design (' + soI.slice(-40) + ' vs ' + foI.slice(-40) + ') — read-free write skipped'); } catch (eIw) {}
        return false;
      }
      return true;
    } catch (eLm) { return true; }
  }
  /* C125 (2026-09-01, Justin: "every order has to be from that user's
     session that's happening at that moment"): order 7843192308031 carried
     ANOTHER design's spec-sheet pair in _AI Proof/_Upload on a FIRST-TIME
     customer's line — the entry channel is not yet proven (foreign cart
     line via shared cart/browser, or a caching/injection layer echoing
     another session's values), so enforce the invariant at the WRITE
     regardless of channel: a spec sheet may only ride an outgoing write if
     its --spec-dk token was computed by THIS session (or arrived on this
     session's own URL params). Foreign sheets are dropped — production
     then renders from the line's own _Original Image, which is always
     safer than foreign paperwork. */
  sensei.__sessionDks = sensei.__sessionDks || {};
  function dkOfUrl(uD) { var mD = /--spec-dk([a-z0-9]+)/i.exec(String(uD || '')); return mD ? mD[1] : ''; }
  function regSessionDk(tD) { if (tD) sensei.__sessionDks[tD] = 1; }
  try {
    var qsD = new URLSearchParams(location.search);
    ['np_proof', 'file', 'np_art'].forEach(function (kQ) { regSessionDk(dkOfUrl(qsD.get(kQ))); });
  } catch (eQD) {}
  function scrubForeignSheets(propsS, whereS) {
    try {
      ['_AI Proof', '_Upload', '_Preview Image'].forEach(function (kS) {
        var tS = dkOfUrl(propsS && propsS[kS]);
        if (tS && !sensei.__sessionDks[tS]) {
          delete propsS[kS];
          try { coMark('foreign-sheet-dropped:' + whereS); } catch (eSc1) {}
          try { console.warn('[np-emb2] C125: dropped foreign spec sheet (dk' + tS + ') from ' + kS + ' at ' + whereS); } catch (eSc2) {}
        }
      });
    } catch (eSc) {}
    return propsS;
  }
  function finalSyncFire() {
    /* B46 — THE checkout write: one read-free /cart/change built entirely
       from local state, aimed at the snapshot's line index. This store
       commits mutations the instant they arrive even when responses crawl
       (0.4s-32s measured), so firing IS finishing. Returns true when the
       composed spec sheets rode along. */
    if (!sensei.added || !sensei.__lineSnap) return false;
    if (!lineSnapMatchesSession()) return false; /* C124 */
    try {
      commitOptions(); commitSizeQty();
      /* B54: the freshness token is computed BEFORE this function's own
         setProps/prune mutate the form — comparing across that boundary made
         the token drift on EVERY click and forced a pointless recompose. */
      var pre = sensei.__preSheets, dkN = null;
      try { dkN = specDkToken(specLines(specFormProps())); } catch (eDk2) {}
      regSessionDk(dkN); /* C125 */
      var complete = !!(pre && (pre.aiBase ? pre.ai : true) && (pre.upBase ? pre.up : true) && (pre.ai || pre.up));
      var withSheets = !!(pre && dkN && complete && pre.dk === dkN);
      var origNow = String(formProp('_Original Image') || '').split('?')[0].split('/').pop();
      /* C126 (2026-09-01, orders 7843192308031 + 7844160700735, both line 2):
         in the add-another-patch flow the sheets composed for PATCH 1 were
         still cached when PATCH 2 (same size!) hit add-to-cart - nearfresh
         validated by SIZE ALONE and stamped patch 1's spec pair onto patch
         2's line. Nearfresh exists for same-design W/H input drift, so bind
         it to the DESIGN: the cached sheets' _Original Image anchor must
         match the line being written. */
      if (!withSheets && complete && pre && pre.wh === (st.w.toFixed(2) + 'x' + st.h.toFixed(2)) && pre.orig && pre.orig === origNow) {
        withSheets = true; /* near-fresh: same design, sizes match; a sheet beats no sheet */
        try { coMark('sheets-nearfresh'); } catch (eNf) {}
      }
      if (digitalNoRender()) setProp('_AI Proof', '');
      setProp('_Proof Approval', proofApprovalLabel());
      var avF = (st.proofApproved && st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
      if (avF && !avF.digital && (avF.frozenProof || avF.hosted)) setProp('_AI Proof', avF.frozenProof || avF.hosted);
      if (avF && (avF.alpha || avF.hosted)) setProp('_cartImg', digitalCartUrl(avF.alpha || avF.hosted));
      try { npPatchRec(); } catch (eRec) {} /* C519 */
      try { npPreviewFlag535(); } catch (eC535c) {}
      pruneLegacyProps();
      var props = mergedOrderProps();
      if (!Object.keys(props).length) return false;
      props['_Width (in)'] = st.w.toFixed(2);
      props['_Height (in)'] = st.h.toFixed(2);
      applyReorder555(props); /* C555 */
      if (withSheets) {
        if (pre.ai && !digitalNoRender()) props['_AI Proof'] = pre.ai;
        var upF = pre.up || pre.ai;
        if (upF) props['_Upload'] = upF;
        sensei.__sheetsFiredDk = dkN;
      }
      props = orderPropsObj(props);
      /* B62 PRICE INTEGRITY: /cart/change.js CANNOT change a variant. The line
         is created at generate/skip time on the seeded size, so a customer who
         sizes up crossed a variant boundary and kept the OLD price (a 6.09"
         patch billed as 2.5"). When the variant must change, ADD the correct
         one first, then zero the old line — never the other way round. */
      var vWant = null;
      try { vWant = nearestVariant(); } catch (eVW) {}
      if (vWant && sensei.__lineVariant && String(vWant.id) !== String(sensei.__lineVariant)) {
        coMark('variant-swap:' + sensei.__lineVariant + '->' + vWant.id);
        var fdV = new FormData();
        fdV.set('id', String(vWant.id));
        fdV.set('quantity', String(st.qty));
        Object.keys(props).forEach(function (kV) { fdV.set('properties[' + kV + ']', props[kV] == null ? '' : props[kV]); });
        var oldLine = sensei.__lineSnap.line;
        var oldVar427 = String(sensei.__lineVariant || '');
        var oldOrig427 = origBase((sensei.__lineSnap.props || {})['_Original Image']);
        sensei.__lineVariant = String(vWant.id);
        sensei.__swapBusy = cleanFetch()('/cart/add.js', { method: 'POST', body: fdV, credentials: 'same-origin' })
          .then(function () { return cartJson(); })
          .then(function (cS) {
            /* C427 (verified 2026-09-28 on this store): /cart/add.js puts the NEW line FIRST, so every line moves down
               one. `line: oldLine` then zeroed the new line (ours on top) or ANOTHER patch (ours lower). Zero the old
               line by KEY: the one at oldLine + 1 (or oldLine when the add merged), confirmed by its old variant and
               this design's _Original Image. Nothing confirmed = zero nothing. */
            var itS = (cS && cS.items) || [];
            var okOld = function (it) {
              return !!it && String(it.variant_id) === oldVar427 && (!oldOrig427 || origBase((it.properties || {})['_Original Image']) === oldOrig427);
            };
            var tgtS = okOld(itS[oldLine]) ? itS[oldLine] : (okOld(itS[oldLine - 1]) ? itS[oldLine - 1] : null);
            if (!tgtS) { coMark('variant-swap-old-unconfirmed'); return cS; }
            return cleanFetch()('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
              body: JSON.stringify({ id: tgtS.key, quantity: 0 })
            }).then(function (r) { return r.json(); });
          })
          .then(function (c3) {
            try {
              var mine3 = ourCartLine(c3);
              if (mine3) sensei.__lineSnap = { line: (c3.items || []).indexOf(mine3) + 1, props: mine3.properties || {} };
              coMark('variant-swapped');
            } catch (eS3) {}
            sensei.__swapBusy = null;
          }).catch(function () { sensei.__swapBusy = null; });
        return withSheets;
      }
      coMark(withSheets ? ('final-fire+sheets:dk' + dkN) : ('final-fire:dk' + dkN + (pre ? '/pre' + pre.dk : '/nopre')));
      cleanFetch()('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ line: sensei.__lineSnap.line, quantity: st.qty, properties: props })
      }).then(function (r) { return r.json(); }).then(function (c2) {
        try {
          var mine = ourCartLine(c2);
          if (mine) sensei.__lineSnap = { line: (c2.items || []).indexOf(mine) + 1, props: mine.properties || {} };
          coMark('final-landed');
        } catch (eFl) {}
      }).catch(function () {});
      return withSheets;
    } catch (eFF) { return false; }
  }
  var addPromise = null;
  function ensureInCart() {
    /* Add DIRECTLY via /cart/add.js with the form's own fields. The legacy
       add-to-cart click chain carries redirects and a location.reload() on
       its error path (resetLoading) — that was the post-generation white
       screen. Direct add sidesteps every legacy side effect.
       MEMOIZED: concurrent callers share ONE in-flight add — a second click
       during the alpha wait was creating a duplicate cart line. */
    if (sensei.added) return Promise.resolve(null); /* callers re-read via syncCartLine when needed — the extra cartJson cost 0.3-12s per click */
    if (addPromise) return addPromise;
    addPromise = ensureInCartNow();
    addPromise.then(function () { addPromise = null; }, function () { addPromise = null; });
    return addPromise;
  }
  function proofApprovalLabel() {
    /* every order carries _Proof Approval: how this patch's proof was settled.
       Stitchout outranks the rest — a paid physical sample means production
       waits on it. PENDING REVISIONS outrank an approval: once notes are filed
       for the specialist, the customer is NOT ordering the render as-is. */
    if (st.stitchAddon && stitchAddonEligible()) return 'Stitchout Needed';
    if (/REVISIONS REQUESTED/i.test(formProp('_AI Proof Status') || '')) return 'Submitted with Revisions';
    if (st.proofApproved) {
      var vP = (st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : st.versions[st.versions.length - 1];
      /* C427: an approval covers only the design it was given for */
      if (!(vP && designChangedSince(vP))) return (vP && vP.digital) ? 'Digital Proof Approved' : 'AI Proof Approved';
    }
    /* C144 (Justin 2026-09-04, PATCH-2109539 "submitted with revisions but there are no
       revision notes"): an UNAPPROVED proof without a note is not a revision request.
       "Not Approved" ends in the word the NinjaForce approval gate negates, so the line
       still holds for a human — it just stops claiming notes that do not exist. */
    return (formProp('_Revision Notes') || '').trim() ? 'Submitted with Revisions' : 'Proof Not Approved';
  }
  function keepTypeActive() {
    /* "Keep this patch type" is FINAL for this artwork (Justin 2026-08-24):
       no re-nag from the re-arm when bg-remove/crop merely change the src
       params. A genuinely different upload re-arms the detector. */
    if (!st.__keepArtBase) return false;
    return (cleanUrl(artworkUrl()) || '').split('?')[0] === st.__keepArtBase;
  }
  /* C519 (Justin 2026-10-27, "whenever a reccomendation for another patch type is overridden and customer comes back to the patch they
     intended can we add a new line item property called _Patch Rec ... For example _Patch Rec: Declined Full Color Patch"): every
     "Keep as <type>" records the type it turned down, for the artwork it was made on. The upload stop and the Generate-time fine-detail
     chooser name their recommended (green) option; the Size step names what its copy recommends (Print & Stitch / Full Color for detail,
     Print & Stitch for a gradient); a keep made in Patch Express or the Mockup Lab rides the hand-off as patchRec. The line carries it
     only while the keep still holds for the artwork on it (a Change or a passing size takes it back). */
  var NP_REC_NAMES = { 'sublimated-patches': 'Full Color Patch', 'print-stitch-patches': 'Print & Stitch Patch', 'woven-patches': 'Woven Patch' };
  function npRecName(handle) { return NP_REC_NAMES[String(handle || '').split('?')[0].split('/').pop()] || ''; }
  function npRecClean(v) {
    /* a hand-off value is only ever a list of the names above */
    var ok = {}; Object.keys(NP_REC_NAMES).forEach(function (k) { ok[NP_REC_NAMES[k]] = 1; });
    return String(v || '').split(' / ').filter(function (n) { return ok[n]; }).join(' / ');
  }
  function npRecNote(slot, names) {
    st['__rec' + slot] = names ? { names: names, base: (cleanUrl(artworkUrl()) || '').split('?')[0] } : null;
    npPatchRec();
  }
  function npPatchRec() {
    var base = (cleanUrl(artworkUrl()) || '').split('?')[0], out = '';
    ['Sz', 'Cl', 'Up', 'Ml'].forEach(function (k) {
      var r = st['__rec' + k]; if (out || !r || !r.names) return;
      if (!r.base && base) r.base = base; /* a hand-off arrives before its artwork has loaded */
      if (r.base === base) out = r.names;
    });
    setProp('_Patch Rec', out ? 'Declined ' + out : '');
  }
  function digitalNoRender() {
    /* the attached proof is a DIGITAL preview (no AI render) — such orders
       must not carry _AI Proof at all (Justin 2026-08-24) */
    var vD = (st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : (st.versions.length ? st.versions[st.versions.length - 1] : null);
    return !!(vD && vD.digital);
  }
  /* C20 (2026-08-25, Justin: "why are you not auto focusing to the top of the
     page?"). Every route onto the FINAL STEP must land at the TOP of it. There
     were two competing scrolls: C19 on the approved-view mount, and the skip
     path's own landSk which targeted #np-e2-approved — a card that sits BELOW
     the pricing card, so on the skip route the customer was dropped past the
     builder into the reviews. One helper, one target, used by both. */
  /* C21 (2026-08-25, Justin: "clicking off this not closing it"). The tooltip
     had NO javascript — it was pure :hover, and on a touch screen that hover
     state sticks after the tap with nothing to clear it. Now the trigger
     toggles .is-open explicitly and any click outside, Escape, or a scroll
     closes it. Bound once, at capture, so a handler that stops propagation
     further down cannot swallow the close. */
  /* C22 (2026-08-25, Justin: "hitting this tool tip needs to bring the info
     closer to the tool tip"). Centring the sheet on the viewport cured the
     overhang but detached it from the icon that opened it. Anchor it to the
     TRIGGER instead and clamp it to the viewport, which gets both: it sits by
     the (i), and it can still never hang off an edge. It stays position:fixed
     so no ancestor's overflow can crop it — fixed just means we own the
     coordinates, and we set them from the trigger's own rect. */
  function npFtipPlace(trig) {
    try {
      var pop = trig.querySelector('.np-e2-ftip__pop');
      if (!pop) return;
      pop.style.transform = 'none';
      pop.style.right = 'auto';
      /* C525: a tip inside a button (Match My Artwork, Let AI Choose) opens
         centred above the BUTTON, not above its small (i) */
      var r = (trig.closest('.np-e2-lnc') || trig).getBoundingClientRect();
      /* C525: style px are not screen px here. .np-e2__grid is zoomed (0.895
         above 1120px), so left:100px lands at 89.5px and every sheet sat up
         and left of its button. Measure where 0 and 100 land, work in screen
         px like the rects above, and convert back only when writing. */
      pop.style.left = '0px';
      pop.style.top = '0px';
      var o = pop.getBoundingClientRect(), ox = o.left, oy = o.top;
      pop.style.left = '100px';
      var k = (pop.getBoundingClientRect().left - ox) / 100 || 1;
      var pw = o.width, ph = o.height;
      var vh = window.innerHeight, PAD = 8;
      /* Clamp to the CONTENT box, not the viewport. The page is narrower than
         the window (centred layout), so clamping to window.innerWidth kept the
         sheet inside the *viewport* while it still hung off the *content* —
         which is what "still hanging over" was. Use the builder's own box,
         intersected with the viewport so it is never the looser of the two. */
      var host = trig.closest('.np-e2-card, .np-e2__grid, #np-e2') || document.body;
      var hr = host.getBoundingClientRect();
      var minX = Math.max(PAD, hr.left + PAD);
      var maxX = Math.min(window.innerWidth - PAD, hr.right - PAD);
      if (maxX - minX < pw) { /* content narrower than the sheet: shrink to fit */
        pop.style.width = Math.max(180, Math.round((maxX - minX) / k)) + 'px';
        o = pop.getBoundingClientRect();
        pw = o.width; ph = o.height;
      }
      var left = r.left + (r.width / 2) - (pw / 2);
      left = Math.max(minX, Math.min(left, maxX - pw));
      /* prefer above the icon; flip below when there is not room */
      var top = r.top - ph - 10;
      if (top < PAD) top = Math.min(r.bottom + 10, vh - ph - PAD);
      if (top < PAD) top = PAD;
      pop.style.left = Math.round((left - ox) / k) + 'px';
      pop.style.top = Math.round((top - oy) / k) + 'px';
      /* the Match My Artwork example is loading=lazy: on the first open the
         sheet is measured without it, then grows down over the button */
      var im = pop.querySelector('img');
      if (im && !im.complete) im.addEventListener('load', function () { npFtipPlace(trig); }, { once: true });
    } catch (eP) {}
  }
  (function npFtipTapClose() {
    var closeAll = function () {
      try {
        [].slice.call(document.querySelectorAll('.np-e2-ftip.is-open'))
          .forEach(function (t) { t.classList.remove('is-open'); });
      } catch (eC) {}
    };
    document.addEventListener('click', function (ev) {
      var trig = ev.target && ev.target.closest ? ev.target.closest('[data-e2-ftip]') : null;
      if (trig) {
        ev.preventDefault();
        ev.stopPropagation();
        var wasOpen = trig.classList.contains('is-open');
        closeAll();
        if (!wasOpen) { trig.classList.add('is-open'); npFtipPlace(trig); }
        return;
      }
      /* a click inside the sheet itself should not dismiss it */
      if (ev.target && ev.target.closest && ev.target.closest('.np-e2-ftip__pop')) return;
      closeAll();
    }, true);
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closeAll(); });
    window.addEventListener('scroll', closeAll, { passive: true });
    /* C525: on a mouse the sheet also opens on hover (CSS), but only a tap ran
       npFtipPlace, so a hovered sheet sat at its fallback, mid-screen. */
    document.addEventListener('mouseover', function (ev) {
      var trig = ev.target && ev.target.closest ? ev.target.closest('[data-e2-ftip]') : null;
      if (!trig || (ev.relatedTarget && trig.contains(ev.relatedTarget))) return;
      npFtipPlace(trig);
    }, true);
  })();

  function npFocusFinalTopOnce(smooth) {
    try {
      /* Justin: "auto focus still not working on mobile" / "it always needs to
         auto focus to the top". On a phone the final step IS the page — there
         is no left column to keep in view — so anchoring to a card's offset
         just re-introduces the settling race. Go to the actual top; it is what
         was asked for and nothing can shift out from under it. */
      if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
        window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
        return;
      }
      var el = null;
      ['np-e2-final-head', 'np-e2-step-pricing', 'np-e2-approved'].some(function (fid) {
        var c = document.getElementById(fid);
        if (c && c.offsetParent !== null && c.getBoundingClientRect().height > 0) { el = c; return true; }
        return false;
      });
      if (!el) el = document.querySelector('.np-e2__main');
      if (!el || !el.getBoundingClientRect().height) { window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' }); return; }
      var y = el.getBoundingClientRect().top + window.pageYOffset - npScrollPad() - 12;
      window.scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto' });
    } catch (eFT) {}
  }
  /* Justin 2026-08-25: "you do autofocus on desktop just not mobile". One shot
     is enough on desktop because the layout is already settled. On a phone the
     final step is still growing when it fires — the sticky preview mounts, the
     proof image decodes, cards reflow — so the page height changes underneath
     a smooth scroll and the customer ends up somewhere else entirely. Re-assert
     it as things settle, and make the later passes INSTANT: a second smooth
     animation would just fight the first, and iOS cancels smooth scrolls on
     touch anyway. Stops early once two consecutive checks agree we are there. */
  function npFocusFinalTop() {
    npFocusFinalTopOnce(true);
    /* Justin: "the autofocus on final step is a little strong, it autofocuses
       like multiple times on mobile — just need 1 nice auto focus". The
       re-assert loop existed because the desktop anchor drifted while the page
       settled. On mobile the target is simply the top of the page, which cannot
       drift, so one smooth scroll is all it needs — the extra passes were only
       ever visible as a stutter. */
    try {
      if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) return;
    } catch (eMQ2) {}
    var tries = 0, stable = 0, last = -1;
    var tick = function () {
      if (++tries > 8) return;
      var before = Math.round(window.pageYOffset);
      npFocusFinalTopOnce(false);
      var after = Math.round(window.pageYOffset);
      if (after === before && after === last) { if (++stable >= 2) return; } else stable = 0;
      last = after;
      setTimeout(tick, tries < 4 ? 200 : 400);
    };
    setTimeout(tick, 200);
  }
  function pdpPricingOn() { return NP_PDP_PRICING && document.body.classList.contains('np-e2-pdp-pricing'); }
  function mountPdpPricing() {
    var card = document.getElementById('np-e2-step-pricing');
    var slot = document.getElementById('np-e2-pricing-slot');
    var pane = document.getElementById('np-e2-pf-sizing');
    var footSlot = document.getElementById('np-e2-proof-options');
    var optsFoot = document.querySelector('#np-e2-step-options .np-e2-optfoot');
    if (!card || !slot || !pane) return;
    if (!slot.contains(pane)) slot.appendChild(pane);
    if (optsFoot && footSlot && !footSlot.contains(optsFoot)) footSlot.appendChild(optsFoot);
    var skipL = document.getElementById('np-e2-skipproof');
    if (skipL) skipL.textContent = 'Skip AI Proof, Continue with Digital Preview';
    /* C115 (Justin 2026-09-01): the whole CTA leaves the card — the green
       Generate-AI-Proof button rides full-width just BELOW the Size & Pricing
       card with the skip line centered under it; only the ready hint stays as
       the card's closing line. The NODES move, so their click listeners and
       every hidden-flag write ride along untouched. With the button out of
       .np-e2-optfoot, paintProofCta's closest() lookup goes null and the
       mobile floating-bar (is-cta-live) treatment simply never arms here. */
    if (skipL && card.parentNode && !document.getElementById('np-e2-skipwrap')) {
      var skw115 = document.createElement('div');
      skw115.className = 'np-e2-skipwrap';
      skw115.id = 'np-e2-skipwrap';
      card.parentNode.insertBefore(skw115, card.nextSibling);
      var proofB115 = document.getElementById('np-e2-proofbtn');
      if (proofB115) skw115.appendChild(proofB115);
      skw115.appendChild(skipL);
      if (optsFoot) optsFoot.classList.remove('is-cta-live');
    }
    var apH = document.getElementById('np-e2-approved');
    if (apH && !document.getElementById('np-e2-final-head')) {
      var fh = document.createElement('header');
      fh.className = 'np-e2-stephead';
      fh.id = 'np-e2-final-head';
      fh.innerHTML = '<div class="np-e2-stephead__left"><span class="np-e2-eyebrow">FINAL STEP</span><h2 class="np-e2-title">Review and Submit Your Patch Order</h2></div>';
      apH.insertBefore(fh, apH.firstChild);
    }
    document.body.classList.add('np-e2-pdp-pricing');
    card.hidden = false;
    pane.hidden = false;
    /* the stage mirrors the LIVE digital preview until a proof is approved —
       debounced + async-decoded so option clicks never wait on the copy */
    (function () {
      var mirrorT = null;
      var mirror = function () {
        clearTimeout(mirrorT);
        mirrorT = setTimeout(function () {
          if (st.proofApproved || st.versions.length) return;
          var pv = document.querySelector('.np-e2-maskprev img');
          var szI = document.getElementById('np-e2-sz-img');
          var pvFlat = previewFlatSrc(pv); /* C168: rulers measure the flat label, never the fold flaps */
          if (pv && pvFlat && szI && szI.src !== pvFlat) { szI.decoding = 'async'; szI.src = pvFlat; }
        }, 250);
      };
      var host = document.getElementById('np-e2-canvas');
      if (host) new MutationObserver(mirror).observe(host, { attributes: true, subtree: true, attributeFilter: ['src'] });
      setTimeout(mirror, 800);
    })();
    /* ── STICKY CUMULATIVE-DISCOUNTS RAIL (right column) ── */
    (function () {
      var main = document.querySelector('.np-e2__main');
      if (!main || document.getElementById('np-e2-tier-rail')) return;
      var rail = document.createElement('aside');
      rail.className = 'np-e2-tierrail';
      rail.id = 'np-e2-tier-rail';
      /* C118 (Justin 2026-09-01): the tiers are per-line volume pricing, not
         cumulative across the order — the head must not claim otherwise */
      rail.innerHTML = '<div class="np-e2-tierrail__head"><span>BUY MORE &amp; SAVE</span><b>Save up to 75%</b><i>Your price per piece drops as your quantity goes up.</i></div>' +
        '<div class="np-e2-tierrail__body">' +
          '<div class="np-e2-vol__row"><b id="np-e2-rail-count">10 pieces</b><span id="np-e2-rail-next"></span></div>' +
          '<div class="np-e2-vol__bar"><span id="np-e2-rail-fill"></span></div>' +
          '<div class="np-e2-vol__scale" id="np-e2-rail-scale"></div>' +
          '<div class="np-e2-vol__rows" id="np-e2-rail-rows"></div>' +
        '</div>';
      main.appendChild(rail);
      var railT = null;
      var syncRail = function () {
        clearTimeout(railT);
        railT = setTimeout(function () {
          var pairs = [['np-e2-vol-count', 'np-e2-rail-count'], ['np-e2-vol-next', 'np-e2-rail-next'], ['np-e2-vol-scale', 'np-e2-rail-scale'], ['np-e2-vol-rows', 'np-e2-rail-rows']];
          pairs.forEach(function (pr) {
            var src2 = document.getElementById(pr[0]), dst = document.getElementById(pr[1]);
            if (src2 && dst && dst.innerHTML !== src2.innerHTML) dst.innerHTML = src2.innerHTML;
          });
          var fS = document.getElementById('np-e2-vol-fill'), fD = document.getElementById('np-e2-rail-fill');
          if (fS && fD) fD.style.width = fS.style.width;
        }, 150);
      };
      var volHost = document.querySelector('.np-e2-vol--modal');
      if (volHost) new MutationObserver(syncRail).observe(volHost, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style'] });
      setTimeout(syncRail, 600);
    })();
    try { renderSizing(); } catch (ePS) {}
  }
  function artOfRecord() {
    /* the SELECTED version's creation-time capture is the first authority —
       approving an older version after an art swap must record THAT art.
       Then the latest render capture; the live (clobber-prone) input last. */
    var vR = (st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
    var vu = vR && cleanUrl(vR.artUsed || '');
    if (vu && isUploadLineage(vu)) return vu;
    var rec = cleanUrl(sensei.artAtRender || '');
    if (st.versions.length && rec && isUploadLineage(rec)) return rec;
    return cleanUrl(artworkUrl());
  }
  function ensureInCartNow() {
    commitOptions(); commitSizeQty();
    if (digitalNoRender()) setProp('_AI Proof', ''); /* a digital order never carries an AI proof */
    /* _AI Model (which engine rendered the proof) is no longer written to the line — retired 2026-09-16 (Justin). */
    if (!PTYPE.noArt) { /* C124: no proof flow on a typed patch */
      setProp('_Proof Approval', proofApprovalLabel());
    }
    /* cart thumbnail contract: the APPROVED AI PROOF is the cart image —
       the upload is only the placeholder when no proof was ever approved
       (Add to Cart runs AFTER approval now, so never clobber the proof) */
    var art = artOfRecord();
    /* order-admin contract: _Upload = the customer's COMPOSED digital patch
       (shape + colors + merrow preview), _Original Image = the raw upload,
       _AI Proof = the approved render (set at approval) */
    var composedUp = sensei.composedCleanUrl || '';
    if (composedUp || art) setProp('_Upload', toImgixHost(composedUp || art));
    var rawBase = (art || '').split('?')[0].split('&')[0];
    if (rawBase) setProp('_Original Image', rawBase);
    var prevImg = sensei.composedCleanUrl || (art ? applyToggleParams(art) : '');
    if (prevImg) setProp('_Preview Image', withMonoBackdrop(prevImg));
    var avc = (st.proofApproved && st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
    /* diagnostic: what image contract goes on this add */
    try { console.log('[np-e2] add-time _cartImg source', { alpha: avc && avc.alpha, frozen: avc && avc.frozenProof, hosted: avc && avc.hosted, clean: sensei.composedCleanUrl, comp: sensei.composedUrl }); } catch (eLg) {}
    var proofImg = (avc && !avc.fallbackUpload)
      ? (avc.alpha || avc.frozenProof || avc.hosted || sensei.composedCleanUrl || '')
      : (formProp('_AI Proof') || sensei.composedCleanUrl || '');
    if (proofImg) proofImg = digitalCartUrl(proofImg);
    if (proofImg) setProp('_cartImg', proofImg);
    if (!st.proofApproved && !PTYPE.noArt) {
      /* submitted WITHOUT approving a render: flag it and carry the revisions */
      var revN = (formProp('_Revision Notes') || '').trim();
      setProp('_AI Proof Status', revN ? 'PROOF NOT APPROVED - see revision notes' : 'PROOF NOT APPROVED - no revision notes'); /* C144 */
      if (revN) setProp('_AI Proof Revisions', revN);
      if (!proofImg && art) setProp('_cartImg', digitalCartUrl(art));
    }
    /* B46: sheets ready at add time ride the ADD itself — one atomic write */
    var sheetsRode = false;
    try {
      var preA = sensei.__preSheets;
      var dkA = specDkToken(specLines(specFormProps()));
      var freshDk = (preA && sensei.__clickDk && preA.dk === sensei.__clickDk);
      if (preA && (preA.ai || preA.up) && ((dkA && preA.dk === dkA) || freshDk)) {
        if (preA.ai && !digitalNoRender()) setProp('_AI Proof', preA.ai);
        var upA = preA.up || preA.ai;
        if (upA) setProp('_Upload', toImgixHost(upA));
        sensei.__sheetsFiredDk = dkA;
        sheetsRode = true;
        try { coMark('sheetsapplied[' + (freshDk && preA.dk !== dkA ? 'fresh-click' : 'dk-match') +
                     '|ai:' + (preA.ai ? 'y' : 'n') + '|up:' + (preA.up ? 'y' : 'n') + ']'); } catch (eSa) {} /* B96: the SHEET owns _AI Proof/_Upload — do not overwrite below */
      }
    } catch (eAS) {}
    /* C12 (2026-08-25) — SEND IMGIX URLS, NOT RAW S3. Justin spotted _Upload
       arriving as ninja-services-production-ninjauploadss3bucket-….s3.amazonaws.com
       while _Original Image and _cartImg beside it were ninjauploads-production
       .imgix.net. toImgixHost() already rewrites exactly that host but was not
       applied at these write sites, so whichever source won (a raw upload path,
       or the C07 empty-field fallback) could ship the S3 form. That is why the
       value wrapped onto its own line in the order admin — the S3 hostname is
       far longer — and it breaks the contract that _Upload is the previewed
       imgix render. Harmless on values already on imgix: the regex simply does
       not match. ═══ B95 (2026-08-25) — WRITE THE FINAL IMAGE INTO THE ADD ═══
       The authoritative image contract (_Upload / _AI Proof / _Original Image /
       _cartImg / _Preview Image) used to be stamped by lineSync() 400ms AND
       2600ms AFTER the add. That was invisible while adds took 15 seconds, but
       the add now completes in 663ms and we leave for /cart immediately, so the
       late passes never land and the cart line shows an unfinished thumbnail
       (Justin, 2026-08-25: "this shows as a broken image because we are moving
       so fast now"). Compute it BEFORE the add so the line is correct the moment
       it is created — one atomic write, no race. The post-add lineSync stays as
       a harmless safety net for anything that hosts late. */
    try {
      var artP = artOfRecord();
      var compP = sensei.composedCleanUrl || '';
      if (!sheetsRode && (compP || artP)) setProp('_Upload', toImgixHost(compP || artP));
      var rawP = (artP || '').split('?')[0].split('&')[0];
      if (rawP) setProp('_Original Image', toImgixHost(rawP));
      var avP = (st.proofApproved && st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
      /* C10 (2026-08-25, Justin): "make sure the specs write to _Upload and
         _Mockup Catalog when a digital proof is approved". _Upload already gets
         the composed sheet via the sheet-ride block above; _Mockup Catalog was
         still taking the BARE frozen proof, so production saw specs on one and
         not the other. Prefer the sheet, fall back to the frozen proof when no
         sheet composed (spec sheets off, or a compose that timed out) so the
         catalog copy is never empty. */
      if (avP && avP.digital) {
        var pS = sensei.__preSheets;
        var mcSheet = (sheetsRode && pS) ? String(pS.up || pS.ai || '') : '';
        var mcVal = mcSheet || avP.frozenProof || '';
        if (mcVal) { setProp('_Mockup Catalog', mcVal); coMark('mcat:' + (mcSheet ? 'sheet' : 'frozen')); }
      }
      else if (!sheetsRode && avP && (avP.frozenProof || avP.hosted)) setProp('_AI Proof', avP.frozenProof || avP.hosted);
      var ciP = '';
      if (avP && !avP.fallbackUpload && (avP.alpha || avP.frozenProof || avP.hosted)) ciP = avP.alpha || avP.frozenProof || avP.hosted;
      else if (compP) ciP = compP;
      if (ciP) {
        var ciUrl = digitalCartUrl(ciP);
        setProp('_cartImg', ciUrl);
        /* B98 (2026-08-25, Justin's idea) — WARM THE CART THUMBNAIL. We already
           know the exact URL /cart will request, and we are about to spend
           ~500ms waiting on sheets and ~470ms on the add. Start the image
           fetch now so the cart paints it from cache instead of blank-then-pop.
           Fire and forget: it can only help, and a failure changes nothing. */
        try { var pw = new Image(); pw.decoding = 'async'; pw.src = ciUrl; } catch (ePw) {}
      }
      if (compP) setProp('_Preview Image', compP);
      /* B96 (2026-08-25) — DO NOT CLOBBER THE SPEC SHEET. B95 set _AI Proof and
         _Upload from the raw render, but it runs AFTER the block that stamps the
         COMPOSED SHEET onto those same two properties, so it overwrote the sheet
         every time. Justin caught it: _AI Proof came back 1536x1024 (raw render
         dimensions) instead of a composed sheet. `sheetsRode` records whether the
         sheet claimed those props; the image contract now fills only what the
         sheet did not. _cartImg is still always ours — that one is the thumbnail,
         not the proof of record. */
      coMark('imgprops[cartImg:' + (ciP ? 'set' : 'MISSING') + '|comp:' + (compP ? 'y' : 'n') +
             '|sheets:' + (sheetsRode ? 'RODE' : 'not-ready') + ']');
      /* B98: 'not-ready' is too blunt — say WHICH gate failed. */
      if (!sheetsRode) {
        try {
          var pD = sensei.__preSheets;
          var dkNow = specDkToken(specLines(specFormProps()));
          coMark('sheetgate[pre:' + (pD ? 'y' : 'NONE') +
                 '|dkMatch:' + (pD && pD.dk === dkNow ? 'y' : 'n') +
                 '|ai:' + (pD && pD.ai ? 'y' : 'n') +
                 '|up:' + (pD && pD.up ? 'y' : 'n') + ']');
          /* C01: name the drifting field */
          if (pD && pD.snap && pD.dk !== dkNow) {
            var nowP = specFormProps(), diffs = [];
            var seen = {};
            Object.keys(pD.snap).forEach(function (k) { seen[k] = 1; });
            Object.keys(nowP).forEach(function (k) { seen[k] = 1; });
            Object.keys(seen).forEach(function (k) {
              var a = String(pD.snap[k] === undefined ? '(absent)' : pD.snap[k]);
              var b = String(nowP[k] === undefined ? '(absent)' : nowP[k]);
              if (a === b) return;
              var trim = function (v) { return v.indexOf('://') > -1 ? ('url:' + v.split('/').pop().split('?')[0].slice(-22)) : v.slice(0, 22); };
              diffs.push(k.replace(/^_+/, '') + ':' + trim(a) + '=>' + trim(b));
            });
            coMark('dkdrift[' + (diffs.length ? diffs.slice(0, 5).join(' ; ') : 'NO-PROP-DIFF(token inputs read outside form)') + ']');
            /* C03: which COMPONENT of the token moved? */
            try {
              if (pD.dbg) {
                var oIn = document.querySelector('input[name="properties[_Original Image]"]');
                var nowDbg = {
                  a: oIn ? String(oIn.value || '').split('?')[0].slice(-28) : '(none)',
                  w: String((st && st.w) || ''),
                  h: String((st && st.h) || ''),
                  l: specLines(nowP).map(function (l) { return l.join(':'); }).join(';')
                };
                var parts = [];
                if (pD.dbg.a !== nowDbg.a) parts.push('ART');
                if (pD.dbg.w !== nowDbg.w) parts.push('W:' + pD.dbg.w + '=>' + nowDbg.w);
                if (pD.dbg.h !== nowDbg.h) parts.push('H:' + pD.dbg.h + '=>' + nowDbg.h);
                if (pD.dbg.l !== nowDbg.l) {
                  var oldL = pD.dbg.l.split(';'), newL = nowDbg.l.split(';');
                  var only = oldL.filter(function (x) { return newL.indexOf(x) < 0; })
                    .concat(newL.filter(function (x) { return oldL.indexOf(x) < 0; }))
                    .map(function (x) { return x.split(':')[0]; });
                  parts.push('LINES[' + only.slice(0, 4).join(',') + ']');
                }
                coMark('dkpart[' + (parts.length ? parts.join(' ; ') : 'IDENTICAL?!') + ']');
              }
            } catch (eDp) {}
          }
        } catch (eSg) {}
      }
    } catch (eFP) {}
    /* ═══ C07 (2026-08-25) — NEVER SHIP AN EMPTY _Upload / _cartImg ═══
       Live order 2107222 (Classic mode) arrived with _Original Image populated
       but _Upload and _cartImg EMPTY. Those have different writers: our code
       stamps _Original Image at click, while custom-uploader.js writes _Upload
       when its own processing finishes. Add-to-Cart used to take 13-20s, which
       always gave that write time to land; at ~600ms a fast customer can now
       beat it. Production cannot receive a line with no artwork on it.
       This ONLY fills a field that is already empty, so it can never overwrite
       a good value, and it prefers the most faithful source available. */
    try {
      var upEl = document.querySelector('input[name="properties[_Upload]"]');
      if (upEl && !String(upEl.value || '').trim()) {
        var oiEl = document.querySelector('input[name="properties[_Original Image]"]');
        var fbU = String(window.__npLastUploadedFilePath || '') ||
                  (oiEl ? String(oiEl.value || '') : '') ||
                  String(artOfRecord() || '');
        if (fbU) { setProp('_Upload', toImgixHost(fbU)); coMark('FALLBACK:_Upload'); }
      }
      var ciEl = document.querySelector('input[name="properties[_cartImg]"]');
      if (ciEl && !String(ciEl.value || '').trim()) {
        var upNow = document.querySelector('input[name="properties[_Upload]"]');
        var fbC = upNow ? String(upNow.value || '') : '';
        if (fbC) { setProp('_cartImg', digitalCartUrl(fbC)); coMark('FALLBACK:_cartImg'); }
      }
    } catch (eFb) {}
    try { npPatchRec(); } catch (eRec2) {} /* C519 */
    try { npPreviewFlag535(); } catch (eC535c2) {}
    pruneLegacyProps();
    orderProps();
    var form = document.querySelector('product-form.product-form form');
    if (!form) return Promise.reject(new Error('form missing'));
    try { stampOrderMode(); } catch (eOMF) {}
    var fd = new FormData(form);
    /* C124 (Justin 2026-09-02, PATCH-2108823): a NO-ARTWORK patch (Custom
       Names) has no upload, no bg-remove/crop switches and no proof flow —
       yet every names line shipped '_Proof Approval: Submitted with Revisions'
       (proofApprovalLabel's FALLBACK, never a customer act), '_AI Model: Open
       AI' (a bare ternary) and the C27 switches at their st defaults. This is
       THE serialization point, so stripping here catches every writer —
       including custom-uploader's own hidden _Remove Background/_Crop & Trim
       inputs that np-emb2 never asked for. */
    if (PTYPE.noArt) NOART_STRIP_C124.forEach(function (kNA) { fd.delete('properties[' + kNA + ']'); });
    fd.set('quantity', String(st.qty));
    /* C518 (Justin 2026-10-27, PATCH-2124400: "the width and height should always match whatever size they chose"): an
       option-variant type's size IS its size option, so the line's width / height come from that option at the add */
    if (PTYPE.optVariant && PTYPE.sizeFromOpt) {
      var selS518 = st['opt' + PTYPE.sizeFromOpt], wh518 = selS518 ? optSizeWH(selS518.label) : null;
      if (wh518) { st.w = wh518[0]; st.h = wh518[1]; st.ratio = st.h / st.w; }
    }
    var vid = nearestVariant();
    if (vid) fd.set('id', String(vid.id));
    /* ═══ C11 (2026-08-25) — THE VARIANT MUST AGREE WITH THE SIZE ON THE LINE ═══
       Live: a line carried _Width 2.69 x _Height 3.00 (mean 2.845, so a 3"
       patch) while the VARIANT charged was 2". Both are normally written by
       selectNearestVariant2 from the same two inputs, so they only diverge when
       the size moves after the variant was chosen — and every such path is a
       silent undercharge. Rather than chase each one, enforce the rule where it
       actually matters: at the add.
       Justin's rule, verbatim: "its width + height / 2 and then we always round
       up to the next variant. so 2+3 = 5/2 = 2.5 that would be patch size 2.5
       but if it was 2.5+3 /2 = 2.75 that would be patch size 3 for pricing."
       `mean <= num` on an ascending list honours an exact match and otherwise
       takes the next size up, which is exactly that. Reads the properties that
       SHIP, so it is correct for Classic and AI alike. */
    try {
      /* C14 (2026-08-25) — READ THE BUILDER'S OWN SIZE, NOT THE FIRST MATCH IN
         THE DOCUMENT. document.querySelector returns the FIRST
         properties[_Width (in)] on the page, and custom-uploader.js PREPENDS its
         own hidden width/height inputs to the product form
         (setWidthHeightProperties2). On an AI order that made this guard read
         the legacy widget's stale numbers and "correct" the variant to a wildly
         wrong one — measured live: builder showed 3.00 x 2.24 (mean 2.62 -> 3"
         at $8.05) while the cart line came through at $26.07, the 8.5" variant.
         In AI mode st.w/st.h ARE the size of record and are what the displayed
         price is computed from, so use them; only fall back to the form inputs
         (scoped to THIS form, not the document) when the builder has no size. */
      var wV = NaN, hV = NaN;
      if (isFinite(st.w) && st.w > 0 && isFinite(st.h) && st.h > 0) {
        wV = st.w; hV = st.h;
      } else {
        var wEl = form.querySelector('input[name="properties[_Width (in)]"], input[name="properties[Width (in)]"]');
        var hEl = form.querySelector('input[name="properties[_Height (in)]"], input[name="properties[Height (in)]"]');
        wV = wEl ? parseFloat(wEl.value) : NaN;
        hV = hEl ? parseFloat(hEl.value) : NaN;
      }
      if (isFinite(wV) && isFinite(hV) && wV > 0 && hV > 0) {
        var meanV = Math.round(((wV + hV) / 2) * 100) / 100;
        var vList = (CFG.variants || []).map(function (vC) {
          return { id: vC.id, num: parseFloat(String(vC.opt1).replace(/[^0-9.]/g, '')) };
        }).filter(function (vC) { return !isNaN(vC.num); }).sort(function (a, b) { return a.num - b.num; });
        var want = null;
        for (var iV = 0; iV < vList.length; iV++) { if (meanV <= vList[iV].num) { want = vList[iV]; break; } }
        if (!want && vList.length) want = vList[vList.length - 1];
        /* C518 (PATCH-2124400): an option-variant type (tackle twill) is priced by ALL its options (optVariantMatch), never
           by the mean size. Read loosely, '11" x 4" (Most Popular)' was 114 and '9" x 3"' 93, so every AI tackle twill line
           since 8-25 was re-picked to the first 9x3 variant, 1 Layer / 1 Line at $13 (2 Layers / 2 Lines is $17.50) and
           carried 9x3 beside its 11 x 4 size. Those types keep the options' variant; C14 below still writes the size. */
        if (!PTYPE.optVariant && want && String(fd.get('id') || '') !== String(want.id)) {
          coMark('VARIANT-FIX:' + meanV + '=>' + want.num);
          fd.set('id', String(want.id));
        }
        /* C14 — and make the SIZE on the line agree with the size we just
           priced from. setProp writes into the options app's / legacy widget's
           input when one exists, and custom-uploader.js's
           setWidthHeightProperties2 keeps rewriting that SAME input on its own
           interval, so the value riding to the cart is whoever wrote last.
           fd.set replaces every entry of that name with one value, so this both
           wins the race and collapses any duplicate field. Size & Pricing is
           the only source for width, height and the priced variant. */
        if (isFinite(st.w) && st.w > 0 && isFinite(st.h) && st.h > 0) {
          if (fd.has('properties[_Width (in)]')) fd.set('properties[_Width (in)]', st.w.toFixed(2));
          if (fd.has('properties[_Height (in)]')) fd.set('properties[_Height (in)]', st.h.toFixed(2));
          if (fd.has('properties[Width (in)]')) fd.set('properties[Width (in)]', st.w.toFixed(2));
          if (fd.has('properties[Height (in)]')) fd.set('properties[Height (in)]', st.h.toFixed(2));
        }
        /* C555: a My Designs purchase on its own patch type — Exact / Similar from the size that ships */
        var rn555 = reorderFor555(wV, hV, fd.get('id'));
        if (rn555) fd.set('properties[_reorder]', rn555);
        else if (rn555 === '') fd.delete('properties[_reorder]');
      }
    } catch (eVv) {}
    rememberMode('ai'); /* mode memory follows the last ADD TO CART */
    /* B78 (2026-08-25) — MEASURE THE POST BODY. Justin's adds run 5.4s-13.7s with
       only ~70ms of our code; the whole cost is this one request. A bare JSON
       /cart/add.js in the same browser runs ~650ms, so the suspect is payload
       size: FormData(form) serializes EVERY field in the product form, including
       any file input or data: URL still sitting in a hidden property. */
    try {
      var fdB = 0, fdF = 0, fdBig = '';
      fd.forEach(function (v, k) {
        var n = String(k).length;
        if (v && typeof v === 'object' && typeof v.size === 'number') { n += v.size; fdF++; }
        else n += String(v).length;
        fdB += n;
        if (n > 51200) fdBig += (fdBig ? ',' : '') + String(k).slice(0, 28) + ':' + Math.round(n / 1024) + 'kb';
      });
      coMark('body[' + Math.round(fdB / 1024) + 'kb|files:' + fdF + (fdBig ? '|big:' + fdBig : '') + ']');
    } catch (eFB) {}
    try { window.__npAdding = true; } catch (eA1) {}
    coMark('add-pre');
    /* B82 (2026-08-25) — IS IT THE NETWORK, OR A JAMMED MAIN THREAD?
       Every isolated piece measures fast in Justin's own browser: /cart/add.js
       627ms, iframe realm 477ms, multipart 667ms, /cart/update.js 605ms. Yet the
       real add marks 5.4s / 13.7s / 18.9s. `add-resp` is marked in a .then()
       microtask, which CANNOT run while the main thread is busy — so a blocked
       thread is indistinguishable from a slow response at this mark. This
       100ms sampler measures the largest gap between ticks during the add: a
       gap near the total means the thread was jammed (our problem to fix), a
       small gap means the response genuinely took that long (Shopify's). */
    var mtLast = performance.now(), mtMax = 0, mtTicks = 0, mtWTicks = 0;
    var mtWall = Date.now(), mtVisPre = document.visibilityState;
    var mtT0 = performance.now(); /* B83: window start for the traffic census */
    /* B87 (2026-08-25) — HOW LONG WAS THE TAB ASLEEP? Every other explanation is
       now excluded by measurement: thread never blocked (longestTask 173ms over
       a 15.7s window), no sync XHR, no canvas work, no network, and the request
       itself runs 627-932ms in isolation. A frozen BACKGROUND tab is the only
       remaining thing that stops plain timers AND worker callbacks AND network
       at once. Justin clicks Add to Cart and then switches apps to message me,
       so the stopwatch keeps running while Chrome has the tab suspended. */
    var hidMs = 0, hidN = 0, hidStart = (document.visibilityState === 'hidden') ? performance.now() : 0;
    var onVisB87 = function () {
      if (document.visibilityState === 'hidden') { hidStart = performance.now(); hidN++; }
      else if (hidStart) { hidMs += performance.now() - hidStart; hidStart = 0; }
    };
    try { document.addEventListener('visibilitychange', onVisB87); } catch (eV) {}
    var cvPre = window.__npCv ? { tdu: window.__npCv.tdu, gid: window.__npCv.gid, nT: window.__npCv.nT, nG: window.__npCv.nG,
                                  xSync: window.__npCv.xSync, xSyncMs: window.__npCv.xSyncMs, xAsync: window.__npCv.xAsync,
                                  ltMax: 0, ltN: window.__npCv.ltN } : null;
    if (window.__npCv) { window.__npCv.ltMax = 0; window.__npCv.ltSrc = ''; }
    var mtIv = setInterval(function () {
      mtTicks++;
      var nMt = performance.now(), gMt = nMt - mtLast;
      if (gMt > mtMax) mtMax = gMt;
      mtLast = nMt;
    }, 100);
    /* worker clock in parallel: it keeps ticking when a THROTTLED tab freezes
       plain timers, so tick counts that disagree prove throttling rather than
       a jammed thread (mtblock[0ms] on Justin's 15.4s add meant the setInterval
       callback never fired ONCE, while the fetch .then microtask ran fine). */
    var mtWStop = false;
    var mtWArm = function () {
      if (mtWStop) return;
      try { npTick(function () { mtWTicks++; mtWArm(); }, 100); } catch (eW) {}
    };
    mtWArm();
    return cleanFetch()('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (r) {
        try {
          clearInterval(mtIv); mtWStop = true;
          var mtEl = Date.now() - mtWall;
          /* expected ticks if nothing was throttled = elapsed/100 */
          coMark('mtblock[gap:' + Math.round(mtMax) + 'ms|timerTicks:' + mtTicks +
                 '|workerTicks:' + mtWTicks + '|expect:' + Math.round(mtEl / 100) +
                 '|vis:' + mtVisPre + '>' + document.visibilityState + ']');
          /* B83 (2026-08-25) — IS THE PIPE BUSY? Every ingredient of the add
             measures <1s from an idle console, but the real click takes 15s.
             The untested variable is what else is in flight at that moment:
             a small POST can queue behind megabytes of proof imagery. Census
             every resource that started during the add window. */
          try {
            var rEnt = performance.getEntriesByType('resource').filter(function (rr) { return rr.startTime >= mtT0 - 1000; });
            var rBytes = 0, rOpen = 0;
            rEnt.forEach(function (rr) { rBytes += (rr.transferSize || 0); if (!rr.responseEnd) rOpen++; });
            coMark('net[reqs:' + rEnt.length + '|kb:' + Math.round(rBytes / 1024) + '|unfinished:' + rOpen + ']');
            if (cvPre && window.__npCv) {
              coMark('cv[toDataURL:' + Math.round(window.__npCv.tdu - cvPre.tdu) + 'ms/' + (window.__npCv.nT - cvPre.nT) +
                     '|getImageData:' + Math.round(window.__npCv.gid - cvPre.gid) + 'ms/' + (window.__npCv.nG - cvPre.nG) +
                     '|alphaCut:' + (NP_ALPHA_CUT ? 'ON' : 'OFF') + ']');
              coMark('blk[syncXHR:' + (window.__npCv.xSync - cvPre.xSync) + '/' + Math.round(window.__npCv.xSyncMs - cvPre.xSyncMs) +
                     'ms|asyncXHR:' + (window.__npCv.xAsync - cvPre.xAsync) +
                     '|longestTask:' + Math.round(window.__npCv.ltMax) + 'ms|tasks:' + (window.__npCv.ltN - cvPre.ltN) +
                     '|from:' + (window.__npCv.ltSrc || '-') + ']');
            }
          } catch (eNet) {}
        } catch (eMt) {}
        try {
          if (hidStart) { hidMs += performance.now() - hidStart; hidStart = 0; }
          document.removeEventListener('visibilitychange', onVisB87);
          var totB87 = Math.round(performance.now() - mtT0);
          coMark('tabsleep[hidden:' + Math.round(hidMs) + 'ms|switches:' + hidN +
                 '|awake:' + Math.max(0, totB87 - Math.round(hidMs)) + 'ms|of:' + totB87 + 'ms]');
          if (window.__npTk) {
            var gz = window.__npTk.gaps.slice(-18).join(',');
            coMark('ticktrace[n:' + window.__npTk.n + '|last18gaps:' + gz + ']');
          }
          if (window.__npT) {
            var hp = '';
            try { if (performance.memory) hp = '|heapMB:' + Math.round(performance.memory.usedJSHeapSize / 1048576); } catch (eH) {}
            try {
              var srcArr = Object.keys(window.__npT.src || {}).map(function (k) { return [k, window.__npT.src[k]]; });
              srcArr.sort(function (a, b) { return b[1] - a[1]; });
              coMark('leakSRC[' + srcArr.slice(0, 4).map(function (x) { return x[0] + '=' + x[1]; }).join(' | ') + ']');
            } catch (eSrc) {}
            coMark('leak[intervalsMade:' + window.__npT.si + '|intervalsLive:' + window.__npT.siLive +
                   '|timeouts:' + window.__npT.st + '|listeners:' + window.__npT.ael +
                   '|observers:' + window.__npT.mo + '|domNodes:' + document.getElementsByTagName('*').length + hp + ']');
          }
        } catch (eV2) {}
        try { window.__npAdding = false; } catch (eA2) {}
        coMark('add-resp');
        try {
          var perfR = (cleanFetch.__ifr && cleanFetch.__ifr.contentWindow && cleanFetch.__ifr.contentWindow.performance) || performance;
          var eAdd = perfR.getEntriesByType('resource').filter(function (rr) { return /cart\/add\.js/.test(rr.name); }).pop();
          if (eAdd) coMark('addnet[queue:' + Math.round(eAdd.requestStart ? (eAdd.requestStart - eAdd.startTime) : -1) + '|srv:' + Math.round(eAdd.responseStart ? (eAdd.responseStart - (eAdd.requestStart || eAdd.startTime)) : -1) + '|dl:' + Math.round(eAdd.responseEnd - (eAdd.responseStart || eAdd.startTime)) + ']');
        } catch (eNp) {}
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || ('add failed ' + r.status)); });
        /* C427: remember WHICH line this add made (two patches can share a design, so the fingerprint alone cannot
           tell them apart). Read in the background: awaiting the body cost 3.8s (measured). */
        try { r.json().then(function (jA) { var kA = jA && (jA.key || (jA.items && jA.items[0] && jA.items[0].key)); if (kA) sensei.__addKey = String(kA); }).catch(function () {}); } catch (eAK427) {}
        return null; /* body unused — awaiting its download cost 3.8s (measured) */
      })
      .then(function () {
        coMark('add-ok');
        sensei.added = true;
        try { sensei.__lineVariant = vid ? String(vid.id) : ''; } catch (eLV) {} /* B62: variant the LINE holds */
        try { sensei.__lineState = curLineState(); } catch (eLS1) {} /* the add carried FINAL qty/variant/props */
        var stitchP = null;
        if (st.stitchAddon && !st.__stitchCharged && stitchAddonEligible()) { st.__stitchCharged = true; stitchP = adjustStitchLine(1); }
        /* the legacy uploader's timers can clobber the hidden image inputs
           with THIS PRODUCT's previous upload right before the add (seen on
           converted-product arrivals: the cart line carried an OLD session's
           proof). Force-correct the image contract on the ACTUAL cart line. */
        (function () {
          var fix = {};
          var artF = artOfRecord();
          var compF = sensei.composedCleanUrl || '';
          if (compF || artF) fix['_Upload'] = compF || artF;
          var rawF = (artF || '').split('?')[0].split('&')[0];
          if (rawF) fix['_Original Image'] = rawF;
          var avF = (st.proofApproved && st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
          if (avF && avF.digital) {
            /* C10: keep the late pass consistent with the pre-add write above —
               the sheet is the catalog copy of record on a digital order. */
            var pS2 = sensei.__preSheets;
            var mcS2 = (pS2 && (pS2.up || pS2.ai)) ? String(pS2.up || pS2.ai) : '';
            var mcV2 = mcS2 || avF.frozenProof || '';
            if (mcV2) fix['_Mockup Catalog'] = mcV2;
          }
          else if (avF && (avF.frozenProof || avF.hosted)) fix['_AI Proof'] = avF.frozenProof || avF.hosted;
          /* cart image = the AI proof, always; a FAILED generation falls back
             to the composed digital preview (border + fill), never raw art */
          if (avF && !avF.fallbackUpload && (avF.alpha || avF.frozenProof || avF.hosted)) fix['_cartImg'] = avF.alpha || avF.frozenProof || avF.hosted;
          else if (compF) fix['_cartImg'] = compF;
          if (fix['_cartImg']) fix['_cartImg'] = digitalCartUrl(fix['_cartImg']);
          if (compF) fix['_Preview Image'] = compF;
          setTimeout(function () { lineSync(fix); }, 400);
          /* second pass outlasts slow compose hosting + legacy timers */
          setTimeout(function () {
            var late = sensei.composedCleanUrl || '';
            if (late) {
              if (!fix['_cartImg'] || (avF && avF.digital && !avF.hosted)) fix['_cartImg'] = late;
              fix['_Preview Image'] = late;
              if (fix['_cartImg']) fix['_cartImg'] = digitalCartUrl(fix['_cartImg']);
            }
            lineSync(fix);
          }, 2600);
        })();
        var s3 = document.getElementById('np-e2-step-options');
        /* only the legacy interactive add may scroll — a BACKGROUND pre-add
           or a checkout-time add yanking the viewport was the mystery
           "keeps focusing to the bottom" (Justin 2026-08-24) */
        if (s3 && !commitSizeQty.__stamping && !coBusy) s3.scrollIntoView({ block: 'center' });
        /* checkout path skips the banked-pieces recount — syncCartLine reads
           the cart right after anyway (0.6s saved, measured) */
        return (stitchP || Promise.resolve()).then(function () { return coBusy ? null : cartJson(); });
      })
      .then(function (cart) {
        if (!cart) return null;
        /* PIECES banked in OTHER lines — exclude our own line by fingerprint
           (Shopify merges identical adds, so subtracting st.qty over-counts) */
        var mine = ourCartLine(cart);
        if (mine) sensei.__lineSnap = { line: (cart.items || []).indexOf(mine) + 1, props: mine.properties || {} }; /* B46: arms the read-free final sync */
        st.cart = Math.max(0, (cart.item_count || 0) - (mine ? mine.quantity : st.qty));
        return cart;
      });
  }

  function customerNotes() {
    var t = ($('#np-e2-change-text') ? $('#np-e2-change-text').value : '').trim();
    return t;
  }
  function normalizeBorder(label) {
    /* the sensei backend + production tooling parse the exact legacy BCPO
       strings — send those regardless of the CMS display label */
    var l = (label || '').toLowerCase();
    if (l.indexOf('merrow') > -1) return 'Merrow';
    if (l.indexOf('hot') > -1 || l.indexOf('embroider') > -1) return 'Embroidered / Hot Cut (Most Popular)';
    return label || '';
  }
  var SHAPE_DESC = {
    'shield': 'a badge/crest outline: flat top edge, sides curving down to a point at the bottom center',
    'heart': 'a classic heart symbol outline',
    'star': 'a five-point star outline',
    'rhombus': 'a diamond outline standing on a point',
    'hexagon': 'a six-sided hexagon outline',
    'oval': 'a vertical (tall) oval',
    'oval-h': 'a horizontal (wide) oval',
    'rectangle': 'a horizontal (wide) rounded rectangle',
    'rectangle-v': 'a vertical (tall) rounded rectangle'
  };
  /* ═══ TEXT PREVIEW (custom names) — the patch carries LETTERING, not an
     upload, so the "artwork" the composer places inside the shape is a
     canvas of the word rendered in the chosen font and thread colour. It is
     handed to the composer as a data URL, which means the shape, the merrow
     ring, the background fill and the safe-area fit all stay exactly the
     same code path every other patch type uses. ═══ */
  function nameFonts() { return CFG.fonts || []; }
  function nameFontStack(f) {
    return "'" + String((f && f.family) || 'sans-serif').replace(/['"\\]/g, '') + "', " + ((f && f.fallback) || 'sans-serif');
  }
  function nameBlockFont() {
    var nf = nameFonts();
    for (var i = 0; i < nf.length; i++) { if (!nf[i].script) return nf[i]; }
    return null;
  }
  function nameTileSample(f2) {
    /* script tiles preview the real treatment: BLOCK first letter, script rest */
    var sTxt = (f2 && f2.greekmap) ? ttGreekify(PTYPE.textPreview || 'NAME') : (PTYPE.textPreview || 'NAME');
    if (PTYPE.names && f2 && f2.script && sTxt.length > 1) {
      var bF = nameBlockFont();
      if (bF) return '<i style="font-style:normal;font-family:' + nameFontStack(bF) + ';font-weight:' + (bF.weight || 700) + '">' + sTxt.charAt(0) + '</i>' + sTxt.slice(1);
    }
    return sTxt;
  }
  function activeNameFont() { return st.font || nameFonts()[0] || { label: 'San Serif', family: 'sans-serif', weight: 700 }; }
  function nameInkHex() {
    /* the text colour owns the lettering. Before it is picked the preview borrows the border colour, which
       is usually close enough to read — but C332 (Justin 2026-09-23, "make sure if they choose the match
       background color for the border color the text color doesn't disappear"): with the Match Your
       Background tile the border IS the background, so that borrow painted the name in the felt colour and
       it vanished. Any borrowed colour that lands on the background is refused, and the preview falls back
       to whichever of near-black / white actually reads on that felt. Preview only — the text step stays
       required and nothing is written to the order. */
    var usable = function (c) {
      return c && c.hex && c.label !== 'Let Ninja Choose' && c.label !== 'Not Sure' ? c.hex : '';
    };
    var chosen = usable(st.text);
    if (chosen) return chosen;
    var bgHex = usable(st.bg);
    var borrowed = usable(st.thread);
    if (borrowed && (!bgHex || borrowed.toLowerCase() !== bgHex.toLowerCase())) return borrowed;
    return bgHex && nameInkLight(bgHex) ? '#0C0C0E' : (bgHex ? '#ffffff' : '#0C0C0E');
  }
  /* perceived lightness of a #rrggbb, ITU-R BT.601 — enough to decide black vs white ink */
  function nameInkLight(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || ''));
    if (!m) return true;
    var n = parseInt(m[1], 16);
    return (((n >> 16 & 255) * 299 + (n >> 8 & 255) * 587 + (n & 255) * 114) / 1000) > 140;
  }
  var nameFontsLoaded = false, nameFontsP = null;
  function ensureNameFonts(cb) {
    /* CRITICAL: a canvas fillText that runs before the webfont file has
       loaded silently paints in the browser's default face and never
       repaints. Wait for the real faces, THEN draw. */
    if (!nameFontsP) {
      nameFontsP = new Promise(function (res) {
        if (!document.fonts || !document.fonts.load) { res(); return; }
        var jobs = nameFonts().map(function (f) {
          try { return document.fonts.load(((f && f.weight) || 700) + ' 400px ' + nameFontStack(f)); }
          catch (eNF) { return null; }
        }).filter(Boolean).map(function (p) { return p.catch(function () {}); });
        Promise.all(jobs)
          /* only the two lettering faces — chaining document.fonts.ready made
             the preview wait for every font on the page */
          .then(function () { res(); }, function () { res(); });
      });
    }
    nameFontsP.then(function () { nameFontsLoaded = true; cb(); }, function () { nameFontsLoaded = true; cb(); });
  }
  function twoLayers() {
    /* '2 Layers' on the layers option = an underlay showing as an outline */
    if (!PTYPE.layersOpt) return false;
    var vL = st['opt' + PTYPE.layersOpt];
    return !!(vL && /2/.test(String(vL.label || '')));
  }
  function ttLines() {
    var out = [];
    for (var iL = 1; iL <= (PTYPE.textLines || 3); iL++) {
      var elL = document.getElementById('np-e2-tt-l' + iL);
      var vT = elL ? String(elL.value || '').replace(/\s+/g, ' ').trim() : '';
      if (vT) out.push(vT);
    }
    return out;
  }
  /* the Symbol-font keyboard convention every Greek-merch shop uses:
     C=Chi, Q=Theta, W=Omega, X=Xi, Y=Psi — everything else is the obvious one */
  var GREEK_MAP = { A:'\u0391', B:'\u0392', C:'\u03A7', D:'\u0394', E:'\u0395', F:'\u03A6', G:'\u0393', H:'\u0397', I:'\u0399', K:'\u039A', L:'\u039B', M:'\u039C', N:'\u039D', O:'\u039F', P:'\u03A0', Q:'\u0398', R:'\u03A1', S:'\u03A3', T:'\u03A4', U:'\u03A5', V:'\u03A5', W:'\u03A9', X:'\u039E', Y:'\u03A8', Z:'\u0396', J:'\u0399' };
  function ttGreekify(str) {
    return String(str).toUpperCase().replace(/[A-Z]/g, function (ch) { return GREEK_MAP[ch] || ch; });
  }
  function ttFontIsScript() {
    var fS = activeNameFont();
    return !!(fS && (fS.script || /script/i.test(fS.label || '')));
  }
  function ttSwooshTextHex() {
    var c = st.swooshTextColor;
    if (c && c.hex) return c.hex;
    /* no pick yet: whichever of white/black reads on the tail's twill */
    var h = ttInk().replace('#', '');
    var lum = parseInt(h.slice(0, 2), 16) * 0.299 + parseInt(h.slice(2, 4), 16) * 0.587 + parseInt(h.slice(4, 6), 16) * 0.114;
    return lum > 140 ? '#0C0C0E' : '#FFFFFF';
  }
  function ttSwooshOn() {
    /* the tail exits the LAST line's baseline: straight or slanted both give
       it one — only an ARCH has no baseline to leave from */
    var nL = ttLines().length || 1;
    return !!(st.swoosh && ttFontIsScript() && !/arch/i.test(String(st['ttLay' + nL] || 'Straight')));
  }
  function ttInk() {
    var c = st.bg;
    return (c && c.hex && c.label !== 'Let Ninja Choose' && c.label !== 'Not Sure') ? c.hex : '#0C0C0E';
  }
  function ttEdge() {
    var c = st.thread;
    if (c && c.hex && c.label !== 'Let Ninja Choose' && c.label !== 'Not Sure') return c.hex;
    /* 2 Layers picked but no outline colour yet: show the second layer in WHITE
       as a placeholder, so the customer sees the underlay exists before they
       choose its colour */
    return '#FFFFFF';
  }
  var TT_ARCH = 0.42; /* half-angle of the arch, radians — a varsity curve */
  var TT_SLANT = 0.21; /* ~12 degrees, ascending to the right (Huskies look) */
  function ttGlyphs(x, txt, cx, baseY, mode) {
    /* mode: true|'arch' = arched, 'slant' = tilted line, anything else straight.
       NOTE it is a STRING now — a truthy 'straight' used to arch everything. */
    var arch = mode === true || mode === 'arch';
    var chars = String(txt).split('');
    var ws = chars.map(function (c) { return x.measureText(c).width; });
    var total = ws.reduce(function (a, b) { return a + b; }, 0) || 1;
    var out = [], s0 = 0, i;
    if (!arch) {
      for (i = 0; i < chars.length; i++) {
        out.push({ ch: chars[i], x: cx - total / 2 + s0 + ws[i] / 2, y: baseY, a: 0 });
        s0 += ws[i];
      }
      if (mode === 'slant') {
        /* rotate the finished line about its centre — letters lean WITH the
           baseline so the whole word tilts as one piece */
        var ca = Math.cos(-TT_SLANT), sa = Math.sin(-TT_SLANT);
        out.forEach(function (g) {
          var dx = g.x - cx, dy = g.y - baseY;
          g.x = cx + dx * ca - dy * sa;
          g.y = baseY + dx * sa + dy * ca;
          g.a = -TT_SLANT;
        });
      }
      return out;
    }
    var R = (total / 2) / Math.sin(TT_ARCH);
    for (i = 0; i < chars.length; i++) {
      var mid = s0 + ws[i] / 2;
      var th = ((mid - total / 2) / (total / 2)) * TT_ARCH;
      out.push({
        ch: chars[i],
        x: cx + R * Math.sin(th),
        y: baseY + R - R * Math.cos(th),
        a: th
      });
      s0 += ws[i];
    }
    return out;
  }
  function ttArchRise(x, txt) {
    /* how much taller an arched line is than a straight one */
    var total = String(txt).split('').reduce(function (a, c) { return a + x.measureText(c).width; }, 0) || 1;
    var R = (total / 2) / Math.sin(TT_ARCH);
    return R - R * Math.cos(TT_ARCH);
  }
  function ttPaintGlyphs(x, gs, mode, boostPx) {
    gs.forEach(function (g) {
      x.save();
      x.translate(g.x, g.y);
      if (g.a) x.rotate(g.a);
      if (mode === 'fill') {
        x.fillText(g.ch, 0, 0);
        /* faux weight: a stroke in the SAME colour thickens a light face to
           match the block font without redrawing its letterforms */
        if (boostPx) {
          var prevS = x.strokeStyle, prevW = x.lineWidth;
          x.strokeStyle = x.fillStyle; x.lineWidth = boostPx;
          x.strokeText(g.ch, 0, 0);
          x.strokeStyle = prevS; x.lineWidth = prevW;
        }
      } else x.strokeText(g.ch, 0, 0);
      x.restore();
    });
  }
  function ttBoost(PX) {
    var fB = activeNameFont();
    var bV = parseFloat((fB && fB.boost) || 0);
    return bV ? Math.max(1, PX * bV) : 0;
  }
  function ttBez(t, a, b, c, d) {
    var mt = 1 - t;
    return mt * mt * mt * a + 3 * mt * mt * t * b + 3 * mt * t * t * c + t * t * t * d;
  }
  function ttBezD(t, a, b, c, d) {
    var mt = 1 - t;
    return 3 * mt * mt * (b - a) + 6 * mt * t * (c - b) + 3 * t * t * (d - c);
  }
  function ttSwooshCtl(x0, x1, yBase, drop) {
    /* the classic varsity tail: dips under the block, sweeps up on the right */
    var sp = x1 - x0;
    return {
      xs: [x0, x0 + sp * 0.24, x0 + sp * 0.70, x1],
      ys: [yBase - drop * 0.30, yBase + drop * 0.92, yBase + drop * 0.92, yBase - drop * 0.62]
    };
  }
  /* ── the 13 stock swoosh tails ──────────────────────────────────────────
     Every style is a CENTERLINE (sampled points) + a WIDTH PROFILE + an
     optional edge modulation, so each renders in the customer's twill colour
     with the 2-layer outline, at any size. Numbers match the catalog sheet. */
  /* display numbers run 1-8 in order; `geo` is the internal geometry key
     (the old catalog case numbers — old orders keep rendering) */
  var TT_SWOOSHES = [
    { n: 1, geo: 1, name: 'Classic Tail' }, { n: 2, geo: 2, name: 'Hook Underline' },
    { n: 3, geo: 3, name: 'Tail Hook' }, { n: 4, geo: 5, name: 'Blade' },
    { n: 5, geo: 8, name: 'Double Wave' }, { n: 6, geo: 10, name: 'Long Hook' }
    /* #7 Wing removed 2026-08-19 (never matched the reference); ttSwooshDef
       falls back to Classic Tail for any session that still stores 7 */
  ];
  function ttSwooshDef(nS) {
    var n = parseInt(nS, 10) || 1;
    for (var i = 0; i < TT_SWOOSHES.length; i++) if (TT_SWOOSHES[i].n === n) return TT_SWOOSHES[i];
    return TT_SWOOSHES[0]; /* Classic Tail */
  }
  function ttCurlPts(cx, cy, r, a0, a1, N) {
    var out = [];
    for (var i = 1; i <= N; i++) {
      var a = a0 + (a1 - a0) * (i / N);
      out.push([cx + Math.cos(a) * r, cy + Math.sin(a) * r]);
    }
    return out;
  }
  function ttInkExit(txt, pxSize, f) {
    /* the REAL end of the last letter: rightmost ink pixel and the height of
       the stroke there — the advance-width box lies about where a cursive
       exit stroke actually finishes */
    try {
      var spec = ((f && f.weight) || 700) + ' ' + Math.round(pxSize) + 'px ' + nameFontStack(f);
      var pad2 = Math.ceil(pxSize * 0.3);
      var probe2 = document.createElement('canvas').getContext('2d');
      probe2.font = spec;
      var m2 = probe2.measureText(txt);
      var w2 = Math.ceil(m2.width), asc2 = Math.ceil(m2.actualBoundingBoxAscent || pxSize * 0.78), desc2 = Math.ceil(m2.actualBoundingBoxDescent || pxSize * 0.22);
      var cv2 = document.createElement('canvas'); cv2.width = w2 + pad2 * 2; cv2.height = asc2 + desc2 + pad2 * 2;
      var x2 = cv2.getContext('2d');
      x2.font = spec; x2.textBaseline = 'alphabetic'; x2.textAlign = 'left';
      x2.fillStyle = '#000'; x2.fillText(txt, pad2, pad2 + asc2);
      var d2 = x2.getImageData(0, 0, cv2.width, cv2.height).data;
      var xe = -1, yy, xx;
      for (xx = cv2.width - 1; xx >= 0 && xe < 0; xx--) {
        for (yy = 0; yy < cv2.height; yy++) { if (d2[(yy * cv2.width + xx) * 4 + 3] > 40) { xe = xx; break; } }
      }
      if (xe < 0) return null;
      var ys = 0, n2 = 0, x3, y3;
      for (x3 = Math.max(0, xe - Math.round(pxSize * 0.05)); x3 <= xe; x3++) {
        for (y3 = 0; y3 < cv2.height; y3++) { if (d2[(y3 * cv2.width + x3) * 4 + 3] > 40) { ys += y3; n2++; } }
      }
      return { dx: xe - pad2, dy: (n2 ? ys / n2 : pad2 + asc2) - (pad2 + asc2) };
    } catch (eIE) { return null; }
  }
  function ttTailGeom(styleN, x0, x1, yB, swH, PX) {
    /* centerline points LEFT→RIGHT + width profile w(t) in [0,1] of halfW */
    var N = 120, pts = [], i, t;
    var span = x1 - x0;
    function bez(cys) {
      for (i = 0; i <= N; i++) {
        t = i / N;
        pts.push([ttBez(t, x0, x0 + span * 0.3, x1 - span * 0.14, x1), ttBez(t, cys[0], cys[1], cys[2], cys[3])]);
      }
    }
    var flat = yB + swH * 0.4;
    var curl = null, wf, mod = null;
    switch (styleN) {
      case 1: /* heavy swash, curl up at the right */
        bez([flat + swH * 0.06, flat - swH * 0.12, flat + swH * 0.1, flat - swH * 0.05]);
        wf = function (t2) { return 0.5 + 0.75 * Math.pow(1 - t2, 0.8); };
        curl = { r: swH * 0.3, up: 1 }; break;
      case 2: /* flat underline, small hook */
        bez([flat, flat, flat, flat - swH * 0.04]);
        wf = function () { return 0.5; };
        curl = { r: swH * 0.22, up: 1 }; break;
      case 3: /* pointed left, flat, hook right */
        bez([flat, flat, flat, flat - swH * 0.04]);
        wf = function (t2) { return 0.55 * Math.min(1, t2 * 6); };
        curl = { r: swH * 0.22, up: 1 }; break;
      case 4: /* tribal leaves */
        bez([flat, flat - swH * 0.05, flat + swH * 0.05, flat]);
        wf = function () { return 0.5; };
        mod = 'flame'; break;
      case 5: /* blade: pointed both ends, belly middle */
        bez([flat + swH * 0.02, flat - swH * 0.1, flat - swH * 0.1, flat + swH * 0.02]);
        wf = function (t2) { return Math.pow(Math.sin(Math.PI * t2), 0.6); };
        break;
      case 6: /* smooth wave */
        bez([flat - swH * 0.06, flat + swH * 0.3, flat - swH * 0.3, flat + swH * 0.02]);
        wf = function (t2) { return 0.45 + 0.3 * Math.sin(Math.PI * t2); };
        break;
      case 7: /* plain bar */
        bez([flat, flat, flat, flat]);
        wf = function () { return 0.55; };
        break;
      case 8: /* double wave, rising right */
        bez([flat + swH * 0.05, flat - swH * 0.42, flat + swH * 0.42, flat - swH * 0.25]);
        wf = function (t2) { return Math.pow(Math.sin(Math.PI * Math.min(1, t2 * 1.04)), 0.5); };
        break;
      case 9: /* lightning */
        bez([flat, flat, flat, flat - swH * 0.1]);
        wf = function () { return 0.42; };
        mod = 'zig';
        curl = { r: swH * 0.2, up: 1 }; break;
      case 10: /* long taper, flick right */
        bez([flat + swH * 0.02, flat, flat, flat - swH * 0.06]);
        wf = function (t2) { return 0.75 * Math.pow(t2, 0.55); };
        curl = { r: swH * 0.24, up: 1 }; break;
      case 12: /* arrow blade: diamond bulge */
        bez([flat, flat, flat, flat]);
        wf = function (t2) { var d = Math.abs(t2 - 0.45); return Math.max(0.06, 1 - d * 2.4); };
        break;
      case 16: /* WING — barbed at the left like a feather, but the RIGHT end
                   is the classic tail's: it sweeps up and fattens back to
                   full width so it welds into the last letter's exit stroke
                   instead of arriving as a thin thread. */
        bez([flat + swH * 0.08, flat - swH * 0.08, flat + swH * 0.1, flat - swH * 0.35]);
        wf = function (t2) {
          var barb = 0.4 + 1.05 * Math.pow(1 - t2, 0.7);
          var weld = t2 > 0.72 ? 0.6 * Math.pow((t2 - 0.72) / 0.28, 2) : 0;
          return Math.min(1.45, barb + weld);
        };
        break;
      case 13: /* crescent smile */
        bez([flat - swH * 0.15, flat + swH * 0.55, flat + swH * 0.55, flat - swH * 0.15]);
        wf = function (t2) { return Math.pow(Math.sin(Math.PI * t2), 0.8); };
        break;
      default: /* 11 — the classic baseball swoosh: NO end curl, the band
                   sweeps up and WELDS into the last letter's exit stroke */
        bez([flat - swH * 0.05, flat + swH * 0.34, flat + swH * 0.3, flat - swH * 0.35]);
        wf = function (t2) { return Math.pow(t2, 0.7); };
        break;
    }
    var attachY = yB - PX * 0.06;
    if (!curl) {
      /* rise into the last letter's baseline exit over the final stretch */
      var M0 = pts.length - 1, i0 = Math.round(M0 * 0.8);
      for (i = i0; i <= M0; i++) {
        var f = (i - i0) / (M0 - i0);
        pts[i][1] += (attachY - pts[i][1]) * f * f;
      }
    } else {
      var last = pts[pts.length - 1];
      pts = pts.concat(ttCurlPts(last[0] - curl.r * 0.15, last[1] - curl.r, curl.r, Math.PI * 0.5, -Math.PI * 0.35, 26));
    }
    return { pts: pts, wf: wf, mod: mod, curlN: curl ? 26 : 0 };
  }
  function ttWingOld(x, x0, x1, yT, sH, fill, edge, ringPx) {
    /* The classic athletic tail: a barbed FORK at the left (two sharp points
       with a notch between), a long tapering body, and a hook that curls up
       and back over itself at the right. */
    var w = x1 - x0, mid = yT + sH * 0.42;
    var bodyT = sH * 0.2;            /* thickest part of the body */
    var hookX = x1 - w * 0.06;
    function path() {
      x.beginPath();
      /* upper barb tip, back along the top edge to the hook */
      x.moveTo(x0, mid - sH * 0.3);
      x.bezierCurveTo(x0 + w * 0.3, mid - bodyT * 0.55, x0 + w * 0.62, mid - bodyT * 0.42, hookX - w * 0.03, mid - bodyT * 0.5);
      /* the hook: up, over the top, and curling back down to the left */
      x.bezierCurveTo(x1, mid - sH * 0.46, x1 + w * 0.012, mid - sH * 0.02, hookX - w * 0.035, mid + sH * 0.03);
      x.bezierCurveTo(x1 - w * 0.055, mid - sH * 0.12, x1 - w * 0.03, mid - sH * 0.28, hookX - w * 0.08, mid - sH * 0.2);
      /* underside of the body running back to the lower barb */
      x.bezierCurveTo(x0 + w * 0.55, mid + bodyT * 0.16, x0 + w * 0.26, mid + bodyT * 0.5, x0 + w * 0.03, mid + sH * 0.3);
      /* the notch between the two barbs */
      x.bezierCurveTo(x0 + w * 0.16, mid + bodyT * 0.1, x0 + w * 0.15, mid - bodyT * 0.12, x0, mid - sH * 0.3);
      x.closePath();
    }
    if (ringPx) { path(); x.strokeStyle = edge; x.lineWidth = ringPx * 2; x.lineJoin = 'round'; x.stroke(); }
    path(); x.fillStyle = fill; x.fill();
  }
  function ttWing(x, x0, x1, yT, sH, fill, edge, ringPx, joinY) {
    /* the standard athletic tail: a BARBED fork at the left (two sharp points
       with a notch bitten out between them), a body that swells then tapers
       to a point at the right — which RISES to meet the last letter's exit
       stroke, so the two read as one cut piece */
    var w = x1 - x0, mid = yT + sH * 0.45;
    var tipY = (typeof joinY === 'number') ? joinY : mid - sH * 0.27;
    function path() {
      x.beginPath();
      x.moveTo(x0, mid - sH * 0.30);                                   /* upper barb */
      x.bezierCurveTo(x0 + w * 0.34, mid - sH * 0.17, x0 + w * 0.72, tipY + sH * 0.04, x1, tipY - sH * 0.06);
      x.bezierCurveTo(x0 + w * 0.72, tipY + sH * 0.2, x0 + w * 0.36, mid + sH * 0.11, x0 + w * 0.05, mid + sH * 0.34);
      x.bezierCurveTo(x0 + w * 0.16, mid + sH * 0.07, x0 + w * 0.15, mid - sH * 0.05, x0, mid - sH * 0.30);
      x.closePath();
    }
    if (ringPx) { path(); x.strokeStyle = edge; x.lineWidth = ringPx * 2; x.lineJoin = 'round'; x.stroke(); }
    path(); x.fillStyle = fill; x.fill();
  }
  function ttBandFromPts(x, g, halfW, fill, edge, ringPx) {
    var pts = g.pts, M = pts.length - 1, top = [], bot = [];
    for (var i = 0; i <= M; i++) {
      var t = i / M;
      var p = pts[i], pp = pts[Math.max(0, i - 1)], pn = pts[Math.min(M, i + 1)];
      var dx = pn[0] - pp[0], dy = pn[1] - pp[1];
      var L = Math.sqrt(dx * dx + dy * dy) || 1;
      var nx = -dy / L, ny = dx / L;
      var hw = halfW * g.wf(Math.min(1, i / (M - g.curlN || M)));
      /* the curl thins to a point along its own length */
      if (g.curlN && i > M - g.curlN) hw = halfW * g.wf(1) * (M - i) / g.curlN;
      if (g.mod === 'zig') hw *= (Math.floor(t * 11) % 2 ? 0.24 : 1);
      if (g.mod === 'flame') hw *= (0.25 + 0.75 * Math.abs(Math.sin(t * Math.PI * 5.5)));
      top.push([p[0] + nx * hw, p[1] + ny * hw]);
      bot.push([p[0] - nx * hw, p[1] - ny * hw]);
    }
    x.beginPath();
    top.forEach(function (p2, i2) { if (i2) x.lineTo(p2[0], p2[1]); else x.moveTo(p2[0], p2[1]); });
    for (var j = bot.length - 1; j >= 0; j--) x.lineTo(bot[j][0], bot[j][1]);
    x.closePath();
    if (ringPx) { x.strokeStyle = edge; x.lineWidth = ringPx * 2; x.lineJoin = 'round'; x.stroke(); }
    x.fillStyle = fill; x.fill();
  }
  function ttTailBand(x, c, halfW, fill, edge, ringPx) {
    /* the baseball tail: pointed at the LEFT tip, full width at the RIGHT end
       where it joins the last letter's exit stroke */
    var N = 96, top = [], bot = [];
    for (var i = 0; i <= N; i++) {
      var t = i / N;
      var px = ttBez(t, c.xs[0], c.xs[1], c.xs[2], c.xs[3]);
      var py = ttBez(t, c.ys[0], c.ys[1], c.ys[2], c.ys[3]);
      var dx = ttBezD(t, c.xs[0], c.xs[1], c.xs[2], c.xs[3]);
      var dy = ttBezD(t, c.ys[0], c.ys[1], c.ys[2], c.ys[3]);
      var L = Math.sqrt(dx * dx + dy * dy) || 1;
      var nx = -dy / L, ny = dx / L;
      var hw = halfW * Math.pow(t, 0.7);
      top.push([px + nx * hw, py + ny * hw]);
      bot.push([px - nx * hw, py - ny * hw]);
    }
    x.beginPath();
    top.forEach(function (p, i2) { if (i2) x.lineTo(p[0], p[1]); else x.moveTo(p[0], p[1]); });
    for (var j = bot.length - 1; j >= 0; j--) x.lineTo(bot[j][0], bot[j][1]);
    x.closePath();
    if (ringPx) { x.strokeStyle = edge; x.lineWidth = ringPx * 2; x.lineJoin = 'round'; x.stroke(); }
    x.fillStyle = fill; x.fill();
  }
  function ttSwooshBand(x, c, halfW, fill, edge, ringPx) {
    /* one closed ribbon: the top edge forward, the bottom edge back, with the
       ends tapered the way a cut twill tail is */
    var N = 96, top = [], bot = [];
    for (var i = 0; i <= N; i++) {
      var t = i / N;
      var px = ttBez(t, c.xs[0], c.xs[1], c.xs[2], c.xs[3]);
      var py = ttBez(t, c.ys[0], c.ys[1], c.ys[2], c.ys[3]);
      var dx = ttBezD(t, c.xs[0], c.xs[1], c.xs[2], c.xs[3]);
      var dy = ttBezD(t, c.ys[0], c.ys[1], c.ys[2], c.ys[3]);
      var L = Math.sqrt(dx * dx + dy * dy) || 1;
      var nx = -dy / L, ny = dx / L;
      var hw = halfW * Math.pow(Math.sin(Math.PI * t), 0.32);
      top.push([px + nx * hw, py + ny * hw]);
      bot.push([px - nx * hw, py - ny * hw]);
    }
    x.beginPath();
    top.forEach(function (p, i) { if (i) x.lineTo(p[0], p[1]); else x.moveTo(p[0], p[1]); });
    for (var j = bot.length - 1; j >= 0; j--) x.lineTo(bot[j][0], bot[j][1]);
    x.closePath();
    if (ringPx) { x.strokeStyle = edge; x.lineWidth = ringPx * 2; x.lineJoin = 'round'; x.stroke(); }
    x.fillStyle = fill; x.fill();
  }
  function ttSwooshLabel(x, c, txt, hex, fontSpec, fitPx, fitFam) {
    /* the banner lettering follows the curve, glyph by glyph, the way it is
       stitched onto the real tail */
    if (!txt) return;
    var pts = [], len = [0], i;
    if (c.pts) {
      pts = c.pts;
      for (i = 1; i < pts.length; i++) {
        var dxp = pts[i][0] - pts[i - 1][0], dyp = pts[i][1] - pts[i - 1][1];
        len.push(len[i - 1] + Math.sqrt(dxp * dxp + dyp * dyp));
      }
    } else {
    var N = 240;
    for (i = 0; i <= N; i++) {
      var t = i / N;
      pts.push([ttBez(t, c.xs[0], c.xs[1], c.xs[2], c.xs[3]), ttBez(t, c.ys[0], c.ys[1], c.ys[2], c.ys[3])]);
      if (i) {
        var ddx = pts[i][0] - pts[i - 1][0], ddy = pts[i][1] - pts[i - 1][1];
        len.push(len[i - 1] + Math.sqrt(ddx * ddx + ddy * ddy));
      }
    }
    }
    var total = len[len.length - 1];
    x.save();
    x.font = fontSpec;
    /* the label must live INSIDE the tail: shrink it until the whole string
       fits the usable run of the shape (it used to spill off the thin end) */
    if (fitPx && fitFam) {
      var pxTry = fitPx, guard = 0;
      while (guard++ < 24) {
        x.font = '700 ' + Math.max(6, Math.round(pxTry)) + 'px ' + fitFam;
        if (x.measureText(String(txt)).width <= total * 0.82 || pxTry <= 7) break;
        pxTry *= 0.92;
      }
    }
    x.textBaseline = 'middle';
    x.textAlign = 'center';
    x.fillStyle = hex;
    var chars = String(txt).split('');
    var widths = chars.map(function (ch) { return x.measureText(ch).width; });
    var tw = widths.reduce(function (a, b) { return a + b; }, 0);
    if (tw > total * 0.9) { /* nothing to do but let it ride the whole tail */ }
    var cur = (total - tw) / 2;
    chars.forEach(function (ch, ci) {
      var at = cur + widths[ci] / 2;
      var k = 1;
      while (k < len.length - 1 && len[k] < at) k++;
      /* INTERPOLATE along the segment — snapping to the nearest sample point
         quantized glyph positions and opened phantom gaps on uneven curves */
      var p0 = pts[k - 1], p1 = pts[k];
      var seg = len[k] - len[k - 1] || 1;
      var f = Math.max(0, Math.min(1, (at - len[k - 1]) / seg));
      var gx = p0[0] + (p1[0] - p0[0]) * f;
      var gy = p0[1] + (p1[1] - p0[1]) * f;
      var ang = Math.atan2(p1[1] - p0[1], p1[0] - p0[0]);
      x.save();
      x.translate(gx, gy);
      x.rotate(ang);
      x.fillText(ch, 0, 0);
      x.restore();
      cur += widths[ci];
    });
    x.restore();
  }
  function ttTextCanvas(ov) {
    /* the typed lettering, drawn as the cut twill pieces: one pass per line,
       an underlay stroke when the order is 2-layer, and the varsity swoosh
       under the block when the script face is on */
    var lines = ttLines();
    if (!lines.length) lines = ['YOUR TEXT'];
    var f = activeNameFont();
    /* the Greek face maps the LATIN keyboard onto Greek letters — typing A
       stitches an Alpha */
    if (f && f.greekmap) lines = lines.map(ttGreekify);
    else if (f && f.caps) lines = lines.map(function (sU) { return sU.toUpperCase(); });
    /* a script face is ALWAYS initial caps — all-caps script is not a thing */
    else if (f && (f.script || /script/i.test(f.label || ''))) {
      lines = lines.map(function (sT) {
        return sT.toLowerCase().replace(/(^|[\s'-])([a-z])/g, function (mT, pre, ch) { return pre + ch.toUpperCase(); });
      });
    }
    var PX = 260, LEAD = 1.16;
    var specFor = function (pxL) { return ((f && f.weight) || 700) + ' ' + Math.round(pxL) + 'px ' + nameFontStack(f); };
    /* line 1 always leads at full size; 2 and 3 can be dropped to half */
    var pxs = lines.map(function (sP, iP) { return iP > 0 && st['ttHalf' + (iP + 1)] ? PX * 0.5 : PX; });
    var spec = specFor(PX);
    var probe = document.createElement('canvas').getContext('2d');
    var widths = [], ascs = [], descs = [], lineHs = [];
    lines.forEach(function (sW, iW) {
      probe.font = specFor(pxs[iW]);
      var mW = probe.measureText(sW);
      widths.push(mW.width);
      ascs.push(mW.actualBoundingBoxAscent || pxs[iW] * 0.78);
      descs.push(mW.actualBoundingBoxDescent || pxs[iW] * 0.22);
      lineHs.push(Math.round((ascs[iW] + descs[iW]) * LEAD));
    });
    probe.font = spec;
    var maxW = Math.max.apply(null, widths) || PX;
    var asc = ascs[0];
    var lineH = Math.max.apply(null, lineHs);
    var ring = twoLayers() ? Math.max(3, Math.round(PX * 0.02)) + 5 : 0; /* +5 each side = ~10px more twill showing */
    var swoosh = ttSwooshOn();
    var pad = Math.round(PX * 0.22) + ring;
    var swH = swoosh ? Math.round(PX * 0.55) : 0;
    /* PER-LINE layout: each line is Straight, Arch or Slanted, and each adds
       its own headroom so stacked lines never collide */
    var lays = lines.map(function (_, iL) { return String(st['ttLay' + (iL + 1)] || 'Straight').toLowerCase(); });
    var slantRises = [], archPad = 0;
    lines.forEach(function (sA, iA) {
      probe.font = specFor(pxs[iA]);
      if (lays[iA] === 'arch') {
        lineHs[iA] += Math.ceil(ttArchRise(probe, sA));
        slantRises.push(0);
      } else if (lays[iA] === 'slanted' || lays[iA] === 'slant') {
        /* parallel slanted lines never collide, so the tilt costs NOTHING
           between lines — only the block's top and bottom need headroom.
           (Charging every line for it spaced them far apart.) */
        slantRises.push(Math.ceil((widths[iA] / 2) * Math.sin(TT_SLANT)) + 4);
      } else slantRises.push(0);
    });
    var slantTop = slantRises[0] || 0;
    var slantBot = slantRises[slantRises.length - 1] || 0;
    lays = lays.map(function (v) { return v === 'slanted' ? 'slant' : v; });
    probe.font = spec;
    var cv = document.createElement('canvas');
    cv.width = Math.ceil(maxW + pad * 2);
    cv.height = Math.ceil(lineHs.reduce(function (a, b) { return a + b; }, 0) + pad * 2 + swH + archPad + slantTop + slantBot);
    var x = cv.getContext('2d');
    x.font = spec;
    x.textBaseline = 'alphabetic';
    x.textAlign = 'center';
    x.lineJoin = 'round';
    x.miterLimit = 2;
    var ink = ttInk(), edge = ttEdge();
    var zig = /zig/i.test(String(st.ttStitch || 'Zig Zag'));
    var baseYs = [], runY = pad + slantTop;
    lines.forEach(function (sB, iB) { baseYs.push(runY + ascs[iB]); runY += lineHs[iB]; });
    var glyphSets = lines.map(function (sG, iG) {
      x.font = specFor(pxs[iG]);
      return ttGlyphs(x, sG, cv.width / 2, baseYs[iG], lays[iG]);
    });
    /* every pass repaints line by line, each in its own size */
    var paintLines = function (mode, widthFn, boostFn) {
      glyphSets.forEach(function (gs, iL) {
        x.font = specFor(pxs[iL]);
        var kL = pxs[iL] / PX; /* a half-size line gets half the stroke weight */
        if (widthFn) x.lineWidth = widthFn(kL);
        ttPaintGlyphs(x, gs, mode, boostFn ? boostFn(kL) : 0);
      });
    };
    /* underlay FIRST for every line, then the tops — otherwise a stacked
       line's outline paints over the line above it */
    if (ring) {
      x.strokeStyle = edge;
      x.setLineDash([]);
      /* the second twill layer is a BORDER on each letter */
      paintLines('stroke', function (kL) { return (ring * 2 + ttBoost(PX)) * kL; });
    }
    /* EVERY order gets an edge stitch — single layer, top layer or stacked.
       Satin is a dense band that covers the cut edge completely; zig-zag is the
       open tacking stitch, so its individual stitches stay visible. */
    {
      /* The reference USED to ship with no edge detail at all, and the renderer
         filled the gap with an invented white satin layer between the twill
         colours. Now that the stitch is self-coloured it goes to Sensei too —
         but always tonal and solid there, never the contrast dashes, so there
         is nothing white for the model to copy. */
      var refOnlyS = !!(ov && ov.refOnly);
      x.strokeStyle = ttStitchHex(refOnlyS ? true : !zig);
      x.setLineDash((zig && !refOnlyS) ? [Math.max(3, PX * 0.03), Math.max(3, PX * 0.028)] : []);
      x.lineCap = (zig && !refOnlyS) ? 'butt' : 'round';
      paintLines('stroke', function (kL) {
        var wS = zig ? Math.max(2, PX * 0.026) : Math.max(3, PX * 0.052) + 10;
        /* TWO LAYERS: the stitch is capped against the underlay so the outline
           colour always stays visible — a full-width satin band covered it */
        if (ring) wS = Math.min(wS, Math.max(2, ring * 0.7));
        return (wS + ttBoost(PX) * 0.6) * kL;
      });
      x.setLineDash([]);
      x.lineCap = 'butt';
    }
    x.fillStyle = ink;
    paintLines('fill', null, function (kL) { return ttBoost(PX) * kL; });
    if (swoosh) {
      /* BASEBALL TAIL: exits the LAST letter's baseline stroke, dips under the
         whole design and tapers to a point past its left edge */
      var lastI = lines.length - 1;
      /* the tail belongs to the line it exits: a half-size last line gets a
         half-size tail — thickness, depth and reach all scale with it */
      var kSw = pxs[lastI] / PX;
      var leftEdge = cv.width / 2 - (widths[lastI] * 1.35) / 2;
      leftEdge = Math.max(cv.width / 2 - Math.max.apply(null, widths) / 2, leftEdge);
      var lastBase = baseYs[lastI];
      var attachX = Math.min(cv.width - pad * 0.4, cv.width / 2 + widths[lastI] / 2 - PX * 0.04 * kSw);
      var attachY = lastBase - PX * 0.06 * kSw;
      /* connect at the letter's ACTUAL exit stroke — measured from the ink,
         then pulled slightly INTO the stroke; the letters repaint on top, so
         the weld reads as one continuous stroke (the cursive-e case) */
      var slantLast = lays[lastI] === 'slant';
      var exitP = ttInkExit(lines[lastI], pxs[lastI], f);
      if (exitP) {
        var lineLeft = cv.width / 2 - widths[lastI] / 2;
        attachX = Math.min(cv.width - pad * 0.3, lineLeft + exitP.dx - Math.max(4, PX * 0.03 * kSw));
        attachY = baseYs[lastI] + exitP.dy;
      }
      var tipX = Math.max(pad * 0.35, leftEdge - PX * 0.1 * kSw);
      /* the tail HUGS the word: a shallow dip just under the baseline, the way
         the classic baseball script underline sits (Royals reference) */
      var deepY = lastBase + swH * 0.52;
      var ctl = {
        xs: [tipX, tipX + (attachX - tipX) * 0.3, attachX - (attachX - tipX) * 0.12, attachX],
        ys: [lastBase + swH * 0.2, deepY, deepY * 0.997, attachY]
      };
      var halfW = Math.max(5, Math.round(PX * 0.085 * kSw));
      /* the tail rides the slant: rotate the whole thing about the line's
         centre so it leaves the letter at the same angle the word sits at */
      if (slantLast) {
        x.save();
        x.translate(cv.width / 2, baseYs[lastI]);
        x.rotate(-TT_SLANT);
        x.translate(-cv.width / 2, -baseYs[lastI]);
      }
      var styleNo = ttSwooshDef(st.swooshStyle).geo;
      var geomT = ttTailGeom(styleNo, tipX, attachX, lastBase, Math.round(swH * kSw), Math.round(PX * kSw));
      if (styleNo === 16) {
        /* the athletic WING is a drawn SHAPE — barbed fork left, swelling
           body, and a hook that curls up-and-over at the right. The hook is
           pushed slightly PAST the attach point so its crest rises under the
           last letter's exit stroke; the letters repaint on top and the two
           read as one cut piece. (The band centerline is kept only as the
           path the on-tail text rides.) */
        ttWingOld(x, tipX, attachX + Math.round(PX * 0.03 * kSw), lastBase, Math.round(swH * kSw), ink, edge, ring);
      } else {
        ttBandFromPts(x, geomT, halfW * 1.3, ink, edge, ring);
      }
      /* optional lettering stitched along the tail, in the contrast colour */
      var swTxt = String(st.swooshText || '').trim();
      if (swTxt) {
        /* the label paints in the same face as the lettering */
        var famT = nameFontStack(f);
        var lblPx = Math.round(halfW * 1.35);
        var lblHex = ttSwooshTextHex();
        var ptsAll = geomT.pts.slice(0, geomT.pts.length - geomT.curlN);
        /* sample the width profile and put the text where the tail is THICK —
           some styles fatten toward the left tip, others toward the join */
        var pathT = (geomT.wf(0.15) >= geomT.wf(0.85))
          ? ptsAll.slice(Math.floor(ptsAll.length * 0.05), Math.floor(ptsAll.length * 0.66))
          : ptsAll.slice(Math.floor(ptsAll.length * 0.34), Math.floor(ptsAll.length * 0.95));
        ttSwooshLabel(x, { pts: pathT }, swTxt.toUpperCase(), lblHex,
          '700 ' + lblPx + 'px ' + famT, lblPx, famT);
      }
      x.font = spec; /* the label reset it */
      if (slantLast) x.restore();
      /* the letters paint back on top so the join reads as ONE stroke */
      x.fillStyle = ink;
      paintLines('fill', null, function (kL) { return ttBoost(PX) * kL; });
    }
    return trimToInk(cv);
  }
  function ttShade(hex, f) {
    /* f > 0 lightens toward white, f < 0 darkens toward black */
    var h = String(hex || '#888888').replace('#', '');
    if (h.length !== 6) h = '888888';
    var out = '#';
    for (var i = 0; i < 3; i++) {
      var v = parseInt(h.substr(i * 2, 2), 16);
      v = f >= 0 ? v + (255 - v) * f : v * (1 + f);
      out += ('0' + Math.round(Math.max(0, Math.min(255, v))).toString(16)).slice(-2);
    }
    return out;
  }
  function ttStitchHex(satin) {
    var inkH = ttInk();
    var h = inkH.replace('#', '');
    var lum = parseInt(h.slice(0, 2), 16) * 0.299 + parseInt(h.slice(2, 4), 16) * 0.587 + parseInt(h.slice(4, 6), 16) * 0.114;
    /* satin = SELF-COLOURED thread: a tonal shade of the letter twill (the
       white contrast band read as a weird outline and buried the real outline
       colour); zig-zag keeps its contrast dashes — they read as stitches */
    if (satin) return lum > 140 ? ttShade(inkH, -0.22) : ttShade(inkH, 0.28);
    return lum > 140 ? 'rgba(12,12,14,.62)' : 'rgba(255,255,255,.78)';
  }
  function ttSampleInk() {
    /* the tile sits on white — a white/cream twill would vanish on it */
    var h = ttInk().replace('#', '');
    var lum = parseInt(h.slice(0, 2), 16) * 0.299 + parseInt(h.slice(2, 4), 16) * 0.587 + parseInt(h.slice(4, 6), 16) * 0.114;
    return lum > 210 ? '#3A3F52' : ttInk();
  }
  function ttSampleCanvas(arch) {
    var f = activeNameFont();
    var lbl = 'ABCD';
    var PX = 120;
    var spec = ((f && f.weight) || 700) + ' ' + PX + 'px ' + nameFontStack(f);
    var probe = document.createElement('canvas').getContext('2d');
    probe.font = spec;
    var w = probe.measureText(lbl).width || PX * 3;
    var rise = arch ? ttArchRise(probe, lbl) : 0;
    var cv = document.createElement('canvas');
    cv.width = Math.ceil(w + PX * 0.45);
    cv.height = Math.ceil(PX * 1.3 + rise);
    var x = cv.getContext('2d');
    x.font = spec;
    x.textAlign = 'center';
    x.textBaseline = 'alphabetic';
    x.fillStyle = ttSampleInk();
    ttPaintGlyphs(x, ttGlyphs(x, lbl, cv.width / 2, PX * 1.02, arch), 'fill', ttBoost(PX));
    return cv;
  }
  function ttFormatTiles() {
    /* redrawn whenever the font or the twill colour changes, so the tiles are
       a true preview of the choice rather than two words */
    $$('[data-tt-seg="fmt"]').forEach(function (bT) {
      var imT = bT.querySelector('img');
      if (!imT) return;
      try { imT.src = ttSampleCanvas(/arch/i.test(bT.getAttribute('data-tt-val') || '')).toDataURL('image/png'); }
      catch (eT) {}
    });
  }
  function ttStitchOpen(open) {
    var bodyS = document.getElementById('np-e2-tt-stitchbody');
    var rowS = document.getElementById('np-e2-tt-stitchrow');
    if (!bodyS || !rowS) return;
    bodyS.hidden = !open;
    rowS.classList.toggle('is-open', !!open);
    if (!open && st.ttStitchSeen) rowS.classList.add('is-done');
  }
  function ttLetterOpen(open) {
    var bodyL = document.getElementById('np-e2-tt-letterbody');
    var rowL = document.getElementById('np-e2-tt-letterrow');
    if (!bodyL || !rowL) return;
    bodyL.hidden = !open;
    rowL.classList.toggle('is-open', !!open);
  }
  function ttSync(repaint) {
    if (!PTYPE.textLines) return;
    var lines = ttLines();
    st.ttext = lines.length ? lines.join(' / ') : null;
    /* the number of filled lines IS the Lines of Text variant option */
    if (PTYPE.autoOpt) {
      /* the swoosh is its own cut piece stitched under the lettering — it takes
         a line, exactly like a typed row does */
      var want = Math.max(1, Math.min(PTYPE.textLines || 3, (lines.length || 1) + (ttSwooshOn() ? 1 : 0)));
      var hit = null;
      optValues(PTYPE.autoOpt).forEach(function (vO) {
        var mO = /(\d+)/.exec(String(vO.label || ''));
        if (mO && parseInt(mO[1], 10) === want) hit = vO;
      });
      if (hit) {
        st['opt' + PTYPE.autoOpt] = hit;
        if (st.draft) st.draft['opt' + PTYPE.autoOpt] = hit;
      }
    }
    setProp('_Lettering Text', lines.join(' | '));
    setProp('_Line Sizes', lines.map(function (sL, iL) {
      return 'L' + (iL + 1) + ' ' + (iL > 0 && st['ttHalf' + (iL + 1)] ? 'half' : 'full');
    }).join(', '));
    setProp('_Design Format', lines.length
      ? lines.map(function (sF, iF) { return 'L' + (iF + 1) + ' ' + (st['ttLay' + (iF + 1)] || 'Straight'); }).join(', ')
      : 'Straight');
    setProp('_Border Stitch', st.ttStitch || 'Zig Zag');
    setProp('_Swoosh', ttSwooshOn() ? 'Yes' : '');
    var swSel = document.getElementById('np-e2-tt-swstyle');
    if (swSel && swSel.value) st.swooshStyle = swSel.value;
    var defSw = ttSwooshDef(st.swooshStyle || 11);
    setProp('_Swoosh Style', ttSwooshOn() ? ('#' + defSw.n + ' ' + defSw.name) : '');
    var stitchValE = document.getElementById('np-e2-tt-stitchval');
    if (stitchValE) {
      stitchValE.textContent = st.ttStitch || 'Zig Zag';
      stitchValE.classList.add('is-set');
    }
    var swStyleRow = document.getElementById('np-e2-tt-swstylerow');
    if (swStyleRow) swStyleRow.hidden = !ttSwooshOn();
    var swColSel = document.getElementById('np-e2-tt-swtxtcolor');
    if (swColSel) {
      if (!swColSel.options.length) {
        var oAuto = document.createElement('option');
        oAuto.value = ''; oAuto.textContent = 'Auto';
        swColSel.appendChild(oAuto);
        (CFG.threads || CFG.bgs || []).forEach(function (cT) {
          if (!cT || !cT.hex) return;
          var oC = document.createElement('option');
          oC.value = cT.label; oC.textContent = cT.label;
          swColSel.appendChild(oC);
        });
      }
      var pickC = null;
      (CFG.threads || CFG.bgs || []).forEach(function (cT) { if (cT && cT.label === swColSel.value) pickC = cT; });
      st.swooshTextColor = pickC;
      setProp('_Swoosh Text Color', ttSwooshOn() && pickC ? pickC.label : '');
    }
    var swIn = document.getElementById('np-e2-tt-swtxt');
    st.swooshText = swIn ? String(swIn.value || '').trim() : '';
    setProp('_Swoosh Text', ttSwooshOn() ? st.swooshText : '');
    var swTxtRow = document.getElementById('np-e2-tt-swtxtrow');
    if (swTxtRow) swTxtRow.hidden = !ttSwooshOn();
    /* the swoosh occupies a line, and three lines is the maximum — at three
       typed lines it is off the table (and switched off if it was on) */
    var swFits = lines.length < (PTYPE.textLines || 3);
    /* only an ARCHED bottom line rules the tail out — slanted is fine */
    var bentS = /arch/i.test(String(st['ttLay' + (lines.length || 1)] || 'Straight'));
    if (st.swoosh && (!swFits || bentS)) st.swoosh = false;
    var swR = document.getElementById('np-e2-tt-swooshrow');
    if (swR) swR.hidden = !(ttFontIsScript() && swFits && !bentS);
    var swBtn = document.getElementById('np-e2-tt-swoosh');
    if (swBtn) {
      var swSw = swBtn.querySelector('.np-e2-switch');
      if (swSw) swSw.classList.toggle('is-on', !!st.swoosh);
      swBtn.setAttribute('aria-pressed', st.swoosh ? 'true' : 'false');
    }
    ensureNameFonts(ttFormatTiles);
    var valL = document.getElementById('np-e2-tt-letterval');
    if (valL) {
      valL.textContent = lines.length ? lines.join(' \u00b7 ') : 'Type your text';
      valL.classList.toggle('is-set', !!lines.length);
    }
    var rowL2 = document.getElementById('np-e2-tt-letterrow');
    if (rowL2) rowL2.classList.toggle('is-done', !!lines.length && !rowL2.classList.contains('is-open'));
    var contL = document.getElementById('np-e2-tt-lettercont');
    if (contL) contL.disabled = !lines.length;
    var lbR = document.getElementById('np-e2-tt-lines');
    if (lbR) {
      lbR.textContent = lines.length
        ? (lines.length + ' line' + (lines.length === 1 ? '' : 's') + ' \u2014 pricing updated')
        : 'Type your lettering to see it on the patch';
      lbR.classList.toggle('is-set', !!lines.length);
    }
    try { commitOptions(); } catch (eTT) {}
    /* a text/option change makes the existing proof stale — the CTA goes back
       to offering a fresh render */
    if (st.versions.length && !st.proofApproved) st.ctaRevealed = true;
    unapproveIfChanged();
    renderPricing();
    renderOptions();
    if (repaint !== false) renderMaskPreview();
  }
  function trimToInk(cv) {
    /* crop to the drawn pixels so the composer centres the ARTWORK, not the
       canvas box (font metrics lie: swashes, caps-height, descenders) */
    try {
      var xc = cv.getContext('2d');
      var idT = xc.getImageData(0, 0, cv.width, cv.height).data;
      var x0 = cv.width, y0 = cv.height, x1 = -1, y1 = -1;
      for (var yy = 0; yy < cv.height; yy++) for (var xx = 0; xx < cv.width; xx++) {
        if (idT[(yy * cv.width + xx) * 4 + 3] > 8) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
      }
      if (x1 > -1) {
        var out = document.createElement('canvas');
        out.width = x1 - x0 + 1; out.height = y1 - y0 + 1;
        out.getContext('2d').drawImage(cv, x0, y0, out.width, out.height, 0, 0, out.width, out.height);
        out.__inkY0 = y0; /* C515: nameTextCanvas maps its cap band into the cropped image */
        return out;
      }
    } catch (eTr) {}
    return cv;
  }
  function textPreviewCanvas(ov) { return PTYPE.textLines ? ttTextCanvas(ov) : nameTextCanvas(); }
  function nameTextCanvas() {
    var txt = String(st.namePreview || PTYPE.textPreview || 'NAME');
    var f = activeNameFont();
    var PX = 400; /* drawn big, then contained into the patch by the composer */
    /* SCRIPT treatment (classic chain-stitch name patch): the FIRST letter
       stitches in the block face, the rest flows in script — and the script
       gets a stroke pass so the thread reads thicker */
    var isScript = !!PTYPE.names && !!(f && f.script) && txt.length > 1;
    var blockF = isScript ? nameBlockFont() : null;
    var specMain = ((f && f.weight) || 700) + ' ' + PX + 'px ' + nameFontStack(f);
    var runs;
    if (isScript && blockF) {
      runs = [
        { t: txt.charAt(0), spec: ((blockF.weight) || 700) + ' ' + Math.round(PX * 0.98) + 'px ' + nameFontStack(blockF) },
        { t: txt.slice(1), spec: specMain }
      ];
    } else {
      runs = [{ t: txt, spec: specMain }];
    }
    var probe = document.createElement('canvas').getContext('2d');
    var asc = 0, desc = 0, leftOv = 0, rightOv = 0, totalAdv = 0;
    runs.forEach(function (r, i) {
      probe.font = r.spec;
      var m = probe.measureText(r.t);
      r.adv = m.width || 0;
      asc = Math.max(asc, m.actualBoundingBoxAscent || PX * 0.78);
      desc = Math.max(desc, m.actualBoundingBoxDescent || PX * 0.24);
      if (i === 0) leftOv = m.actualBoundingBoxLeft || 0;
      if (i === runs.length - 1) rightOv = Math.max(0, (m.actualBoundingBoxRight || m.width || PX) - r.adv);
      totalAdv += r.adv;
    });
    /* script faces overshoot their own metrics (swashes, tails) — pad so the
       flourishes are not clipped by the canvas edge */
    var pad = Math.ceil(PX * 0.08);
    var strokeW = (PTYPE.names && f && f.script) ? Math.max(2, Math.round(PX * 0.012)) : 0;
    var cv = document.createElement('canvas');
    cv.width = Math.max(2, Math.ceil(leftOv + totalAdv + rightOv) + pad * 2 + strokeW * 2);
    cv.height = Math.max(2, Math.ceil(asc + desc) + pad * 2 + strokeW * 2);
    var x = cv.getContext('2d');
    x.textBaseline = 'alphabetic';
    x.textAlign = 'left';
    x.fillStyle = nameInkHex();
    x.strokeStyle = nameInkHex();
    x.lineJoin = 'round';
    var cx = pad + strokeW + leftOv, cy = pad + strokeW + asc;
    runs.forEach(function (r) {
      x.font = r.spec;
      if (strokeW) { x.lineWidth = strokeW; x.strokeText(r.t, cx, cy); }
      x.fillText(r.t, cx, cy);
      cx += r.adv;
    });
    /* C515: the cap band (an H's top to the baseline) in the trimmed image's pixels, so the composer can size and
       centre the CAPITALS — a descender (Gary) then hangs below instead of shrinking the name and pushing it up */
    var capA = 0;
    runs.forEach(function (r) { probe.font = r.spec; capA = Math.max(capA, probe.measureText('H').actualBoundingBoxAscent || PX * 0.7); });
    var out = trimToInk(cv), y0c = out.__inkY0 || 0;
    out.__cap = { top: Math.max(0, cy - capA - y0c), base: cy - y0c };
    return out;
  }


  /* C151: the AI reference already shows the panned placement; say it in words too so the model does not re-centre */
  function panPromptLine151(dx, dy) {
    var bits = [];
    if (Math.abs(dx) >= 0.01) bits.push('about ' + Math.round(Math.abs(dx) * 100) + '% of the patch width to the ' + (dx > 0 ? 'right' : 'left'));
    if (Math.abs(dy) >= 0.01) bits.push('about ' + Math.round(Math.abs(dy) * 100) + '% of the patch height ' + (dy > 0 ? 'down' : 'up'));
    return 'PLACEMENT: the customer deliberately positioned the design OFF-CENTRE (' + (bits.join(' and ') || 'slightly off-centre') + ') exactly as shown in the reference image; reproduce that placement and crop faithfully, do not re-centre or rescale the design.';
  }
  function composePatchImage(cb, Csize, ov) {
    /* the colorized mask preview, rendered at high resolution: shape, border
       ring, background, art placement and fill — a faithful reference image
       for the renderer to convert into a patch */
    /* leather with NO shape picked yet: preview on a circle WITHOUT
       selecting it (Justin 2026-08-21 — no Circle pre-select) */
    if (!ov && !st.shape && PTYPE.mats && !PTYPE.noArt) ov = { g: 'circle' };
    var g = (ov && ov.g) || shapeGeom();
    if ((!ov && !st.shape) || !g) { cb(null); return; }
    /* text-preview types: the face has to be resident before the first paint
       or the patch renders in the browser default font, permanently */
    if ((PTYPE.textPreview || PTYPE.textLines) && !(ov && ov.src) && !nameFontsLoaded) {
      ensureNameFonts(function () { composePatchImage(cb, Csize, ov); });
      return;
    }
    var capBand515 = null; /* C515: the name's cap band (nameTextCanvas), when the drawn image is the typed name */
    var raw = (ov && ov.src) || ((PTYPE.textPreview || PTYPE.textLines)
      ? (function () { var tcv = textPreviewCanvas(ov); capBand515 = tcv.__cap || null; return tcv.toDataURL('image/png'); })()
      : applyToggleParams(cleanUrl(artworkUrl()) || ''));
    if (!raw) { cb(null); return; }
    /* C101 (2026-09-01): a FULLY-OPAQUE upload whose filled shape reaches the
       canvas edge gets amputated by imgix trim=color (border colour == fill,
       rows are stripped inward until the first interior detail - the tan
       circle lost the top of NINJA). The leather etch thresholds luminance
       anyway, so margins are harmless: drop trim for opaque art on the etch
       path. Uses npPixelHasAlpha's cache; a cold cache keeps the old URL and
       warms itself for the next compose. */
    try {
      if ((PTYPE.name === 'Leather' || PTYPE.name === 'Faux Leather') && !/^data:|^blob:/.test(raw) && /[?&]trim=/.test(raw)) {
        var aKey101 = cleanUrl(artworkUrl()) || '';
        if (alphaTruth[aKey101] === false) {
          var u101 = new URL(raw); u101.searchParams.delete('trim'); raw = u101.toString();
        } else if (alphaTruth[aKey101] === undefined) { npPixelHasAlpha(aKey101, function () {}); }
      }
    } catch (e101) {}
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        /* C122 (2026-09-01, Justin: "why do the shapes and the preview in the
           shapes look off?"): when C107 dropped imgix trim for opaque
           leather/faux art, the SHAPE TILES started stamping the UN-TRIMMED
           frame — the art sat tiny inside each shape, sized by its blank
           margins. Tiles now tight-crop CLIENT-SIDE to the content's bounding
           box (padding kept): the same tight frame trim used to give, with
           none of trim=color's edge-amputation risk. Tiles only — the main
           preview's fit was signed off as-is. The crop returns a canvas
           carrying naturalWidth/naturalHeight expandos so every downstream
           read (fit math, etchArtCanvas, drawImage) works unchanged. */
        /* C222 (Justin 2026-09-15, "why is cropped rectangle keeping the logo so small?"): a CROPPED shape's face follows the
           artwork's CONTENT aspect (measureAlphaBounds ignores blank margins), but the image drawn into it was the whole frame —
           imgix trim is dropped for opaque leather art (C101) and declines padded PNGs — so a wide wordmark on a square canvas
           was fitted by the frame's HEIGHT and sat tiny in a face cut to the wordmark's width. Cropped shapes now draw the same
           tight content crop the tiles use (any type; returns null when the frame is already tight). Fixed shapes unchanged. */
        if ((isLeather() && ov && ov.tile) || (npSelCropped() && !(ov && ov.src))) {
          var t122 = npTightArt122(img);
          if (t122) img = t122;
        }
        /* C46 (2026-08-31, Justin: "if I hit cropped rectangle it changes all
           rectangles to cropped and ovals ... they all need to be independent
           shapes and not get affected when you click another"). This line sized
           EVERY stamp from st.w/st.h — the CURRENT selection — so one click
           re-aspected the whole family's tiles (C43 fixed only the span frames,
           not the image stamped inside them). A tile stamp now sizes from its
           OWN entry: fixed geoms at their fixed dims, Cropped from st.artRatio
           via shapeDims' flex path. The main preview keeps the old line. */
        var d = (ov && ov.tile)
          ? shapeDims(g, 1, !!ov.crop)
          : ((PTYPE.previewDims && st.w && st.h) ? [st.w * 100, st.h * 100] : shapeDims(g, 1, npSelCropped()));
        var C = Csize || 1200;
        var k = (C * 0.94) / Math.max(d[0], d[1]);
        var W = Math.round(d[0] * k), H = Math.round(d[1] * k);
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var x = cv.getContext('2d');
        var pick = function (c) { return c && c.hex && c.label !== 'Let Ninja Choose' && c.label !== 'Not Sure' ? c.hex : null; };
        var thNoneC = !!(st.thread && (st.thread.none || isFollowVal(st.thread) || /^none$/i.test(st.thread.label || '')));
        var followBgC = !(ov && ov.bg) && isFollowVal(st.bg);
        var threadHex = pick(st.thread), bgHex = (ov && ov.bg) || pick(st.bg) || (followBgC ? null : npDefaultBgHex());
        /* a BARE-ART type (tackle twill letters) has no patch base at all: the
           cut pieces ARE the artwork, so nothing may be filled behind them */
        if (PTYPE.bareArt && !(ov && ov.bg)) bgHex = null;
        var isMerrow = st.border && /merrow/i.test(st.border.label || '');
        var ringHex = (ov && ov.ring) || threadHex || '#9CA3AF'; /* no color picked yet: neutral grey ring so the border STYLE still previews (merrow texture included) */
        var noBorderC = !!PTYPE.borderless || !!(st.border && /no border/i.test(st.border.label || '')); /* C162: borderless types (woven labels) never get the neutral preview ring */
        var ring = (ov && ov.thin) ? Math.round(C * 0.02) : ((thNoneC || noBorderC || isLeather() || (!st.thread && !st.border)) ? 0 : Math.round(C * (isMerrow ? 0.024 : 0.016)));
        /* BARE ART (tackle twill): there is no patch base and no patch border —
           the cut pieces ARE the artwork. Its outline colour is the second twill
           layer, drawn per letter inside the text canvas, so the composer must
           not also ring the whole silhouette (that read as a custom-shape base
           padded around the lettering). */
        if (PTYPE.bareArt) ring = 0;
        /* molded flex/PVC: the border is part of the mold, so the 1-10
           thickness choice scales the ring. Flex: 3 = standard (0.55+0.15x).
           PVC (lbZeroMax2): 5 = standard, 1 = barely-there, 10 = double. */
        if (ring > 0 && PTYPE.borderThick && !(ov && ov.thin)) {
          ring = Math.max(PTYPE.lbZeroMax2 ? 1 : 2, Math.round(ring * lbRingFactor()));
        }
        /* C56 (2026-08-31, Justin: "on cropped rectangle / oval when you add
           the border it gets cut off"). The border stroke is centered on the
           shape path (lineWidth = ring*2) while the path sits only `ring` from
           the canvas edge — the band's outer edge landed EXACTLY on the
           boundary and rendered flush/truncated, worst on Cropped shapes whose
           canvas hugs the artwork bounds. Pad the canvas by a small margin and
           push the path in by the same amount (below): the patch keeps its
           exact size, the whole band stays visible and centered. */
        var npPad56 = ring > 0 ? Math.max(3, Math.round(ring * 0.2)) : 0;
        if (npPad56) { W += npPad56 * 2; H += npPad56 * 2; cv.width = W; cv.height = H; }
        /* surface texture rides ON the background color, UNDER the artwork.
           Skipped on the little shape tiles, where ribbing only reads as mush. */
        var texKind = (!(ov && ov.thin) && PTYPE.texture && st.texture) ? st.texture.label : null;
        /* METALLIC FLEX free form is molded from ONE solid colour: the artwork
           takes that colour as two tones, like the single-material finishes.
           Every other free-form material (silicone, full-color flex) molds in
           the artwork's own colors — never flatten those. */
        var ffTone = null;
        if (isFreeFormShape() && bgHex && /^metallic-flex/.test(TYPE_KEY)) {
          var _h = bgHex.replace('#', '');
          var _r = parseInt(_h.substr(0, 2), 16), _g2 = parseInt(_h.substr(2, 2), 16), _b = parseInt(_h.substr(4, 2), 16);
          var _hex = function (r2, g3, b2) {
            return '#' + [r2, g3, b2].map(function (v) { return ('0' + Math.max(0, Math.min(255, Math.round(v))).toString(16)).slice(-2); }).join('');
          };
          ffTone = { dark: _hex(_r * 0.62, _g2 * 0.62, _b * 0.62), light: _hex(_r + (255 - _r) * 0.30, _g2 + (255 - _g2) * 0.30, _b + (255 - _b) * 0.30) };
        }
        /* BARE ART never gets the custom-shape treatment: tackle twill letters
           are individual cut pieces, so there is no silhouette base to dilate
           and no contour to run a border along. The second twill layer is a
           BORDER on each letter, drawn in the text canvas — the bubble below
           was what padded it out into one blob. */
        if (g === 'custom' && !PTYPE.bareArt) {
          /* CUSTOM SHAPE IS STILL A SHAPE: the base is the artwork silhouette
             DILATED into one smooth continuous contour (a bubble hugging the
             whole design), filled with the background color — the border runs
             along that OUTER contour, never around individual letters */
          var padC = Math.round(C * 0.1);
          var sC = Math.min((C - padC * 2) / img.naturalWidth, (C - padC * 2) / img.naturalHeight);
          var awC = Math.max(1, Math.round(img.naturalWidth * sC)), ahC = Math.max(1, Math.round(img.naturalHeight * sC));
          var WC = awC + padC * 2, HC = ahC + padC * 2;
          var cvC = document.createElement('canvas'); cvC.width = WC; cvC.height = HC;
          var xC = cvC.getContext('2d');
          var freeF = ov ? !!ov.freeform : isFreeFormShape();
          var ringC = freeF ? 0 : ((ov && ov.thin) ? Math.round(C * 0.012) : ((thNoneC || noBorderC || isLeather() || (!st.thread && !st.border)) ? 0 : Math.round(C * (isMerrow ? 0.016 : 0.012))));
          if (ringC > 0 && PTYPE.borderThick && !(ov && ov.thin)) ringC = Math.max(PTYPE.lbZeroMax2 ? 1 : 2, Math.round(ringC * lbRingFactor()));
          /* LEATHER / FAUX LEATHER custom shape: the hide is cut ON the
             artwork's own outer contour — no dilated margin ("border") around
             it. Interior detail stays leather (hole-filled below) with the
             etch showing the art's indentations. */
          var leatherCutC = isLeather();
          /* background "None" acts EXACTLY like Match My Artwork: no dilated
             base bubble, and any border runs along the ART's own contour.
             The neutral grey style-preview ring stays off until a REAL
             thread color is picked (Justin 2026-08-21). */
          var noneBgC = !!(st.bg && /^none$/i.test(String(st.bg.label || '')));
          if (noneBgC && !((ov && ov.thin)) && !(st.thread && st.thread.hex)) ringC = 0;
          var baseR = (freeF || followBgC || leatherCutC || noneBgC) ? 0 : Math.round(C * 0.05);
          /* C143: un-picked background on Design's Shape → preview the plate
             (#f2f2f2 so white art still reads) with the hot-cut edge in the
             neutral ring, exactly the geometry a picked colour will fill */
          var plateDS = !freeF && !leatherCutC && !noneBgC && !followBgC && !((ov && ov.bg) || (st.bg && (st.bg.hex || st.bg.follow)));
          if (plateDS) {
            bgHex = '#f2f2f2';
            if (ringC === 0 && !(ov && ov.thin) && !noBorderC && !thNoneC) ringC = Math.round(C * 0.012);
          }
          /* C472 (Justin 2026-10-05, potato + crossed tools proof vs production: "registration issues with the mass
             production of sublimation — border needs to be set a safe distance to avoid accidentally overlapping with
             design"): Full Color is printed first and the border stitched on after, and in production the two never
             register exactly, so a border drawn ON the art's edge (Match My Artwork / None / self-enclosed art cut on its
             own contour) or a thin bubble on a small patch lands on the design. A sublimated custom shape with a border
             keeps at least NP_SUBLI_SAFE_IN of patch between the design and the border at the patch's real size; with no
             background colour picked, that margin is the white sublimation fabric. */
          var subliGapC = 0;
          if (ringC > 0 && !freeF && TYPE_FAMILY === 'fullcolor-2-0' && !(ov && (ov.tile || ov.thin)) && st.w > NP_SUBLI_SAFE_IN * 4) {
            var ppiS = (awC + ringC * 2) / (st.w - NP_SUBLI_SAFE_IN * 2);
            if (st.h > NP_SUBLI_SAFE_IN * 4) ppiS = Math.max(ppiS, (ahC + ringC * 2) / (st.h - NP_SUBLI_SAFE_IN * 2));
            subliGapC = Math.ceil(NP_SUBLI_SAFE_IN * ppiS);
            baseR = Math.max(baseR, subliGapC);
            if (baseR + ringC + 4 > padC) {
              padC = baseR + ringC + 4;
              WC = awC + padC * 2; HC = ahC + padC * 2;
              cvC.width = WC; cvC.height = HC;
            }
          }
          var sil = document.createElement('canvas'); sil.width = awC; sil.height = ahC;
          var sx2 = sil.getContext('2d');
          sx2.drawImage(img, 0, 0, awC, ahC);
          sx2.globalCompositeOperation = 'source-in';
          sx2.fillStyle = '#000';
          sx2.fillRect(0, 0, awC, ahC);
          /* HARD-EDGE the silhouette (Justin 2026-08-24): AI uploads carry
             faint (alpha 1-60) junk pixels and soft anti-aliased edges that
             are invisible on the page — but the dilation below stamps this
             silhouette ~100 times, accumulating that residue toward full
             opacity, and the Match-My-Artwork bg fill then paints it (the
             pixelated halo). Binarize: alpha < 64 is not part of the patch. */
          (function () {
            var sdI = sx2.getImageData(0, 0, awC, ahC), sdD = sdI.data;
            for (var oS = 3; oS < sdD.length; oS += 4) sdD[oS] = sdD[oS] < 64 ? 0 : 255;
            sx2.putImageData(sdI, 0, 0);
          })();
          /* SELF-ENCLOSED ART CUTS ON ITS OWN EDGE (Justin 2026-08-24, the
             "AIR BOSS" framed logo): when the artwork already draws ONE
             connected outline, the patch IS that contour — interior holes
             fill with the background and no dilated bubble pads the edge.
             The bubble stays for disconnected art, which needs bridging. */
          var contourCut = false;
          if (!ov) st.__contourHoles = 0; /* C426 */
          /* C128 (2026-09-02, Justin: "this should follow the same rules for
             custom shape for emb, full color etc" — order 2108432, faux
             leather, "HUMAN" brush lettering): leather was EXEMPT from this
             connectivity test and always cut on the raw contour, so five
             floating letters became five floating leather pieces — nothing to
             produce. Leather now takes the same test: ONE connected outline
             still cuts on its own edge (the lane's spec), disconnected art
             gets the bridging bubble below, in hide colour, art etched on it. */
          if (!freeF) (function () {
            var sdI2 = sx2.getImageData(0, 0, awC, ahC), dd2 = sdI2.data;
            var ext2 = new Uint8Array(awC * ahC), stk2 = [];
            var push2 = function (px, py) {
              if (px < 0 || py < 0 || px >= awC || py >= ahC) return;
              var o2 = py * awC + px;
              if (ext2[o2] || dd2[o2 * 4 + 3] > 127) return;
              ext2[o2] = 1; stk2.push(o2);
            };
            for (var bi = 0; bi < awC; bi++) { push2(bi, 0); push2(bi, ahC - 1); }
            for (var bj = 0; bj < ahC; bj++) { push2(0, bj); push2(awC - 1, bj); }
            while (stk2.length) {
              var oP = stk2.pop(), pxP = oP % awC, pyP = (oP / awC) | 0;
              push2(pxP + 1, pyP); push2(pxP - 1, pyP); push2(pxP, pyP + 1); push2(pxP, pyP - 1);
            }
            var filled = new Uint8Array(awC * ahC), fillN = 0, seed = -1;
            for (var oF = 0; oF < awC * ahC; oF++) if (!ext2[oF]) { filled[oF] = 1; fillN++; if (seed < 0) seed = oF; }
            if (!fillN) return;
            var comp = new Uint8Array(awC * ahC), compN = 0, stk3 = [seed];
            comp[seed] = 1;
            while (stk3.length) {
              var oC = stk3.pop(); compN++;
              var pxC = oC % awC, pyC = (oC / awC) | 0;
              if (pxC + 1 < awC && !comp[oC + 1] && filled[oC + 1]) { comp[oC + 1] = 1; stk3.push(oC + 1); }
              if (pxC > 0 && !comp[oC - 1] && filled[oC - 1]) { comp[oC - 1] = 1; stk3.push(oC - 1); }
              if (pyC + 1 < ahC && !comp[oC + awC] && filled[oC + awC]) { comp[oC + awC] = 1; stk3.push(oC + awC); }
              if (pyC > 0 && !comp[oC - awC] && filled[oC - awC]) { comp[oC - awC] = 1; stk3.push(oC - awC); }
            }
            if (compN / fillN < 0.97) return; /* disconnected pieces keep the bubble */
            contourCut = true;
            /* C426 (Justin 2026-09-28, customer order of single letters: "the holes in the letters kept filling in ... A, B,
               D, P, R, Q" — with and without a background, and a border filled them too): an enclosed EMPTY region that
               touches only ONE piece of the art is a letter counter / ring opening and is cut out of the patch; the
               border then runs around it as well. A region that also touches other pieces (the AIR BOSS frame with its
               wordmark inside) still fills — that art needs the backing — and so does anything under 1.5% of the
               design's box (pinholes, distress, counters too small to cut). */
            (function () {
              if (leatherCutC) return; /* C545 (Justin 2026-11-03, World Emblem sheet of a faux leather bear with a white half-face: "sometimes we are adding white to leather / faux or color that can never happen, simply laser etched every time"): leather is never cut — an enclosed opening stays hide and is etched, so no counter is cut here and none is re-cut on the AI render */
              var N4 = awC * ahC, olab = new Int32Array(N4), nL = 0, stO = [];
              var oMinX = awC, oMinY = ahC, oMaxX = -1, oMaxY = -1;
              for (var o4 = 0; o4 < N4; o4++) {
                if (olab[o4] || dd2[o4 * 4 + 3] <= 127) continue;
                nL++; olab[o4] = nL; stO.push(o4);
                while (stO.length) {
                  var q4 = stO.pop(), qx4 = q4 % awC, qy4 = (q4 / awC) | 0;
                  if (qx4 < oMinX) oMinX = qx4; if (qx4 > oMaxX) oMaxX = qx4; if (qy4 < oMinY) oMinY = qy4; if (qy4 > oMaxY) oMaxY = qy4;
                  if (qx4 + 1 < awC && !olab[q4 + 1] && dd2[(q4 + 1) * 4 + 3] > 127) { olab[q4 + 1] = nL; stO.push(q4 + 1); }
                  if (qx4 > 0 && !olab[q4 - 1] && dd2[(q4 - 1) * 4 + 3] > 127) { olab[q4 - 1] = nL; stO.push(q4 - 1); }
                  if (qy4 + 1 < ahC && !olab[q4 + awC] && dd2[(q4 + awC) * 4 + 3] > 127) { olab[q4 + awC] = nL; stO.push(q4 + awC); }
                  if (qy4 > 0 && !olab[q4 - awC] && dd2[(q4 - awC) * 4 + 3] > 127) { olab[q4 - awC] = nL; stO.push(q4 - awC); }
                }
              }
              if (oMaxX < 0) return;
              var minHole = (oMaxX - oMinX + 1) * (oMaxY - oMinY + 1) * 0.015, hseen = new Uint8Array(N4), cutN = 0;
              for (var h4 = 0; h4 < N4; h4++) {
                if (hseen[h4] || ext2[h4] || dd2[h4 * 4 + 3] > 127) continue;
                var pixH = [], stH = [h4], touch = 0, multi = false;
                hseen[h4] = 1;
                while (stH.length) {
                  var p4 = stH.pop(); pixH.push(p4);
                  var px4 = p4 % awC, nb4 = [px4 + 1 < awC ? p4 + 1 : -1, px4 > 0 ? p4 - 1 : -1, p4 + awC < N4 ? p4 + awC : -1, p4 - awC];
                  for (var k4 = 0; k4 < 4; k4++) {
                    var n4 = nb4[k4]; if (n4 < 0) continue;
                    if (dd2[n4 * 4 + 3] > 127) { if (!touch) touch = olab[n4]; else if (olab[n4] !== touch) multi = true; continue; }
                    if (!hseen[n4] && !ext2[n4]) { hseen[n4] = 1; stH.push(n4); }
                  }
                }
                if (multi || pixH.length < minHole) continue;
                for (var c4 = 0; c4 < pixH.length; c4++) filled[pixH[c4]] = 0;
                cutN++;
              }
              if (!ov) st.__contourHoles = cutN;
            })();
            for (var oW = 0; oW < awC * ahC; oW++) dd2[oW * 4 + 3] = filled[oW] ? 255 : 0;
            sx2.putImageData(sdI2, 0, 0);
          })();
          /* C128: disconnected art on leather gets the same bridging margin
             emb/full-color use, so the dilation below produces ONE piece of
             hide; the flag lets the sensei prompt describe the bridged cut. */
          var leatherBridgeC = leatherCutC && !contourCut && !freeF;
          if (leatherBridgeC) baseR = Math.round(C * 0.05);
          if (isLeather() && !(ov && ov.tile)) st.__leatherBridged = leatherBridgeC;
          var mask = document.createElement('canvas'); mask.width = WC; mask.height = HC;
          var mx2 = mask.getContext('2d');
          mx2.drawImage(sil, padC, padC);
          if (!contourCut) npDiskDilate(mx2, WC, HC, baseR); /* C463: a true dilation, not 96 stamped copies */
          else if (subliGapC) npDiskDilate(mx2, WC, HC, subliGapC); /* C472: art cut on its own contour still clears the border */
          if (!freeF && !contourCut) npOnePiece549(mx2, WC, HC, C); /* C549: one piece, never two (Free Form is pieces by design) */
          if (ringC > 0) {
            var ringLayer = document.createElement('canvas'); ringLayer.width = WC; ringLayer.height = HC;
            var rx2 = ringLayer.getContext('2d');
            rx2.drawImage(mask, 0, 0);
            npDiskDilate(rx2, WC, HC, ringC); /* C463: the ring is the mask dilated for real, not 28 stamps */
            rx2.globalCompositeOperation = 'source-in';
            rx2.fillStyle = ringHex;
            rx2.fillRect(0, 0, WC, HC);
            xC.drawImage(ringLayer, 0, 0);
          }
          if (leatherCutC) {
            /* fill INTERIOR holes of the silhouette so knockout detail sits on
               leather (etched), while the outer contour stays the exact cut:
               flood the exterior from the canvas border, then everything not
               exterior becomes mask */
            var midL = mx2.getImageData(0, 0, WC, HC), mdL = midL.data;
            var extL = new Uint8Array(WC * HC);
            var stkL = [];
            var pushL = function (px3, py3) {
              if (px3 < 0 || py3 < 0 || px3 >= WC || py3 >= HC) return;
              var o3 = py3 * WC + px3;
              if (extL[o3] || mdL[o3 * 4 + 3] > 40) return;
              extL[o3] = 1; stkL.push(o3);
            };
            for (var bi3 = 0; bi3 < WC; bi3++) { pushL(bi3, 0); pushL(bi3, HC - 1); }
            for (var bj3 = 0; bj3 < HC; bj3++) { pushL(0, bj3); pushL(WC - 1, bj3); }
            while (stkL.length) {
              var oP = stkL.pop();
              var pxP = oP % WC, pyP = (oP / WC) | 0;
              pushL(pxP + 1, pyP); pushL(pxP - 1, pyP); pushL(pxP, pyP + 1); pushL(pxP, pyP - 1);
            }
            for (var oF = 0; oF < WC * HC; oF++) { if (!extL[oF]) mdL[oF * 4 + 3] = 255; }
            mx2.putImageData(midL, 0, 0);
          }
          /* NO base bubble until the customer actually PICKS a background —
             the default white read as an uninvited sticker border around
             bg-removed art (Justin 2026-08-21). Leather always shows its
             hide. */
          var bgPickedC2 = !noneBgC && !!((ov && ov.bg) || (st.bg && (st.bg.hex || st.bg.follow)));
          var baseHexC = (bgHex && !freeF && (bgPickedC2 || leatherCutC || plateDS)) ? bgHex : null;
          /* C472: no background colour = the white sublimation fabric shows in the margin; C472b: Match My Artwork extends the
             artwork's own background colour (when it has one) into the margin instead */
          var subliEdgeC = (!baseHexC && subliGapC && followBgC) ? npArtEdgeHex(img) : null;
          if (!baseHexC && subliGapC) baseHexC = subliEdgeC || '#ffffff';
          if (!ov || ov.refOnly) st.__subliGap = subliGapC ? { white: baseHexC === '#ffffff' && !subliEdgeC && bgHex !== baseHexC, edge: subliEdgeC } : null;
          if (baseHexC) {
            var baseLayer = document.createElement('canvas'); baseLayer.width = WC; baseLayer.height = HC;
            var bx2 = baseLayer.getContext('2d');
            bx2.drawImage(mask, 0, 0);
            bx2.globalCompositeOperation = 'source-in';
            bx2.fillStyle = baseHexC;
            bx2.fillRect(0, 0, WC, HC);
            var texPC = texturePattern(bx2, baseHexC, texKind, C);
            if (texPC) { bx2.fillStyle = texPC; bx2.fillRect(0, 0, WC, HC); }
            xC.drawImage(baseLayer, 0, 0);
          }
          if (leatherCutC && st.etchInvert) {
            /* INVERTED etch on a custom cut: burn the whole cut face */
            var invL = document.createElement('canvas'); invL.width = WC; invL.height = HC;
            var ivx = invL.getContext('2d');
            ivx.drawImage(mask, 0, 0);
            ivx.globalCompositeOperation = 'source-in';
            ivx.fillStyle = leatherEtch().hex;
            ivx.fillRect(0, 0, WC, HC);
            xC.drawImage(invL, 0, 0);
          }
          /* C123 (Justin 2026-09-01: "why are they not nice and clean in
             here? maybe just keep them the actual image like you do with
             emb") — the SHAPE TILES stamp the RAW artwork, exactly like
             embroidered's tiles: thresholding an etch at ~140px tile scale
             reads as jagged mush. The etch stays on the MAIN preview only. */
          if (isLeather() && !(ov && ov.tile)) xC.drawImage(etchArtCanvas(img, awC, ahC, st.etchInvert ? (bgHex || '#DCA05F') : null), padC, padC, awC, ahC);
          else if (ffTone || PTYPE.monoTone) xC.drawImage(monoArtCanvas(img, awC, ahC, ffTone || PTYPE.monoTone), padC, padC, awC, ahC);
          else xC.drawImage(img, padC, padC, awC, ahC);
          if (leatherCutC && st.border && /etched/i.test(st.border.label || '')) {
            /* etched border on a CUSTOM cut (Justin 2026-08-21): a burn band
               that FOLLOWS the contour, inset from the cut edge, thickness
               1-10 — erosion by 28-direction intersection (the inverse of
               the dilation used for the ring above) */
            var lbTC = Math.max(1, Math.min(10, st.lbThick || 3));
            var lbWC = Math.max(2, Math.min(20, lbTC * 2));
            var lbInC = Math.round(Math.min(WC, HC) * 0.045) + 2;
            var erodeC = function (rE) {
              var e = document.createElement('canvas'); e.width = WC; e.height = HC;
              var ex2 = e.getContext('2d');
              ex2.drawImage(mask, 0, 0);
              ex2.globalCompositeOperation = 'destination-in';
              for (var aK = 0; aK < 28; aK++) {
                var angK = aK / 28 * Math.PI * 2;
                ex2.drawImage(mask, Math.cos(angK) * rE, Math.sin(angK) * rE);
              }
              return e;
            };
            var bandC = erodeC(lbInC);
            var bx3 = bandC.getContext('2d');
            bx3.globalCompositeOperation = 'destination-out';
            bx3.drawImage(erodeC(lbInC + lbWC), 0, 0);
            bx3.globalCompositeOperation = 'source-in';
            bx3.fillStyle = leatherEtch().hex;
            bx3.fillRect(0, 0, WC, HC);
            xC.globalAlpha = 0.92;
            xC.drawImage(bandC, 0, 0);
            xC.globalAlpha = 1;
          }
          if (npSewOn() && !freeF && !(ov && (ov.tile || ov.thin))) {
            /* C538: the sewing channel follows the cut — mid-rim, or just inside the edge on a thin / no rim */
            var gwC = npSewWidth(C), inRimC = npSewInRim(ringC);
            var sewB = npSewBand(mask, WC, HC, inRimC ? ringC / 2 : -gwC * 3, gwC);
            var sbx = sewB.getContext('2d');
            sbx.globalCompositeOperation = 'source-in';
            sbx.fillStyle = npSewInk(inRimC ? ringHex : (baseHexC || bgHex));
            sbx.fillRect(0, 0, WC, HC);
            npSewShadow(xC, gwC, true);
            xC.drawImage(sewB, 0, 0);
            npSewShadow(xC, gwC, false);
          }
          cb(cvC);
          return;
        }
        var polyPts = null;
        if (SHAPE_CLIPS[g]) {
          polyPts = [];
          (SHAPE_CLIPS[g].match(/([\d.]+)%\s+([\d.]+)%/g) || []).forEach(function (p) {
            var m = p.match(/([\d.]+)%\s+([\d.]+)%/);
            polyPts.push([parseFloat(m[1]) / 100, parseFloat(m[2]) / 100]);
          });
        }
        function shapePath(x0, y0, w2, h2) {
          x.beginPath();
          if (g === 'circle' || g === 'oval' || g === 'oval-h') {
            x.ellipse(x0 + w2 / 2, y0 + h2 / 2, w2 / 2, h2 / 2, 0, 0, Math.PI * 2);
          } else if (polyPts) {
            polyPts.forEach(function (p, i2) {
              var px = x0 + p[0] * w2, py = y0 + p[1] * h2;
              if (i2 === 0) x.moveTo(px, py); else x.lineTo(px, py);
            });
          } else {
            var r = (((ov && ov.corners) || (ov ? 'rounded' : st.corners)) === 'square') ? 0 : Math.min(w2, h2) * 0.1;
            if (r > 0 && x.roundRect) x.roundRect(x0, y0, w2, h2, r);
            else x.rect(x0, y0, w2, h2);
          }
          x.closePath();
        }
        /* the border is a STROKE along the shape path — uniform width on every
           contour (an inset-scaled copy pinches at hearts' clefts and tips) */
        var inset = Math.max(ring + npPad56, 2); /* C56: outer band edge clears the canvas by npPad56 */
        if (bgHex) {
          shapePath(inset, inset, W - inset * 2, H - inset * 2);
          x.fillStyle = bgHex; x.fill();
          var texP = texturePattern(x, bgHex, texKind, C);
          if (texP) {
            x.save();
            shapePath(inset, inset, W - inset * 2, H - inset * 2);
            x.clip();
            x.fillStyle = texP;
            x.fillRect(0, 0, W, H);
            x.restore();
          }
        }
        x.save();
        shapePath(inset, inset, W - inset * 2, H - inset * 2);
        x.clip();
        /* Match My Artwork must NOT change the artwork fill — the full-face
           bump made the preview visibly jump/zoom on the MMA click. The
           customer owns fill via the Artwork fill slider alone. */
        /* C538b (Justin 2026-11-03, PVC border colour None: "it seems to zoom out the artwork can you keep the artwork still
           cushioned and center"): on rubber PVC the face is still the shape in its background colour with no border, so None
           keeps the normal cushioned, centred fit. Match My Artwork (the art IS the face) still fills. */
        var noneCushC = !!(PTYPE.noneCushion && thNoneC && !isFollowVal(st.thread));
        var safe = (thNoneC && !noneCushC) ? 1 : (SHAPE_SAFE[g] || 0.68);
        if (PTYPE.textFill) safe = PTYPE.textFill; /* names fill the patch more generously */
        /* long names are WIDTH-bound: give them their own, wider cap so a
           'Christopher' runs close to the merrow while the height keeps its
           breathing room above and below the lettering */
        var safeW = PTYPE.textFillW || safe;
        /* MATCH MY ARTWORK on a standard shape (B56): the artwork IS the
           patch face, so it fills the shape completely — the shape clip
           (incl. ROUNDED corners) then genuinely cuts its edges. At the old
           68% fit the art's own sharp corners sat inside the rounded clip
           untouched — Justin's "MMA overrides rounded corners" bug. */
        if (followBgC) { safe = 1; safeW = 1; }
        var zmV = (ov && ov.zoom) || st.artZoom;
        var maxW = W * safeW * zmV, maxH = H * safe * zmV;
        /* C156 (2026-09-09, Justin: "on the crop display add a little padding so it matches how it looks when you
           actually click it" → "still too tight" → "some breathing room"). The fit above is a fraction of the CANVAS;
           the visible face is the canvas minus the band (inset + ring). At a 200px stamp the thin ring plus the fixed
           3px clearance eat ~12% of the width (vs ~6% at the 1200px preview), and a CROPPED plate hugs the art's own
           aspect, so the Cropped tiles' art kissed the ring. Cropped stamps now fit the art into their FACE at 74%
           (13% clear per side). Scope per Justin = the Cropped tiles only; fixed shapes keep their fit. Skipped when
           the preview itself is full-bleed (safe = 1: thread Match My Artwork / None) so tile and preview still agree
           (review 2026-09-09). */
        if (ov && ov.tile && ov.crop && safe < 1) {
          var faceW156 = Math.max(10, W - (inset + ring) * 2), faceH156 = Math.max(10, H - (inset + ring) * 2);
          maxW = faceW156 * 0.74 * zmV; maxH = faceH156 * 0.74 * zmV;
        }
        var s = Math.min(maxW / img.naturalWidth, maxH / img.naturalHeight);
        /* MMA (B57): COVER with a 4% bleed — the art runs past the clip so
           the shape's rounded corner is the ONLY curve; contain-fit left the
           art's own baked-in corners fighting the clip (chamfered mess) */
        if (followBgC) s = Math.max(maxW / img.naturalWidth, maxH / img.naturalHeight) * 1.04;
        /* C58 (2026-08-31, Justin: "its still cutting off the design when I use
           cropped rectangle"). The art's fit is computed against the CANVAS, but
           the usable face is the shape MINUS the border band. On fixed shapes
           the gap never binds; on Cropped the face hugs the artwork's own
           aspect exactly, so the art ran under the band and its edges vanished.
           Clamp the art into the band's inner box. MMA cover mode (followBgC)
           bleeds on purpose and stays exempt. */
        if (ring > 0 && !followBgC) {
          var innerW58 = W - (inset + ring) * 2 - 4, innerH58 = H - (inset + ring) * 2 - 4;
          if (innerW58 > 10 && innerH58 > 10) s = Math.min(s, innerW58 / img.naturalWidth, innerH58 / img.naturalHeight);
        }
        /* C515: name patches size by CAP HEIGHT — the capitals stand textCapFill of the patch height (still inside the
           width cap and the band clamp above, so a long name stays width-bound) */
        var cap515 = (PTYPE.textCapFill && capBand515 && !followBgC) ? (capBand515.base - capBand515.top) : 0;
        if (cap515 > 0) s = Math.min(s, (H * PTYPE.textCapFill * zmV) / cap515);
        var aw = img.naturalWidth * s, ah = img.naturalHeight * s;
        var cyF = ({ shield: 0.44, heart: 0.45 })[g] || 0.5;
        /* INVERTED etch on a standard shape: the PATCH FACE never changes —
           only the DESIGN flips (fills burn, detail reads as bare hide) */
        /* C123: tiles stamp RAW art (see the custom-branch note) — etch only
           on the real preview */
        /* C151 artwork pan: offset the art by the customer's drag (fractions of the box), clamped so the art's edge
           never leaves the face — whichever is larger, art or face, may travel by half the difference. Tiles never pan. */
        var panX = 0, panY = 0;
        if (!(ov && ov.tile) && (st.artDx || st.artDy)) {
          var faceW151 = Math.max(10, W - (inset + ring) * 2), faceH151 = Math.max(10, H - (inset + ring) * 2);
          var mxA = Math.abs(aw - faceW151) / 2 / W, myA = Math.abs(ah - faceH151) / 2 / H;
          var cdx = Math.max(-mxA, Math.min(mxA, st.artDx || 0)), cdy = Math.max(-myA, Math.min(myA, st.artDy || 0));
          if (!ov) { st.artDx = cdx; st.artDy = cdy; }
          panX = cdx * W; panY = cdy * H;
        }
        var pX151 = (W - aw) / 2 + panX, pY151 = H * cyF - ah / 2 + panY;
        if (cap515 > 0) pY151 = H * cyF - ((capBand515.top + capBand515.base) / 2) * s + panY; /* C515: centre the capitals, not the ink box */
        if (isLeather() && !(ov && ov.tile)) x.drawImage(etchArtCanvas(img, aw, ah, null, st.etchInvert), pX151, pY151, aw, ah);
        else if (ffTone || PTYPE.monoTone) x.drawImage(monoArtCanvas(img, aw, ah, ffTone || PTYPE.monoTone), pX151, pY151, aw, ah);
        else x.drawImage(img, pX151, pY151, aw, ah);
        x.restore();
        if (isLeather() && st.border && /etched/i.test(st.border.label || '')) {
          /* laser-etched border line, inset from the edge (thickness 1-10) */
          var lbT = Math.max(1, Math.min(10, st.lbThick || 3));
          var lbIn = inset + Math.round(Math.min(W, H) * 0.055);
          shapePath(lbIn, lbIn, W - lbIn * 2, H - lbIn * 2);
          x.strokeStyle = leatherEtch().hex;
          x.globalAlpha = 0.92;
          x.lineWidth = Math.max(2, Math.min(20, lbT * 2));
          x.lineJoin = 'round';
          x.stroke();
          x.globalAlpha = 1;
        }
        if (ring > 0 && ringHex) {
          shapePath(inset, inset, W - inset * 2, H - inset * 2);
          /* The diagonal merrow hatching is a shorthand for the CUSTOMER'S view.
             It must never reach Patch Sensei: the renderer treats the composed
             image as the finished layout, so it reproduced those stripes as a
             literal striped metal band. It already receives border_style:
             Merrow as a mandatory spec and its style profile knows how to build
             a merrow edge — so the reference gets a solid ring in the thread
             colour and the renderer supplies the real texture. */
          x.strokeStyle = (isMerrow && !(ov && ov.refOnly)) ? merrowPattern(x, ringHex, ring) : ringHex;
          x.lineWidth = ring * 2;
          x.lineJoin = (st.corners === 'square' && (g === 'square' || g === 'rectangle' || g === 'rectangle-v')) ? 'miter' : 'round'; /* square corners keep sharp outer ring corners (2026-09-08) */ /* no round caps — they dot the path start */
          x.stroke();
        }
        if (npSewOn() && !(ov && (ov.tile || ov.thin))) {
          /* C538: the sewing channel on a fixed shape — the ring's own centre line (mid-rim), or just inside the face on a
             thin / no rim; one fixed width whatever the thickness */
          var gwF = npSewWidth(C), inRimF = npSewInRim(ring);
          var sewIn = inRimF ? inset : Math.max(inset, 2) + ring + Math.round(gwF * 3);
          shapePath(sewIn, sewIn, W - sewIn * 2, H - sewIn * 2);
          x.strokeStyle = npSewInk(inRimF ? ringHex : bgHex);
          x.lineWidth = gwF;
          x.lineJoin = 'round';
          npSewShadow(x, gwF, true);
          x.stroke();
          npSewShadow(x, gwF, false);
        }
        cb(cv);
      } catch (e) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    /* C105 (2026-09-01): the trim-skip for opaque art (C101) was best-effort -
       cold cache meant the FIRST compose after upload still rendered the
       amputated bitmap and only the next re-compose corrected it. The first
       render now WAITS for the opacity answer. */
    var start105 = function () { img.src = raw; };
    if ((PTYPE.name === 'Leather' || PTYPE.name === 'Faux Leather') && !/^data:|^blob:/.test(raw) && /[?&]trim=/.test(raw)) {
      var aK105 = cleanUrl(artworkUrl()) || '';
      npPixelHasAlpha(aK105, function () {
        if (alphaTruth[aK105] === false) { try { var u5 = new URL(raw); u5.searchParams.delete('trim'); raw = u5.toString(); } catch (e5) {} }
        start105();
      });
    } else start105();
  }
  function countArtPieces(cv) {
    /* C140 (Justin 2026-09-04, NINJA TRANSFERS free-form silicone rendered on a
       white die-cut plate: "free form each letter is individual and applied
       with a transfer sheet"): count the separate opaque pieces in the
       composite so the prompt can say "exactly N individual pieces". Downscaled,
       8-connected, specks below 0.2% of the ink ignored. */
    var sc = Math.min(1, 300 / Math.max(cv.width, cv.height));
    var w = Math.max(2, Math.round(cv.width * sc)), h = Math.max(2, Math.round(cv.height * sc));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d'); x.drawImage(cv, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h).data, op = new Uint8Array(w * h), ink = 0, i;
    for (i = 0; i < w * h; i++) { if (d[i * 4 + 3] >= 128) { op[i] = 1; ink++; } }
    if (!ink) return 0;
    var lab = new Int32Array(w * h), n = 0, minA = Math.max(4, ink * 0.002), q = new Int32Array(w * h);
    for (i = 0; i < w * h; i++) {
      if (!op[i] || lab[i]) continue;
      var id = ++n, qh = 0, qt = 0, area = 0; lab[i] = id; q[qt++] = i;
      while (qh < qt) {
        var p = q[qh++], px = p % w, py = (p / w) | 0; area++;
        for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) {
          if (!dx && !dy) continue;
          var nx = px + dx, ny = py + dy; if (nx < 0 || ny < 0 || nx >= w || ny >= h) continue;
          var np2 = ny * w + nx; if (op[np2] && !lab[np2]) { lab[np2] = id; q[qt++] = np2; }
        }
      }
      if (area < minA) n--; /* speck: not a piece (label stays set, count does not) */
    }
    return n;
  }
  function backdropCanvas(cv, avoid) {
    /* the renderer flattens transparent padding to white, so a white patch
       background is indistinguishable from the studio backdrop and the model
       silhouette-cuts the patch (2026-08-15 skull/rectangle case). Host the
       reference on an explicit neutral grey stage so the patch boundary is
       unambiguous; display surfaces keep the transparent copy. */
    /* pick whichever grey sits FURTHEST from the patch's own colors */
    var cands = [[179, 179, 179, '#B3B3B3'], [98, 102, 109, '#62666D']];
    var back = cands[0][3], bestD = -1;
    cands.forEach(function (c) {
      var dMin = Infinity;
      (avoid || []).forEach(function (h) {
        if (!h || !/^#[0-9a-fA-F]{6}$/.test(h)) return;
        var r = parseInt(h.substr(1, 2), 16), g2 = parseInt(h.substr(3, 2), 16), b = parseInt(h.substr(5, 2), 16);
        var d = Math.sqrt((r - c[0]) * (r - c[0]) + (g2 - c[1]) * (g2 - c[1]) + (b - c[2]) * (b - c[2]));
        if (d < dMin) dMin = d;
      });
      if (dMin > bestD) { bestD = dMin; back = c[3]; }
    });
    var pad = Math.round(Math.max(cv.width, cv.height) * 0.12);
    var out = document.createElement('canvas');
    out.width = cv.width + pad * 2; out.height = cv.height + pad * 2;
    /* C228 (Justin 2026-09-16, tackle twill: "user had 1 line and it created 2 lines"): the nano generator asks fal for one of a
       fixed set of frame ratios (1:1, 4:3, 3:4, 3:2, 2:3, 16:9, 9:16) and the model RE-FLOWS a layout that is wider than the frame
       (a 2.75:1 line of letters into two stacked lines). A prompt lock did not stop it. So the hosted reference is LETTERBOXED to
       the very ratio the generator will request — the model then re-photographs a frame-shaped source and has nothing to re-flow.
       Extra stage is the same grey. Only on the nano lane; Patch Sensei keeps the tight 12% pad. */
    try {
      if (typeof genOn === 'function' && genOn() && st.w && st.h) {
        var rT228 = st.w / st.h, best228 = 1, bd228 = Infinity;
        [1, 4 / 3, 3 / 4, 3 / 2, 2 / 3, 16 / 9, 9 / 16].forEach(function (v) { var d = Math.abs(Math.log(rT228 / v)); if (d < bd228) { bd228 = d; best228 = v; } });
        var rC228 = out.width / out.height;
        if (rC228 > best228 * 1.02) out.height = Math.round(out.width / best228);        /* source wider than the frame: add stage above/below */
        else if (rC228 < best228 / 1.02) out.width = Math.round(out.height * best228);   /* source taller than the frame: add stage left/right */
      }
    } catch (e228) {}
    var x = out.getContext('2d');
    x.fillStyle = back;
    x.fillRect(0, 0, out.width, out.height);
    x.drawImage(cv, Math.round((out.width - cv.width) / 2), Math.round((out.height - cv.height) / 2));
    return out;
  }
  function composeAndHost() {
    /* returns a promise; sets sensei.composedUrl (null on any failure —
       generation falls back to the raw artwork) */
    return new Promise(function (resolve) {
      composePatchImage(function (cv) {
        if (!cv) { sensei.composedUrl = null; sensei.composedFoldedUrl = null; sensei.composedLocal = null; sensei.composedLocalFolded = null; sensei.composedCleanUrl = null; sensei.composedCleanDone = true; resolve(null); return; }
        /* local copy: the compare slider can always show the TRUE preview
           even if hosting fails */
        try { sensei.composedLocal = cv.toDataURL('image/png'); } catch (e) { sensei.composedLocal = null; }
        /* C181 (Justin 2026-09-11, 'the left side of the slider has to be the digital image from builder'): the compare
           slider shows the DIGITAL preview — the fold depiction the customer saw on the page — while composedLocal stays
           the flat composite for the digital proof / production readers (C168) */
        sensei.composedLocalFolded = null;
        try { var fcvL181 = foldDepiction(cv); if (fcvL181 && fcvL181 !== cv) sensei.composedLocalFolded = fcvL181.toDataURL('image/png'); } catch (eL181) { sensei.composedLocalFolded = null; }
        var bp = backdropCanvas(cv, [st.bg && st.bg.hex, st.thread && st.thread.hex]);
        sensei.composedCleanUrl = null;
        sensei.composedCleanDone = false;
        var cseq = (sensei.composeSeq = (sensei.composeSeq || 0) + 1);
        /* C13 (2026-08-25) — NORMALISE TO IMGIX AT THE SOURCE. hostProof returns
           the presign S3 URL. Storing that raw broke TWO things at once on live
           order PATCH-2107255: _Upload shipped as
           ninja-services-production-ninjauploadss3bucket-….s3.amazonaws.com, and
           the SPEC SHEET never built — composeSpec loads its base with
           crossOrigin='anonymous' and the raw S3 host sends no CORS headers, so
           the canvas taints and the compose dies silently. imgix fronts the same
           object WITH CORS. A third assignment site already did this
           (`= toImgixHost(u4)`); these two did not. */
        hostProof(cv, 'refclean' + (Date.now() % 100000), function (e2, cu) { if (sensei.composeSeq === cseq) { sensei.composedCleanUrl = cu ? toImgixHost(cu) : null; sensei.composedCleanDone = true; } });
        var done = false;
        var t = setTimeout(function () { if (!done) { done = true; sensei.composedUrl = null; resolve(null); } }, 8000);
        /* C177: a FOLDED woven label also hosts its fold depiction (C168, the on-screen preview's construction) as the
           renderer's reference image — the image is the strongest signal the model gets, and the flat composite kept
           every label rendering flat. The flat composite stays the production _Upload / composedUrl. */
        var wantFold177 = !!(PTYPE.fold && st.fold && foldKind(st.fold.label) && shapeGeom() !== 'custom');
        sensei.composedFoldedUrl = null;
        var pending177 = 1;
        function finish177() { if (--pending177 > 0 || done) return; done = true; clearTimeout(t); resolve(sensei.composedUrl); }
        if (wantFold177) {
          var fcv177 = null;
          try { fcv177 = foldDepiction(cv); } catch (eF177) { fcv177 = null; }
          if (fcv177 && fcv177 !== cv) {
            pending177++;
            hostProof(backdropCanvas(fcv177, [st.bg && st.bg.hex, st.thread && st.thread.hex]), 'reffold' + (Date.now() % 100000), function (eF, urlF) {
              if (done) return;
              sensei.composedFoldedUrl = urlF ? toImgixHost(urlF) : null;
              finish177();
            });
          }
        }
        sensei.composeRefPending = cseq; /* C465: the nano lane waits on this */
        hostProof(bp, 'ref' + (Date.now() % 100000), function (e, url) {
          if (sensei.composeRefPending === cseq) sensei.composeRefPending = 0;
          if (done) {
            /* C465: a reference that lands AFTER the 8s cap still belongs to this composition (same composeSeq) — keep
               it instead of dropping it, so a render that is still waiting (waitGenRef) gets the real reference */
            if (url && sensei.composeSeq === cseq && !sensei.composedUrl) sensei.composedUrl = toImgixHost(url);
            return;
          }
          sensei.composedUrl = url ? toImgixHost(url) : null; /* C13: imgix, not raw S3 */
          finish177();
        });
      }, null, { refOnly: 1, corners: st.corners, freeform: isFreeFormShape() });
    });
  }
  function senseiNoteDirective() {
    /* explicit render instructions — the shape MUST be honored */
    var parts = [];
    /* C164b: a FOLDED label (anything but Straight Cut / Die Cut) must show its folds — the flat-camera and hot-cut lines
       below are for cut patches; the fold sentence (foldPrompt) is the authority on the label's edges */
    var foldedLbl = !!(PTYPE.fold && st.fold && !/straight|die|design/i.test(st.fold.label || '')); /* C167; C174: keyed on the fold step */
    if (foldedLbl) parts.push('CAMERA: straight-on product photo from above on the plain backdrop; the label rests naturally on the backdrop and its FOLDS are shown as real creases and folded flaps exactly as the FOLD STYLE line describes (side thickness is visible only where a fold turns). NO white plate, backing board or mat beneath or behind the label, no halo. The label is the ONLY object in the frame.');
    else parts.push('CAMERA: perfectly FLAT top-down product photo taken straight above the patch — no perspective tilt, no visible side thickness or stacked edge, NO white plate, backing board, or mat beneath or behind the patch, no halo. The patch is the ONLY object, lying flat directly on the plain studio backdrop.');
    /* a type whose construction is NOT "artwork sitting on a patch base"
       states its own MATERIAL paragraph and skips the generic base/shape copy
       below, which would otherwise instruct the renderer to invent a patch */
    if (PTYPE.matNote) parts.push(typeof PTYPE.matNote === 'function' ? PTYPE.matNote() : PTYPE.matNote);
    if (st.fdChoice === 'ps' || TYPE_KEY === 'print-and-stitch-2-0') parts.push('HYBRID PRINT & STITCH PATCH — the defining feature, it must be visible: every piece of lettering, every outline and every large solid colour area is EMBROIDERED in dense satin-stitch thread with visible stitch direction and raised relief; ONLY the small text and fine detail that thread cannot hold is PRINTED as smooth flat sublimation on the twill; the two textures sit side by side, clearly distinguishable; the border is real embroidered thread. Never render the whole design as flat print. (C235)');
    if (isLeather()) {
      parts.push('HARD RULE: this is ' + (PTYPE.name === 'Faux Leather' ? 'FAUX' : 'GENUINE') + ' LEATHER — absolutely NO stitching, thread, embroidery, or merrow anywhere. The artwork is a single-tone laser etch (' + leatherEtch().hex + ' burn tone), never full color.');
      if (isLeather() && st.etchInvert) parts.push('INVERTED ETCH: the entire leather face is laser-burned to the dark etch tone, and the ARTWORK is left as bare un-burned leather \u2014 the design reads leather-light on burned-dark, the exact inverse of a normal etch.');
      if (st.border && /etched/i.test(st.border.label || '')) parts.push('BORDER: a thin laser-etched border LINE runs parallel to the patch edge, inset slightly from it like a debossed groove, thickness ' + (st.lbThick || 3) + ' out of 10, in the same etch tone. A clean continuous line — never stitching.');
      else parts.push('The patch edge is a smooth clean-cut leather edge with NO border line of any kind.');
    }
    /* LIGHT BORDER vs LIGHT BACKDROP (Justin 2026-08-24): a white/cream
       border sits ~5% away from the #F2F2F2 studio backdrop — generative
       renderers absorb near-identical tones into one region and the border
       washes out or thins. Spell out the separation. */
    /* C159 (2026-09-10 review of C158): 'No Border' hides the thread step but never clears st.thread, so a
       thread picked earlier still fed the LIGHT BORDER / RIM THICKNESS paragraphs. Compute the fact here. */
    var noBorderPickD = !!PTYPE.borderless || !!(st.border && /no border/i.test(st.border.label || '')); /* C162 */
    var thLbN = (st.thread && st.thread.label) || '';
    var thHxN = (st.thread && st.thread.hex) || '';
    var isLightBorder = /white|cream|ivory|natural|silver|light gr[ae]y/i.test(thLbN);
    if (!isLightBorder && /^#?[0-9a-f]{6}$/i.test(thHxN)) {
      var hN = thHxN.replace('#', '');
      isLightBorder = (0.299 * parseInt(hN.slice(0, 2), 16) + 0.587 * parseInt(hN.slice(2, 4), 16) + 0.114 * parseInt(hN.slice(4, 6), 16)) > 218;
    }
    if (isLightBorder && st.thread && !/^none$/i.test(thLbN) && !isLeather() && !noBorderPickD) {
      parts.push('LIGHT BORDER ON A LIGHT BACKDROP: the ' + thLbN + ' border is nearly the same tone as the studio backdrop \u2014 it must remain CLEARLY visible at its full thickness on every side: render its raised thread texture crisply and add a soft neutral contact shadow just outside the patch edge so the border reads against the backdrop. NEVER thin, dim, grey, or blend the border into the backdrop.');
    }
    if (PTYPE.borderThick && PTYPE.lbZeroMax2 && st.thread && !/^none$/i.test(st.thread.label || '') && !noBorderPickD) {
      var tSN = Math.max(1, Math.min(10, st.lbThick || PTYPE.lbDefault || 5));
      parts.push('BORDER RIM THICKNESS: the ' + (/silicone/.test(TYPE_KEY) ? 'thin flat silicone border' : 'raised moulded border rim') /* C553 */ + ' is ' + (tSN / 5).toFixed(1) + 'x the standard rim width (' + tSN + ' of 10, where 5 is standard, 1 is a barely-there fine rim and 10 is twice standard). Keep it identical on every side.');
    }
    if (PTYPE.sewChannel) parts.push(npSewOn() /* C538 */
      ? 'SEWING CHANNEL: a narrow moulded groove of one fixed width runs all the way around the patch ' + (npSewInRim(thLbN && !/^none$/i.test(thLbN) && !noBorderPickD ? 1 : 0) ? 'in the middle of the raised border rim' : 'just inside the outer edge') + ', following the outline exactly and unbroken. It is an empty indented channel for sewing the patch on (no thread, no holes); show it with a soft shadow inside the groove so it reads even on the same colour.'
      : 'NO SEWING CHANNEL: the border rim and the patch edge are smooth solid moulded PVC. Never add a groove, channel or indented line around them.');
    /* C553 (Justin 2026-11-03, order 18951893090623: "silicone is not like rubber pvc ... silicone never has a sew path ever and is not 3d
       like rubber pvc / It is only slightly elevated like .5mm"): silicone was briefed as moulded PVC with the velcro sew line. */
    if (/silicone/.test(TYPE_KEY)) parts.push('SILICONE: one thin flat layer of matte silicone only about 0.5 mm thick, barely raised off the surface \u2014 never a thick moulded 3D rubber / PVC patch, never a raised rim, and never any sew line, groove, channel or stitching, whatever the backing.');
    if (/rubber/.test(TYPE_KEY) && st.backing && /hook|velcro/i.test(st.backing.label || '')) parts.push('ABSOLUTE RULE \\u2014 VELCRO BACKING SEW LINE (overrides any no-stitching rule for this material): the hook-and-loop backing is SEWN on and its attachment stitching MUST be clearly visible on the front of the patch: one single continuous track of small, even machine stitches running around the ENTIRE outer rim, inset about 2mm from the outer edge, following the patch outline exactly, unbroken with no gaps \\u2014 it reads like a fine dashed thread line drawn around the rim. A render without this visible perimeter stitch track is WRONG.');
    /* The renderer improvises border thickness — it came back thinner on one
       side of a merrow patch. Our reference ring is uniform by construction, so
       this has to be stated explicitly in the prompt. */
    if (!isLeather() && st.border && !/no border/i.test(st.border.label || '')) {
      parts.push('BORDER WIDTH: the border runs around the ENTIRE patch at exactly the SAME thickness on every side — top, bottom, left and right are identical. Never taper, thin, or thicken it on one edge, and never let it fade out or break at a corner. Measure it as one constant band following the outline.');
    }
    var thNoneD = !!(st.thread && (st.thread.none || /^none$/i.test(st.thread.label || '')));
    /* C158 (Justin 2026-09-10, pig photo / Full Color / Square / No Border rendered with a white
       rim): 'No Border' is picked on the BORDER-STYLE step, which hides the thread step, so
       st.thread never carries none and the NO-ADDED-BORDER instruction below never fired — the
       renderer only saw 'Border style: No Border' and its full-color style text still invites a
       merrow. The lab and Patch Express already key on the border label; this is the PDP catching up. */
    /* C161 (2026-09-10, C158 review): leather's border tiles are literally 'No Border' / 'Etched Border' and custom-shape leather is
       forced to No Border, so without this gate every leather render gained the INTERIOR-only / cut-at-the-artwork-edge lines —
       contradicting the C128 bridged-leather margin and the fixed-shape paragraph. Leather keeps its own no-border copy above. */
    var noBorderD = !isLeather() && (!!PTYPE.borderless || !!(st.border && /no border/i.test(st.border.label || ''))); /* C162: a borderless type (woven labels) has no border step, so the fact comes from the profile */
    var noBorderAnyD = thNoneD || noBorderD;
    /* C159: the no-border WORDING depends on the geometry. A custom (Design's Shape) patch is cut on the
       artwork's own contour, so the background fills the design interior only; a FIXED shape keeps its
       outline and the background runs to the hot-cut edge — the old interior-only text told the model to
       cut a Square to the artwork. */
    var fixedGeomD = shapeGeom() !== 'custom';
    var thFollowD = isFollowVal(st.thread);
    var bgFollowD = isFollowVal(st.bg);
    if (sensei.composedUrl && !sensei.titleOverride && !PTYPE.bareArt && isFreeFormShape()) {
      /* C137 (Justin 2026-09-03, "Fascomp" free-form silicone): the composed
         reference for Free Form is the BARE artwork on a grey stage — there is
         no patch base in it — so the "fully composed patch layout / keep the
         base shape" copy below must never run for Free Form. Combined with
         the renderer's plate-rimmed silicone references it made the model
         mount the pieces on a white design-shape plate and drop the logo's
         own oval ring ("this is like design shape which is wrong — it should
         just be standalone"). */
      parts.push('The supplied artwork image shows the design pieces on a neutral grey studio backdrop: the grey area is the photography surface and is NOT part of any patch — wherever the artwork is transparent (around the pieces AND inside any ring, oval, frame or letter opening) the backdrop shows through and stays EMPTY in the render. There is NO patch base, plate or panel in this layout and none may be added — the pieces stand alone exactly as drawn.');
      /* C142: the C140 "NO BACKING PLATE … transfer sheet … N pieces" paragraph is GONE —
         it never stopped the model's plate (the plate cut does) and "transfer sheet"
         pushed the material toward flat vinyl; the prompt is back to the C137d.2 text
         Justin liked. */
    } else if (sensei.composedUrl && !sensei.titleOverride && !PTYPE.bareArt) {
      parts.push('The supplied artwork image IS the fully composed patch layout — shape, background color, border ring, and art placement are already exact. The patch lies on a neutral grey studio backdrop in that image: the grey area is the photography surface, NOT part of the patch. Keep the full patch base shape exactly as shown and reproduce it faithfully as a real patch in this material — do NOT cut the patch outline to the artwork silhouette.' + (foldedLbl ? ' The reference shows the label FLAT before folding; render it folded exactly as the FOLD STYLE line describes while keeping its face design, colours and proportions.' : '') /* C164c */);
    }
    if (st.shape && !PTYPE.bareArt) {
      var sg = shapeGeom();
      if (PTYPE.monoTone) parts.push('SINGLE MATERIAL FINISH: this patch is molded entirely from ' + (PTYPE.fixedBg ? PTYPE.fixedBg.label : 'one colour') + ' flex. The design is NOT printed in colour — it is raised in the SAME material, so the whole patch is one colour and the artwork reads only through its raised relief, highlights and shadow. Do NOT reproduce the artwork colours.');
      if (sg === 'custom' && isFreeFormShape()) parts.push('The patch is FREE FORM (STANDALONE): the artwork itself is the patch. Every shape the artwork draws — including any outer ring, oval, outline, frame or box that is part of the design — is a real piece and must be kept EXACTLY as drawn; never delete, thin or merge it. Elements that touch in the artwork form ONE piece; elements that do not touch stay SEPARATE standalone pieces with empty backdrop between them. There is no shared backing, no connecting base, no plate or panel under the pieces, no background field behind the design, and no ADDED border of any kind — "no border" means do not add one, never remove an outline the artwork already has. ENCLOSED OPENINGS STAY OPEN: the inside of a ring, oval, frame or letter that is empty in the artwork stays empty — never fill it with material, never turn a ring into a solid plate; a ring renders as a ring with the backdrop visible through its middle. Reproduce only the artwork itself, cut out. C62: EDGE COLOUR RULE — every cut piece\'s edge and sides are the SAME colour as that piece\'s own face. NEVER add a white or light keyline, outline, halo, rim, plate or base edge around the design or around any element unless the uploaded artwork itself contains one. The silhouette must match the uploaded image exactly, including its interior openings.');
      else if (sg === 'custom' && isLeather() && st.__leatherBridged) parts.push('The patch is a CUSTOM SHAPE cut from the hide as ONE smooth continuous contour hugging the overall outline of the whole design with a small plain-leather margin — separate letters or elements are BRIDGED into a single piece, NEVER cut around individually, and there is NO border of any kind. The artwork is laser-etched into the surface so every line and indentation of the design reads as burn marks; the margin around the design stays plain leather.'); /* C128 */
      else if (sg === 'custom' && isLeather()) parts.push('The patch is a CUSTOM SHAPE cut from the hide EXACTLY along the artwork\'s own outer contour \u2014 no margin around the design, no base sticking out past it, and NO border of any kind. Interior knockout detail stays leather; the artwork is laser-etched into the surface so every line and indentation of the design reads as burn marks.');
      else if (sg === 'custom') parts.push('The patch is a CUSTOM SHAPE: the base is cut as ONE smooth continuous contour hugging the overall outline of the whole design — NEVER cut around individual letters or elements — and filled with the background color' + ((noBorderAnyD || thFollowD) ? '.' : (', with a ' + ((st.thread && st.thread.hex && st.thread.label !== 'Let Ninja Choose' && st.thread.label !== 'Not Sure') ? st.thread.label + ' ' : '') + 'border running along that outer contour.')));
      else parts.push('The patch base shape MUST be a ' + st.shape + (SHAPE_DESC[orientGeom(sg)] ? ' (' + (st.corners === 'square' ? SHAPE_DESC[orientGeom(sg)].replace(/rounded[- ]/i, '') : SHAPE_DESC[orientGeom(sg)]) + ')' : '') + ((sg === 'square' || sg === 'rectangle' || sg === 'rectangle-v') ? (st.corners === 'square' ? ', with sharp SQUARE corners (no rounding),' : ', with softly rounded corners,') : '') + ' — the fabric patch itself is a ' + st.shape + ' with the artwork placed on it, NOT cut to the artwork outline.' + (foldedLbl ? ' This is the label\u2019s FLAT shape before folding \u2014 the FOLD STYLE line describes the finished fold.' : '') /* C164c */);
    }
    parts.push('Patch dimensions: ' + st.w.toFixed(2) + '" wide x ' + st.h.toFixed(2) + '" tall.');
    if (bgFollowD) parts.push('BACKGROUND: the artwork already contains its own background — reproduce it exactly as shown in the artwork; do NOT add or change any background color.');
    else if (st.bg && st.bg.label !== 'Let Ninja Choose' && st.bg.label !== 'Not Sure') parts.push('Patch background color: ' + st.bg.label + (st.bg.hex ? ' (' + st.bg.hex + ')' : '') + (noBorderAnyD ? (fixedGeomD ? (foldedLbl ? ' \u2014 this color fills the whole label to every edge; there is no border of any kind.' : (' \u2014 this color fills the whole ' + (st.shape || 'patch') + ' right to the hot-cut edge; there is no border of any kind.')) : ' — this color fills the design INTERIOR only; it must NEVER extend beyond or wrap around the artwork\'s outermost edge.') : '.'));
    if (noBorderAnyD && fixedGeomD) parts.push(foldedLbl ? 'NO ADDED BORDER: the label has NO border of any kind \u2014 no stitched ring, merrow, keyline, white margin, halo or raised rim; the weave runs to every edge and the folds are plain creases in the same woven material.' : 'NO ADDED BORDER: the ' + (st.shape || 'patch') + ' patch has NO border of any kind \u2014 no stitched ring, merrow, keyline, white margin, halo or raised rim. The ' + (st.shape || 'patch') + ' is hot-cut on its outline and the patch face (background colour or artwork) runs to that cut edge on every side.'); /* C159: fixed-shape wording */
    else if (noBorderAnyD) parts.push('NO ADDED BORDER: do not add any border, outline, rim, ring, or edge highlight of your own. FOLLOW THE ARTWORK EDGE-FOR-EDGE — if the artwork already includes its own border, outer ring, or edge design, reproduce that edge EXACTLY as drawn in the artwork colors, and the patch is CUT exactly at that outermost edge: NO patch material, base color, or margin of ANY color extends beyond the artwork\'s outer boundary. Only if the artwork has no edge design of its own does the background color run cleanly to the edge.');
    else if (thFollowD) parts.push('BORDER: the artwork already includes its own border/edge treatment — keep it exactly as drawn in the artwork; do NOT add another border ring.');
    else if (st.thread && st.thread.label !== 'Let Ninja Choose' && st.thread.label !== 'Not Sure') parts.push('Border thread color: ' + st.thread.label + (st.thread.hex ? ' (' + st.thread.hex + ')' : '') + '.');
    if (st.border) parts.push(noBorderD ? 'Border: NONE.' : ('Border style: ' + normalizeBorder(st.border.label) + '.')); /* C159: 'Border style: No Border' read as a style to render */
    else if (PTYPE.borderless) parts.push('Border: NONE.'); /* C162 */
    /* C472: the reference carries the sublimation safety margin between the design and the border — say so, or the
       'artwork already contains its own background' line reads the white margin as an added background */
    if (st.__subliGap && shapeGeom() === 'custom' && !noBorderAnyD && !thFollowD) parts.push('BORDER CLEARANCE: the border runs a small, even margin (about ' + (NP_SUBLI_SAFE_IN === 0.125 ? '1/8' : String(NP_SUBLI_SAFE_IN)) + ' inch) outside the printed design, exactly as in the reference \u2014 the design never touches or runs under the border' + (st.__subliGap.edge ? '; that margin continues the artwork\'s own background colour (' + st.__subliGap.edge + ') out to the border.' : st.__subliGap.white ? '; that margin is plain white fabric, not an added background colour.' : '.'));
    if (stepEnabled('fold') && st.fold) parts.push(foldPrompt(st.fold.label)); /* C164: the fold is a physical feature of the rendered label */
    /* C158: Full Color and Woven are the two types that offer 'No Border' (PTYPE.noBorderOpt) —
       on both, No Border means the face runs to the hot-cut edge (print for Full Color, weave for Woven). */
    if (noBorderAnyD && /^(fullcolor-2-0|woven-2-0)$/.test(TYPE_FAMILY) && shapeGeom() !== 'custom') {
      var wovenD = /^woven/.test(TYPE_KEY);
      parts.push(foldedLbl ? 'FULL BLEED, NO BORDER: the woven design runs to every edge of the label with no margin. NEVER add a white or light margin, keyline, halo, frame, stitched rim or merrow edge anywhere. The reference photos\u2019 borders belong to THEIR designs; this label has none.' : 'FULL BLEED, NO BORDER: this is a ' + (wovenD ? 'woven' : 'printed') + ' patch with NO border. The ' + (wovenD ? 'woven design' : 'printed image') + ' runs all the way to the cut edge on every side and the patch is hot-cut on the ' + (st.shape || 'chosen') + ' outline. NEVER add a white or light margin, keyline, halo, frame, stitched rim or merrow edge anywhere \u2014 the cut edge IS the ' + (wovenD ? 'woven design' : 'printed image') + '. The reference photos\u2019 borders belong to THEIR designs; this patch has none.');
    }
    if (st.artZoom && Math.abs(st.artZoom - 1) > 0.02) {
      parts.push('Artwork fill: scale the artwork to about ' + Math.round(st.artZoom * 100) + '% of standard sizing within the patch (' + (st.artZoom > 1 ? 'larger — filling more of the patch' : 'smaller — leaving more margin') + ').');
    }
    if ((st.artDx || st.artDy) && shapeGeom() !== 'custom') parts.push(panPromptLine151(st.artDx, st.artDy)); /* C151: only where the composer pans (never Design's Shape) */
    else parts.push('PLACEMENT: the design group must sit in the EXACT CENTER of the patch — equal empty space above and below the design, equal space left and right. Never place the design in the top half with empty material below it.');
    return '[' + parts.join(' ') + ']';
  }
  function senseiSpecs() {
    return {
      /* bare art (tackle twill) = the renderer's FREE FORM path: separate cut
         pieces, no base, no contour border — its colours travel in the NOTE,
         because background_color/border_color read as patch base + ring specs
         and produced one solid patch with a merrow around everything */
      shape: PTYPE.bareArt ? 'Free Form' : (st.shape || ''),
      /* C461: for leather the render Lambda reads the hide from background_color ("real <label> leather") — leather_color alone
         left every Patch Sensei leather render as natural tan; = the PDP nano generator's label(ctx.bg) */
      background_color: (isLeather() && st.bg) ? st.bg.label : (!PTYPE.bareArt && !isLeather() && stepEnabled('bg') && st.bg && !isFollowVal(st.bg) && st.bg.label !== 'Not Sure' && st.bg.label !== 'Let Ninja Choose') ? (st.bg.label + (st.bg.hex ? ' (exact hex ' + st.bg.hex + ')' : '')) : '',
      leather_color: (isLeather() && st.bg) ? st.bg.label : '',
      /* C461 (PATCH-2112705, Justin 10-01): the inverted etch rides as a SPEC. It lived only in the line note
         (senseiNoteDirective), which the render Lambda never reads — the C177 / backing_sew_line lesson — so a 9-09 Patch
         Sensei render came back as the default black-with-silver etch. RankMockup's nano_ctx turns etchInvert on from
         specs.etch_mode. */
      etch_mode: (isLeather() && st.etchInvert) ? 'Inverted - background etched, artwork bare' : '',
      etch_tone: isLeather() ? leatherEtch().hex : '', /* C461: the burn tone (Black & Silver = #9A9A9A silver); the Lambda defaulted to #2E1B0E brown */
      border_color: (!PTYPE.bareArt && stepEnabled('thread') && st.thread && !isFollowVal(st.thread) && st.thread.label !== 'Not Sure' && st.thread.label !== 'Let Ninja Choose' && st.thread.label !== 'None') ? (st.thread.label + (st.thread.hex ? ' (exact hex ' + st.thread.hex + ')' : '')) : '',
      border_style: (function () {
        var bs = (stepEnabled('border') && st.border && !(st.thread && (st.thread.none || /^none$/i.test(st.thread.label || '')))) ? normalizeBorder(st.border.label) : '';
        if (bs && isLeather() && /etched/i.test(bs)) bs += ' (etched line thickness ' + (st.lbThick || 3) + ' of 10)';
        return bs;
      })(),
      background_texture: (stepEnabled('texture') && st.texture) ? st.texture.label : '',
      border_thickness: PTYPE.borderThick ? (Math.max(1, Math.min(10, st.lbThick || PTYPE.lbDefault || 3)) + ' of 10' + (PTYPE.lbZeroMax2 ? ' (5 = the standard rim width, 1 = a barely-there fine rim, 10 = twice the standard width)' : '')) : '',
      /* velcro-backed PVC/silicone: the sewn-on backing's stitch track must
         show on the front. Rides as a SPEC (mandatory prompt line) because
         the render Lambda never sees the line-level note (2026-08-24). */
      backing_sew_line: (/rubber/.test(TYPE_KEY) && st.backing && /hook|velcro/i.test(st.backing.label || '')) /* C553: never on silicone */
        ? 'VELCRO BACKING SEW LINE (required): the hook-and-loop backing is SEWN on \u2014 render one single continuous track of small, even machine stitches around the ENTIRE outer rim, inset about 2mm from the outer edge, following the patch outline exactly, unbroken with no gaps, clearly visible on the front like a fine dashed thread line. A render without this stitch track is wrong.'
        : '',
      corner_style: (function () { var g3 = shapeGeom(); return (g3 === 'square' || g3 === 'rectangle' || g3 === 'rectangle-v') && st.corners ? (st.corners === 'square' ? 'Square (sharp corners, no rounding)' : 'Rounded corners') : ''; })(),
      border_stitch: (PTYPE.stitches && st.ttStitch) ? st.ttStitch : '',
      /* C177 (Justin 2026-09-11, "you still are not showing the end fold on the AI mockup"): the fold rode ONLY in the
         line note, which the render Lambda never sees (same lesson as backing_sew_line) — it now travels as a SPEC, with
         the theme's own fold sentence, so RankMockup's mandatory block can say FOLDED LABEL (ninjaforce main 20015b8ef
         reads fold_style / fold_directive) */
      fold_style: (stepEnabled('fold') && st.fold) ? st.fold.label : '',
      fold_directive: (stepEnabled('fold') && st.fold) ? foldPrompt(st.fold.label) : '',
      /* C193 (Justin 2026-09-11, 'the AI gens are not keeping this layout' — the fold TILE photos ARE the layout): the
         tile image travels as the renderer's fold reference photo (RankMockup fetches it; labels otherwise render with
         no photo at all). Protocol-relative CDN URLs become https. */
      fold_reference_url: (function () { var u = (stepEnabled('fold') && st.fold && (st.fold.img || st.fold.image)) ? String(st.fold.img || st.fold.image) : ''; if (/^\/\//.test(u)) u = 'https:' + u; return /^https:\/\//.test(u) ? u.split('?')[0] : ''; })(),
      /* C198 (PATCH-2111164, 2026-09-11): a photographed artwork (the gate's photo verdict, or the client photo heuristic)
         tells the renderer to drop its style-reference photos — a photo of a finished patch looked like one more reference
         and the model invented a different design. The renderer also verifies every render against the artwork now. */
      art_is_photo: (function () { try { return (npGateVerdictIs('photo') || fullColorLikely()) ? '1' : ''; } catch (eAP) { return ''; } })(),
      width_inches: st.w.toFixed(2),
      height_inches: st.h.toFixed(2)
    };
  }
  function senseiArtworkOf(item) {
    var p = item.properties || {};
    return cleanUrl(p._cartImg || p['_Original Image'] || p._artwork_url || p._Upload || p.Upload || artworkUrl());
  }
  function specsFromProps(p) {
    var shape = p['_Shape'] || p['_Select Shape'] || p['Select Shape'] || '';
    return {
      shape: shape,
      /* fallback chain covers every name any era wrote: canonical first, then
         the legacy shared names, then the per-type labels (leather/faux wrote
         'Leather Color'/'Faux Leather Color'; PVC/silicone/flex wrote plain
         'Border Color') — an OLD order of any type must still rebuild */
      background_color: p['_Background Color'] || p['Patch Background Color'] || p['Leather Color'] || p['Faux Leather Color'] || '',
      border_color: p['_Border Color'] || p['Border Thread Color'] || p['Border Color'] || p['Border Color (Merrow only)'] || '',
      border_style: normalizeBorder(p['_Border Style'] || p['_Border Style ' + shape] || ''),
      width_inches: p['_Width (in)'] || p['Width (in)'] || '',
      height_inches: p['_Height (in)'] || p['Height (in)'] || ''
    };
  }
  function senseiLines(cart, regenNote) {
    /* THE PAYLOAD IS THIS SESSION ONLY: one line — fresh render id, the
       image in the canvas right now, the current selections, the note.
       Other cart lines are never sent, so old sessions/test lines can't
       leak into the render (the proof-preview page rebuilds its own full
       session from the cart when it loads). */
    return [{
      line_item_id: sensei.renderLineId,
      /* full-color proofs render under the FC product title — the backend
         derives its render style from the title.
         C86 (2026-08-31): the backend has NO style for the Print & Stitch
         product title ("Print + Embroidery Patches" -> style_id null ->
         "Mockup generation failed." on EVERY generate). P&S centers are
         PRINTED, so render under the Full Color style; the stitched border
         is spelled out in the note directive below. */
      title: sensei.titleOverride || (TYPE_KEY === 'print-and-stitch-2-0' ? 'Full Color Printed Patches' : '') || CFG.productTitle || 'Embroidered Patches',
      quantity: st.qty,
      /* embroidered renders get the COMPOSED reference image (shape+colors
         baked in); Full Color and fallbacks use the raw artwork */
      artwork_url: ((!sensei.titleOverride || PTYPE.noArt) && (sensei.composedFoldedUrl || sensei.composedUrl)) || cleanUrl(artworkUrl()), /* C177: folded labels render from the folded depiction */
      specs: (function () {
        var sp = senseiSpecs();
        if (sensei.editBase) { sp.revision_note = sensei.editBase.note; sp.prev_mockup_url = sensei.editBase.url; sensei.editBase = null; }
        return sp;
      })(),
      /* the renderer respects the PROMPT more than the specs — spell the
         shape (and everything else) out explicitly in the note */
      note: ((regenNote
        ? 'CUSTOMER REVISION REQUEST \u2014 HIGHEST PRIORITY, apply it even where it conflicts with the reference image layout: \"' + regenNote + '\". '
        : ((customerNotes() || '') + ' ')) + senseiNoteDirective()
        /* C86: P&S renders as full color + REAL embroidered border */
        /* C235: the C86 "artwork printed, only the border stitched" line rendered all-print proofs (Patch-2113283) — the hybrid rule above (senseiNoteDirective) now carries P&S on both generators */
        ).trim()
    }];
  }
  function findOurLine(cart) {
    /* identify OUR cart line by the artwork it carries — position-based
       matching (items[0]) breaks when an add merges into an existing line
       and once caused a stale patch's render to show as the proof */
    /* C427 (PATCH-2115499): never cart.items[0]. That fallback handed patch 1's line to patch 2's page, which then
       treated it as its own. Only a line THIS page added can be ours, found the same way every writer finds it. */
    var ownF = ourCartLine(cart);
    return ownF ? (ownF.key || String(ownF.id)) : null;
  }
  /* ═══ STAGING GENERATOR OVERRIDE (Justin 2026-08-21) ═══
     When assets/np-ideogram-gen.js is present (staging only) AND the page
     carries ?np_gen=1, generation is routed through window.NP_GEN instead of
     the PatchSensei render API. Everything downstream — versions, the proof
     modal, approve, cart properties, spec sheets — is untouched: the override
     just has to resolve to a hosted image URL, exactly like a mockup_url.
     On live the asset does not exist, genOn() is false, and this is inert. */
  function genOn() {
    try {
      if (/[?&]np_gen=0/.test(window.location.search)) return false; /* escape hatch */
      /* AUTO-ON for the staging theme (Justin 2026-08-21): every product page
         on "Justin Staging 8-21" uses the nb2 generator with no URL param.
         Inert everywhere else — the LIVE theme id never matches, and the
         generator asset only exists on staging anyway. ⚠ If this staging
         theme is ever PUBLISHED, remove its id here first. */
      /* nano lane RETIRED on staging (Justin 2026-08-24): 8-21 renders via
         PatchSensei/OpenAI exactly like live. Keyed to no theme. */
      /* C224 (Justin 2026-09-16, "nano on live"): the OpenAI renderer's output shifted on 9-15 (rubber/paint instead of thread on the
         SAME inputs that rendered correctly on 9-13 — replay-verified); the nano generator (np-ideogram-gen.js → bg-removal-proxy /
         Gemini) still renders real stitching, so LIVE product pages generate through it again. Escape hatch stays: ?np_gen=0 renders
         through Patch Sensei. Patch Express, the lab and Shinobi still use Patch Sensei. Staging carries its own copy keyed to its id. */
      /* C224b (Justin 2026-09-16, "keep gpt 1.5 for free form"): silicone / Free Form pieces render as glossy black rubber on nano —
         those keep the Patch Sensei path; the shape is only known at generate time, so this is re-evaluated on every call. */
      /* C224c/C227 (Justin 2026-09-16): silicone Free Form rendered a plate on the OpenAI path; with the C225 wording nano renders
         separate matte pieces ("ok that's better") — every product-page render now goes through nano. ?np_gen=0 stays. */
      if (window.Shopify && Shopify.theme && String(Shopify.theme.id) === '187988967743') return true;
      /* STAGING ONLY (Justin 2026-08-24): np_gen=1 once persisted to
         localStorage and the generator asset now ships on BOTH themes (for
         the shared prompt code), so the flag was silently routing LIVE
         renders through nano instead of PatchSensei. Off the staging theme,
         the generator never runs — and the leaked flag is scrubbed. */
      try { localStorage.removeItem('np_gen'); } catch (eGc) {}
      return false;
    } catch (eG) { return false; }
  }
  function genLoad() {
    if (!genOn() || window.NP_GEN || window.__npGenLoading) return;
    window.__npGenLoading = true;
    var mine = document.querySelector('script[src*="np-emb2.js"]');
    var src = window.NP_E2_GEN_SRC ||
      (mine ? mine.src.replace(/np-emb2\.js/, 'np-ideogram-gen.js') : '');
    if (!src) { console.warn('[np-e2] cannot locate generator asset'); return; }
    var sc = document.createElement('script');
    sc.src = src;
    sc.async = true;
    sc.onerror = function () { console.warn('[np-e2] generator override asset missing — staying on sensei'); };
    document.head.appendChild(sc);
  }
  function genActive() { return genOn() && !!(window.NP_GEN && window.NP_GEN.render); }
  try { genLoad(); } catch (eGL) {}
  /* dark upload skin now gates in np-emb2-builder.liquid (theme.id) so the
     stylesheet is present at FIRST PAINT — the JS loader here caused FOUC */
  function genContext(regenNote) {
    var geomG = shapeGeom();
    var thNoneG = !!(st.thread && (st.thread.none || isFollowVal(st.thread) || /^none$/i.test(st.thread.label || '')));
    var noteG = regenNote || customerNotes() || '';
    return {
      typeKey: TYPE_FAMILY, /* family key: woven-labels renders on the woven-2-0 rules */
      materialPhrase: (function () {
        if (isLeather()) return (PTYPE.name === 'Faux Leather' ? 'faux leather' : 'genuine leather');
        if (PTYPE.monoTone) return 'molded ' + ((PTYPE.fixedBg && PTYPE.fixedBg.label) || 'flex') + ' flex';
        if (/print-and-stitch/.test(TYPE_KEY) || st.fdChoice === 'ps') return 'hybrid print-and-stitch (embroidered thread with printed fine detail)'; /* C235 */
        if (/fullcolor/.test(TYPE_KEY)) return 'full-colour printed';
        if (/woven/.test(TYPE_KEY)) return 'woven';
        if (/chenille/.test(TYPE_KEY)) return 'chenille';
        if (/silicone/.test(TYPE_KEY)) return 'thin flat silicone'; /* C553: silicone is not PVC */
        if (/rubber/.test(TYPE_KEY)) return 'moulded PVC';
        return 'embroidered';
      })(),
      isLeather: isLeather(),
      etchHex: isLeather() ? leatherEtch().hex : '',
      etchInvert: !!st.etchInvert,
      monoTone: !!PTYPE.monoTone,
      fixedBg: PTYPE.fixedBg || null,
      fullColor: /fullcolor/.test(TYPE_KEY) || !!sensei.titleOverride && /full color/i.test(sensei.titleOverride || ''),
      woven: /woven/.test(TYPE_KEY) || !!sensei.titleOverride && /woven/i.test(sensei.titleOverride || ''),
      printStitch: st.fdChoice === 'ps' || /print-and-stitch/.test(TYPE_KEY),
      freeform: (typeof isFreeFormShape === 'function') ? !!isFreeFormShape() : false,
      bareArt: !!PTYPE.bareArt,
      chenille: /chenille/.test(TYPE_KEY),
      pvc: /silicone|rubber/.test(TYPE_KEY),
      shape: st.shape || '',
      shapeDesc: SHAPE_DESC ? (SHAPE_DESC[orientGeom(geomG)] || '') : '', /* C223: the oriented description */
      geom: geomG,
      corners: (geomG === 'square' || geomG === 'rectangle' || geomG === 'rectangle-v') ? (st.corners || '') : '',
      w: st.w ? st.w.toFixed(2) : '', h: st.h ? st.h.toFixed(2) : '',
      bg: st.bg || null, bgFollow: isFollowVal(st.bg),
      thread: st.thread || null, threadNone: thNoneG,
      borderStyle: st.border ? normalizeBorder(st.border.label) : '',
      borderThickness: st.lbThick || PTYPE.lbDefault || 3,
      lbTuned: !!(PTYPE.borderThick && PTYPE.lbZeroMax2),
      texture: (st.texture && st.texture.label) || '',
      backing: (st.backing && st.backing.label) || '',
      velcroSew: /rubber/.test(TYPE_KEY) && !!(st.backing && /hook|velcro/i.test(st.backing.label || '')), /* C553: silicone never has a sew line */
      sewChannel: PTYPE.sewChannel ? npSewOn() : undefined, /* C538: PVC sends true/false — the proof shows the groove only when chosen */
      sewInRim: PTYPE.sewChannel ? npSewInRim(thNoneG ? 0 : 1) : undefined,
      notes: noteG,
      referenceUrl: sensei.composedUrl || sensei.composedCleanUrl || cleanUrl(artworkUrl()) || '', /* C465: never an empty reference */
      artworkUrl: cleanUrl(artworkUrl())
    };
  }
  /* C465 (PATCH-2117713 line 1, Justin 2026-10-02): the nano lane renders FROM the hosted grey-staged reference. composeAndHost
     gives up after 8s — a photo-like artwork (an AI-made image) is a big PNG, and on a slow uplink the upload outlives the cap —
     and genContext then sent no image at all: the proxy POSTed image_urls:[] to fal → HTTP 422 → "AI GENERATION FAILED -
     specialist proof required". Wait (up to 15s) for a reference still in flight; genContext then falls back to the clean
     composite and finally the artwork, the same way the Patch Sensei lane falls back to artwork_url. */
  function waitGenRef(go) {
    var t0 = Date.now();
    (function tick() {
      if (sensei.composedUrl || !sensei.composeRefPending || Date.now() - t0 > 15000) { go(); return; }
      setTimeout(tick, 250);
    })();
  }
  function senseiCreate(cart, regenNote) {
    /* B72 (2026-08-25) — STRIP THE CART-TOKEN QUERY STRING.
       Shopify's cart.token now comes back as "<token>?key=<hash>". The proof
       poll builds its URL with encodeURIComponent(cartToken), which turns that
       "?key=" into "%3Fkey%3D" INSIDE the path segment, so the ECS looks up a
       token that does not exist, answers 200 with no matching line, and the
       client waits on a render that will never appear (versions stays 0, the
       modal spins forever on "Rendering your patch").
       Diagnosed live from Justin's Safari session uP0GCLkHMA:
         GET /api/proof/session/hWNG3H8ROlGnKZuP0GCLkHMA%3Fkey%3D9d89... 200
       It is cart-dependent, not browser-dependent — which is why it reproduced
       on his cart and never on mine. */
    sensei.cartToken = String(cart.token || '').split('?')[0];
    /* ARTWORK OF RECORD (PATCH-2106699, 2026-08-24): the upload that this
       render is generated FROM. The legacy uploader's timers can clobber the
       hidden art inputs with an OLD upload right before Add to Cart — that
       order's _Original Image showed a file from two days earlier. The art
       captured at render time is the truth the proof was made from. */
    var artAR = cleanUrl(artworkUrl());
    if (artAR && isUploadLineage(artAR)) sensei.artAtRender = artAR;
    /* pre-Add-to-Cart there is no cart line — a stable synthetic id keys the
       session line instead (create + decision must use the same id) */
    sensei.syntheticId = sensei.syntheticId || ('npe2-' + Date.now());
    sensei.lineItemId = findOurLine(cart) || sensei.syntheticId;
    if (sensei.forceFresh) {
      /* one unique render id per generate — guarantees the render reflects
         the CURRENT config (cached session lines can carry old configs) and
         costs exactly one render (the old echo-comparison approach was
         double-rendering every generate: ~45s instead of ~15s) */
      sensei.renderLineId = sensei.lineItemId + '::g' + (new Date().getTime() % 10000000);
      sensei.forceFresh = false;
    }
    if (!sensei.renderLineId) sensei.renderLineId = sensei.lineItemId;
    if (genActive()) {
      /* staging: Ideogram renders instead of sensei. Resolve into the same
         shape senseiPoll returns, so the wait loop needs no special case. */
      sensei.__gen = { status: 'processing', url: '' };
      var genMine = sensei.__gen;
      waitGenRef(function () {
        if (sensei.__gen !== genMine) return; /* superseded while waiting */
        window.NP_GEN.render(genContext(regenNote)).then(function (u) {
          if (sensei.__gen === genMine) sensei.__gen = { status: 'complete', url: u };
        }).catch(function (e) {
          console.warn('[np-gen] render failed', e);
          if (sensei.__gen === genMine) sensei.__gen = { status: 'error', error: String((e && e.message) || e) };
        });
      });
      return Promise.resolve({ session_id: 'gen-' + sensei.renderLineId });
    }
    return fetch(SENSEI_EP + '/api/proof/session', {
      method: 'POST',
      body: JSON.stringify({ cart_token: cart.token, line_items: senseiLines(cart, regenNote) })
    }).then(function (r) {
      if (!r.ok) throw new Error('session ' + r.status);
      return r.json();
    }).then(function (j) { sensei.sessionId = j.session_id; return j; });
  }
  function senseiPoll() {
    if (genActive() && sensei.__gen) {
      var g = sensei.__gen;
      return Promise.resolve({
        line_item_id: sensei.renderLineId,
        session_id: 'gen-' + sensei.renderLineId,
        status: g.status,
        mockup_url: g.url || '',
        error: g.error || '',
        revision_count: 0
      });
    }
    /* B77 (2026-08-25) — DEFEAT THE POLL CACHE.
       This was a bare GET with no cache directives. Safari caches such GETs
       aggressively and re-served the FIRST "pending" body for the life of the
       render: the client never saw status:complete, and the origin barely saw
       traffic (measured: ONE poll in four minutes while a render ran to
       completion). Chrome revalidates more eagerly, which is why it only ever
       failed on Safari. Cache-bust per request AND ask for no-store. */
    var _pollUrl = SENSEI_EP + '/api/proof/session/' + encodeURIComponent(sensei.cartToken) +
                   '?_=' + Date.now() + '.' + Math.floor(Math.random() * 100000);
    /* NO custom request headers here. Cache-Control/Pragma are NOT CORS-safelisted,
       so adding them forced an OPTIONS preflight — and the backend advertises
       `access-control-allow-headers: content-type` ONLY. Every poll failed CORS,
       and after 95s the modal fell back to the uploaded design. Measured 2026-08-25;
       cost Justin a live test round. The `?_=` param alone defeats the cache, and
       fetch's `cache` init is not an author header so it never preflights. */
    return fetch(_pollUrl, { method: 'GET', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('poll ' + r.status); return r.json(); })
      .then(function (j) {
        var items = j.line_items || [];
        /* the backend PREFIXES line ids with "li-" — match both forms */
        var mine = items.filter(function (x) { return x.line_item_id === sensei.renderLineId || x.line_item_id === 'li-' + sensei.renderLineId; })[0] ||
                   items.filter(function (x) { return x.line_item_id === sensei.lineItemId || x.line_item_id === 'li-' + sensei.lineItemId; })[0] || items[0];
        if (mine && mine.session_id) sensei.sessionId = mine.session_id;
        if (j.session_id) sensei.sessionId = j.session_id;
        return mine;
      });
  }
  function senseiDecide(status, note) {
    return fetch(SENSEI_EP + '/api/proof/decision', {
      method: 'POST',
      body: JSON.stringify({
        session_id: sensei.sessionId,
        line_item_id: sensei.lineItemId,
        status: status,
        note: note || '',
        reference_url: '',
        reference_name: ''
      })
    }).then(function (r) { if (!r.ok) throw new Error('decision ' + r.status); return r.json(); });
  }
  function cleanProof(mockupUrl) {
    /* the renderer returns the patch on a white studio backdrop — run it
       through our proxy's bg-removal, which also re-hosts on imgix
       (persistent + CORS-open), then trim to the patch itself. Falls back
       to the raw mockup if the cleanup is unavailable. */
    return fetch('https://ruhg140mmf.execute-api.us-east-1.amazonaws.com/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ model: 'gram', imageUrl: mockupUrl })
    }).then(function (r) {
      if (!r.ok) throw new Error('cleanup ' + r.status);
      return r.json();
    }).then(function (j) {
      if (!j || !j.url) throw new Error('cleanup no url');
      return j.url + '?trim=colorUnlessAlpha&fm=png';
    }).catch(function (e) {
      console.warn('[np-emb2] proof cleanup unavailable', e);
      return mockupUrl;
    });
  }
  /* THROTTLE-PROOF TIMER (Justin 2026-08-24): hidden tabs clamp setTimeout
     to as little as once per MINUTE, so a backgrounded generation looked
     stalled even though the render finished server-side long ago. Worker
     timers are exempt from tab throttling — one shared worker plays the
     clock for the generation poll and the progress checklist. */
  var npwSeq = 0, npwCbs = {};
  function npWorker() {
    if (npWorker.__w !== undefined) return npWorker.__w;
    try {
      var b = new Blob(['onmessage=function(e){setTimeout(function(){postMessage(e.data.id)},e.data.ms)}'], { type: 'text/javascript' });
      var w = new Worker(URL.createObjectURL(b));
      w.onmessage = function (e) { var f = npwCbs[e.data]; delete npwCbs[e.data]; if (f) { try { f(); } catch (eF) {} } };
      npWorker.__w = w;
    } catch (eW) { npWorker.__w = null; } /* CSP-blocked worker → plain timers */
    return npWorker.__w;
  }
  function npTick(fn, ms) {
    /* DUAL CLOCK (B65, 2026-08-25 — Justin: "I can't generate a proof on
       mobile, it just gets stuck").
       The worker keeps the CLOCK off the main thread so background throttling
       cannot stall it. But if that worker is never created, is KILLED under
       memory pressure (iOS Safari reclaims workers aggressively on a page
       holding multi-MB canvases), or its message is dropped, the callback
       simply never fires — and EVERYTHING scheduled through here stops
       silently, including senseiWaitReady's poll. A render that finished on
       the backend in 12s then sits forever behind "Rendering your patch".
       Both clocks are now armed; a latch keeps it exactly-once. The plain
       timer is deliberately 250ms LATE so the worker normally wins and we keep
       its throttle immunity. */
    var ran = false;
    var once = function () { if (ran) return; ran = true; try { fn(); } catch (eF) {} };
    var w = npWorker();
    if (!w) { setTimeout(once, ms); return 0; }
    var id = ++npwSeq;
    npwCbs[id] = once;
    try { w.postMessage({ id: id, ms: ms }); }
    catch (eP) { try { npWorker.__w = null; } catch (eN) {} }
    setTimeout(once, (ms || 0) + 250);
    return -id;
  }
  /* C185 (Justin 2026-09-11, 'when I edit selection and generate a new AI proof it brings up the old one for a few
     seconds and then it updates with the new one'): the poll's fallback can hand back the PREVIOUS session line while
     the regenerate's own line is still pending, and `revision_count > -1` accepted any completed render — so the old
     image was pushed as the new version and only later replaced. A render is new ONLY if its URL is not one the
     customer already has, or it comes from a session line no existing version was made from (the renderer reuses a
     key per session; a same-URL fresh line is accepted and cache-busted). */
  function seenRender185(url) {
    var k = String(url || '').split('?')[0]; if (!k) return false;
    return st.versions.some(function (v) { return String(v.rawUrl || '').split('?')[0] === k || String(v.hosted || '').split('?')[0] === k; });
  }
  function lineUsed185(id) { id = String(id || ''); return !!id && st.versions.some(function (v) { return v.lineId === id; }); }
  function senseiWaitChanged(prevUrl, prevRev, cb, maxMs) {
    var start = Date.now();
    (function tick() {
      senseiPoll().then(function (mine) {
        var done = mine && mine.mockup_url && (mine.status === 'complete' || mine.status === 'ready');
        var changed = done && (mine.mockup_url !== prevUrl || (mine.revision_count || 0) > prevRev);
        /* C185b: measured on staging — the regenerate's OWN line comes back `complete` carrying the PREVIOUS render's
           URL for several seconds before the fresh render replaces it (every fresh render lands under a NEW ranklab
           session id). A URL the customer already has is therefore never the new proof, whichever line carries it. */
        if (changed && seenRender185(mine.mockup_url)) changed = false;
        if (changed) cb(null, mine);
        else if (mine && (mine.status === 'error' || mine.error)) cb(new Error(mine.error || 'render error'));
        else if (Date.now() - start > (maxMs || 240000)) cb(new Error('revision timed out'));
        else npTick(tick, 2000);
      }).catch(function () {
        if (Date.now() - start > (maxMs || 240000)) cb(new Error('revision timed out'));
        else npTick(tick, 2000);
      });
    })();
  }
  function senseiWaitReady(cb, maxMs) {
    /* B88 (2026-08-25) — SURVIVE A SUSPENDED TAB. Two bugs made "leave the page
       and come back" fatal, which is why Safari sat on "Rendering" while the
       backend was healthy (sessions created, renders COMPLETE in 22-25s, polls
       reaching origin):
       1. The budget was WALL CLOCK. Background the tab for two minutes and the
          first poll on return sees >95s elapsed and reports "render timed out"
          for a render that actually succeeded. Hidden time is now EXCLUDED, so
          the budget only counts time the page could actually work.
       2. Nothing re-polled on return — it waited for a tick that a suspended
          tab may never deliver. Coming back to the tab now fires a poll
          IMMEDIATELY (guarded by inFlight so it cannot double-poll).
       Justin has reported the leave-and-return failure since the start:
       "if I leave the browser and come back it's frozen and then the whole
       screen goes blank". */
    var start = Date.now();
    var hidden = 0, hidAt = (document.visibilityState === 'hidden') ? Date.now() : 0;
    var fin = false, inFlight = false;
    var elapsed = function () {
      return Date.now() - start - hidden - (hidAt ? (Date.now() - hidAt) : 0);
    };
    var onVis = function () {
      if (document.visibilityState === 'hidden') { if (!hidAt) hidAt = Date.now(); return; }
      if (hidAt) { hidden += Date.now() - hidAt; hidAt = 0; }
      if (!fin && !inFlight) tick(); /* woke up — check RIGHT NOW */
    };
    var done = function (e, m) {
      if (fin) return;
      fin = true;
      try { document.removeEventListener('visibilitychange', onVis); } catch (eR) {}
      cb(e, m);
    };
    try { document.addEventListener('visibilitychange', onVis); } catch (eA) {}
    function tick() {
      if (fin) return;
      inFlight = true;
      senseiPoll().then(function (mine) {
        inFlight = false;
        /* the render statuses are pending/processing -> complete | error
           ("ready" was only ever a UI state in the proof-preview bundle) */
        var ok = mine && mine.mockup_url && (mine.status === 'complete' || mine.status === 'ready');
        if (ok) done(null, mine);
        else if (mine && (mine.status === 'error' || mine.error)) done(new Error(mine.error || 'render error'));
        else if (elapsed() > (maxMs || 240000)) done(new Error('render timed out'));
        else npTick(tick, elapsed() < 8000 ? 1200 : 2500); /* tight cadence early — most renders land ~10s */
      }).catch(function (e) {
        inFlight = false;
        if (elapsed() > (maxMs || 240000)) done(e);
        else npTick(tick, 2000);
      });
    }
    tick();
  }

  /* ---- proof compositing (canvas — offline fallback only) ---- */
  function compositeProof(cb) {
    var art = artworkUrl();
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var W = 900, H = 900;
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var ctx = cv.getContext('2d');
        var geom = null;
        (CFG.shapes || []).forEach(function (s) { if (s.label === st.shape) geom = s.geom; });
        var bg = (st.bg && st.bg.hex) ? st.bg.hex : '#ffffff';
        var thread = st.thread ? st.thread.hex : '#0C0C0E';
        var ring = 26;

        function drawShapePath(pad) {
          ctx.beginPath();
          if (geom === 'circle') ctx.arc(W / 2, H / 2, W / 2 - pad, 0, Math.PI * 2);
          else if (geom === 'oval') ctx.ellipse(W / 2, H / 2, W * 0.38 - pad, H * 0.48 - pad, 0, 0, Math.PI * 2);
          else if (geom === 'rectangle') roundRect(ctx, pad + 30, H * 0.18 + pad, W - 2 * (pad + 30), H * 0.64 - 2 * pad, 28);
          else roundRect(ctx, pad, pad, W - 2 * pad, H - 2 * pad, 28); /* square */
          ctx.closePath();
        }
        function roundRect(c, x, y, w, h, r) {
          c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r);
          c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r);
        }
        function drawArtContained(x, y, w, h) {
          var r = Math.min(w / img.width, h / img.height);
          var dw = img.width * r, dh = img.height * r;
          ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
        }

        if (geom === 'custom' || !geom) {
          /* silhouette of the art: draw art, then stroke via shadow ring */
          ctx.save();
          ctx.shadowColor = thread; ctx.shadowBlur = 0;
          var off = 10;
          [[off,0],[-off,0],[0,off],[0,-off],[off,off],[-off,-off],[off,-off],[-off,off]].forEach(function (d) {
            ctx.shadowOffsetX = d[0]; ctx.shadowOffsetY = d[1];
            drawArtContained(60, 60, W - 120, H - 120);
          });
          ctx.restore();
          drawArtContained(60, 60, W - 120, H - 120);
        } else {
          /* thread ring */
          drawShapePath(6); ctx.fillStyle = thread; ctx.fill();
          /* background */
          drawShapePath(6 + ring); ctx.fillStyle = bg; ctx.fill();
          /* artwork clipped + contained inside the background area */
          ctx.save(); drawShapePath(6 + ring); ctx.clip();
          var inset = 6 + ring + 40;
          drawArtContained(inset, inset, W - 2 * inset, H - 2 * inset);
          ctx.restore();
        }
        cb(null, cv);
      } catch (err) { cb(err); }
    };
    img.onerror = function () { cb(new Error('artwork load failed')); };
    img.src = art;
  }

  function canvasPngBlob(canvas) {
    /* toBlob callbacks can be DEFERRED FOREVER on hidden/backgrounded pages
       (Chromium) — dataURL->Blob is synchronous and always completes */
    try {
      var dU = canvas.toDataURL('image/png');
      var bin = atob(dU.split(',')[1]);
      var arr = new Uint8Array(bin.length);
      for (var iB = 0; iB < bin.length; iB++) arr[iB] = bin.charCodeAt(iB);
      return new Blob([arr], { type: 'image/png' });
    } catch (eB) { return null; }
  }
  function hostProof(canvas, version, cb) {
    if (typeof window.getPresignedUploadUrl !== 'function') { cb(null, ''); return; }
    var blob = canvasPngBlob(canvas);
    if (!blob) { cb(null, ''); return; }
    var name = 'ai-proof-v' + version + '____image_' + Date.now() + '_' + Math.floor(Math.random() * 1000) + '.png';
    window.getPresignedUploadUrl(name, 'image/png').then(function (p) {
      if (!p || !p.url) { cb(null, ''); return; }
      return npPut(p.url, blob).then(function () { cb(null, p.sourceUrl || ''); });
    }).catch(function () { cb(null, ''); });
  }

  function formProp(name) {
    var el = document.querySelector('product-form.product-form form [name="properties[' + name + ']"]');
    return el ? el.value : '';
  }
  function stripBlockedProps(o) {
    if (!o) return o;
    Object.keys(o).forEach(function (kB) { if (propBlocked(kB) || !propKept(kB)) delete o[kB]; });
    return o;
  }
  function lineSync(extra) {
    stripBlockedProps(extra);
    /* notes entered AFTER the item was added only exist on the form —
       mirror them (plus anything in `extra`) onto the cart line itself so
       they actually reach the order */
    if (!sensei.added) return Promise.resolve();
    return cartJson().then(function (cart) {
      var line = ourCartLine(cart);
      if (!line) return;
      var props = {};
      Object.keys(line.properties || {}).forEach(function (k) { props[k] = line.properties[k]; });
      /* AI Edit stays out: the edited artwork is the record, not the prompt */
      ['Design Notes', '_Revision Notes'].forEach(function (k) {
        var v = formProp(k);
        if (v) props[k] = v;
      });
      delete props['AI Edit'];
      Object.keys(extra || {}).forEach(function (k) {
        /* the composed build sheet must never be downgraded back to a plain
           image by a late fixer pass */
        if ((k === '_AI Proof' || k === '_Upload') && /--spec-dk/.test(String(props[k] || '')) && !/--spec-dk/.test(String(extra[k] || ''))) return;
        props[k] = extra[k];
      });
      if (digitalNoRender()) delete props['_AI Proof'];
      props = orderPropsObj(props);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        /* PROPERTY mirror only — the LINE's own quantity is preserved. This
           helper fires from lingering builder tabs (notes, toggles, late
           promises); imposing st.qty here was silently resetting quantities
           the customer had already changed on the cart page. */
        body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: props })
      }).then(function (r) { return r.json(); }).then(function (c2) { ourCartLine(c2); });
    }).catch(function (e) { console.warn('[np-emb2] line sync failed', e); });
  }

  /* ---- proof modal ---- */
  var pf = $('#np-e2-proof');
  /* revisions are UNLIMITED (2026-08-18): customers may keep editing selections
     and regenerating until they are happy. Kept as a function so the old call
     sites stay valid. */
  function regensLeft() { return 999; }
  function showPageLoader(msg) {
    /* plain full-page loader — the skip/digital path never shows the AI
       generation checklist */
    var ov = document.getElementById('np-e2-pageloader');
    if (!ov) {
      ov = document.createElement('div');
      ov.id = 'np-e2-pageloader';
      ov.className = 'np-e2-ov np-e2-ov--loader';
      ov.innerHTML = '<div class="np-e2-pl"><i class="np-e2-pl-spin"></i><b></b></div>';
      document.body.appendChild(ov);
    }
    ov.querySelector('b').textContent = msg || 'Loading\u2026';
    ov.hidden = false;
    /* VEIL WATCHDOG (Justin 2026-08-24, "stop covering my flow in white"):
       no veil may EVER outlive its work. Whatever loses its hide call \u2014 a
       dead host callback, a dropped promise \u2014 the veil clears itself and the
       finished page underneath is usable. Every show re-arms it. */
    try { clearTimeout(showPageLoader.__wd); } catch (eW1) {}
    showPageLoader.__wd = setTimeout(function reWd() {
      /* an ACTIVE checkout owns its veil for as long as the add genuinely
         runs (22s server adds measured) — everything else clears at 8s.
         C72: but coBusy may never come back down when a flow dies mid-chain
         (the stranded add-another loader) — defer at most ~60s, then the
         standing rule wins: no veil EVER outlives its work. */
      reWd.__n = (reWd.__n || 0) + 1;
      if (typeof coBusy !== 'undefined' && coBusy && reWd.__n < 20) { showPageLoader.__wd = setTimeout(reWd, 3000); return; }
      hidePageLoader();
    }, 8000);
  }
  function hidePageLoader() {
    try { clearTimeout(showPageLoader.__wd); } catch (eW2) {}
    var ov = document.getElementById('np-e2-pageloader');
    if (ov) ov.hidden = true;
  }
  /* TAB-RETURN SAFETY (Justin 2026-08-24, mobile): leave the page mid-flow
     and come back — any veil that was up when the tab froze is an orphan
     (its work either finished throttled or died with the freeze). Give it
     3s after return, then clear unless a checkout is actively running. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    /* returning to the tab: a preview compose that froze while hidden gets
       cleared and repainted IMMEDIATELY — no waiting out the throttle backlog
       (Justin 2026-08-24: "major delay on the digital preview when I come back") */
    try {
      if (renderMaskPreview.__busy && Date.now() - (renderMaskPreview.__busyAt || 0) > 4000) {
        renderMaskPreview.__busy = false;
        renderMaskPreview.__again = false;
        ++maskPrevSeq;
      }
      if (document.body.classList.contains('np-e2-active') && !st.proofApproved && !renderMaskPreview.__busy) renderMaskPreview();
    } catch (eRV) {}
    var ovV = document.getElementById('np-e2-pageloader');
    if (!ovV || ovV.hidden) return;
    try { clearTimeout(showPageLoader.__wd); } catch (eV1) {}
    showPageLoader.__wd = setTimeout(function () { if (!coBusy) hidePageLoader(); }, 3000);
  });
  function showProofLoading(desc) {
    pf.hidden = false;
    var hn = document.getElementById('np-e2-pf-headnotice');
    if (hn) hn.hidden = true;
    $('#np-e2-pf-title').textContent = 'Generating your proof';
    $('#np-e2-pf-loading').hidden = false;
    $('#np-e2-pf-ready').hidden = true;
    var er = $('#np-e2-pf-error'); if (er) er.hidden = true;
    var sz = $('#np-e2-pf-sizing'); if (sz) sz.hidden = true;
    var eb = $('#np-e2-pf-eyebrow'); if (eb) eb.textContent = 'AI PROOF';
    var panel = pf.querySelector('.np-e2-modal'); if (panel) panel.classList.remove('is-sizing');
    st.proofPhase = 'loading';
    sensei.__versionsAtLoad186 = st.versions.length; /* C186: the reveal watchdog may only reveal a version that lands DURING this render */
    startFunStatus();
    var etaEl = document.querySelector('.np-e2-pf-eta');
    if (etaEl) {
      /* nano (theme B) really does finish in 12-15s — promise what each
         engine delivers, same file on both themes (A/B parity, 2026-08-24) */
      etaEl.textContent = genOn() ? 'Usually takes 15–20 seconds.' : 'Usually takes 20–25 seconds.';
      /* C217 (Justin 2026-09-15, "make sure info is being communicated to customers so they don't feel stuck"): the
         renderer now re-renders a flagged proof at HIGHER quality (fine lettering), so a render can legitimately run
         60–120 s. Tell the customer what is happening at each stage instead of leaving one "taking longer" line up.
         One token per loading run — an older run's timers must not write over a newer one. */
      var tok217 = (showProofLoading.__tok217 = (showProofLoading.__tok217 || 0) + 1);
      /* the grey .np-e2-pf-eta line is display:none on the live theme (np-emb2.css) — the customer-visible status is the green
         "keep this page open" pill, so the stages write THERE (and restore its default at the start of every run) */
      var stay217 = document.querySelector('#np-e2-pf-loading .np-e2-pf-stay b');
      var STAY_DEFAULT217 = 'Please keep this page open while your proof renders.';
      if (stay217) stay217.textContent = STAY_DEFAULT217;
      var stage217 = function (ms, txt) {
        setTimeout(function () {
          if (st.proofPhase !== 'loading' || showProofLoading.__tok217 !== tok217) return;
          etaEl.textContent = txt;
          if (stay217) stay217.textContent = txt;
        }, ms);
      };
      stage217(18000, 'Still stitching — taking a little longer than usual. Please keep this page open.');
      stage217(32000, 'Still working: designs with fine lettering or detail get a second, higher-quality pass. This can take another minute or two — please keep this page open.');
      stage217(95000, 'Almost there. If the render can\u2019t finish, we\u2019ll show your digital preview instead and a ' + NP_NOUN + ' specialist will email your proof by hand.');
    }
  }
  /* keep them smiling while the machine does its thing — no option recap */
  /* jokes match the MATERIAL being made (Justin 2026-08-24): no felt or
     thread gags on rubber, leather, silicone, printed or flex renders */
  var FUN_GENERIC = [
    'Inspecting every detail with a comically large magnifying glass…',
    'Politely shooing the lint away…',
    'Double-checking everything for good luck…',
    'Teaching a ninja patience. Slowly…'
  ];
  var FUN_BY_KIND = {
    stitch: [
      'Threading the world’s tiniest needle…',
      'Negotiating with the thread spools…',
      'Teaching a ninja to sew blindfolded…',
      'Counting stitches. Twice. Lost count. Again…',
      'Untangling exactly one (1) very dramatic knot…',
      'Convincing the border to stay in its lane…',
      'Asking the twill very politely to hold still…',
      'Sharpening scissors to ninja specification…',
      'Double-knotting for good luck…'
    ],
    woven: [
      'Threading the loom with microscopic thread…',
      'Counting warp and weft. Twice…',
      'Convincing ten thousand threads to cooperate…',
      'Weaving your pixels into fabric…',
      'Tuning the loom to ninja pitch…',
      'Sharpening scissors to ninja specification…'
    ],
    leather: [
      'Warming up the laser (it likes to stretch first)…',
      'Polishing the hide to ninja standard…',
      'Calibrating the etch depth to the millimeter…',
      'Asking the leather very politely to hold still…',
      'Burning in your artwork, one careful pass at a time…',
      'Buffing the edges for good luck…'
    ],
    molded: [
      'Carving the mold with ninja precision…',
      'Mixing colors to the exact drop…',
      'Pouring very carefully. Very, very carefully…',
      'Asking the mold very politely to let go…',
      'Smoothing each layer with a tiny squeegee…',
      'De-bubbling the pour for good luck…'
    ],
    printed: [
      'Loading inks one pixel at a time…',
      'Color-matching to the nearest nanometer…',
      'Convincing the printer it CAN do photo-real…',
      'Asking the ink very politely to dry faster…',
      'Heat-setting the colors for good luck…',
      'Cutting edges sharper than a ninja star…'
    ],
    flex: [
      'Polishing the finish to ninja standard…',
      'Pressing at exactly the right temperature…',
      'Asking the vinyl very politely to lie flat…',
      'Cutting edges sharper than a ninja star…',
      'Buffing out one (1) very dramatic smudge…'
    ],
    chenille: [
      'Fluffing the chenille to regulation fluffiness…',
      'Looping yarn like a tiny rollercoaster…',
      'Asking the felt very politely to hold still…',
      'Combing the pile with a very small comb…',
      'Counting loops. Twice. Lost count. Again…'
    ]
  };
  function funKindOf(label) {
    var L = String(label || '');
    if (/leather/i.test(L)) return 'leather';
    if (/pvc|rubber|silicone|keychain/i.test(L)) return 'molded';
    if (/flex|chrome/i.test(L)) return 'flex';
    if (/woven/i.test(L)) return 'woven';
    if (/chenille/i.test(L)) return 'chenille';
    if (/printed|full color/i.test(L)) return 'printed';
    return 'stitch';
  }
  function funStatusList() {
    /* the same kind resolution the checklist uses — conversions joke about
       what is ACTUALLY being rendered */
    var kindF = sensei.titleOverride === 'Full Color Printed Patches' ? 'Printed'
      : (sensei.titleOverride === 'Woven Patches' ? 'Woven'
      : (st.fdChoice === 'ps' ? 'Print & Stitch' : PTYPE.name));
    return (FUN_BY_KIND[funKindOf(kindF)] || FUN_BY_KIND.stitch).concat(FUN_GENERIC);
  }
  var CHECK_STEPS = ['Artwork prepared', 'Shape and colors applied', 'Matching thread colors', 'Stitching the border', 'Attaching the backing', 'Final quality inspection'];
  function currentCheckSteps() {
    /* checklist wording matches what's ACTUALLY being made — including
       conversions rendering a different type than the page's own */
    var kindL = sensei.titleOverride === 'Full Color Printed Patches' ? 'Printed'
      : (sensei.titleOverride === 'Woven Patches' ? 'Woven'
      : (st.fdChoice === 'ps' ? 'Print & Stitch' : PTYPE.name));
    var CL = {
      'Leather': ['Artwork prepared', 'Cutting the hide', 'Calibrating the laser', 'Etching your artwork', 'Finishing the edge', 'Final quality inspection'],
      'Faux Leather': ['Artwork prepared', 'Cutting the hide', 'Calibrating the laser', 'Etching your artwork', 'Finishing the edge', 'Final quality inspection'],
      'PVC / Rubber': ['Artwork prepared', 'Carving the mold', 'Mixing rubber colors', 'Pouring the PVC', 'Molding the border', 'Final quality inspection'],
      'Silicone': ['Artwork prepared', 'Carving the mold', 'Mixing silicone colors', 'Pouring the silicone', 'Molding the border', 'Final quality inspection'],
      'Printed': ['Artwork prepared', 'Color-matching your design', 'Printing at high resolution', 'Heat-setting the inks', 'Cutting the edge', 'Final quality inspection'],
      'Woven': ['Artwork prepared', 'Threading the loom', 'Weaving fine threads', 'Setting the colors', 'Finishing the border', 'Final quality inspection'],
      'Woven Label': ['Artwork prepared', 'Threading the loom', 'Weaving fine threads', 'Setting the colors', 'Cutting the edge', 'Final quality inspection'],
      'Chenille': ['Artwork prepared', 'Cutting the felt base', 'Looping chenille yarn', 'Setting the colors', 'Finishing the edge', 'Final quality inspection'],
      '3D Embroidered': ['Artwork prepared', 'Shape and colors applied', 'Laying the puff foam', 'Stitching raised layers', 'Attaching the backing', 'Final quality inspection'],
      'Print & Stitch': ['Artwork prepared', 'Shape and colors applied', 'Printing the fine detail', 'Stitching the large areas', 'Attaching the backing', 'Final quality inspection']
    };
    return CL[kindL] || CHECK_STEPS;
  }

  var funTimer = null, funIdx = 0, checkTimer = null;
  function startFunStatus() {
    var el = $('#np-e2-pf-desc');
    if (!el) return;
    clearInterval(funTimer);
    var funL = funStatusList();
    funIdx = Math.floor(Date.now() / 1000) % funL.length;
    el.textContent = funL[funIdx];
    funTimer = setInterval(function () {
      if (st.proofPhase !== 'loading') { clearInterval(funTimer); return; }
      funIdx = (funIdx + 1) % funL.length;
      el.textContent = funL[funIdx];
    }, 2600);
    /* progressive checklist (Justin 2026-08-24: "fill faster, leave only the
       last one"): every item except the LAST goes green within ~9s — well
       inside any render time — and the reveal completes the final one. Runs
       on the throttle-proof clock so a backgrounded tab keeps pace too. */
    var checks = document.querySelector('.np-e2-pf-checks');
    if (checks) {
      var stepsL = currentCheckSteps();
      checks.innerHTML = stepsL.map(function (s, i) {
        return '<span class="' + (i === 0 ? 'is-done' : 'is-wait') + '"><i></i>' + s + '</span>';
      }).join('');
      var ci = 0;
      var myChk = (startFunStatus.__chk = (startFunStatus.__chk || 0) + 1);
      (function chkStep() {
        if (myChk !== startFunStatus.__chk || st.proofPhase !== 'loading') return;
        if (ci < stepsL.length - 2) {
          ci++;
          var span = checks.querySelectorAll('span')[ci];
          if (span) span.className = 'is-done';
          npTick(chkStep, 2200);
        }
      })();
    }
  }
  function pushVersion(v) {
    if (st.proofApproved) {
      /* a new render after approval supersedes it — the customer must approve
         the version they actually want on the order */
      st.proofApproved = false;
      var ap = document.getElementById('np-e2-approved');
      if (ap) ap.hidden = true;
      clearApprovedCanvas(); /* prep tools return with the un-approval */
      renderOptions();
    }
    st.versions.push(v);
    upgradeVersionAlpha(v); /* transparent copy for display + the My Proofs catalog */
    /* with one version it's the choice; with more, the customer must pick */
    st.selected = st.versions.length === 1 ? 0 : null;
    st.proofPhase = 'ready';
    try { renderProofReady(); }
    catch (e) { console.error('[np-emb2] proof render failed', e); pf.hidden = true; }
    renderOptions(); /* keep the page button in sync ("View your proof") even if the modal was closed mid-render */
  }
  function newVersionMeta() {
    /* artUsed: the upload this version was built from, captured at version
       creation — the per-version anchor for _Original Image (2026-08-24) */
    return { shape: st.shape, border: st.border, fold: st.fold, bg: st.bg, thread: st.thread, backing: st.backing, texture: st.texture, lbThick: st.lbThick, sewChannel: !!st.sewChannel /* C538 */, ttStitch: st.ttStitch, qty: st.qty, w: st.w, h: st.h, corners: st.corners, opts: optSnapshot(), /* C194: the selections list reads the PICKED version */ letters: letterSnapshot(), artZoom: st.artZoom || 1, artDx: st.artDx || 0, artDy: st.artDy || 0, artUsed: cleanUrl(sensei.artAtRender || '') || cleanUrl(artworkUrl()) };
  }
  function compositeFallback() {
    /* offline fallback when the patch-sensei render is unreachable */
    var t0 = Date.now();
    compositeProof(function (err, canvas) {
      var v = newVersionMeta();
      v.dataUrl = err ? '' : canvas.toDataURL('image/png');
      v.hosted = ''; v.rev = 0; v.fallback = true;
      if (canvas) hostProof(canvas, st.versions.length + 1, function (_e, url) { v.hosted = url ? toImgixHost(url) : ''; });
      var wait = Math.max(0, 2400 - (Date.now() - t0));
      setTimeout(function () { pushVersion(v); }, wait);
    });
  }
  function digitalConvert(altKind) {
    /* customer chose an INSTANT digital proof and the assessment converted
       the patch type — hand the digital proof to the target product with no
       AI render anywhere */
    pf.hidden = true;
    showPageLoader('Preparing your digital proof\u2026');
    composeAndHost().then(function () {
      var fin2 = function (hostedUrl) {
        var v = newVersionMeta();
        v.hosted = hostedUrl || '';
        v.dataUrl = sensei.composedLocal || hostedUrl || '';
        v.digital = true;
        v.fullColor = altKind !== 'ps';
        v.altKind = altKind;
        st.versions = [v];
        st.selected = 0;
        st.proofApproved = true; try { prewarmAlphaForCart(); } catch (ePW2) {}
        switchToFullColor(v);
      };
      awaitCleanHosted(fin2);
    });
  }
  /* ═══ C136 (2026-09-03, Justin — PATCH-2109017 lines 4-10): "we always need
     the digital mockup to come through even if the spec sheet isn't ready ...
     the image needs to always be there ... whether it's first or add another".
     The digital lane draws the preview LOCALLY and hosts the clean copy in the
     background (composeDigitalFast gives it a 2.5s grace). "Upload another
     patch" banked the line the instant the next file was picked and reloaded
     the page as soon as the next upload landed — so the background host, the
     sheet compose and the late cart-line patch all died with the page, and
     _Upload / _cartImg fell back to the RAW artwork with no _Mockup Catalog
     (seven of ten lines on that order). A fast Add to Cart could lose the same
     race. Before ANY add: make sure the hosted composite exists (bounded, both
     clocks), point the digital version at it and catalog it, THEN let the
     sheets have their window. An approved AI render is already the mockup. */
  function ensureCompositeForLine(maxMs) {
    return new Promise(function (res) {
      var done = false, t0 = Date.now(), kicked = false;
      var fin = function () { if (done) return; done = true; res(sensei.composedCleanUrl || ''); };
      var curV = function () {
        if (st.selected !== null && st.selected !== undefined && st.versions[st.selected]) return st.versions[st.selected];
        return st.versions.length ? st.versions[st.versions.length - 1] : null;
      };
      try {
        if (PTYPE.noArt || document.body.classList.contains('np-e2-classic')) { fin(); return; }
        var settle = function (u) {
          try {
            var v = curV();
            if (u && v && (v.digital || v.fallbackUpload)) {
              /* the version must POINT at the hosted composite (the flow's own
                 watchdog may have fired with '' before it landed) */
              if (!v.hosted || /^data:|^blob:/.test(String(v.hosted))) v.hosted = u;
              if (v.fallbackUpload) { v.fallbackUpload = false; v.digital = true; v.dataUrl = sensei.composedLocal || u; }
              /* My Mockups catalog copy = what _Mockup Catalog carries (mcat:frozen) */
              if (!v.frozenProof && !v.__frozeStart) {
                v.__frozeStart = true;
                var left = Math.max(1200, maxMs - (Date.now() - t0));
                var fz = false;
                freezeProofCopy(u, (TYPE_KEY || 'patch') + '--digital', function (uF) { if (uF && !v.frozenProof) v.frozenProof = uF; if (!fz) { fz = true; fin(); } });
                setTimeout(function () { if (!fz) { fz = true; fin(); } }, left);
                try { coMark('c136:freeze-wait'); } catch (eM1) {}
                return;
              }
            }
          } catch (eS) {}
          fin();
        };
        var tick = function () {
          if (done) return;
          var v = curV();
          var aiRender = !!(v && !v.digital && !v.fallbackUpload && (v.alpha || v.frozenProof || v.hosted));
          if (aiRender) { fin(); return; }                       /* an approved AI render IS the mockup */
          if (sensei.composedCleanUrl) { settle(sensei.composedCleanUrl); return; }
          /* the digital flow may still be composing/hosting (it waits on art
             analysis first) — give it the window; if it FINISHED without a
             hosted copy, host one ourselves, once */
          if (v && sensei.composedCleanDone === true && !sensei.composedCleanUrl && !kicked) {
            kicked = true;
            try { coMark('c136:rehost'); composeDigitalFast(); } catch (eK) {}
          }
          if (Date.now() - t0 > maxMs) { try { coMark('c136:composite-timeout'); } catch (eM3) {} fin(); return; }
          setTimeout(tick, 250);
        };
        try { coMark('c136:composite-wait'); } catch (eM2) {}
        tick();
        npTick(fin, maxMs + 300); /* worker clock: a hidden tab must never hold the bank */
      } catch (eC) { fin(); }
    });
  }
  function waitSheetsBounded(ms) {
      return new Promise(function (res) {
        var t0 = Date.now(), want = null;
        try { want = specDkToken(specLines(specFormProps())); } catch (eW) { want = null; }
        if (!want || !NP_SPEC_SHEETS) { res(null); return; }
        var chk = function () {
          var pre = sensei.__preSheets;
          /* B99 (2026-08-25) — WAIT FOR BOTH SHEETS, not either. This read
             `(pre.ai || pre.up)`, so the first sheet to finish released the
             wait and the second landed after the add had already read the
             properties. Measured on Justin's run: pre:up-ok@78723,
             sheets-ready@78730, the add read at 78763, pre:ai-ok@78790 — the
             AI sheet missed by 60ms, which is exactly why _Upload carried its
             specs and _AI Proof did not. Wait for each sheet that was actually
             REQUESTED (aiBase/upBase say which), so neither is left behind.
             Cost of the fix on that run would have been 67ms. */
          var okAi = !pre || !pre.aiBase || !!pre.ai;
          var okUp = !pre || !pre.upBase || pre.upBase === pre.aiBase || !!pre.up; /* C460: one shared base = ONE job (upA falls back to the AI sheet) */
          if (pre && pre.dk === want && pre.__capped && (pre.ai || pre.up || !(pre.aiBusy || pre.upBusy))) { coMark('sheets-capped:' + (Date.now() - t0) + 'ms'); res(null); return; } /* C460: a failed job is not coming — stop waiting */
          if (pre && pre.dk === want && okAi && okUp && (pre.ai || pre.up)) {
            coMark('sheets-ready:' + (Date.now() - t0) + 'ms:ai' + (pre.ai ? 'y' : 'n') + 'up' + (pre.up ? 'y' : 'n'));
            res(null); return;
          }
          if (Date.now() - t0 > ms) { coMark('sheets-timeout:' + (Date.now() - t0) + 'ms'); res(null); return; }
          setTimeout(chk, 100);
        };
        chk();
      });
  }

  function awaitCleanHosted(cbIn) {
    /* watchdog: whatever goes wrong below, the flow ALWAYS completes */
    var fired = false;
    var cb = function (u) { if (fired) return; fired = true; cbIn(u); };
    setTimeout(function () { cb(sensei.composedCleanUrl || ''); }, 6000); /* was 20s — never hold the flow */
    return awaitCleanHostedInner(cb);
  }
  function awaitCleanHostedInner(cb) {
    /* resolve a CLEAN hosted compose (transparent patch: border, colors,
       merrow). sensei.composedUrl is the GREY-STAGED renderer reference --
       it exists only so the AI never cuts to the artwork silhouette, and
       must never reach a customer-facing surface or an order property. */
    var tries = 0;
    (function tickC() {
      if (sensei.composedCleanUrl) { cb(sensei.composedCleanUrl); return; }
      if (!sensei.composedCleanDone && tries++ < 20) { setTimeout(tickC, 300); return; }
      try {
        composePatchImage(function (cv2) {
          if (!cv2) { cb(''); return; }
          hostProof(cv2, 'digital' + (Date.now() % 100000), function (e4, u4) {
            if (u4) sensei.composedCleanUrl = toImgixHost(u4);
            cb(sensei.composedCleanUrl || '');
          });
        }, 1200);
      } catch (e5) { cb(''); }
    })();
  }
  function monoBackdropHex() {
    /* the stage tone the matte finishes present against, WITHOUT the '#' —
       imgix flattens transparency onto it so the thumbnail keeps the same
       look in the cart, at checkout and on the order as it has in the
       builder (a white patch on a transparent thumb reads as blank) */
    if (!PTYPE.monoTone) return '';
    var hx = String((PTYPE.fixedBg && PTYPE.fixedBg.hex) || '').replace('#', '');
    if (hx.length !== 6) return '';
    var lum = 0.299 * parseInt(hx.substr(0, 2), 16) + 0.587 * parseInt(hx.substr(2, 2), 16) + 0.114 * parseInt(hx.substr(4, 2), 16);
    return lum > 140 ? '17181A' : 'E9E9E4';
  }
  function withMonoBackdrop(u) {
    var bgH = monoBackdropHex();
    if (!u || !bgH || !/imgix/.test(u) || /[?&]bg=/.test(u)) return u || '';
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'bg=' + bgH;
  }
  function digitalCartUrl(u) {
    /* Cart images ship TRANSPARENT — every display surface draws its own
       checkerboard behind them. This is the single choke point for the cart
       image treatment.
       When the transparent copy never landed we fall back to an OPAQUE source
       (the raw studio render, which carries a white field). Those get imgix's
       bg-remove so the cart thumb still shows the patch alone instead of a
       white box. Sources that are already transparent are left untouched —
       running bg-remove over them risks eating pale patch interiors. */
    /* transparent sources ship as-is; an OPAQUE source (raw studio render, when
       the cut did not produce an alpha copy) gets imgix bg-remove so the cart
       thumb is the patch alone instead of a white box */
    if (!u) return '';
    if (isAlphaSrc(u)) return u;
    if (!/imgix/.test(u) || /bg-remove=/.test(u)) return u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'bg-remove=true';
  }
  function startDigitalPath(withStitch) {
    /* Skip path: the digital preview becomes the proof; stitched types
       still get the photo / fine-detail assessment first */
    st.pendingProofKind = withStitch ? 'stitch' : 'digital';
    var goD = function () { digitalProofFlow(withStitch); };
    if (PTYPE.fdGate && !st.versions.length && !st.fdChoice && !st.fcConfirmed && !st.__photoCleared) {
      /* B50 (Justin: the bypass must be INSTANT — there is no generation):
         sizing opens NOW; the artwork check runs in PARALLEL and interrupts
         on top only if it actually trips. Photos still get stopped. */
      if (npGateOn() ? !st.__gateDone : !st.__artAnalyzed) { if (npGateOn()) npGateAsk(); else { try { analyzeArtwork(); } catch (eA2) { st.__artAnalyzed = true; } } } /* C134 */
      var wA2 = 0;
      (function tickB() {
        if (npGateOn() ? st.__gateDone : st.__artAnalyzed) {
          if (!st.__photoCleared && (npGateOn() ? npGateVerdictIs('photo') : fullColorLikely())) { openPhotoConfirm(); return; }
          if (!st.__photoCleared && (npGateOn() ? npGateVerdictIs('fineDetail') : fineDetailLikely())) { openFineDetailChoice(); return; }
          return;
        }
        if (wA2++ > 24) return;
        npTick(tickB, 250);
      })();
    }
    goD();
  }
  function composeDigitalFast() {
    /* digital-lane compose (Justin 2026-08-24, "20s to size & pricing"): NO
       grey AI-reference upload (that exists only for generation), and the
       clean hosted copy gets a 2.5s grace instead of a blocking wait. It
       keeps uploading in the background; digitalProofFlow patches it into
       the version, props and cart line whenever it lands. */
    return new Promise(function (resolve) {
      composePatchImage(function (cv) {
        if (!cv) { sensei.composedLocal = null; sensei.composedLocalFolded = null; sensei.composedCleanUrl = null; sensei.composedCleanDone = true; resolve(''); return; }
        try { sensei.composedLocal = cv.toDataURL('image/png'); } catch (eL) { sensei.composedLocal = null; }
        try { var fcvD181 = foldDepiction(cv); sensei.composedLocalFolded = (fcvD181 && fcvD181 !== cv) ? fcvD181.toDataURL('image/png') : null; } catch (eD181) { sensei.composedLocalFolded = null; } /* C181 */
        sensei.composedCleanUrl = null;
        sensei.composedCleanDone = false;
        var cseq = (sensei.composeSeq = (sensei.composeSeq || 0) + 1);
        var done = false;
        var fin = function () { if (!done) { done = true; resolve(sensei.composedCleanUrl || ''); } };
        hostProof(cv, 'refclean' + (Date.now() % 100000), function (e2, cu) {
          /* C13: same imgix normalisation as the other hostProof callback — an
             S3 URL here means no CORS, which kills the spec-sheet compose. */
          if (sensei.composeSeq === cseq) { sensei.composedCleanUrl = cu ? toImgixHost(cu) : null; sensei.composedCleanDone = true; }
          fin();
        });
        setTimeout(fin, 2500);
      }, null, { refOnly: 1, corners: st.corners, freeform: isFreeFormShape() });
    });
  }
  function digitalProofFlow(withStitch) {
    /* no AI render — the composed digital preview IS the proof */
    st.proofMode = withStitch ? 'stitch' : 'digital';
    setProp('_Proof Preference', withStitch ? 'REAL STITCHOUT REQUESTED ($19.99)' : 'DIGITAL PROOF (no AI render)');
    pf.hidden = true;
    showPageLoader('Preparing your digital proof\u2026');
    /* sizing opens INSTANTLY off the preview already on screen (Justin
       2026-08-24: "we already have it while they're building it") — the
       fresh compose + hosting run entirely in the background and upgrade
       the version, props and cart line as they land. */
    var quickPrev = '';
    try {
      var pvQ = document.querySelector('.np-e2-maskprev img');
      if (pvQ && pvQ.src) quickPrev = previewFlatSrc(pvQ); /* C168: the quick digital proof / _Upload base is the FLAT label */
      if (!quickPrev && sensei.composedLocal) quickPrev = sensei.composedLocal;
      if (!quickPrev) { var aQ = document.getElementById('np-e2-artimg'); if (aQ && aQ.src && aQ.naturalWidth > 0) quickPrev = aQ.src; }
    } catch (eQP) {}
    try { coMark(quickPrev ? 'skip-quick' : 'skip-noprev'); } catch (eQB) {}
    var bgCompose = composeDigitalFast();
    Promise.race([bgCompose, new Promise(function (resQ) { npTick(function () { resQ(''); }, quickPrev ? 200 : 2500); })]).then(function (hostedFast) {
      var finishD = function (hostedUrl) {
        var v = newVersionMeta();
        v.dataUrl = sensei.composedLocal || hostedUrl || quickPrev || cleanUrl(artworkUrl()) || '';
        v.hosted = hostedUrl || '';
        v.rev = 0;
        v.digital = true;
        st.versions = [v];
        st.selected = 0;
        st.proofApproved = true; try { prewarmAlphaForCart(); } catch (ePW2) {}
        /* the cart image is the HOSTED digital preview — never a data URL,
           never the raw upload */
        if (hostedUrl) setProp('_cartImg', digitalCartUrl(hostedUrl));
        if (hostedUrl) freezeProofCopy(hostedUrl, (TYPE_KEY || 'patch') + '--digital', function (fzD) {
          /* the frozen copy IS the approved digital proof — writing it to
             _AI Proof puts the catalog filename on the ORDER, which is what
             lets My Mockups mark a purchased digital mockup as Purchased */
          if (!fzD) return;
          v.frozenProof = fzD;
          /* the catalog filename still reaches the ORDER (My Mockups marks a
             purchased digital mockup by it) — but in its own hidden property:
             a digital order must not show _AI Proof (Justin 2026-08-24) */
          setProp('_Mockup Catalog', fzD);
          setProp('_AI Proof', '');
          if (sensei.added) lineSync({ '_Mockup Catalog': fzD });
        });
        /* no AI proof = no status line: "DIGITAL PREVIEW APPROVED - no AI
           proof generated" read as noise on the order. _Proof Approval and
           _Proof Preference already tell the whole story. */
        setProp('_AI Proof Status', withStitch ? 'DIGITAL PREVIEW - REAL STITCHOUT requested ($19.99)' : '');
        commitOptions();
        commitSizeQty();
        renderOptions();
        /* approved summary fields — approveProof never runs on this path */
        var apD = document.getElementById('np-e2-approved');
        if (apD) apD.hidden = false;
        var thD = document.getElementById('np-e2-cart-thumb');
        if (thD) thD.src = hostedUrl || v.dataUrl;
        var tbD = document.querySelector('.np-e2-cartrow__thumb');
        if (tbD) { tbD.classList.add('is-alpha'); tbD.classList.add('is-digital'); } /* transparent compose on a plain grey card */
        var lineD = document.getElementById('np-e2-cart-line');
        if (lineD) lineD.textContent = [
          PTYPE.textLines ? null : v.shape,
          PTYPE.textLines && st.font ? st.font.label : null,
          PTYPE.textLines && st['opt' + (PTYPE.layersOpt || 2)] ? st['opt' + (PTYPE.layersOpt || 2)].label : null,
          st.border ? st.border.label + ' border' : null,
      (stepEnabled('fold') && st.fold) ? st.fold.label : null, /* C164 */
          v.bg ? v.bg.label + (PTYPE.textLines ? ' letters' : (isLeather() ? '' : ' background')) : null,
          v.thread ? v.thread.label + (PTYPE.textLines ? ' outline' : ' thread') : null,
          PTYPE.stitches ? (st.ttStitch || 'Zig Zag') + ' stitch' : null,
          v.backing ? v.backing.label : null,
          withStitch ? 'Real stitchout requested' : 'Digital proof'
        ].filter(Boolean).join(' \u00b7 ');
        var pflD = document.getElementById('np-e2-prooffile');
        if (pflD) pflD.textContent = withStitch ? 'digital-proof.png (real stitchout to follow)' : 'digital-proof.png';
        var coID = document.querySelector('.np-e2-checkoutrow i');
        if (coID) coID.textContent = withStitch ? 'A real stitched sample is produced and photographed for your approval first (adds 2-4 business days).' : 'Your digital preview is your proof above.';
        var crID = document.querySelector('.np-e2-cartrow__mid i');
        if (crID) crID.textContent = 'Your original upload and your digital preview both attach to this order.';
        try { renderApprovedCanvas(); } catch (eD1) {}
        renderSizing();
      };
      finishD(hostedFast || '');
      if (!hostedFast) (function lateTick(nT) {
        /* the hosted copy is still uploading — patch it in when it lands so
           the cart image / catalog copy still reach the order */
        var uT = sensei.composedCleanUrl || '';
        if (uT) {
          var vT = st.versions[0];
          if (vT && vT.digital && !vT.hosted) {
            /* the fresh compose replaces the quick on-screen copy */
            if (sensei.composedLocal) { vT.dataUrl = sensei.composedLocal; try { renderApprovedCanvas(); } catch (eRC2) {} }
            vT.hosted = uT;
            setProp('_cartImg', digitalCartUrl(uT));
            if (sensei.added) lineSync({ '_cartImg': digitalCartUrl(uT) });
            var thT = document.getElementById('np-e2-cart-thumb');
            if (thT) thT.src = uT;
            freezeProofCopy(uT, (TYPE_KEY || 'patch') + '--digital', function (fzT) {
              if (!fzT) return;
              vT.frozenProof = fzT;
              setProp('_Mockup Catalog', fzT);
              setProp('_AI Proof', '');
              if (sensei.added) lineSync({ '_Mockup Catalog': fzT });
            });
          }
          return;
        }
        if (nT < 60) setTimeout(function () { lateTick(nT + 1); }, 500);
      })(0);
    });
  }
  function openProof() {
    sensei.editBase = null; /* fresh generations never ride a stale edit base */
    /* B42: the line returns to the cart at GENERATION time — the original v2
       design. Rendering takes 15-25s plus review dwell, which gives the
       background add all the headroom Shopify's wildly variable /cart/add
       latency needs (2.4s and 14.6s measured minutes apart). Approval already
       knows how to update props on an existing line; the sheets then stamp
       minutes before any click. Abandoned generations leave the line in the
       cart — the original, accepted behavior. */
    /* PRE-ADD REMOVED (B66, 2026-08-25 — Justin, twice: "ai gen is creating a
       line item before I even add it to cart", "why would anything be added to
       cart until I physically hit the add to cart button").
       This block used to fire ensureInCart() 2.5s after Generate, so the cart
       carried a line — at the SEEDED size the customer never chose — from the
       moment a proof started rendering. It bought a fast Add-to-Cart click at
       the cost of a phantom cart item, a wrong-priced line for anyone who
       abandoned, and the seed-variant duplicate when the size later crossed a
       variant boundary. The cart is now mutated in exactly ONE place:
       doCheckout, when the customer presses Add to Cart. Build sheets still
       pre-compose in the background (preComposeSheets), so the click stays
       fast without touching the cart early. */
    /* the REAL proof: patch-sensei (Shinobi's renderer). The item goes into
       the cart first (sessions are cart-token keyed), then the session is
       created with every selected option + the customer's Step-1 notes. */
    if ((PTYPE.fdGate || photoGateOn()) && !st.versions.length && !sensei.titleOverride && (npGateOn() ? !st.__gateDone : !st.__artAnalyzed)) {
      /* Patch Sensei assesses the image BEFORE anything renders */
      showProofLoading('Patch Sensei is checking your artwork first.');
      if (npGateOn()) npGateAsk(); else { try { analyzeArtwork(); } catch (eAn) { st.__artAnalyzed = true; } } /* C134 */
      var waitA = 0;
      (function tickA() {
        if ((npGateOn() ? st.__gateDone : st.__artAnalyzed) || waitA++ > 40) { openProof(); return; }
        setTimeout(tickA, 250);
      })();
      return;
    }
    if (photoGateOn() && !st.versions.length && !sensei.titleOverride && !st.__photoCleared && (npGateOn() ? npGateVerdictIs('photo') : fullColorLikely())) {
      /* photographs can't be stitched — STOP before generating and make the
         conversion explicit; the popup is the sign-off */
      if (!st.fcConfirmed) { openPhotoConfirm(); return; }
      st.fcForced = true;
      st.fcForcedReason = 'photo';
      st.fcOffered = true;
      generateFullColor();
      return;
    }
    if (PTYPE.fdGate && !st.versions.length && !sensei.titleOverride && !st.fdChoice && !st.__photoCleared && (npGateOn() ? npGateVerdictIs('fineDetail') : fineDetailLikely())) {
      /* fine detail can't be stitched either — but it has MULTIPLE viable
         productions, so the customer chooses (the modal is the sign-off).
         __photoCleared = the UPLOAD check already ran on this art — the
         customer was prompted there (or the art passed); never re-interrupt
         at Generate (Justin: detection belongs at upload) */
      openFineDetailChoice();
      return;
    }
    if (sensei.busy) return; /* one render at a time — concurrent generates duplicate versions and burn regens */
    sensei.busy = true;
    var gen = sensei.genSeq = (sensei.genSeq || 0) + 1;
    showProofLoading('Applying your artwork' + (stepEnabled('shape') && st.shape ? ', ' + st.shape + ' cut' : '') + (stepEnabled('border') && st.border ? ', ' + st.border.label + ' border' : '') + (stepEnabled('bg') && st.bg ? ', ' + st.bg.label + (isLeather() ? '' : ' background') : '') + (stepEnabled('thread') && st.thread ? ', ' + st.thread.label + ' border thread' : '') + ', and ' + (st.backing ? st.backing.label : 'selected') + ' backing.');
    /* NOTHING goes in the cart until "Add to Cart" — the session only needs
       the cart TOKEN. verify + token + composed reference run in parallel. */
    /* B75 (2026-08-25) — THE GENERATE GATE CAN NEVER HANG AGAIN.
       This Promise.all fed senseiCreate (the POST that starts a render). If ANY
       of the three never settles, the POST is never sent and the modal spins on
       "Rendering your patch" forever — with no error, because nothing rejected.
       Diagnosed from Justin's Safari session: composed=hosted, busy=true,
       versions=0, and ZERO POST /api/proof/session in the ECS logs.
       Each leg now resolves-or-reports within its own cap (never rejects), and
       marks which one stalled so np_co_log names it. A missing cart is retried
       once directly, because the session is keyed on the cart token. */
    var gate = function (p, name, ms) {
      return new Promise(function (res) {
        var done = false;
        var fin = function (v, why) { if (done) return; done = true; if (why) { try { coMark(why + ':' + name); } catch (e0) {} } res(v); };
        try { Promise.resolve(p).then(function (v) { fin(v, null); }, function (e) { fin(null, 'gate-rej'); }); }
        catch (eS) { fin(null, 'gate-threw'); }
        npTick(function () { fin(null, 'gate-stall'); }, ms);
        setTimeout(function () { fin(null, 'gate-stall2'); }, ms + 500);
      });
    };
    Promise.all([gate(verifyArtwork(), 'verify', 8000), gate(cartJson(), 'cart', 8000), gate(composeAndHost(), 'compose', 12000)])
      .then(function (r) {
        if (r[1]) return r[1];
        /* cart token is REQUIRED — one direct retry before giving up */
        try { coMark('gate-cart-retry'); } catch (eC) {}
        return cleanFetch()('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (x) { return x.json(); })
          .catch(function () { return null; });
      })
      .then(function (cart) {
        if (!cart) { try { coMark('gate-cart-FAILED'); } catch (eF) {} throw new Error('cart unavailable — please try again'); }
        return cart;
      })
      .then(function (cart) {
        sensei.renderLineId = null; sensei.lineItemId = null; sensei.forceFresh = true;
        return senseiCreate(cart);
      })
      .then(function () {
        return new Promise(function (res, rej) { senseiWaitReady(function (e, m) { e ? rej(e) : res(m); }, 60000); });
      })
      .then(function (mine) {
        var v = newVersionMeta();
        /* C137d: Free Form — cut the model's fill out of enclosed openings before the reveal */
        return npFreeFormFix(mine.mockup_url, 6000, function (lateU) { npAdoptLateFix(v, mine.mockup_url, lateU); }).then(function (fixedU) {
          var uR = fixedU || mine.mockup_url;
          v.dataUrl = uR; v.hosted = uR; v.rawUrl = String(mine.mockup_url || ''); v.lineId = String(mine.line_item_id || ''); /* C185 */ v.rev = mine.revision_count || 0;
          v.line = mine;
          v.fullColor = !!sensei.titleOverride;
          sensei.titleOverride = null;
          return new Promise(function (res) { prepareVersionDisplay(v, function () { pushVersion(v); res(); }); });
        });
      })
      .catch(function (err) {
        console.warn('[np-emb2] sensei proof failed', err);
        sensei.titleOverride = null;
        pushUploadFallback(err);
        /* the ramp fired but the render is usually still cooking — keep
           listening and swap the REAL AI proof in the moment it lands */
        senseiWaitReady(function (e2, mine) {
          if (!e2 && mine && gen === sensei.genSeq) adoptLateRender(mine);
        }, 150000);
      })
      .then(function () { sensei.busy = false; });
  }
  function adoptLateRender(mine) {
    /* a render that finished after the exit ramp replaces the upload-preview
       fallback version — the customer must always end up with the AI patch */
    if (!mine.mockup_url) return;
    var idx = -1;
    st.versions.forEach(function (x, i) { if (x.fallbackUpload) idx = i; });
    if (idx === -1) return;
    var v = st.versions[idx];
    npFreeFormFix(mine.mockup_url, 6000, function (lateU) { npAdoptLateFix(v, mine.mockup_url, lateU); }).then(function (fixedU) { /* C137d */
    var uR = fixedU || mine.mockup_url;
    v.dataUrl = uR; v.hosted = uR; v.rawUrl = String(mine.mockup_url || ''); v.lineId = String(mine.line_item_id || ''); /* C185 */
    v.rev = mine.revision_count || 0; v.line = mine;
    v.fallbackUpload = false;
    v.alpha = null;
    prepareVersionDisplay(v, function () { rerenderProofPhase(); });
    if (st.selected === null || st.selected === undefined) st.selected = idx;
    if (!pf.hidden && st.proofPhase === 'ready') renderProofReady();
    else if (!pf.hidden && st.proofPhase === 'sizing') renderSizing();
    renderOptions();
    if (st.proofApproved && st.selected === idx) {
      /* they approved the fallback — upgrade the order line to the real render */
      setProp('_AI Proof', v.hosted); setProp('_cartImg', digitalCartUrl(v.alpha || v.hosted));
      setProp('_AI Proof Status', 'AI render attached');
      lineSync({ '_AI Proof': v.hosted, '_cartImg': digitalCartUrl(v.alpha || v.hosted), '_AI Proof Status': 'AI render attached', '_Proof Version': 'v' + (idx + 1) });
      var th = document.getElementById('np-e2-cart-thumb'); if (th) th.src = v.dataUrl;
      var pfl = document.getElementById('np-e2-prooffile'); if (pfl) pfl.textContent = 'ai-proof-v' + (idx + 1) + '.png';
    }
    });
  }
  function generateFullColor(altKind) {
    if (sensei.busy) return;
    sensei.editBase = null; /* FC proofs always render fresh */
    sensei.busy = true;
    var gen = sensei.genSeq = (sensei.genSeq || 0) + 1; /* invalidate any late-swap listener */
    st.fcOffered = true;
    sensei.titleOverride = altKind === 'woven' ? 'Woven Patches' : 'Full Color Printed Patches';
    sensei.renderLineId = (sensei.lineItemId || 'line') + '::fc' + (new Date().getTime() % 10000000);
    showProofLoading(altKind === 'woven' ? 'Rendering your design as a Woven Patch.' : 'Rendering your design as a Full Color Printed Patch.');
    Promise.all([verifyArtwork(), cartJson()])
      .then(function (r) { return senseiCreate(r[1], customerNotes()); })
      .then(function () {
        return new Promise(function (res, rej) { senseiWaitReady(function (e, m) { e ? rej(e) : res(m); }, 60000); });
      })
      .then(function (mine) {
        var v = newVersionMeta();
        v.dataUrl = mine.mockup_url; v.hosted = mine.mockup_url; v.rawUrl = String(mine.mockup_url || ''); v.lineId = String(mine.line_item_id || ''); v.rev = 0; v.line = mine; /* C185 */ v.fullColor = true; v.altKind = altKind === 'woven' ? 'woven' : 'fc';
        sensei.titleOverride = null;
        return new Promise(function (res) { prepareVersionDisplay(v, function () { pushVersion(v); res(); }); });
      })
      .catch(function (err) {
        console.warn('[np-emb2] full color proof failed', err);
        sensei.titleOverride = null;
        if (!st.versions.length) {
          /* forced-FC first render: NEVER strand an empty review view — show
             the upload fallback and keep listening for the real render */
          pushUploadFallback(err);
          senseiWaitReady(function (e2, mine2) {
            if (e2 || !mine2 || gen !== sensei.genSeq) return;
            adoptLateRender(mine2);
            if (st.fcForced) {
              var lv = st.versions[st.versions.length - 1];
              if (lv && !lv.fallbackUpload) { lv.fullColor = true; try { renderProofReady(); } catch (e3) {} }
            }
          }, 150000);
        } else {
          st.proofPhase = 'ready';
          renderProofReady();
        }
      })
      .then(function () { sensei.busy = false; });
  }
  function verifyArtwork() {
    /* the render MUST depict the customer's uploaded image — an unfetchable
       artwork_url makes the backend produce a demo/sample render. Confirm
       the exact URL loads before any session is created. */
    return new Promise(function (resolve, reject) {
      /* TYPED products have no upload at all: their artwork IS the composed
         lettering, hosted by composeAndHost(). Wait for that instead of failing
         with 'no artwork url' (which is what killed the tackle twill proof). */
      if (PTYPE.noArt) {
        composeAndHost().then(function () {
          var urlT = cleanUrl(sensei.composedUrl || '');
          if (!urlT) { reject(new Error('composed artwork not hosted')); return; }
          var probeT = new Image();
          probeT.onload = function () { resolve(urlT); };
          probeT.onerror = function () { reject(new Error('composed artwork not fetchable')); };
          probeT.src = urlT;
        }, function () { reject(new Error('composed artwork not hosted')); });
        return;
      }
      var url = cleanUrl(artworkUrl());
      if (!url) { reject(new Error('no artwork url')); return; }
      var probe = new Image();
      var pDone = false;
      probe.onload = function () { if (pDone) return; pDone = true; resolve(url); };
      probe.onerror = function () { if (pDone) return; pDone = true; reject(new Error('artwork not fetchable')); };
      /* B67 (2026-08-25): a STALLED request fires NEITHER event — iOS keeps the
         socket open on a flaky connection — so this promise never settled and
         NO SESSION WAS EVER CREATED. The modal then span forever while the
         checklist ticked on its own timers ("mobile refuses to render an AI
         image even if I never leave the page"). A timeout is INCONCLUSIVE, not
         a failure: the backend fetches this URL server-side and is unaffected
         by the phone's connection, so proceed. A real 404 still rejects above. */
      npTick(function () {
        if (pDone) return;
        pDone = true;
        console.warn('[np-e2] artwork probe stalled — proceeding (backend fetches server-side)');
        resolve(url);
      }, 7000);
      probe.src = url;
    });
  }
  function pushUploadFallback(err) {
    /* C198: remember WHY, so the fallback note can stay truthful without alarming anyone */
    try { window.__npFallbackReason198 = (err && err.message) ? String(err.message) : ''; } catch (eFR) {}
    /* LAST RESORT ONLY. The loader must hold until the real render lands —
       this ramp shows the customer's own upload labelled as their proof, which
       is worse than waiting. The wait was raised to 95s on 2026-08-18 when
       transparent output moved renders from ~15s to ~40s; at 40s this ramp was
       firing on perfectly good renders that arrived moments later. */
    console.warn('[np-emb2] proof render unavailable, continuing with upload', err);
    var art = cleanUrl(artworkUrl());
    /* C216 (Justin 2026-09-15, War Pigs FC: "why would the black not be showing up here?"): this ramp showed the bare
       processed ARTWORK. For a shaped patch the art's own backdrop (a black rectangle there) is flood-cut so the design sits
       on the patch base — so the Black background and Black merrow the customer chose were nowhere in the picture. Show the
       DIGITAL PREVIEW (the composed shape + colours, fold depicted) whenever it exists; the raw upload is the last resort. */
    var digital = sensei.composedLocalFolded || sensei.composedLocal || sensei.composedCleanUrl || '';
    if (!art && !digital) { showProofError(err); return; }
    var v = newVersionMeta();
    v.dataUrl = digital || art; v.hosted = ''; v.rev = 0; v.fallbackUpload = true; v.fallbackDigital = !!digital;
    pushVersion(v);
  }
  function showProofError(err) {
    $('#np-e2-pf-title').textContent = 'Review your proof';
    $('#np-e2-pf-loading').hidden = true;
    $('#np-e2-pf-ready').hidden = true;
    $('#np-e2-pf-error').hidden = false;
    var why = $('#np-e2-pf-error-why');
    if (why) why.textContent = err ? String(err.message || err).slice(0, 140) : '';
    st.proofPhase = null;
  }
  function specsChangedSince(v) {
    if (!v) return false;
    return v.shape !== st.shape ||
      (v.border && st.border && v.border.label !== st.border.label) ||
      (v.bg && st.bg && v.bg.label !== st.bg.label) ||
      (v.thread && st.thread && v.thread.label !== st.thread.label) ||
      (v.backing && st.backing && v.backing.label !== st.backing.label) ||
      (v.w != null && v.w !== st.w) || (v.h != null && v.h !== st.h) ||
      (v.opts != null && v.opts !== optSnapshot()) ||
      (v.letters != null && v.letters !== letterSnapshot()) ||
      (v.artZoom != null && Math.abs(v.artZoom - (st.artZoom || 1)) > 0.001) || /* C151: a fill or pan change is a spec change */
      (v.artDx != null && (Math.abs(v.artDx - (st.artDx || 0)) > 0.001 || Math.abs(v.artDy - (st.artDy || 0)) > 0.001)) ||
      (v.corners || 'rounded') !== (st.corners || 'rounded') ||
      (v.sewChannel != null && v.sewChannel !== !!st.sewChannel) || /* C538: adding or removing the sewing channel needs a new proof */
      ((v.fold ? v.fold.label : '') !== (st.fold ? st.fold.label : '')); /* C164b: a fold change after a render is a spec change */
  }
  function letterSnapshot() {
    /* everything the customer typed or chose about the lettering, as one
       comparable string — text, per-line layout and size, font, tail */
    if (!PTYPE.textLines) return '';
    return ttLines().map(function (l, i) {
      return l + '|' + (st['ttLay' + (i + 1)] || 'Straight') + '|' + (st['ttHalf' + (i + 1)] ? 'h' : 'f');
    }).join('~') + '~' + (st.font ? st.font.label : '') +
      '~' + (ttSwooshOn() ? ttSwooshDef(st.swooshStyle).name + ':' + String(st.swooshText || '') : '') +
      '~' + (st.ttStitch || '');
  }
  /* an approved proof stops being "approved" the moment the design changes —
     the customer must see (and approve) what they are actually ordering */
  /* C427 (PATCH-2115499): line 2 carried line 1's render as "AI Proof Approved" for a shape, border and background
     that were never rendered, because Approve accepted any selected version. A DESIGN change since a render =
     anything specsChangedSince sees except plain size; a new size counts only when the proportions change. */
  function designChangedSince(v) {
    if (!v) return false;
    var sD = {};
    for (var kD in v) { if (Object.prototype.hasOwnProperty.call(v, kD)) sD[kD] = v[kD]; }
    sD.w = null; sD.h = null;
    if (specsChangedSince(sD)) return true;
    if (v.w && v.h && st.w && st.h && Math.abs(Math.log((v.w / v.h) / (st.w / st.h))) > 0.03) return true;
    return false;
  }
  function unapproveIfChanged() {
    if (!st.proofApproved || !st.versions.length) return;
    var vA = st.versions[(st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected];
    if (!vA || !specsChangedSince(vA)) return;
    if (designChangedSince(vA)) { try { setProp('_AI Proof', ''); } catch (eUa427) {} } /* C427: no stale render on a later add */
    st.proofApproved = false;
    st.ctaRevealed = true;
    try { clearApprovedCanvas(); } catch (eU) {}
    try { renderOptions(); } catch (eU2) {}
  }
  function optSnapshot() {
    /* Layers / Lines of Text change how the piece is BUILT without moving a
       dimension, so the width/height compare above cannot see them */
    return ['opt1', 'opt2', 'opt3'].map(function (kV) {
      return (optDef(kV) && st[kV]) ? st[kV].label : '';
    }).join('|');
  }
  /* explicit color instructions in a revision note ("make the border green",
     "red background") UPDATE the selections — so the cart line, the checkout
     properties, and the recomposed reference all reflect the request */
  var NOTE_COLORS = [
    ['dark green', '#1D3C34'], ['light blue', '#69B3E7'], ['dark blue', '#003087'], ['navy', '#003087'],
    ['red', '#D6001C'], ['green', '#00843D'], ['blue', '#0057B8'], ['black', '#0C0C0E'], ['white', '#FFFFFF'],
    ['yellow', '#FFD100'], ['gold', '#A28D5B'], ['orange', '#FF6A13'], ['purple', '#582C83'], ['pink', '#E93CAC'],
    ['brown', '#6B4C35'], ['tan', '#D3BC8D'], ['grey', '#8E9089'], ['gray', '#8E9089'], ['teal', '#008C95'],
    ['maroon', '#5E2A2B'], ['silver', '#C7C9C7']
  ];
  function applyNoteSelections(note) {
    var n = ' ' + note.toLowerCase() + ' ';
    var hit = false, usedB = false, usedG = false;
    NOTE_COLORS.forEach(function (cw) {
      var w = cw[0], hex = cw[1];
      if (!usedB && new RegExp('(?:border|thread|merrow|edge|outline)[^.,;!\\n]{0,26}\\b' + w + '\\b|\\b' + w + '\\b[^.,;!\\n]{0,12}(?:border|thread|merrow|edge|outline)').test(n)) {
        st.thread = { label: pmsName(hex), hex: hex }; usedB = true; hit = true;
      }
      if (!usedG && new RegExp('(?:background|base)[^.,;!\\n]{0,26}\\b' + w + '\\b|\\b' + w + '\\b[^.,;!\\n]{0,12}(?:background|base)').test(n)) {
        st.bg = (PTYPE.noCustomBg && stockNearest471(hex, CFG.bgs)) || { label: pmsName(hex), hex: hex }; usedG = true; hit = true; /* C471: stock-only backgrounds take the nearest stock colour */
      }
    });
    /* size intents change the COMPOSITION — the reference image is the
       strongest channel to the renderer, so "make the logo smaller" must
       literally recompose smaller */
    if (/(logo|design|image|artwork|art|graphic|text|it)\b/.test(n)) {
      var z0 = st.artZoom || 1;
      if (/(smaller|shrink|reduce|tinier|too big|too large)/.test(n)) st.artZoom = Math.max(0.6, Math.round((z0 - 0.25) * 20) / 20);
      else if (/(bigger|larger|enlarge|increase|too small)/.test(n)) st.artZoom = Math.min(2.5, Math.round((z0 + 0.25) * 20) / 20);
      if (st.artZoom !== z0) { if (Math.abs((st.artZoom || 1) - 1) < 0.001) { st.artDx = 0; st.artDy = 0; } /* 100% = centred again (review 2026-09-05) */
        hit = true;
        var zs = document.getElementById('np-e2-artzoom'), zv = document.getElementById('np-e2-artzoom-val');
        if (zs) { zs.value = Math.round(st.artZoom * 100); try { paintSlider(zs); } catch (ez) {} }
        if (zv) zv.textContent = Math.round(st.artZoom * 100) + '%';
      }
    }
    if (hit) { commitOptions(); renderAccordion(); }
    return hit;
  }
  function regenerateWithNotes(note) {
    if (sensei.busy) return;
    sensei.busy = true;
    var gen = sensei.genSeq = (sensei.genSeq || 0) + 1; /* invalidate any late-swap listener */
    var prev = st.versions[st.versions.length - 1] || {};
    showProofLoading('Applying your notes and re-rendering your patch.');
    /* quick edit (note only, selections unchanged): pass the CURRENT render
       as the edit base — the renderer re-edits it with high input fidelity,
       so "remove the small text" style requests actually land instead of
       fighting the redraw-from-artwork fidelity rules */
    var editV = st.versions[(st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected] || prev;
    sensei.editBase = (note && !specsChangedSince(prev) && editV && editV.hosted && !editV.fallbackUpload)
      ? { url: String(editV.hosted).split('?')[0], note: note }
      : null;
    /* converted sessions REVISE in the converted style — a revision must
       never silently fall back to an embroidered render */
    var convKind = (editV && editV.fullColor) ? (editV.altKind || 'fc') : ((prev && prev.fullColor) ? (prev.altKind || 'fc') : null);
    if (convKind) sensei.titleOverride = convKind === 'woven' ? 'Woven Patches' : 'Full Color Printed Patches';
    /* keep every revision request on the order too — C144: ONLY when the customer
       actually wrote one. A selections-only regenerate is not a revision; it used to
       file "v2: " (an empty note) and flip the footer to "Submit with Revisions". */
    var noteT = String(note || '').trim();
    if (noteT) {
      var el = document.querySelector('input[name="properties[_Revision Notes]"]');
      var existing = el ? el.value : '';
      setProp('_Revision Notes', (existing ? existing + ' | ' : '') + 'v' + (st.versions.length + 1) + ': ' + noteT);
      lineSync();
    }
    if (sensei.sessionId || st.versions.length) {
      var diffs = 'Updated selections: ' + [st.shape, stepEnabled('fold') && st.fold && st.fold.label + ' fold' /* C164c */, st.border && normalizeBorder(st.border.label), st.bg && st.bg.label + ' background', st.thread && st.thread.label + ' thread', st.backing && st.backing.label].filter(Boolean).join(', ') + '.';
      var fullNote = note ? (specsChangedSince(prev) ? diffs + ' ' + note : note) : diffs;
      sensei.renderLineId = (sensei.lineItemId || (sensei.syntheticId = sensei.syntheticId || ('npe2-' + Date.now()))) + '::v' + (st.versions.length + 1);
      composeAndHost() /* the regen must submit the CURRENT selections' composition, not the prior one */
        .then(function () { return cartJson(); })
        .then(function (cart) { return senseiCreate(cart, fullNote); })
        .then(function () {
          return new Promise(function (res, rej) { senseiWaitChanged(prev.hosted || '', -1, function (e, m) { e ? rej(e) : res(m); }, 60000); });
        })
        .then(function (mine) {
          var v = newVersionMeta();
          return npFreeFormFix(mine.mockup_url, 6000, function (lateU) { npAdoptLateFix(v, mine.mockup_url, lateU); }).then(function (fixedU) { /* C137d */
            var uR = fixedU || mine.mockup_url;
            v.dataUrl = uR; v.hosted = uR; v.rawUrl = String(mine.mockup_url || ''); v.lineId = String(mine.line_item_id || ''); /* C185 */ v.rev = mine.revision_count || 0;
            if (convKind) { v.fullColor = true; v.altKind = convKind; }
            sensei.titleOverride = null;
            return new Promise(function (res) { prepareVersionDisplay(v, function () { pushVersion(v); res(); }); });
          });
        })
        .catch(function (err) {
          console.warn('[np-emb2] sensei revision failed', err);
          sensei.titleOverride = null;
          pushUploadFallback(err);
          /* same as first-generation: keep listening and swap the real
             render in over the fallback the moment it lands */
          senseiWaitChanged(prev.hosted || '', -1, function (e2, m2) {
            if (!e2 && m2 && gen === sensei.genSeq) adoptLateRender(m2);
          }, 150000);
        })
        .then(function () { sensei.busy = false; });
    } else {
      /* no session yet (e.g. earlier failure) — run a fresh generation */
      sensei.busy = false;
      openProof();
    }
  }
  /* ═══ C224 (2026-09-16, Justin: "when they get to their proof they can easily show their patch on a hat or a polo and that hat
     or polo can be any color the user wants with a color picker — that would show on the AI proof side of the slider"). STAGING
     CONCEPT. The garment photo bases + any-colour tint + placement live in assets/np-wear.js (window.NPWear); this is the review
     modal chrome: a "See this on a: Patch | Hat | Polo" control above the stage, a colour row (stock swatches + the wheel) and a
     garment layer BEHIND the proof image, so it shows on the AI PROOF side of the compare slider only. Cosmetic — never an order
     property. "Patch" leaves the stage byte-identical to before. ═══ */
  function wearEsc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var WEAR_SWATCHES = [['White', '#ffffff'], ['Black', '#0C0C0E'], ['Navy', '#1f3a6e'], ['Heather Gray', '#9ca3af'], ['Charcoal', '#4b5563'], ['Royal', '#1d4ed8'], ['Red', '#b91c1c'], ['Forest', '#14532d'], ['Maroon', '#7f1d1d'], ['Sand', '#d6c7a1'], ['Orange', '#ea580c'], ['Purple', '#4b2e83']];
  function wearState() { if (!st.wear) st.wear = { mode: 'patch', color: {}, place: {} }; return st.wear; }
  /* the review comes BEFORE sizing on the standard flow, so st.w is only a seed there: until the customer has actually picked a size the
     patch shows at the LARGEST size the placement's max print area allows (Justin 2026-09-16 "carry over the max print area sizes") */
  function wearSizeChosen() { return !!((pdpPricingOn() || (sizeFirstOn() && st.__sizeEntered)) && st.w > 0); } /* C229: a size entered before the proof is a chosen size */
  function wearColorFor(key) { var w = wearState(); return w.color[key] || '#ffffff'; } /* Justin 2026-09-16: "default all garments on white color" */
  function wearToolbarHtml() {
    var w = wearState(), g = w.mode === 'patch' ? null : w.mode, G = g && window.NPWear ? NPWear.garment(g) : null, cur = g ? String(wearColorFor(g)).toLowerCase() : '';
    var items = [['patch', 'Patch']].concat((window.NPWear ? NPWear.catalog() : []).map(function (x) { return [x.key, x.label]; })); /* C224e: garments come from the Ninja Size Helper app (fallback: the built-in hat + polo) */
    var seg = items.map(function (o) { return '<button type="button" role="tab" data-e2-wear="' + wearEsc(o[0]) + '" class="' + (w.mode === o[0] ? 'is-on' : '') + '" aria-selected="' + (w.mode === o[0] ? 'true' : 'false') + '">' + wearEsc(o[1]) + '</button>'; }).join('');
    var stock = WEAR_SWATCHES.map(function (c) { return '<button type="button" class="np-e2-pf-wear__sw' + (cur === c[1].toLowerCase() ? ' is-on' : '') + '" data-e2-wear-color="' + c[1] + '" title="' + c[0] + '" aria-label="' + c[0] + '"><i style="background:' + c[1] + '"></i></button>'; }).join('');
    var isCustom = g && !WEAR_SWATCHES.some(function (c) { return c[1].toLowerCase() === cur; });
    var places = (G && G.kind === 'tile' && G.zones.length > 1) ? '<div class="np-e2-pf-wear__row np-e2-pf-wear__places"><span class="np-e2-pf-wear__lab">Placement</span><div class="np-e2-pf-wear__seg" role="tablist">' + G.zones.map(function (z, i) { var on = (w.place[g] || G.zones[0].placement) === z.placement; return '<button type="button" role="tab" data-e2-wear-place="' + wearEsc(z.placement) + '" class="' + (on ? 'is-on' : '') + '">' + wearEsc(z.placement.charAt(0).toUpperCase() + z.placement.slice(1).toLowerCase()) + '</button>'; }).join('') + '</div></div>' : '';
    return '<div class="np-e2-pf-wear__row"><span class="np-e2-pf-wear__lab">See this on a:</span><div class="np-e2-pf-wear__seg" role="tablist" aria-label="Show the proof on">' + seg + '</div></div>' + places +
      '<div class="np-e2-pf-wear__colors"' + (g ? '' : ' hidden') + '><span class="np-e2-pf-wear__lab">' + wearEsc(G ? G.label : 'Garment') + ' color</span><div class="np-e2-pf-wear__sws">' + stock +
      '<label class="np-e2-pf-wear__sw np-e2-pf-wear__wheel' + (isCustom ? ' is-on' : '') + '" title="Any color"><i' + (isCustom ? ' style="background:' + cur + '"' : '') + '></i><input type="color" value="' + (cur || '#1f3a6e') + '" aria-label="Pick any garment color"></label></div></div>' +
      '<p class="np-e2-pf-wear__note" id="np-e2-pf-wear-note"' + (g ? '' : ' hidden') + '></p>';
  }
  function wearMount(v, pfShown) {
    var stage = $('#np-e2-pf-stage'); if (!stage) return;
    var bar = document.getElementById('np-e2-pf-wear');
    if (!window.NPWear || !pfShown) { if (bar) bar.hidden = true; wearApply(); return; }
    if (!bar) {
      bar = document.createElement('div'); bar.id = 'np-e2-pf-wear'; bar.className = 'np-e2-pf-wear';
      stage.parentElement.insertBefore(bar, stage);
      bar.addEventListener('click', function (e) {
        var seg = e.target.closest('[data-e2-wear]'); if (seg) { wearState().mode = seg.getAttribute('data-e2-wear'); wearRefresh(); return; }
        var sw = e.target.closest('[data-e2-wear-color]'); if (sw) { var w = wearState(); if (w.mode !== 'patch') w.color[w.mode] = sw.getAttribute('data-e2-wear-color'); wearRefresh(); return; }
        var pl = e.target.closest('[data-e2-wear-place]'); if (pl) { var w2 = wearState(); if (w2.mode !== 'patch') w2.place[w2.mode] = pl.getAttribute('data-e2-wear-place'); wearRefresh(); }
      });
      var onPick = function (e) { var inp = e.target; if (!inp || inp.type !== 'color') return; var w = wearState(); if (w.mode === 'patch') return; w.color[w.mode] = inp.value; /* live, IN PLACE — re-rendering the row kills the native picker mid-drag */ var wheel = inp.closest('.np-e2-pf-wear__wheel'); if (wheel) { wheel.classList.add('is-on'); var iW = wheel.querySelector('i'); if (iW) iW.style.background = inp.value; } $$('.np-e2-pf-wear__sw[data-e2-wear-color]', bar).forEach(function (b) { b.classList.remove('is-on'); }); wearApply(); };
      bar.addEventListener('input', onPick); bar.addEventListener('change', onPick);
    }
    try { NPWear.setContext({ typeKey: (typeof TYPE_KEY === 'string' ? TYPE_KEY : '') + ' ' + ((PTYPE && PTYPE.name) || ''), patchH: wearSizeChosen() && st.h > 0 ? st.h : 0 }); } catch (eCtx) {} /* per-type garments: crewneck = Tackle Twill only; keychains = none; C512: no hat above 2.5" tall */
    var wsM = wearState(); wsM.cur = v; wsM.shown = pfShown;
    if (wsM.mode !== 'patch' && !NPWear.garment(wsM.mode)) {
      var lcM = NPWear.isHat && NPWear.isHat(wsM.mode) && NPWear.leftChest ? NPWear.leftChest() : null; /* C512: the hat was dropped for height → the left chest */
      if (lcM) { wsM.mode = lcM.key; if (lcM.placement) wsM.place[lcM.key] = lcM.placement; } else wsM.mode = 'patch';
    }
    if (!NPWear.catalog().length) { bar.hidden = true; wsM.mode = 'patch'; wearApply(); return; } /* not a patch (PVC keychain): no "See this on a" at all */
    bar.hidden = false;
    bar.innerHTML = wearToolbarHtml();
    wearApply();
  }
  function wearRefresh() { var bar = document.getElementById('np-e2-pf-wear'); if (bar) bar.innerHTML = wearToolbarHtml(); wearApply(); }
  function wearApply() {
    var stage = $('#np-e2-pf-stage'); if (!stage) return;
    var w = wearState(), layer = stage.querySelector('.np-e2-wear-layer');
    if (w.mode === 'patch' || !window.NPWear) { stage.classList.remove('is-wear'); stage.classList.remove('is-tile'); stage.style.removeProperty('background-color'); if (layer) layer.remove(); return; }
    var G0 = NPWear.garment(w.mode), tileMode = !!(G0 && G0.kind === 'tile'); stage.classList.toggle('is-tile', tileMode); /* Size Helper PNGs carry their own white backdrop */
    if (tileMode) stage.style.setProperty('background-color', '#fff', 'important'); else stage.style.removeProperty('background-color'); /* the light-artwork rule paints the stage dark grey with !important */
    var img = stage.querySelector(':scope > img'), src = img ? img.getAttribute('src') : '';
    if (!src) { stage.classList.remove('is-wear'); if (layer) layer.remove(); return; }
    if (!layer) { layer = document.createElement('div'); layer.className = 'np-e2-wear-layer'; stage.insertBefore(layer, stage.firstChild); }
    stage.classList.add('is-wear');
    if (img && !img.naturalWidth && !img.__wearWait) { img.__wearWait = true; img.addEventListener('load', function () { try { wearApply(); } catch (eW) {} }, { once: true }); }
    /* the garment needs the TRANSPARENT patch: the alpha re-host when it exists, else our own flat-backdrop cut of the studio
       square (cached per version) — the raw white square must never land on a hat */
    var v = w.cur, useSrc = src;
    /* decide by PIXELS, never the filename: the bg-removal-/alpha re-host can come back opaque on a grey studio square
       (bg-removal-NB2 copies did, 2026-09-16) — exactly the case isAlphaSrc() calls transparent */
    if (v && v.__wearAlphaFor !== src) {
      if (!v.__wearProbing) { v.__wearProbing = true; var probeFor = src; npPixelHasAlpha(probeFor, function (hasA) { v.__wearProbing = false; v.__wearAlphaFor = probeFor; v.__wearAlpha = hasA === true; if (!v.__wearAlpha) { v.__wearCut = null; v.__wearCutFailed = false; } try { wearApply(); } catch (eW3) {} }); }
      useSrc = null;
    } else if (v && !v.__wearAlpha) {
      if (v.__wearCut) useSrc = v.__wearCut;
      else {
        useSrc = null;
        if (!v.__wearCutting) {
          v.__wearCutting = true;
          var cutFor = src;
          shapeMaskCutCanvas(toImgixHost(cutFor), shapeGeom(), function (cv) {
            var url = null; try { url = cv ? cv.toDataURL('image/png') : null; } catch (eC) {}
            var done = function (u) { v.__wearCutting = false; if (u) v.__wearCut = u; else v.__wearCutFailed = true; try { wearApply(); } catch (eW2) {} };
            if (url) done(url); else NPWear.cutFlat(toImgixHost(cutFor), done); /* second opinion: the generic flood cut */
          });
        }
        if (v.__wearCutFailed) useSrc = src; /* both cuts failed: show the square rather than nothing */
      }
    }
    /* whatever transparent copy we have, peel its fringe once (cached per version) before it goes on the garment */
    if (useSrc && v) {
      if (v.__wearClean && v.__wearCleanFor === useSrc) useSrc = v.__wearClean;
      else if (v.__wearCleaning !== useSrc) { var cleanFor = useSrc; v.__wearCleaning = cleanFor; var refOpaque = !v.__wearAlpha ? toImgixHost(src) : (v.hosted ? toImgixHost(v.hosted) : null); /* the opaque studio render = the backdrop colour the interior clean-up keys on */
        NPWear.defringe(/^data:/.test(cleanFor) ? cleanFor : toImgixHost(cleanFor), function (u) { if (v.__wearCleaning === cleanFor) v.__wearCleaning = null; if (u) { v.__wearClean = u; v.__wearCleanFor = cleanFor; } else { v.__wearClean = cleanFor; v.__wearCleanFor = cleanFor; } try { wearApply(); } catch (eW4) {} }, refOpaque); useSrc = null; }
      else useSrc = null;
    }
    var pr = (img && img.naturalWidth) ? img.naturalHeight / img.naturalWidth : ((st.h > 0 && st.w > 0) ? st.h / st.w : 1);
    var chosen = wearSizeChosen(), inW = chosen ? st.w : 0; /* 0 = let the zone's max print area size it */
    NPWear.render(layer, { garment: w.mode, placement: w.place[w.mode] || '', color: wearColorFor(w.mode), patch: useSrc, patchRatio: (st.h > 0 && st.w > 0) ? st.h / st.w : pr, patchIn: inW, onReady: function (wrapEl, info) {
      /* the size note — the Size Helper zone knows the placement's real max size, so the customer sees the patch true to size and learns the limit */
      var note = document.getElementById('np-e2-pf-wear-note'); if (!note || !info) return;
      var fmt = function (n) { return (Math.round(n * 100) / 100).toString().replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, ''); };
      var pl = (info.placement || 'front').toLowerCase(), where = info.label.toLowerCase() + ' ' + pl, inch = function (n) { return fmt(n) + '\u2033'; };
      if (info.kind === 'tile' && info.shownIn) {
        var sz = inch(info.shownIn[0]) + ' \u00d7 ' + inch(info.shownIn[1]), mx = inch(info.maxIn[0]) + ' \u00d7 ' + inch(info.maxIn[1]);
        note.textContent = info.over
          ? 'Your ' + inch(st.w) + ' patch is larger than the ' + mx + ' ' + pl + ' zone \u2014 shown scaled to fit.'
          : (chosen ? 'Shown true to size: ' + sz + ' on the ' + where + ' (max print area ' + mx + ').'
                    : 'Shown at the largest size for a ' + where + ': ' + sz + ' (max print area ' + mx + '). You\u2019ll pick your exact size next.');
        note.hidden = false;
      } else if (info.shownIn) { note.textContent = (chosen ? 'Shown true to size: ' : 'Shown at ') + inch(info.shownIn[0]) + ' wide' + (chosen ? '.' : '. You\u2019ll pick your exact size next.'); note.hidden = false; }
      else note.hidden = true;
    } });
  }
  function wearZoomSrc() {
    /* the lightbox shows the garment + patch as one picture while a garment is on */
    try { var w = wearState(); if (w.mode === 'patch') return null; var wrap = document.querySelector('#np-e2-pf-stage .np-e2-wear-layer .np-wear'); return wrap && window.NPWear ? NPWear.composite(wrap) : null; } catch (e) { return null; }
  }
  function renderProofReady() {
    $('#np-e2-pf-title').textContent = 'Review your proof';
    $('#np-e2-pf-loading').hidden = true;
    $('#np-e2-pf-ready').hidden = false;
    var szPane = $('#np-e2-pf-sizing'); if (szPane) szPane.hidden = true;
    var eb = $('#np-e2-pf-eyebrow'); if (eb) eb.textContent = 'AI PROOF';
    var szPanel = pf.querySelector('.np-e2-modal'); if (szPanel) szPanel.classList.remove('is-sizing');
    st.proofPhase = 'ready';
    var hasPick = st.selected !== null && st.selected !== undefined;
    var v = st.versions[hasPick ? st.selected : st.versions.length - 1];
    var stale427 = hasPick && designChangedSince(st.versions[st.selected]); /* C427 */
    $('#np-e2-pf-approve').disabled = !hasPick || stale427;
    var pick = $('#np-e2-pf-pick');
    if (pick) pick.hidden = !(st.versions.length > 1 && !hasPick);
    var pfShown = v.alpha || v.dataUrl || v.hosted;
    /* the compare shows THE PREVIEW WINDOW (composed shape+colors) vs the
       AI proof — the raw upload is only the fallback */
    var cmpUpload = !v.fallbackUpload && pfShown ? (sensei.composedLocalFolded || sensei.composedLocal || sensei.composedCleanUrl || applyToggleParams(cleanUrl(artworkUrl()) || '') || '') : ''; /* C181: the slider compares the DIGITAL preview (fold depicted) with the AI proof */
    $('#np-e2-pf-stage').innerHTML = pfShown
      ? '<div class="np-e2-stage-note"><i>i</i><div><b>This is an AI-rendered proof</b> <span class="np-e2-note-long">' + (v.fallbackUpload
          ? (((function () { var r216 = String(window.__npFallbackReason198 || ''); return !r216 || /timed out|timeout/i.test(r216); })() ? 'Our AI renderer is taking longer than usual, so we\u2019re showing your ' : 'Our AI renderer couldn\u2019t produce a proof for this design, so we\u2019re showing your ') + (v.fallbackDigital ? 'digital preview.' : 'uploaded design.') + ' You can continue to checkout \u2014 a ' + NP_NOUN + ' specialist will prepare and email your proof by hand.') /* C198 / C216: any renderer error = "couldn't produce"; only a timeout = "taking longer" */
          : 'This step is just your design and colors. You\u2019ll pick your ' + ((sizeFirstOn() && st.__sizeEntered) ? 'quantity' : 'size and quantity') + ' next. A ' + NP_NOUN + ' specialist reviews every order by hand before anything is created.') + '</span><span class="np-e2-note-short">' + (v.fallbackUpload ? (v.fallbackDigital ? 'Showing your digital preview' : 'Showing your upload') + ' \u2014 a specialist will email your proof.' : 'Size &amp; quantity come next.') + '</span></div></div>' +
        '<i class="np-e2-pf-under" aria-hidden="true"></i><img src="' + pfShown + '" alt="AI proof">' +
        '<span class="np-e2-cmp__tag np-e2-cmp__tag--r">AI PROOF</span>' +
        (cmpUpload
          ? '<div class="np-e2-cmp__before" id="np-e2-cmp-before" style="clip-path:inset(0 91% 0 0);-webkit-clip-path:inset(0 91% 0 0)"><img src="' + cmpUpload + '" alt="Your preview"><span class="np-e2-cmp__tag np-e2-cmp__tag--l">YOUR PREVIEW</span></div>' +
            '<button type="button" class="np-e2-cmp__handle" id="np-e2-cmp-handle" style="left:9%" aria-label="Drag to compare"><svg viewBox="0 0 24 24" fill="none" stroke="#0f172a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="10 8 6 12 10 16"/><polyline points="14 8 18 12 14 16"/></svg></button>'
          : '') +
        '<button type="button" class="np-e2-pf-zoombtn" aria-label="Zoom proof"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></button>' +
        ((pdpPricingOn() || (sizeFirstOn() && st.__sizeEntered)) && !v.fallbackUpload /* C229: a size entered before the proof shows on the proof too */
          /* on-page-pricing flow (Justin 2026-08-24): size is ALREADY picked
             in Step 3 before proofing, so the proof carries the measuring
             arrows too — positionDims sizes them to the measured patch */
          ? '<div class="np-e2-dim np-e2-dim--w"><i class="np-e2-dim__line"></i><b class="np-e2-dim__chip"></b></div><div class="np-e2-dim np-e2-dim--h"><i class="np-e2-dim__line"></i><b class="np-e2-dim__chip"></b></div>'
          : '')
      : ''; /* elsewhere no dimension arrows — size isn't picked until the sizing phase */
    try { wearMount(v, pfShown); } catch (eWm) {} /* C224: See this on a Patch | Hat | Polo */
    $('#np-e2-pf-stage').classList.toggle('is-alpha', isAlphaSrc(pfShown || v.hosted || ''));
    (function (pfS, pfU) { if (pfS && pfU) npArtIsLight(pfU, function (lite) { pfS.classList.toggle('is-lightart', lite); }); })($('#np-e2-pf-stage'), pfShown || v.hosted || ''); /* C30 */
    /* C34 (2026-08-28, Justin: "digital preview in slider comparison with AI
       rendering") — the THIRD surface. The compare slider's BEFORE pane is its
       own element with its own !important background, so darkening the stage
       behind it does nothing for the customer's own preview: their white
       artwork still sits on a light field while the AI proof beside it reads
       fine. Classify the upload the pane actually shows and mark the pane. */
    (function (cu) {
      if (!cu) return;
      npArtIsLight(cu, function (lite) {
        var cb = document.getElementById('np-e2-cmp-before');
        if (cb) cb.classList.toggle('is-lightart', lite);
      });
    })(cmpUpload);
    var cmpCap = document.getElementById('np-e2-pf-cmpcap');
    if (cmpCap) cmpCap.hidden = !cmpUpload;
    try {
      var stgSet = $('#np-e2-pf-stage');
      if (stgSet && cmpUpload) {
        stgSet.classList.add('is-settling');
        npTick(function () { try { stgSet.classList.remove('is-settling'); } catch (eSr) {} }, 1500); /* never hide longer than this */
      }
    } catch (eSt) {}
    cmpSweep = !!cmpUpload && !v.__swept && !v.fallbackUpload;
    if (cmpSweep) v.__swept = true;
    wireCompare();
    var pfImg = $('#np-e2-pf-stage > img');
    if (pfImg) pfImg.addEventListener('load', function () { positionDims(); });
    positionDims();
    try { matchCompareScale($('#np-e2-pf-stage')); } catch (eMS) {}
    $('#np-e2-pf-cap').textContent = (v.fullColor ? 'Full Color Printed Patch · ' : (v.fallbackUpload ? (v.fallbackDigital ? 'Your digital preview · ' : 'Your uploaded design · ') : (v.fallback ? 'Instant preview · ' : ''))) + [pdpPricingOn() ? (v.w.toFixed(2) + '" × ' + v.h.toFixed(2) + '"') : '', displayShapeLabel(v.shape) || v.shape, v.fold && v.fold.label, v.backing && v.backing.label].filter(Boolean).join(' · '); /* C194: no size before the sizing phase; the fold rides the caption */
    var headNotice = document.getElementById('np-e2-pf-headnotice');
    if (headNotice) headNotice.hidden = true; /* the notice lives INSIDE the preview square now */
    var left = regensLeft();
    $('#np-e2-pf-versions').innerHTML = st.versions.map(function (x, i) {
      var on = hasPick && i === st.selected;
      return '<span class="np-e2-pf-version' + (on ? ' is-on' : '') + (x.fullColor ? ' is-fc' : '') + '" data-e2-v="' + i + '"><i>' + ((x.alpha || x.dataUrl) ? '<img src="' + (x.alpha || x.dataUrl) + '">' : '') + '</i><b>' + (x.fullColor ? 'FC' : 'V' + (i + 1)) + '</b></span>';
    }).join('');
    /* full-color recommendation: photo-real art stitches poorly */
    var reco = $('#np-e2-fc-reco');
    var forcedN = $('#np-e2-fc-forced');
    var forcedTxt = null;
    if (st.fdChoice === 'woven') forcedTxt = '<b>\ud83e\uddf5 Converted to Woven</b><span>The fine detail in your design can\u2019t be stitched in embroidery thread \u2014 ultra-fine woven threads keep it crisp, so your proof was generated as a <em>Woven Patch</em>.</span>';
    else if (st.fdChoice === 'ps') forcedTxt = '<b>\ud83e\udea1 Print &amp; Stitch production</b><span>The fine detail in your design will be PRINTED and the larger areas embroidered. A patch specialist finalizes the split by hand before production.</span>';
    else if (st.fcForced && st.fcForcedReason === 'detail') forcedTxt = '<b>\ud83d\udd0e Converted to Full Color Printed</b><span>Small text and thin lines can\u2019t be stitched in embroidery thread \u2014 full color print reproduces every detail exactly, so your proof was generated as a <em>Full Color Printed Patch</em>.</span>';
    else if (st.fcForced) forcedTxt = '<b>\ud83d\udcf8 Converted to Full Color Printed</b><span>Photographs can\u2019t be stitched in embroidery thread \u2014 full color print is the only way to produce this image, so your proof was generated as a <em>Full Color Printed Patch</em>.</span>';
    if (forcedTxt) {
      if (reco) reco.hidden = true;
      if (forcedN) { forcedN.innerHTML = forcedTxt; forcedN.hidden = false; }
    } else {
      if (forcedN) forcedN.hidden = true;
      if (reco) reco.hidden = !!PTYPE.labelsOnly || !(PTYPE.name !== 'Printed' && fullColorLikely(v.line) && !st.fcOffered && !v.fullColor && !st.proofApproved); /* C163b (review): the post-render Full Color offer was the last conversion path left on woven labels */
    }
    var approveBtn = $('#np-e2-pf-approve');
    var pkV = hasPick && st.versions[st.selected];
    var revNow = formProp('_Revision Notes') || '';
    approveBtn.textContent = revNow ? (pdpPricingOn() ? 'Submit with Revisions & Finalize Order' : 'Submit with Revisions and go to pricing')
      : (pkV && pkV.fullColor && !onTargetProduct(pkV))
      ? (pkV.altKind === 'woven' ? 'Continue with Woven patch' : 'Continue with Full Color patch')
      : ((st.fdChoice === 'ps' && !onTargetProduct({ altKind: 'ps' })) ? 'Continue with Print & Stitch patch' : (pdpPricingOn() ? 'Approve & Finalize Order' : (sizeFirstOn() && st.__sizeEntered) ? 'Approve and go to pricing' : 'Approve and go to size and pricing'));
    if (stale427) approveBtn.textContent = 'Regenerate to approve your new selections'; /* C427 */
    $$('#np-e2-pf-versions [data-e2-v]').forEach(function (el) {
      el.addEventListener('click', function () { st.selected = parseInt(el.getAttribute('data-e2-v'), 10); renderProofReady(); });
    });
    var changeTxt = $('#np-e2-change-text').value.trim();
    var usedRows = [];
    if (PTYPE.textLines) {
      /* the typed order IS the design — every lettering decision belongs here */
      var linesU = ttLines();
      linesU.forEach(function (lU, iU) {
        usedRows.push(['Line ' + (iU + 1), lU + '  ·  ' + (st['ttLay' + (iU + 1)] || 'Straight') +
          (iU > 0 && st['ttHalf' + (iU + 1)] ? '  ·  \u00bd size' : '')]);
      });
      if (stepEnabled('font')) usedRows.push(['Font style', st.font ? st.font.label : '\u2014']);
      var layU = st['opt' + (PTYPE.layersOpt || 2)];
      if (layU) usedRows.push(['Layers', layU.label]);
      if (ttSwooshOn()) {
        usedRows.push(['Tail', ttSwooshDef(st.swooshStyle).name]);
        if (String(st.swooshText || '').trim()) {
          usedRows.push(['Text on tail', String(st.swooshText).trim().toUpperCase() +
            (st.swooshTextColor ? '  ·  ' + st.swooshTextColor.label : '')]);
        }
      }
    }
    /* C194 (Justin 2026-09-11, "when I change versions the options need to change also"): every row reads the PICKED
       version's snapshot (falling back to the live state only for fields older versions never stored), so clicking V1
       shows what V1 was rendered with. Size and quantity appear only in the on-page-pricing flow, where they were picked
       BEFORE the proof — elsewhere the banner says "you'll pick your size and quantity next", so they are not shown. */
    var vSel = function (k) { return (v[k] !== undefined) ? v[k] : st[k]; };
    if (stepEnabled('shape') || PTYPE.foldShapes) usedRows.push(['Shape', displayShapeLabel(v.shape) || '\u2014']); /* C165 */
    if (stepEnabled('border')) usedRows.push(['Border style', vSel('border') ? vSel('border').label : '\u2014']);
    if (stepEnabled('fold')) usedRows.push(['Fold style', vSel('fold') ? vSel('fold').label : '\u2014']); /* C164 */
    if (stepEnabled('bg')) usedRows.push([PTYPE.bgLabel || 'Patch background', v.bg ? v.bg.label : '\u2014']);
    if (stepEnabled('thread')) usedRows.push([PTYPE.threadLabel || 'Border thread', v.thread ? v.thread.label : '\u2014']);
    if (PTYPE.borderThick) usedRows.push(['Border thickness', Math.max(1, Math.min(10, vSel('lbThick') || 3)) + ' of 10']);
    if (PTYPE.sewChannel) usedRows.push(['Sewing channel', vSel('sewChannel') ? 'Yes' : 'No']); /* C538 */
    if (stepEnabled('texture')) usedRows.push(['Background texture', vSel('texture') ? vSel('texture').label : '\u2014']);
    if (PTYPE.stitches) usedRows.push(['Border stitch', vSel('ttStitch') || 'Zig Zag']);
    if (PTYPE.backing !== 0) usedRows.push(['Backing', v.backing ? v.backing.label : '\u2014']); /* C176: labels carry no backing — no dash row */
    if (pdpPricingOn()) {
      usedRows.push(['Size', v.w.toFixed(2) + '" × ' + v.h.toFixed(2) + '"']);
      usedRows.push(['Quantity', vSel('qty') + ' pcs']); /* no pricing before approval — it reveals in the sizing phase */
    }
    /* AI edit request row removed — it is noise in the selections list */
    var revSaved = formProp('_Revision Notes') || '';
    var revBox = document.getElementById('np-e2-pf-revsaved');
    if (revBox) {
      revBox.hidden = !revSaved;
      var revTxt = document.getElementById('np-e2-pf-revsaved-txt');
      if (revTxt) revTxt.textContent = revSaved;
    }
    $('#np-e2-pf-used').innerHTML = usedRows.map(function (r) { return '<div class="np-e2-pf-used-row"><span>' + r[0] + '</span><b>' + r[1] + '</b></div>'; }).join('');
    var regen = $('#np-e2-pf-regen');
    regen.disabled = false;
    var changedNow = specsChangedSince(st.versions[st.versions.length - 1]);
    regen.textContent = changedNow ? 'Regenerate with updated selections' : 'Submit Revisions';
    regen.classList.toggle('is-updated', changedNow);
    /* revisions already filed: the saved panel's "Edit notes" is the way back,
       so the footer button would just be a second door to the same room. It
       returns the moment selections change, since that is a regenerate. */
    regen.hidden = !!revSaved && !changedNow;
  }
  function onTargetProduct(v) {
    /* already ON the converted product — approve behaves normally there */
    var h = v && v.altKind === 'woven' ? 'woven-patches' : (v && v.altKind === 'ps' ? 'print-stitch-patches' : 'sublimated-patches');
    return location.pathname.indexOf(h) !== -1;
  }
  var fdChoiceEl = null;
  function openFineDetailChoice() {
    /* C79: never interrupt a classic-mode previous-design arrival */
    if (mdArrival79C) { st.__photoCleared = true; st.fdChoice = st.fdChoice || 'keep'; return; } /* C100: any mode */
    if (PTYPE.labelsOnly) { openLabelsStop(); return; } /* C163 */
    /* recommendation depends on HOW MUCH of the design is fine detail:
       nearly all thin (or a photo, which never reaches here) -> Full Color;
       a MIX of chunky areas + fine detail -> Print & Stitch leads */
    var allFine = (st.artThinInkFrac || 0) > 0.7;
    /* molded PVC can't stitch OR mold fine detail — Full Color leads, woven
       is not a sane conversion from rubber (Justin 2026-08-24) */
    var molded = /^(rubber-pvc-2-0|keychains-2-0|silicone-2-0)$/.test(TYPE_KEY);
    var OPT = {
      fc: '<button type="button" class="np-e2-fdopt' + (allFine || molded ? ' np-e2-fdopt--rec' : '') + '" data-fd="fc"><b>Full Color Printed</b><i>Every detail reproduced exactly \u2014 the sharpest result for fine detail.</i></button>',
      ps: '<button type="button" class="np-e2-fdopt' + (allFine || molded ? '' : ' np-e2-fdopt--rec') + '" data-fd="ps"><b>Print &amp; Stitch combo</b><i>Large areas embroidered, fine details printed \u2014 a patch specialist finalizes the split by hand.</i></button>',
      woven: '<button type="button" class="np-e2-fdopt" data-fd="woven"><b>Woven Patch</b><i>Ultra-fine woven threads keep tiny detail crisp with a true fabric look.</i></button>',
      /* C422: fine detail is not a hard stop — the customer may keep this patch type */
      keep: '<button type="button" class="np-e2-fdopt" data-fd="keep"><b>Keep as ' + (PTYPE.name || 'this patch type') + '</b><i>Continue on this patch type \u2014 the finest detail may soften.</i></button>'
    };
    var intro = molded
      ? 'Your image is packed with fine detail. Molded PVC has a physical minimum line width, so detail that small would blur or fill in. Choose how you\u2019d like us to produce it:'
      : allFine
      ? 'Your image is made almost entirely of small text or very thin lines. Embroidery thread has a physical minimum stitch width, so that fine detail would blur or fill in. Choose how you\u2019d like us to produce it:'
      : 'Parts of your design have small text or thin lines that embroidery thread can\u2019t stitch cleanly \u2014 the rest stitches beautifully. Choose how you\u2019d like us to produce it:';
    if (!fdChoiceEl) {
      fdChoiceEl = document.createElement('div');
      fdChoiceEl.className = 'np-e2-ov np-e2-ov--fd';
      (document.getElementById('np-e2') || document.body).appendChild(fdChoiceEl);
    }
    fdChoiceEl.__kind = null;
    fdChoiceEl.innerHTML = '<div class="np-e2-modal">' +
      '<header class="np-e2-modal__head"><div><span class="np-e2-modal__eyebrow np-e2-fcc-eyebrow">FINE DETAIL DETECTED</span>' +
      '<h3 class="np-e2-modal__title">' + (molded ? 'This design is too detailed for molded PVC' : allFine ? 'This design is too detailed for embroidery thread' : 'Part of this design is too detailed for embroidery thread') + '</h3></div></header>' +
      '<div class="np-e2-modal__body">' +
      '<p class="np-e2-fd-txt">' + intro + '</p>' +
      (molded ? OPT.fc + OPT.ps : allFine ? OPT.fc + OPT.woven + OPT.ps : OPT.ps + OPT.fc + OPT.woven) + OPT.keep +
      '</div>' +
      '<footer class="np-e2-modal__foot"><button type="button" class="np-e2-btn np-e2-btn--outline" data-fd-back>Go back</button><div class="np-e2-modal__footright"><button type="button" class="np-e2-btn np-e2-btn--green" data-fd-go disabled>Continue</button></div></footer></div>';
    fdChoiceEl.querySelector('[data-fd-back]').addEventListener('click', function () { fdChoiceEl.hidden = true; });
    var fdGo = fdChoiceEl.querySelector('[data-fd-go]');
    $$('[data-fd]', fdChoiceEl).forEach(function (btnF) {
      btnF.addEventListener('click', function () {
        /* select only — Continue confirms, so a stray click can't convert */
        $$('[data-fd]', fdChoiceEl).forEach(function (b2) { b2.classList.toggle('is-on', b2 === btnF); });
        fdChoiceEl.__kind = btnF.getAttribute('data-fd');
        fdGo.disabled = false;
      });
    });
    fdGo.addEventListener('click', function () {
      var kind = fdChoiceEl.__kind;
      if (!kind) return;
      fdChoiceEl.hidden = true;
      st.fdChoice = kind;
      var digIntent = (st.pendingProofKind === 'digital' || st.pendingProofKind === 'stitch');
      if (digIntent) st.proofMode = st.pendingProofKind;
      if (kind === 'keep') {
        /* C422: stand the detector down for this artwork (same contract as the upload-time keep) and carry on with
           what the customer asked for — the digital path is already running; Generate re-enters openProof() */
        st.__photoCleared = true; st.__photoNudged = true;
        st.__keepArtBase = (cleanUrl(artworkUrl()) || '').split('?')[0];
        npRecNote('Up', (allFine || molded) ? 'Full Color Patch' : 'Print & Stitch Patch'); /* C519: the --rec option */
        if (!digIntent) openProof();
        return;
      }
      if (kind === 'fc') {
        st.fcForced = true; st.fcForcedReason = 'detail'; st.fcOffered = true;
        if (digIntent) { st.fcConfirmed = true; digitalConvert('fc'); } else generateFullColor();
      }
      else if (kind === 'woven') {
        st.fcConfirmed = true; st.fcOffered = true;
        if (digIntent) digitalConvert('woven'); else generateFullColor('woven');
      }
      else {
        if (molded) {
          /* PVC can't split print/embroider on itself — Print & Stitch means
             the print-stitch PRODUCT, artwork riding along */
          var artM = cleanUrl(artworkUrl()) || '';
          window.location.href = '/products/print-stitch-patches?np_mode=ai' + (artM && isUploadLineage(artM) ? '&file=' + encodeURIComponent(artM) : '');
          return;
        }
        st.fcConfirmed = true;
        setProp('_Production Method', 'PRINT & STITCH - fine detail printed, remainder embroidered');
        if (digIntent) digitalConvert('ps'); else openProof();
      }
    });
    try { hidePageLoader(); } catch (e79j) {}
    try { var vj79c = document.getElementById('np-modejump-veil'); if (vj79c) vj79c.remove(); } catch (e79k) {}
    try { document.querySelectorAll('.loadingScreen__').forEach(function (l79c) { l79c.remove(); }); } catch (e79l) {}
    try { document.documentElement.classList.add('np-ready'); } catch (e89c) {} /* C89: releases html.np-arriving cover AND the modejump veil's hold loop */
    fdChoiceEl.hidden = false;
  }
  var leaveConfirmEl = null;
  function openLeaveConfirm() {
    /* X in Size & Pricing: leaving throws the whole session away — make
       sure that's what they want, then restart the page clean */
    if (!leaveConfirmEl) {
      leaveConfirmEl = document.createElement('div');
      leaveConfirmEl.className = 'np-e2-ov np-e2-ov--fcc';
      leaveConfirmEl.innerHTML = '<div class="np-e2-modal np-e2-modal--fcc">' +
        '<header class="np-e2-modal__head"><div><span class="np-e2-modal__eyebrow np-e2-fcc-eyebrow">ARE YOU SURE?</span>' +
        '<h3 class="np-e2-modal__title">Leave size and pricing?</h3></div></header>' +
        '<div class="np-e2-modal__body">' +
        '<p class="np-e2-fcc-txt">If you leave now, <b>everything will be lost</b> \u2014 your proof, your selections, and your sizing. You\u2019ll start over from a fresh upload.</p>' +
        '</div>' +
        '<footer class="np-e2-modal__foot"><button type="button" class="np-e2-btn np-e2-btn--outline" data-lv-stay>Stay here</button><div class="np-e2-modal__footright"><button type="button" class="np-e2-btn np-e2-btn--green" data-lv-go>Continue \u2014 start over</button></div></footer></div>';
      (document.getElementById('np-e2') || document.body).appendChild(leaveConfirmEl);
      leaveConfirmEl.querySelector('[data-lv-stay]').addEventListener('click', function () { leaveConfirmEl.hidden = true; });
      leaveConfirmEl.querySelector('[data-lv-go]').addEventListener('click', function () {
        /* clean product URL: no file=/np_* params — lands on the upload box */
        window.location.href = window.location.pathname + (window.location.search.indexOf('view=') > -1 ? '?view=' + new URLSearchParams(window.location.search).get('view') : '');
      });
    }
    leaveConfirmEl.hidden = false;
  }
  var photoConfirmEl = null;
  /* C79: same arrival signal as the boot-scope copy, captured before either
     consumer runs (removeItem happens in the boot copy; read both sources). */
  var mdArrival79C = false;
  try {
    mdArrival79C = sessionStorage.getItem('np_md_arrival') === '1' || /[?&]file=/.test(String(location.search || ''));
    sessionStorage.removeItem('np_md_arrival');
  } catch (e79e) {}
  function isClassic79() {
    /* body.np-e2-classic is applied mid-boot - too late for the digital-path
       parallel artwork check - so the mode PREFERENCE (written before the
       arrival navigation) is the timing-proof signal. */
    try { if (localStorage.getItem('np_order_mode') === 'classic') return true; } catch (e79f) {}
    return document.body.classList.contains('np-e2-classic');
  }
  function openPhotoConfirm() {
    /* C79: never interrupt a classic-mode previous-design arrival */
    if (mdArrival79C) { st.__photoCleared = true; st.__photoNudged = true; return; } /* C100: any mode */
    if (PTYPE.labelsOnly) { openLabelsStop(); return; } /* C163 */
    if (!photoConfirmEl) {
      photoConfirmEl = document.createElement('div');
      photoConfirmEl.className = 'np-e2-ov np-e2-ov--fcc';
      photoConfirmEl.innerHTML = '<div class="np-e2-modal np-e2-modal--fcc">' +
        /* C98 (2026-09-01, Justin: v2 must match the dense modal - no Keep,
           short trusting copy) */
        /* C132 (2026-09-02, Justin: "for photos you don't have to get that
           detailed, just mention it's a photograph and that it needs to be
           full color"; on leather say etch, not thread). Body is filled per
           open below because the modal is cached and the material matters. */
        '<header class="np-e2-modal__head"><div><span class="np-e2-modal__eyebrow np-e2-fcc-eyebrow">PHOTOGRAPH DETECTED</span>' +
        '<h3 class="np-e2-modal__title">Photographs need Full Color printing</h3></div></header>' +
        '<div class="np-e2-modal__body">' +
        '<p class="np-e2-fcc-txt" data-fcc-l2></p>' +
        '</div>' +
        '<footer class="np-e2-modal__foot"><div class="np-e2-modal__footright"><button type="button" class="np-e2-btn np-e2-btn--green" data-pc-ok>Continue with Full Color</button></div></footer></div>';
      (document.getElementById('np-e2') || document.body).appendChild(photoConfirmEl);
      /* KEEP THIS PATCH TYPE (Justin 2026-08-24, replaces the re-upload
         escape): the customer overrides the detector and continues building
         on the current type. Mark the check cleared so neither the upload
         gate nor the generate backstop re-interrupts this session. */
      var pcKeep98 = photoConfirmEl.querySelector('[data-pc-keep]');
      if (pcKeep98) pcKeep98.addEventListener('click', function () {
        st.__photoCleared = true;
        st.__photoNudged = true;
        st.__keepArtBase = (cleanUrl(artworkUrl()) || '').split('?')[0];
        photoConfirmEl.hidden = true;
        if (!photoConfirmEl.__upload) pf.hidden = true;
      });
      photoConfirmEl.querySelector('[data-pc-ok]').addEventListener('click', function () {
        photoConfirmEl.hidden = true;
        if (photoConfirmEl.__upload) {
          /* UPLOAD-TIME path: hand the customer to the Full Color builder
             FRESH so every option is chosen on the right patch type — no
             carried selections, no auto-generate. */
          var artU2 = cleanUrl(artworkUrl()) || '';
          window.location.href = '/products/sublimated-patches?np_mode=ai' + (artU2 && isUploadLineage(artU2) ? '&file=' + encodeURIComponent(artU2) : '');
          return;
        }
        st.fcConfirmed = true;
        st.fcForced = true; st.fcForcedReason = 'photo'; st.fcOffered = true;
        if (st.pendingProofKind === 'digital' || st.pendingProofKind === 'stitch') {
          st.proofMode = st.pendingProofKind;
          digitalConvert('fc');
        } else generateFullColor();
      });
    }
    photoConfirmEl.__upload = (arguments[0] === 'upload');
    var l2P = photoConfirmEl.querySelector('[data-fcc-l2]');
    /* C132: one short body for both variants (C98), material-aware \u2014
       leather / faux leather are laser-etched in a single tone */
    var cardG = (st.__gateRes && st.__gateRes.ok && st.__gateRes.verdict === 'photo' && st.__gateRes.card) ? st.__gateRes.card : null; /* C134 */
    if (cardG && cardG.copy && l2P) {
      l2P.innerHTML = cardG.copy.bodyHtml;
      var eyG = photoConfirmEl.querySelector('.np-e2-fcc-eyebrow'), tiG = photoConfirmEl.querySelector('.np-e2-modal__title');
      if (eyG) eyG.textContent = cardG.copy.eyebrow; if (tiG) tiG.textContent = cardG.copy.title;
    } else if (l2P) l2P.innerHTML = isLeather()
      ? 'Your image is a photograph. Leather is laser-etched in a single tone, so photographic shading can\u2019t be reproduced \u2014 a <b>Full Color Printed Patch</b> prints it exactly as it is. We\u2019ll take you right to it.'
      : 'Your image is a photograph. Embroidery thread can\u2019t reproduce photographic shading \u2014 a <b>Full Color Printed Patch</b> prints it exactly as it is. We\u2019ll take you right to it.';
    /* C79: a question must never sit under a loader - kill every veil the
       arrival may still have up before showing the confirm. */
    try { hidePageLoader(); } catch (e79b) {}
    try { var vj79 = document.getElementById('np-modejump-veil'); if (vj79) vj79.remove(); } catch (e79c) {}
    try { document.querySelectorAll('.loadingScreen__').forEach(function (l79) { l79.remove(); }); } catch (e79d) {}
    try { document.documentElement.classList.add('np-ready'); } catch (e89a) {} /* C89: releases html.np-arriving cover AND the modejump veil's hold loop */
    photoConfirmEl.hidden = false;
  }
  var uploadRecoEl = null;
  function openFdReco(modeF) {
    if (mdArrival79C) { st.__photoCleared = true; st.__photoNudged = true; return; } /* C79+C100: any mode */
    /* material-aware at-upload fine-detail recommendation — rubber PVC molds,
       it doesn't stitch, and Full Color is the preferred escape (Justin
       2026-08-24) */
    if (/^(rubber-pvc-2-0|keychains-2-0|silicone-2-0)$/.test(TYPE_KEY)) openUploadReco(
      'FINE DETAIL DETECTED',
      'This design is too detailed for molded PVC',
      'Patch Sensei checked your image: it\u2019s full of fine detail, and molded PVC has a physical minimum line width \u2014 detail that small would blur or fill in. A <b>Full Color Printed Patch</b> reproduces every detail exactly, crisp and true to your design.',
      'Continue with Full Color',
      '/products/sublimated-patches',
      modeF,
      null,
      { keep: true } /* C422 */
    );
    else openUploadReco(
      'FINE DETAIL DETECTED',
      'Small text and thin lines can\u2019t be stitched in embroidery thread',
      'Patch Sensei checked your image: it has fine detail that embroidery thread physically can\u2019t reproduce. A <b>Print &amp; Stitch</b> patch PRINTS the fine detail and embroiders the rest \u2014 or go <b>Full Color Printed</b> to print every bit of it.',
      'Continue with Print & Stitch',
      '/products/print-stitch-patches',
      modeF,
      /* C133 (2026-09-02, Justin: 'why doesn't this image give me a full color
         recommendation on emb (only print stitch)'): the fine-detail stop offers
         BOTH like the dense stop - only photographs are Full-Color-only */
      { label: 'Full Color instead', handle: '/products/sublimated-patches' },
      { keep: true } /* C422 */
    );
  }
  var labelsStopEl = null;
  function openLabelsStop(modeR) {
    /* C163 (Justin 2026-09-10): woven LABELS are an exclusive use case — never a conversion offer, never a
       recommendation from another page or the mockup generator. Whatever the gate stopped on (photograph,
       dense pictorial, fine detail, small text) the customer sees ONE message — this image will not work as a
       woven label — and ONE way out: upload another image. Every stop modal routes here on PTYPE.labelsOnly;
       the copy stays generic (no image-specific numbers, standing rule). */
    if (mdArrival79C) { st.__photoCleared = true; st.__photoNudged = true; return; } /* C100: chosen designs are never re-interrogated */
    st.__photoNudged = true;
    if (labelsStopEl && labelsStopEl.parentNode) labelsStopEl.parentNode.removeChild(labelsStopEl);
    labelsStopEl = document.createElement('div');
    labelsStopEl.className = 'np-e2-ov np-e2-ov--fcc';
    labelsStopEl.innerHTML = '<div class="np-e2-modal np-e2-modal--fcc">' +
      '<header class="np-e2-modal__head"><div><span class="np-e2-modal__eyebrow np-e2-fcc-eyebrow">WOVEN LABELS</span>' +
      '<h3 class="np-e2-modal__title">This image won\u2019t work as a woven label</h3></div></header>' +
      '<div class="np-e2-modal__body"><p class="np-e2-fcc-txt">Woven labels are woven from fine thread in a handful of solid colors, so photographs, shading and very fine detail can\u2019t be reproduced. Please upload a different image \u2014 flat, solid-color artwork or clean text weaves best.</p></div>' +
      '<footer class="np-e2-modal__foot"><div class="np-e2-modal__footright"><button type="button" class="np-e2-btn np-e2-btn--green" data-ls-again>Upload another image</button></div></footer></div>';
    document.body.appendChild(labelsStopEl);
    labelsStopEl.querySelector('[data-ls-again]').addEventListener('click', function () {
      labelsStopEl.hidden = true;
      /* clean product URL (no file= / np_* params) lands on the upload box — the leave-confirm's own recipe */
      window.location.href = window.location.pathname + (window.location.search.indexOf('view=') > -1 ? '?view=' + new URLSearchParams(window.location.search).get('view') : '');
    });
    /* C79: a stop must never sit under a loader */
    try { hidePageLoader(); } catch (e163a) {}
    try { var vj163 = document.getElementById('np-modejump-veil'); if (vj163) vj163.remove(); } catch (e163b) {}
    try { document.querySelectorAll('.loadingScreen__').forEach(function (l163) { l163.remove(); }); } catch (e163c) {}
    try { document.documentElement.classList.add('np-ready'); } catch (e163d) {}
    try { if (typeof pf !== 'undefined' && pf) pf.hidden = true; } catch (e163e) {} /* Generate-time stop: drop the proof panel's checking veil */
    labelsStopEl.hidden = false;
  }
  /* C424 (Justin 2026-09-24, "add text above the buttons that says View x options to choose from ... Full Color Printed /
     Print & Stitch / Keep as (Patch Type) ... if it's a different patch type we wouldn't say full color printed etc"):
     a stop with a choice lists every option as a button under "View N options to choose from", named by where it goes
     (the recommended one stays green); a stop with one way out (photographs) keeps its single CTA. */
  var NP_UR_NAMES = { '/products/sublimated-patches': 'Full Color Printed', '/products/print-stitch-patches': 'Print & Stitch' };
  function npUrFooter(cta, handle, altR, keep, typeName) {
    var opts = [{ attr: 'data-ur-ok', label: NP_UR_NAMES[handle] || cta, rec: true, key: handle }];
    if (altR) opts.push({ attr: 'data-ur-alt', label: NP_UR_NAMES[altR.handle] || altR.label, rec: false, key: altR.handle });
    if (opts.length === 1 && !keep) {
      return '<div class="np-e2-modal__footright"><button type="button" class="np-e2-btn np-e2-btn--green" data-ur-ok>' + cta + '</button></div>';
    }
    /* Full Color Printed, then Print & Stitch, then Keep — the order Justin listed them */
    var rank = function (o) { return o.key === '/products/sublimated-patches' ? 0 : o.key === '/products/print-stitch-patches' ? 1 : 2; };
    opts.sort(function (a, b) { return rank(a) - rank(b); });
    if (keep) opts.push({ attr: 'data-ur-keep', label: 'Keep as ' + (typeName || 'this patch type'), rec: false });
    return '<div class="np-e2-optwrap"><p class="np-e2-optcount">Choose from the ' + opts.length + ' options below</p><div class="np-e2-optrow">' /* C425 (Justin 2026-09-24): wording + centred */ +
      opts.map(function (o) { return '<button type="button" class="np-e2-btn ' + (o.rec ? 'np-e2-btn--green' : 'np-e2-btn--outline') + '" ' + o.attr + '>' + o.label + '</button>'; }).join('') +
      '</div></div>';
  }
  function openUploadReco(eyebrow, title, body, cta, handle, modeR, altR, optsR) {
    if (PTYPE.labelsOnly) { openLabelsStop(modeR); return; } /* C163: labels never get a conversion offer */
    /* at-upload recommendation: warn BEFORE options are chosen and reset the
       customer onto the RIGHT product with their image in the URL.
       C78 (2026-08-31): optional altR = { label, handle } renders a SECOND
       destination button (Justin: dense pictorial art should offer BOTH
       Full Color and Print & Stitch). */
    if (uploadRecoEl && uploadRecoEl.parentNode) uploadRecoEl.parentNode.removeChild(uploadRecoEl);
    uploadRecoEl = document.createElement('div');
    uploadRecoEl.className = 'np-e2-ov np-e2-ov--fcc';
    uploadRecoEl.innerHTML = '<div class="np-e2-modal np-e2-modal--fcc">' +
      '<header class="np-e2-modal__head"><div><span class="np-e2-modal__eyebrow np-e2-fcc-eyebrow">' + eyebrow + '</span>' +
      '<h3 class="np-e2-modal__title">' + title + '</h3></div></header>' +
      '<div class="np-e2-modal__body"><p class="np-e2-fcc-txt">' + body + '</p>' +
      ((optsR && optsR.short) ? '' : '<p class="np-e2-fcc-txt">By continuing, we\u2019ll take you to the right builder so you can pick your options for that patch type.</p>') + '</div>' +
      /* C100 (2026-09-01, Justin: 'Keep this patch type' hidden from ALL angles).
         C422 (Justin 2026-09-24, "add back the continue option when we block a customer's artwork for embroidery ...
         photo realistic images should be the only thing that keeps the block"): high-detail and fine-detail stops opt
         back in with optsR.keep — the customer may stay on this patch type. Photographs never pass keep. */
      '<footer class="np-e2-modal__foot">' + npUrFooter(cta, handle, altR, !!(optsR && optsR.keep && !PTYPE.labelsOnly), PTYPE.name) + '</footer></div>';
    /* BODY, always: on classic pages #np-e2 is hidden, which made the modal
       invisible while its overlay froze the page */
    document.body.appendChild(uploadRecoEl);
    var urKeep = uploadRecoEl.querySelector('[data-ur-keep]');
    if (urKeep) urKeep.addEventListener('click', function () {
      /* KEEP THIS PATCH TYPE (Justin 2026-08-24): the customer overrides the
         recommendation and continues on the current type — stand the detector
         down so neither the upload gate nor the generate-time gates re-nag
         this session. */
      st.__photoCleared = true;
      st.__photoNudged = true;
      st.__keepArtBase = (cleanUrl(artworkUrl()) || '').split('?')[0];
      uploadRecoEl.hidden = true;
      npRecNote('Up', npRecName(handle)); /* C519 */
    });
    uploadRecoEl.querySelector('[data-ur-ok]').addEventListener('click', function () {
      uploadRecoEl.hidden = true;
      var artU3 = cleanUrl(artworkUrl()) || '';
      window.location.href = handle + '?np_mode=' + (modeR || 'ai') + (artU3 && isUploadLineage(artU3) ? '&file=' + encodeURIComponent(artU3) : '');
    });
    var urAlt = uploadRecoEl.querySelector('[data-ur-alt]');
    if (urAlt) urAlt.addEventListener('click', function () {
      /* C78: same fresh-handoff contract as the primary CTA, alternate product */
      uploadRecoEl.hidden = true;
      var artU4 = cleanUrl(artworkUrl()) || '';
      window.location.href = altR.handle + '?np_mode=' + (modeR || 'ai') + (artU4 && isUploadLineage(artU4) ? '&file=' + encodeURIComponent(artU4) : '');
    });
    /* C79: kill every veil before showing - the arrival veil was covering
       this modal, leaving the customer on an endless spinner. */
    try { hidePageLoader(); } catch (e79g) {}
    try { var vj79b = document.getElementById('np-modejump-veil'); if (vj79b) vj79b.remove(); } catch (e79h) {}
    try { document.querySelectorAll('.loadingScreen__').forEach(function (l79b) { l79b.remove(); }); } catch (e79i) {}
    try { document.documentElement.classList.add('np-ready'); } catch (e89b) {} /* C89: releases html.np-arriving cover AND the modejump veil's hold loop */
    uploadRecoEl.hidden = false;
  }
  function openDenseReco(modeD) {
    /* C78 (2026-08-31): dense pictorial art (densePictorialLikely) — material
       aware like openFdReco: molded products offer Full Color only (P&S does
       not mold); stitchable products offer BOTH Full Color and Print & Stitch
       (Justin: "should have recommended full color and print and stitch"). */
    if (/^(rubber-pvc-2-0|keychains-2-0|silicone-2-0)$/.test(TYPE_KEY)) openUploadReco(
      'HIGH-DETAIL ARTWORK',
      'Your art is packed with detail — let’s keep all of it',
      'Detail this fine won’t hold in molded material at patch size. A <b>Full Color Printed Patch</b> keeps every bit of it crisp and true — we’ll take you right to it.',
      'Continue with Full Color',
      '/products/sublimated-patches',
      modeD,
      null,
      { keep: true, short: true } /* C422 */
    );
    else openUploadReco(
      'HIGH-DETAIL ARTWORK',
      'Your art is packed with detail — let’s keep all of it',
      'Detail this fine won’t hold in embroidery thread at patch size. <b>Full Color Printed</b> keeps every bit of it crisp — or <b>Print &amp; Stitch</b> prints the fine detail and embroiders the rest. We’ll take you right to it.',
      'Continue with Full Color',
      '/products/sublimated-patches',
      modeD,
      { label: 'Print & Stitch instead', handle: '/products/print-stitch-patches' },
      { keep: true, short: true } /* C422 */
    );
  }
  var fcConfirmEl = null;
  function openFcConfirm(picked) {
    /* forced conversions need an explicit sign-off: the customer must
       acknowledge the Embroidered -> Full Color switch before continuing */
    if (!fcConfirmEl) {
      fcConfirmEl = document.createElement('div');
      fcConfirmEl.className = 'np-e2-ov np-e2-ov--fcc';
      fcConfirmEl.innerHTML = '<div class="np-e2-modal np-e2-modal--fcc">' +
        '<header class="np-e2-modal__head"><div><span class="np-e2-modal__eyebrow np-e2-fcc-eyebrow">PLEASE CONFIRM</span>' +
        '<h3 class="np-e2-modal__title">We converted your patch to Full Color</h3></div></header>' +
        '<div class="np-e2-modal__body">' +
        '<p class="np-e2-fcc-txt">Your image is a photograph or highly detailed image, and that level of detail can\u2019t be stitched in embroidery thread. We generated your proof as a <b>Full Color Printed Patch</b> \u2014 the only way to produce this image.</p>' +
        '<p class="np-e2-fcc-txt">By continuing, you approve this proof and the switch from Embroidered to Full Color Printed.</p>' +
        '</div>' +
        '<footer class="np-e2-modal__foot"><button type="button" class="np-e2-btn np-e2-btn--outline" data-fcc-cancel>Go back</button>' +
        '<div class="np-e2-modal__footright"><button type="button" class="np-e2-btn np-e2-btn--green" data-fcc-ok>I understand \u2014 Continue with Full Color</button></div></footer></div>';
      (document.getElementById('np-e2') || document.body).appendChild(fcConfirmEl);
      fcConfirmEl.querySelector('[data-fcc-cancel]').addEventListener('click', function () { fcConfirmEl.hidden = true; });
      fcConfirmEl.querySelector('[data-fcc-ok]').addEventListener('click', function () {
        fcConfirmEl.hidden = true;
        st.fcConfirmed = true; /* signed off — don't ask again this session */
        if (fcConfirmEl.__pick) switchToFullColor(fcConfirmEl.__pick);
      });
    }
    fcConfirmEl.__pick = picked;
    fcConfirmEl.hidden = false;
  }
  function switchToFullColor(v) {
    /* they chose the Full Color proof: drop the embroidered line from the
       cart and hand off to the Full Color PDP with the approved proof */
    var notes = formProp('_Revision Notes') || '';
    var go = function () {
      /* the PROOF travels as the working file (file=) so the FC page shows
         and sells the approved render; the ORIGINAL upload rides separately
         (np_art) and is restored into _Original Image on arrival */
      var tgtView = v.altKind === 'woven' ? 'woven-2-0' : (v.altKind === 'ps' ? 'print-and-stitch-2-0' : 'fullcolor-2-0');
      /* LINEAGE GUARD (PATCH-2106464/68): artworkUrl() can be clobbered by
         legacy timers mid-session — an np_art that doesn't share the proof's
         original-upload suffix is NOT this customer's artwork. Send nothing
         rather than someone else's image. */
      var npArtV = cleanUrl(artworkUrl());
      if (!sameLineage(npArtV, v.hosted)) npArtV = '';
      var qs = '?view=' + tgtView + '&np_proof=' + encodeURIComponent(v.hosted || '') +
        '&np_art=' + encodeURIComponent(npArtV) +
        '&np_w=' + st.w.toFixed(2) + '&np_h=' + st.h.toFixed(2) + '&np_qty=' + st.qty +
        (notes ? '&np_notes=' + encodeURIComponent(notes.slice(0, 400)) : '') +
        '&np_conv=' + encodeURIComponent(st.fdChoice || st.fcForcedReason || (st.fcForced ? 'photo' : '')) +
        '&np_pp=' + encodeURIComponent((st.proofMode === 'digital' || st.proofMode === 'stitch') ? st.proofMode : '') +
        '&np_shape=' + encodeURIComponent(st.shape || '') +
        '&np_corners=' + encodeURIComponent(st.corners || '') +
        '&np_bgl=' + encodeURIComponent(st.bg ? st.bg.label : '') +
        '&np_thl=' + encodeURIComponent(st.thread ? st.thread.label : '') +
        '&np_txl=' + encodeURIComponent(st.text ? st.text.label : '') +
        '&np_bgh=' + encodeURIComponent((st.bg && st.bg.hex) || '') + '&np_thh=' + encodeURIComponent((st.thread && st.thread.hex) || '') + '&np_txh=' + encodeURIComponent((st.text && st.text.hex) || '') + /* C180 */
        '&np_bsl=' + encodeURIComponent(st.border ? st.border.label : '') +
        '&np_bkl=' + encodeURIComponent(st.backing ? st.backing.label : '') +
        '&file=' + encodeURIComponent(v.hosted || cleanUrl(artworkUrl()));
      window.location.href = '/products/' + (v.altKind === 'woven' ? 'woven-patches' : (v.altKind === 'ps' ? 'print-stitch-patches' : 'sublimated-patches')) + qs;
    };
    if (sensei.added && sensei.lineItemId) {
      cartJson().then(function (cart) {
        var line = ourCartLine(cart); /* the key drifts after every props change — refresh before zeroing */
        if (!line) return;
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: line.key, quantity: 0 }) });
      }).then(go).catch(go);
    } else go();
  }
  function renderSizing() {
    /* Phase 3 — Size and pricing, inside the same modal after approval.
       The approved proof is the product image; steppers/tiers/checkout all
       live here (no pricing anywhere on the page). */
    hidePageLoader(); /* any path landing here clears the skip-path loader */
    st.proofPhase = 'sizing';
    if (pdpPricingOn()) {
      /* STAGING: pricing IS on the page — the modal never shows a sizing
         phase. A skip-path arrival goes straight to checkout (size and qty
         were already chosen on the page). */
      if (st.__skipCheckout) {
        /* skip lands on the FINAL REVIEW: approved digital summary with the
           stitchout add-on and Add to Cart — never an auto-checkout (it was
           holding the customer on the adding-veil, Justin 2026-08-24) */
        st.__skipCheckout = false;
        var apSk = $('#np-e2-approved');
        if (apSk) apSk.hidden = false;
        var srSk = document.getElementById('np-e2-stitchrow');
        if (srSk) { try { srSk.hidden = !stitchAddonEligible(); } catch (eSk) {} }
        if (apSk) {
          var landSk = function () { npFocusFinalTop(); };
          setTimeout(landSk, 150); setTimeout(landSk, 650); setTimeout(landSk, 1300);
        }
      }
      var wasModalG = !pf.hidden;
      pf.hidden = true;
      /* on the FINAL STEP the review page stands alone — step 3 (pricing)
         and everything below it leave the page (Justin 2026-08-24) */
      document.body.classList.toggle('np-e2-final', !!st.proofApproved);
      var szG0 = $('#np-e2-pf-sizing'); if (szG0) szG0.hidden = false;
      if (st.proofApproved) {
        var apG0 = $('#np-e2-approved');
        if (apG0) apG0.hidden = false;
        var srG0 = document.getElementById('np-e2-stitchrow');
        if (srG0) { try { srG0.hidden = !stitchAddonEligible(); } catch (eSg) {} }
        /* an approval just closed the modal — land the customer ON the
           final step (Review and Submit), not wherever they were */
        if (wasModalG && apG0) {
          /* the final-step class COLLAPSES step-3 + the tier rail above this
             card — a single early scroll gets stranded at the page bottom
             when the layout shifts. Land, then re-land as it settles. */
          var landTop = function () {
            var yF = apG0.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
            window.scrollTo({ top: Math.max(0, yF), behavior: 'smooth' });
          };
          setTimeout(landTop, 150); setTimeout(landTop, 650); setTimeout(landTop, 1300);
        }
      }
    } else {
      pf.hidden = false;
      $('#np-e2-pf-loading').hidden = true;
      $('#np-e2-pf-ready').hidden = true;
      var er = $('#np-e2-pf-error'); if (er) er.hidden = true;
      var hn = $('#np-e2-pf-headnotice'); if (hn) hn.hidden = true;
      var sz = $('#np-e2-pf-sizing'); if (sz) sz.hidden = false;
      var eb = $('#np-e2-pf-eyebrow'); if (eb) eb.textContent = 'STEP 3 OF 3';
      $('#np-e2-pf-title').textContent = 'Size and pricing';
      var panel = pf.querySelector('.np-e2-modal'); if (panel) panel.classList.add('is-sizing');
    }
    var idx = (st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected;
    var v = st.versions[idx];
    var img = $('#np-e2-sz-img');
    /* digital proofs fill their canvas edge-to-edge — shrink the display so
       the rulers get breathing room instead of hugging the stage */
    var szStageD = document.getElementById('np-e2-sz-stage');
    if (szStageD) szStageD.classList.toggle('is-digital', !!(v && v.digital));
    var centerSz = function () {
      var szImgD = document.getElementById('np-e2-sz-img');
      if (szImgD) centerPatchInBox(szImgD, szImgD.currentSrc || szImgD.src);
    };
    setTimeout(centerSz, 120);
    setTimeout(centerSz, 700);
    var szSrc = (v && (v.alpha || v.dataUrl || v.hosted)) || cleanUrl(artworkUrl()) || '';
    if (pdpPricingOn() && !st.proofApproved && !st.versions.length) {
      var pvM = document.querySelector('.np-e2-maskprev img');
      if (pvM && pvM.src) szSrc = previewFlatSrc(pvM); /* the live digital preview — flat (C168) */
    }
    if (img) {
      if (!img.__npDimWired) { img.__npDimWired = true; img.addEventListener('load', function () { positionDims(); }); }
      img.src = szSrc;
    }
    var szStage = $('#np-e2-sz-stage');
    if (szStage) {
      szStage.classList.toggle('is-alpha', isAlphaSrc(szSrc)); /* first guess, corrected below */
      npPixelHasAlpha(szSrc, function (has) {
        if (has === null) return; /* could not read the pixels — keep the guess */
        szStage.classList.toggle('is-alpha', has);
      });
      npArtIsLight(szSrc, function (lite) { szStage.classList.toggle('is-lightart', lite); }); /* C30 */
    }
    var cap = $('#np-e2-sz-cap');
    if (cap) cap.textContent = (v && v.fallbackUpload)
      ? (v.fallbackDigital ? 'Your digital preview · specialist proof to follow' : 'Your uploaded design · specialist proof to follow')
      : (v && v.digital ? ('Approved proof · digital-proof.png' + (st.proofMode === 'stitch' ? ' · real stitchout to follow' : '')) : 'Approved proof · ai-proof-v' + (idx + 1) + '.png');
    var szRev = document.getElementById('np-e2-sz-review');
    if (szRev) szRev.hidden = !!(v && v.digital); /* nothing to regenerate on digital/stitchout */
    if (pdpPricingOn() && !st.proofApproved && !st.versions.length) {
      if (cap) cap.textContent = 'Your digital preview \u2014 updates live as you build';
      if (szRev) szRev.hidden = true;
    }
    renderPricing();
  }

  function approveProof() {
    if (st.selected === null || st.selected === undefined) return;
    var picked = st.versions[st.selected];
    /* C427: a proof made for OTHER selections can never be approved for these (PATCH-2115499) */
    if (picked && designChangedSince(picked)) {
      try { coMark('approve-stale-blocked'); } catch (eAb427) {}
      npToast('Your selections changed since this proof. Regenerate to see them, then approve.');
      renderProofReady();
      return;
    }
    if (picked && st.fdChoice === 'ps' && !onTargetProduct({ altKind: 'ps' })) {
      /* Print & Stitch is its OWN product — approving hands off to it */
      picked.altKind = 'ps';
      switchToFullColor(picked);
      return;
    }
    if (picked && picked.fullColor && !onTargetProduct(picked)) {
      if (st.fcForced && !st.fcConfirmed) { openFcConfirm(picked); return; }
      switchToFullColor(picked);
      return;
    }
    var notes = formProp('_Revision Notes') || '';
    var v = st.versions[st.selected];
    st.proofApproved = true; try { prewarmAlphaForCart(); } catch (ePW2) {}
    /* record the approval in patch-sensei (same as the proof-preview page) */
    if (sensei.sessionId) {
      var approvedNote = (notes ? notes + ' ' : '') + '(approved AI render v' + (st.selected + 1) + ')';
      var keepRender = sensei.renderLineId;
      sensei.renderLineId = sensei.lineItemId; /* decision targets the real cart line */
      try { senseiDecide('approved', approvedNote); } catch (e) {}
      sensei.renderLineId = keepRender;
    }
    /* cart contract: proof + original both on the line; proof is the thumbnail.
       The line is ALREADY in the cart (added at generate time), so write the
       proof properties + current qty onto the LINE via /cart/change.js —
       form-level setProp only affects future adds. */
    /* _AI Proof = the production mockup; _cartImg = the TRANSPARENT imgix
       copy so the cart shows just the patch on the checkerboard */
    if (v.hosted) { setProp('_AI Proof', v.frozenProof || v.hosted); setProp('_cartImg', digitalCartUrl(v.alpha || v.hosted)); }
    if (v.hosted && !v.frozenProof) {
      freezeProofCopy(v.hosted, (TYPE_KEY || 'patch') + '--v' + (st.selected + 1), function (uF) {
        if (!uF) return;
        v.frozenProof = uF;
        setProp('_AI Proof', uF);
        if (sensei.added) lineSync({ '_AI Proof': uF });
      });
    }
    setProp('_Proof Version', 'v' + (st.selected + 1));
    if (v.fallbackUpload) setProp('_AI Proof Status', 'AI GENERATION FAILED - specialist proof required');
    if (notes) setProp('_Revision Notes', notes);
    /* arm the background pre-add + sheet stamper the moment approval lands —
       the sheets must be ON the line well before any Add to Cart click */
    try { coMark('approved'); } catch (eAb) {}
    try { commitSizeQty(); } catch (eShA) {}
    if (sensei.added) cartJson().then(function (cart) {
      /* legacy path: only when a line already exists (e.g. Add another) —
         normally the props above ride the final Add to Cart */
      var line = ourCartLine(cart);
      if (!line) return;
      var props = {};
      Object.keys(line.properties || {}).forEach(function (k) { if (k.indexOf('_Border Style') !== 0) props[k] = line.properties[k]; });
      /* current option values win (customer may have edited selections since the add) */
      if (stepEnabled('shape') || PTYPE.foldShapes) props['_Shape'] = st.shape || ''; /* C165 */
      if (stepEnabled('border') && st.shape && st.border) props['_Border Style'] = normalizeBorder(st.border.label);
      if (stepEnabled('fold') && st.fold) props['_Fold Style'] = st.fold.label; /* C164 */
      if (stepEnabled('bg')) props[PTYPE.bgProp || PTYPE.bgLabel || '_Background Color'] = propColor(st.bg); /* C180 */
      if (stepEnabled('thread')) props[PTYPE.threadProp || PTYPE.threadLabel || '_Border Color'] = propColor(st.thread);
      if (stepEnabled('text')) props[PTYPE.textProp || '_Text Color'] = propColor(st.text);
      props['_Select Your Backing'] = st.backing ? st.backing.label : '';
      if (stepEnabled('texture')) props['_Background Texture'] = st.texture ? st.texture.label : '';
      props['_Width (in)'] = st.w.toFixed(2);
      props['_Height (in)'] = st.h.toFixed(2);
      applyReorder555(props); /* C555 */
      if (v.hosted) { if (v.digital) { if (v.frozenProof) props['_Mockup Catalog'] = v.frozenProof; } else props['_AI Proof'] = v.frozenProof || v.hosted; props['_cartImg'] = digitalCartUrl(v.alpha || v.hosted); }
      if (v.fallbackUpload) props['_AI Proof Status'] = 'AI GENERATION FAILED - specialist proof required';
      props['_Proof Version'] = 'v' + (st.selected + 1);
      if (notes) props['_Revision Notes'] = notes;
      ['Design Notes', '_Revision Notes'].forEach(function (k) { var fv = formProp(k); if (fv) props[k] = fv; });
      delete props['AI Edit']; /* the edited artwork is the record, not the prompt */
      stripBlockedProps(props); /* order admin never receives the blocked set */
      props = orderPropsObj(props);
      sensei.__lineSnap = { line: (cart.items || []).indexOf(line) + 1, props: props };
      try { fireSheetStamp(); } catch (eFa) {}
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: line.key, quantity: st.qty, properties: props })
      }).then(function (r) { return r.json(); }).then(function (c2) { ourCartLine(c2); }); /* property change re-keys the line */
    }).catch(function (e) { console.warn('[np-emb2] cart line update failed', e); });
    /* approved UI */
    $('#np-e2-approved').hidden = false;
    $('#np-e2-cart-thumb').src = v.alpha || v.dataUrl || artworkUrl();
    var thumbBox = document.querySelector('.np-e2-cartrow__thumb');
    if (thumbBox) thumbBox.classList.toggle('is-alpha', !!(v.alpha || isAlphaSrc(v.dataUrl || '')));
    /* C33: the cart-preview thumb shows the same artwork and had the same
       white-on-light problem. */
    if (thumbBox) {
      var tSrcL = v.alpha || v.dataUrl || artworkUrl();
      npArtIsLight(tSrcL, function (lite) { thumbBox.classList.toggle('is-lightart', lite); });
    }
    $('#np-e2-cart-line').textContent = [
      v.shape,
      st.border ? st.border.label + ' border' : null,
      (stepEnabled('fold') && st.fold) ? st.fold.label : null, /* C164 */
      v.bg ? v.bg.label + (isLeather() ? '' : ' background') : null,
      v.thread ? v.thread.label + ' thread' : null,
      v.backing ? v.backing.label : null
    ].filter(Boolean).join(' \u00b7 ');
    var pfl2 = $('#np-e2-prooffile'); if (pfl2) pfl2.textContent = v.fallbackUpload ? 'specialist proof to follow' : ('ai-proof-v' + (st.selected + 1) + '.png');
    renderOptions();
    renderApprovedCanvas(); /* the page behind: proof + compare slider in the preview */
    /* the modal stays open: approval leads straight into size & pricing */
    renderSizing();
  }

  /* ---- checkout & add-another ---- */
  function syncCartLine() {
    try { setProp('_Proof Approval', proofApprovalLabel()); } catch (ePA2) {}
    /* v2 flow: sizing happens AFTER the line is in the cart (it was added at
       generate time with the seeded size and default qty). The final size can
       cross a variant/price boundary — /cart/change.js can't swap variants,
       so on a variant change the line is re-added with its properties. */
    commitOptions(); commitSizeQty();
    coMark('sync-read');
    return cartJson().then(function (cart) {
      coMark('sync-got');
      var line = ourCartLine(cart);
      if (!line) return cart;
      var v = nearestVariant();
      var props = {};
      Object.keys(line.properties || {}).forEach(function (k) { props[k] = line.properties[k]; });
      props['_Width (in)'] = st.w.toFixed(2);
      props['_Height (in)'] = st.h.toFixed(2);
      applyReorder555(props); /* C555 */
      /* C124: a line REWRITE must not re-stamp (or carry) the proof/artwork
         ghosts onto a no-artwork patch */
      if (PTYPE.noArt) NOART_STRIP_C124.forEach(function (kNA) { delete props[kNA]; });
      else props['_Proof Approval'] = proofApprovalLabel();
      /* current option values win (B43) — same contract as the approval
         branch: a post-approval edit must reach the LINE */
      var optDrift = false;
      try {
        var optMap = {};
        if (stepEnabled('shape') || PTYPE.foldShapes) optMap['_Shape'] = st.shape || ''; /* C165 */
        if (stepEnabled('border') && st.shape && st.border) optMap['_Border Style'] = normalizeBorder(st.border.label);
        if (stepEnabled('fold') && st.fold) optMap['_Fold Style'] = st.fold.label; /* C164 */
        if (stepEnabled('bg')) optMap[PTYPE.bgProp || PTYPE.bgLabel || '_Background Color'] = propColor(st.bg); /* C180 */
        if (stepEnabled('thread')) optMap[PTYPE.threadProp || PTYPE.threadLabel || '_Border Color'] = propColor(st.thread);
        if (stepEnabled('text')) optMap[PTYPE.textProp || '_Text Color'] = propColor(st.text);
        optMap['_Select Your Backing'] = st.backing ? st.backing.label : '';
        if (stepEnabled('texture')) optMap['_Background Texture'] = st.texture ? st.texture.label : '';
        Object.keys(optMap).forEach(function (kO) {
          if (optMap[kO] && String(props[kO] || '') !== String(optMap[kO])) { props[kO] = optMap[kO]; optDrift = true; }
        });
      } catch (eOD) {}
      if (digitalNoRender()) delete props['_AI Proof'];
      /* C427: the selected render was made for OTHER selections — it must not ride the line as the proof */
      try { var vSt427 = (st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null; if (vSt427 && designChangedSince(vSt427)) { delete props['_AI Proof']; coMark('stale-proof-dropped'); } } catch (eSt427) {}
      var avs = (st.proofApproved && st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
      if (avs && avs.alpha) props['_cartImg'] = digitalCartUrl(avs.alpha); /* flattened imgix copy always wins */
      props = orderPropsObj(props);
      if (v && v.id !== line.variant_id) {
        /* ADD the replacement line FIRST, only then zero the old one — a
           failed re-add must never delete the customer's patch */
        var fd = new FormData();
        fd.set('id', String(v.id));
        fd.set('quantity', String(st.qty));
        Object.keys(props).forEach(function (k) { fd.set('properties[' + k + ']', props[k] == null ? '' : props[k]); });
        rememberMode('ai'); /* mode memory follows the last ADD TO CART */
        coMark('sync-readd');
        return cleanFetch()('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) throw new Error('variant re-add failed ' + r.status);
            return cleanFetch()('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
              body: JSON.stringify({ id: line.key, quantity: 0 })
            });
          })
          .then(function () { return cartJson(); }).then(function (c2) {
            /* C427: the first same-variant, same-width line can be ANOTHER patch; re-find ours by its render */
            sensei.lineItemId = null; sensei.__addKey = null;
            var mine = ourCartLine(c2);
            try { sensei.__lineVariant = String(v.id); } catch (eLV2) {}
            try { sensei.__lineState = curLineState(); } catch (eLS2) {}
            return c2;
          });
      }
      if (optDrift || line.quantity !== st.qty ||
          (line.properties || {})['_Width (in)'] !== props['_Width (in)'] ||
          (line.properties || {})['_Height (in)'] !== props['_Height (in)']) {
        coMark('sync-change');
        sensei.__lineSnap = { line: (cart.items || []).indexOf(line) + 1, props: props };
        return cleanFetch()('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
          body: JSON.stringify({ id: line.key, quantity: st.qty, properties: props })
        }).then(function (r) { return r.json(); }).then(function (c2) { ourCartLine(c2); try { sensei.__lineState = curLineState(); } catch (eLS3) {} return c2; });
      }
      try { sensei.__lineState = curLineState(); } catch (eLS4) {}
      return cart;
    }).catch(function (e) { console.warn('[np-emb2] cart sync failed', e); });
  }
  /* B79 (2026-08-25) — PRE-WARM the transparent copy. Hosting it is the single
     most expensive thing the add click used to do, so start it the moment the
     customer approves a proof: by the time they finish size and quantity it is
     cached on the version and ensureAlphaForCart resolves on its v.alpha guard.
     Fire-and-forget by design — never blocks, never surfaces an error. */
  /* B84 (2026-08-25) — THE TRANSPARENT CART IMAGE IS OFF.
     hostMockup() does a LOCAL pixel cut (flood fill / shape mask / geometry
     pass) over a full-size canvas, entirely synchronous on the main thread.
     Measured on Justin's add: 17,868ms with plain timers ticking 0 times out of
     an expected 179, worker callbacks 1, zero network traffic, tab visible the
     whole time — the signature of a jammed thread, not a slow request. The POST
     was never slow (627-932ms in every isolated test); its .then() simply could
     not run. Moving the cut off the click just moved the jam into the add.
     Justin, verbatim: "the cart image having background is NOT IMPORTANT if
     that is whats stalling this." So it is switched off. The cart thumbnail
     keeps its studio backdrop; the ORDER is unaffected (the line still carries
     _AI Proof, _Upload and _Original Image). Flip this to true to restore it —
     but move the cut into a Worker or an OffscreenCanvas first, or it will
     jam the thread again. */
  function prewarmAlphaForCart() {
    if (!NP_ALPHA_CUT) return;
    try {
      var v = (st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
      if (!v || v.alpha || v.fallbackUpload || !v.hosted || isAlphaSrc(v.hosted)) return;
      if (v.__alphaWarming) return;
      v.__alphaWarming = true;
      hostMockup(v.dataUrl || v.hosted, function (u) {
        v.__alphaWarming = false;
        if (u) { v.alpha = u; try { setProp('_cartImg', digitalCartUrl(u)); } catch (eSP) {} }
      });
    } catch (ePW) {}
  }
  function ensureAlphaForCart() {
    /* the cart image must be the TRANSPARENT IMGIX copy, never the raw S3
       mockup — wait (bounded) for the re-host before the line is created */
    return new Promise(function (resolve) {
      if (!NP_ALPHA_CUT) { resolve(); return; } /* B84: never block the add on a pixel cut */
      var v = (st.proofApproved && st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : null;
      if (!v || v.alpha || v.fallbackUpload || !v.hosted || isAlphaSrc(v.hosted)) { resolve(); return; }
      /* B79 (2026-08-25): this used to hold the ADD CLICK for up to 12 SECONDS
         waiting on an image upload. Measured on Justin's session: 12,356ms of a
         17.8s add, versus 71ms for all the rest of our code. The transparent
         cart image is COSMETIC — the order line still carries _AI Proof,
         _Upload and _Original Image either way — so it is never worth making a
         customer wait. Cap the click at 900ms; if the host has not landed by
         then, let it finish in the BACKGROUND and stamp _cartImg if it arrives.
         prewarmAlphaForCart() (fired at proof approval) means it is normally
         already done and this resolves instantly on the v.alpha guard above. */
      /* B80 (2026-08-25) — Justin, verbatim: "the cart image having background is
         NOT IMPORTANT if that is whats stalling this". So the click NEVER waits
         on it. Kick the host off in the background and resolve immediately: zero
         click cost, and prewarmAlphaForCart() (fired at approval) means the
         transparent copy is usually already cached on the version anyway, in
         which case the v.alpha guard above returns before we ever get here. */
      hostMockup(v.dataUrl || v.hosted, function (u) {
        if (u) { v.alpha = u; try { setProp('_cartImg', digitalCartUrl(u)); } catch (eSP3) {} }
      });
      resolve();
    });
  }
  /* ═══ NAMES ROSTER (custom-names) — the patches ARE the names, so the
     roster drives the quantity, and Add to Cart stays locked until the
     product's piece minimum is genuinely typed in. Writes the EXISTING
     line-item property the live product already collects. ═══ */
  function namesMin() { return PTYPE.namesMin || QTY_MIN; }
  function namesList() {
    var ta = document.getElementById('np-e2-names-ta');
    if (!ta) return [];
    /* commas OR newlines — customers paste both */
    return ta.value.split(/[\n,]+/).map(function (x) { return x.trim(); }).filter(function (x) { return !!x; });
  }
  function renderNames() {
    var card = document.getElementById('np-e2-names');
    if (!card) return;
    var list = namesList(), min = namesMin(), ok = list.length >= min;
    var cnt = document.getElementById('np-e2-names-count');
    if (cnt) {
      /* short: red with the minimum spelled out; met: green, suffix dropped.
         Dip back under and the suffix returns with the red. */
      cnt.textContent = list.length + ' of ' + min + ' names' + (ok ? '' : ' (' + min + 'pc minimum)');
      cnt.classList.toggle('is-ok', ok);
    }
    var entN = document.getElementById('np-e2-nr-entries');
    if (entN) entN.textContent = list.length + (list.length === 1 ? ' entry' : ' entries');
    /* the countdown carries the minimum message now — no separate banner */
    var btnN = document.getElementById('np-e2-names-atc');
    if (btnN) btnN.disabled = !ok;
    /* one patch per name */
    st.qty = Math.max(min, list.length);
    setProp(PTYPE.namesProp || 'List of Names (Separate by Comma)', list.join(', '));
    var pN = pricing();
    var totN = document.getElementById('np-e2-names-total');
    if (totN) totN.textContent = money(pN.unit * st.qty);
    var subN = document.getElementById('np-e2-names-sub');
    if (subN) subN.textContent = st.qty + ' pcs \u00b7 ' + money(pN.unit) + ' ea';
    commitSizeQty();
  }
  function revealNames() {
    var card = document.getElementById('np-e2-names');
    if (!card) return;
    card.hidden = false;
    renderNames();
    try { nrRenderRows(); } catch (eNR) {} /* the grid tab opens ready to type */
    setTimeout(function () {
      var yN = card.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
      window.scrollTo({ top: Math.max(0, yN), behavior: 'smooth' });
    }, 60);
  }

  var coBusy = false;
  /* C508 (Justin 2026-10-21, PATCH-2122661: "Make them regenerate: a short note ('Your saved proof used a border we no longer offer
     — regenerate to see it with No Border'), and no Add to Cart until a new proof is made"). A My Proofs re-order whose proof was
     rendered with a border this product no longer offers (e.g. Hot Cut on Full Color, retired by C502) used to check out with the
     old picture next to the new border. While that re-order proof is still the selected version, Add to Cart stays locked and a
     note + "Regenerate proof" replace it; the first new proof (current selections) unlocks it. */
  function bNorm508(l) { return String(l || '').toLowerCase().replace(/\(.*?\)/g, '').replace(/\s+/g, ' ').trim(); }
  function reorderBorderStale508() {
    var rv = st.__reorderV508, was = bNorm508(st.__reorderBsl508);
    if (!rv || !was || !stepEnabled('border')) return false;
    var selV = st.versions[(st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected];
    if (selV !== rv) return false; /* a new proof exists — it shows the current border */
    return !effectiveBorders().some(function (b) { return bNorm508(b.label) === was; });
  }
  function note508Text() {
    var now = st.border && st.border.label;
    return 'Your saved proof used a border we no longer offer \u2014 regenerate to see it with ' + (now ? now : 'your new border') + '.';
  }
  function regen508() {
    if (!st.border && effectiveBorders().length) { /* pick the border first, then regenerate */
      var bI = WZ_STEPS.indexOf('border');
      try { pf.hidden = true; } catch (ePf508) {}
      if (bI !== -1) openAcc(bI);
      try { npToast('Choose a border, then regenerate your proof'); } catch (eT508) {}
      return;
    }
    try { regenerateWithNotes(''); } catch (eR508) {}
  }
  function sync508() {
    var on = reorderBorderStale508();
    ['np-e2-checkout', 'np-e2-sz-checkout'].forEach(function (id) {
      var b = document.getElementById(id);
      if (!b) return;
      var n = document.getElementById(id + '-508');
      if (on) {
        if (!n) {
          n = document.createElement('p');
          n.id = id + '-508';
          n.className = 'np-e2-szf__msg';
          n.setAttribute('data-state', 'block');
          n.setAttribute('role', 'status');
          b.parentNode.insertBefore(n, b);
        }
        var t = note508Text();
        if (n.getAttribute('data-t') !== t) {
          n.setAttribute('data-t', t);
          n.textContent = t + ' ';
          var g = document.createElement('button');
          g.type = 'button'; g.className = 'np-e2-szf__fix'; g.textContent = 'Regenerate proof';
          g.addEventListener('click', function (e) { e.preventDefault(); regen508(); });
          n.appendChild(g);
        }
        n.hidden = false;
        b.setAttribute('data-np508', '1'); b.disabled = true; /* re-asserted: the size check re-enables it on its own schedule */
      } else {
        if (n) n.hidden = true;
        if (b.hasAttribute('data-np508')) { b.removeAttribute('data-np508'); b.disabled = b.classList.contains('is-szf-blocked'); } /* hand back to the size check */
      }
    });
  }
  if (!window.__np508t) window.__np508t = setInterval(function () { try { if (st.__reorderV508) sync508(); } catch (eS508) {} }, 700);
  function doCheckout() {
    /* "Add to Cart": the ONE cart mutation in the flow — the line lands with
       its final variant, qty, and every property (proof, original, options,
       notes), then the customer reviews it on /cart. Locked + instant button
       feedback: the alpha wait made double-clicks double-add. */
    if (coBusy) return;
    /* C476: a backing the Full Color Velcro rule dropped (custom shape / Hot Cut — e.g. Hook & Loop carried over from the
       Embroidered builder) is asked for again here; the line never lands without one.
       C493 (Justin 2026-10-13, PATCH-2119875 — and PATCH-2119086 / PATCH-2113685 before it: Full Color lines with NO Border
       Style): an approved proof that arrives from elsewhere (the Embroidered builder's Full Color switch, My Designs / My
       Proofs, the Mockup Lab, Patch Express) brings only the options that match this product, and Add to Cart never asked
       for the rest. Now a missing shape, border or backing is asked for here, the same way. A first pick keeps the proof
       approved (specsChangedSince ignores what the approved version never had). */
    try { commitOptions(); } catch (eC476) {}
    var need493 = (stepEnabled('shape') && !st.shape) ? 'shape'
      : (stepEnabled('border') && !st.border && effectiveBorders().length) ? 'border'
      : (stepEnabled('backing') && !st.backing && effectiveBackings().length) ? 'backing' : null;
    if (need493) {
      try { pf.hidden = true; } catch (ePf476) {}
      var bkI476 = WZ_STEPS.indexOf(need493);
      if (bkI476 !== -1) {
        openAcc(bkI476);
        setTimeout(function () {
          var r476 = document.querySelector('.np-e2-accrow[data-e2-acc="' + bkI476 + '"]');
          if (r476) window.scrollTo({ top: Math.max(0, r476.getBoundingClientRect().top + window.pageYOffset - npScrollPad()), behavior: 'smooth' });
        }, 60);
      }
      try {
        npToast(need493 === 'backing' && npNoVelcroFor(st.border, st.shape) ? 'Choose a backing \u2014 Hook & Loop isn\u2019t available on this patch'
          : 'Choose a ' + (need493 === 'shape' ? 'shape' : need493 === 'border' ? 'border' : 'backing') + ' for your patch to add it to your cart');
      } catch (eT476) {}
      return;
    }
    if (reorderBorderStale508()) { /* C508: no Add to Cart with a proof that shows a border we no longer offer */
      try { sync508(); npToast(note508Text()); } catch (eT508) {}
      return;
    }
    coBusy = true;
    var btn = document.getElementById(PTYPE.names ? 'np-e2-names-atc' : 'np-e2-checkout');
    var oldLabel = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding to cart…'; }
    showPageLoader('Finalizing Order & Adding to Cart\u2026');
    /* stage beacons (911 debug 2026-08-24): window.__npCoStage names the last
       stage reached — read it when an add hangs */
    var coStage = function (n) { try { var tMs = Math.round(performance.now()); window.__npCoStage = n + ' @' + Math.round(tMs / 1000); if (n.indexOf('start') === 0) localStorage.setItem('np_co_log', ''); localStorage.setItem('np_co_log', (localStorage.getItem('np_co_log') || '') + n + '@' + tMs + 'ms | '); console.log('[np-e2] checkout stage', n, tMs + 'ms'); } catch (eCs) {} };
    /* nothing may compose during the click — a pending background sheet
       stamp would race the add and jam the thread */
    commitSizeQty.__sheetGen = (commitSizeQty.__sheetGen || 0) + 1; /* cancels any pending background fire */
    commitSizeQty.__sheetPend = false; commitSizeQty.__armTok = null;
    /* C02 (2026-08-25) — SETTLE THE SPEC BEFORE COMPOSING.
       The sheet is fingerprinted (specDkToken) against the form's spec fields,
       and the cart-line gate re-computes that fingerprint at write time. Those
       fields are finalised inside ensureInCartNow() — which runs AFTER this —
       so the sheet was composed from pre-final values and was CORRECTLY judged
       stale every time. Measured: sheetgate[pre:y|dkMatch:n|ai:y|up:y] with
       dkdrift[Width (in), Upload, Original Image, cartImg, AI Model]. Both
       sheets composed fine in 566-850ms and were thrown away, which is why
       Justin saw specs on NEITHER property.
       Write the same values ensureInCartNow will write, THEN compose, so both
       sides fingerprint identically. Width matters most: composing early meant
       the sheet literally carried a stale size. */
    try { commitOptions(); commitSizeQty(); } catch (eCS2) {}
    if (!PTYPE.noArt) { /* C124 */
      try { setProp('_Proof Approval', proofApprovalLabel()); } catch (ePA2) {}
    }
    try {
      var artD = artOfRecord();
      var rawD = (artD || '').split('?')[0].split('&')[0];
      if (rawD) setProp('_Original Image', rawD); /* specDkToken keys off this input */
    } catch (eOI2) {}
    /* B97 (2026-08-25) — COMPOSE THE SHEETS NOW, don't just cancel the timer.
       The background stamper waits 1200ms before composing and this click
       cancels it. That was invisible while adds took 15s (the sheets finished
       inside that window anyway), but the add now completes in 433ms, so the
       sheets were never ready and the line shipped the RAW render — measured
       `sheets:not-ready`, _AI Proof 1536x1024 instead of a composed sheet.
       Kick the compose immediately, then wait a bounded moment for it below. */
    try {
      preComposeSheets();
      /* C04 (2026-08-25) — TRUST THE SHEET WE JUST BUILT.
         The dk fingerprint exists to stop a STALE pre-composed sheet being
         attached. It does not apply here: the spec is settled immediately
         above, then the sheet is composed from it, then we wait for it. Four
         rounds of chasing dkMatch:n were spent guarding against staleness that
         cannot exist on this path. Record the token this click composed with;
         the cart-line gate accepts that one as well as an exact match.
         Justin, verbatim: "when add to cart is clicked simply write these items
         onto the proof and the _upload for it to get into the shopify admin." */
      sensei.__clickDk = specDkToken(specLines(specFormProps()));
    } catch (ePCC) {}
    coStage('start:C136'); /* build tag — bump on every np-emb2 push */
    /* TIME-BOXED CHECKOUT + redirect (2026-08-24 final): add the line, give
       the build sheets ONE short bounded window, then land on /cart — target
       feel ~3s. specForAI() is GONE from the chain: nothing consumed its
       result (applySpecToLine composes its own sheets from the LINE), so it
       was a guaranteed dead wait in front of every single add. */
    var timebox = function (p, ms) {
      /* worker clock: a hidden tab froze the plain-setTimeout cap for 35s.
         B79 (2026-08-25): race BOTH clocks. Racing npTick alone meant a stalled
         worker left the cap unenforced — measured on Justin's 12,356ms add,
         where a 1200ms box lost to ensureAlphaForCart's own 12s timeout. */
      return Promise.race([
        Promise.resolve(p).catch(function () {}),
        new Promise(function (res) { npTick(res, ms); setTimeout(res, ms + 150); })
      ]);
    };
    /* ═══ B70 (2026-08-25, Justin): ADD TO CART IS A SIMPLE FINAL BUTTON ═══
       "add to cart should be a simple final button not a waiting period for
       our customers" — hard target 3 seconds.
       The click now does exactly three things: make sure the cart image is the
       transparent copy (usually already done, ~20ms measured), POST the line
       to /cart/add.js (0.48s and 0.89s measured on live), and navigate.
       EVERYTHING to do with build sheets is gone from this path — the compose,
       the upload, the freshness-token comparison, the poll loop, the
       applySpecToLine re-stamp and the __specBusy grace. Those were the entire
       14.5s / 16.1s measured on live and the cause of the "Finalizing Order &
       Adding to Cart" hang. Sheet generation itself is switched off at
       NP_SPEC_SHEETS. Order lines still carry _AI Proof (the approved render),
       _Upload (the composed preview) and _Original Image — only the drawn
       spec panel is gone. */
    /* B97: bounded wait for the composed sheets. specDkToken must match the
       FINAL size/qty, which is why these cannot simply be composed at approval
       — the customer picks size AFTER approving. Cap it so a stuck compose can
       never hold a customer: we ship the raw proof rather than hang, and the
       post-add lineSync still upgrades the line if the sheet lands late. */
    var waitSheets = waitSheetsBounded; /* C136: shared with the add-another bank */
    ensureCompositeForLine(9000).then(function () {
      /* C136: the sheets compose from the LINE — with the composite now hosted,
         re-point _Upload and recompose (a fresh base is never "already fresh") */
      try {
        var upC6 = sensei.composedCleanUrl || '';
        if (upC6) setProp('_Upload', toImgixHost(upC6));
        preComposeSheets();
        sensei.__clickDk = specDkToken(specLines(specFormProps()));
      } catch (eC36) {}
      return timebox(ensureAlphaForCart(), 1200);
    }).then(function () {
      coStage('alpha-done');
      /* C460: up to 6s, but ONLY while a sheet is still being built — ready sheets release it at once, a failed one too.
         The 2.5s window lost ~30% of sheets (measured 2,248ms on a fast desktop, i.e. a phone misses). */
      return waitSheets(6000);
    }).then(function () {
      /* B74 (2026-08-25): a real click measured 15,928ms on /cart/add.js while
         a bare fetch to the same endpoint from the same browser took 645ms.
         So the time is NOT Shopify serving — it is spent BEFORE the request is
         sent. Record the browser's own resource timing for the add so the next
         slow click says which phase ate it (queueing vs DNS/TLS vs server). */
      try {
        window.__npAddTiming = function () {
          try {
            /* B76: cleanFetch issues the add from a hidden IFRAME, and
               PerformanceResourceTiming is per-realm — so the entry lives in
               the iframe's timeline, not this one. Check both. */
            var perfs = [performance];
            try { if (cleanFetch.__ifr && cleanFetch.__ifr.contentWindow && cleanFetch.__ifr.contentWindow.performance) perfs.push(cleanFetch.__ifr.contentWindow.performance); } catch (eR) {}
            var es = [];
            perfs.forEach(function (pf) {
              try { es = es.concat(pf.getEntriesByType('resource').filter(function (e) { return /\/cart\/add\.js/.test(e.name); })); } catch (eE) {}
            });
            var e = es[es.length - 1];
            if (!e) return;
            coMark('addTiming:queue' + Math.round(e.requestStart - e.fetchStart) +
                   ':dns' + Math.round(e.domainLookupEnd - e.domainLookupStart) +
                   ':tcp' + Math.round(e.connectEnd - e.connectStart) +
                   ':ttfb' + Math.round(e.responseStart - e.requestStart) +
                   ':dl' + Math.round(e.responseEnd - e.responseStart) +
                   ':total' + Math.round(e.duration));
          } catch (eT) {}
        };
      } catch (eT0) {}
    }).then(function () {
      if (false) {
        /* THE normal path (line pre-added at generation/skip): one read-free
           fire with everything final; sheets ride it when ready */
        coStage('incart-done');
        try { if (window.__npAddTiming) window.__npAddTiming(); } catch (eTm) {}
        if (finalSyncFire()) { coMark('go+sheets'); return 'fired'; }
        /* sheets stale or still uploading — RE-KICK the composer for the
           final specs (1.3s measured per sheet) and fire as soon as they
           land; bounded either way (B48) */
        try { preComposeSheets(); } catch (ePK) {}
        return new Promise(function (resW) {
          var t0W = Date.now();
          (function wsh() {
            var preW = sensei.__preSheets, dkW = null;
            try { dkW = specDkToken(specLines(specFormProps())); } catch (eW) {}
            var catOk = true;
            try {
              if (digitalNoRender()) {
                var mp = mergedOrderProps();
                catOk = !!mp['_Mockup Catalog'];
              }
            } catch (eC) {}
            var allW = preW && (preW.aiBase ? preW.ai : true) && (preW.upBase ? preW.up : true) && (preW.ai || preW.up);
            if (preW && dkW && preW.dk === dkW && allW && catOk) { finalSyncFire(); resW('fired'); return; }
            /* B64: was 10,000ms — a hard floor on every click that reached
               here, measured at 14.5s and 16.1s on live because the jobs it
               waited for could never settle (see mk's HARD CAP). With those
               bounded, 4,000ms comfortably covers a real compose (~2.3-2.7s
               measured end to end) while capping the customer's worst case at
               ~5.5s including the 1,500ms alpha timebox above. A sheet that
               misses this window is simply not attached — the line NEVER
               carries a mismatched one (PATCH-2106492: production builds from
               the sheet). */
            if (Date.now() - t0W > 4000) { coMark('sheets-timeout'); finalSyncFire(); resW('fired'); return; }
            npTick(wsh, 300);
          })();
        });
      }
      /* no snapshot (fresh session, or the background read still in flight):
         the classic bounded path — the fresh ADD carries sheets atomically */
      /* B68 (2026-08-25): ensureInCart() had NO bound here. That was survivable
         while a background pre-add meant this branch almost never ran — but
         with the pre-add removed (B66) EVERY click comes through here, so a
         stalled /cart/add.js pinned the customer on "Finalizing Order & Adding
         to Cart…" forever. Bound it, and if the line genuinely did not land,
         say so and give the button back instead of spinning. */
      return timebox(ensureInCart(), 20000).then(function (r3) {
        coStage('incart-done');
        if (!sensei.added) {
          coMark('incart-TIMEOUT');
          throw new Error('the cart did not respond in time — please try again');
        }
        /* B71 (2026-08-25): the follow-up syncCartLine is REDUNDANT on the
           fresh-add path and it is expensive — measured 4,782ms on live for a
           /cart/change.js that changed nothing. ensureInCartNow() already runs
           commitOptions() + commitSizeQty() and builds the add FormData from
           the final form, so the line lands complete. The old skip-guard was
           gated on __sheetsFiredDk, which is never set now that build sheets
           are off, so it never fired and every click paid the extra call. */
        coMark('sync-skip:fresh-add');
        return null;
      });
    }).then(function () {
      /* B70: the entire sheet-stamping stage is gone from the click. */
      return null;
    }).then(function () {
      /* a variant swap must fully land (add + zero) before we leave, or the
         old, wrongly-priced line stays in the cart (B62) */
      if (sensei.__swapBusy) { coMark('await-swap'); return timebox(sensei.__swapBusy, 6000); }
      return null;
    }).then(function () {
      coStage('done');
      window.location.href = '/cart';
    })
      .catch(function (err) {
        coStage('CATCH: ' + String(err && err.message || err).slice(0, 120));
        coBusy = false;
        hidePageLoader();
        if (btn) { btn.disabled = false; btn.textContent = oldLabel; }
        alert('Could not add to cart: ' + (err && err.message || 'try again'));
      });
  }
  /* C303: exported so the blank-apparel rail and quick buy reuse this toast on builder PDPs rather than
     rendering a second one of their own (they keep an identical-looking fallback for the cart). */
  window.npToast = function (msg) { return npToast(msg); };
  function npToast(msg) {
    var t = document.createElement('div');
    t.className = 'np-e2-toast';
    t.textContent = msg;
    /* C306: a <dialog> opened with showModal() is in the TOP LAYER, above every z-index in <body>, so a
       toast appended to <body> is hidden behind it. Mount into the open modal when there is one. */
    var npToastHost = document.querySelector('dialog:modal') || document.body;
    npToastHost.appendChild(t);
    setTimeout(function () { t.classList.add('is-in'); }, 20);
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 400); }, 3600);
  }
  function addAnother() {
    /* file picker FIRST (must stay inside the click gesture). Picking a file
       banks the CURRENT patch in the cart (toast confirms it), hosts the new
       image, and reloads THIS product + ?view= with the new design. */
    if (coBusy) return; /* shares the add lock with Add to Cart */
    var fi = document.createElement('input');
    fi.type = 'file';
    fi.accept = 'image/*';
    fi.style.display = 'none';
    document.body.appendChild(fi);
    fi.addEventListener('change', function () {
      var f = fi.files && fi.files[0];
      try { document.body.removeChild(fi); } catch (eRm) {}
      if (!f || coBusy) return;
      coBusy = true;
      npToast('\u2713 This patch was added to your cart');
      showPageLoader('Adding this patch to your cart\u2026');
      var qs = window.location.search
        .replace(/[?&]file=[^&]*/g, '')
        .replace(/[?&]np_added=[^&]*/g, '')
        .replace(/^&/, '?');
      if (qs && qs[0] !== '?') qs = '?' + qs;
      var go = function (fileUrl) {
        var q2 = qs || '';
        if (fileUrl) q2 += (q2 ? '&' : '?') + 'file=' + encodeURIComponent(fileUrl); /* file LAST */
        window.location.href = window.location.pathname + q2;
      };
      /* host the NEXT design while the current patch banks */
      var upP = new Promise(function (res) {
        try {
          if (typeof window.getPresignedUploadUrl !== 'function') { res(''); return; }
          /* C16 (2026-08-25, Justin: "add another patch ... reloads the product
             page but it does not start the new upload") — NAME THE FILE WITH
             THE UPLOAD LINEAGE PATTERN. theme.liquid's ARRIVAL LINEAGE GUARD
             (PATCH-2106464/68/82) deletes ?file= unless the URL looks like a
             real customer upload (image_<ts>_<rand>) or a proof (ai-proof-*).
             This flow named its object 'next_<ts>_<filename>', which matches
             neither, so the guard stripped ?file= from the reload we had just
             built — the current patch banked, the page reloaded, and the next
             design was gone. It IS a real customer upload, so name it like one
             (same convention as custom-uploader.js) instead of widening the
             guard. Covers AI and Classic: both use this one addAnother(). */
          var fnRaw = String(f.name || 'image.png');
          var fnExt = fnRaw.indexOf('.') > -1
            ? ((fnRaw.split('.').pop() || 'png').replace(/[^a-zA-Z0-9]/g, '') || 'png')
            : (((f.type || '').split('/')[1] || 'png').replace(/[^a-zA-Z0-9]/g, '') || 'png');
          var fnBase = (fnRaw.split('.').slice(0, -1).join('.') || 'image')
            .replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-') || 'image';
          var nm = fnBase + '____image_' + Date.now() + '_' + Math.floor(Math.random() * 1000) + '.' + fnExt;
          window.getPresignedUploadUrl(nm, f.type || 'image/png').then(function (p) {
            if (!p || !p.url) { res(''); return; }
            return npPut(p.url, f, { 'Content-Type': f.type || 'image/png' })
              .then(function () {
                /* C32 (2026-08-28): "add another patch" hosts the customer's
                   NEXT design and then reloads into the ?file= arrival branch,
                   which passes forcesave=false — so this upload was never
                   registered by anything. Register it here. */
                try {
                  if (typeof window.npSaveUploadRecord === 'function' && CFG.customerId) {
                    window.npSaveUploadRecord({
                      variant_title: 'custom',
                      file: toImgixHost(p.sourceUrl || ''),
                      customer_id: String(CFG.customerId),
                      file_name: nm, /* C36: object name, never the local one — see custom-uploader.js */
                      file_crc: nm,
                      product_id: 'my-designs',
                      gangsheet: false
                    });
                  }
                } catch (eReg) {}
                res(toImgixHost(p.sourceUrl || ''));
              });
          }).catch(function () { res(''); });
        } catch (eU) { res(''); }
      });
      /* C72 (2026-08-31, Justin: "when upload is made with classic mode and then
         another upload is added, the loader stays on page"). If any leg of this
         chain threw synchronously or never settled, coBusy stayed true forever,
         the veil watchdog deferred forever, and the customer stared at a
         stranded spinner. The flow now cannot strand: a synchronous throw
         degrades to a resolved bank, and a 25s single-shot failsafe navigates
         regardless. */
      var bank;
      try {
        /* C136: the banked line must carry the digital mockup (and gets the
           sheets a bounded window) exactly like Add to Cart does — the next
           upload runs in parallel, so this costs the customer little */
        bank = ensureCompositeForLine(15000).then(function () {
          try { commitOptions(); commitSizeQty(); } catch (eCS3) {}
          try { var upC3 = sensei.composedCleanUrl || ''; if (upC3) setProp('_Upload', toImgixHost(upC3)); } catch (eUp3) {}
          try { preComposeSheets(); sensei.__clickDk = specDkToken(specLines(specFormProps())); } catch (ePC3) {}
          return waitSheetsBounded(6000); /* C460: same bounded window as Add to Cart (runs alongside the next upload) */
        }).then(ensureAlphaForCart).then(ensureInCart).then(syncCartLine).catch(function () {});
      }
      catch (eBank72) { bank = Promise.resolve(); }
      var went72 = false;
      var go72 = function (u) { if (went72) return; went72 = true; go(u || ''); };
      setTimeout(function () { go72(''); }, 25000);
      Promise.all([bank, upP]).then(function (r) {
        showPageLoader('Added to cart. Loading your next design\u2026');
        go72(r[1] || '');
      }, function () { go72(''); });
    });
    fi.click();
  }

  /* ---- activation: hide legacy post-upload UI, show builder ---- */
  function hideLegacy() {
    /* the builder REPLACES the legacy post-upload UI entirely: hide every
       rendered child of the main product section's container (the form and
       its hidden inputs stay in the DOM and still submit). */
    var ua = document.getElementById('uploadArea');
    var mainSec = ua ? ua.closest('.shopify-section') : null;
    if (!mainSec) {
      var ppL = document.querySelector('product-page, .product-actions, .product-text');
      if (ppL && ppL.closest) mainSec = ppL.closest('.shopify-section');
    }
    if (mainSec) {
      $$('.container > *, .container--large > *', mainSec).forEach(function (el) {
        if (el.closest('#np-e2')) return;
        el.classList.add('np-e2-legacy-hidden');
      });
    }
    /* post-upload the builder IS the page: hide every other template section
       below it (this also kills the huge empty scroll region that read as a
       "blank screen" when legacy code scrolled to a clipped element) */
    var builderSec = root.closest('.shopify-section');
    if (builderSec && builderSec.parentElement) {
      var seen = false;
      $$(':scope > .shopify-section', builderSec.parentElement).forEach(function (sec) {
        if (sec === builderSec) { seen = true; return; }
        if (seen || sec === mainSec) return;
        sec.classList.add('np-e2-legacy-hidden');
      });
      var after = builderSec.nextElementSibling;
      while (after) { after.classList.add('np-e2-legacy-hidden'); after = after.nextElementSibling; }
    }
    [
      '.product-gallery',                       /* image carousel */
      '.product__media-gallery',
      '.bcpo',                                  /* app option widgets */
      '.selector-wrapper.bcpo-buttons',
      '.customTabel',                           /* legacy size/qty table */
      '.customTabelPopup__openBtn',
      '.buymoresave', '.customTabelPlace',      /* legacy buy-more panel (kept in DOM for discount props) */
      'file-preview',                           /* legacy preview box */
      '.np-upload-toolbar', '.design-notes',
      '.fileupload_bg_options',
      '.disabled-cta.second-upload-cta',        /* legacy second box (we proxy to it) */
      '.customTabelPopup__overlay-2',           /* post-upload size popup */
      '.customTabelPopup__overlay',
      '.widthHeight', '.customQtyFile',         /* legacy steppers (hidden, still driven) */
      '.cta-wrapper-box'                        /* legacy CTA (clicked programmatically) */
    ].forEach(function (sel) {
      $$(sel).forEach(function (el) { el.classList.add('np-e2-legacy-hidden'); });
    });
    var style = document.getElementById('np-e2-hidestyle');
    if (!style) {
      style = document.createElement('style');
      style.id = 'np-e2-hidestyle';
      style.textContent = '.np-e2-legacy-hidden { position: absolute !important; width: 1px !important; height: 1px !important; overflow: hidden !important; clip: rect(0 0 0 0) !important; margin: 0 !important; padding: 0 !important; opacity: 0 !important; pointer-events: none !important; }';
      document.head.appendChild(style);
    }
  }

  function waitForArt(cb, maxMs) {
    var start = Date.now();
    (function attempt() {
      var cands = artworkCandidates().map(applyToggleParams);
      var i = 0;
      (function tryNext() {
        if (i >= cands.length) {
          if (Date.now() - start > (maxMs || 60000)) { cb(null); return; } /* artwork rendition wait keeps its 60s budget (only the render polls moved to 240s, 2026-09-08) */
          setTimeout(attempt, 1200);
          return;
        }
        var url = cands[i++];
        var probe = new Image();
        probe.onload = function () { cb(url); };
        probe.onerror = tryNext;
        probe.src = url;
      })();
    })();
  }

  var lastDetected = '';
  function readDetectedSize() {
    /* the upload pipeline renders "Detected size: W" x H"" into [d-size]
       — the TRUE image inches at 300dpi, and it changes when Remove
       Background / Crop+Trim re-render the artwork */
    var el = document.querySelector('.widthHeight__option-detectedSize [d-size], [d-size]');
    var txt = el ? el.textContent : '';
    var m2 = txt.match(/([\d.]+)"?\s*x\s*([\d.]+)/i);
    if (!m2) return null;
    var w = parseFloat(m2[1]), h = parseFloat(m2[2]);
    if (!(w > 0) || !(h > 0)) return null;
    return { w: w, h: h, raw: txt.trim() };
  }
  function measureArt(cb) {
    /* true inches = rendered pixels / 300dpi, measured from the SAME imgix
       render the canvas shows (trim / bg-remove included). The legacy
       [d-size] element doesn't exist on every lineage — this never lies
       about the artwork's dimensions or orientation. */
    var url = applyToggleParams(cleanUrl(artworkUrl()) || '');
    if (!url || url.indexOf('http') !== 0) { cb(null); return; }
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      var pw = probe.naturalWidth, ph = probe.naturalHeight;
      if (!(pw > 0 && ph > 0)) { cb(null); return; }
      /* C25 (2026-08-26) — MEASURE THE ARTWORK, NOT THE CANVAS.
         This used the raw pixel dimensions, i.e. the whole image INCLUDING its
         background and padding. Measured from three bad orders:
           · a Mockup-Lab proof on a 1024x1024 white canvas measured 1.000;
             the artwork inside it is 925x400 = 2.312
           · a chair PNG on a square canvas with wide transparent padding
           · a Letter PDF measured 11/8.5 = 1.29, the sheet not the art
         The proof RENDERER draws the trimmed artwork, so the customer approved
         a proof whose stated dimensions described a different shape than the
         one pictured. measureAlphaBounds is the same scan the rulers already
         use, and it reads real pixels — unlike `trim=colorUnlessAlpha`, which
         declines to trim at all when an alpha channel is present (that is why
         the padded PNGs slipped through). Fall back to the canvas only if the
         scan fails, so a CORS-tainted read degrades to today's behaviour. */
      measureAlphaBounds(url, function (b) {
        var aw = pw, ah = ph, how = 'canvas';
        if (b && (b.x1 - b.x0) > 0.02 && (b.y1 - b.y0) > 0.02) {
          aw = pw * (b.x1 - b.x0); ah = ph * (b.y1 - b.y0); how = 'art';
        }
        var w = aw / 300, h = ah / 300;
        if (w > 0 && h > 0) {
          cb({ w: Math.round(w * 100) / 100, h: Math.round(h * 100) / 100,
               raw: 'm:' + Math.round(aw) + 'x' + Math.round(ah) + ':' + how + ':' + (st.crop ? 1 : 0) + (st.removeBg ? 1 : 0) });
        } else cb(null);
      });
    };
    probe.onerror = function () { cb(null); };
    probe.src = url;
  }
  function adoptDetected(d) {
    /* orientation must follow the artwork — a landscape design can never
       seed portrait numbers (or vice versa) */
    var img = document.getElementById('np-e2-artimg');
    if (img && img.naturalWidth && img.naturalHeight) {
      var artLand = img.naturalWidth >= img.naturalHeight, dLand = d.w >= d.h;
      if (artLand !== dLand) { var t = d.w; d.w = d.h; d.h = t; }
    }
    lastDetected = d.raw;
    st.artRatio = d.h / d.w; /* C45: artwork-owned aspect — shape picks never touch it */
    st.ratio = d.h / d.w;
    var gD = shapeGeom();
    if (gD && gD !== 'custom' && !heightLocked()) {
      /* a chosen standard shape owns the aspect — the artwork only sets scale */
      if (!(FLEX_GEOM[gD] && npSelCropped())) { /* C43 */
        var dD = shapeDims(gD);
        st.ratio = dD[1] / dD[0];
      } /* C26: a flex family keeps the artwork's own aspect */
    }
    st.w = clampSize(Math.round(d.w * 100) / 100, true);
    st.h = heightLocked() ? st.w : clampSize(Math.round(st.w * st.ratio * 100) / 100, true);
    st.sizeSeeded = true;
    commitSizeQty();
  }
  function seedSizeFromLegacy() {
    var tries = 0;
    (function poll() {
      if (st.sizeSeeded) return;
      /* C25 — the ARTWORK measurement is authoritative. It used to be a
         one-shot at tries===2, consulted only when the legacy [d-size] was
         absent — so the page-box/canvas value won whenever it existed, and a
         single null callback forfeited the only good source for the session.
         measureArt is ASYNC, so the [d-size] fallback has to live INSIDE its
         callback: reading it synchronously here would let the bad value win
         the race every time and the fix would do nothing. */
      measureArt(function (m) {
        if (st.sizeSeeded) return;
        if (m) { adoptDetected(m); return; }
        var dFallback = readDetectedSize();
        if (dFallback) adoptDetected(dFallback);
      });
      /* fallback: the legacy inputs (2" default + proportional height) */
      var wi = legacyInput('width__value'), hi = legacyInput('height__value');
      var w = wi ? parseFloat(wi.value) : 0, h = hi ? parseFloat(hi.value) : 0;
      /* C25b — this fallback is SELF-FULFILLING. commitSizeQty() calls
         setLegacySize(st.w, st.h), which writes st.w/st.h into these very
         inputs; any of its ~17 call sites firing during the poll window stamps
         them, and the poller then reads its own stamp back and commits it as
         though the pipeline had supplied it. Only accept values that actually
         DIFFER from what we already hold — our own echo is not a measurement. */
      var wEcho = Math.abs(w - st.w) < 0.005 && Math.abs(h - st.h) < 0.005;
      if (tries > 12 && w > 0 && h > 0 && !wEcho) {
        st.sizeSeeded = true;
        st.w = clampSize(Math.round(w * 100) / 100, true);
        st.h = clampSize(Math.round(h * 100) / 100, true);
        if (!isFinite(st.artRatio) || st.artRatio <= 0) st.artRatio = st.h / st.w; /* C45 fallback seed */
        st.ratio = st.h / st.w;
        commitSizeQty();
        return;
      }
      if (++tries < 25) { setTimeout(poll, 700); return; }
      /* C25b — the exhaust branch used to set sizeSeeded = true immediately,
         which BOTH shipped the untouched line-54 defaults (2.00 x 2.19 — order
         A byte for byte) AND poisoned the guard on every in-flight measureArt
         callback, so a true size arriving one tick later was discarded for the
         rest of the session. Take one last real measurement first; only fall
         back to committing placeholders if that genuinely fails, and leave the
         door open for a late arrival to correct it. */
      measureArt(function (mFinal) {
        if (st.sizeSeeded) return;
        if (mFinal) { adoptDetected(mFinal); return; }
        st.sizeSeeded = true;
        commitSizeQty(); /* never leave the $0.00 placeholders */
      });
    })();
  }
  function reseedAfterToggle() {
    /* toggles re-render the artwork -> measure the new render directly and
       adopt its TRUE dimensions; the legacy [d-size] poll is the backup */
    var start = Date.now();
    measureArt(function (m) {
      if (m && m.raw !== lastDetected) { adoptDetected(m); return; }
      (function poll() {
        var d = readDetectedSize();
        if (d && d.raw !== lastDetected) { adoptDetected(d); return; }
        if (Date.now() - start < 20000) setTimeout(poll, 800);
        else renderPricing();
      })();
    });
  }
  function mountMobileSticky() {
    /* MOBILE: the preview rides in its own sticky card pinned to the top.
       Mounted whenever the viewport IS mobile — at activation OR when a
       desktop window is later narrowed (the mount used to be a one-shot
       inside activate(), so resizing after upload lost the sticky). */
    /* C541 (Justin 2026-11-03): phone/tablet is 1024px and below now (was 1366px), and the switch has to follow a window
       being dragged both ways ("make sure its a responsive switch if screen is changed with click and drag manually") —
       widening past the breakpoint hands the preview back to its desktop card */
    if (!(window.matchMedia && matchMedia('(max-width: 1024px)').matches)) { unmountMobileSticky(); return; }
    if (!document.body.classList.contains('np-e2-active')) return;
    if (document.getElementById('np-e2-msticky')) return;
    var mMain = document.querySelector('.np-e2__main');
    var mCanvas = document.getElementById('np-e2-canvas');
    var mZrow = document.getElementById('np-e2-zoomrow');
    if (mMain && mCanvas) {
      var mWrap = document.createElement('div');
      mWrap.id = 'np-e2-msticky';
      mWrap.className = 'np-e2-card np-e2-msticky';
      mMain.insertBefore(mWrap, mMain.firstChild);
      var mNote = document.getElementById('np-e2-prevnote'); /* C535b: the preview note travels with the preview */
      [mCanvas, mNote, mZrow].forEach(function (el) { if (el) el.__npMsHome = { parent: el.parentNode, next: el.nextSibling }; }); /* C541 */
      mWrap.appendChild(mCanvas);
      if (mNote) mWrap.appendChild(mNote);
      if (mZrow) mWrap.appendChild(mZrow);
      var mS1 = document.getElementById('np-e2-step1');
      if (mS1) mS1.style.display = 'none'; /* just an orphaned title once the canvas leaves */
    }
    /* the switch was placed before this card existed — seat it again now
       that the preview has a new home, so the tabs stay above the image */
    try { paintModeSwitch(); } catch (ePM2) {}
  }
  function unmountMobileSticky() {
    /* C541: the reverse of mountMobileSticky — last moved, first home, so every saved next-sibling is back in place */
    var mWrap = document.getElementById('np-e2-msticky');
    if (!mWrap) return;
    ['np-e2-zoomrow', 'np-e2-prevnote', 'np-e2-canvas'].forEach(function (id) {
      var el = document.getElementById(id), home = el && el.__npMsHome;
      if (!el || el.parentNode !== mWrap || !home || !home.parent || !home.parent.isConnected) return;
      home.parent.insertBefore(el, home.next && home.next.parentNode === home.parent ? home.next : null);
    });
    if (mWrap.querySelector('#np-e2-canvas')) return; /* a home went missing: leave the mobile card rather than lose the preview */
    mWrap.remove();
    var mS1 = document.getElementById('np-e2-step1');
    if (mS1) mS1.style.display = '';
    try { paintModeSwitch(); } catch (ePM3) {}
  }
  (function () {
    if (!window.matchMedia) return;
    var mqS = matchMedia('(max-width: 1024px)');
    var onMqS = function () { try { mountMobileSticky(); } catch (eMS) {} };
    if (mqS.addEventListener) mqS.addEventListener('change', onMqS);
    else if (mqS.addListener) mqS.addListener(onMqS);
    window.addEventListener('resize', function () { setTimeout(onMqS, 150); });
  })();
  function activate() {
    /* permanent diagnostics: how long the customer saw the legacy page before
       the builder took over. Read with performance.getEntriesByName('np-e2-activate'). */
    try { performance.mark('np-e2-activate'); } catch (ePM) {}
    /* the boot gate held the page blank until we were ready — release it */
    document.documentElement.classList.remove('np-e2-boot');
    /* the moment the upload signal fires, the builder IS the page — no
       legacy loading UI (running ninja). Our spinner sits over the canvas
       until the artwork actually renders. */
    if (document.body.classList.contains('np-e2-active')) return;
    document.body.classList.add('np-e2-active');
    try { paintModeSwitch(); } catch (ePM) {}
    /* PHOTO CHECK AT UPLOAD (not at the Generate button): the customer learns
       "this is a photo -> Full Color" BEFORE spending time on options for the
       wrong patch type — the same early identification the mockup-generator
       page does. The generate-time gate below stays as the backstop. */
    /* C79 (2026-08-31): a previous-design / second-upload arrival in CLASSIC
       mode is a design the customer explicitly chose - the photo/fine-detail
       gate must not re-interrupt it (its confirm modal stranded the arrival
       under the loading veil on woven/chenille/PVC: endless "Loading your
       design"). The flag is stamped by custom-uploader's .use_design handler;
       ?file= is checked too for direct handoff links (consume-on-read). */
    var mdArrival79 = mdArrival79C; /* consumed once at module scope */
    if (photoGateOn() && !st.versions.length && !st.proofApproved) {
      var pcTries = 0;
      /* NEW ART = NEW VERDICT: a delete-and-reupload (or AI edit) in the same
         session must re-run the analysis — the flags otherwise freeze the
         FIRST upload's verdict for the whole tab (Justin 2026-08-22) */
      (function () {
        var artW = document.getElementById('np-e2-artimg');
        if (!artW || artW.__npPcRearm) return;
        artW.__npPcRearm = true;
        artW.addEventListener('load', function () {
          if (!this.src || !st.__analyzedSrc || this.src === st.__analyzedSrc) return;
          st.__artAnalyzed = false; st.__photoCleared = false; st.__photoNudged = false;
          st.__gateReq = null; st.__gateRes = null; st.__gateFor = null; st.__gateDone = false; /* C134 */
          st.__szfDetail = null; /* C432: new art, new deferred verdict */
          /* "Keep this patch type" is final for this artwork — a toggle that
             only changed the src params must not resurrect the stop */
          if (keepTypeActive()) { st.__photoCleared = true; st.__photoNudged = true; return; }
          pcTries = 0;
          setTimeout(pcTick, 250);
        });
      })();
      function pcTick() {
        if (mdArrival79C) { st.__photoCleared = true; st.__pcDone = true; return; } /* C79+C100: chosen designs are never re-interrogated, any mode */
        if (st.fcConfirmed || st.versions.length || st.__photoNudged) return;
        var artIP = document.getElementById('np-e2-artimg');
        if (!(artIP && artIP.naturalWidth > 0)) { if (pcTries++ < 120) setTimeout(pcTick, 350); return; }
        if (npGateOn()) {
          /* C134: the central gate service decides — one card, one source */
          if (!st.__gateDone) { npGateAsk(); if (pcTries++ < 130) setTimeout(pcTick, 300); return; }
          if (npGateRenderUpload(st.__gateRes, undefined, true)) return; /* C432: only a photo stops here in AI mode */
          st.__photoCleared = true; st.__pcDone = true;
          return;
        }
        if (!st.__artAnalyzed) {
          try { analyzeArtwork(); } catch (ePA) { st.__artAnalyzed = true; }
          if (pcTries++ < 130) setTimeout(pcTick, 300);
          return;
        }
        if (fullColorLikely()) { st.__photoNudged = true; openPhotoConfirm('upload'); return; }
        /* C78: dense pictorial inside the vivid class — offer FC / P&S */
        if (typeof densePictorialLikely === 'function' && densePictorialLikely()) {
          if (szfDefersDetail()) st.__szfDetail = 'dense'; /* C432: the Size step raises it */
          else { st.__photoNudged = true; openDenseReco(); return; }
        }
        st.__photoCleared = true; /* checked at upload, not a photo — never re-interrupt at Generate */
        st.__pcDone = true;
        if (typeof fineDetailLikely === 'function' && fineDetailLikely() && PTYPE.fdGate) {
          if (szfDefersDetail()) st.__szfDetail = st.__szfDetail || 'fineDetail'; /* C432 */
          else { st.__photoNudged = true; openFdReco(); }
        }
      }
      pcTick();
    }
    /* a type whose size is a PRODUCT fact rather than a typed number hides the
       width/height steppers and the mean-size line. Unlike the names roster it
       keeps the qty stepper and the volume table — quantity is still a choice. */
    if (PTYPE.fixedSize) document.body.classList.add('np-e2-nosize');
    hideLegacy();
    /* the legacy size popup fades in ~after upload; keep it suppressed */
    setInterval(function () {
      var pop = document.querySelector('.customTabelPopup__overlay-2, .customTabelPopup__overlay.pricing-table');
      if (pop && !pop.classList.contains('np-e2-legacy-hidden')) pop.classList.add('np-e2-legacy-hidden');
    }, 800);
    root.hidden = false;
    /* the tabs were seated while the builder was display:none — every rect
       measured 0, so the options-column offset came out 0 and the band hugged
       the left edge. The grid takes several frames (zoom + webfonts + images)
       to reach its real geometry, so keep re-seating until the two columns
       actually read as two columns (or the layout is genuinely one-column). */
    (function reseat(n) {
      try { paintModeSwitch(); } catch (eP1) {}
      if (n >= 10) return;
      var colR = document.querySelector('.np-e2-rightcol');
      var mainR = document.querySelector('.np-e2__main');
      var twoCol = colR && mainR && (colR.getBoundingClientRect().left - mainR.getBoundingClientRect().left) > 40;
      var oneColMQ = window.matchMedia && window.matchMedia('(max-width: 1120px)').matches;
      if (twoCol || oneColMQ) { try { paintModeSwitch(); } catch (eP2) {} if (twoCol) return; }
      setTimeout(function () { reseat(n + 1); }, n < 3 ? 150 : 400);
    })(0);
    /* MOBILE: the preview rides in its own sticky card pinned to the top so
       it stays visible while the customer scrolls through the options */
    mountMobileSticky();
    /* NO-UPLOAD TYPES (custom names): there is no artwork to load, crop,
       background-remove, analyze or observe — the preview composes text. The
       artwork half of activate() is skipped wholesale rather than being fed
       an empty URL, which is what made loadArt() retry forever. */
    if (PTYPE.noArt) {
      document.body.classList.add('np-e2-noart');
      /* warm the lettering faces NOW (they used to start downloading only when
         the font row opened -> visible fallback-then-swap on the tiles) and
         repaint the open row when they land */
      ensureNameFonts(function () { try { if (accOpen !== null && accOpen !== undefined) renderAccordion(); } catch (eWF) {} });
      if (PTYPE.names) document.body.classList.add('np-e2-names-mode');
      /* loader stays ON until the first composed NAME frame lands — the
         preview used to sit as a blank white card while fonts resolved */
      artLoader(true);
      var artWrapN = document.querySelector('#np-e2-canvas .np-e2-art');
      if (artWrapN) artWrapN.hidden = true;
      var cusN = document.getElementById('np-e2-step-customize');
      if (cusN) cusN.hidden = true;
      var ebN = document.querySelector('#np-e2-step-options .np-e2-eyebrow');
      if (ebN) ebN.textContent = 'STEP 1 OF 2';
      var ebN2 = document.querySelector('#np-e2-names .np-e2-eyebrow');
      if (ebN2) ebN2.textContent = 'STEP 2 OF 2';
      var pvN = document.getElementById('np-e2-prevtitle');
      if (pvN) pvN.textContent = PTYPE.textLines ? 'Your Tackle Twill Preview' : 'Your Name Patch Preview';
      if (PTYPE.textLines) {
        var ttC = document.getElementById('np-e2-tt');
        if (ttC) ttC.hidden = false;
        /* open on the most popular size (11" x 4") so the preview, the rulers
           and the price are all true from the first frame */
        if (PTYPE.sizeFromOpt && !st['opt' + PTYPE.sizeFromOpt]) {
          var v0 = optValues(PTYPE.sizeFromOpt)[0];
          if (v0) {
            st['opt' + PTYPE.sizeFromOpt] = v0;
            if (st.draft) st.draft['opt' + PTYPE.sizeFromOpt] = v0;
            var wh0 = optSizeWH(v0.label);
            if (wh0) { st.w = wh0[0]; st.h = wh0[1]; st.ratio = st.h / st.w; st.sizeSeeded = true; }
          }
        }
        /* the product's own photos ride along: the legacy page showed this work
           after upload and the builder used to drop it entirely */
        /* the font is the first decision — its row moves ABOVE the text inputs
           (handlers are delegated, and stepSeq reads DOM order, so moving the
           node reorders the flow too) */
        var fontSlotT = document.getElementById('np-e2-tt-fontslot');
        if (fontSlotT) {
          /* font first, then 1-or-2 layers — both before any text is typed */
          ['6', String(6 + (PTYPE.layersOpt || 2))].forEach(function (nT) {
            var rowT = document.querySelector('.np-e2-accrow[data-e2-acc="' + nT + '"]');
            if (rowT && !fontSlotT.contains(rowT)) fontSlotT.appendChild(rowT);
          });
          fontSlotT.hidden = false;
        }
        /* the stitch is a finishing question: it lives in its own collapsed
           row after the colours, opened when the flow reaches it */
        var stGrp = document.getElementById('np-e2-tt-stitchgrp');
        var stSlot = document.getElementById('np-e2-tt-stitchslot');
        if (stGrp && stSlot && !stSlot.contains(stGrp)) stSlot.appendChild(stGrp);
        var stRow = document.getElementById('np-e2-tt-stitchrow');
        if (stRow && PTYPE.stitches) stRow.hidden = false;
        var galW = document.getElementById('np-e2-ttgal');
        var galS = document.getElementById('np-e2-ttgal-strip');
        var galL = (CFG.gallery || []).filter(Boolean);
        if (galW && galS && galL.length) {
          galS.innerHTML = galL.map(function (uG) {
            return '<img src="' + uG + '" alt="" loading="lazy">';
          }).join('');
          /* its own SECTION: full width under all the options, above whatever
             the theme renders next (the carbon-neutral bar) */
          var gridG = document.querySelector('#np-e2 .np-e2__grid');
          if (gridG && gridG.parentNode && galW.parentNode !== gridG.parentNode) {
            galW.classList.add('np-e2-ttgal--sec');
            gridG.parentNode.insertBefore(galW, gridG.nextSibling);
          }
          galW.hidden = false;
        }
        if (ebN) ebN.textContent = 'STEP 2 OF 2';
        var ttE = document.getElementById('np-e2-tt-eyebrow');
        if (ttE) ttE.textContent = 'STEP 1 OF 2';
        ttSync();
      }
      var minN = document.getElementById('np-e2-names-min');
      if (minN) minN.textContent = namesMin() + ' name minimum';
      var taN = document.getElementById('np-e2-names-ta');
      if (taN) taN.placeholder = 'Alex\nJordan\nSam\n\u2026or paste a comma separated list';
    } else {
    artLoader(true);
    var img = document.getElementById('np-e2-artimg');
    if (img && !img.__npAnalyzeWired) {
      img.__npAnalyzeWired = true;
      var analyzed = false;
      img.addEventListener('load', function () {
        if (!analyzed) { analyzed = true; analyzeArtwork(); }
        /* the accordion opened before the art resolved — refresh the open
           row so shape tiles show the CUSTOMER's art, not the CMS samples */
        if (accOpen !== null) renderAccordion();
      });
    }
    loadArt(); /* retries internally until a candidate resolves */
    /* crop+trim is no longer a customer choice — keep the legacy checkbox in
       sync so detected sizes and the print file reflect the trimmed art */
    var cropTries = 0;
    (function syncCrop() {
      var cc = document.getElementById('option_checkbox');
      if (cc) { if (!cc.checked) cc.click(); return; }
      if (++cropTries < 10) setTimeout(syncCrop, 800);
    })();
    /* remove-background defaults OFF — keep the legacy toggle aligned with
       st.removeBg for a few ticks (the uploader may initialize it checked,
       and the ml handoff can flip the preference mid-activation) */
    var bgTries = 0;
    (function syncBgRemove() {
      var cbg = document.getElementById('option_checkbox_upscale');
      if (cbg && !!cbg.checked !== !!st.removeBg) cbg.click();
      if (++bgTries < 10) setTimeout(syncBgRemove, 800);
    })();
    /* C542: solid-cornered uploads switch Remove background on — checked once the artwork has loaded, and again for each new upload */
    (function () {
      var artA = document.getElementById('np-e2-artimg');
      if (!artA || artA.__np542) return;
      artA.__np542 = true;
      var go542 = function () { if (artA.naturalWidth > 0) setTimeout(function () { try { npAutoBg542('ai'); } catch (e542) {} }, 600); };
      artA.addEventListener('load', go542);
      go542();
    })();
    var hero = document.getElementById('fileupload_hero');
    if (hero) new MutationObserver(function () { loadArt(); }).observe(hero, { attributes: true, attributeFilter: ['src'] });
    }
    /* renderMaskPreview sizes the composed patch in PIXELS off the canvas
       box, so any reflow AFTER that first measure leaves it the wrong size —
       the mobile sticky card re-parents the canvas, late assets change the
       column width, and the customer can just resize the window. A 2.6:1
       name patch overflowed its stage that way. Re-fit whenever the box
       actually changes (debounced: each re-fit is a full re-compose). */
    (function () {
      var cvO = document.getElementById('np-e2-canvas');
      if (!cvO || cvO.__npRO || typeof ResizeObserver === 'undefined') return;
      var tO = null;
      cvO.__npRO = new ResizeObserver(function () {
        clearTimeout(tO);
        tO = setTimeout(function () { try { renderMaskPreview(); } catch (eRO) {} }, 150);
      });
      cvO.__npRO.observe(cvO);
    })();
    seedSizeFromLegacy();
    if (NP_PDP_PRICING) { try { mountPdpPricing(); } catch (eMP) {} }
    handleProofHandoff();
    try { handleSizeCarry(); } catch (eSC) {} /* C229h */
    renderOptions();
    renderPricing(); /* real prices immediately — the markup ships $0.00 placeholders */
    /* C235 (Justin 2026-09-17 "make it clear what is printed and what is stitched"): the Print & Stitch PRODUCT carries the same
       production split the embroidered→P&S switch stamps, so the proof sheet and the order line say it (production reads this line) */
    if (TYPE_KEY === 'print-and-stitch-2-0') { try { setProp('_Production Method', 'PRINT & STITCH - fine detail printed, remainder embroidered'); } catch (ePM235) {} }
    openAcc(firstUnsetStep()); /* on-page options: first unset row starts open */
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (st.__sizeCarried) setTimeout(szfFocusNext, 700); /* C230 */
  }

  /* C157b (2026-09-10, review): the URL copy of the handoff is attacker-controllable (a shareable link) and its values reach
     innerHTML / style attributes unescaped (renderOptions swatch dot + label, colour wizard tile). WHITELIST every field before
     adopting it: labels must match the product's own option lists (so "Hook & Loop", "Black & Silver", "Embroidered / Hot Cut
     (Most Popular)" pass untouched) or be plain text (PMS names from the studio's detected colours), hexes must be #rrggbb,
     numbers are clamped, booleans coerced. Only the URL copy is sanitised — the same-origin localStorage path is unchanged. */
  /* C157c (2026-09-10): shared label whitelist for EVERY URL-sourced option label (the ml lane's np_ml object and the
     conversion lane's np_shape/np_tex/np_bgl/np_thl/np_txl/np_bsl/np_bkl) — an exact match against the product's own
     option list passes untouched, anything else must be plain text with no markup characters, else '' (= not set). */
  var ML157_TXT = /^[A-Za-z0-9 \/\-.,()+]{1,60}$/;
  function ml157InList(list, v) { return typeof v === 'string' && (list || []).some(function (x) { return x && x.label === v; }); }
  function ml157Label(list, v) { if (ml157InList(list, v)) return v; return (typeof v === 'string' && ML157_TXT.test(v)) ? v : ''; }
  function sanitizeMl157(o) {
    var HEX = /^#[0-9a-fA-F]{6}$/; /* labels: ml157Label (no &, <, >, quotes, =, ; — list labels with & pass by exact match) */
    var C = (typeof CFG !== 'undefined' && CFG) || {};
    var mats = (typeof PTYPE !== 'undefined' && PTYPE && PTYPE.mats) || [];
    var lbl = ml157Label;
    var col = function (c, list) { if (!c || typeof c !== 'object' || typeof c.hex !== 'string' || !HEX.test(c.hex)) return null; var L = lbl((list || []).concat(mats), c.label); if (!L) { try { L = (typeof pmsName === 'function' && pmsName(c.hex)) || ''; } catch (eP) { L = ''; } } return { label: L || c.hex, hex: c.hex }; }; /* off-palette custom colours keep a derived PMS name, never a raw label */
    var num = function (v, lo, hi, d) { v = +v; return isFinite(v) ? Math.max(lo, Math.min(hi, v)) : d; };
    return {
      removeBg: o.removeBg === true, etchInvert: o.etchInvert === true,
      shape: lbl(C.shapes, legacyShapeLabel(o.shape)), /* C223 */ border: lbl(C.borders, o.border), backing: lbl(C.backings, o.backing),
      corners: (o.corners === 'square' || o.corners === 'rounded') ? o.corners : '',
      bg: col(o.bg, C.bgs), thread: col(o.thread, C.threads),
      lbThick: Math.round(num(o.lbThick, 0, 10, 0)), artZoom: num(o.artZoom, 0.6, 2.5, 1), artDx: num(o.artDx, -1, 1, 0), artDy: num(o.artDy, -1, 1, 0),
      w: num(o.w, 0, 30, 0), h: num(o.h, 0, 30, 0), /* C229: the studio's chosen size (0 = none) */
      printedPvc: o.printedPvc === true, /* C441: the studio judged it printed rubber PVC */
      sewChannel: o.sewChannel === true || o.sewChannel === 1, /* C538 (the My Proofs sidecar stores 1) */
      patchRec: npRecClean(o.patchRec) /* C519: the studio keep's declined type(s) */
    };
  }
  function handleSizeCarry() {
    /* C229h (Justin 2026-09-17): arriving from another patch type's Size step ("pick a Print & Stitch or Full Color patch") —
       np_src=size&np_ml=<JSON of the last builder's selections + size>. Every option whose label exists on THIS product is
       preselected (the C157 whitelist + the product's own lists decide), the size lands in the Size row already checked, and any
       row this product asks that the last one did not have stays open for the customer. No proof, no approval — the normal flow. */
    var params = new URLSearchParams(window.location.search);
    if (params.get('np_src') !== 'size') return;
    var raw = params.get('np_ml'); if (!raw || raw.length > 4096) return;
    var h = null; try { h = JSON.parse(raw); } catch (eJ) { return; }
    if (!h || typeof h !== 'object' || Array.isArray(h)) return;
    var s = sanitizeMl157(h);
    if (s.shape && ml157InList(CFG.shapes, s.shape) && !foldIsDesign178()) st.shape = s.shape;
    if (s.border) st.border = (CFG.borders || []).filter(function (b) { return b.label === s.border; })[0] || st.border;
    if (s.backing) st.backing = (CFG.backings || []).filter(function (b) { return b.label === s.backing; })[0] || st.backing;
    if (s.bg && s.bg.hex && PTYPE.bg && !PTYPE.fixedBg) st.bg = { label: s.bg.label, hex: s.bg.hex };
    if (s.thread && s.thread.hex && PTYPE.thread) st.thread = { label: s.thread.label, hex: s.thread.hex };
    if (s.removeBg) { st.removeBg = true; var tglC = document.querySelector('[data-e2-toggle="removeBg"] .np-e2-switch'); if (tglC) tglC.classList.add('is-on'); }
    if (s.artZoom) st.artZoom = s.artZoom; if (s.artDx || s.artDy) { st.artDx = +s.artDx || 0; st.artDy = +s.artDy || 0; }
    if ((s.corners === 'square' || s.corners === 'rounded') && !PTYPE.fixedCorners) st.corners = s.corners;
    var wC = +h.w, hC = +h.h;
    if (isFinite(wC) && wC > 0 && isFinite(hC) && hC > 0 && sizeFirstOn()) {
      /* C230: a carried size outside this product's window snaps AS A PAIR (ratio kept) — clamping each side alone turned a 2 × 0.57 logo
         into 2 × 1.00 and rewrote the ratio */
      var wC2 = Math.round(wC * 100) / 100, hC2 = heightLocked() ? wC2 : Math.round(hC * 100) / 100, snC = szfSnap(wC2, hC2);
      if (snC) { wC2 = snC.w; hC2 = snC.h; }
      st.w = wC2; st.h = heightLocked() ? st.w : hC2;
      st.ratio = st.h / st.w; st.sizeSeeded = true; st.__sizeEntered = true;
      setTimeout(function () { try { sizeFirstJudge(st.w, st.h).then(function (r) { if (r) sizeFirstApply(r); }); } catch (eSJ) {} }, 900);
    }
    st.__sizeCarried = true; /* C230: the boot focuses the first open choice (or Generate) once the rows are painted */
    st.draft = null; /* the accordion re-seeds its draft from the carried selections */
    try { console.log('[np-e2] size carry-over applied', s, st.w, st.h); } catch (eLc) {}
  }
  function handleProofHandoff() {
    /* arriving from another builder with an approved proof (np_proof):
       attach it, seed size/qty, and land in the approved state — the
       customer just confirms and checks out. */
    var params = new URLSearchParams(window.location.search);
    var proof = params.get('np_proof');
    if (!proof || proof.indexOf('http') !== 0) {
      document.documentElement.classList.remove('np-e2-ml-arrive');
      if (params.get('np_src') === 'ml') pf.hidden = true; /* the boot loading pane has nothing to wait for */
      return;
    }
    /* ── Mockup Lab pass-through (np_src=ml): the lab's mockup IS the proof.
       Selections ride localStorage; land straight in Size & Pricing. ── */
    if (params.get('np_src') === 'ml') {
      var mlArt = params.get('np_art');
      var h = null;
      try { h = JSON.parse(localStorage.getItem('np_ml_handoff') || 'null'); } catch (e0) {}
      /* C157 (2026-09-10): CROSS-STORE ARRIVAL — the Patch Express studio on ninjatransfers.com sends the SAME selections
         object as `np_ml=<JSON>` in the URL (localStorage never crosses origins; PATCH-2111205 landed with "options did not
         carry over" and a bare-artwork _Upload sheet). The URL copy WINS over any stale local entry, is re-stamped and
         persisted so a reload of the arrival URL still carries the options. `np_h` is NOT usable here — it is the
         conversion lane's height param. */
      try {
        var hq157 = params.get('np_ml');
        if (hq157 && hq157.length <= 4096) { var hj157 = JSON.parse(hq157); if (hj157 && typeof hj157 === 'object' && !Array.isArray(hj157)) { hj157 = sanitizeMl157(hj157); hj157.t = Date.now(); h = hj157; try { localStorage.setItem('np_ml_handoff', JSON.stringify(hj157)); } catch (eS157) {} } } /* C157b: whitelisted copy only */
      } catch (eH157) {}
      /* kept in storage so a RELOAD of the arrival URL still carries the
         options — only expiry clears it */
      if (h && (!h.t || (Date.now() - h.t) >= 1800000)) { h = null; try { localStorage.removeItem('np_ml_handoff'); } catch (e1) {} }
      if (h) {
        if (typeof h.removeBg === 'boolean') {
          st.__bgChosen542 = true; /* C542: the studio's own Remove background choice wins over the auto rule */
          st.removeBg = h.removeBg;
          var tgl = document.querySelector('[data-e2-toggle="removeBg"] .np-e2-switch');
          if (tgl) tgl.classList.toggle('is-on', st.removeBg);
        }
        if (h.shape) st.shape = legacyShapeLabel(h.shape); /* C223: a saved Tall Rectangle / Wide Oval lands on the self-orienting tile */
        if (h.border) st.border = (CFG.borders || []).filter(function (b) { return b.label === h.border; })[0] || { label: h.border };
        if (h.bg && h.bg.hex) st.bg = { label: h.bg.label, hex: h.bg.hex };
        if (h.thread && h.thread.hex) st.thread = { label: h.thread.label, hex: h.thread.hex };
        if (h.backing) st.backing = (CFG.backings || []).filter(function (b) { return b.label === h.backing; })[0] || { label: h.backing };
        if (h.lbThick) st.lbThick = h.lbThick;
        if (h.etchInvert) st.etchInvert = true;
        if (h.artZoom) st.artZoom = h.artZoom;
        if ((h.corners === 'square' || h.corners === 'rounded') && !PTYPE.fixedCorners) st.corners = h.corners; /* Patch Express corners choice (2026-09-08); C165: fixed-corner types ignore it */
        if (h.artDx || h.artDy) { st.artDx = +h.artDx || 0; st.artDy = +h.artDy || 0; } /* C151 pan travels with the handoff */
        if (h.sewChannel === true && PTYPE.sewChannel) st.sewChannel = true; /* C538: the studio's sewing channel */
        if (h.printedPvc === true && szfPrintedPvc()) { st.__pvcCarried = true; try { npPrintedPvc(true); } catch (ePC) {} } /* C441: Patch Express (either store) said printed PVC */
        if (npRecClean(h.patchRec)) st.__recMl = { names: npRecClean(h.patchRec), base: '' }; /* C519: a keep made in the studio / lab */
      }
      /* a missing/partial handoff must never null-crash the review pane —
         default the gaps (the order is already flagged for specialist confirm) */
      if (!st.shape) st.shape = 'Custom Shape';
      if (!st.border) st.border = (CFG.borders || [])[0] || { label: 'Embroidered / Hot Cut' };
      if (!st.bg) st.bg = { label: 'Not Sure', hex: '' };
      if (!st.thread) st.thread = { label: 'Not Sure', hex: '' };
      if (!st.backing) st.backing = (CFG.backings || [])[0] || { label: 'Heat Applied' };
      /* C229: the studio now picks the size before its proof — it lands here so the sizing pane opens on the same number */
      if (h && h.w > 0 && h.h > 0) { st.w = clampSize(Math.round(h.w * 100) / 100, true); st.h = heightLocked() ? st.w : clampSize(Math.round(h.h * 100) / 100, true); st.ratio = st.h / st.w; st.__sizeEntered = true; }
      /* sizes are set in the sizing pane — stop the async seeder from mutating
         them AFTER the version meta is captured (that drift flipped the
         revisions modal into 'updated' mode and buried Edit selections) */
      st.sizeSeeded = true;
      var vml = newVersionMeta();
      vml.dataUrl = proof; vml.hosted = proof; vml.rev = 0;
      vml.w = null; vml.h = null; /* the handoff version makes no size claim */
      var mlAlpha = params.get('np_alpha') || '';
      if (mlAlpha.indexOf('http') !== 0) mlAlpha = '';
      if (mlAlpha) vml.alpha = mlAlpha; /* the lab's edge-cut transparent copy — no white studio box */
      st.versions = [vml];
      st.selected = 0;
      st.proofApproved = true; try { prewarmAlphaForCart(); } catch (ePW2) {}
      if (params.get('np_reorder')) { vml.frozenProof = proof; vml.__frozeStart = true; } /* a reorder IS the catalog entry — never re-catalog it */
      upgradeVersionAlpha(vml); /* reorders arrive with the OPAQUE frozen copy — cut the studio white */
      setProp('_AI Proof', proof);
      setProp('_cartImg', digitalCartUrl(vml.alpha || mlAlpha || proof));
      freezeProofCopy(proof, (TYPE_KEY || 'patch') + '--ml', function (uF) {
        if (!uF) return;
        vml.frozenProof = uF;
        setProp('_AI Proof', uF);
      });
      setProp('_Proof Version', 'v1');
      setProp('_AI Proof Status', h ? 'Approved in Mockup Lab' : 'Approved in Mockup Lab - options did not carry over, specialist must confirm');
      if (mlArt && mlArt.indexOf('http') === 0) setProp('_Original Image', mlArt.split('?')[0]);
      commitOptions();
      /* compose OUR digital patch preview (shape + colors + fake merrow) so
         the compare slider's YOUR PREVIEW side shows the patch, not the raw
         upload — re-draw the approved canvas once it lands */
      composeAndHost().then(function () {
        if (st.proofApproved) { try { renderApprovedCanvas(); } catch (eRc2) {} }
      });
      /* the approved-summary elements are normally filled by approveProof —
         this path skips it, so fill them here (dead cart thumb otherwise) */
      var mlThumb = $('#np-e2-cart-thumb'); if (mlThumb) mlThumb.src = mlAlpha || proof;
      var mlLine = $('#np-e2-cart-line');
      if (mlLine) mlLine.textContent = (st.shape || 'Patch') + (st.border ? ' · ' + st.border.label + ' border' : '') + (st.bg ? ' · ' + st.bg.label + ' background' : '') + (st.thread ? ' · ' + st.thread.label + ' thread' : '') + (st.backing ? ' · ' + st.backing.label : '');
      var mlPfl = $('#np-e2-prooffile'); if (mlPfl) mlPfl.textContent = 'ai-proof-v1.png';
      /* the page BEHIND the modal is the approved summary (proof canvas +
         rulers, options collapsed) — same end-state as a normal approval, so
         sizing-Continue lands on the finished view */
      var mlAp = $('#np-e2-approved'); if (mlAp) mlAp.hidden = false;
      try { renderApprovedCanvas(); } catch (eac) {}
      upgradeVersionAlpha(vml); /* fallback transparent copy when np_alpha is absent */
      /* straight to Size & Pricing — but NEVER flash a not-ready image: hold
         the loading phase until the final transparent proof has fully loaded */
      showProofLoading('Preparing your approved proof\u2026');
      var mlTtl = document.getElementById('np-e2-pf-title'); if (mlTtl) mlTtl.textContent = 'Preparing your approved proof';
      var mlT0 = Date.now();
      function mlProbe(u, cb2) { var im = new Image(); im.onload = function () { cb2(true); }; im.onerror = function () { cb2(false); }; im.src = u; }
      (function mlReveal() {
        var timedOut = Date.now() - mlT0 > 12000;
        var src = vml.alpha || vml.dataUrl || vml.hosted || '';
        if (!src) { setTimeout(mlReveal, 300); return; }
        mlProbe(src, function (ok) {
          if (!ok && vml.alpha === src) {
            /* dead transparent copy — drop it, fall back to the real proof
               and let the local cut rebuild the alpha in the background */
            vml.alpha = null;
            setProp('_cartImg', digitalCartUrl(proof));
            upgradeVersionAlpha(vml);
            if (!timedOut) { setTimeout(mlReveal, 300); return; }
          }
          document.documentElement.classList.remove('np-e2-ml-arrive'); /* drop the first-paint cover */
          renderSizing();
        });
      })();
      return;
    }
    var pw = parseFloat(params.get('np_w')), ph = parseFloat(params.get('np_h')), pq = parseInt(params.get('np_qty'), 10);
    if (pw > 0 && ph > 0) {
      st.w = clampSize(Math.round(pw * 100) / 100, true);
      st.h = clampSize(Math.round(ph * 100) / 100, true);
      if (!isFinite(st.artRatio) || st.artRatio <= 0) st.artRatio = st.h / st.w; /* C45 fallback seed */
      st.ratio = st.h / st.w;
      st.sizeSeeded = true;
    }
    if (pq > 0) st.qty = Math.max(QTY_MIN, Math.min(QTY_MAX, pq));
    var art = params.get('np_art');
    /* the conversion carries the options — the cart line must still show
       Patch Background Color / Border Thread Color etc. on the new product */
    /* C157c: every label below is URL-sourced and reaches optionLabel() -> innerHTML unescaped — whitelist (exact list match
       or plain text), enum the corners, clamp the thickness */
    var qShape157 = ml157Label(CFG.shapes, legacyShapeLabel(params.get('np_shape'))); /* C223 */ if (qShape157) st.shape = qShape157;
    var qFold164 = params.get('np_fold'); if (qFold164 && CFG.folds) { var qFoldAlias173 = ({ 'Loop Fold': 'Center Fold' })[qFold164] || qFold164; /* C173: proofs saved before the rename */ var fArr164 = CFG.folds.filter(function (fq) { return fq.label === qFold164 || fq.label === qFoldAlias173; }); if (fArr164.length) { st.fold = fArr164[0]; applyFoldShape(); } } /* C164b: My Proofs re-order carries the fold (exact option match only) */
    var qCorners157 = params.get('np_corners'); if ((qCorners157 === 'square' || qCorners157 === 'rounded') && !PTYPE.fixedCorners) st.corners = qCorners157; /* C165 */
    if (params.get('np_lbt')) { var qLbt157 = parseInt(params.get('np_lbt'), 10); st.lbThick = isFinite(qLbt157) ? Math.max(0, Math.min(10, qLbt157)) : 3; }
    if (params.get('np_inv')) st.etchInvert = true;
    var texL = ml157Label(PTYPE.texture, params.get('np_tex'));
    if (texL) {
      st.texture = { label: texL, img: '' };
      (PTYPE.texture || []).forEach(function (tR) { if (tR.label === texL) st.texture = tR; });
    }
    var mats157 = (PTYPE && PTYPE.mats) || [];
    var qBgl157 = ml157Label((CFG.bgs || []).concat(mats157), params.get('np_bgl'));
    /* C180: a PMS-named colour arrives with its hex (np_bgh / np_thh / np_txh); the hex is the truth — re-name it from the current table */
    var hex176 = function (k) { var v = params.get(k) || ''; return /^#[0-9a-fA-F]{6}$/.test(v) ? v.toUpperCase() : ''; };
    var pmsShaped176 = function (l) { return /^PMS\s/.test(l || '') || ['Black 6 C', 'Black C', 'Cool Gray 9 C', 'Cool Gray 6 C', 'Cool Gray 2 C', 'Cool Gray 1 C'].indexOf(l) !== -1; };
    var withHex176 = function (c, hx) { if (!c) return c; (CFG.bgs || []).concat(CFG.threads || [], mats157).forEach(function (o) { if (o.label === c.label && o.hex && !c.hex) c.hex = o.hex; }); if (hx) { c.hex = hx; if (pmsShaped176(c.label)) c.label = pmsName(hx); } return c; };
    if (qBgl157) { st.bg = withHex176({ label: qBgl157, hex: '' }, hex176('np_bgh')); if (FOLLOW_RE.test(st.bg.label)) st.bg.follow = true; }
    var qThl157 = ml157Label(CFG.threads, params.get('np_thl'));
    if (qThl157) { st.thread = withHex176({ label: qThl157, hex: '' }, hex176('np_thh')); if (FOLLOW_RE.test(st.thread.label)) st.thread.follow = true; }
    var txL = ml157Label(CFG.threads, params.get('np_txl'));
    if (txL) {
      st.text = withHex176({ label: txL, hex: '' }, hex176('np_txh'));
      (CFG.threads || []).forEach(function (cT) { if (cT.label === txL) st.text = cT; });
    }
    var qBsl157 = ml157Label(CFG.borders, params.get('np_bsl')); if (qBsl157) st.border = { label: qBsl157 };
    var qBkl157 = ml157Label(CFG.backings, params.get('np_bkl')); if (qBkl157) st.backing = { label: qBkl157 };
    try { commitOptions(); } catch (eCo) {}
    /* keep the conversion reminder alive on the converted product — the
       customer must never lose sight of WHY they're on this product */
    var conv = params.get('np_conv') || ''; if (!/^[a-z]{1,12}$/.test(conv)) conv = ''; /* C157c: emitters send woven | ps | photo | detail */
    if (conv === 'woven' || conv === 'ps') { st.fdChoice = conv; st.fcConfirmed = true; st.fcOffered = true; }
    else if (conv) { st.fcForced = true; st.fcForcedReason = conv; st.fcConfirmed = true; st.fcOffered = true; }
    var ppA = params.get('np_pp') || '';
    if (ppA === 'digital' || ppA === 'stitch') {
      st.proofMode = ppA;
      setProp('_Proof Preference', ppA === 'stitch' ? 'REAL STITCHOUT REQUESTED ($19.99)' : 'DIGITAL PROOF (no AI render)');
      st.proof = { label: ppA === 'stitch' ? 'Real stitchout ($19.99)' : 'Digital proof', kind: ppA };
    }
    var v = newVersionMeta();
    v.dataUrl = proof; v.hosted = proof; v.rev = 0;
    /* C506 (PATCH-2122494, Justin 2026-10-21: "why did we reccomend full color on this leather patch????"): a My Proofs
       re-order (np_reorder, no np_conv) is THIS product's own proof — it is not a Full Color conversion. Flagging it fullColor
       made the review's approve read "Continue with Full Color patch" and hand a Faux Leather re-order off to
       /products/sublimated-patches (and a revision re-render it as Full Color). Conversions keep their flags. */
    var reorder506 = !!params.get('np_reorder') && !conv;
    v.fullColor = !reorder506 && conv !== 'ps';
    v.digital = (ppA === 'digital' || ppA === 'stitch');
    if (!reorder506) v.altKind = conv === 'woven' ? 'woven' : (conv === 'ps' ? 'ps' : 'fc');
    if (params.get('np_reorder')) { st.__reorderV508 = v; st.__reorderBsl508 = String(params.get('np_bsl') || ''); } /* C508 */
    st.versions = [v];
    st.selected = 0;
    st.proofApproved = true; try { prewarmAlphaForCart(); } catch (ePW2) {}
    st.fcOffered = true;
    if (params.get('np_reorder')) { v.frozenProof = proof; v.__frozeStart = true; } /* a reorder IS the catalog entry — never re-catalog it */
    if (!v.digital) upgradeVersionAlpha(v); /* reorders arrive with the OPAQUE frozen copy — cut the studio white */
    if (!v.digital) setProp('_AI Proof', proof);
    else setProp('_Mockup Catalog', proof);
    setProp('_cartImg', digitalCartUrl(v.alpha || proof));
    setProp('_AI Proof Status', conv === 'ps'
      ? 'Approved in Embroidered builder - converted to PRINT & STITCH (fine detail)'
      : (conv === 'woven'
        ? 'Approved in Embroidered builder - converted to WOVEN (fine detail)'
        : 'Approved in Embroidered builder - converted to FULL COLOR' + (conv === 'detail' ? ' (fine detail)' : (conv === 'photo' ? ' (photograph)' : ''))));
    var pn = params.get('np_notes');
    if (pn) setProp('_Revision Notes', pn);
    var dnA = params.get('np_dnotes');
    if (dnA) { setProp('Design Notes', dnA); var taDn = $('#np-e2-change-text'); if (taDn && !taDn.value) taDn.value = dnA; }
    /* lab handoff with revisions: the order carries the requested-revisions
       status exactly as if the note had been saved on this page */
    if (params.get('np_revreq')) setProp('_AI Proof Status', 'REVISIONS REQUESTED - specialist to apply notes');
    if (art && art.indexOf('http') === 0 && sameLineage(art, proof)) setProp('_Original Image', art);
    if (params.get('np_reorder')) setProp('_AI Proof Status', 'Reordered from My Proofs - AI proof attached');
    commitSizeQty();
    $('#np-e2-approved').hidden = false;
    $('#np-e2-cart-thumb').src = proof;
    $('#np-e2-cart-line').textContent = (CFG.productTitle || 'Patch') + (v.digital ? ' \u00b7 digital proof attached' : ' \u00b7 approved AI proof attached');
    var pfl3 = $('#np-e2-prooffile'); if (pfl3) pfl3.textContent = v.digital ? 'digital-proof.png' : 'ai-proof-fc.png';
    if (v.digital) {
      var crIA = document.querySelector('.np-e2-cartrow__mid i');
      if (crIA) crIA.textContent = 'Your original upload and your digital preview both attach to this order.';
      var coIA = document.querySelector('.np-e2-checkoutrow i');
      if (coIA) coIA.textContent = st.proofMode === 'stitch' ? 'A real stitched sample is produced and photographed for your approval first (adds 2-4 business days).' : 'Your digital preview is your proof above.';
    }
    renderApprovedCanvas();
    /* conversions land STRAIGHT in Size & Pricing — the approved summary
       waits behind the modal for when they close it */
    try { renderSizing(); } catch (eSz2) {}
  }

  /* ---- events ---- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var acccont = t.closest && t.closest('[data-e2-acccont]');
    if (acccont) {
      if (acccont.disabled) return;
      var ci2 = parseInt(acccont.getAttribute('data-e2-acccont'), 10);
      var nxA = stepAfter(ci2);
      if (nxA !== -1 && PTYPE.stitches && WZ_STEPS[nxA] === 'backing' && document.getElementById('np-e2-tt-stitchrow')) {
        accOpen = null;
        renderAccordion();
        ttStitchOpen(true);
        var rowSt = document.getElementById('np-e2-tt-stitchrow');
        setTimeout(function () {
          var ySt = rowSt.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
          window.scrollTo({ top: Math.max(0, ySt), behavior: 'smooth' });
        }, 60);
        return;
      }
      if (nxA === -1) {
        accOpen = null;
        renderAccordion();
        if (committed()) {
          if (PTYPE.names) { revealNames(); return; }
          proofAfterSelections183(); /* C183 */
        }
      } else {
        openAcc(nxA);
        /* bring the newly opened section's top into view */
        var rowN = document.querySelector('.np-e2-accrow[data-e2-acc="' + nxA + '"]');
        if (rowN) setTimeout(function () {
          var yR = rowN.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
          window.scrollTo({ top: Math.max(0, yR), behavior: 'smooth' });
        }, 60);
      }
      return;
    }
    var acctext = t.closest && t.closest('[data-e2-acctext]');
    if (acctext) {
      accOpen = null;
      renderAccordion();
      ttLetterOpen(true);
      var l1T = document.getElementById('np-e2-tt-l1');
      if (l1T) {
        var yT = l1T.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
        window.scrollTo({ top: Math.max(0, yT), behavior: 'smooth' });
        setTimeout(function () { try { l1T.focus(); } catch (eF) {} }, 320);
      }
      return;
    }
    var accdone = t.closest && t.closest('[data-e2-accdone]');
    if (accdone) {
      if (accdone.disabled) return;
      st.ctaRevealed = true;
      accOpen = null;
      renderAccordion();
      if (PTYPE.names) { revealNames(); return; }
      var fBD = document.getElementById('np-e2-proofbtn');
      if (fBD && !fBD.hidden) setTimeout(function () {
        var yD = fBD.getBoundingClientRect().top + window.pageYOffset - Math.round(window.innerHeight * 0.55);
        window.scrollTo({ top: Math.max(0, yD), behavior: 'smooth' });
      }, 60);
      return;
    }
    var acchead = t.closest && t.closest('[data-e2-acchead]');
    if (acchead) {
      var ai = parseInt(acchead.getAttribute('data-e2-acchead'), 10);
      if (accOpen === ai) { accOpen = null; renderAccordion(); } else openAcc(ai);
      return;
    }
    var row = t.closest && t.closest('[data-e2-row]');
    if (row) { openWizard(parseInt(row.getAttribute('data-e2-row'), 10)); return; }
    var seg = t.closest && t.closest('[data-e2-toggle]');
    if (seg) {
      var key = seg.getAttribute('data-e2-toggle');
      st[key === 'removeBg' ? 'removeBg' : 'crop'] = !st[key === 'removeBg' ? 'removeBg' : 'crop'];
      seg.querySelector('.np-e2-switch').classList.toggle('is-on');
      /* proxy into the legacy toggles so the imgix render + properties update */
      var legacy = key === 'removeBg' ? document.getElementById('option_checkbox_upscale') : document.getElementById('option_checkbox');
      if (legacy) legacy.click();
      loadArt(); /* re-render the canvas with the new imgix params */
      reseedAfterToggle();
      /* the palette belongs to the CURRENT render: re-read it and repaint the
         open colour step so "Colors from your artwork" follows the toggle */
      try {
        st.__artAnalyzed = false;
        analyzeArtwork();
        setTimeout(function () { try { renderAccordion(); } catch (eRA) {} }, 260);
      } catch (eAT) {}
      return;
    }
    var guideRow = t.closest && t.closest('[data-e2-guide]');
    if (guideRow) {
      /* apply the placement's preferred size: hit the CHARGED size exactly
         while keeping the aspect as close as possible */
      var gt = parseFloat(guideRow.getAttribute('data-e2-guide'));
      /* 2026-08-25 (Justin): Apply sets the WIDTH to the stated number and lets
         the height follow the artwork's aspect. It used to scale BOTH dimensions
         so the MEAN equalled the guide number — which kept the charged size
         exact but meant tapping "4 inches" never put 4 in the Width box.
         NOTE the trade-off: the charged size is still the mean rounded UP to a
         variant, so a 4.00 x 2.86 patch prices at 3.5", not 4". The guide now
         reads as "make it this wide", not "charge me this size". */
      if (sizeFirstOn()) { /* C230: a guide width whose derived side falls outside the window snaps to the nearest size that fits, with the little red note */
        var gW = gt, gH = heightLocked() ? gt : Math.round(gt * st.ratio * 100) / 100, snG = szfSnap(gW, gH);
        if (snG) { gW = snG.w; gH = snG.h; szfLimitNote(document.getElementById('np-e2-winput'), snG.kind, snG.limit); }
        st.w = gW; st.h = heightLocked() ? gW : gH;
      }
      else if (heightLocked()) { st.w = clampSize(gt); st.h = st.w; }
      else {
        st.w = clampSize(gt, true);
        st.h = clampSize(Math.max(SIZE_MIN, Math.round(st.w * st.ratio * 100) / 100), true);
      }
      commitSizeQty();
      renderSizeGuide();
      return;
    }
    if (t.closest && t.closest('[data-e2-close="guide"]')) { var gm = document.getElementById('np-e2-sizeguide-m'); if (gm) gm.hidden = true; return; }
    if (t.closest && t.closest('[data-e2-close="wizard"]')) { closeWizard(); return; }
    if (t.closest && t.closest('[data-e2-close="proof"]')) {
      if (st.proofPhase === 'sizing') { openLeaveConfirm(); return; }
      pf.hidden = true;
      return;
    }
    if (t === wz) { closeWizard(); return; }
    /* the proof modal only closes via its X — a stray backdrop click must
       never kill an in-flight render or an unsaved proof review */
  });

  $$('.np-e2-stepper button').forEach(function (b) {
    b.addEventListener('click', function () {
      var kind = b.closest('[data-e2-step]').getAttribute('data-e2-step');
      if (kind === 'w' || kind === 'h') npMarkSizeManual(); /* C25b: stepper = a deliberate size too */
      var d = parseInt(b.getAttribute('data-d'), 10);
      if (kind === 'w' && sizeFirstOn()) { /* C230: step, then snap to the window with the little red note (never a silent one-sided clamp) */
        var sW = Math.round((st.w + d * SIZE_STEP) * 100) / 100, sH = heightLocked() ? sW : Math.round(sW * st.ratio * 100) / 100, snW = szfSnap(sW, sH);
        if (snW) { sW = snW.w; sH = snW.h; szfLimitNote(document.getElementById('np-e2-winput'), snW.kind, snW.limit); }
        st.w = sW; st.h = heightLocked() ? sW : sH;
      }
      else if (kind === 'h' && sizeFirstOn()) {
        if (heightLocked()) return;
        var sH2 = Math.round((st.h + d * SIZE_STEP) * 100) / 100, sW2 = Math.round(sH2 / st.ratio * 100) / 100, snH = szfSnap(sW2, sH2);
        if (snH) { sW2 = snH.w; sH2 = snH.h; szfLimitNote(document.getElementById('np-e2-hinput'), snH.kind, snH.limit); }
        st.w = sW2; st.h = sH2;
      }
      else if (kind === 'w') {
        st.w = clampSize(Math.round((st.w + d * SIZE_STEP) * 100) / 100);
        st.h = heightLocked() ? st.w : clampSize(Math.round(st.w * st.ratio * 100) / 100, true);
      }
      else if (kind === 'h') {
        if (heightLocked()) return;
        st.h = clampSize(Math.round((st.h + d * SIZE_STEP) * 100) / 100);
        st.w = clampSize(Math.round(st.h / st.ratio * 100) / 100, true);
      }
      else { setQty(st.qty + d * QTY_STEP); return; }
      commitSizeQty();
    });
  });

  /* C25b — the steppers/inputs assign st.w/st.h but never marked the size as
     seeded, so a measurement resolving later could silently overwrite a number
     the customer had typed by hand. Anything the customer sets is final. */
  function npMarkSizeManual() { try { st.sizeSeeded = true; } catch (eMS2) {} }
  function wireSizeInput(id, key) {
    var el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('focus', function () { var s = this; setTimeout(function () { s.select(); }, 0); });
    el.addEventListener('click', function () { this.select(); });
    el.addEventListener('change', function () {
      var v = parseFloat(el.value);
      if (!v) v = SIZE_MIN;
      npMarkSizeManual(); /* C25b: a typed size outranks any late measurement */
      if (sizeFirstOn()) {
        /* C230 (Justin 2026-09-17): the derived side keeps the true proportion — a 2" wide logo really is 2 × 0.57 — and when either
           side falls outside the window the size SNAPS to the nearest one that fits, with the little red note under the box (2 s) */
        v = Math.round(v * 100) / 100; var rW, rH;
        if (key === 'w') { rW = v; rH = heightLocked() ? v : Math.round(v * st.ratio * 100) / 100; }
        else { if (heightLocked()) { renderPricing(); return; } rH = v; rW = Math.round(v / st.ratio * 100) / 100; }
        var snP = szfSnap(rW, rH); if (snP) { rW = snP.w; rH = snP.h; szfLimitNote(el, snP.kind, snP.limit); }
        st.w = rW; st.h = heightLocked() ? rW : rH;
        commitSizeQty();
        return;
      }
      v = clampSize(Math.round(v * 100) / 100);
      if (key === 'w') {
        st.w = v;
        st.h = heightLocked() ? v : clampSize(Math.round(v * st.ratio * 100) / 100, true);
      } else {
        if (heightLocked()) { renderPricing(); return; }
        st.h = v;
        st.w = clampSize(Math.round(v / st.ratio * 100) / 100, true);
      }
      commitSizeQty();
    });
    el.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); el.blur(); } });
  }
  wireSizeInput('np-e2-winput', 'w');
  wireSizeInput('np-e2-hinput', 'h');

  var qtyInput = document.getElementById('np-e2-qtyinput');
  if (qtyInput) {
    qtyInput.addEventListener('focus', function () { var el = this; setTimeout(function () { el.select(); }, 0); });
    qtyInput.addEventListener('click', function () { this.select(); });
    qtyInput.addEventListener('change', function () {
      var v = parseInt(qtyInput.value, 10);
      if (!v || v < QTY_MIN) {
        var cap = document.getElementById('np-e2-qtycap');
        cap.classList.add('is-error');
        setTimeout(function () { cap.classList.remove('is-error'); }, 2000);
        v = QTY_MIN;
      }
      setQty(v || QTY_MIN);
    });
    qtyInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); qtyInput.blur(); } });
  }

  $('#np-e2-wz-prev').addEventListener('click', function () { if (st.step > 0) { st.step--; renderWizard(); } });
  $('#np-e2-wz-next').addEventListener('click', function () {
    if ($('#np-e2-wz-next').disabled) return;
    if (st.step < 4) { st.step++; renderWizard(); } else applyDraft();
  });
  $('#np-e2-wz-save').addEventListener('click', applyDraft);

  $('#np-e2-change-toggle').addEventListener('click', function () {
    st.expanded = !st.expanded;
    $('.np-e2-change__body').hidden = !st.expanded;
    this.textContent = st.expanded ? 'Close' : 'Add a change';
    $('#np-e2-change-sub').textContent = st.expanded ? (st.isAI ? 'Edit with AI' : 'Design Notes') : 'AI edits or design notes for our art team';
    if (st.expanded) {
      var ctxt = $('#np-e2-change-text');
      if (ctxt) setTimeout(function () { try { ctxt.focus({ preventScroll: false }); } catch (eF) { ctxt.focus(); } }, 30);
    }
  });
  $$('.np-e2-pill').forEach(function (p) {
    p.addEventListener('click', function () {
      st.isAI = p.getAttribute('data-e2-mode') === 'ai';
      $$('.np-e2-pill').forEach(function (x) { x.classList.toggle('is-on', x === p); });
      $('#np-e2-change-sub').textContent = st.isAI ? 'Edit with AI' : 'Design Notes';
      $('#np-e2-mode-help').textContent = st.isAI ? 'Describe it and our AI applies it now' : 'Our art team handles it before printing';
      $('#np-e2-change-text').placeholder = st.isAI ? 'i.e. Make the outline thicker and center the text.' : 'i.e. Keep the white inside of the text. Change the border of the logo to blue.';
      $('#np-e2-mode-foot').textContent = st.isAI ? 'Free · Unlimited edits' : 'Free · Reviewed before printing';
      $('#np-e2-change-cta').textContent = st.isAI ? 'Generate edit' : 'Save notes';
      $('#np-e2-change-cta').classList.toggle('np-e2-btn--ai', st.isAI);
    });
  });
  (function () { var c0 = $('#np-e2-change-cta'); if (c0) c0.classList.toggle('np-e2-btn--ai', !!st.isAI); })();
  function aiEditModal(on) {
    /* Edit-with-AI takes over the page: a white square holds the wand ninja
       front and center and the backdrop blocks every control until the new
       artwork lands — picking options mid-generate left half the session
       derived from the OLD image. */
    var m = document.getElementById('np-e2-aimodal');
    if (!m && on) {
      m = document.createElement('div');
      m.id = 'np-e2-aimodal';
      m.className = 'np-e2-ov np-e2-ov--aimodal';
      m.innerHTML = '<div class="np-e2-aimodal__panel" role="alert" aria-busy="true">' +
        '<img src="https://cdn.shopify.com/s/files/1/0819/2170/4255/files/AI_Wizard_Patches.gif?v=1768923627" alt="">' +
        '<b>Transforming your image<br>with AI magic</b>' +
        '<i>Hang tight \u2014 just a few seconds</i></div>';
      document.body.appendChild(m);
    }
    if (m) m.hidden = !on;
  }
  $('#np-e2-change-cta').addEventListener('click', function () {
    var txt = $('#np-e2-change-text').value.trim();
    if (!txt) { $('#np-e2-change-text').focus(); return; }
    if (st.isAI && typeof window.nanoBananaEditRequest === 'function') {
      var cta = this; cta.textContent = 'Generating…'; cta.disabled = true;
      /* ONE indicator: the blocking white modal. The old in-canvas ninja
         stays retired — two wands at once read as a glitch. */
      aiEditModal(true);
      window.nanoBananaEditRequest(artworkUrl(), txt).then(function (url) {
        aiEditModal(false);
        if (/imgix/.test(url || '') && url.indexOf('cs=strip') === -1) url += (url.indexOf('?') === -1 ? '?' : '&') + 'cs=strip';
        var artElA = $('#np-e2-artimg');
        artElA.src = url;
        var hero = document.getElementById('fileupload_hero');
        if (hero) hero.setAttribute('src', url);
        analyzeArtwork();
        /* The artwork just CHANGED, so everything derived from it is stale: the
           composed reference we send the renderer, and the live patch preview.
           Without this the customer edits their art with AI on a fully
           configured patch and the preview keeps showing the OLD artwork. */
        sensei.composedUrl = null; sensei.composedFoldedUrl = null; sensei.composedLocal = null; sensei.composedLocalFolded = null; sensei.composedCleanUrl = null; sensei.composedCleanDone = false;
        var repaintA = function () {
          try { renderMaskPreview(); } catch (eR1) {}
          try { renderOptions(); } catch (eR2) {}
          try { if (accOpen !== null && accOpen !== undefined) renderAccordion(); } catch (eR3) {}
        };
        /* ALWAYS wait for the load event: right after assigning .src the element
           can still report complete/naturalWidth for the PREVIOUS image, so the
           earlier "repaint if complete" version recomposed the old artwork. */
        artElA.addEventListener('load', repaintA, { once: true });
        setTimeout(repaintA, 1200); /* belt and braces if the load event is missed */
        setProp('AI Edit', txt); /* session-only: stripped at add time, never synced to the line */
        cta.textContent = 'Generate edit'; cta.disabled = false;
        /* done populating — fold the change panel back up */
        st.expanded = false;
        $('.np-e2-change__body').hidden = true;
        var tglC = $('#np-e2-change-toggle');
        if (tglC) tglC.textContent = 'Add a change';
        var subC = $('#np-e2-change-sub');
        if (subC) subC.textContent = 'AI edits or design notes for our art team';
        /* the request is spent — clear it so the next edit starts empty */
        $('#np-e2-change-text').value = '';
        npToast('\u2713 AI edit applied');
      }).catch(function (err) {
        aiEditModal(false);
        alert('AI edit failed: ' + (err && err.message || 'try again'));
        cta.textContent = 'Generate edit'; cta.disabled = false;
      });
    } else {
      setProp('Design Notes', txt);
      lineSync({ 'Design Notes': txt });
      var el = this; el.textContent = 'Saved ✓';
      setTimeout(function () {
        el.textContent = 'Save notes';
        /* the note is filed — fold the panel back up */
        st.expanded = false;
        $('.np-e2-change__body').hidden = true;
        var tglN = $('#np-e2-change-toggle');
        if (tglN) tglN.textContent = 'Add a change';
        var subN = $('#np-e2-change-sub');
        if (subN) subN.textContent = 'AI edits or design notes for our art team';
      }, 1100);
    }
  });

  /* C183 (Justin 2026-09-11, 'when I edit selection and generate a new AI proof it brings up the old one for a few
     seconds and then it updates — it should come in with the new one ONLY'): every way back into the proof after the
     selections changed goes STRAIGHT to the generation phase (loading state, no stale version painted first). The
     Generate button already did this; the last accordion Continue and the reopen link reopened the previous render. */
  function proofAfterSelections183() {
    if (st.versions.length && !st.proofApproved && regensLeft() > 0 && specsChangedSince(st.versions[st.versions.length - 1])) { regenerateWithNotes(''); return; }
    if (!st.versions.length) openProof(); else reopenProof();
  }
  function reopenProof() {
    /* back into the proof modal (they approved but haven't checked out, or
       closed it) — NEVER burns a regeneration. Approved -> straight to the
       size & pricing phase; unapproved -> the review phase. */
    if (!st.versions.length) { openProof(); return; }
    if (st.proofApproved) {
      if (pdpPricingOn()) { pf.hidden = false; st.proofPhase = 'ready'; renderProofReady(); return; }
      renderSizing(); return;
    }
    pf.hidden = false;
    st.proofPhase = 'ready';
    renderProofReady();
  }
  function npScrollPad() {
    /* the mobile sticky preview overlays the top of the page — scrolled-to
       rows must land BELOW it, not underneath it */
    var stk = document.getElementById('np-e2-msticky');
    if (stk && window.innerWidth < 1025) { /* C541: was 1367 */
      var rS = stk.getBoundingClientRect();
      if (rS.height > 40) return Math.round(rS.bottom + 14);
    }
    return 120;
  }
  function firstUnsetStep() {
    var sq = stepSeq();
    for (var i = 0; i < sq.length; i++) { if (!st[WZ_STEPS[sq[i]]]) return sq[i]; }
    return sq.length ? sq[sq.length - 1] : 0;
  }
  var skipBtnE = document.getElementById('np-e2-skipproof');
  if (skipBtnE) skipBtnE.addEventListener('click', function () {
    if (st.versions.length || st.proofApproved) return;
    if (!committed()) { openAcc(firstUnsetStep()); return; }
    if (pdpPricingOn()) st.__skipCheckout = true; /* size/qty already picked on the page */
    startDigitalPath(false);
  });
  $('#np-e2-proofbtn').addEventListener('click', function () {
    if (this.disabled || this.hidden) return;
    if (!committed()) { openAcc(firstUnsetStep()); return; }
    if (!st.versions.length) { st.pendingProofKind = 'ai'; setProp('_Proof Preference', 'AI PROOF (free)'); }
    proofAfterSelections183(); /* C183: one rule for every re-entry — changed selections regenerate, unchanged reopen */
  });
  function paintSlider(el) {
    var p = (el.value - el.min) / (el.max - el.min) * 100;
    el.style.background = 'linear-gradient(to right, #1AA86C ' + p + '%, #d4f1e0 ' + p + '%)';
  }
  var zoomSlider = document.getElementById('np-e2-artzoom');
  if (zoomSlider) paintSlider(zoomSlider);
  if (zoomSlider) zoomSlider.addEventListener('input', function () {
    paintSlider(zoomSlider);
    st.artZoom = parseInt(zoomSlider.value, 10) / 100; if (Math.abs((st.artZoom || 1) - 1) < 0.001) { st.artDx = 0; st.artDy = 0; } /* 100% = centred again (review 2026-09-05) */
    var lv = document.getElementById('np-e2-artzoom-val');
    if (lv) lv.textContent = zoomSlider.value + '%';
    /* the preview img is the WHOLE composed patch — never transform it;
       re-compose instead so only the ART inside the shape scales */
    if (!zoomSlider.__npRaf) {
      zoomSlider.__npRaf = true;
      requestAnimationFrame(function () { zoomSlider.__npRaf = false; renderMaskPreview(); });
    }
    setProp('_Art Fill', zoomSlider.value + '%');
  });

  /* C151 (2026-09-05, Justin): "when an image is zoomed using artwork fill the user should be able to drag it up
     down left and right … it should snap to grid at center vertically and horizontally". The offset lives on the
     state as FRACTIONS of the patch box (artDx/artDy), every composer applies + clamps it (art edge never leaves the
     face), and this pointer wiring drags the live preview with a centre magnet on each axis. Pan is only armed when
     the fill is not 100% and the shape is not Design's Shape. */
  (function wireArtPan(){
    var cv = document.getElementById('np-e2-canvas'); if (!cv) return;
    var PAN_SNAP = 0.035, ZMIN = 0.6, ZMAX = 2.5, drag = null, pinch = null, pts = {};
    var PINCH = false; /* Justin 2026-09-05: "pinch zoom on mobile isn't a good feature" — the slider is the only fill control; one finger still drags */
    function hasArt(){ return !!(st.shape && shapeGeom() !== 'custom' && !PTYPE.noArt && !st.proofApproved && cv.querySelector('.np-e2-maskprev')); }
    function pannable(){ return hasArt(); } /* Justin 2026-09-05 ('still cant move image around' at 100%): drag at ANY fill — the clamp keeps the art inside the face */
    function zoomed(){ return Math.abs((st.artZoom || 1) - 1) > 0.001; }
    function cyOf(){ return (({ shield: 0.44, heart: 0.45 })[shapeGeom()] || 0.5); }
    function guideOf(mp){ var g = mp.querySelector('.np-e2-panguide'); if (!g) { g = document.createElement('i'); g.className = 'np-e2-panguide'; mp.appendChild(g); } g.style.setProperty('--pan-cy', (cyOf() * 100) + '%'); return g; }
    /* classes drive touch-action: pinch-able (pan-y: one finger still scrolls the page, two fingers reach us) and
       armed (none: one finger pans). Set at render time too, so the FIRST touch already sees the right policy. */
    function sync(){ var mp = cv.querySelector('.np-e2-maskprev'); if (!mp) return; var a = hasArt(); mp.classList.toggle('np-e2-pinch', a && PINCH); mp.classList.toggle('np-e2-pan', a && pannable()); mp.classList.toggle('np-e2-pan--free', a && zoomed()); /* at 100% touch keeps vertical page scroll (pan-y); zoomed = full 2D pan */ }
    window.__npE2PanSync = sync;
    function count(){ return Object.keys(pts).length; }
    function dist(){ var k = Object.keys(pts); if (k.length < 2) return 0; var a = pts[k[0]], b = pts[k[1]]; return Math.hypot(a.x - b.x, a.y - b.y); }
    function setZoom(z){
      z = Math.max(ZMIN, Math.min(ZMAX, Math.round(z * 20) / 20)); /* the slider's 5% steps */
      if (Math.abs(z - (st.artZoom || 1)) < 0.001) return false;
      st.artZoom = z; var pct = Math.round(z * 100); if (Math.abs((st.artZoom || 1) - 1) < 0.001) { st.artDx = 0; st.artDy = 0; } /* 100% = centred again (review 2026-09-05) */
      var zs = document.getElementById('np-e2-artzoom'), zv = document.getElementById('np-e2-artzoom-val'), z2 = document.querySelector('[data-e2-artzoom2]');
      if (zs) { zs.value = pct; try { paintSlider(zs); } catch (e1) {} } if (zv) zv.textContent = pct + '%';
      if (z2) { z2.value = pct; try { paintSlider(z2); } catch (e2) {} var b2 = z2.parentNode && z2.parentNode.querySelector('b'); if (b2) b2.textContent = pct + '%'; }
      try { setProp('_Art Fill', pct + '%'); } catch (e3) {}
      return true;
    }
    function schedule(){ if (schedule.raf) return; schedule.raf = true; requestAnimationFrame(function(){ schedule.raf = false; renderMaskPreview(); }); }
    cv.addEventListener('pointerover', sync);
    cv.addEventListener('dragstart', function(e){ if (e.target && e.target.closest && e.target.closest('.np-e2-maskprev')) e.preventDefault(); }); /* never let a native image drag cancel the pan (Justin 2026-09-05) */
    cv.addEventListener('contextmenu', function(e){ if (hasArt() && e.target && e.target.closest && e.target.closest('.np-e2-maskprev')) e.preventDefault(); }); /* a long-press must not open the image callout / context menu mid-pan */
    cv.addEventListener('pointerdown', function(e){
      var mp = e.target && e.target.closest ? e.target.closest('.np-e2-maskprev') : null;
      if (!mp || e.button || !hasArt()) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { mp.setPointerCapture(e.pointerId); } catch (eC) {}
      if (count() >= 2) { /* second finger: pinch = Artwork fill — OFF (PINCH flag) */
        if (!PINCH) return;
        if (drag) { drag.mp.classList.remove('is-panning'); drag = null; }
        pinch = { d0: dist() || 1, z0: st.artZoom || 1, mp: mp };
        mp.classList.add('is-pinching');
        e.preventDefault(); return;
      }
      if (!pannable()) return;
      var r = mp.getBoundingClientRect(); if (!r.width || !r.height) return;
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, dx0: st.artDx || 0, dy0: st.artDy || 0, w: r.width, h: r.height, mp: mp, moved: false }; /* the drag belongs to THIS pointer (review 2026-09-05) */
      mp.classList.add('is-panning'); sync();
      try { if (PTYPE.fold && st.fold) renderMaskPreview(); } catch (ePan170) {} /* C170: swap to the flat label for the drag; C174: keyed on the fold step */
      var g0 = guideOf(mp); g0.classList.toggle('is-snapx', !st.artDx); g0.classList.toggle('is-snapy', !st.artDy);
      e.preventDefault();
    });
    function move(e){
      if (pts[e.pointerId]) pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (pinch) { if (count() >= 2 && setZoom(pinch.z0 * dist() / pinch.d0)) schedule(); return; }
      if (!drag || e.pointerId !== drag.id) return; /* a stray second finger must not hijack the pan */
      var rx = drag.dx0 + (e.clientX - drag.x) / drag.w, ry = drag.dy0 + (e.clientY - drag.y) / drag.h;
      if (Math.abs(e.clientX - drag.x) + Math.abs(e.clientY - drag.y) > 2) drag.moved = true;
      if (!drag.moved) return; /* a 1-2px tap must not rewrite the offset (review 2026-09-05) */
      st.artDx = Math.abs(rx) < PAN_SNAP ? 0 : rx; st.artDy = Math.abs(ry) < PAN_SNAP ? 0 : ry; /* magnet: within 3.5% of a centre line = centred on that axis */
      var g = drag.mp.querySelector('.np-e2-panguide'); if (g) { g.classList.toggle('is-snapx', !st.artDx); g.classList.toggle('is-snapy', !st.artDy); }
      schedule();
    }
    function end(e){
      delete pts[e.pointerId];
      if (pinch) { if (count() < 2) { pinch.mp.classList.remove('is-pinching'); pinch = null; sync(); renderMaskPreview(); } return; }
      if (!drag || e.pointerId !== drag.id) return; /* only the owning pointer ends the pan */
      var mp = drag.mp, moved = drag.moved; drag = null;
      mp.classList.remove('is-panning');
      try { mp.releasePointerCapture(e.pointerId); } catch (eR) {}
      renderMaskPreview(); /* the composer clamps the final offset to the face and writes it back */
      if (moved) { try { setProp('_Art Fill', Math.round((st.artZoom || 1) * 100) + '%'); } catch (eS) {} }
    }
    cv.addEventListener('pointermove', move);
    cv.addEventListener('pointerup', end);
    cv.addEventListener('pointercancel', end);
  })();
  var reopenLink = document.getElementById('np-e2-pf-reopen');
  if (reopenLink) reopenLink.addEventListener('click', function (e) { e.preventDefault(); proofAfterSelections183(); }); /* C183 */

  var zb = $('#np-e2-zoombox');
  var zbIdx = 0;
  function zbShow(i) {
    var n = st.versions.length;
    if (!n) return;
    zbIdx = ((i % n) + n) % n;
    var v = st.versions[zbIdx];
    var src = v.dataUrl || v.hosted || v.alpha;
    if (!src) return;
    var wearZ = (zbIdx === ((st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected)) ? wearZoomSrc() : null; /* C224: zoom the garment mockup while it is on */
    $('#np-e2-zoombox-img').src = wearZ || src;
    var multi = n > 1;
    $('#np-e2-zoomprev').hidden = !multi;
    $('#np-e2-zoomnext').hidden = !multi;
    var cap = $('#np-e2-zoomcap');
    cap.hidden = !multi;
    cap.textContent = (v.fullColor ? 'FC' : 'V' + (zbIdx + 1)) + ' of ' + n;
    zb.hidden = false;
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.np-e2-pf-zoombtn')) {
      zbShow((st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected);
    } else if (e.target.closest && e.target.closest('#np-e2-zoomprev')) {
      zbShow(zbIdx - 1);
    } else if (e.target.closest && e.target.closest('#np-e2-zoomnext')) {
      zbShow(zbIdx + 1);
    } else if (e.target.closest && e.target.closest('#np-e2-zoomx')) {
      zb.hidden = true;
    } else if (!zb.hidden && (e.target === zb || e.target.id === 'np-e2-zoombox-img')) {
      zb.hidden = true;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (zb.hidden) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); zbShow(zbIdx - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); zbShow(zbIdx + 1); }
    else if (e.key === 'Escape') { zb.hidden = true; }
  });

  /* self-heal: if anything ever re-renders the section markup, the fresh copy
     shows the raw $0.00 placeholders — repaint it (all renderers query the
     document, not stale node references) */
  /* B81 (2026-08-25) — BOUND THE $0.00 SELF-HEAL. This was an UNBOUNDED repair
     loop: every 3s, forever, a $0.00 price triggered a FULL renderPricing() +
     renderOptions() rebuild. Sitting in any section where the price is not set
     yet (e.g. stepping BACK before size) put the builder in that state
     permanently — a complete options rebuild every 3 seconds, each one
     re-attaching listeners (151 addEventListener vs 2 removeEventListener in
     this file), so it compounded the longer you stayed. Justin, on Safari:
     "once you slow down and start going backwards into other sections thats
     when it tightens up and starts to lag."
     A repair that has not worked in 3 tries is not going to work on the 400th;
     the counter resets as soon as a real price renders, so a genuine later
     $0.00 still gets its own bounded set of retries. */
  var npZeroHealN = 0;
  setInterval(function () {
    if (!document.body.classList.contains('np-e2-active')) return;
    var each = document.getElementById('np-e2-each');
    if (!each) return;
    if (each.textContent === '$0.00') {
      if (npZeroHealN >= 3) return;
      npZeroHealN++;
      try { renderPricing(); renderOptions(); } catch (e) {}
    } else if (npZeroHealN) npZeroHealN = 0;
  }, 3000);
  $('#np-e2-fc-go').addEventListener('click', function () { if (PTYPE.labelsOnly) return; /* C163b */ generateFullColor(); });
  $('#np-e2-fc-no').addEventListener('click', function () { st.fcOffered = true; $('#np-e2-fc-reco').hidden = true; });
  $('#np-e2-pf-retry').addEventListener('click', function () { openProof(); });
  function editSelections() {
    /* selections are edited ON THE PAGE (accordion) — close the proof,
       open the options card; the way back is the "View your proof" button,
       where the revisions CTA flips to "Regenerate with updated selections". */
    pf.hidden = true;
    var rm = $('#np-e2-regenm'); if (rm) rm.hidden = true;
    if (document.body.classList.contains('np-e2-approved-view')) {
      /* the approved summary hides the options card — restore the editing
         surface (approval itself stands until a new render supersedes it) */
      document.body.classList.remove('np-e2-approved-view');
      try { clearApprovedCanvas(); } catch (eAc) {}
      renderOptions();
      renderMaskPreview();
    }
    openAcc((typeof stepSeq === 'function' && stepSeq()[0] != null) ? stepSeq()[0] : 0); /* C165b/C174: open the FIRST enabled row in accordion DOM order (labels: Fold Style sits before Shape; every other type still starts at Shape) */
    var oc = document.getElementById('np-e2-step-options');
    if (oc) oc.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  var revEditBtn = $('#np-e2-rev-edit');
  if (revEditBtn) revEditBtn.addEventListener('click', editSelections);
  var regenM = $('#np-e2-regenm');
  var regenMode = 'notes';
  var regenHadNotes = false;
  function openRegenModal(mode) {
    regenMode = mode;
    var updated = mode === 'updated';
    regenM.querySelector('.np-e2-modal__title').textContent = updated ? 'Regenerate with updated selections' : 'Submit Revisions';
    regenM.querySelector('.np-e2-wz-help').textContent = updated
      ? 'We\u2019ll re-render your ' + NP_NOUN + ' with the new selections. Add a note if there\u2019s anything else you\u2019d like changed (optional).'
      : 'Tell us what to change and a ' + NP_NOUN + ' specialist will apply it by hand before production \u2014 this does NOT re-generate the proof. Want a brand new proof instead? Use Edit selections above, which regenerates your ' + NP_NOUN + ' with the changes applied.';
    $('#np-e2-regen-go').textContent = updated ? 'Regenerate proof' : 'Save';
    var rc = $('#np-e2-revchoice'); if (rc) rc.hidden = false; /* Edit selections stays available in every mode */
    $('#np-e2-regen-notes').value = '';
    /* opened onto an existing note? then an EMPTY box is a valid save — it
       clears the revisions and returns the flow to a plain approval */
    regenHadNotes = !updated && !!(formProp('_Revision Notes') || '');
    $('#np-e2-regen-go').disabled = !updated && !regenHadNotes;
    regenM.hidden = false;
  }
  $('#np-e2-pf-regen').addEventListener('click', function () {
    if (this.disabled) return;
    openRegenModal(specsChangedSince(st.versions[st.versions.length - 1]) ? 'updated' : 'notes');
  });
  $('#np-e2-regen-notes').addEventListener('input', function () {
    $('#np-e2-regen-go').disabled = regenMode === 'updated' ? false : (!this.value.trim() && !regenHadNotes);
    if (regenHadNotes) $('#np-e2-regen-go').textContent = this.value.trim() ? 'Save' : 'Clear revisions';
  });
  $('#np-e2-regen-go').addEventListener('click', function () {
    var note = $('#np-e2-regen-notes').value.trim();
    if (regenMode !== 'updated' && !note && !regenHadNotes) return;
    regenM.hidden = true;
    if (regenMode !== 'updated' && !note && regenHadNotes) {
      /* cleared: drop the notes and the requested-revisions status so the
         footer goes back to a straight approval */
      setProp('_Revision Notes', '');
      lineSync({ '_Revision Notes': '' });
      setProp('_AI Proof Status', '');
      npToast('\u2713 Revisions cleared');
      renderProofReady();
      return;
    }
    if (regenMode === 'updated') {
      /* they changed their selections — that DOES warrant a fresh render */
      if (note) applyNoteSelections(note);
      regenerateWithNotes(note);
      return;
    }
    /* Notes-only revisions do NOT re-render. The note is filed as Revision
       Notes and a patch specialist applies it by hand; regenerating here was
       the source of the revision problems. Editing selections is the explicit
       path to a new proof. */
    setProp('_Revision Notes', (formProp('_Revision Notes') ? formProp('_Revision Notes') + ' | ' : '') + note);
    setProp('_AI Proof Status', 'REVISIONS REQUESTED - specialist to apply notes');
    setProp('_Proof Approval', proofApprovalLabel());
    lineSync({
      '_Revision Notes': formProp('_Revision Notes') || note,
      '_AI Proof Status': 'REVISIONS REQUESTED - specialist to apply notes',
      '_Proof Approval': proofApprovalLabel()
    });
    npToast('\u2713 Revision notes saved');
    renderProofReady();
    var svEl = document.getElementById('np-e2-pf-revsaved');
    if (svEl) svEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-e2-close="regen"]')) regenM.hidden = true;
    else if (e.target === regenM) regenM.hidden = true;
  });
  var revEditBtn = document.getElementById('np-e2-pf-reveditbtn');
  if (revEditBtn) revEditBtn.addEventListener('click', function () {
    openRegenModal('notes');
    var box = $('#np-e2-regen-notes');
    if (box) { box.value = formProp('_Revision Notes') || ''; box.dispatchEvent(new Event('input', { bubbles: true })); }
  });
  $('#np-e2-pf-approve').addEventListener('click', approveProof);
  /* B90 (2026-08-25) — STOP THE NATIVE FORM SUBMIT.
     This was `addEventListener('click', doCheckout)` and doCheckout takes NO
     event, so nothing ever called preventDefault(). A <button> inside the
     product <form> defaults to type="submit", so each click ALSO fired a native
     submit — a full page navigation. The browser then freezes the outgoing
     document, which is the exact fingerprint we measured on Justin's adds:
     timers 0 ticks of an expected 135, worker 0, longest task 153ms (thread
     IDLE, not busy), zero network entries, tab awake and never hidden. The wait
     was the server answering the form navigation, and /cart takes 5-7s to serve.
     PROOF from Justin: adding from the mockup shelf is "almost instant" — that
     path calls doCheckout() PROGRAMMATICALLY (see reorder flow), with no click
     event and therefore no form submit. Same add code, no freeze.
     Belt and braces: force type="button" AND preventDefault on the click. */
  (function () {
    var coBtn = $('#np-e2-checkout');
    if (!coBtn) return;
    try { coBtn.setAttribute('type', 'button'); } catch (eT) {}
    coBtn.addEventListener('click', function (evCo) {
      try { if (evCo && evCo.preventDefault) { evCo.preventDefault(); evCo.stopPropagation(); } } catch (eP) {}
      doCheckout();
    });
  })();
  /* detector: if anything still submits the product form during an add, say so
     in the log rather than leaving it to be re-diagnosed from symptoms. */
  try {
    document.addEventListener('submit', function (evS) {
      try {
        coMark('FORM-SUBMIT' + (window.__npAdding ? ':DURING-ADD-BLOCKED' : ''));
        if (window.__npAdding) { evS.preventDefault(); evS.stopImmediatePropagation(); }
      } catch (eS2) {}
    }, true);
  } catch (eS) {}
  function parseNamesCsv(text) {
    /* proper quoted-cell parse so "Smith, John" stays one cell */
    var rows = [], row = [], cell = '', q = false;
    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      if (q) {
        if (ch === '"') { if (text[i + 1] === '"') { cell += '"'; i++; } else q = false; }
        else cell += ch;
      } else if (ch === '"') q = true;
      else if (ch === ',') { row.push(cell); cell = ''; }
      else if (ch === '\n' || ch === '\r') {
        if (ch === '\r' && text[i + 1] === '\n') i++;
        row.push(cell); cell = '';
        rows.push(row); row = [];
      } else cell += ch;
    }
    row.push(cell);
    rows.push(row);
    rows = rows.map(function (r) {
      return r.map(function (c) { return c.replace(/\s+/g, ' ').trim(); }).filter(function (c) { return !!c; });
    }).filter(function (r) { return r.length; });
    if (!rows.length) return [];
    /* a header row ("Name", "First Name"...) is metadata, not a customer */
    var HDR = /^(names?|first|last|middle|first ?name|last ?name|full ?name|employees?|players?|members?|staff|roster|title|#|no\.?|number|id)$/i;
    if (rows.length > 1 && rows[0].every(function (c) { return HDR.test(c); })) rows.shift();
    /* one row of many cells = a comma list of names; many rows = one name per
       row, with multi-column rows (First,Last) joined into the full name */
    var out = (rows.length === 1 && rows[0].length > 1) ? rows[0] : rows.map(function (r) { return r.join(' '); });
    /* the roster textarea treats commas as SEPARATORS — a comma inside a
       quoted cell ("Smith, Jr.") would split into two names downstream */
    return out.map(function (nm) { return nm.replace(/\s*,\s*/g, ' ').replace(/\s+/g, ' ').trim(); });
  }
  /* the preview shows the name being TYPED: the roster row under the caret,
     else the last row they were on, else (right after a CSV) the first name */
  var namePrevTimer = null;
  function namePreviewFromCaret() {
    var taP = document.getElementById('np-e2-names-ta');
    if (!taP || !PTYPE.names) return;
    var V = taP.value, P = taP.selectionStart || 0;
    /* the active segment is bounded by newlines OR commas, same as the split */
    var a = Math.max(V.lastIndexOf('\n', P - 1), V.lastIndexOf(',', P - 1)) + 1;
    var nl = V.indexOf('\n', P), cm = V.indexOf(',', P);
    var b = Math.min(nl === -1 ? V.length : nl, cm === -1 ? V.length : cm);
    var seg = V.slice(a, b).trim();
    if (!seg || seg === st.namePreview) return; /* empty row: keep the last one */
    st.namePreview = seg;
    if (namePrevTimer) clearTimeout(namePrevTimer);
    /* a breath of throttle so fast typing doesn't queue a compose per key */
    namePrevTimer = setTimeout(function () { namePrevTimer = null; try { renderMaskPreview(); } catch (eNP) {} }, 120);
  }
  (function () {
    var taP = document.getElementById('np-e2-names-ta');
    if (!taP) return;
    ['input', 'keyup', 'click', 'focus'].forEach(function (evN) {
      taP.addEventListener(evN, namePreviewFromCaret);
    });
  })();
  /* ═══ ROSTER TABS (custom names): Grid table / Bulk paste / Upload CSV.
     All three write through the ONE textarea (#np-e2-names-ta) — namesList(),
     pricing, minimums and the order property never learn a second source. ═══ */
  function nrPane(which) {
    ['grid', 'paste', 'csv'].forEach(function (k) {
      var pane = document.getElementById('np-e2-nr-' + k);
      if (pane) pane.hidden = k !== which;
    });
    $$('.np-e2-nr-tab').forEach(function (t) {
      var on = t.getAttribute('data-nr-tab') === which;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (which === 'grid') nrRenderRows();
  }
  /* clicking into a roster QTY selects the whole value — typing replaces
     instead of appending (a tapped "1" becoming "110" was a support call) */
  document.addEventListener('focusin', function (evQ) {
    var q = evQ.target;
    if (q && q.classList && q.classList.contains('np-e2-nr-qn')) {
      q.__npSelArm = 1;
      try { q.select(); } catch (eQ0) {}
      setTimeout(function () { try { q.select(); } catch (eQS) {} }, 0);
      requestAnimationFrame(function () { try { q.select(); } catch (eQR) {} });
    }
  });
  /* the mouseup that follows the focusing click would collapse the selection */
  document.addEventListener('mouseup', function (evM) {
    var q = evM.target;
    if (q && q.classList && q.classList.contains('np-e2-nr-qn') && q.__npSelArm) {
      q.__npSelArm = 0;
      evM.preventDefault();
    }
  });
  function nrRowHTML(val, qty) {
    var q = Math.max(1, parseInt(qty, 10) || 1);
    return '<div class="np-e2-nr-row' + (String(val || '').trim() ? '' : ' is-blank') + '">' +
      '<input type="text" class="np-e2-nr-name" value="' + String(val || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;') + '" placeholder="Name" spellcheck="false" autocomplete="off">' +
      '<span class="np-e2-nr-qty"><button type="button" class="np-e2-nr-qbtn" data-nr-q="-1" aria-label="One fewer">\u2212</button>' +
      '<input type="number" class="np-e2-nr-qn" value="' + q + '" min="1" inputmode="numeric" aria-label="Quantity of this name">' +
      '<button type="button" class="np-e2-nr-qbtn" data-nr-q="1" aria-label="One more">+</button></span>' +
      '<button type="button" class="np-e2-nr-del" aria-label="Remove name">\u00d7</button></div>';
  }
  function nrRenderRows() {
    /* the roster is one name per patch; the grid shows CONSECUTIVE repeats of
       a name as one row with a quantity, so a team of 12 "Smith"s is one row */
    var box = document.getElementById('np-e2-nr-rows');
    if (!box) return;
    var list = namesList(), grouped = [];
    list.forEach(function (nm) {
      var lastG = grouped[grouped.length - 1];
      if (lastG && lastG.name === nm) lastG.qty++;
      else grouped.push({ name: nm, qty: 1 });
    });
    /* no phantom spare row: "+ Add row" (or Enter) mints new ones — a
       permanent empty row with a live-looking qty read as a counted entry */
    box.innerHTML = grouped.length ? grouped.map(function (g) { return nrRowHTML(g.name, g.qty); }).join('') : nrRowHTML('', 1);
    nrWireRows(box);
  }
  function nrSync() {
    /* rows -> textarea -> everything else: each row expands to (qty) roster
       lines, so one patch per name stays literally true downstream. Empty
       rows stay OUT of the roster but their inputs stay on screen. */
    var box = document.getElementById('np-e2-nr-rows');
    var ta = document.getElementById('np-e2-names-ta');
    if (!box || !ta) return;
    var out = [];
    [].slice.call(box.querySelectorAll('.np-e2-nr-row')).forEach(function (row) {
      var nm = row.querySelector('.np-e2-nr-name').value.replace(/[\n,]+/g, ' ').trim();
      if (!nm) return;
      var qEl = row.querySelector('.np-e2-nr-qn');
      var q = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
      for (var i3 = 0; i3 < q; i3++) out.push(nm);
    });
    ta.value = out.join('\n');
    renderNames();
  }
  function nrWireRows(box) {
    $$('.np-e2-nr-name', box).forEach(function (inp) {
      inp.addEventListener('input', function () {
        this.closest('.np-e2-nr-row').classList.toggle('is-blank', !this.value.trim());
        nrSync();
        /* the live preview follows the row being typed, like the caret does */
        var v2 = this.value.trim();
        if (v2) { st.namePreview = v2; try { renderMaskPreview(); } catch (eGP) {} }
      });
      inp.addEventListener('focus', function () {
        var v3 = this.value.trim();
        if (v3) { st.namePreview = v3; try { renderMaskPreview(); } catch (eGF) {} }
      });
      inp.addEventListener('keydown', function (ev2) {
        /* Enter walks down the roster, minting a fresh row from the last one */
        if (ev2.key !== 'Enter') return;
        ev2.preventDefault();
        var rows2 = [].slice.call(box.querySelectorAll('.np-e2-nr-name'));
        var at = rows2.indexOf(this);
        if (at === rows2.length - 1) { nrAddRow(); }
        else rows2[at + 1].focus();
      });
    });
    $$('.np-e2-nr-qbtn', box).forEach(function (qb) {
      qb.addEventListener('click', function () {
        var qn = this.parentElement.querySelector('.np-e2-nr-qn');
        var v4 = Math.max(1, (parseInt(qn.value, 10) || 1) + parseInt(this.getAttribute('data-nr-q'), 10));
        qn.value = v4;
        nrSync();
        var nmQ = this.closest('.np-e2-nr-row').querySelector('.np-e2-nr-name').value.trim();
        if (nmQ) { st.namePreview = nmQ; try { renderMaskPreview(); } catch (eQP) {} }
      });
    });
    $$('.np-e2-nr-qn', box).forEach(function (qn) {
      ['input', 'change'].forEach(function (evQ) {
        qn.addEventListener(evQ, function () {
          if (this.value !== '' && (parseInt(this.value, 10) || 0) < 1) this.value = 1;
          nrSync();
        });
      });
      qn.addEventListener('blur', function () { if (!this.value) { this.value = 1; nrSync(); } });
    });
    $$('.np-e2-nr-del', box).forEach(function (del) {
      del.addEventListener('click', function () {
        var row = this.closest('.np-e2-nr-row');
        var only = box.querySelectorAll('.np-e2-nr-row').length === 1;
        if (only) {
          /* the grid never goes empty — the last row clears instead */
          row.querySelector('.np-e2-nr-name').value = '';
          var qq = row.querySelector('.np-e2-nr-qn'); if (qq) qq.value = 1;
          row.classList.add('is-blank');
          nrSync();
          return;
        }
        row.remove(); /* filled or empty alike */
        nrSync();
        nrRenderRows(); /* neighbours that now touch regroup into one row */
      });
    });
  }
  function nrAddRow() {
    var box = document.getElementById('np-e2-nr-rows');
    if (!box) return;
    box.insertAdjacentHTML('beforeend', nrRowHTML(''));
    nrWireRows(box);
    var all = box.querySelectorAll('.np-e2-nr-name');
    all[all.length - 1].focus();
  }
  (function () {
    var addB = document.getElementById('np-e2-nr-add');
    if (addB) addB.addEventListener('click', nrAddRow);
    $$('.np-e2-nr-tab').forEach(function (t) {
      t.addEventListener('click', function () { nrPane(this.getAttribute('data-nr-tab')); });
    });
  })();
  var namesCsvBtn = document.getElementById('np-e2-names-csv');
  var namesCsvFile = document.getElementById('np-e2-names-csvfile');
  if (namesCsvBtn && namesCsvFile) {
    namesCsvBtn.addEventListener('click', function (evD) {
      /* the template link inside the dropzone downloads — it never opens the picker */
      if (evD.target && evD.target.closest && evD.target.closest('.np-e2-nr-tpl')) return;
      namesCsvFile.click();
    });
    namesCsvBtn.addEventListener('dragover', function (evO) { evO.preventDefault(); this.classList.add('is-drag'); });
    namesCsvBtn.addEventListener('dragleave', function () { this.classList.remove('is-drag'); });
    namesCsvBtn.addEventListener('drop', function (evP) {
      evP.preventDefault();
      this.classList.remove('is-drag');
      try {
        if (evP.dataTransfer && evP.dataTransfer.files && evP.dataTransfer.files.length) {
          namesCsvFile.files = evP.dataTransfer.files;
          namesCsvFile.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } catch (eDD) {}
    });
    namesCsvFile.addEventListener('change', function () {
      var fC = this.files && this.files[0];
      if (!fC) return;
      var noteC = document.getElementById('np-e2-names-csvnote');
      var rd = new FileReader();
      rd.onload = function () {
        var names = parseNamesCsv(String(rd.result || ''));
        var taC = document.getElementById('np-e2-names-ta');
        if (!names.length) {
          if (noteC) { noteC.textContent = 'No names found in ' + fC.name; noteC.classList.remove('is-ok'); }
          return;
        }
        if (taC) {
          var curC = taC.value.trim();
          /* appended, never replaced — typed names survive the upload */
          taC.value = (curC ? curC + '\n' : '') + names.join('\n');
          taC.dispatchEvent(new Event('input', { bubbles: true }));
        }
        if (noteC) {
          noteC.textContent = names.length + ' name' + (names.length === 1 ? '' : 's') + ' added from ' + fC.name;
          noteC.classList.add('is-ok');
        }
        var firstN = namesList()[0];
        if (firstN) { st.namePreview = firstN; try { renderMaskPreview(); } catch (eNP2) {} }
        /* the customer should SEE what the file became — flip to the grid */
        try { nrPane('grid'); } catch (eNG) {}
      };
      rd.onerror = function () { if (noteC) { noteC.textContent = 'Could not read ' + fC.name; noteC.classList.remove('is-ok'); } };
      rd.readAsText(fC);
      this.value = ''; /* same file can be picked again */
    });
  }
  var namesTaE = document.getElementById('np-e2-names-ta');
  if (namesTaE) {
    namesTaE.addEventListener('input', renderNames);
    namesTaE.addEventListener('change', renderNames);
  }
  for (var iTT = 1; iTT <= 3; iTT++) {
    (function (elTT) {
      if (!elTT) return;
      elTT.addEventListener('input', function () { ttSync(); });
      elTT.addEventListener('change', function () { ttSync(); });
    })(document.getElementById('np-e2-tt-l' + iTT));
  }
  $$('[data-tt-seg]').forEach(function (segB) {
    segB.addEventListener('click', function () {
      var grp = this.getAttribute('data-tt-seg');
      var val = this.getAttribute('data-tt-val');
      if (grp === 'fmt') st.ttFormat = val; else { st.ttStitch = val; st.ttStitchSeen = true; }
      $$('[data-tt-seg="' + grp + '"]').forEach(function (b2) {
        b2.classList.toggle('is-on', b2 === segB);
      });
      ttSync();
    });
  });
  $$('[data-tt-lay]').forEach(function (selL) {
    selL.addEventListener('change', function () {
      var vL = this.value;
      var wasSlant = false;
      $$('[data-tt-lay]').forEach(function (s2) { if (/slant/i.test(s2.value)) wasSlant = true; });
      st['ttLay' + this.getAttribute('data-tt-lay')] = vL;
      /* a slant is a property of the whole BLOCK, not one line: the lines
         have to stay parallel, so they all tilt (or un-tilt) together */
      if (/slant/i.test(vL) || wasSlant) {
        $$('[data-tt-lay]').forEach(function (s3) {
          s3.value = vL;
          st['ttLay' + s3.getAttribute('data-tt-lay')] = vL;
        });
      }
      ttSync();
    });
  });
  [2, 3].forEach(function (nH) {
    var bH = document.getElementById('np-e2-tt-half' + nH);
    if (!bH) return;
    bH.addEventListener('click', function () {
      st['ttHalf' + nH] = !st['ttHalf' + nH];
      this.classList.toggle('is-on', !!st['ttHalf' + nH]);
      this.setAttribute('aria-pressed', st['ttHalf' + nH] ? 'true' : 'false');
      ttSync();
    });
  });
  var stitchHeadE = document.getElementById('np-e2-tt-stitchhead');
  if (stitchHeadE) stitchHeadE.addEventListener('click', function () {
    var bodyS = document.getElementById('np-e2-tt-stitchbody');
    ttStitchOpen(bodyS ? bodyS.hidden : true);
  });
  var stitchContE = document.getElementById('np-e2-tt-stitchcont');
  if (stitchContE) stitchContE.addEventListener('click', function () {
    st.ttStitchSeen = true;
    ttStitchOpen(false);
    var headB = document.querySelector('.np-e2-accrow[data-e2-acc="5"] [data-e2-acchead]');
    if (headB) {
      headB.click();
      setTimeout(function () {
        var rowB = headB.closest('.np-e2-accrow');
        var yB = rowB.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
        window.scrollTo({ top: Math.max(0, yB), behavior: 'smooth' });
      }, 120);
    }
  });
  var letterContE = document.getElementById('np-e2-tt-lettercont');
  if (letterContE) letterContE.addEventListener('click', function () {
    ttLetterOpen(false);
    try { ttSync(false); } catch (eLC) {}
    var firstHead = document.querySelector('#np-e2-step-options .np-e2-accrow:not([hidden]) [data-e2-acchead]');
    if (firstHead) {
      firstHead.click();
      var rowF = firstHead.closest('.np-e2-accrow');
      setTimeout(function () {
        var yF = rowF.getBoundingClientRect().top + window.pageYOffset - npScrollPad();
        window.scrollTo({ top: Math.max(0, yF), behavior: 'smooth' });
      }, 120);
    }
  });
  function doModeSwitch(m) {
    /* NOTE: switching tabs does NOT write the mode memory — only ADDING TO
       CART does (see armClassicAddMemory + the builder's cart POSTs) */
    if (m === 'classic') {
      /* hand off to the legacy flow WITH the artwork: its reuse path reads
         everything after "file=", so that param must stay LAST */
      var artC = cleanUrl(artworkUrl() || '');
      var baseC = location.pathname + '?np_mode=classic' + (artC ? '&file=' + encodeURIComponent(artC) : '');
      markModeJump('Switching to Classic Order Mode');
      showPageLoader('Switching to Classic Order Mode');
      location.href = baseC;
      return;
    }
    var artA = PTYPE.noArt ? '' : (cleanUrl(artworkUrl() || '') || legacyArtworkUrl()); /* C231: the typed builder takes no file */
    if (document.body.classList.contains('np-e2-classic')) {
      /* the builder never booted on this page load — come back through a
         clean AI arrival carrying the artwork */
      markModeJump('Switching to AI Order Mode');
      showPageLoader('Switching to AI Order Mode');
      location.href = location.pathname + '?np_mode=ai' + (artA ? '&file=' + encodeURIComponent(artA) : '');
      return;
    }
    activate();
    paintModeSwitch();
  }
  var modeConfirmEl = null;
  function openModeConfirm(m) {
    /* our own dialog, in the builder's voice — never window.confirm — and it
       shows EVERY time: switching always restarts the design on the other
       flow, whether or not anything has been chosen yet */
    if (!modeConfirmEl) {
      modeConfirmEl = document.createElement('div');
      modeConfirmEl.className = 'np-e2-ov np-e2-ov--fcc';
      modeConfirmEl.innerHTML = '<div class="np-e2-modal np-e2-modal--fcc">' +
        '<header class="np-e2-modal__head"><div><span class="np-e2-modal__eyebrow np-e2-fcc-eyebrow">SWITCH ORDER MODE?</span>' +
        '<h3 class="np-e2-modal__title" data-mc-title></h3></div></header>' +
        '<div class="np-e2-modal__body"><p class="np-e2-fcc-txt" data-mc-txt></p></div>' +
        '<footer class="np-e2-modal__foot"><button type="button" class="np-e2-btn np-e2-btn--outline" data-mc-stay>Stay here</button>' +
        '<div class="np-e2-modal__footright"><button type="button" class="np-e2-btn np-e2-btn--green" data-mc-go></button></div></footer></div>';
      /* NOT inside #np-e2 — that whole tree is display:none in classic mode,
         and this dialog has to open from both sides of the switch */
      document.body.appendChild(modeConfirmEl);
      modeConfirmEl.querySelector('[data-mc-stay]').addEventListener('click', function () { modeConfirmEl.hidden = true; });
      modeConfirmEl.addEventListener('click', function (ev) { if (ev.target === modeConfirmEl) modeConfirmEl.hidden = true; });
      modeConfirmEl.querySelector('[data-mc-go]').addEventListener('click', function () {
        modeConfirmEl.hidden = true;
        doModeSwitch(modeConfirmEl.getAttribute('data-mc-mode') || 'ai');
      });
    }
    modeConfirmEl.setAttribute('data-mc-mode', m);
    var toClassic = m === 'classic';
    modeConfirmEl.querySelector('[data-mc-title]').textContent = toClassic
      ? 'Switch to Classic Order Mode?' : 'Switch to AI Order Mode?';
    modeConfirmEl.querySelector('[data-mc-txt]').innerHTML = toClassic
      ? 'Your uploaded image comes with you, but <b>any selections made here will be cleared</b> \u2014 you\u2019ll start fresh in the classic order form.'
      : 'Your uploaded image comes with you, but <b>any selections made in the classic form will be cleared</b> \u2014 you\u2019ll start fresh in the AI designer.';
    modeConfirmEl.querySelector('[data-mc-go]').textContent = toClassic
      ? 'Switch to Classic' : 'Switch to AI Mode';
    modeConfirmEl.hidden = false;
  }
  /* C74: classic-side progress tracker - any change inside the legacy form */
  document.addEventListener('change', function (ev74) {
    if (!document.body.classList.contains('np-e2-classic')) return;
    var t74 = ev74.target;
    if (t74 && t74.closest && t74.closest('#uploadArea, .customVariantWidget, .fileupload_bg_options, .product-variant__item, form[action*="/cart/add"], .customTabelPlace')) {
      window.__npClassicTouched74 = true;
    }
  }, true);
  $$('#np-e2-modeswitch .np-e2-modebtn[data-e2-mode]').forEach(function (bM) {
    bM.addEventListener('click', function () {
      var m = this.getAttribute('data-e2-mode');
      if (m !== 'ai' && m !== 'classic') return;
      /* compare against the PAGE's actual mode, not the stored preference */
      var curM = document.body.classList.contains('np-e2-classic') ? 'classic' : 'ai';
      if (m === curM) return;
      /* C74 (2026-08-31, Justin: "not pop up unless someone has picked an
         option and began the process down that flow"). The confirm exists to
         warn that selections will be cleared - with nothing selected there is
         nothing to lose, so the switch is silent. AI progress = any committed
         or drafted option, a proof, or an approval; classic progress = the
         customer touched any control in the classic form this page load. */
      var prog74 = false;
      if (curM === 'ai') {
        try {
          /* C164c: seeded product facts (fixedShape, defaultBg) are not customer progress */
          prog74 = !!(st.versions.length || st.proofApproved || (stepEnabled('shape') && st.shape && !st.__shapeSeeded175) || (st.bg && !st.__bgSeeded166) || st.thread || st.border || st.backing || st.fold ||
            (st.draft && ((stepEnabled('shape') && st.draft.shape && !st.__shapeSeeded175) || (st.draft.bg && !st.__bgSeeded166) || st.draft.thread || st.draft.border || st.draft.backing || st.draft.text || st.draft.fold /* C164b */))); /* C182: a seeded Rectangle is not progress */
        } catch (e74) { prog74 = true; }
      } else {
        prog74 = !!window.__npClassicTouched74;
      }
      /* C88 (2026-08-31, Justin: "switching to AI mode shouldn't ask for
         approval just take them"): classic -> AI always switches silently;
         the confirm only guards leaving AI-mode progress. */
      if (m === 'ai' || !prog74) { doModeSwitch(m); return; }
      openModeConfirm(m);
    });
  });
  if (window.matchMedia) {
    /* the tabs sit in a different place in one column than in two, so they
       have to be re-placed when the layout flips (rotate / resize) */
    var mqCol = window.matchMedia('(max-width: 1120px)');
    var onCol = function () { try { paintModeSwitch(); } catch (eC) {} };
    if (mqCol.addEventListener) mqCol.addEventListener('change', onCol);
    else if (mqCol.addListener) mqCol.addListener(onCol);
  }
  var mswRsz = null;
  window.addEventListener('resize', function () {
    /* classic alignment is measured, not styled — re-measure when settled */
    clearTimeout(mswRsz);
    mswRsz = setTimeout(function () { try { paintModeSwitch(); } catch (eR) {} }, 180);
  });
  var letterHeadE = document.getElementById('np-e2-tt-letterhead');
  if (letterHeadE) letterHeadE.addEventListener('click', function () {
    var bodyL = document.getElementById('np-e2-tt-letterbody');
    ttLetterOpen(bodyL ? bodyL.hidden : true);
    try { ttSync(false); } catch (eL) {}
  });
  var swSelE = document.getElementById('np-e2-tt-swstyle');
  if (swSelE) {
    TT_SWOOSHES.forEach(function (sw) {
      var o = document.createElement('option');
      o.value = String(sw.n); o.textContent = '#' + sw.n + ' \u2014 ' + sw.name;
      swSelE.appendChild(o);
    });
    swSelE.value = '1'; /* Classic Tail */
    swSelE.addEventListener('change', function () { st.swooshStyle = this.value; ttSync(); });
  }
  var swColE = document.getElementById('np-e2-tt-swtxtcolor');
  if (swColE) swColE.addEventListener('change', function () { ttSync(); });
  var swTxtE = document.getElementById('np-e2-tt-swtxt');
  if (swTxtE) {
    swTxtE.addEventListener('input', function () { ttSync(); });
    swTxtE.addEventListener('change', function () { ttSync(); });
  }
  var swTT = document.getElementById('np-e2-tt-swoosh');
  if (swTT) swTT.addEventListener('click', function () {
    st.swoosh = !st.swoosh;
    var swEl = this.querySelector('.np-e2-switch');
    if (swEl) swEl.classList.toggle('is-on', st.swoosh);
    this.setAttribute('aria-pressed', st.swoosh ? 'true' : 'false');
    ttSync();
  });
  var namesAtcE = document.getElementById('np-e2-names-atc');
  if (namesAtcE) namesAtcE.addEventListener('click', function () {
    /* the button is disabled under the minimum, but re-check here: paste +
       submit can outrun the input event on some mobile keyboards */
    renderNames();
    if (namesList().length < namesMin()) {
      var errB = document.getElementById('np-e2-names-err');
      if (errB) { errB.hidden = false; errB.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }
    doCheckout();
  });
  var stitchTgl = document.getElementById('np-e2-stitch-toggle');
  if (stitchTgl) stitchTgl.addEventListener('click', function () {
    st.stitchAddon = !st.stitchAddon;
    st.proofMode = st.stitchAddon ? 'stitch' : 'digital';
    var prefS = st.stitchAddon ? 'REAL STITCHOUT REQUESTED ($19.99)' : 'DIGITAL PROOF (no AI render)';
    setProp('_Proof Preference', prefS);
    var swS = this.querySelector('.np-e2-switch');
    if (swS) swS.classList.toggle('is-on', st.stitchAddon);
    this.setAttribute('aria-pressed', st.stitchAddon ? 'true' : 'false');
    setProp('_Proof Approval', proofApprovalLabel());
    if (sensei.added) {
      lineSync({ '_Proof Preference': prefS, '_Proof Approval': proofApprovalLabel() });
      if (st.stitchAddon && !st.__stitchCharged) { st.__stitchCharged = true; adjustStitchLine(1); }
      else if (!st.stitchAddon && st.__stitchCharged) { st.__stitchCharged = false; adjustStitchLine(-1); }
    }
    npToast(st.stitchAddon ? '\u2713 Real stitchout added ($19.99 in cart)' : 'Real stitchout removed');
  });
  $$('[data-e2-stitchtip]').forEach(function (tipS) {
    tipS.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); tipS.classList.toggle('is-open'); });
  });
  $('#np-e2-another').addEventListener('click', addAnother);
  var szCoBtn = $('#np-e2-sz-checkout');
  if (szCoBtn) szCoBtn.addEventListener('click', function () {
    if (szfPrBlocked) { var mB = document.getElementById('np-e2-szf-msg-pr'); if (mB) mB.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; } /* C229: no Continue at a size the design cannot be made at */
    if (pdpPricingOn() && !st.proofApproved) {
      /* on-page step 3: Continue hands off to the proof choice below */
      var poF = document.getElementById('np-e2-proof-options');
      if (poF) {
        poF.scrollIntoView({ behavior: 'smooth', block: 'center' });
        poF.classList.add('np-e2-flash');
        setTimeout(function () { poF.classList.remove('np-e2-flash'); }, 1200);
      }
      return;
    }
    /* Continue: back to the page — the approved summary owns Add to Cart
       and Add-another */
    pf.hidden = true;
    try { renderApprovedCanvas(); } catch (eRc) {}
    var ap = document.getElementById('np-e2-approved');
    if (ap) { ap.hidden = false; ap.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  });
  var szAnother = $('#np-e2-sz-another'); if (szAnother) szAnother.addEventListener('click', addAnother);
  var szReview = $('#np-e2-sz-review');
  if (szReview) szReview.addEventListener('click', function (e) {
    /* back to the review phase — swap versions or regenerate, then approve
       again to return to sizing */
    e.preventDefault();
    pf.hidden = false;
    st.proofPhase = 'ready';
    renderProofReady();
  });
  var delM = $('#np-e2-delconfirm');
  $('#np-e2-delete').addEventListener('click', function () { delM.hidden = false; });
  $('#np-e2-del-go').addEventListener('click', function () {
    var qs = window.location.search
      .replace(/[?&]file=[^&]*/g, '')
      .replace(/[?&]np_added=[^&]*/g, '')
      .replace(/^&/, '?');
    if (qs && qs[0] !== '?') qs = '?' + qs;
    window.location.href = window.location.pathname + qs;
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-e2-close="del"]')) delM.hidden = true;
    else if (e.target === delM) delM.hidden = true;
  });
  $('#np-e2-zoom').addEventListener('click', function () {
    /* zoom = the SAME preview they're looking at, in the lightbox */
    function showInBox(src) {
      if (!src) return;
      $('#np-e2-zoombox-img').src = src;
      var pv = $('#np-e2-zoomprev'), nx = $('#np-e2-zoomnext'), cap = $('#np-e2-zoomcap');
      if (pv) pv.hidden = true;
      if (nx) nx.hidden = true;
      if (cap) cap.hidden = true;
      zb.hidden = false;
    }
    if (st.proofApproved && st.versions.length) {
      zbShow((st.selected === null || st.selected === undefined) ? st.versions.length - 1 : st.selected);
      return;
    }
    var g = shapeGeom();
    /* typed products (names, tackle twill) have no artwork URL — their preview
       IS the composition, so the lightbox always shows the composed frame */
    if ((st.shape && g !== 'custom') || PTYPE.textPreview || PTYPE.textLines) {
      composePatchImage(function (cv) {
        showInBox(cv ? cv.toDataURL('image/png') : (applyToggleParams(cleanUrl(artworkUrl()) || '') || ''));
      });
    } else {
      showInBox(applyToggleParams(cleanUrl(artworkUrl()) || '') || '');
    }
  });
  /* ---- Patch Size Guide modal: preferred sizes by placement, tap to apply ---- */

  /* ═══ C229 (Justin 2026-09-17, STAGING ONLY) — SIZE BEFORE THE AI PROOF ═══
     "when done backing it will say continue to sizing … they will enter a width or height and then a proportional height or width
     will fill in and the rulers will display on the preview window … we are going to start including patch sizing into our decision
     making before the generation … block generate AI proof until sizing is in the right window … you cant generate an embroidered
     patch at 1 x 1 on a design but you can do it at 5x5 on the same design". A Size row (WZ_STEPS 'size', last) holds width/height
     steppers with proportional fill (heightLocked → square), the Patch Size Guide's common sizes as quick picks, and a feasibility
     line. The feasibility check re-runs the theme's own classifier (analyzeArtwork) with NP_JUDGE_OVERRIDE = the entered width, asks
     fineDetailLikely() at that width, and if it fires bisects upward (0.5" grid, up to 12") for the smallest width that passes.
     st.size is only set while the size is inside the window, so committed() keeps the Generate CTA hidden otherwise. Pricing is NOT
     here — it stays on the sizing/pricing step after the proof. Shipped everywhere on 2026-09-17 (was keyed to the staging theme id while it was a concept). */
  function sizeFirstOn() {
    /* Justin 2026-09-17 "I want the new sizing logic to be everywhere": no theme key any more — every size-able type, every theme */
    if (typeof PTYPE !== 'object' || !PTYPE) return false;
    return !PTYPE.fixedWH && !PTYPE.sizeFromOpt && !PTYPE.names && !PTYPE.noArt && !PTYPE.optVariant && !PTYPE.fixedSize && !PTYPE.labelsOnly;
  }
  function szfFmt(n) { return (Math.round(n * 100) / 100).toString().replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, ''); }
  function szfSnap(rawW, rawH) {
    /* C230: the nearest size with BOTH sides inside the window for this shape (ratio kept; square shapes snap to the limit itself) */
    var locked = heightLocked(), r = locked ? 1 : ((rawW > 0 && rawH > 0) ? rawH / rawW : (st.ratio || 1));
    var q4 = function (x, up) { return (up ? Math.ceil(x * 4 - 1e-9) : Math.floor(x * 4 + 1e-9)) / 4; }, r2 = function (x) { return Math.round(x * 100) / 100; };
    if (rawW < SIZE_MIN - 1e-9 || rawH < SIZE_MIN - 1e-9) { var wMin = locked ? SIZE_MIN : q4(Math.max(SIZE_MIN, SIZE_MIN / r), true); return { w: wMin, h: locked ? wMin : Math.max(SIZE_MIN, r2(wMin * r)), kind: 'min', limit: SIZE_MIN }; }
    if (rawW > SIZE_MAX + 1e-9 || rawH > SIZE_MAX + 1e-9) { var wMax = locked ? SIZE_MAX : q4(Math.min(SIZE_MAX, SIZE_MAX / r), false); return { w: wMax, h: locked ? wMax : Math.min(SIZE_MAX, r2(wMax * r)), kind: 'max', limit: SIZE_MAX }; }
    return null;
  }
  function szfLimitNote(inp, kind, limit) {
    /* C230 (Justin 2026-09-17, like classic mode): a small red line right under the box — "1″ minimum" / "12″ maximum" — the box
       flashes red, and both fall off after 2 seconds; the value itself has already been adjusted */
    if (!inp) return;
    var host = inp.closest('.np-e2-stepper') || inp, par = host.parentNode; if (!par) return;
    var note = par.querySelector('.np-e2-lim');
    if (!note) { note = document.createElement('small'); note.className = 'np-e2-lim'; note.setAttribute('role', 'status'); host.insertAdjacentElement('afterend', note); }
    note.textContent = szfFmt(limit) + '″ ' + (kind === 'max' ? 'maximum' : 'minimum');
    note.hidden = false; host.classList.add('is-error');
    clearTimeout(note.__t); note.__t = setTimeout(function () { note.hidden = true; host.classList.remove('is-error'); }, 2000);
  }
  function szfFocusNext() {
    /* C230 (Justin 2026-09-17 "when we swap to another patch lets auto focus to the field that needs to be entered or just the
       generate AI proof button if all else are filled in"): runs once after a size carry-over arrival */
    var target = null, row = null;
    if (committed()) target = document.getElementById('np-e2-proofbtn');
    else {
      row = document.querySelector('.np-e2-accrow.is-open[data-e2-acc]') || document.querySelector('.np-e2-accrow[data-e2-acc="' + firstUnsetStep() + '"]');
      if (row) target = row.querySelector('[data-e2-accbody] input:not([type="hidden"]):not([disabled]), [data-e2-accbody] button:not([disabled]), [data-e2-accbody] [tabindex]:not([tabindex="-1"])') || row;
    }
    if (!target) return;
    try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (eSV) { try { target.scrollIntoView(); } catch (eSV2) {} }
    setTimeout(function () { try { target.focus({ preventScroll: true }); } catch (eF) { try { target.focus(); } catch (eF2) {} } }, 400);
  }
  function szfAltLinks(withKeep) {
    /* Justin 2026-09-17: "give them an easy way to get to the other options when we recommend it" — the same hand-off the fine-detail card
       uses (np_mode=ai + the upload riding along as file=); the staging preview id travels too so the test lane stays on staging */
    var art = cleanUrl(artworkUrl()) || '', q = 'np_mode=' + (document.body.classList.contains('np-e2-classic') ? 'classic' : 'ai') + (art && isUploadLineage(art) ? '&file=' + encodeURIComponent(art) : ''); /* C434: classic stays classic */
    var pv = /[?&]preview_theme_id=(\d+)/.exec(location.search || ''); if (pv) q += '&preview_theme_id=' + pv[1];
    /* C229h (Justin 2026-09-17): "preselect everything that they had on the previous where it makes sense" — the selections and the size ride
       along as np_src=size&np_ml=<JSON>; handleSizeCarry() on the target keeps whatever its own option lists recognise */
    try {
      var carry = { shape: st.shape || '', corners: st.corners || '', border: st.border ? st.border.label : '', bg: (st.bg && st.bg.hex) ? { label: st.bg.label, hex: st.bg.hex } : null, thread: (st.thread && st.thread.hex) ? { label: st.thread.label, hex: st.thread.hex } : null, backing: st.backing ? st.backing.label : '', removeBg: st.removeBg === true, artZoom: st.artZoom || 1, artDx: st.artDx || 0, artDy: st.artDy || 0, w: st.w, h: st.h };
      q += '&np_src=size&np_ml=' + encodeURIComponent(JSON.stringify(carry));
    } catch (eCarry) {}
    var mk = function (h, lbl) { return '<a class="np-e2-szf__alt" href="/products/' + h + '?' + q + '">' + lbl + ' \u2192</a>'; };
    return '<span class="np-e2-szf__alts">' + mk('print-stitch-patches', 'Print &amp; Stitch patch') + mk('sublimated-patches', 'Full Color patch') + (withKeep ? szfKeepBtn() : '') + '</span>';
  }
  /* C430 (Justin 2026-09-28, "when we reccomend here after they enter size we still need to leave optoin for them to continue with patch
     type they are on (this is AI mode)"): a fine-detail size stop offers "Keep as <type>" beside the Print & Stitch / Full Color routes —
     the same choice the upload and Generate-time stops give (C422/C424). Keeping is per artwork, like keepTypeActive(), and stands the
     other detectors down the same way; the product's min/max per side stay hard limits. */
  function szfArtBase() { return (cleanUrl(artworkUrl()) || '').split('?')[0]; }
  /* C432: AI mode defers every non-photo upload verdict to the Size step when this type has one */
  function szfDefersDetail() { return sizeFirstOn() && !PTYPE.labelsOnly; }
  /* a verdict the width check cannot answer — dense detail/shading, or fine detail on a type without the width-aware fine check */
  function szfDetailAnyWidth() { return st.__szfDetail === 'dense' || st.__szfDetail === 'gradient' || (st.__szfDetail === 'fineDetail' && !PTYPE.fdGate); } /* C516: a gradient is size-free too */
  function szfKeptActive() { return !!st.__szfKeepBase && st.__szfKeepBase === szfArtBase(); }
  /* C433 (Justin 2026-09-28): "it shouldnt say stitch on rubber silicone leather full color, etc (only on embroidered or 3d embroidered or
     woven should it say stitched) / the messaging should be more reccomending not directive" */
  function szfStitched() { return /^(embroidery-2-0|3demb-2-0|woven-2-0|chenille-2-0)$/.test(String(TYPE_FAMILY || '')); }
  function szfClean() { return szfStitched() ? 'stitch cleanly' : 'come through cleanly'; }
  function szfTypeName() { return String(PTYPE.name || 'this patch type').replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  /* C437 (Justin 2026-09-28, "lets add a change link after they select one that lets them change their answer"): the kept note carries a
     Change link that takes the keep back — the recommendation and its routes return */
  function szfChangeLink() { return ' <button type="button" class="np-e2-szf__change" data-e2-szf-unkeep>Change</button>'; }
  document.addEventListener('click', function (e) {
    var uB = e.target && e.target.closest && e.target.closest('[data-e2-szf-unkeep]'); if (!uB) return;
    e.preventDefault();
    st.__szfKeepBase = null;
    if (uB.closest('#np-e2-szf-msg-cl')) { classicSizeWatch(true); return; }
    var prOpenU = !!document.getElementById('np-e2-szf-msg-pr') && !!uB.closest('#np-e2-pf-sizing');
    sizeFirstJudge(st.w, st.h).then(function (res) { if (res) sizeFirstApply(res); if (prOpenU) sizeFirstPricingCheck(); });
  });
  /* C439 (Justin 2026-09-28): every size recommendation ends "We will contact you if necessary." */
  /* C440 (Justin 2026-09-28): "PVC actually allows full color high detail printer printed rubber pvc … If user has a high detail image we
     don't have to warn them and give options anymore we can just let them know we will be creating their patch as a printed rubber pvc
     patch and those will just need a line item property that says _printed pvc: yes". Photos are unchanged (the upload stop → Full Color). */
  function szfPrintedPvc() { return /^(rubber-pvc-2-0|keychains-2-0)$/.test(String(TYPE_FAMILY || '')); } /* C440c: PVC keychains too (Justin 9-28: "do it for pvc keychains too not silicone") */
  function szfPvcRes(W, H) { return { state: 'ok', printedPvc: true, text: 'Your design has a lot of fine detail, so we\u2019ll create it as a <b>printed rubber PVC ' + (String(TYPE_FAMILY || '') === 'keychains-2-0' ? 'keychain' : 'patch') + '</b> at <b>' + szfFmt(W) + '″ × ' + szfFmt(H) + '″</b> \u2014 this will allow you to keep all your details!' }; } /* C440b: Justin's wording */
  function npPrintedPvc(on) {
    /* the line property follows the CURRENT size verdict: on for a high-detail PVC design, off (field switched off) otherwise */
    if (st.__pvcCarried) on = true; /* C441: a studio verdict carried over is never switched off here */
    if (on && szfPrintedPvc()) { try { setProp('_Printed PVC', 'Yes'); } catch (ePP) {} return; }
    var fP = document.querySelector('product-form.product-form form');
    if (fP) $$('[name="properties[_Printed PVC]"]', fP).forEach(function (eP) { eP.disabled = true; });
  }
  function szfKeepBtn() { return '<button type="button" class="np-e2-szf__keep" data-e2-szf-keep>Keep as ' + szfTypeName() + '</button>'; }
  document.addEventListener('click', function (e) {
    var kB = e.target && e.target.closest && e.target.closest('[data-e2-szf-keep]'); if (!kB) return;
    e.preventDefault();
    var base = szfArtBase(); if (!base) return;
    st.__szfKeepBase = base;
    st.__photoCleared = true; st.__photoNudged = true; st.__keepArtBase = base; /* no re-nag at Generate (C422 contract) */
    if (kB.closest('#np-e2-szf-msg-cl')) { classicSizeWatch(true); return; } /* C434 */
    var prOpen = !!document.getElementById('np-e2-szf-msg-pr') && !!kB.closest('#np-e2-pf-sizing');
    sizeFirstJudge(st.w, st.h).then(function (res) { if (res) sizeFirstApply(res); if (prOpen) sizeFirstPricingCheck(); });
  });
  var szfJudgeQ = Promise.resolve(), szfJudgeSeq = 0, szfDebounce = null;
  var szfMem = { art: '', at: {} }; /* C229: verdicts per width for the current artwork — a re-entered size never re-rasterises */
  function szfMemFor() { var a = String(artworkUrl() || ''); if (szfMem.art !== a) szfMem = { art: a, at: {} }; return szfMem; }
  function judgeAtWidthMemo(W) { var m = szfMemFor(), k = W.toFixed(2); if (m.at[k]) return Promise.resolve(m.at[k]); return judgeAtWidth(W).then(function (r) { m.at[k] = r; return r; }); }
  function judgeAtWidth(W) {
    /* run analyzeArtwork as if the patch were W inches wide, read the verdict, then put every st.art* field back the way it was —
       the upload-time gate and the palette must never see the alternate-width numbers */
    return new Promise(function (resolve) {
      var keep = {}; Object.keys(st).forEach(function (k) { if (/^art/.test(k) || k === '__analyzedSrc' || k === '__physSrc' || k === '__artAnalyzed') keep[k] = st[k]; });
      var finished = false;
      var done = function () {
        if (finished) return; finished = true;
        var r = { fine: false, photo: false, phys: st.artPhys || null };
        try { r.photo = !!fullColorLikely(); r.fine = !!fineDetailLikely(); } catch (eJ) {}
        NP_JUDGE_OVERRIDE = 0; Object.keys(keep).forEach(function (k) { st[k] = keep[k]; });
        resolve(r);
      };
      NP_JUDGE_OVERRIDE = W; st.__artAnalyzed = false;
      try { analyzeArtwork(); } catch (eA) { done(); return; }
      var t0 = Date.now(), tick = function () { if (st.__artAnalyzed) return done(); if (Date.now() - t0 > 6000) return done(); setTimeout(tick, 40); };
      tick();
    });
  }
  function sizeFirstJudge(W, H) {
    var my = ++szfJudgeSeq, name = (/patch|label|keychain|coaster/i.test(PTYPE.name || '') ? (PTYPE.name || 'patch') : (PTYPE.name || '') + ' patch').toLowerCase(); /* "embroidered patch", not "embroidered" */
    return (szfJudgeQ = szfJudgeQ.then(function () {
      /* Justin 2026-09-17 "make sure the min max errors appear here too": an out-of-range entry is judged as typed (the box keeps the number) */
      if (W < SIZE_MIN - 1e-9 || H < SIZE_MIN - 1e-9) return { state: 'block', kind: 'min', text: szfFmt(SIZE_MIN) + '″ minimum per side.' }; /* C230: unreachable from the boxes (they snap) — a compact safety line */
      if (W > SIZE_MAX + 1e-9 || H > SIZE_MAX + 1e-9) return { state: 'block', kind: 'max', text: szfFmt(SIZE_MAX) + '″ maximum per side.' };
      /* C432: the upload verdict the Size step now raises — dense detail and shading is a recommendation at every size */
      var anyW = szfDetailAnyWidth(), keptNow = szfKeptActive();
      var detWhat = st.__szfDetail === 'dense' ? 'a lot of detail and shading' : 'fine detail';
      var isGrad516 = st.__szfDetail === 'gradient'; /* C516: smooth colour gradient — Print & Stitch prints it, the rest is stitched */
      var detailKept = { state: 'ok', kept: true, rec: isGrad516 ? 'Print & Stitch Patch' : 'Print & Stitch Patch / Full Color Patch', /* C519 */ links: szfChangeLink(), text: 'Keeping it ' + szfTypeName() + ' at <b>' + szfFmt(W) + '″ × ' + szfFmt(H) + '″</b>. Heads up: ' + (isGrad516 ? 'embroidery thread can\u2019t blend this design\u2019s color gradient.' : 'this design\u2019s ' + (st.__szfDetail === 'dense' ? 'detail and shading' : 'fine detail') + ' may not ' + szfClean() + '.') };
      if (anyW && szfPrintedPvc()) return szfPvcRes(W, H); /* C440 */
      if (anyW && !keptNow && isGrad516) return { state: 'block', kind: 'detail', keep: true, links: szfAltLinks(true), text: 'This design has a smooth color gradient that embroidery thread can\u2019t blend. We recommend a Print &amp; Stitch patch — it prints the gradient and stitches the rest — or you can keep it ' + szfTypeName() + '. We will contact you if necessary.' }; /* C516 */
      if (anyW && !keptNow) return { state: 'block', kind: 'detail', keep: true, links: szfAltLinks(true), text: 'This design has ' + detWhat + ' that may not ' + szfClean() + '. We recommend a Print &amp; Stitch or Full Color patch — or you can keep it ' + szfTypeName() + '. We will contact you if necessary.' }; /* C433 */
      if (!PTYPE.fdGate || !artworkUrl()) return anyW ? detailKept : { state: 'ok', text: '<b>' + szfFmt(W) + '″ × ' + szfFmt(H) + '″</b> set.' };
      /* MONOTONIC PHYSICS (C229i): a design that stitches at the calibrated 3" frame stitches at every larger size, and a design that
         fails at W fails at every smaller size — so the 3" verdict answers every W >= 3 that it passes, and any known pass caps the
         search from above. (The raw classifier is not monotonic on its own: upsampling a small file for a big frame can chain
         anti-alias specks into a "small text run" — the ninja text logo passes at 3" and 1" but flagged smallText at 8".) */
      var m = szfMemFor(), knownPass = Infinity; Object.keys(m.at).forEach(function (k) { if (!m.at[k].fine) knownPass = Math.min(knownPass, parseFloat(k)); });
      var okRes = anyW ? detailKept : { state: 'ok', text: 'Looks good at <b>' + szfFmt(W) + '″ × ' + szfFmt(H) + '″</b>' + (szfStitched() ? ' — stitches cleanly.' : '.') }; /* C433 */ /* C432: a kept dense design never reads "stitches cleanly" */
      var fineAt = function (x) { return judgeAtWidthMemo(x).then(function (r) { var kp = Infinity; Object.keys(m.at).forEach(function (k) { if (!m.at[k].fine && parseFloat(k) < x) kp = Math.min(kp, parseFloat(k)); }); return r.fine && !(kp < x); }); };
      if (W >= knownPass) return okRes;
      var BASE = 3;
      return fineAt(BASE).then(function (fine3) {
        if (my !== szfJudgeSeq) return null;
        if (W >= BASE && !fine3) return okRes;
        return (W === BASE ? Promise.resolve(fine3) : fineAt(W)).then(function (fineW) {
          if (my !== szfJudgeSeq) return null;
          if (!fineW) return okRes;
          /* too fine at W — the smallest passing width on a 0.5" grid: below 3" the answer is at most 3" when 3" passes */
          var keptRes = function (minW) { return { state: 'ok', kept: true, rec: 'Print & Stitch Patch / Full Color Patch', /* C519 */ minW: minW, links: szfChangeLink(), text: 'Keeping it ' + szfTypeName() + ' at <b>' + szfFmt(W) + '″ × ' + szfFmt(H) + '″</b>. Heads up: fine detail may not ' + szfClean() + ' at this size' + (minW ? ' — we recommend <b>' + szfFmt(minW) + '″</b> or wider.' : '.') }; }; /* C430 / C433 */
          var blockAt = function (minW) { if (szfPrintedPvc()) return szfPvcRes(W, H); /* C440 */ if (szfKeptActive()) return keptRes(minW); return { state: 'block', kind: 'fine', minW: minW, keep: true, links: szfAltLinks(true), text: 'This design has fine detail that may not ' + szfClean() + ' at <b>' + szfFmt(W) + '″</b>. We recommend <b>' + szfFmt(minW) + '″</b> or wider, or a Print &amp; Stitch or Full Color patch — or you can keep it ' + szfTypeName() + '. We will contact you if necessary.' }; }; /* C433 */
          var bisect = function (lo, hi) { /* lo fails, hi passes */
            if (hi - lo <= 0.5 + 1e-9) return Promise.resolve(blockAt(hi));
            var mid = Math.round(((lo + hi) / 2) * 2) / 2; if (mid <= lo) mid = lo + 0.5; if (mid >= hi) mid = hi - 0.5;
            return fineAt(mid).then(function (fm) { if (my !== szfJudgeSeq) return null; return fm ? bisect(mid, hi) : bisect(lo, mid); });
          };
          if (W < BASE && !fine3) return bisect(W, BASE);
          var top = isFinite(knownPass) ? knownPass : Math.min(SIZE_MAX, 12);
          return (isFinite(knownPass) ? Promise.resolve(false) : fineAt(top)).then(function (fineTop) {
            if (my !== szfJudgeSeq) return null;
            if (fineTop) return szfPrintedPvc() ? szfPvcRes(W, H) : szfKeptActive() ? keptRes(null) : { state: 'block', kind: 'fine', minW: null, keep: true, links: szfAltLinks(true), text: 'This design has fine detail that may not ' + szfClean() + ' at any size. We recommend a Print &amp; Stitch or Full Color patch — or you can keep it ' + szfTypeName() + '. We will contact you if necessary.' }; /* C433 */
            return bisect(Math.max(W, BASE), top);
          });
        });
      });
    }));
  }
  var szfPrT = null, szfPrBlocked = false;
  function sizeFirstPricingCheck() {
    /* Justin 2026-09-17: "when we get here the same 2x2 error needs to show back up so they know they cant continue at that size" —
       the Sizing & Pricing step re-runs the same check on every size change and holds its Continue while the size is out of the window */
    if (!sizeFirstOn() || !st.__sizeEntered) return;
    var pane = document.getElementById('np-e2-pf-sizing'); if (!pane) return;
    var msg = document.getElementById('np-e2-szf-msg-pr');
    if (!msg) { msg = document.createElement('p'); msg.className = 'np-e2-szf__msg np-e2-szf__msg--pr'; msg.id = 'np-e2-szf-msg-pr'; msg.hidden = true; var panel = pane.querySelector('.np-e2-sizepanel'); if (panel && panel.parentNode) panel.parentNode.insertBefore(msg, panel.nextSibling); else pane.appendChild(msg); }
    var W0 = st.w, H0 = st.h, co = document.getElementById('np-e2-sz-checkout');
    clearTimeout(szfPrT);
    szfPrT = setTimeout(function () {
      sizeFirstJudge(W0, H0).then(function (res) {
        if (!res || st.w !== W0 || st.h !== H0) return;
        szfPrBlocked = res.state === 'block';
        if (res.kind !== 'min' && res.kind !== 'max') npPrintedPvc(!!res.printedPvc); /* C440 */
        if (res.kind !== 'min' && res.kind !== 'max') npRecNote('Sz', res.kept ? res.rec : ''); /* C519 */
        msg.hidden = false; msg.setAttribute('data-state', res.kept ? 'kept' : res.state);
        msg.innerHTML = res.text + ((res.minW || res.fix) ? ' <button type="button" class="np-e2-szf__fix" data-e2-szf-quick="' + (res.minW || res.fix) + '">Use ' + szfFmt(res.minW || res.fix) + '\u2033 wide</button>' : '') + (res.links || '');
        if (co) { co.disabled = szfPrBlocked; co.classList.toggle('is-szf-blocked', szfPrBlocked); }
      });
    }, 200);
  }
  document.addEventListener('click', function (e) {
    var q = e.target && e.target.closest && e.target.closest('#np-e2-pf-sizing [data-e2-szf-quick]'); if (!q) return;
    var wI = document.getElementById('np-e2-winput'); if (wI) { wI.value = q.getAttribute('data-e2-szf-quick'); wI.dispatchEvent(new Event('change', { bubbles: true })); }
  });
  function sizeFirstApply(res) {
    var msg = document.getElementById('np-e2-szf-msg');
    if (res) {
      st.size = res.state === 'ok' ? { label: szfFmt(st.w) + '″ × ' + szfFmt(st.h) + '″' } : null;
      if (res.kind !== 'min' && res.kind !== 'max') npPrintedPvc(!!res.printedPvc); /* C440 */
      if (res.kind !== 'min' && res.kind !== 'max') npRecNote('Sz', res.kept ? res.rec : ''); /* C519 */
      if (st.draft) st.draft.size = st.size;
      if (msg) { msg.setAttribute('data-state', res.kept ? 'kept' : res.state); msg.innerHTML = res.text + ((res.minW || res.fix) ? ' <button type="button" class="np-e2-szf__fix" data-e2-szf-quick="' + (res.minW || res.fix) + '">Use ' + szfFmt(res.minW || res.fix) + '″ wide</button>' : '') + (res.links || ''); }
    }
    try { renderOptions(); } catch (eRO) {}
    var rowS = document.querySelector('.np-e2-accrow[data-e2-acc="' + WZ_STEPS.indexOf('size') + '"]');
    if (rowS) rowS.classList.toggle('is-done', !!st.size && !rowS.classList.contains('is-open'));
  }
  function sizeFirstCommit(kind, v) {
    /* one typed/stepped number → both dimensions, proportional to the patch (square shapes lock the height to the width).
       An out-of-range number stays in the box and is judged AS TYPED so the min/max message shows (Justin 2026-09-17); st.w/st.h,
       which drive the preview and later the pricing, hold the clamped values. */
    if (!(v > 0)) return;
    npMarkSizeManual();
    if (kind === 'h' && heightLocked()) kind = 'w';
    var rawW, rawH;
    if (kind === 'w') { rawW = Math.round(v * 100) / 100; rawH = heightLocked() ? rawW : Math.round(rawW * st.ratio * 100) / 100; }
    else { rawH = Math.round(v * 100) / 100; rawW = Math.round(rawH / st.ratio * 100) / 100; }
    /* C230 (Justin 2026-09-17 "just need the little red text under the entry that says 1 inch min and then adjust the sizer for them
       and the warning falls off after 2 seconds"): an out-of-range entry SNAPS to the nearest size that keeps both sides inside the
       window (ratio kept) and a small red note under the box says why for 2 s — boxes and rulers always agree, nothing goes below the minimum */
    var snap = szfSnap(rawW, rawH);
    if (snap) { rawW = snap.w; rawH = snap.h; szfLimitNote(document.getElementById(kind === 'h' ? 'np-e2-szf-h' : 'np-e2-szf-w'), snap.kind, snap.limit); }
    st.w = rawW; st.h = heightLocked() ? st.w : rawH;
    st.__sizeEntered = true;
    var wI = document.getElementById('np-e2-szf-w'), hI = document.getElementById('np-e2-szf-h');
    if (wI) wI.value = st.w.toFixed(2); if (hI) hI.value = st.h.toFixed(2);
    try { commitSizeQty(); } catch (eCS) {}
    try { renderMaskPreview(); } catch (eMP) {} /* the preview redraws with the rulers hugging the patch */
    var msg = document.getElementById('np-e2-szf-msg');
    if (msg) { msg.setAttribute('data-state', 'pending'); msg.textContent = 'Checking your design at ' + szfFmt(st.w) + '″ wide…'; }
    st.size = null; if (st.draft) st.draft.size = null; sizeFirstApply(null);
    clearTimeout(szfDebounce);
    var JW = st.w, JH = st.h;
    szfDebounce = setTimeout(function () { var W0 = st.w, H0 = st.h; sizeFirstJudge(JW, JH).then(function (res) { if (res && st.w === W0 && st.h === H0) sizeFirstApply(res); }); }, 250);
  }
  function renderSizeFirstBody(body, onChange) {
    var locked = heightLocked(), entered = !!st.__sizeEntered;
    /* C499 (Justin 2026-10-14, "there is a max for hats ... so if a design at 4 wide is above 2.5 hat rectangle should not be an option /
       can we have it so options that wont work anymore go red?" ... "actually keep it simply" ... "lets make it say 2"x2" Hat Square/Circle,
       4"x2" Hat Rectangle ..." ... "circle can be 2.5x2.5 not 2x2"): each common size shows its placement BOX (width x max height) and still
       sets the width. C499b (Justin 2026-10-14, "this shouldnt be red its just there for reference"): no red / disabled state — the chips are
       reference only. Label placements (no box) keep the old chip. */
    var quick = (GUIDE_SIZES || []).map(function (g) {
      return '<button type="button" class="np-e2-szf__chip" data-e2-szf-quick="' + g[1] + '">' + (g[2] > 0 ? szfFmt(g[1]) + '″×' + szfFmt(g[2]) + '″ ' : szfFmt(g[1]) + '″ · ') + wearEsc(String(g[0]).replace(/ Patch$/, '')) + '</button>';
    }).join('');
    body.innerHTML =
      '<div class="np-e2-szf">' +
        '<p class="np-e2-szf__help">Enter a width or height — the other side follows your design' + (locked ? ' (a ' + wearEsc(String(st.shape || 'square').toLowerCase()) + ' patch is as tall as it is wide)' : '') + '. We check ' + (szfStitched() ? 'it stitches' : 'your design') + ' at that size before the proof.</p>' + /* C433 */
        '<div class="np-e2-szf__fields">' +
          '<label class="np-e2-szf__field"><span>Width</span><div class="np-e2-stepper" data-e2-szf="w"><button type="button" data-d="-1" aria-label="Narrower">&minus;</button><input type="number" id="np-e2-szf-w" value="' + (entered ? st.w.toFixed(2) : '') + '" placeholder="e.g. 3" min="' + SIZE_MIN + '" max="' + SIZE_MAX + '" step="' + SIZE_STEP + '" inputmode="decimal" aria-label="Width in inches"><button type="button" data-d="1" aria-label="Wider">+</button></div><small>inches</small></label>' +
          '<span class="np-e2-szf__x">×</span>' +
          '<label class="np-e2-szf__field' + (locked ? ' is-locked' : '') + '"><span>Height</span><div class="np-e2-stepper" data-e2-szf="h"><button type="button" data-d="-1" aria-label="Shorter"' + (locked ? ' disabled' : '') + '>&minus;</button><input type="number" id="np-e2-szf-h" value="' + (entered ? st.h.toFixed(2) : '') + '" placeholder="' + (locked ? 'matches width' : 'e.g. 2') + '" min="' + SIZE_MIN + '" max="' + SIZE_MAX + '" step="' + SIZE_STEP + '" inputmode="decimal" aria-label="Height in inches"' + (locked ? ' readonly' : '') + '><button type="button" data-d="1" aria-label="Taller"' + (locked ? ' disabled' : '') + '>+</button></div><small>inches</small></label>' +
        '</div>' +
        (quick ? '<div class="np-e2-szf__quick"><span>Common sizes:</span>' + quick + '</div>' : '') +
        '<p class="np-e2-szf__msg" id="np-e2-szf-msg" data-state="idle">Enter a width or a height to continue.</p>' +
      '</div>';
    var skipL = document.getElementById('np-e2-skipproof'); if (skipL && /Sizing &amp; Pricing|Sizing & Pricing/.test(skipL.innerHTML)) skipL.textContent = 'Skip AI Proof, Continue to Pricing';
    body.addEventListener('click', function (e) {
      var q = e.target.closest && e.target.closest('[data-e2-szf-quick]'); if (q) { sizeFirstCommit('w', parseFloat(q.getAttribute('data-e2-szf-quick'))); return; }
      var b = e.target.closest && e.target.closest('.np-e2-stepper[data-e2-szf] button'); if (!b || b.disabled) return;
      var kind = b.closest('[data-e2-szf]').getAttribute('data-e2-szf'), d = parseInt(b.getAttribute('data-d'), 10) || 0;
      var cur = kind === 'w' ? (entered || st.__sizeEntered ? st.w : 0) : (entered || st.__sizeEntered ? st.h : 0);
      sizeFirstCommit(kind, cur ? cur + d * SIZE_STEP : Math.max(SIZE_MIN, kind === 'w' ? 3 : 3 * st.ratio));
    });
    body.addEventListener('change', function (e) {
      var inp = e.target; if (!inp || inp.tagName !== 'INPUT') return;
      var kind = inp.id === 'np-e2-szf-h' ? 'h' : 'w', v = parseFloat(inp.value);
      if (!(v > 0)) { inp.value = ''; return; }
      sizeFirstCommit(kind, v);
    });
    body.addEventListener('input', function (e) {
      /* live proportional preview in the other box while typing; the commit (clamp, rulers, check) happens on change/Enter */
      var inp = e.target; if (!inp || inp.tagName !== 'INPUT') return;
      var v = parseFloat(inp.value); if (!(v > 0)) return;
      var other = document.getElementById(inp.id === 'np-e2-szf-w' ? 'np-e2-szf-h' : 'np-e2-szf-w'); if (!other) return;
      other.value = (inp.id === 'np-e2-szf-w' ? (heightLocked() ? v : v * st.ratio) : (heightLocked() ? v : v / st.ratio)).toFixed(2);
    });
    body.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target && e.target.tagName === 'INPUT') { e.preventDefault(); e.target.blur(); } });
    if (entered) sizeFirstApply(null), sizeFirstJudge(st.w, st.h).then(function (res) { if (res) sizeFirstApply(res); });
  }
  var GUIDE_SIZES = PTYPE.labelsOnly ? [ /* C176: label placements (0.5"–3" product) */
    ['Neck Label (inside collar)', 2],
    ['Hem Tag (folded into the seam)', 1],
    ['Sleeve or Cuff Tag', 1.5],
    ['Side Seam Tag', 1.5],
    ['Bags, Hats & Blankets', 2.5]
  ] : [ /* C499: [placement, width, max height] */
    ['Hat Square/Circle Patch', 2.5, 2.5], /* Justin 2026-10-14: "circle can be 2.5x2.5 not 2x2" */
    ['Hat Rectangle Patch', 4, 2.5], /* C499b: "you can make hats 4x2.5" */
    ['Front Left Chest Shirt', 4, 4],
    ['Sleeve', 3, 3],
    ['Back Neckline', 3, 3]
  ];
  function renderSizeGuide() {
    var rows = document.getElementById('np-e2-guide-rows');
    if (!rows) return;
    var pv = nearestVariant();
    /* match on WIDTH: Apply sets the width, so the badge must compare width or
       the row you just applied would never read as Current. */
    var cur = Math.round(st.w * 100) / 100;
    rows.innerHTML = GUIDE_SIZES.map(function (r) {
      var on = Math.abs(cur - r[1]) < 0.01;
      return '<div class="np-e2-guide__row" data-e2-guide="' + r[1] + '"><span>' + r[0] + '</span>' +
        /* C499b (Justin 2026-10-14, "update those size here too ... from the patch size guide"): the placement BOX, same as the Size step's chips */
        '<span class="np-e2-guide__size"><b>' + (r[2] > 0 ? szfFmt(r[1]) + '″ × ' + szfFmt(r[2]) + '″' : r[1] + (r[1] === 1 ? ' inch' : ' inches')) + '</b><em class="' + (on ? 'is-cur' : '') + '">' + (on ? 'Current' : 'Apply') + '</em></span></div>';
    }).join('');
  }
  var sg = $('#np-e2-sizeguide');
  if (sg) sg.addEventListener('click', function (e) {
    e.preventDefault();
    renderSizeGuide();
    var m = document.getElementById('np-e2-sizeguide-m');
    if (m) m.hidden = false;
  });

  /* any open builder overlay locks background scroll */
  (function () {
    function sync() {
      var anyOpen = $$('.np-e2-ov').some(function (ov) { return !ov.hidden; });
      document.body.classList.toggle('np-e2-modal-open', anyOpen);
    }
    /* B92 (2026-08-25) — COALESCE THE BODY OBSERVER. This is a childList +
       subtree observer on document.body, so it fired on EVERY DOM change
       anywhere on the page and ran a querySelectorAll each time. During an add
       (which mutates a lot of DOM) that is a storm of short callbacks — none
       over 50ms, so longtask never reports them, while the event loop starves.
       Measured symptom: a 250ms interval degrading 743,1311,2051,3112,5587,
       8458,13690,27496ms while longestTask stayed at 148ms and the thread
       looked "idle". Collapse every burst into ONE sync per animation frame;
       behaviour is identical, the work is bounded. */
    var moPend = false;
    var moSched = function () {
      if (moPend) return;
      moPend = true;
      var run = function () { moPend = false; sync(); };
      if (window.requestAnimationFrame) requestAnimationFrame(run); else setTimeout(run, 16);
    };
    var mo = new MutationObserver(moSched);
    /* subtree: dynamically created overlays (photo/FC/fine-detail popups)
       must lock background scroll too */
    mo.observe(document.body, { attributes: true, attributeFilter: ['hidden'], subtree: true, childList: true });
    sync();
  })();

  /* ---- boot: wait for the legacy upload signal.
     body.image-uploaded fires only on real dropzone events; the ?file=
     reuse path (second uploads, My Designs, ordering modal) never adds
     it. #uploadArea gaining .hidden is the reliable post-upload marker
     on BOTH paths (see np-upload-signal notes), so watch both. ---- */
  function classicHasFile() {
    /* the upload box ships with its own artwork illustration, so "is there an
       image in there" is not the question — only the flow's own state says
       whether a customer file has landed. The hidden property field counts
       ONLY during a ?file= handoff: the legacy uploader RESTORES the previous
       session's upload into that input on a fresh visit, which was showing
       the mode tabs under the carousel before any upload happened. */
    /* while the upload/review card is open (mid-upload progress included)
       the flow is not settled — no tabs yet */
    if (document.querySelector('.uploaded-file.uploaded-file--open')) return false;
    if (uploadedNow()) return true;
    if (!/[?&]file=/.test(location.search)) return false;
    var f = document.querySelector('input[name="properties[_Upload]"], input[name="properties[_cartImg]"]');
    return !!(f && f.value);
  }
  function classicReady() {
    return document.body.classList.contains('np-e2-classic') && classicHasFile();
  }
  function uploadedNow() {
    if (document.body.classList.contains('image-uploaded')) return true;
    var ua = document.getElementById('uploadArea');
    return !!(ua && ua.classList.contains('hidden'));
  }
  /* ═══ ORDER MODE ══════════════════════════════════════════════════════
     Uploading products offer the customer a choice BEFORE they upload: the new
     AI flow (default) or the classic one. Nothing changes until a file lands —
     at that moment AI activates this builder and Classic simply stands down
     and lets the legacy post-upload UI run untouched. Typed products (custom
     names, tackle twill) have no upload, so they never show the switch. */
  function modeEligible() { return (!PTYPE.noArt || !!PTYPE.classicOk) && !PTYPE.aiOnly; } /* C169: aiOnly types (woven labels) never show the Classic tab; C231: a typed type with classicOk (tackle twill) does */
  /* The choice sticks: whichever mode they used last is the one the next
     product opens in. Safe now that BOTH modes carry the tabs — an accidental
     Classic click is one click to undo, on any product. */
  var MODE_PREF = 'np_order_mode';
  function storedMode() {
    try {
      var v = (localStorage.getItem(MODE_PREF) || '').toLowerCase();
      return (v === 'classic' || v === 'ai') ? v : '';
    } catch (e) { return ''; }
  }
  function rememberMode(m) {
    try { localStorage.setItem(MODE_PREF, m === 'classic' ? 'classic' : 'ai'); } catch (e) {}
  }
  function orderMode() {
    if (!modeEligible()) return 'ai';
    if (NP_FORCE_CLASSIC) return 'classic'; /* live kill-switch: see flag */
    var pM = new URLSearchParams(location.search);
    var q = (pM.get('np_mode') || '').toLowerCase();
    if (q === 'classic' || q === 'ai') return q;           /* this page said so */
    /* a link INTO the builder — an approved proof, a Mockup Lab handoff, a
       reorder, a 2.0 template by name — outranks a stored classic preference */
    if (pM.get('np_proof') || pM.get('np_src') === 'ml' || pM.get('np_reorder')) return 'ai';
    if (/2-0$/.test(pM.get('view') || '')) return 'ai';
    return storedMode() || 'ai';
  }
  /* ── mode handoff ───────────────────────────────────────────────────
     Changing mode is a full page load (the legacy flow only picks the
     artwork up on arrival), which by default dumps the customer at the top
     of a page that then rearranges itself under them. Instead the tabs'
     on-screen position rides across in sessionStorage and the new page is
     held behind the loader until it has been seated back there. */
  var MODE_JUMP = 'np_mode_jump';
  function markModeJump(msg) {
    try {
      var w = document.getElementById('np-e2-modeswitch');
      var vy = w && !w.hidden ? Math.round(w.getBoundingClientRect().top) : 140;
      sessionStorage.setItem(MODE_JUMP, String(Math.max(60, Math.min(vy, 320))) + '|' + (msg || ''));
    } catch (e) {}
  }
  function settleModeJump() {
    var raw = null;
    try { raw = sessionStorage.getItem(MODE_JUMP); sessionStorage.removeItem(MODE_JUMP); } catch (e) { return; }
    if (raw === null) return;
    var vy = parseInt(raw, 10); if (isNaN(vy)) vy = 140;
    var msgJ = String(raw).split('|').slice(1).join('|');
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e2) {}
    /* the OLD page's message stays up while the new page settles — one
       continuous "Switching…" from click to landing, not a bare spinner */
    showPageLoader(msgJ || 'Loading your design\u2026');
    /* the head-level veil OWNS the whole transition now (one loader style
       start to finish) — it removes itself when every loader below is done,
       so it is NOT removed here */
    var ovJ = document.getElementById('np-e2-pageloader');
    if (ovJ) ovJ.setAttribute('data-jump', '1');
    function release() {
      /* only ever take down the veil we raised — another flow may have put
         its own loader up in the meantime */
      var o = document.getElementById('np-e2-pageloader');
      if (o && o.getAttribute('data-jump') === '1') { o.removeAttribute('data-jump'); o.hidden = true; }
    }
    /* the loader may only come down when the DESTINATION flow is actually on
       screen — the legacy uploader shows its own textless spinner while it
       consumes ?file=, and releasing on scroll-stability alone left the
       customer staring at that bare ring with no words under it */
    var hasFileP = /[?&]file=/.test(location.search);
    function destinationReady() {
      if (document.body.classList.contains('np-e2-classic')) return !hasFileP || classicHasFile();
      return !hasFileP || document.body.classList.contains('np-e2-active');
    }
    var tries = 0, landed = 0, lastY = -1, stable = 0;
    function anchorEl() {
      /* the tabs are the anchor once they are on the page; until then (classic
         is still consuming file=, AI is still booting) the flow's own top edge
         stands in for them, so the page never sits at scroll 0 waiting */
      var w = document.getElementById('np-e2-modeswitch');
      if (w && !w.hidden) return w;
      return document.querySelector('.shopify-section[id$="__main"] .np-upload-tabs')
        || document.getElementById('uploadArea')
        || document.getElementById('np-e2-step-customize')
        || document.querySelector('.shopify-section[id$="__main"] .product-actions');
    }
    function land() {
      var w = anchorEl();
      if (w) {
        landed++;
        var want = Math.max(0, Math.round(w.getBoundingClientRect().top + window.pageYOffset - vy));
        window.scrollTo(0, want);
        var after = w.getBoundingClientRect().top;
        /* whatever grew above them, the customer has to land looking AT the
           tabs — never off the top of the screen */
        if (after < 8) { window.scrollBy(0, Math.round(after - 12)); want = Math.round(window.pageYOffset); }
        stable = Math.abs(want - lastY) <= 4 ? stable + 1 : 0;
        lastY = want;
      }
      tries++;
      /* artwork and the legacy step boxes arrive late and shove everything
         below them — re-seat until the position stops moving AND the flow is
         genuinely up (classic has its file / the builder is active) */
      if (((landed && stable >= 2) || tries >= 12) && destinationReady()) { release(); return; }
      if (tries >= 90) { release(); return; } /* ~25s hard cap — never trap */
      setTimeout(land, landed ? 250 : 150);
    }
    requestAnimationFrame(land);
    setTimeout(release, 26000); /* absolute failsafe behind the in-loop cap */
  }
  function paintModeSwitch() {
    var wrap = document.getElementById('np-e2-modeswitch');
    if (!wrap) return;
    if (NP_FORCE_CLASSIC) { wrap.hidden = true; return; } /* no AI option shown on live */
    var classicOn = document.body.classList.contains('np-e2-classic');
    var aiOn = document.body.classList.contains('np-e2-active');
    /* the choice belongs AFTER the upload — before one there is nothing to
       switch between. In CLASSIC the switch has to live outside the (hidden)
       builder, above the legacy flow, or they could never come back. AI
       requires REAL artwork in the builder (st.versions) — np-e2-active alone
       fires pre-upload on 2.0 templates where the legacy #uploadArea is
       hidden by design, which painted the tabs under the carousel before any
       upload. While hidden, keep re-checking so the tabs appear the moment
       a file lands. */
    var aiHasArt = false;
    try { aiHasArt = (st.versions || []).some(function (vA) { return !!(vA && (vA.hosted || vA.dataUrl || vA.alpha)); }); } catch (eHA) {}
    if (!aiHasArt) {
      /* fresh uploads live in the preview canvas before any version exists */
      var aImg = document.getElementById('np-e2-artimg');
      var aR = aImg ? aImg.getBoundingClientRect() : null;
      aiHasArt = !!(aImg && aImg.src && aImg.naturalWidth > 0 && aR && aR.width > 0);
      if (!aiHasArt && aImg && aImg.src && aImg.naturalWidth > 0) {
        /* LEATHER (Circle default) composes immediately, hiding the raw art
           img behind the composed preview — the visible canvas counts as
           artwork or the tabs never appear (2026-08-21 regression) */
        var cvV = document.getElementById('np-e2-canvas');
        aiHasArt = !!(cvV && cvV.getBoundingClientRect().width > 0);
      }
    }
    /* belt AND suspenders: beyond having artwork, the builder's DESIGN UI must
       be visibly on screen — while the upload panel is what the customer sees
       (pre-upload, any flow, any restored state) the tabs stay gone */
    var designUi = document.querySelector('.np-e2__main')
      || document.getElementById('np-e2-step-customize')
      || document.getElementById('np-e2-step-options');
    var dRect = designUi ? designUi.getBoundingClientRect() : null;
    var designUp = !!(dRect && dRect.width > 0 && dRect.height > 80);
    var aiReady = aiOn && aiHasArt && designUp;
    /* C231: on tackle twill the choice comes FIRST — AI types the lettering, Classic uploads — so the tabs show before any file, on both sides */
    var earlyTabs = !!PTYPE.classicOk && !st.proofApproved;
    if (!modeEligible() || (!earlyTabs && !aiReady && !classicReady())) {
      wrap.hidden = true;
      if (modeEligible() && !paintModeSwitch.__rearm) {
        paintModeSwitch.__rearm = setTimeout(function () {
          paintModeSwitch.__rearm = null;
          try { paintModeSwitch(); } catch (eRA) {}
        }, 900);
      }
      return;
    }
    /* the tabs are a design-page control: once the customer is at Size &
       Pricing / the approved review page, switching flows would throw that
       work away — the choice is over, so the tabs leave with it. They return
       only if Edit selections brings the design page back.
       C114: on the on-page pricing layout, Size & Pricing is on the page from
       the FIRST paint (mountPdpPricing calls renderSizing at mount, which
       stamps proofPhase 'sizing' before any customer choice) — there 'sizing'
       does not mean the design step is over, so it must not hide the tabs;
       the approved/final review still does. */
    if (aiOn && (st.proofApproved || (st.proofPhase === 'sizing' && !pdpPricingOn())
        || document.body.classList.contains('np-e2-approved-view'))) { wrap.hidden = true; return; }
    var host = classicOn
      ? (document.querySelector('.shopify-section[id$="__main"] .np-upload-tabs')
         || document.getElementById('uploadArea')
         || document.querySelector('.shopify-section[id$="__main"] .product-text'))
      : ((!aiOn && earlyTabs) ? (document.getElementById('np-e2-startcta') || document.querySelector('.shopify-section[id$="__main"] .product-text')) /* C231: before the typed builder opens, the tabs sit above its Start CTA */
         : (document.querySelector('.np-e2__main')
         || document.getElementById('np-e2-step-customize') || document.getElementById('np-e2-step-options')));
    /* C452 (Justin 2026-09-29, tackle twill: "put the AI classic mode tabs above the h1 on AI mode"): before the typed builder
       opens, the AI side takes the classic placement too — above the product grid, over the H1 — not above the Start card */
    var aboveGrid = classicOn || (!aiOn && earlyTabs);
    if (aboveGrid) {
      /* the tabs leave the ordering column entirely and sit ABOVE the product
         grid, so the carousel and the ordering flow start on the same line —
         then they are shoved right to line up with the ordering column */
      var gridC = document.querySelector('.shopify-section[id$="__main"] .grid--layout');
      var colC = document.querySelector('.shopify-section[id$="__main"] .product-text');
      if (gridC && gridC.parentNode && colC) {
        if (wrap.nextElementSibling !== gridC) gridC.parentNode.insertBefore(wrap, gridC);
        var dxC = Math.max(0, Math.round(colC.getBoundingClientRect().left - gridC.getBoundingClientRect().left));
        wrap.style.marginLeft = dxC ? dxC + 'px' : '';
        wrap.style.maxWidth = dxC ? Math.round(colC.getBoundingClientRect().width) + 'px' : '';
      } else if (host && host.parentNode) {
        var targetC = host.closest('.np-upload-tabs') || host;
        if (wrap.nextElementSibling !== targetC) targetC.parentNode.insertBefore(wrap, targetC);
      }
    } else {
      if (host && host.parentNode && wrap.nextElementSibling !== host) host.parentNode.insertBefore(wrap, host);
      /* same treatment as classic: the tabs fill the dead strip above the
         grid, starting where the options column starts; the two cards below
         keep one shared top line. (The grid is zoomed, so the measured visual
         offset converts back to local px before it becomes a margin.) */
      var colA = document.querySelector('.np-e2-rightcol');
      var mainA = document.querySelector('.np-e2__main');
      var dxA = 0, zA = 1;
      if (colA && mainA) {
        try { zA = parseFloat(getComputedStyle(document.querySelector('.np-e2__grid')).zoom) || 1; } catch (eZ) {}
        dxA = Math.max(0, Math.round((colA.getBoundingClientRect().left - mainA.getBoundingClientRect().left) / zA));
      }
      wrap.style.marginLeft = dxA ? dxA + 'px' : '';
      wrap.style.maxWidth = dxA && colA ? Math.round(colA.getBoundingClientRect().width / zA) + 'px' : '';
    }
    wrap.classList.toggle('np-e2-modeswitch--classic', aboveGrid); /* C452: the above-grid layout (width + top margin), either mode */
    wrap.hidden = false;
    var cur = classicOn ? 'classic' : 'ai';
    $$('[data-e2-mode]', wrap).forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-e2-mode') === cur);
      b.setAttribute('aria-pressed', b.getAttribute('data-e2-mode') === cur ? 'true' : 'false');
    });
  }
  function armClassicRequiredOptions() {
    /* C231c (Justin 2026-09-17 "make all fields required and dont preselect anything" + "the prices have to change based on the layer
       count and line count"): on tackle twill's CLASSIC flow the variant picker ships with the first variant ticked (11″×4″ / 1 Layer /
       1 Line). Nothing may be pre-chosen, and Proceed to Checkout (and the express buttons) hold until Size, Layers and Lines of Text are
       all chosen — a missing group is named and scrolled to. The theme's picker resolves the variant once every option is picked; the
       legacy price row is nudged to re-read it. The section renders the picker twice (desktop + collapsed copy), so groups are keyed
       by OPTION, and the clearing stops the moment the customer touches a choice (the picker re-renders on every pick). */
    if (!PTYPE.classicOk || armClassicRequiredOptions.__on) return;
    armClassicRequiredOptions.__on = 1;
    var mainSel = '.shopify-section[id$="__main"]', touched = false;
    function optName(g) { return (g.getAttribute('data-name') || '').replace(/^product-/, '').replace(/-template.*$/, ''); }
    function groups() {
      var all = $$(mainSel + ' .product-variant[data-js-product-variant]'), byName = {};
      all.forEach(function (g) { var n = optName(g); if (!n) return; var vis = g.offsetParent !== null; if (!byName[n] || (vis && byName[n].offsetParent === null)) byName[n] = g; });
      return Object.keys(byName).map(function (n) { return byName[n]; });
    }
    function allGroupsNamed(n) { return $$(mainSel + ' .product-variant[data-js-product-variant]').filter(function (g) { return optName(g) === n; }); }
    function radiosOf(g) { return $$('.product-variant__item--radio input[type="radio"]', g); }
    function picked(g) { return (keyOf(optName(g)) in picks); }
    /* C231d (Justin 2026-09-17 "when I select 2 layers it doesnt outline it … the price is not changing from $13.00"): the theme's picker
       only resolves a variant once EVERY option is picked and its re-render re-ticks the current variant, so a lone Layers pick lost its
       outline and the row stayed on the first variant's price. The picks are ours now: they are re-applied to every picker copy after
       each re-render, and the variant is resolved from the picks with the first Size standing in for pricing until a size is chosen. */
    var picks = {}, productJson = null;
    try { fetch(location.pathname.replace(/\/+$/, '') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) { productJson = j; applyResolved(); }).catch(function () {}); } catch (eF) {}
    function keyOf(n) { return String(n || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
    function resolveVariant() {
      if (!productJson || !productJson.options || !productJson.variants) return null;
      var want = productJson.options.map(function (o) { var name = typeof o === 'string' ? o : o.name, vals = (o && o.values) || []; var k = keyOf(name); return (k in picks) ? picks[k] : (vals[0] || null); });
      for (var i = 0; i < productJson.variants.length; i++) { var v = productJson.variants[i]; if ([v.option1, v.option2, v.option3].every(function (ov, j) { return want[j] == null || ov == null || String(ov) === String(want[j]); })) return v; }
      return null;
    }
    function applyResolved() {
      var v = resolveVariant(); if (!v) return;
      var idEl = document.querySelector(mainSel + ' form[action*="/cart/add"] [name="id"]');
      if (idEl && String(idEl.value) !== String(v.id)) { idEl.value = v.id; }
      refreshPrice();
    }
    function syncRadios() {
      /* our picks win over whatever the theme re-rendered; options not yet picked stay empty (nothing pre-chosen) */
      $$(mainSel + ' .product-variant[data-js-product-variant]').forEach(function (g) {
        var k = keyOf(optName(g)), has = (k in picks);
        radiosOf(g).forEach(function (r) { r.checked = has && String(r.value) === String(picks[k]); });
      });
    }
    function clearPreselect() { syncRadios(); }
    function complete() { var gs = groups(); return gs.length > 0 && gs.every(picked); }
    function missing() { return groups().filter(function (g) { return !picked(g); }); }
    function hintEl() {
      var act = document.querySelector(mainSel + ' .product-actions'); if (!act) return null;
      var h = act.querySelector('.np-tt-req-hint');
      if (!h) {
        h = document.createElement('p'); h.className = 'np-tt-req-hint';
        var cta = act.querySelector('button.add-to-cart, .disabled-cta') || act.firstElementChild;
        if (cta && cta.parentNode) cta.parentNode.insertBefore(h, cta); else act.appendChild(h);
      }
      return h;
    }
    function paint() {
      var sec = document.querySelector(mainSel); if (!sec) return;
      var done = complete(), miss = missing();
      sec.classList.toggle('np-tt-incomplete', !done);
      var h = hintEl();
      if (h) {
        if (done) { h.hidden = true; }
        else {
          var names = miss.map(function (g) { return optName(g).replace(/-/g, ' ') || 'option'; });
          h.hidden = false;
          h.textContent = 'Choose your ' + (names.length > 1 ? names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] : names[0]) + ' to continue.';
        }
      }
      $$(mainSel + ' .product-variant.is-np-missing').forEach(function (g) { if (picked(g)) g.classList.remove('is-np-missing'); });
    }
    function refreshPrice() {
      /* the theme's picker writes the resolved variant into the form; the legacy price row / tier table only re-read it on the qty keyup */
      setTimeout(function () {
        try { if (window.jQuery) window.jQuery('precut-unit-logic .customQtyFile__qty').trigger('keyup'); } catch (eJ) {}
        try { if (typeof window.changeDiscounts === 'function') window.changeDiscounts(0); } catch (eC) {}
      }, 350);
    }
    function block(ev) {
      if (!document.body.classList.contains('np-e2-classic') || complete()) return;
      var tEl = ev.target && ev.target.closest ? ev.target.closest('button.add-to-cart, .shopify-payment-button, .disabled-cta') : null;
      if (!tEl || !tEl.closest(mainSel)) return;
      ev.preventDefault(); ev.stopImmediatePropagation();
      var miss = missing();
      miss.forEach(function (g) { allGroupsNamed(optName(g)).forEach(function (gg) { gg.classList.add('is-np-missing'); }); });
      if (miss[0]) { try { miss[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (eS) {} }
      paint();
    }
    document.addEventListener('click', block, true);
    document.addEventListener('click', function (ev) { if (ev.target && ev.target.closest && ev.target.closest(mainSel + ' .product-variant__item--radio')) touched = true; }, true);
    document.addEventListener('submit', function (ev) { if (document.body.classList.contains('np-e2-classic') && !complete() && ev.target && ev.target.closest && ev.target.closest(mainSel + ' form[action*="/cart/add"]')) { ev.preventDefault(); ev.stopImmediatePropagation(); paint(); } }, true);
    document.addEventListener('change', function (ev) {
      if (!(ev.target && ev.target.matches && ev.target.matches(mainSel + ' .product-variant__item--radio input[type="radio"]'))) return;
      touched = true;
      var g = ev.target.closest('.product-variant[data-js-product-variant]'); if (g && ev.target.checked) picks[keyOf(optName(g))] = ev.target.value;
      syncRadios(); paint(); applyResolved();
      setTimeout(function () { syncRadios(); applyResolved(); }, 450); /* after the theme's own re-render + variant write */
    }, true);
    var pend = null;
    var run = function () { pend = null; clearPreselect(); paint(); };
    var sec0 = document.querySelector(mainSel);
    if (sec0 && window.MutationObserver) new MutationObserver(function () { if (pend) return; pend = setTimeout(run, 60); }).observe(sec0, { attributes: true, childList: true, subtree: true, attributeFilter: ['class', 'hidden'] });
    run(); setTimeout(run, 400); setTimeout(run, 1500);
  }
  function classicStitchOffer() {
    /* CLASSIC MODE proof choice, above "Upload another patch" — ONLY where a
       physical stitchout exists (embroidery family, full color, leather,
       faux leather); every other patch type gets NO proof section in classic.
       Clicking a card SELECTS it (click again to unselect — never disables,
       never navigates); the cart action happens on the page's own Add to
       Cart: stitch = Stitchout: Yes property + the $19.99 line added first,
       none = straight through, no selection = blocked with a nudge. */
    var CST_STITCH_TYPES = ['embroidery-2-0', '3demb-2-0', 'fullcolor-2-0', 'leather-2-0', 'fauxleather-2-0',
      'print-and-stitch-2-0'];  /* 2026-08-25 Justin: P&S is embroidery + print, a real stitchout exists */
    if (CST_STITCH_TYPES.indexOf(TYPE_KEY) === -1 || !CFG.stitchVid) {
      /* C320 (Justin 2026-09-22, "for those in classic mode with no proof option have it default to
         _Proof Approval: Digital Proof Approved"): silicone, rubber/PVC, woven, chenille, the flex family,
         sublimated, keychains and tackle twill have no physical stitchout, so there is no choice to offer
         and no card is drawn. Until now that also meant the line left with NO _Proof Approval at all, while
         every card-carrying type always ships one — production had nothing to read on those orders. The
         answer is the same one No Proof gives: the digital preview IS the approval.

         Re-asserted on a ticker because the legacy uploader re-renders the add-to-cart form on size and
         quantity edits, which drops the hidden input. Gated on the classic body class so it never fights
         AI mode, which writes this property itself, and it stands down if a card is ever drawn here. */
      var defaultProof = function () {
        if (!document.body.classList.contains('np-e2-classic')) return;
        if (document.getElementById('np-cst')) return;
        setLineProp('_Proof Approval', 'Digital Proof Approved');
      };
      defaultProof();
      if (!classicStitchOffer.__defTick) classicStitchOffer.__defTick = setInterval(defaultProof, 1200);
      return;
    }
    var host = document.querySelector('.shopify-section[id$="__main"] .second-upload-cta');
    if (!host || !host.parentNode || document.getElementById('np-cst')) return;
    /* the upload box sits inside a FLEX ROW (.flex-buttons) — the card goes
       ABOVE the whole row, full width, never beside the box */
    if (host.parentElement && /flex-buttons/.test(host.parentElement.className || '')) host = host.parentElement;
    var card = document.createElement('div');
    card.id = 'np-cst';
    card.className = 'np-cst';
    card.innerHTML = '<b class="np-cst__title">Select Your Proof Option</b>' +
      '<p class="np-cst__sub">Choose how you\u2019d like to approve your design before it goes into production.</p>' +
      '<div class="np-cst__btns">' +
      '<button type="button" class="np-cst__opt" data-cst="none"><span class="np-cst__opt-top"><b>No Proof</b><em class="np-cst__badge np-cst__badge--free">FREE</em><em class="np-cst__badge np-cst__badge--pop">Most Popular</em></span><i>Go straight to production</i></button>' +
      '<button type="button" class="np-cst__opt" data-cst="stitch"><span class="np-cst__opt-top"><b>Physical Stitchout</b><em class="np-cst__badge">$19.99</em></span><i>A real sample patch, emailed for your approval \u2014 adds 2\u20134 business days</i></button>' +
      '</div>';
    host.parentNode.insertBefore(card, host);
    /* the legacy uploader re-renders this area (size/qty edits) and REPLACES
       the card — restore the customer's previous choice on the new copy.
       First render PRESELECTS No Proof (FREE · Most Popular). */
    if (!classicStitchOffer.__pick) classicStitchOffer.__pick = 'none';
    var rP = card.querySelector('[data-cst="' + classicStitchOffer.__pick + '"]');
    if (rP) rP.classList.add('is-on');
    function setLineProp(nameP, valP) {
      var form = document.querySelector('.shopify-section[id$="__main"] form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var inp = form.querySelector('input[name="properties[' + nameP + ']"]');
      if (valP == null) { if (inp && inp.parentNode) inp.parentNode.removeChild(inp); return; }
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[' + nameP + ']';
        form.appendChild(inp);
      }
      inp.value = valP;
    }
    function picked() {
      /* ALWAYS resolve the live card — a stale closure over a replaced card
         froze the checkout lock on "greyed out" even with everything chosen */
      var cNow = document.getElementById('np-cst');
      var on = cNow && cNow.querySelector('[data-cst].is-on');
      return on ? on.getAttribute('data-cst') : '';
    }
    /* the Add to Cart greys out until a proof option is chosen — the capture
       gate below still hard-blocks, this is the visual cue */
    function paintAtcGate() {
      var lock = !picked() || (typeof window.NP_CO_MISSING === 'function' && window.NP_CO_MISSING() > 0);
      ['button.add-to-cart', '.second-upload-cta'].forEach(function (selG) {
        var elG = document.querySelector('.shopify-section[id$="__main"] ' + selG) || document.querySelector(selG);
        if (elG) elG.classList.toggle('np-e2-atc-locked', lock);
      });
    }
    /* classic ALWAYS ships a _Proof Approval — one or the other */
    if (classicStitchOffer.__pick === 'stitch') setLineProp('_Proof Approval', 'Stitchout Needed');
    else if (classicStitchOffer.__pick === 'none') setLineProp('_Proof Approval', 'Digital Proof Approved');
    paintAtcGate();
    if (!classicStitchOffer.__tick) {
      classicStitchOffer.__tick = setInterval(function () {
        if (document.getElementById('np-cst')) paintAtcGate();
      }, 1200);
    }
    card.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-cst]');
      if (!b) return;
      var was = b.classList.contains('is-on');
      $$('[data-cst]', card).forEach(function (x) { x.classList.remove('is-on'); });
      if (!was) b.classList.add('is-on');
      card.classList.remove('np-cst--nudge');
      if (picked() === 'stitch') {
        setLineProp('_Proof Approval', 'Stitchout Needed'); /* same property AI mode writes */
        npToast('Physical stitchout will be added with your patch ($19.99)');
      } else if (picked() === 'none') {
        setLineProp('_Proof Approval', 'Digital Proof Approved'); /* No Proof = the digital preview IS the approval */
      } else {
        setLineProp('_Proof Approval', null); /* deselected — the gate forces a re-pick */
      }
      classicStitchOffer.__pick = picked();
      paintAtcGate();
    });
    /* gate the page's Add to Cart (capture, before the theme handler):
       no choice = nudge; stitch = add the $19.99 line, THEN let it through */
    var cstBusy = false;
    if (classicStitchOffer.__gate) return;
    classicStitchOffer.__gate = 1;
    document.addEventListener('click', function (ev) {
      var go = ev.target.closest && ev.target.closest('.shopify-section[id$="__main"] button.add-to-cart, .second-upload-cta');
      if (!go || !document.getElementById('np-cst')) return;
      if (go.getAttribute('data-np-cst-ok') === '1') { go.removeAttribute('data-np-cst-ok'); return; }
      var isSecondUp = !(go.matches && go.matches('button.add-to-cart'));
      var pick = picked();
      if (!ev.isTrusted) {
        /* programmatic clicks are the theme's own pipelines (the second-upload
           flow adds the current design via $('.anotherTransfer').click()).
           NEVER block or defer those — swallowing that click ate the add and
           bounced the customer back to the product page with an empty cart.
           If a stitchout is selected, add its line in parallel instead. */
        if (pick === 'stitch') { try { adjustStitchLine(1); } catch (eBG) {} }
        return;
      }
      if (!pick) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        var cN = document.getElementById('np-cst') || card;
        cN.classList.add('np-cst--nudge');
        try { cN.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (eSV) { cN.scrollIntoView(); }
        npToast('Please select a proof option first');
        return;
      }
      /* "Upload another patch" with a proof chosen proceeds untouched — the
         pipeline's own programmatic add picks the stitch line up in parallel */
      if (isSecondUp) return;
      /* a REAL checkout click: disarm any leftover second-upload machinery —
         a zombie cart-count poll from an earlier "upload another" watches for
         ANY count change and yanks the customer back to the product page
         (?np_added reload = "white screen then right back to the options") */
      try { window.__npLastUploadedFilePath = null; window.__npSecondUploadRedirect = false; } catch (eZP) {}
      if (pick === 'stitch') {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        if (cstBusy) return;
        cstBusy = true;
        setLineProp('_Proof Approval', 'Stitchout Needed');
        var passed = false;
        var pass = function () {
          if (passed) return;
          passed = true;
          cstBusy = false;
          /* the legacy uploader may have REPLACED the button while the stitch
             line was being added — a click on a detached node goes nowhere */
          var goNow = (go && go.isConnected) ? go : (document.querySelector('.shopify-section[id$="__main"] button.add-to-cart') || go);
          goNow.setAttribute('data-np-cst-ok', '1');
          goNow.click();
        };
        var pr = null;
        try { pr = adjustStitchLine(1); } catch (eAS) {}
        if (pr && pr.then) pr.then(pass, pass); else pass();
        /* a hung cart call must never strand the customer — proceed anyway */
        setTimeout(pass, 7000);
      }
      /* pick === 'none' -> fall through untouched */
    }, true);
  }
  /* ═══ SPEC SHEET ═══════════════════════════════════════════════════════
     The proof image production opens should BE the build sheet: the patch
     render on the left, every attribute used to build it on the right.
     Composed in-browser at order time from the line's own properties, so it
     adapts to whatever options each patch type carries, and uploaded through
     the same pipeline as frozen proofs (dk-token naming keeps the portal's
     purchased-matching intact). Rides as _AI Proof in BOTH modes. */
  /* C428 (2026-09-28): SPEC_EXCLUDE, the sheet rows, the composer and its uploader moved VERBATIM to
     assets/np-spec-sheet.js (window.npSpecSheet) so the cart's size editor rebuilds sheets with the same code. The
     functions below are the builder's bindings; every call site is unchanged. */
  function npSS() { return window.npSpecSheet || null; }
  function specFormProps() {
    var out = {};
    var form = document.querySelector('product-form.product-form form') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return out;
    [].slice.call(form.querySelectorAll('input[name^="properties["], textarea[name^="properties["]')).forEach(function (el) {
      if (el.disabled) return;
      if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
      var m = /^properties\[(.+)\]$/.exec(el.name || '');
      if (!m) return;
      var v = (el.value || '').trim();
      if (v) out[m[1]] = v;
    });
    return out;
  }
  function specLines(props) {
    /* the sheet leads with WHAT the patch is — the patch type from the product itself */
    var ptN = (PTYPE && PTYPE.name) || '';
    if (!ptN && TYPE_KEY) ptN = String(TYPE_KEY).replace(/-2-0$/, '').replace(/-/g, ' ').replace(/\b[a-z]/g, function (mC) { return mC.toUpperCase(); });
    return npSS() ? npSS().lines(props, ptN) : [];
  }
  function specNotes(props) {
    /* revision notes ride onto the sheet as their own wrapped block */
    return npSS() ? npSS().notes(props) : '';
  }
  function composeSpec(imgUrl, lines, notes, cb) {
    if (typeof notes === 'function') { cb = notes; notes = ''; }
    if (!npSS()) { cb(null); return; }
    npSS().compose(imgUrl, lines, notes, cb, { host: toImgixHost, w: (typeof st !== 'undefined' && st && st.w) || 0, h: (typeof st !== 'undefined' && st && st.h) || 0 });
  }
  /* the freshness token baked into sheet filenames: art + size + the sheet's
     own content. If the customer changes ANY spec after the sheets were
     stamped (re-opening sizing, new border color...), the recomputed token
     stops matching and applySpecToLine recomposes — the PATCH-2106492 lesson:
     a stale sheet shipped 3.00" stats on a 4.00" line. */
  function specDkToken(lines) {
    /* B61: key off the ORIGINAL upload — stable for the whole session. It
       used to key off artworkUrl(), which the checkout's own _AI Proof write
       changes, so the token drifted at click time and every ready sheet was
       judged stale (beacon-proven: click dk != composer dk). */
    var artU = '';
    try {
      var oI = document.querySelector('input[name="properties[_Original Image]"]');
      artU = oI ? String(oI.value || '').split('?')[0] : '';
    } catch (eO) {}
    if (!artU) { try { artU = (cleanUrl(artworkUrl()) || '').split('?')[0]; } catch (eA) {} }
    if (!artU) {
      var upI = document.querySelector('input[name="properties[_Upload]"]');
      artU = upI ? (upI.value || '').split('?')[0] : '';
    }
    var wI = document.querySelector('input[name="properties[_Width (in)]"]');
    var hI = document.querySelector('input[name="properties[_Height (in)]"]');
    return npSS() ? npSS().dk(artU, ((st && st.w) || (wI && wI.value) || 0), ((st && st.h) || (hI && hI.value) || 0), lines) : '';
  }
  function uploadSpec(cv, cb, lines) {
    if (!npSS()) { cb(null); return; }
    var name = 'ai-proof-' + (TYPE_KEY || 'patch') + '--spec-dk' + specDkToken(lines) + '-' + Date.now() + '-' + Math.floor(Math.random() * 10000) + '.png';
    npSS().upload(cv, name, cb, { host: toImgixHost, put: npPut });
  }
  function makeSpecSheet(imgUrl, cb) {
    var fp = specFormProps();
    var lines = specLines(fp);
    if (!imgUrl || !lines.length) { cb(null); return; }
    composeSpec(imgUrl, lines, specNotes(fp), function (cv) {
      if (!cv) { cb(null); return; }
      uploadSpec(cv, cb, lines);
    });
  }
  function specForAI() {
    /* AI checkout: swap _AI Proof for the composed build sheet, then proceed.
       Any failure (image blocked, upload hiccup) falls back to the plain
       proof after 9s — checkout is never held hostage. */
    return new Promise(function (resolve) {
      var done = false;
      var fin = function () { if (!done) { done = true; resolve(); } };
      setTimeout(fin, 9000);
      try {
        var src = formProp('_AI Proof') || formProp('_cartImg') || formProp('_Preview Image') || formProp('_Upload') || '';
        if (!src) { fin(); return; }
        makeSpecSheet(src, function (u) {
          if (u) {
            specForAI.__url = u; /* applied to the LINE by applySpecToLine.
              NO form-level writes: stamping the form made artworkUrl()
              return the sheet, which leaked it into _Original Image */
          }
          fin();
        });
      } catch (eAll) { fin(); }
    });
  }
  function fireSheetStamp() {
    if (!NP_SPEC_SHEETS) return;  /* B70: build sheets disabled */

    /* B45 (the live-flow fix): the sheet stamp FIRES the instant both sheets
       are uploaded — no cart read before it, no response wait after it.
       Mutations commit server-side immediately on this store even when the
       response takes 30s, so firing IS finishing. Addressed by line INDEX
       (stable across Shopify's property re-keying), with the full property
       snapshot cached at the last authoritative write. */
    try {
      var pre = sensei.__preSheets, snap = sensei.__lineSnap;
      if (!pre || !snap || !sensei.added) return;
      if (!lineSnapMatchesSession()) return; /* C124: never stamp sheets through a foreign snapshot */
      if (!pre.ai && !pre.up) return;
      if ((pre.aiBase && !pre.ai) || (pre.upBase && !pre.up)) return; /* B53: fire only when complete */
      var fp = specFormProps();
      var linesF = specLines(fp);
      if (!linesF.length) return;
      var dkF = specDkToken(linesF);
      regSessionDk(dkF); /* C125 */
      if (pre.dk !== dkF) return; /* sheets are stale for the current specs */
      if (sensei.__sheetsFiredDk === dkF) return; /* already fired */
      var props = scrubForeignSheets(mergedOrderProps(), 'sheetStamp'); /* C125 */
      props['_Width (in)'] = st.w.toFixed(2);
      props['_Height (in)'] = st.h.toFixed(2);
      if (pre.ai) props['_AI Proof'] = pre.ai;
      var upSheet = pre.up || pre.ai;
      if (upSheet) props['_Upload'] = upSheet;
      if (digitalNoRender()) delete props['_AI Proof'];
      sensei.__sheetsFiredDk = dkF;
      try { coMark('sheet-fired'); } catch (eSf) {}
      cleanFetch()('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ line: snap.line, quantity: st.qty, properties: props })
      }).then(function (r) { return r.json(); }).then(function (c2) {
        try {
          var mine = ourCartLine(c2);
          if (mine) sensei.__lineSnap = { line: (c2.items || []).indexOf(mine) + 1, props: mine.properties || {} };
          coMark('sheet-landed');
        } catch (eSn) {}
      }).catch(function () { sensei.__sheetsFiredDk = null; /* retry-able */ });
    } catch (eFS) {}
  }
  function preComposeSheets() {
    if (!NP_SPEC_SHEETS) return;  /* B70: build sheets disabled */

    /* build sheets composed AHEAD of need (at approval and on every size
       settle) from CURRENT state — applySpecToLine then only stamps the
       ready URLs onto the line, so the Add-to-Cart grace covers one cart
       write instead of a canvas+upload race (Justin 2026-08-24: orders were
       still shipping plain proofs when the click beat the compose). */
    try {
      var fp = specFormProps();
      var lines = specLines(fp);
      if (!lines.length) { coMark('pre:no-lines'); return; }
      var wantDk = specDkToken(lines);
      regSessionDk(wantDk); /* C125 */
      var avSp = (st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : (st.versions.length ? st.versions[st.versions.length - 1] : null);
      var aiBase = (avSp && !avSp.digital) ? String(avSp.alpha || avSp.frozenProof || avSp.hosted || '') : '';
      /* DIGITAL lane (B41): the LOCAL compose data URL is a legitimate sheet
         base when the hosted clean copy has not landed yet. */
      var upBase = String(sensei.composedCleanUrl || '') || ((avSp && avSp.digital && /^data:|^blob:/.test(String(avSp.dataUrl || '')) ? String(avSp.dataUrl) : '')) || aiBase;
      if (/--spec-dk/.test(aiBase)) aiBase = '';
      if (/--spec-dk/.test(upBase)) upBase = '';
      if (!aiBase && !upBase) { coMark('pre:no-base' + (avSp ? (avSp.digital ? ':dig' : ':ai') : ':nover')); return; }
      var pre = sensei.__preSheets;
      /* B64: `&& !pre.__capped` — a run whose jobs were capped (see mk below)
         left this object in place with ai/up still null. Without this clause
         every later attempt for the same token short-circuits here as "fresh"
         and that configuration can NEVER obtain a sheet again for the rest of
         the session. */
      /* C460 (Justin 2026-09-30, "a lot of AI mockups with the builder details not showing up on the AI proof images"): ~30% of
         AI-mode lines 9-20..9-30 shipped the BARE render in _AI Proof (and often the plain composite in _Upload). The AI base
         flips URL mid-flow — the render's frozen copy (freezeProofCopy) lands a few seconds after approval, a reorder's
         transparent copy (upgradeVersionAlpha) likewise — same pixels, new URL. The URL compare below then threw BOTH sheets
         away and restarted them, usually on the Add to Cart click itself, where the wait is short. Judge the AI sheet by the
         VERSION it depicts (its render), and keep a finished or in-flight job whose inputs did not change. */
      var aiKey = aiBase ? String((avSp && (avSp.hosted || avSp.frozenProof || avSp.alpha)) || aiBase).split('?')[0] : '';
      var aiSame = !!(pre && (pre.aiBase === aiBase || (aiKey && pre.aiKey === aiKey)));
      if (pre && pre.dk === wantDk && aiSame && pre.upBase === upBase && !pre.__capped) return; /* already fresh */
      var keepAi = !!(pre && !pre.__capped && pre.dk === wantDk && aiSame && aiBase && (pre.ai || pre.aiBusy));
      var keepUp = !!(pre && !pre.__capped && pre.dk === wantDk && pre.upBase === upBase && upBase && upBase !== aiBase && (pre.up || pre.upBusy));
      var notes = specNotes(fp);
      var mine = (sensei.__preSheets = { dk: wantDk, aiBase: aiBase, aiKey: aiKey, upBase: upBase, upKey: upBase,
        ai: keepAi ? (pre.ai || null) : null, up: keepUp ? (pre.up || null) : null,
        aiBusy: keepAi ? !!(pre.aiBusy && !pre.ai) : false, upBusy: keepUp ? !!(pre.upBusy && !pre.up) : false,
        wh: st.w.toFixed(2) + 'x' + st.h.toFixed(2),
        /* C126: the design these sheets belong to - nearfresh may never cross designs */
        orig: String(formProp('_Original Image') || '').split('?')[0].split('/').pop() });
      coMark('pre:composing' + (aiBase ? '+ai' : '') + (upBase ? '+up' : '') + ':dk' + wantDk);
      /* C01 (2026-08-25): keep the exact props this sheet was composed from, so
         a later dkMatch:n can name WHICH field drifted instead of leaving us to
         guess. Both sheets compose fine (ai:y up:y) and are still rejected. */
      try {
        mine.snap = fp;
        /* C03 (2026-08-25): the fingerprint is artU | WxH | specLines, where
           artU is read from the DOM and W/H come from st.*, NOT from the form.
           A form-level diff therefore cannot see the real cause — C02 narrowed
           the drift to two URL fields that specLines already excludes, yet
           dkMatch stayed 'n'. Capture the ACTUAL components. */
        var oId = document.querySelector('input[name="properties[_Original Image]"]');
        mine.dbg = {
          a: oId ? String(oId.value || '').split('?')[0].slice(-28) : '(none)',
          w: String((st && st.w) || ''),
          h: String((st && st.h) || ''),
          l: lines.map(function (l) { return l.join(':'); }).join(';')
        };
      } catch (eSn) {}
      var mk = function (base, key) {
        /* HARD CAP (B64, 2026-08-25). composeSpec + uploadSpec sit behind FOUR
           unbounded awaits — the sheet base image load (no timer on im.src),
           cv.toBlob, getPresignedUploadUrl and the PUT. With none of them
           bounded, mine.ai / mine.up could stay null FOREVER, and the
           Add-to-Cart wait loop (doCheckout) has no state that could ever
           satisfy it: it then burns its whole cap and ships with no sheet.
           Live proof — two clicks of 14,544ms and 16,142ms in which NOT ONE of
           pre:ai-ok / pre:up-ok / pre:cv-null / pre:upload-fail was emitted,
           i.e. the jobs never reached any terminal state at all.
           Every job now settles exactly once, always leaves a mark, and a
           capped attempt is flagged so preComposeSheets may compose it again
           instead of short-circuiting on "already fresh". */
        var settled = false, capped = false;
        var fin = function (u, mark) {
          if (settled) {
            /* C468 (Justin 2026-10-02, the ~13% of AI lines still shipping without build sheets): a job that hit the cap is
               usually still UPLOADING — a 0.6-0.9 MB sheet PNG on an ordinary connection — and its finished sheet used to be
               thrown away here. Each retry was capped the same way, so a customer whose sheet upload takes longer than the cap
               could never get a sheet at all. Land the late sheet on whichever state still wants it (same token + same base). */
            if (!u || !capped) return;
            try { coMark('pre:late-ok:' + key); } catch (eLk) {}
            var curL = sensei.__preSheets;
            var tgtL = (curL === mine) ? mine : ((curL && curL.dk === mine.dk && curL[key + 'Key'] && curL[key + 'Key'] === mine[key + 'Key']) ? curL : null);
            if (!tgtL || tgtL[key]) return;
            tgtL[key] = u;
            tgtL[key + 'Busy'] = false;
            if ((!tgtL.aiBase || tgtL.ai) && (!tgtL.upBase || tgtL.upBase === tgtL.aiBase || tgtL.up)) tgtL.__capped = false;
            try { fireSheetStamp(); } catch (eFl) {}
            return;
          }
          settled = true;
          capped = !u && /^pre:cap:/.test(String(mark || ''));
          try { coMark(mark); } catch (eM) {}
          /* C460: a job lands on whichever current state still wants THIS sheet (same token + same base key) — a newer
             object that carried the job over must receive it, or the carried job could never settle */
          var cur = sensei.__preSheets;
          var tgt = (cur === mine) ? mine : ((cur && cur.dk === mine.dk && cur[key + 'Key'] && cur[key + 'Key'] === mine[key + 'Key']) ? cur : null);
          if (!tgt) return;
          tgt[key + 'Busy'] = false;
          if (u) {
            tgt[key] = u;
            try { fireSheetStamp(); } catch (eFk) {}
          } else {
            tgt.__capped = true; /* allow a later attempt to retry this token */
          }
        };
        npTick(function () { fin(null, 'pre:cap:' + key); }, 20000); /* C468: was 6s — jobs started at approval were killed and restarted at the click; the click's own wait stays 6s */
        composeSpec(base, lines, notes, function (cv) {
          if (!cv) { fin(null, 'pre:cv-null:' + key); return; }
          uploadSpec(cv, function (u) {
            fin(u || null, u ? ('pre:' + key + '-ok') : ('pre:upload-fail:' + key));
          }, lines);
        });
      };
      if (aiBase && !keepAi) { mine.aiBusy = true; mk(aiBase, 'ai'); }
      if (upBase && upBase !== aiBase && !keepUp) { mine.upBusy = true; mk(upBase, 'up'); }
      if (keepAi || keepUp) { try { coMark('pre:kept' + (keepAi ? '+ai' : '') + (keepUp ? '+up' : '')); } catch (eKp) {} }
    } catch (ePS) { try { coMark('pre:threw'); } catch (eT) {} }
  }
  function applySpecToLine() {
    if (!NP_SPEC_SHEETS) return Promise.resolve(null);  /* B70: build sheets disabled */

    /* tracked: doCheckout gives an IN-FLIGHT stamp a short bounded grace so
       orders never ship without their build sheets (Justin 2026-08-24) */
    var pSp = applySpecToLineInner();
    var reg = Promise.resolve(pSp).catch(function () {}).then(function () { if (sensei.__specBusy === reg) sensei.__specBusy = null; });
    sensei.__specBusy = reg;
    return pSp;
  }
  function applySpecToLineInner() {
    /* FINAL step of checkout: TWO build sheets composed from the LINE's own
       final properties — _AI Proof = the AI render + stats, _Upload = the
       customer's digital preview + stats (they are DIFFERENT base images).
       A line with only one base image (classic-style) rides one sheet on
       both. Verify-and-retry beats any late builder write. Capped so
       checkout is never held hostage. */
    return cartJson().then(function (cart) {
      var line = ourCartLine(cart);
      if (!line) return;
      var props = {};
      Object.keys(line.properties || {}).forEach(function (k) { props[k] = line.properties[k]; });
      var lines = specLines(props);
      var notes = specNotes(props);
      if (!lines.length) return;
      /* SESSION-OWNED bases ONLY (2026-08-21 PATCH-2106464 incident): the
         legacy uploader's restore can clobber the LINE's image props with a
         DIFFERENT session's artwork on converted-product arrivals — a real
         customer's build sheet composed with someone else's photo. st.versions
         and sensei.composedCleanUrl belong to THIS tab alone; when they are
         missing we skip the sheet rather than ever risk foreign art. */
      var avSp = (st.selected !== null && st.selected !== undefined) ? st.versions[st.selected] : (st.versions.length ? st.versions[st.versions.length - 1] : null);
      var aiBase = (avSp && !avSp.digital) ? String(avSp.alpha || avSp.frozenProof || avSp.hosted || '') : '';
      /* DIGITAL lane (B41): until the hosted clean copy lands there was NO
         base to compose the _Upload sheet from — fast checkouts shipped a
         plain preview forever. The LOCAL compose data URL is canvas-safe and
         identical in content, so it is the fallback base. */
      var upBase = String(sensei.composedCleanUrl || '') || ((avSp && avSp.digital && /^data:|^blob:/.test(String(avSp.dataUrl || '')) ? String(avSp.dataUrl) : '')) || aiBase;
      if (/--spec-dk/.test(aiBase)) aiBase = '';
      if (/--spec-dk/.test(upBase)) upBase = '';
      /* a sheet is only "done" when its dk token matches the CURRENT specs —
         a stale token (customer re-sized / re-colored after the first stamp)
         recomposes instead of shipping outdated stats (PATCH-2106492) */
      var wantDk = specDkToken(lines);
      regSessionDk(wantDk); /* C125 */
      var freshSheet = function (v) {
        var m = /--spec-dk([a-z0-9]+)-/.exec(String(v || ''));
        return !!m && m[1] === wantDk;
      };
      var needA = !!aiBase && !freshSheet(props['_AI Proof']);
      var needB = !!upBase && !freshSheet(props['_Upload']);
      if (!needA && !needB) { sensei.__sheetsDk = wantDk; return; }
      function sheet(base) {
        return new Promise(function (res) {
          var done = false;
          var fin = function (u) { if (!done) { done = true; res(u || null); } };
          setTimeout(function () { fin(null); }, 12000);
          composeSpec(base, lines, notes, function (cv) {
            if (!cv) { fin(null); return; }
            uploadSpec(cv, fin, lines);
          });
        });
      }
      var preS = sensei.__preSheets && sensei.__preSheets.dk === wantDk ? sensei.__preSheets : null;
      var preAi = preS && preS.ai && preS.aiBase === aiBase ? preS.ai : null;
      var preUp = preS && ((preS.up && preS.upBase === upBase) ? preS.up : (preS.ai && preS.aiBase === upBase ? preS.ai : null));
      var jobs = [
        needA ? (preAi ? Promise.resolve(preAi) : sheet(aiBase)) : Promise.resolve(null),
        needB ? (preUp ? Promise.resolve(preUp) : sheet(upBase)) : Promise.resolve(null)
      ];
      return Promise.all(jobs).then(function (r) {
        var uA = r[0], uB = r[1];
        if (!uA && !uB) return;
        function stamp(pObj) {
          var changed = false;
          if (uA && !freshSheet(pObj['_AI Proof'])) { pObj['_AI Proof'] = uA; changed = true; }
          var upSheet = uB || (!upBase ? uA : null); /* never the AI sheet when a digital base existed */
          if (upSheet && !freshSheet(pObj['_Upload'])) { pObj['_Upload'] = upSheet; changed = true; }
          return changed;
        }
        function write(l2, pObj) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: l2.key, quantity: l2.quantity, properties: pObj })
          });
        }
        var stChanged = stamp(props);
        sensei.__sheetsDk = wantDk;
        if (!stChanged) return;
        return write(line, props).then(function () {
          /* verify after the dust settles; one retry wins over late racers */
          return new Promise(function (res) { setTimeout(res, 1500); });
        }).then(function () { return cartJson(); }).then(function (c2) {
          var l2 = ourCartLine(c2);
          if (!l2) return;
          var p2 = {};
          Object.keys(l2.properties || {}).forEach(function (k) { p2[k] = l2.properties[k]; });
          if (stamp(p2)) return write(l2, p2);
        });
      });
    }).catch(function () {});
  }
  function classicVectorUpload() {
    /* vector uploads (PDF/AI/EPS): _Upload becomes the imgix RASTER (Justin
       2026-08-21 — production no longer needs the vector there); the true
       source file rides in _Original Image. Also lets the build sheet and
       the cart thumbnail actually render. */
    var upI = document.querySelector('input[name="properties[_Upload]"]');
    if (!upI || !upI.value || upI.value.indexOf('fm=png') > -1) return;
    var base = upI.value.split('?')[0];
    if (!/\.(pdf|ai|eps)$/i.test(base)) return;
    var form = upI.form || document.querySelector('form[action*="/cart/add"]');
    var oI = document.querySelector('input[name="properties[_Original Image]"]');
    if (form && (!oI || !oI.value)) {
      if (!oI) { oI = document.createElement('input'); oI.type = 'hidden'; oI.name = 'properties[_Original Image]'; form.appendChild(oI); }
      oI.value = base;
    }
    var vU = toImgixHost(upI.value);
    upI.value = vU + (vU.indexOf('?') > -1 ? '&' : '?') + 'fm=png';
  }
  /* C542 (Justin 2026-11-03): "when a customer uploads an image with all 4 corners having pixels like this image ... we should
     auto apply remove bg for ai and classic mode" — not photos and not leather (Justin's picks). Once per uploaded artwork, so a
     customer who switches it back off keeps it off (across reloads too): the four corners of the RAW upload must all be solid, the
     central gate must answer that it is not a photo, then Remove background is switched on exactly as the customer's own click
     does it (AI toggle / classic checkbox), so the render, _Remove Background and the palette all follow. Designs chosen from My
     Designs and studio handoffs that carry their own choice are left alone. */
  var NP_AUTOBG_KEY = 'np_autobg542';
  function npAutoBgSeen(raw, mark) {
    var m = {};
    try { m = JSON.parse(sessionStorage.getItem(NP_AUTOBG_KEY) || '{}') || {}; } catch (eS) {}
    if (!mark) return !!m[raw];
    m[raw] = 1;
    try { sessionStorage.setItem(NP_AUTOBG_KEY, JSON.stringify(m)); } catch (eS2) {}
    return true;
  }
  function npCornersSolid(raw, cb) {
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var W = Math.min(64, im.naturalWidth), H = Math.max(1, Math.round(im.naturalHeight * (W / im.naturalWidth)));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(im, 0, 0, W, H);
        var d = x.getImageData(0, 0, W, H).data, k = Math.max(1, Math.round(W / 32)), means = [];
        var solid = [[0, 0], [W - k, 0], [0, H - k], [W - k, H - k]].every(function (p) {
          var sr = 0, sg = 0, sb = 0, n = 0;
          for (var yy = p[1]; yy < p[1] + k; yy++) for (var xx = p[0]; xx < p[0] + k; xx++) {
            var o = (yy * W + xx) * 4;
            if (d[o + 3] < 250) return false;
            sr += d[o]; sg += d[o + 1]; sb += d[o + 2]; n++;
          }
          means.push([sr / n, sg / n, sb / n]);
          return true;
        });
        /* C554 (Justin 2026-11-03, Option 1 for photos the gate misses): the four corners must also be about the SAME colour —
           a background panel or plain backdrop is one colour all round, a photograph's corners are not (measured spread: logo
           panel 1, product shot on a plain backdrop 4, zebra / dahlia / parrot photos 120 / 101 / 97) */
        if (solid) for (var ch = 0; ch < 3 && solid; ch++) {
          var lo = Math.min(means[0][ch], means[1][ch], means[2][ch], means[3][ch]), hi = Math.max(means[0][ch], means[1][ch], means[2][ch], means[3][ch]);
          if (hi - lo > 40) solid = false;
        }
        cb(solid);
      } catch (eC) { cb(false); }
    };
    im.onerror = function () { cb(false); };
    im.src = raw + '?w=64&fm=png';
  }
  function npAutoBg542(mode) {
    if (isLeather() || PTYPE.noArt) return;
    try { if (sessionStorage.getItem('np_md_arrival') === '1') return; } catch (eMd) {}
    if (mode === 'ai' && (st.__bgChosen542 || st.removeBg)) return;
    var src = mode === 'ai' ? artworkUrl()
      : ((document.querySelector('input[name="properties[_Original Image]"]') || {}).value || (document.querySelector('input[name="properties[_Upload]"]') || {}).value || '');
    if (!src || /^data:|^blob:/.test(src) || !isUploadLineage(src)) return;
    var raw = toImgixHost(cleanUrl(src)).split('?')[0];
    if (/ai-proof-/i.test(raw) || npAutoBgSeen(raw)) return;
    if (mode !== 'ai' && !npClassicBgReady(raw)) return; /* the 1.5s classic tick asks again */
    npAutoBgSeen(raw, true);
    npCornersSolid(raw, function (solid) {
      if (!solid || !npGateOn()) return;
      npGateAsk().then(function (res) {
        if (!(res && res.ok) || res.verdict === 'photo') return;
        if (mode === 'ai') {
          if (st.removeBg) return;
          var seg = document.querySelector('[data-e2-toggle="removeBg"]');
          if (seg) seg.click();
        } else {
          var tries = 0;
          (function tickC() {
            var cbx = document.getElementById('option_checkbox_upscale');
            if (!cbx || cbx.checked) return;
            if (npClassicBgReady(raw)) { cbx.click(); return; }
            if (++tries < 20) setTimeout(tickC, 750);
          })();
        }
      }, function () {});
    });
  }
  function npClassicBgReady(raw) {
    /* classic: the upload is still processing while the toggles are locked (.fileupload_bg_options pointer-events:none) and
       executeNextStep repaints #fileupload_hero when it finishes — a click before that is overwritten (switch on, background kept) */
    var heroC = document.getElementById('fileupload_hero'), optsC = document.querySelector('.fileupload_bg_options');
    if (!heroC || !heroC.complete || !heroC.naturalWidth || toImgixHost(cleanUrl(heroC.src || '')).split('?')[0] !== raw) return false;
    return !(optsC && getComputedStyle(optsC).pointerEvents === 'none');
  }
  function classicPhotoWatch() {
    /* CLASSIC photo gate (Justin 2026-08-21): a photograph uploaded on a
       stitched type gets the same at-upload warning as AI mode and moves to
       Full Color IN CLASSIC MODE, image riding in the URL. */
    if (classicPhotoWatch.__on) return;
    classicPhotoWatch.__on = 1;
    if (!photoGateOn()) return;
    var cpTries = 0;
    (function cpTick() {
      /* C79: a design chosen from My Designs (previous design / second upload)
         was explicitly picked by the customer - never re-interrupt it. The
         modal was stranding these arrivals UNDER the loading veil. */
      if (mdArrival79C) { st.__photoNudged = true; return; }
      if (st.__photoNudged) return;
      var upIc = document.querySelector('input[name="properties[_Upload]"]');
      if (!(upIc && upIc.value && isUploadLineage(upIc.value))) { if (cpTries++ < 240) setTimeout(cpTick, 500); return; }
      /* WAIT FOR THE VISIBLE PREVIEW (Justin 2026-08-24): the _Upload property
         lands seconds before the hero image finishes loading, so the modal was
         popping over a still-blank page. Interrupt only once the customer can
         SEE their image (capped — a broken hero must not silence the gate). */
      var heroCp = document.getElementById('fileupload_hero');
      var heroReady = heroCp && heroCp.complete && heroCp.naturalWidth > 0 && heroCp.offsetParent !== null;
      if (!heroReady && cpTries < 230) { cpTries++; setTimeout(cpTick, 400); return; }
      if (npGateOn()) {
        /* C134: classic mode asks the same central gate */
        if (!st.__gateDone) { npGateAsk(); if (cpTries++ < 250) setTimeout(cpTick, 300); return; }
        if (!npGateRenderUpload(st.__gateRes, 'classic', true)) st.__photoCleared = true; /* C434: classic defers non-photo verdicts too */
        return;
      }
      if (!st.__artAnalyzed) {
        try { analyzeArtwork(); } catch (ePA2) { st.__artAnalyzed = true; }
        if (cpTries++ < 250) setTimeout(cpTick, 300);
        return;
      }
      if (fullColorLikely()) {
        st.__photoNudged = true;
        openUploadReco(
          'PHOTOGRAPH DETECTED', /* C132: plain photo stop, etch wording on leather */
          'Photographs need Full Color printing',
          isLeather()
            ? 'Your image is a photograph. Leather is laser-etched in a single tone, so photographic shading can\u2019t be reproduced \u2014 a <b>Full Color Printed Patch</b> prints it exactly as it is.'
            : 'Your image is a photograph. Embroidery thread can\u2019t reproduce photographic shading \u2014 a <b>Full Color Printed Patch</b> prints it exactly as it is.',
          'Continue with Full Color',
          '/products/sublimated-patches',
          'classic'
        );
        return;
      }
      if (typeof densePictorialLikely === 'function' && densePictorialLikely()) {
        /* C78: dense pictorial inside the vivid class, classic mode */
        if (szfDefersDetail()) { st.__szfDetail = 'dense'; st.__photoNudged = true; st.__photoCleared = true; return; } /* C434: raised at size */
        st.__photoNudged = true;
        openDenseReco('classic');
        return;
      }
      if (typeof fineDetailLikely === 'function' && fineDetailLikely() && PTYPE.fdGate) {
        /* same recommendation contract as AI mode, staying in classic */
        st.__photoNudged = true;
        if (szfDefersDetail()) { st.__szfDetail = 'fineDetail'; st.__photoCleared = true; return; } /* C434 */
        openFdReco('classic');
      }
    })();
  }
  function classicRulers() {
    /* W/H arrow rulers on the classic preview — spanning EXACTLY the image
       box (classic prints the image as-is, border included), values live
       from the _Width/_Height inputs */
    var hero = document.getElementById('fileupload_hero');
    var host = hero && hero.closest('.easyzoom');
    var wrap = document.getElementById('np-cl-rulers');
    function hideR() { if (wrap) wrap.style.display = 'none'; }
    if (!hero || !host || !hero.complete || !hero.naturalWidth) { hideR(); return; }
    var iR = hero.getBoundingClientRect();
    if (iR.width < 40 || iR.height < 20) { hideR(); return; }
    var wV = (document.querySelector('input[name="properties[_Width (in)]"]') || {}).value || '';
    var hV = (document.querySelector('input[name="properties[_Height (in)]"]') || {}).value || '';
    if (!wV || !hV) { hideR(); return; }
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.id = 'np-cl-rulers';
      wrap.innerHTML = '<div class="np-cl-dim np-cl-dim--w"><b class="np-cl-dim__chip"></b></div>' +
                       '<div class="np-cl-dim np-cl-dim--h"><b class="np-cl-dim__chip"></b></div>';
    }
    if (wrap.parentElement !== host) { host.appendChild(wrap); }
    host.classList.add('np-cl-hasrulers');
    wrap.style.display = '';
    var hR = host.getBoundingClientRect();
    var x = iR.left - hR.left, y = iR.top - hR.top;
    var wd = wrap.children[0], hd = wrap.children[1];
    wd.style.left = Math.round(x) + 'px';
    wd.style.top = Math.round(y - 18) + 'px';
    wd.style.width = Math.round(iR.width) + 'px';
    hd.style.left = Math.round(x - 18) + 'px';
    hd.style.top = Math.round(y) + 'px';
    hd.style.height = Math.round(iR.height) + 'px';
    wd.querySelector('.np-cl-dim__chip').textContent = wV + '"';
    hd.querySelector('.np-cl-dim__chip').textContent = hV + '"';
  }
  setInterval(function () {
    if (document.body.classList.contains('np-e2-classic')) {
      try { classicPhotoWatch(); } catch (eCW2) {}
      try { npAutoBg542('classic'); } catch (eAB542) {} /* C542 */
      try { classicSizeWatch(); } catch (eCSW) {} /* C434 */
    }
  }, 1500); /* tab switches and np_mode reloads arm the photo gate too */
  /* C434 (Justin 2026-09-28): "on classic mode we should do the same thing in regards to not blocking the artwork unless its a photograph etc
     / when customer enters their size we should apply the same size warnings as we are going to do on AI Mode with reccomednations".
     The classic size card (custom-uploader's sizes-blocks) gets the AI Size step's verdict: the same sizeFirstJudge, message, routes, Use-X
     chip and Keep. Add to Cart holds while the size is a stop the customer has not kept. Classic's own min/max handling stays in charge. */
  var szfCl = { sig: '', seq: 0, blocked: false, t: null };
  function classicSizeWH() {
    var wI = document.querySelector('input[name="properties[_Width (in)]"]'), hI = document.querySelector('input[name="properties[_Height (in)]"]');
    return { w: parseFloat(wI && wI.value), h: parseFloat(hI && hI.value) };
  }
  function classicSizeMsg() {
    var m = document.getElementById('np-e2-szf-msg-cl');
    if (m) return m;
    var sb = document.querySelector('#size_selection sizes-blocks') || document.querySelector('sizes-blocks');
    if (!sb || !sb.parentNode) return null;
    m = document.createElement('p'); m.className = 'np-e2-szf__msg np-e2-szf__msg--cl'; m.id = 'np-e2-szf-msg-cl'; m.hidden = true; m.setAttribute('role', 'status');
    /* C438 (Justin 2026-09-28, "fix this UI so the yellow box is just in the size section"): INSIDE the size card (sizes-blocks is the white
       card with 16px padding) — as its sibling it split the card from its "Patch Size" row and ran edge to edge */
    sb.appendChild(m);
    return m;
  }
  function classicSizeWatch(force) {
    var upI = document.querySelector('input[name="properties[_Upload]"]');
    var hasArt = !!(upI && upI.value && isUploadLineage(upI.value));
    var wh = classicSizeWH();
    var on = hasArt && sizeFirstOn() && wh.w > 0 && wh.h > 0 && (PTYPE.fdGate || szfDetailAnyWidth());
    var m = classicSizeMsg();
    if (!on) { szfCl.blocked = false; if (m) m.hidden = true; szfCl.sig = ''; if (!hasArt) npPrintedPvc(false); if (st.__recCl) npRecNote('Cl', ''); /* C519 */ return; }
    var sig = szfArtBase() + '|' + wh.w + 'x' + wh.h + '|' + (st.__szfDetail || '') + '|' + (szfKeptActive() ? 'k' : '');
    if (!force && sig === szfCl.sig) return;
    szfCl.sig = sig;
    var my = ++szfCl.seq;
    clearTimeout(szfCl.t);
    szfCl.t = setTimeout(function () {
      sizeFirstJudge(wh.w, wh.h).then(function (res) {
        if (!res || my !== szfCl.seq) return;
        var mm = classicSizeMsg(); if (!mm) return;
        if (res.kind === 'min' || res.kind === 'max') { szfCl.blocked = false; mm.hidden = true; return; } /* classic owns its size window */
        szfCl.blocked = res.state === 'block';
        npPrintedPvc(!!res.printedPvc); /* C440: classic lines carry it too */
        npRecNote('Cl', res.kept ? res.rec : ''); /* C519 */
        if (res.state === 'ok' && !res.kept && !res.printedPvc) { mm.hidden = true; return; } /* a clean size needs no line in classic */
        mm.hidden = false; mm.setAttribute('data-state', res.kept ? 'kept' : res.state);
        mm.innerHTML = res.text + ((res.minW || res.fix) ? ' <button type="button" class="np-e2-szf__fix" data-e2-szf-cl-quick="' + (res.minW || res.fix) + '">Use ' + szfFmt(res.minW || res.fix) + '\u2033 wide</button>' : '') + (res.links || '');
      });
    }, 300);
  }
  document.addEventListener('click', function (e) {
    if (!document.body.classList.contains('np-e2-classic')) return;
    var q = e.target && e.target.closest && e.target.closest('[data-e2-szf-cl-quick]');
    if (q) {
      /* the Use-X chip drives the classic width box exactly like typing (custom-uploader recomputes height, variant and price) */
      e.preventDefault();
      var wB = document.querySelector('#size_selection sizes-blocks .widthHeight__value') || document.querySelector('sizes-blocks .widthHeight__value');
      if (wB) { wB.value = q.getAttribute('data-e2-szf-cl-quick'); ['input', 'keyup', 'change', 'blur'].forEach(function (t) { try { wB.dispatchEvent(new Event(t, { bubbles: true })); } catch (eEv) {} }); }
      setTimeout(function () { classicSizeWatch(true); }, 600);
      return;
    }
    var go = e.target && e.target.closest && e.target.closest('button.add-to-cart');
    if (go && szfCl.blocked) {
      /* no Add to Cart at a size the design cannot be made at, until the customer picks a bigger size or keeps this type */
      e.preventDefault(); e.stopImmediatePropagation();
      var mB = document.getElementById('np-e2-szf-msg-cl'); if (mB) { mB.hidden = false; try { mB.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (eS) {} }
    }
  }, true);

  function armClassicSpecSheet() {
    if (!NP_SPEC_SHEETS) return;  /* B70: build sheets disabled */

    if (armClassicSpecSheet.__on) return;
    armClassicSpecSheet.__on = 1;
    var upSig = '', busySp = false, lastSpecUrl = '';
    function upLineageOk(u) {
      /* the _Upload input must belong to THIS session: it matches the file
         we uploaded here, the file= arrival, or an attached proof's lineage.
         Foreign values (legacy-restore clobber) compose NO sheet at all. */
      u = String(u || '');
      if (!isUploadLineage(u)) return false; /* catalog/style asset — never */
      var own = String(window.__npLastUploadedFilePath || '');
      if (own && (u.indexOf(own.split('/').pop().split('?')[0]) > -1 || sameLineage(u, own))) return true;
      var fp = '';
      try { fp = new URLSearchParams(location.search).get('file') || ''; } catch (eF) {}
      if (fp && isUploadLineage(fp) && (u.split('?')[0].split('/').pop() === fp.split('?')[0].split('/').pop() || sameLineage(u, fp) || sameLineage(fp, u))) return true;
      var prI = document.querySelector('input[name="properties[_AI Proof]"]');
      if (prI && prI.value && /--spec-dk|____/.test(prI.value) && (sameLineage(u, prI.value) || sameLineage(prI.value, u))) return true;
      return !own && !fp; /* nothing to compare against — allow (plain classic upload flow) */
    }
    function currentSig() {
      var upI = document.querySelector('input[name="properties[_Upload]"]');
      if (!upI || !upI.value) return '';
      if (!upLineageOk(upI.value)) return '';
      if (typeof window.NP_CO_MISSING === 'function' && window.NP_CO_MISSING() > 0) return '';
      var cN = document.getElementById('np-cst');
      if (cN && !cN.querySelector('[data-cst].is-on')) return '';
      var lines = specLines(specFormProps());
      if (!lines.length) return '';
      return (upI.value || '').split('?')[0] + '|' + JSON.stringify(lines);
    }
    function refresh(cb) {
      var sig = currentSig();
      if (!sig || sig === upSig || busySp) { if (cb) cb(); return; }
      busySp = true;
      var upI = document.querySelector('input[name="properties[_Upload]"]');
      makeSpecSheet(upI.value, function (u) {
        busySp = false;
        if (u) {
          upSig = sig;
          lastSpecUrl = u; /* swapped into _Upload at the final trusted click */
        }
        /* CONTRACT (Justin 2026-08-21): _AI Proof means AN AI PROOF WAS
           GENERATED — classic mode has no such option, so classic must never
           submit one. The sheet rides on _Upload alone. Remove any stray
           _AI Proof input a prior build seeded in this session. */
        var strayAI = document.querySelector('form input[name="properties[_AI Proof]"]');
        if (strayAI && strayAI.parentNode) strayAI.parentNode.removeChild(strayAI);
        if (cb) cb();
      });
    }
    setInterval(function () { try { classicVectorUpload(); } catch (eCV) {} refresh(); }, 2500);
    try { classicVectorUpload(); } catch (eCV0) {}
    /* checkout guarantee: choices changed within the last moments → hold the
       click, refresh the sheet, then continue (marker bypasses the re-click) */
    document.addEventListener('click', function (ev) {
      if (!document.body.classList.contains('np-e2-classic')) return;
      var go = ev.target.closest && ev.target.closest('button.add-to-cart');
      if (!go) return;
      if (go.getAttribute('data-np-spec-ok') === '1') { go.removeAttribute('data-np-spec-ok'); return; }
      if (!ev.isTrusted) return;
      function swapUpload() {
        /* the FINAL trusted checkout also points _Upload at the sheet — done
           only now so nothing mid-flow (upload-another, reorders, artwork
           restores) ever reads the sheet as artwork */
        if (!lastSpecUrl) return;
        var uI = document.querySelector('input[name="properties[_Upload]"]');
        if (uI) uI.value = lastSpecUrl;
      }
      var sig = currentSig();
      if (!sig) return; /* gates will block this click anyway */
      if (sig === upSig) { swapUpload(); return; } /* sheet fresh — pass through */
      ev.preventDefault();
      ev.stopImmediatePropagation();
      var passed2 = false;
      var go2 = function () {
        if (passed2) return;
        passed2 = true;
        swapUpload();
        var goNow = go.isConnected ? go : document.querySelector('.shopify-section[id$="__main"] button.add-to-cart');
        if (goNow) { goNow.setAttribute('data-np-spec-ok', '1'); goNow.click(); }
      };
      setTimeout(go2, 9000);
      refresh(go2);
    }, true);
  }
  function armClassicAddMemory() {
    /* the mode PREFERENCE follows the last add-to-cart: any classic-mode
       Add to Cart / Proceed to Checkout click stamps 'classic' */
    if (armClassicAddMemory.__on) return;
    armClassicAddMemory.__on = 1;
    document.addEventListener('click', function (ev) {
      if (!document.body.classList.contains('np-e2-classic')) return;
      if (!(ev.target.closest && ev.target.closest('button.add-to-cart'))) return;
      rememberMode('classic');
      /* the same white "Adding your patch to the cart…" cover AI mode shows —
         raised only AFTER dispatch, so a validation block (preventDefault)
         never flashes it; it rides until the cart page navigation lands */
      setTimeout(function () {
        if (ev.defaultPrevented) return;
        if (document.getElementById('np-atc-veil')) return;
        var v = document.createElement('div');
        v.id = 'np-atc-veil';
        v.innerHTML = '<style>#np-atc-veil{position:fixed;inset:0;background:rgba(255,255,255,.97);z-index:2147483300;display:flex;align-items:center;justify-content:center}#np-atc-veil .in{display:flex;flex-direction:column;align-items:center;gap:14px}#np-atc-veil .sp{width:46px;height:46px;border-radius:50%;border:4px solid #d4f1e0;border-top-color:#1AA86C;animation:npATC .8s linear infinite}@keyframes npATC{to{transform:rotate(360deg)}}#np-atc-veil b{font:700 16px/1.4 -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:#0f172a}</style>' +
          '<span class="in"><span class="sp"></span><b>Adding your patch to the cart\u2026</b></span>';
        document.body.appendChild(v);
        setTimeout(function () {
          var e2 = document.getElementById('np-atc-veil');
          if (e2 && e2.parentNode) e2.parentNode.removeChild(e2);
        }, 15000); /* failsafe if no navigation follows */
      }, 0);
    }, true);
  }
  function classicStepReveal() {
    /* THE ?file= ARRIVAL BUG: the legacy uploader consumes the handed-over
       file but never calls goToNextStep(), so the ENTIRE buy area (options,
       proof, upload-another, Proceed to checkout) stays inside .step__2.hidden
       — a hidden dead checkout and a scrambled-looking page. Once the file has
       genuinely landed and step 2 is still hidden, run the reveal ourselves. */
    if (classicStepReveal.__armed) return;
    classicStepReveal.__armed = 1;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var upI = document.querySelector('input[name="properties[_Upload]"]');
      var s2 = document.querySelector('.step__2.hidden');
      if (!s2) { clearInterval(iv); return; } /* already revealed */
      if (upI && upI.value && uploadedNow() && typeof window.goToNextStep === 'function') {
        clearInterval(iv);
        try { window.goToNextStep(); } catch (eGS) {}
      } else if (tries > 240) { clearInterval(iv); } /* ~2min cap */
    }, 500);
  }
  function stampOrderMode() {
    /* every patch order carries a hidden _Order Mode: AI | Classic property,
       seated directly ABOVE properties[_Upload] so it lands in that spot on
       the order. One input covers both flows: the classic submit posts the
       form natively and the AI checkout builds FormData from the same form. */
    var form = document.querySelector('product-form.product-form form') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var upI = form.querySelector('input[name="properties[_Upload]"]');
    /* typed products (Custom Names, Tackle Twill) have no upload input but
       are ALWAYS AI — the builder root marks the patch flow */
    if (!upI && !document.getElementById('np-e2')) return;
    var inp = form.querySelector('input[name="properties[_Order Mode]"]');
    if (!inp) {
      inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'properties[_Order Mode]';
    }
    if (upI) { if (inp.nextElementSibling !== upI) upI.parentNode.insertBefore(inp, upI); }
    else if (!inp.parentNode) form.appendChild(inp);
    inp.value = document.body.classList.contains('np-e2-classic') ? 'Classic' : 'AI';
  }
  function bootWatch() {
    try { settleModeJump(); } catch (eJ) {}
    try { stampOrderMode(); } catch (eOM) {}
    if (!bootWatch.__omTick) {
      /* the legacy uploader re-renders the form area — keep the stamp seated,
         and re-seat at the exact moment of submission so the property always
         lands ABOVE _Upload regardless of late re-renders */
      bootWatch.__omTick = setInterval(function () { try { stampOrderMode(); } catch (eOM2) {} }, 1500);
      document.addEventListener('submit', function () { try { stampOrderMode(); } catch (eOM3) {} }, true);
      document.addEventListener('click', function (evOM) {
        if (evOM.target.closest && evOM.target.closest('button.add-to-cart, .anotherTransfer')) {
          try { stampOrderMode(); } catch (eOM4) {}
        }
      }, true);
    }
    /* CLASSIC arrival: the customer chose the old flow and we handed the page
       over with ?np_mode=classic…&file=<artwork>. Stand down before any of the
       arrival handling below, so the legacy reuse path consumes that file. */
    if (orderMode() === 'classic' && modeEligible()) {
      document.body.classList.add('np-e2-classic');
      paintModeSwitch();
      try { armClassicRequiredOptions(); } catch (eCRO) {} /* C231c */
      armClassicAddMemory();
      armClassicSpecSheet();
      try { classicPhotoWatch(); } catch (eCPW) {}
      try { classicStitchOffer(); } catch (eCS) {}
      if (/[?&]file=/.test(location.search)) classicStepReveal();
      /* arriving on classic by remembered preference means there may be no
         upload yet — the tabs stay off the page until the legacy flow has a
         file, exactly as they do on the AI side */
      if (!uploadedNow()) {
        var obsC = new MutationObserver(function () {
          if (!classicHasFile()) return;
          try { paintModeSwitch(); } catch (eO) {}
          obsC.disconnect();
        });
        obsC.observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
      }
      return;
    }
    /* Mockup Lab arrivals never see the upload screen: the proof modal's
       loading pane covers the page from first paint until the builder
       activates and the handoff opens Size & Pricing */
    try {
      var mlq = new URLSearchParams(window.location.search);
      if (mlq.get('np_src') === 'ml') {
        showProofLoading('Preparing your approved proof\u2026');
        var mlTtl0 = document.getElementById('np-e2-pf-title'); if (mlTtl0) mlTtl0.textContent = 'Preparing your approved proof';
        setTimeout(function () {
          /* safety valve: if the builder never activated (artwork failed to
             load), release the page instead of holding a dead overlay */
          document.documentElement.classList.remove('np-e2-ml-arrive');
          if (!document.body.classList.contains('np-e2-active')) pf.hidden = true;
        }, 30000);
      }
    } catch (eml) {}
    if (PTYPE.cta) {
      /* nothing is ever uploaded on this type, so the upload watcher below
         would never fire — the builder opens from its own call to action */
      var scB = document.getElementById('np-e2-startcta');
      var sbB = document.getElementById('np-e2-startbtn');
      if (sbB) sbB.textContent = PTYPE.cta;
      var stT = document.querySelector('#np-e2-startcta .np-e2-startcta__title');
      if (stT && PTYPE.ctaTitle) stT.textContent = PTYPE.ctaTitle;
      var stS = document.querySelector('#np-e2-startcta .np-e2-startcta__sub');
      if (stS && PTYPE.ctaSub) stS.textContent = PTYPE.ctaSub;
      if (scB) scB.hidden = false;
      if (sbB) sbB.addEventListener('click', function () {
        if (scB) scB.hidden = true;
        activate();
      });
      if (PTYPE.classicOk) { try { paintModeSwitch(); } catch (ePMc) {} } /* C231: the AI/Classic tabs sit above the Start CTA from first paint */
      return;
    }
    /* CLASSIC: stand down completely — the legacy flow owns the page. The
       arrival paths above (file= reuse, np_proof) already returned, so our own
       links still open the builder regardless of the stored preference. */
    if (orderMode() === 'classic') {
      document.body.classList.add('np-e2-classic');
      paintModeSwitch();
      try { armClassicRequiredOptions(); } catch (eCRO2) {} /* C231c */
      armClassicAddMemory();
      armClassicSpecSheet();
      try { classicPhotoWatch(); } catch (eCPW) {}
      try { classicStitchOffer(); } catch (eCS2) {}
      /* tabs + the AI-rendering card wait for the upload, same as the
         np_mode=classic arrival above */
      if (!uploadedNow()) {
        var obsC2 = new MutationObserver(function () {
          if (!classicHasFile()) return;
          try { paintModeSwitch(); } catch (eO2) {}
          try { classicStitchOffer(); } catch (eO3) {}
          obsC2.disconnect();
        });
        obsC2.observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
      }
      return;
    }
    /* np_proof arrival WITHOUT file= (the dashboard portal's My Mockups
       links omit it): the proof IS the session, so boot the builder directly
       instead of waiting on an upload signal that will never fire — the
       reorder branch in handleProofHandoff builds the version from np_proof
       alone (Justin 2026-08-24, PDP arrived dead from portal reorder links) */
    var bwQ = new URLSearchParams(location.search);
    if ((bwQ.get('np_proof') || '').indexOf('http') === 0 && !uploadedNow()) { activate(); return; }
    if (uploadedNow()) { activate(); return; }
    new MutationObserver(function (_m, obs) {
      if (uploadedNow()) { obs.disconnect(); activate(); }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootWatch);
  else bootWatch();

  /* Recover the UI after tab switches: background tabs throttle timers and
     some flows can leave the page in a half-rendered state. On return,
     re-assert the builder and never allow a visible proof overlay with
     neither of its states shown (= blank screen). */
  function npRecoverUI(why) {
    /* MOBILE RETURN RECOVERY (B65, 2026-08-25 — Justin: "on mobile I fill
       everything out, leave the browser, come back and it's frozen, then the
       whole screen goes blank").
       TWO defects fixed here.
       (1) EVERY step used to share ONE try block with the blank-screen guard
           LAST. A phone reclaims canvas memory while the tab is away, so
           renderOptions()/loadArt() can throw on return — and when they did,
           the guard that repairs a visible-but-empty proof overlay never ran.
           That is the blank screen. Each step is now isolated: no single
           failure can skip the repair.
       (2) It was bound to visibilitychange ONLY. Returning to a backgrounded
           mobile browser usually restores the page from the back/forward
           cache, where `pageshow` is the reliable signal and visibilitychange
           is often not delivered at all — so on mobile NONE of this ran. */
    try {
      /* CLASSIC MODE OWNS THE PAGE: the legacy flow has consumed the upload,
         so uploadedNow() is true — activating here layered the AI builder
         (which classic keeps display:none) over hideLegacy()'s hidden page,
         i.e. a tab-switch away and back BLANKED the whole product section. */
      if (document.body.classList.contains('np-e2-classic')) return;
      if (!document.body.classList.contains('np-e2-active')) { if (uploadedNow()) activate(); return; }
      root.hidden = false;
    } catch (eG) { console.error('[np-emb2] recover gate', eG); }
    /* a compose that froze mid-flight leaves __busy latched, and every later
       repaint is gated on it — clear it unconditionally on return (the 4s
       threshold in the other handler let a quick tab-switch stay stuck) */
    try {
      if (renderMaskPreview.__busy) {
        renderMaskPreview.__busy = false;
        renderMaskPreview.__again = false;
        maskPrevSeq++;
      }
    } catch (eB) {}
    try { renderPricing(); } catch (eP) { console.error('[np-emb2] recover pricing', eP); }
    try { renderOptions(); } catch (eO) { console.error('[np-emb2] recover options', eO); }
    try { loadArt(); } catch (eA) { console.error('[np-emb2] recover art', eA); }
    try {
      if (!pf.hidden) {
        var loadingShown = !$('#np-e2-pf-loading').hidden;
        var readyShown = !$('#np-e2-pf-ready').hidden;
        var szShown = $('#np-e2-pf-sizing') ? !$('#np-e2-pf-sizing').hidden : false;
        if (!loadingShown && !readyShown && !szShown) {
          if (st.proofPhase === 'sizing' && st.versions.length) { renderSizing(); }
          else if (st.versions.length) { st.proofPhase = 'ready'; renderProofReady(); }
          else if (st.proofPhase === 'loading') { $('#np-e2-pf-loading').hidden = false; }
          else pf.hidden = true;
        }
      }
    } catch (eV) { console.error('[np-emb2] recover overlay', eV); }
    /* last line of defence: an active builder must never come back hidden */
    try { if (document.body.classList.contains('np-e2-active') && root && root.hidden) root.hidden = false; } catch (eR) {}
    /* ANTI-BLANK WATCHDOG (B66, 2026-08-25 — Justin: "every time I leave Safari
       to go to another app and come back the whole screen is blank and wiped
       out on my iPhone").
       Leaving Safari for ANOTHER APP is not a tab switch: iOS suspends the page
       and, under memory pressure, throws away its rendering state. We can come
       back with hideLegacy()'s `np-e2-legacy-hidden` still applied to the whole
       product section while the builder itself has no laid-out height — which
       is a white void with no way out. If the builder is not actually painting,
       give the customer the real page back rather than nothing. Re-checked on a
       short delay too, because iOS restores layout asynchronously. */
    var npAntiBlank = function (tag) {
      try {
        var rb = root ? root.getBoundingClientRect() : null;
        var painting = !!(rb && rb.height > 40 && !root.hidden);
        if (painting) return;
        var hid = document.querySelectorAll('.np-e2-legacy-hidden');
        if (!hid.length) return;
        [].slice.call(hid).forEach(function (el) { el.classList.remove('np-e2-legacy-hidden'); });
        try { document.body.classList.remove('np-e2-active'); } catch (eC) {}
        console.warn('[np-e2] ANTI-BLANK(' + tag + '): builder not painting on return — restored ' + hid.length + ' hidden elements');
      } catch (eW) {}
    };
    npAntiBlank('now');
    setTimeout(function () { npAntiBlank('t600'); }, 600);
    setTimeout(function () { npAntiBlank('t2500'); }, 2500);
    try { console.log('[np-e2] UI recovered via', why); } catch (eL) {}
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    npRecoverUI('visibilitychange');
  });
  /* PROOF-REVEAL WATCHDOG (B67, 2026-08-25 — Justin: "render status comes back
     but it never takes me to the AI proof").
     A finished render pushes a version, but the reveal is gated on image
     preloads that can stall indefinitely on iOS. If a version EXISTS while the
     loading panel is still up, the render is done and the customer is simply
     being held behind a gate that will never open — so open it. */
  /* ON-DEVICE DIAGNOSTICS (B68, 2026-08-25). iOS Safari cannot be reproduced
     from the dev machine — the same flow passes in Chrome at 606px (inside the
     ≤767px mobile branch) but fails on a real iPhone. Add ?npdiag=1 to the PDP
     URL and this paints the live internal state over the loading panel so a
     screenshot from the phone shows exactly where the flow stops. Gated on the
     query param, so customers never see it. */
  try {
    if (/[?&]npdiag=1/.test(location.search)) {
      var dg = document.createElement('div');
      dg.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:2147483647;background:rgba(0,0,0,.88);color:#0f0;font:11px/1.35 ui-monospace,Menlo,monospace;padding:8px 10px;white-space:pre-wrap;max-height:44vh;overflow:auto;';
      document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(dg); });
      if (document.body) document.body.appendChild(dg);
      setInterval(function () {
        try {
          var v = (st.versions || []).length;
          var lines = [
            'phase=' + String(st.proofPhase) + '  versions=' + v + '  approved=' + !!st.proofApproved,
            'session=' + (sensei.sessionId ? String(sensei.sessionId).slice(-10) : 'NONE') +
              '  cartTok=' + (sensei.cartToken ? 'yes' : 'NONE') +
              '  lineId=' + (sensei.lineItemId ? String(sensei.lineItemId).slice(-8) : 'none'),
            'composed=' + (sensei.composedUrl ? 'hosted' : (sensei.composedLocal ? 'localOnly' : 'NONE')) +
              '  busy=' + !!sensei.busy + '  added=' + !!sensei.added,
            'loading=' + (document.getElementById('np-e2-pf-loading') ? !document.getElementById('np-e2-pf-loading').hidden : '-') +
              '  ready=' + (document.getElementById('np-e2-pf-ready') ? !document.getElementById('np-e2-pf-ready').hidden : '-'),
            'errs=' + ((window.__npErrs || []).length ? (window.__npErrs || []).slice(-2).join(' ; ') : '0')
          ];
          dg.textContent = lines.join('\n');
        } catch (eD) { try { dg.textContent = 'diag error: ' + eD.message; } catch (eD2) {} }
      }, 1000);
      window.__npErrs = window.__npErrs || [];
      /* B73: "Script error." alone is useless — capture file/line and the real
         stack so a phone screenshot names the failing call. */
      window.addEventListener('error', function (e) {
        try {
          var f = String(e.filename || '').split('/').pop().split('?')[0];
          var st = (e.error && e.error.stack) ? String(e.error.stack).replace(/https?:\/\/[^ )]+\//g, '').replace(/\s+/g, ' ').slice(0, 150) : '';
          window.__npErrs.push('ERR ' + String(e.message).slice(0, 60) + ' @' + f + ':' + e.lineno + (st ? ' | ' + st : ''));
        } catch (x) {}
      });
      window.addEventListener('unhandledrejection', function (e) {
        try {
          var r = e.reason;
          var st = (r && r.stack) ? String(r.stack).replace(/https?:\/\/[^ )]+\//g, '').replace(/\s+/g, ' ').slice(0, 150) : '';
          window.__npErrs.push('REJ ' + String((r && r.message) || r).slice(0, 70) + (st ? ' | ' + st : ''));
        } catch (x) {}
      });
    }
  } catch (eDG) {}
  var pfHeldSince = 0;
  setInterval(function () {
    try {
      if (!pf || pf.hidden) { pfHeldSince = 0; return; }
      var ld = document.getElementById('np-e2-pf-loading');
      if (!ld || ld.hidden) { pfHeldSince = 0; return; }
      if (!st.versions || !st.versions.length) { pfHeldSince = 0; return; }
      /* C186 (Justin 2026-09-11, 'when I edit selection and generate a new AI proof it brings up the old one for a
         few seconds and then it updates'): measured on staging — THIS watchdog was the flash. It was written for a
         first render whose reveal got stuck, but during a REGENERATE a version already exists (the old proof), so
         three seconds into the loading state it forced that old proof on screen until the new one landed. It now
         only fires for a version that arrived during the current render. */
      if (st.versions.length <= (sensei.__versionsAtLoad186 || 0)) { pfHeldSince = 0; return; }
      if (!pfHeldSince) { pfHeldSince = Date.now(); return; }
      if (Date.now() - pfHeldSince < 3000) return;
      pfHeldSince = 0;
      console.warn('[np-e2] REVEAL WATCHDOG: version ready but still on loading — forcing proof view');
      try { coMark('reveal-watchdog'); } catch (eM) {}
      st.proofPhase = 'ready';
      renderProofReady();
    } catch (eW) {}
  }, 1500);
  /* B67 REVERTED (2026-08-25): a `pageshow` binding here re-ran renderOptions()
     on a bfcache restore, i.e. exactly when iOS has discarded canvas/layout
     state. If that render throws part-way it leaves the builder shell painted
     but EMPTY — a grey void, which is what Justin hit. Until the iOS restore
     path can be reproduced and stepped through, do not re-render on restore;
     visibilitychange alone is the pre-existing, better-understood path. */
  window.addEventListener('pageshow', function (ev) {
    if (!(ev && ev.persisted)) return;
    /* observability only — no DOM work on the restore path */
    try { console.warn('[np-e2] bfcache restore (no re-render performed)'); } catch (eL) {}
  });
})();
